import * as React from 'react';
import React__default, { createContext as createContext$2, forwardRef as forwardRef$1, useContext, createElement, Fragment, useRef, useLayoutEffect, useEffect, useState, useMemo, useCallback, useReducer, useInsertionEffect as useInsertionEffect$1, useId as useId$1, cloneElement, Children, isValidElement as isValidElement$1, memo as memo$1, useSyncExternalStore, PureComponent, Component } from 'react';
import PropTypes, { node as node$1, bool, oneOfType, object, func, string, arrayOf, any } from 'prop-types';
import { createPortal } from 'react-dom';
import cn from 'classnames';

function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles$1(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles$1(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$1(r);
}
function _assertThisInitialized$1(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf$1(o), _possibleConstructorReturn$1(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf$1(t).constructor) : o.apply(t, e));
}
function _classCallCheck$1(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct$1()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf$1(p, r.prototype), p;
}
function _defineProperties$1(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey$1(o.key), o);
  }
}
function _createClass$1(e, r, t) {
  return r && _defineProperties$1(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty$3(e, r, t) {
  return (r = _toPropertyKey$1(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$7.apply(null, arguments);
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _getPrototypeOf$1(t) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf$1(t);
}
function _inherits$1(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf$1(t, e);
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _isNativeReflectConstruct$1() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$1 = function () {
    return !!t;
  })();
}
function _iterableToArray$1(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit$1(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty$3(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties$1(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _possibleConstructorReturn$1(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(t);
}
function _setPrototypeOf$1(t, e) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf$1(t, e);
}
function _slicedToArray$1(r, e) {
  return _arrayWithHoles$1(r) || _iterableToArrayLimit$1(r, e) || _unsupportedIterableToArray$1(r, e) || _nonIterableRest$1();
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$1(t)););
  return t;
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf$1(t.prototype ), o, e);
  return "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _taggedTemplateLiteral$1(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _toArray(r) {
  return _arrayWithHoles$1(r) || _iterableToArray$1(r) || _unsupportedIterableToArray$1(r) || _nonIterableRest$1();
}
function _toConsumableArray$1(r) {
  return _arrayWithoutHoles$1(r) || _iterableToArray$1(r) || _unsupportedIterableToArray$1(r) || _nonIterableSpread$1();
}
function _toPrimitive$1(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey$1(t) {
  var i = _toPrimitive$1(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}
function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function (t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf$1(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf$1(Wrapper, t);
  }, _wrapNativeSuper(t);
}

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */

  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);
  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }
  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}
var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;
    this._insertTag = function (tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;
      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };
  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';
var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash$3(value, length) {
  return charat(value, 0) ^ 45 ? (((length << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}

/**
 * @param {string} value
 * @return {string}
 */
function trim(value) {
  return value.trim();
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof(value, search) {
  return value.indexOf(search);
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat(value, index) {
  return value.charCodeAt(index) | 0;
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr(value, begin, end) {
  return value.slice(begin, end);
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen(value) {
  return value.length;
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof(value) {
  return value.length;
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append(value, array) {
  return array.push(value), value;
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine(array, callback) {
  return array.map(callback).join('');
}

var line = 1;
var column = 1;
var length = 0;
var position$1 = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node(value, root, parent, type, props, children, length) {
  return {
    value: value,
    root: root,
    parent: parent,
    type: type,
    props: props,
    children: children,
    line: line,
    column: column,
    length: length,
    "return": ''
  };
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy$1(root, props) {
  return assign(node('', null, null, '', null, null, 0), root, {
    length: -root.length
  }, props);
}

/**
 * @return {number}
 */
function _char() {
  return character;
}
function prev() {
  character = position$1 > 0 ? charat(characters, --position$1) : 0;
  if (column--, character === 10) column = 1, line--;
  return character;
}

/**
 * @return {number}
 */
function next() {
  character = position$1 < length ? charat(characters, position$1++) : 0;
  if (column++, character === 10) column = 1, line++;
  return character;
}

/**
 * @return {number}
 */
function peek() {
  return charat(characters, position$1);
}

/**
 * @return {number}
 */
function caret() {
  return position$1;
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice(begin, end) {
  return substr(characters, begin, end);
}

/**
 * @param {number} type
 * @return {number}
 */
function token(type) {
  switch (type) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position$1 = 0, [];
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc(value) {
  return characters = '', value;
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit(type) {
  return trim(slice(position$1 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace(type) {
  while (character = peek()) if (character < 33) next();else break;
  return token(type) > 2 || token(character) > 3 ? '' : ' ';
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping(index, count) {
  while (--count && next())
  // not 0-9 A-F a-f
  if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
  return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter(type) {
  while (next()) switch (character) {
    // ] ) " '
    case type:
      return position$1;
    // " '
    case 34:
    case 39:
      if (type !== 34 && type !== 39) delimiter(character);
      break;
    // (
    case 40:
      if (type === 41) delimiter(type);
      break;
    // \
    case 92:
      next();
      break;
  }
  return position$1;
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter(type, index) {
  while (next())
  // //
  if (type + character === 47 + 10) break;
  // /*
  else if (type + character === 42 + 42 && peek() === 47) break;
  return '/*' + slice(index, position$1 - 1) + '*' + from(type === 47 ? type : next());
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier(index) {
  while (!token(peek())) next();
  return slice(index, position$1);
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile(value) {
  return dealloc(parse$1('', null, null, null, [''], value = alloc(value), 0, [0], value));
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse$1(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character = 0;
  var type = '';
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters = type;
  while (scanning) switch (previous = character, character = next()) {
    // (
    case 40:
      if (previous != 108 && charat(characters, length - 1) == 58) {
        if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
        break;
      }
    // " ' [
    case 34:
    case 39:
    case 91:
      characters += delimit(character);
      break;
    // \t \n \r \s
    case 9:
    case 10:
    case 13:
    case 32:
      characters += whitespace(previous);
      break;
    // \
    case 92:
      characters += escaping(caret() - 1, 7);
      continue;
    // /
    case 47:
      switch (peek()) {
        case 42:
        case 47:
          append(comment(commenter(next(), caret()), root, parent), declarations);
          break;
        default:
          characters += '/';
      }
      break;
    // {
    case 123 * variable:
      points[index++] = strlen(characters) * ampersand;
    // } ; \0
    case 125 * variable:
    case 59:
    case 0:
      switch (character) {
        // \0 }
        case 0:
        case 125:
          scanning = 0;
        // ;
        case 59 + offset:
          if (property > 0 && strlen(characters) - length) append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
          break;
        // @ ;
        case 59:
          characters += ';';
        // { rule/at-rule
        default:
          append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
          if (character === 123) if (offset === 0) parse$1(characters, root, reference, reference, props, rulesets, length, points, children);else switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
            // d m s
            case 100:
            case 109:
            case 115:
              parse$1(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
              break;
            default:
              parse$1(characters, reference, reference, reference, [''], children, 0, points, children);
          }
      }
      index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
      break;
    // :
    case 58:
      length = 1 + strlen(characters), property = previous;
    default:
      if (variable < 1) if (character == 123) --variable;else if (character == 125 && variable++ == 0 && prev() == 125) continue;
      switch (characters += from(character), character * variable) {
        // &
        case 38:
          ampersand = offset > 0 ? 1 : (characters += '\f', -1);
          break;
        // ,
        case 44:
          points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
          break;
        // @
        case 64:
          // -
          if (peek() === 45) characters += delimit(next());
          atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
          break;
        // -
        case 45:
          if (previous === 45 && strlen(characters) == 2) variable = 0;
      }
  }
  return rulesets;
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [''];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index; ++i) for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x) if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x]))) props[k++] = z;
  return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length);
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from(_char()), substr(value, 2, -2), 0);
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration(value, root, parent, length) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length);
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize(children, callback) {
  var output = '';
  var length = sizeof(children);
  for (var i = 0; i < length; i++) output += callback(children[i], i, children, callback) || '';
  return output;
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify(element, index, children, callback) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
      return element["return"] = element["return"] || element.value;
    case COMMENT:
      return '';
    case KEYFRAMES:
      return element["return"] = element.value + '{' + serialize(element.children, callback) + '}';
    case RULESET:
      element.value = element.props.join(',');
  }
  return strlen(children = serialize(element.children, callback)) ? element["return"] = element.value + '{' + children + '}' : '';
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware(collection) {
  var length = sizeof(collection);
  return function (element, index, children, callback) {
    var output = '';
    for (var i = 0; i < length; i++) output += collection[i](element, index, children, callback) || '';
    return output;
  };
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet(callback) {
  return function (element) {
    if (!element.root) if (element = element["return"]) callback(element);
  };
}

var weakMemoize$1 = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }
    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize$3(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;
  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }
    if (token(character)) {
      break;
    }
    next();
  }
  return slice(begin, position$1);
};
var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;
  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(position$1 - 1, points, index);
        break;
      case 2:
        parsed[index] += delimit(character);
        break;
      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());
  return parsed;
};
var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11

var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent ||
  // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value,
    parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case

  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */ && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"

  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;
    if (
    // charcode for l
    value.charCodeAt(0) === 108 &&
    // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children :
      // global rule at the root level
      children;
      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];
        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version

        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }
          break;
        }
      }
      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};
var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }
  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user

var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};
var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }
  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash$3(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }
      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;
    case KEYFRAMES:
      return serialize([copy$1(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);
    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy$1(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy$1(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy$1(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy$1(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }
        return '';
      });
  }
};
var isBrowser$9 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$9 ? undefined : weakMemoize$1(function () {
  return memoize$3(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];
var createCache = function createCache(options) {
  var key = options.key;
  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }
  if (isBrowser$9 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');
      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  if (isBrowser$9) {
    container = options.container || document.head;
    Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }
      nodesToHydrate.push(node);
    });
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }
    }), incorrectImportAlarm);
  }
  if (isBrowser$9) {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];
    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe

    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);
    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;
      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }
      return serverStylisCache[name];
    };
    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);
      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }
        if (
        // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }
        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }
  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

function _extends$6() {
  _extends$6 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$6.apply(this, arguments);
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }
    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var reactIs = {exports: {}};

var reactIs_production_min = {};

var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol["for"],
    c = b ? Symbol["for"]("react.element") : 60103,
    d = b ? Symbol["for"]("react.portal") : 60106,
    e = b ? Symbol["for"]("react.fragment") : 60107,
    f = b ? Symbol["for"]("react.strict_mode") : 60108,
    g = b ? Symbol["for"]("react.profiler") : 60114,
    h = b ? Symbol["for"]("react.provider") : 60109,
    k = b ? Symbol["for"]("react.context") : 60110,
    l = b ? Symbol["for"]("react.async_mode") : 60111,
    m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
    n = b ? Symbol["for"]("react.forward_ref") : 60112,
    p = b ? Symbol["for"]("react.suspense") : 60113,
    q = b ? Symbol["for"]("react.suspense_list") : 60120,
    r = b ? Symbol["for"]("react.memo") : 60115,
    t = b ? Symbol["for"]("react.lazy") : 60116,
    v = b ? Symbol["for"]("react.block") : 60121,
    w = b ? Symbol["for"]("react.fundamental") : 60117,
    x = b ? Symbol["for"]("react.responder") : 60118,
    y = b ? Symbol["for"]("react.scope") : 60119;
  function z(a) {
    if ("object" === _typeof$1(a) && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === _typeof$1(a) && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === _typeof$1(a) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}

var reactIs_development = {};

var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof$1(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (_typeof$1(object) === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return _typeof$1(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}

var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === 'production') {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}

var hoistNonReactStatics_cjs;
var hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var reactIs = requireReactIs();

  /**
   * Copyright 2015, Yahoo! Inc.
   * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
   */
  var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
  function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) {
      return MEMO_STATICS;
    } // React v16.12 and above

    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
  }
  var defineProperty = Object.defineProperty;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getPrototypeOf = Object.getPrototypeOf;
  var objectPrototype = Object.prototype;
  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
      // don't hoist over string (html) components
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
      }
      var keys = getOwnPropertyNames(sourceComponent);
      if (getOwnPropertySymbols) {
        keys = keys.concat(getOwnPropertySymbols(sourceComponent));
      }
      var targetStatics = getStatics(targetComponent);
      var sourceStatics = getStatics(sourceComponent);
      for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
          var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
          try {
            // Avoid failures from read-only properties
            defineProperty(targetComponent, key, descriptor);
          } catch (e) {}
        }
      }
    }
    return targetComponent;
  }
  hoistNonReactStatics_cjs = hoistNonReactStatics;
  return hoistNonReactStatics_cjs;
}

requireHoistNonReactStatics_cjs();

var isBrowser$8 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false ||
  // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$8 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;
    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
      if (!isBrowser$8 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }
      current = current.next;
    } while (current !== undefined);
    if (!isBrowser$8 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array

  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.

  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */memoize$3(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }
  return value;
};
if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};
  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }
    var processed = oldProcessStyleValue(key, value);
    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }
    return processed;
  };
}
var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }
  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }
    return interpolation;
  }
  switch (_typeof$1(interpolation)) {
    case 'boolean':
      {
        return '';
      }
    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }
        if (interpolation.styles !== undefined) {
          var next = interpolation.next;
          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }
          var styles = interpolation.styles + ";";
          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }
          return styles;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
        break;
      }
    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }
      break;
  } // finalize string values (regular strings and functions interpolated into css calls)

  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = '';
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (_typeof$1(value) !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && _typeof$1(args[0]) === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }
  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];
  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }
    styles += strings[0];
  } // we start at 1 since we've already handled the first arg

  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }
      styles += strings[i];
    }
  }
  var sourceMap;
  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time

  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' +
    // $FlowFixMe we know it's not null
    match[1];
  }
  var name = murmur2(styles) + identifierName;
  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$7 = typeof document !== 'undefined';
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var EmotionCacheContext$1 = /* #__PURE__ */createContext$2(
// we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);
EmotionCacheContext$1.Provider;
var withEmotionCache$1 = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef$1(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext$1);
    return func(props, cache, ref);
  });
};
if (!isBrowser$7) {
  withEmotionCache$1 = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext$1);
      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/createElement(EmotionCacheContext$1.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}
var ThemeContext$1 = /* #__PURE__ */createContext$2({});
var getTheme$1 = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);
    if (process.env.NODE_ENV !== 'production' && (mergedTheme == null || _typeof$1(mergedTheme) !== 'object' || Array.isArray(mergedTheme))) {
      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
    }
    return mergedTheme;
  }
  if (process.env.NODE_ENV !== 'production' && (theme == null || _typeof$1(theme) !== 'object' || Array.isArray(theme))) {
    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
  }
  return _extends$6({}, outerTheme, {}, theme);
};
var createCacheWithTheme = /* #__PURE__ */weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme$1(outerTheme, theme);
  });
});
var ThemeProvider$2 = function ThemeProvider(props) {
  var theme = useContext(ThemeContext$1);
  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }
  return /*#__PURE__*/createElement(ThemeContext$1.Provider, {
    value: theme
  }, props.children);
};
var typePropName$1 = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName$1 = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var Emotion$1 = /* #__PURE__ */withEmotionCache$1(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }
  var type = props[typePropName$1];
  var registeredStyles = [cssProp];
  var className = '';
  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, undefined, typeof cssProp === 'function' || Array.isArray(cssProp) ? useContext(ThemeContext$1) : undefined);
  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName$1];
    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }
  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty$1.call(props, key) && key !== 'css' && key !== typePropName$1 && (process.env.NODE_ENV === 'production' || key !== labelPropName$1)) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/createElement(type, newProps);
  if (!isBrowser$7 && rules !== undefined) {
    var _ref;
    var serializedNames = serialized.name;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }
    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
  }
  return ele;
});
if (process.env.NODE_ENV !== 'production') {
  Emotion$1.displayName = 'EmotionCssPropInternal';
}

var pkg$1 = {
  name: "@emotion/react",
  version: "11.1.5",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  types: "types/index.d.ts",
  files: ["src", "dist", "jsx-runtime", "jsx-dev-runtime", "isolated-hoist-non-react-statics-do-not-use-this-in-your-code", "types/*.d.ts", "macro.js", "macro.d.ts", "macro.js.flow"],
  sideEffects: false,
  author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.7.2",
    "@emotion/cache": "^11.1.3",
    "@emotion/serialize": "^1.0.0",
    "@emotion/sheet": "^1.0.1",
    "@emotion/utils": "^1.0.0",
    "@emotion/weak-memoize": "^0.2.5",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    "@babel/core": "^7.0.0",
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@babel/core": {
      optional: true
    },
    "@types/react": {
      optional: true
    }
  },
  devDependencies: {
    "@babel/core": "^7.7.2",
    "@emotion/css": "11.1.3",
    "@emotion/css-prettifier": "1.0.0",
    "@emotion/server": "11.0.0",
    "@emotion/styled": "11.1.5",
    "@types/react": "^16.9.11",
    dtslint: "^0.3.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1"
  },
  repository: "https://github.com/emotion-js/emotion/tree/master/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: ["./index.js", "./jsx-runtime.js", "./jsx-dev-runtime.js", "./isolated-hoist-non-react-statics-do-not-use-this-in-your-code.js"],
    umdName: "emotionReact"
  }
};
var warnedAboutCssPropForGlobal$1 = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global$1 = /* #__PURE__ */withEmotionCache$1(function (props, cache) {
  if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal$1 && (
  // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal$1 = true;
  }
  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, typeof styles === 'function' || Array.isArray(styles) ? useContext(ThemeContext$1) : undefined);
  if (!isBrowser$7) {
    var _ref;
    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }
    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);
    if (shouldCache) {
      return null;
    }
    return /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything

  var sheetRef = useRef();
  useLayoutEffect(function () {
    var key = cache.key + "-global";
    var sheet = new StyleSheet({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }
    if (node !== null) {
      sheet.hydrate([node]);
    }
    sheetRef.current = sheet;
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useLayoutEffect(function () {
    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }
    var sheet = sheetRef.current;
    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }
    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});
if (process.env.NODE_ENV !== 'production') {
  Global$1.displayName = 'EmotionGlobal';
}
function css$5() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var keyframes$2 = function keyframes() {
  var insertable = css$5.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var classnames$1 = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;
    switch (_typeof$1(arg)) {
      case 'boolean':
        break;
      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (process.env.NODE_ENV !== 'production' && arg.styles !== undefined && arg.name !== undefined) {
              console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
            }
            toAdd = '';
            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }
          break;
        }
      default:
        {
          toAdd = arg;
        }
    }
    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }
  return cls;
};
function merge$3(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css(registeredStyles);
}
var ClassNames$1 = /* #__PURE__ */withEmotionCache$1(function (props, cache) {
  var rules = '';
  var serializedHashes = '';
  var hasRendered = false;
  var css = function css() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('css can only be used during render');
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache.registered);
    if (isBrowser$7) {
      insertStyles(cache, serialized, false);
    } else {
      var res = insertStyles(cache, serialized, false);
      if (res !== undefined) {
        rules += res;
      }
    }
    if (!isBrowser$7) {
      serializedHashes += " " + serialized.name;
    }
    return cache.key + "-" + serialized.name;
  };
  var cx = function cx() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('cx can only be used during render');
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge$3(cache.registered, css, classnames$1(args));
  };
  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext$1)
  };
  var ele = props.children(content);
  hasRendered = true;
  if (!isBrowser$7 && rules.length !== 0) {
    var _ref;
    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
  }
  return ele;
});
if (process.env.NODE_ENV !== 'production') {
  ClassNames$1.displayName = 'EmotionClassNames';
}
if (process.env.NODE_ENV !== 'production') {
  var isBrowser$6 = typeof document !== 'undefined'; // #1727 for some reason Jest evaluates modules twice if some consuming module gets mocked with jest.mock

  var isJest = typeof jest !== 'undefined';
  if (isBrowser$6 && !isJest) {
    var globalContext$1 = isBrowser$6 ? window : global;
    var globalKey$1 = "__EMOTION_REACT_" + pkg$1.version.split('.')[0] + "__";
    if (globalContext$1[globalKey$1]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }
    globalContext$1[globalKey$1] = true;
  }
}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React__default,
    k = Symbol["for"]("react.element"),
    l = Symbol["for"]("react.fragment"),
    m = Object.prototype.hasOwnProperty,
    n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    p = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function q(c, a, g) {
    var b,
      d = {},
      e = null,
      h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return {
      $$typeof: k,
      type: c,
      key: e,
      ref: h,
      props: d,
      _owner: n.current
    };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      var React = React__default;

      // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types.
      var REACT_ELEMENT_TYPE = Symbol["for"]('react.element');
      var REACT_PORTAL_TYPE = Symbol["for"]('react.portal');
      var REACT_FRAGMENT_TYPE = Symbol["for"]('react.fragment');
      var REACT_STRICT_MODE_TYPE = Symbol["for"]('react.strict_mode');
      var REACT_PROFILER_TYPE = Symbol["for"]('react.profiler');
      var REACT_PROVIDER_TYPE = Symbol["for"]('react.provider');
      var REACT_CONTEXT_TYPE = Symbol["for"]('react.context');
      var REACT_FORWARD_REF_TYPE = Symbol["for"]('react.forward_ref');
      var REACT_SUSPENSE_TYPE = Symbol["for"]('react.suspense');
      var REACT_SUSPENSE_LIST_TYPE = Symbol["for"]('react.suspense_list');
      var REACT_MEMO_TYPE = Symbol["for"]('react.memo');
      var REACT_LAZY_TYPE = Symbol["for"]('react.lazy');
      var REACT_OFFSCREEN_TYPE = Symbol["for"]('react.offscreen');
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || _typeof$1(maybeIterable) !== 'object') {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning('error', format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          } // eslint-disable-next-line react-internal/safe-string-coercion

          var argsWithFormat = args.map(function (item) {
            return String(item);
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      // -----------------------------------------------------------------------------

      var enableScopeAPI = false; // Experimental Create Event Handle API.
      var enableCacheElement = false;
      var enableTransitionTracing = false; // No known bugs, but needs performance testing

      var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
      // stuff. Intended to enable React core members to more easily debug scheduling
      // issues in DEV builds.

      var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol["for"]('react.module.reference');
      }
      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (_typeof$1(type) === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE ||
          // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
      } // Keep in sync with react-reconciler/getComponentNameFromFiber

      function getContextName(type) {
        return type.displayName || 'Context';
      } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.

      function getComponentNameFromType(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }
        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }
        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }
        if (typeof type === 'string') {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment';
          case REACT_PORTAL_TYPE:
            return 'Portal';
          case REACT_PROFILER_TYPE:
            return 'Profiler';
          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';
          case REACT_SUSPENSE_TYPE:
            return 'Suspense';
          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }
        if (_typeof$1(type) === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  return getComponentNameFromType(init(payload));
                } catch (x) {
                  return null;
                }
              }

            // eslint-disable-next-line no-fallthrough
          }
        }
        return null;
      }
      var assign = Object.assign;

      // Helpers to patch console.logs to avoid logging during side-effect free
      // replaying on render function. This currently only patches the object
      // lazily which won't cover if the log function was extracted eagerly.
      // We could also eagerly patch the method.
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {}
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
            /* eslint-enable react-internal/no-production-logging */
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
            /* eslint-enable react-internal/no-production-logging */
          }
          if (disabledDepth < 0) {
            error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === undefined) {
            // Extract the VM specific prefix used by each line.
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || '';
            }
          } // We use the prefix to ensure our stacks line up with native stack frames.

          return '\n' + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) {
          return '';
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== undefined) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
          // for warnings.

          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          // This should throw.
          if (construct) {
            // Something should be setting the props in the constructor.
            var Fake = function Fake() {
              throw Error();
            }; // $FlowFixMe

            Object.defineProperty(Fake.prototype, 'props', {
              set: function set() {
                // We use a throwing setter instead of frozen or non-writable props
                // because that won't throw in a non-strict mode function.
                throw Error();
              }
            });
            if ((typeof Reflect === "undefined" ? "undefined" : _typeof$1(Reflect)) === 'object' && Reflect.construct) {
              // We construct a different control for this case to include any extra
              // frames added by the construct call.
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          // This is inlined manually because closure doesn't do it for us.
          if (sample && control && typeof sample.stack === 'string') {
            // This extracts the first frame from the sample that isn't also in the control.
            // Skipping one frame that we assume is the frame that calls the two.
            var sampleLines = sample.stack.split('\n');
            var controlLines = control.stack.split('\n');
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              // We expect at least one stack frame to be shared.
              // Typically this will be the root most one. However, stack frames may be
              // cut off due to maximum stack limits. In this case, one maybe cut off
              // earlier than the other. We assume that the sample is longer or the same
              // and there for cut off earlier. So we should find the root most frame in
              // the sample somewhere in the control.
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              // Next we find the first one that isn't the same which should be the
              // frame that called our sample function and the control.
              if (sampleLines[s] !== controlLines[c]) {
                // In V8, the first line is describing the message but other VMs don't.
                // If we're about to return the first line, and the control is also on the same
                // line, that's a pretty good indicator that our sample threw at same line as
                // the control. I.e. before we entered the sample frame. So we ignore this result.
                // This can happen if you passed a class to function component, or non-function.
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--; // We may still have similar intermediate frames from the construct call.
                    // The next one that isn't the same should be our match though.

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                      var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                      // but we have a user-provided "displayName"
                      // splice it in to make the stack more readable.

                      if (fn.displayName && _frame.includes('<anonymous>')) {
                        _frame = _frame.replace('<anonymous>', fn.displayName);
                      }
                      {
                        if (typeof fn === 'function') {
                          componentFrameCache.set(fn, _frame);
                        }
                      } // Return the line we found.

                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.

        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        {
          if (typeof fn === 'function') {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return '';
        }
        if (typeof type === 'function') {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === 'string') {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame('Suspense');
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame('SuspenseList');
        }
        if (_typeof$1(type) === 'object') {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              // Memo may contain any component type so we recursively resolve it.
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  // Lazy may contain any component type so we recursively resolve it.
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
              }
          }
        }
        return '';
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          // $FlowFixMe This is okay but Flow doesn't know it.
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
              // fail the render phase where it didn't fail before. So we log it.
              // After these have been cleaned up, we'll let them throw.

              try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                  // eslint-disable-next-line react-internal/prod-error-codes
                  var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof$1(typeSpecs[typeSpecName]) + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                  err.name = 'Invariant Violation';
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, _typeof$1(error$1));
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

      function isArray(a) {
        return isArrayImpl(a);
      }

      /*
       * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
       * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
       *
       * The functions in this module will throw an easier-to-understand,
       * easier-to-debug exception with a clear errors message message explaining the
       * problem. (Instead of a confusing exception thrown inside the implementation
       * of the `value` object).
       */
      // $FlowFixMe only called in DEV, so void return is not possible.
      function typeName(value) {
        {
          // toStringTag is needed for namespaced types like Temporal.Instant
          var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
          return type;
        }
      } // $FlowFixMe only called in DEV, so void return is not possible.

      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== undefined;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== undefined;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function warnAboutAccessingKey() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function warnAboutAccessingRef() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      /**
       * Factory method to create a new React element. This no longer adheres to
       * the class pattern, so do not use new to call it. Also, instanceof check
       * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
       * if something is a React Element.
       *
       * @param {*} type
       * @param {*} props
       * @param {*} key
       * @param {string|object} ref
       * @param {*} owner
       * @param {*} self A *temporary* helper to detect places where `this` is
       * different from the `owner` when React.createElement is called, so that we
       * can warn. We want to get rid of owner and replace string `ref`s with arrow
       * functions, and as long as `this` and owner are the same, there will be no
       * change in behavior.
       * @param {*} source An annotation object (added by a transpiler or otherwise)
       * indicating filename, line number, and/or other information.
       * @internal
       */

      var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type: type,
          key: key,
          ref: ref,
          props: props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          // The validation flag is currently mutative. We put it on
          // an external backing store so that we can freeze the whole object.
          // This can be replaced with a WeakMap once they are implemented in
          // commonly used development environments.
          element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
          // the validation flag non-enumerable (where possible, which should
          // include every environment we run tests in), so the test framework
          // ignores it.

          Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          }); // self and source are DEV only properties.

          Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          }); // Two elements created in two different places should be considered
          // equal for testing purposes and therefore we hide it from enumeration.

          Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      /**
       * https://github.com/reactjs/rfcs/pull/107
       * @param {*} type
       * @param {object} props
       * @param {string} key
       */

      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName; // Reserved names are extracted

          var props = {};
          var key = null;
          var ref = null; // Currently, key can be spread in as a prop. This causes a potential
          // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
          // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
          // but as an intermediary step, we will use jsxDEV for everything except
          // <div {...props} key="Hi" />, because we aren't currently able to tell if
          // key is explicitly declared to be undefined or not.

          if (maybeKey !== undefined) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = '' + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = '' + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          } // Remaining properties are added to a new props object

          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          } // Resolve default props

          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === undefined) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      /**
       * Verifies the object is a ReactElement.
       * See https://reactjs.org/docs/react-api.html#isvalidelement
       * @param {?object} object
       * @return {boolean} True if `object` is a ReactElement.
       * @final
       */

      function isValidElement(object) {
        {
          return _typeof$1(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return '\n\nCheck the render method of `' + name + '`.';
            }
          }
          return '';
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return '';
        }
      }
      /**
       * Warn if there's no key explicitly set on dynamic arrays of children or
       * object keys are not valid. This allows us to keep track of children between
       * updates.
       */

      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      /**
       * Warn if the element doesn't have an explicit key assigned to it.
       * This element is in an array. The array could grow and shrink or be
       * reordered. All children that haven't already been validated are required to
       * have a "key" property assigned to it. Error statuses are cached so a warning
       * will only be shown once.
       *
       * @internal
       * @param {ReactElement} element Element that requires a key.
       * @param {*} parentType element's parent's type.
       */

      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
          // property, it may be the creator of the child that's responsible for
          // assigning it a key.

          var childOwner = '';
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            // Give the component that originally created this child.
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      /**
       * Ensure that every element either is passed in a static location, in an
       * array with an explicit keys property defined, or in an object literal
       * with valid key property.
       *
       * @internal
       * @param {ReactNode} node Statically passed child of any type.
       * @param {*} parentType node's parent's type.
       */

      function validateChildKeys(node, parentType) {
        {
          if (_typeof$1(node) !== 'object') {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            // This element was passed in a valid location.
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') {
              // Entry iterators used to provide implicit keys,
              // but now we print a separate warning for them later.
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      /**
       * Given an element, validate that its props follow the propTypes definition,
       * provided by the type.
       *
       * @param {ReactElement} element
       */

      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === undefined || typeof type === 'string') {
            return;
          }
          var propTypes;
          if (typeof type === 'function') {
            propTypes = type.propTypes;
          } else if (_typeof$1(type) === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE ||
          // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
          } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

            var _name = getComponentNameFromType(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
          }
          if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
          }
        }
      }
      /**
       * Given a fragment, validate that it can only be provided with fragment props
       * @param {ReactElement} fragment
       */

      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
              setCurrentlyValidatingElement$1(fragment);
              error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
          // succeed and there will likely be errors in render.

          if (!validType) {
            var info = '';
            if (type === undefined || _typeof$1(type) === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = 'null';
            } else if (isArray(type)) {
              typeString = 'array';
            } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
              info = ' Did you accidentally export a JSX literal instead of a component?';
            } else {
              typeString = _typeof$1(type);
            }
            error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
          // TODO: Drop this when these are no longer allowed as the type argument.

          if (element == null) {
            return element;
          } // Skip key warning if the type isn't valid since our key validation logic
          // doesn't expect a non-string/function type and can throw confusing errors.
          // We don't want exception behavior to differ between dev and prod.
          // (Rendering will throw with a helpful message and as soon as the type is
          // fixed, the key warnings will appear.)

          if (validType) {
            var children = props.children;
            if (children !== undefined) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      } // These two functions exist to still get child warnings in dev
      // even with the prod transform. This means that jsxDEV is purely
      // opt-in behavior for better messages but that we won't stop
      // giving you warnings if you use production apis.

      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
      // for now we can ship identical prod functions

      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}

var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === 'production') {
    jsxRuntime.exports = requireReactJsxRuntime_production_min();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}

var jsxRuntimeExports = requireJsxRuntime();

var _templateObject$2, _templateObject2$1;
var css$4 = String.raw;
var vhPolyfill = css$4(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral$1(["\n  :root,\n  :host {\n    --chakra-vh: 100vh;\n  }\n\n  @supports (height: -webkit-fill-available) {\n    :root,\n    :host {\n      --chakra-vh: -webkit-fill-available;\n    }\n  }\n\n  @supports (height: -moz-fill-available) {\n    :root,\n    :host {\n      --chakra-vh: -moz-fill-available;\n    }\n  }\n\n  @supports (height: 100dvh) {\n    :root,\n    :host {\n      --chakra-vh: 100dvh;\n    }\n  }\n"])));
var CSSPolyfill = function CSSPolyfill() {
  return /* @__PURE__ */jsxRuntimeExports.jsx(Global$1, {
    styles: vhPolyfill
  });
};
var CSSReset = function CSSReset(_ref) {
  var _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? "" : _ref$scope;
  return /* @__PURE__ */jsxRuntimeExports.jsx(Global$1, {
    styles: css$4(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral$1(["\n      html {\n        line-height: 1.5;\n        -webkit-text-size-adjust: 100%;\n        font-family: system-ui, sans-serif;\n        -webkit-font-smoothing: antialiased;\n        text-rendering: optimizeLegibility;\n        -moz-osx-font-smoothing: grayscale;\n        touch-action: manipulation;\n      }\n\n      body {\n        position: relative;\n        min-height: 100%;\n        margin: 0;\n        font-feature-settings: \"kern\";\n      }\n\n      ", " :where(*, *::before, *::after) {\n        border-width: 0;\n        border-style: solid;\n        box-sizing: border-box;\n        word-wrap: break-word;\n      }\n\n      main {\n        display: block;\n      }\n\n      ", " hr {\n        border-top-width: 1px;\n        box-sizing: content-box;\n        height: 0;\n        overflow: visible;\n      }\n\n      ", " :where(pre, code, kbd,samp) {\n        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n        font-size: 1em;\n      }\n\n      ", " a {\n        background-color: transparent;\n        color: inherit;\n        text-decoration: inherit;\n      }\n\n      ", " abbr[title] {\n        border-bottom: none;\n        text-decoration: underline;\n        -webkit-text-decoration: underline dotted;\n        text-decoration: underline dotted;\n      }\n\n      ", " :where(b, strong) {\n        font-weight: bold;\n      }\n\n      ", " small {\n        font-size: 80%;\n      }\n\n      ", " :where(sub,sup) {\n        font-size: 75%;\n        line-height: 0;\n        position: relative;\n        vertical-align: baseline;\n      }\n\n      ", " sub {\n        bottom: -0.25em;\n      }\n\n      ", " sup {\n        top: -0.5em;\n      }\n\n      ", " img {\n        border-style: none;\n      }\n\n      ", " :where(button, input, optgroup, select, textarea) {\n        font-family: inherit;\n        font-size: 100%;\n        line-height: 1.15;\n        margin: 0;\n      }\n\n      ", " :where(button, input) {\n        overflow: visible;\n      }\n\n      ", " :where(button, select) {\n        text-transform: none;\n      }\n\n      ", " :where(\n          button::-moz-focus-inner,\n          [type=\"button\"]::-moz-focus-inner,\n          [type=\"reset\"]::-moz-focus-inner,\n          [type=\"submit\"]::-moz-focus-inner\n        ) {\n        border-style: none;\n        padding: 0;\n      }\n\n      ", " fieldset {\n        padding: 0.35em 0.75em 0.625em;\n      }\n\n      ", " legend {\n        box-sizing: border-box;\n        color: inherit;\n        display: table;\n        max-width: 100%;\n        padding: 0;\n        white-space: normal;\n      }\n\n      ", " progress {\n        vertical-align: baseline;\n      }\n\n      ", " textarea {\n        overflow: auto;\n      }\n\n      ", " :where([type=\"checkbox\"], [type=\"radio\"]) {\n        box-sizing: border-box;\n        padding: 0;\n      }\n\n      ", " input[type=\"number\"]::-webkit-inner-spin-button,\n      ", " input[type=\"number\"]::-webkit-outer-spin-button {\n        -webkit-appearance: none !important;\n      }\n\n      ", " input[type=\"number\"] {\n        -moz-appearance: textfield;\n      }\n\n      ", " input[type=\"search\"] {\n        -webkit-appearance: textfield;\n        outline-offset: -2px;\n      }\n\n      ", " input[type=\"search\"]::-webkit-search-decoration {\n        -webkit-appearance: none !important;\n      }\n\n      ", " ::-webkit-file-upload-button {\n        -webkit-appearance: button;\n        font: inherit;\n      }\n\n      ", " details {\n        display: block;\n      }\n\n      ", " summary {\n        display: list-item;\n      }\n\n      template {\n        display: none;\n      }\n\n      [hidden] {\n        display: none !important;\n      }\n\n      ", " :where(\n          blockquote,\n          dl,\n          dd,\n          h1,\n          h2,\n          h3,\n          h4,\n          h5,\n          h6,\n          hr,\n          figure,\n          p,\n          pre\n        ) {\n        margin: 0;\n      }\n\n      ", " button {\n        background: transparent;\n        padding: 0;\n      }\n\n      ", " fieldset {\n        margin: 0;\n        padding: 0;\n      }\n\n      ", " :where(ol, ul) {\n        margin: 0;\n        padding: 0;\n      }\n\n      ", " textarea {\n        resize: vertical;\n      }\n\n      ", " :where(button, [role=\"button\"]) {\n        cursor: pointer;\n      }\n\n      ", " button::-moz-focus-inner {\n        border: 0 !important;\n      }\n\n      ", " table {\n        border-collapse: collapse;\n      }\n\n      ", " :where(h1, h2, h3, h4, h5, h6) {\n        font-size: inherit;\n        font-weight: inherit;\n      }\n\n      ", " :where(button, input, optgroup, select, textarea) {\n        padding: 0;\n        line-height: inherit;\n        color: inherit;\n      }\n\n      ", " :where(img, svg, video, canvas, audio, iframe, embed, object) {\n        display: block;\n      }\n\n      ", " :where(img, video) {\n        max-width: 100%;\n        height: auto;\n      }\n\n      [data-js-focus-visible]\n        :focus:not([data-focus-visible-added]):not(\n          [data-focus-visible-disabled]\n        ) {\n        outline: none;\n        box-shadow: none;\n      }\n\n      ", " select::-ms-expand {\n        display: none;\n      }\n\n      ", "\n    "])), scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, vhPolyfill)
  });
};

function getErrorMessage(hook, provider) {
  return "".concat(hook, " returned `undefined`. Seems you forgot to wrap component within ").concat(provider);
}
function createContext$1() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var name = options.name,
    _options$strict = options.strict,
    strict = _options$strict === void 0 ? true : _options$strict,
    _options$hookName = options.hookName,
    hookName = _options$hookName === void 0 ? "useContext" : _options$hookName,
    _options$providerName = options.providerName,
    providerName = _options$providerName === void 0 ? "Provider" : _options$providerName,
    errorMessage = options.errorMessage,
    defaultValue = options.defaultValue;
  var Context = /*#__PURE__*/createContext$2(defaultValue);
  Context.displayName = name;
  function useContext$1() {
    var _a;
    var context = useContext(Context);
    if (!context && strict) {
      var error = new Error(errorMessage != null ? errorMessage : getErrorMessage(hookName, providerName));
      error.name = "ContextError";
      (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext$1);
      throw error;
    }
    return context;
  }
  return [Context.Provider, useContext$1, Context];
}

var _createContext$o = createContext$1({
    strict: false,
    name: "PortalManagerContext"
  }),
  _createContext2$o = _slicedToArray$1(_createContext$o, 2),
  PortalManagerContextProvider = _createContext2$o[0],
  usePortalManager = _createContext2$o[1];
function PortalManager(props) {
  var children = props.children,
    zIndex = props.zIndex;
  return /* @__PURE__ */jsxRuntimeExports.jsx(PortalManagerContextProvider, {
    value: {
      zIndex: zIndex
    },
    children: children
  });
}
PortalManager.displayName = "PortalManager";

var useSafeLayoutEffect$2 = Boolean(globalThis == null ? void 0 : globalThis.document) ? useLayoutEffect : useEffect;

var _excluded$2n = ["containerRef"];
var _createContext$n = createContext$1({
    strict: false,
    name: "PortalContext"
  }),
  _createContext2$n = _slicedToArray$1(_createContext$n, 2),
  PortalContextProvider = _createContext2$n[0],
  usePortalContext = _createContext2$n[1];
var PORTAL_CLASSNAME = "chakra-portal";
var PORTAL_SELECTOR = ".chakra-portal";
var Container$2 = function Container(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("div", {
    className: "chakra-portal-zIndex",
    style: {
      position: "absolute",
      zIndex: props.zIndex,
      top: 0,
      left: 0,
      right: 0
      // NB: Don't add `bottom: 0`, it makes the entire app unusable
      // @see https://github.com/chakra-ui/chakra-ui/issues/3201
    },
    children: props.children
  });
};
var DefaultPortal = function DefaultPortal(props) {
  var appendToParentPortal = props.appendToParentPortal,
    children = props.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray$1(_useState, 2),
    tempNode = _useState2[0],
    setTempNode = _useState2[1];
  var portal = useRef(null);
  var _useState3 = useState({}),
    _useState4 = _slicedToArray$1(_useState3, 2),
    forceUpdate = _useState4[1];
  useEffect(function () {
    return forceUpdate({});
  }, []);
  var parentPortal = usePortalContext();
  var manager = usePortalManager();
  useSafeLayoutEffect$2(function () {
    if (!tempNode) return;
    var doc = tempNode.ownerDocument;
    var host = appendToParentPortal ? parentPortal != null ? parentPortal : doc.body : doc.body;
    if (!host) return;
    portal.current = doc.createElement("div");
    portal.current.className = PORTAL_CLASSNAME;
    host.appendChild(portal.current);
    forceUpdate({});
    var portalNode = portal.current;
    return function () {
      if (host.contains(portalNode)) {
        host.removeChild(portalNode);
      }
    };
  }, [tempNode]);
  var _children = (manager == null ? void 0 : manager.zIndex) ? /* @__PURE__ */jsxRuntimeExports.jsx(Container$2, {
    zIndex: manager == null ? void 0 : manager.zIndex,
    children: children
  }) : children;
  return portal.current ? /*#__PURE__*/createPortal(/* @__PURE__ */jsxRuntimeExports.jsx(PortalContextProvider, {
    value: portal.current,
    children: _children
  }), portal.current) : /* @__PURE__ */jsxRuntimeExports.jsx("span", {
    ref: function ref(el) {
      if (el) setTempNode(el);
    }
  });
};
var ContainerPortal = function ContainerPortal(props) {
  var children = props.children,
    containerRef = props.containerRef,
    appendToParentPortal = props.appendToParentPortal;
  var containerEl = containerRef.current;
  var host = containerEl != null ? containerEl : typeof window !== "undefined" ? document.body : void 0;
  var portal = useMemo(function () {
    var node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
    if (node) node.className = PORTAL_CLASSNAME;
    return node;
  }, [containerEl]);
  var _useState5 = useState({}),
    _useState6 = _slicedToArray$1(_useState5, 2),
    forceUpdate = _useState6[1];
  useSafeLayoutEffect$2(function () {
    return forceUpdate({});
  }, []);
  useSafeLayoutEffect$2(function () {
    if (!portal || !host) return;
    host.appendChild(portal);
    return function () {
      host.removeChild(portal);
    };
  }, [portal, host]);
  if (host && portal) {
    return /*#__PURE__*/createPortal(/* @__PURE__ */jsxRuntimeExports.jsx(PortalContextProvider, {
      value: appendToParentPortal ? portal : null,
      children: children
    }), portal);
  }
  return null;
};
function Portal(props) {
  var portalProps = _objectSpread2$1({
    appendToParentPortal: true
  }, props);
  var containerRef = portalProps.containerRef,
    rest = _objectWithoutProperties$1(portalProps, _excluded$2n);
  return containerRef ? /* @__PURE__ */jsxRuntimeExports.jsx(ContainerPortal, _objectSpread2$1({
    containerRef: containerRef
  }, rest)) : /* @__PURE__ */jsxRuntimeExports.jsx(DefaultPortal, _objectSpread2$1({}, rest));
}
Portal.className = PORTAL_CLASSNAME;
Portal.selector = PORTAL_SELECTOR;
Portal.displayName = "Portal";

function useTheme() {
  var theme = useContext(ThemeContext$1);
  if (!theme) {
    throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
  }
  return theme;
}

var ColorModeContext = /*#__PURE__*/createContext$2({});
ColorModeContext.displayName = "ColorModeContext";
function useColorMode() {
  var context = useContext(ColorModeContext);
  if (context === void 0) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }
  return context;
}

// src/color-mode.utils.ts
var classNames$1 = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function getColorModeUtils() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$preventTrans = options.preventTransition,
    preventTransition = _options$preventTrans === void 0 ? true : _options$preventTrans;
  var utils = {
    setDataset: function setDataset(value) {
      var cleanup = preventTransition ? utils.preventTransition() : void 0;
      document.documentElement.dataset.theme = value;
      document.documentElement.style.colorScheme = value;
      cleanup == null ? void 0 : cleanup();
    },
    setClassName: function setClassName(dark) {
      document.body.classList.add(dark ? classNames$1.dark : classNames$1.light);
      document.body.classList.remove(dark ? classNames$1.light : classNames$1.dark);
    },
    query: function query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme: function getSystemTheme(fallback) {
      var _a;
      var dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
      return dark ? "dark" : "light";
    },
    addListener: function addListener(fn) {
      var mql = utils.query();
      var listener = function listener(e) {
        fn(e.matches ? "dark" : "light");
      };
      if (typeof mql.addListener === "function") mql.addListener(listener);else mql.addEventListener("change", listener);
      return function () {
        if (typeof mql.removeListener === "function") mql.removeListener(listener);else mql.removeEventListener("change", listener);
      };
    },
    preventTransition: function preventTransition() {
      var css = document.createElement("style");
      css.appendChild(document.createTextNode("*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"));
      document.head.appendChild(css);
      return function () {
        (function () {
          return window.getComputedStyle(document.body);
        })();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            document.head.removeChild(css);
          });
        });
      };
    }
  };
  return utils;
}

// src/storage-manager.ts
var STORAGE_KEY = "chakra-ui-color-mode";
function createLocalStorageManager(key) {
  return {
    ssr: false,
    type: "localStorage",
    get: function get(init) {
      if (!(globalThis == null ? void 0 : globalThis.document)) return init;
      var value;
      try {
        value = localStorage.getItem(key) || init;
      } catch (e) {}
      return value || init;
    },
    set: function set(value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {}
    }
  };
}
var localStorageManager = createLocalStorageManager(STORAGE_KEY);

var noop$2 = function noop() {};
function getTheme(manager, fallback) {
  return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function ColorModeProvider(props) {
  var value = props.value,
    children = props.children,
    _props$options = props.options,
    _props$options2 = _props$options === void 0 ? {} : _props$options,
    useSystemColorMode = _props$options2.useSystemColorMode,
    initialColorMode = _props$options2.initialColorMode,
    disableTransitionOnChange = _props$options2.disableTransitionOnChange,
    _props$colorModeManag = props.colorModeManager,
    colorModeManager = _props$colorModeManag === void 0 ? localStorageManager : _props$colorModeManag;
  var defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
  var _useState = useState(function () {
      return getTheme(colorModeManager, defaultColorMode);
    }),
    _useState2 = _slicedToArray$1(_useState, 2),
    colorMode = _useState2[0],
    rawSetColorMode = _useState2[1];
  var _useState3 = useState(function () {
      return getTheme(colorModeManager);
    }),
    _useState4 = _slicedToArray$1(_useState3, 2),
    resolvedColorMode = _useState4[0],
    setResolvedColorMode = _useState4[1];
  var _useMemo = useMemo(function () {
      return getColorModeUtils({
        preventTransition: disableTransitionOnChange
      });
    }, [disableTransitionOnChange]),
    getSystemTheme = _useMemo.getSystemTheme,
    setClassName = _useMemo.setClassName,
    setDataset = _useMemo.setDataset,
    addListener = _useMemo.addListener;
  var resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
  var setColorMode = useCallback(function (value2) {
    var resolved = value2 === "system" ? getSystemTheme() : value2;
    rawSetColorMode(resolved);
    setClassName(resolved === "dark");
    setDataset(resolved);
    colorModeManager.set(resolved);
  }, [colorModeManager, getSystemTheme, setClassName, setDataset]);
  useSafeLayoutEffect$2(function () {
    if (initialColorMode === "system") {
      setResolvedColorMode(getSystemTheme());
    }
  }, []);
  useEffect(function () {
    var managerValue = colorModeManager.get();
    if (managerValue) {
      setColorMode(managerValue);
      return;
    }
    if (initialColorMode === "system") {
      setColorMode("system");
      return;
    }
    setColorMode(defaultColorMode);
  }, [colorModeManager, defaultColorMode, initialColorMode, setColorMode]);
  var toggleColorMode = useCallback(function () {
    setColorMode(resolvedValue === "dark" ? "light" : "dark");
  }, [resolvedValue, setColorMode]);
  useEffect(function () {
    if (!useSystemColorMode) return;
    return addListener(setColorMode);
  }, [useSystemColorMode, addListener, setColorMode]);
  var context = useMemo(function () {
    return {
      colorMode: value != null ? value : resolvedValue,
      toggleColorMode: value ? noop$2 : toggleColorMode,
      setColorMode: value ? noop$2 : setColorMode,
      forced: value !== void 0
    };
  }, [resolvedValue, toggleColorMode, setColorMode, value]);
  return /* @__PURE__ */jsxRuntimeExports.jsx(ColorModeContext.Provider, {
    value: context,
    children: children
  });
}
ColorModeProvider.displayName = "ColorModeProvider";

function useChakra() {
  var colorModeResult = useColorMode();
  var theme = useTheme();
  return _objectSpread2$1(_objectSpread2$1({}, colorModeResult), {}, {
    theme: theme
  });
}
function getBreakpointValue(theme, value, fallback) {
  var _a, _b;
  if (value == null) return value;
  var getValue = function getValue(val) {
    var _a2, _b2;
    return (_b2 = (_a2 = theme.__breakpoints) == null ? void 0 : _a2.asArray) == null ? void 0 : _b2[val];
  };
  return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function getTokenValue(theme, value, fallback) {
  var _a, _b;
  if (value == null) return value;
  var getValue = function getValue(val) {
    var _a2, _b2;
    return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.value;
  };
  return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function useToken(scale, token, fallback) {
  var theme = useTheme();
  return getToken(scale, token, fallback)(theme);
}
function getToken(scale, token, fallback) {
  var _token = Array.isArray(token) ? token : [token];
  var _fallback = Array.isArray(fallback) ? fallback : [fallback];
  return function (theme) {
    var fallbackArr = _fallback.filter(Boolean);
    var result = _token.map(function (token2, index) {
      var _a, _b;
      if (scale === "breakpoints") {
        return getBreakpointValue(theme, token2, (_a = fallbackArr[index]) != null ? _a : token2);
      }
      var path = "".concat(scale, ".").concat(token2);
      return getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
    });
    return Array.isArray(token) ? result : result[0];
  };
}

// src/index.ts
var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(" ");
};
function isDev() {
  return process.env.NODE_ENV !== "production";
}
function isObject(value) {
  var type = _typeof$1(value);
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var warn = function warn(options) {
  var condition = options.condition,
    message = options.message;
  if (condition && isDev()) {
    console.warn(message);
  }
};
function runIfFn$2(valueOrFn) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  return isFunction$3(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
var isFunction$3 = function isFunction(value) {
  return typeof value === "function";
};
var dataAttr = function dataAttr(condition) {
  return condition ? "" : void 0;
};
var ariaAttr = function ariaAttr(condition) {
  return condition ? true : void 0;
};
function callAllHandlers$1() {
  for (var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    fns[_key3] = arguments[_key3];
  }
  return function func(event) {
    fns.some(function (fn) {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll() {
  for (var _len4 = arguments.length, fns = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    fns[_key4] = arguments[_key4];
  }
  return function mergedFn(arg) {
    fns.forEach(function (fn) {
      fn == null ? void 0 : fn(arg);
    });
  };
}

var lodash_mergewith = {exports: {}};

lodash_mergewith.exports;
var hasRequiredLodash_mergewith;
function requireLodash_mergewith() {
  if (hasRequiredLodash_mergewith) return lodash_mergewith.exports;
  hasRequiredLodash_mergewith = 1;
  (function (module, exports) {
    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /** Used to detect hot functions by number of calls within a span of milliseconds. */
    var HOT_COUNT = 800,
      HOT_SPAN = 16;

    /** Used as references for various `Number` constants. */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]';
    var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;

    /** Used to detect unsigned integer values. */
    var reIsUint = /^(?:0|[1-9]\d*)$/;

    /** Used to identify `toStringTag` values of typed arrays. */
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

    /** Detect free variable `global` from Node.js. */
    var freeGlobal = _typeof$1(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

    /** Detect free variable `self`. */
    var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof$1(self)) == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function('return this')();

    /** Detect free variable `exports`. */
    var freeExports = exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Detect free variable `process` from Node.js. */
    var freeProcess = moduleExports && freeGlobal.process;

    /** Used to access faster Node.js helpers. */
    var nodeUtil = function () {
      try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) {
          return types;
        }

        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();

    /* Node.js helper references. */
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }

    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */
    function baseTimes(n, iteratee) {
      var index = -1,
        result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }

    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */
    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }

    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }

    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */
    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = root['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

    /** Built-in value references. */
    var Buffer = moduleExports ? root.Buffer : undefined,
      _Symbol = root.Symbol,
      Uint8Array = root.Uint8Array;
      Buffer ? Buffer.allocUnsafe : undefined;
      var getPrototype = overArg(Object.getPrototypeOf, Object),
      objectCreate = Object.create,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice,
      symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
    var defineProperty = function () {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }();

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
      nativeMax = Math.max,
      nativeNow = Date.now;

    /* Built-in method references that are verified to be native. */
    var Map = getNative(root, 'Map'),
      nativeCreate = getNative(Object, 'create');

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = function () {
      function object() {}
      return function (proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object();
        object.prototype = undefined;
        return result;
      };
    }();

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash(),
        'map': new (Map || ListCache)(),
        'string': new Hash()
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
        size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
        result = data['delete'](key);
      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;
      for (var key in value) {
        if (!(skipIndexes && (
        // Safari 9 has enumerable `arguments.length` in strict mode.
        key == 'length' ||
        // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == 'offset' || key == 'parent') ||
        // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
        // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
        result = [];
      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function (srcValue, key) {
        stack || (stack = new Stack());
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        } else {
          var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
        srcValue = safeGet(source, key),
        stacked = stack.get(srcValue);
      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
      var isCommon = newValue === undefined;
      if (isCommon) {
        var isArr = isArray(srcValue),
          isBuff = !isArr && isBuffer(srcValue),
          isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          } else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          } else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue);
          } else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue);
          } else {
            newValue = [];
          }
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          } else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        } else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function (func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      {
        return buffer.slice();
      }
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = cloneArrayBuffer(typedArray.buffer) ;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
        length = source.length;
      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});
      var index = -1,
        length = props.length;
      while (++index < length) {
        var key = props[index];
        var newValue = undefined;
        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function (object, sources) {
        var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function (object, iteratee, keysFunc) {
        var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;
        while (length--) {
          var key = props[++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];
      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = _typeof$1(value);
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = _typeof$1(index);
      if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = _typeof$1(value);
      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
      return value === proto;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? func.length - 1 : start, 0);
      return function () {
        var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);
        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }
      if (key == '__proto__') {
        return;
      }
      return object[key];
    }

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
        lastCalled = 0;
      return function () {
        var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return func + '';
        } catch (e) {}
      }
      return '';
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function () {
      return arguments;
    }()) ? baseIsArguments : function (value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = _typeof$1(value);
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && _typeof$1(value) == 'object';
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeysIn(object);
    }

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function () {
        return value;
      };
    }

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }
    module.exports = mergeWith;
  })(lodash_mergewith, lodash_mergewith.exports);
  return lodash_mergewith.exports;
}

var lodash_mergewithExports = requireLodash_mergewith();
var mergeWith = /*@__PURE__*/getDefaultExportFromCjs(lodash_mergewithExports);

var _excluded$2m = ["__cssMap", "__cssVars", "__breakpoints"];
var isImportant = function isImportant(value) {
  return /!(important)?$/.test(value);
};
var withoutImportant = function withoutImportant(value) {
  return typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
};
var tokenToCSSVar = function tokenToCSSVar(scale, value) {
  return function (theme) {
    var valueStr = String(value);
    var important = isImportant(valueStr);
    var valueWithoutImportant = withoutImportant(valueStr);
    var key = scale ? "".concat(scale, ".").concat(valueWithoutImportant) : valueWithoutImportant;
    var transformed = isObject(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
    transformed = withoutImportant(transformed);
    return important ? "".concat(transformed, " !important") : transformed;
  };
};
function createTransform(options) {
  var scale = options.scale,
    transform2 = options.transform,
    compose = options.compose;
  var fn = function fn(value, theme) {
    var _a;
    var _value = tokenToCSSVar(scale, value)(theme);
    var result = (_a = transform2 == null ? void 0 : transform2(_value, theme)) != null ? _a : _value;
    if (compose) {
      result = compose(result, theme);
    }
    return result;
  };
  return fn;
}

// src/utils/pipe.ts
var pipe$2 = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (v) {
    return fns.reduce(function (a, b) {
      return b(a);
    }, v);
  };
};

// src/utils/prop-config.ts
function toConfig(scale, transform2) {
  return function (property) {
    var result = {
      property: property,
      scale: scale
    };
    result.transform = createTransform({
      scale: scale,
      transform: transform2
    });
    return result;
  };
}
var getRtl = function getRtl(_ref) {
  var rtl = _ref.rtl,
    ltr = _ref.ltr;
  return function (theme) {
    return theme.direction === "rtl" ? rtl : ltr;
  };
};
function logical(options) {
  var property = options.property,
    scale = options.scale,
    transform2 = options.transform;
  return {
    scale: scale,
    property: getRtl(property),
    transform: scale ? createTransform({
      scale: scale,
      compose: transform2
    }) : transform2
  };
}

// src/utils/templates.ts
var transformTemplate = ["rotate(var(--chakra-rotate, 0))", "scaleX(var(--chakra-scale-x, 1))", "scaleY(var(--chakra-scale-y, 1))", "skewX(var(--chakra-skew-x, 0))", "skewY(var(--chakra-skew-y, 0))"];
function getTransformTemplate() {
  return ["translateX(var(--chakra-translate-x, 0))", "translateY(var(--chakra-translate-y, 0))"].concat(transformTemplate).join(" ");
}
function getTransformGpuTemplate() {
  return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"].concat(transformTemplate).join(" ");
}
var filterTemplate = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: ["var(--chakra-blur)", "var(--chakra-brightness)", "var(--chakra-contrast)", "var(--chakra-grayscale)", "var(--chakra-hue-rotate)", "var(--chakra-invert)", "var(--chakra-saturate)", "var(--chakra-sepia)", "var(--chakra-drop-shadow)"].join(" ")
};
var backdropFilterTemplate = {
  backdropFilter: ["var(--chakra-backdrop-blur)", "var(--chakra-backdrop-brightness)", "var(--chakra-backdrop-contrast)", "var(--chakra-backdrop-grayscale)", "var(--chakra-backdrop-hue-rotate)", "var(--chakra-backdrop-invert)", "var(--chakra-backdrop-opacity)", "var(--chakra-backdrop-saturate)", "var(--chakra-backdrop-sepia)"].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function getRingTemplate(value) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": value,
    boxShadow: ["var(--chakra-ring-offset-shadow)", "var(--chakra-ring-shadow)", "var(--chakra-shadow, 0 0 #0000)"].join(", ")
  };
}
var flexDirectionTemplate = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
};

// src/utils/parse-gradient.ts
var directionMap = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
};
var valueSet = new Set(Object.values(directionMap));
var globalSet = /* @__PURE__ */new Set(["none", "-moz-initial", "inherit", "initial", "revert", "unset"]);
var trimSpace = function trimSpace(str) {
  return str.trim();
};
function parseGradient(value, theme) {
  if (value == null || globalSet.has(value)) return value;
  var prevent = isCSSFunction(value) || globalSet.has(value);
  if (!prevent) return "url('".concat(value, "')");
  var regex = /(^[a-z-A-Z]+)\((.*)\)/g;
  var results = regex.exec(value);
  var type = results == null ? void 0 : results[1];
  var values = results == null ? void 0 : results[2];
  if (!type || !values) return value;
  var _type = type.includes("-gradient") ? type : "".concat(type, "-gradient");
  var _values$split$map$fil = values.split(",").map(trimSpace).filter(Boolean),
    _values$split$map$fil2 = _toArray(_values$split$map$fil),
    maybeDirection = _values$split$map$fil2[0],
    stops = _values$split$map$fil2.slice(1);
  if ((stops == null ? void 0 : stops.length) === 0) return value;
  var direction = maybeDirection in directionMap ? directionMap[maybeDirection] : maybeDirection;
  stops.unshift(direction);
  var _values = stops.map(function (stop) {
    if (valueSet.has(stop)) return stop;
    var firstStop = stop.indexOf(" ");
    var _ref2 = firstStop !== -1 ? [stop.substr(0, firstStop), stop.substr(firstStop + 1)] : [stop],
      _ref3 = _slicedToArray$1(_ref2, 2),
      _color = _ref3[0],
      _stop = _ref3[1];
    var _stopOrFunc = isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");
    var key = "colors.".concat(_color);
    var color2 = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
    return _stopOrFunc ? [color2].concat(_toConsumableArray$1(Array.isArray(_stopOrFunc) ? _stopOrFunc : [_stopOrFunc])).join(" ") : color2;
  });
  return "".concat(_type, "(").concat(_values.join(", "), ")");
}
var isCSSFunction = function isCSSFunction(value) {
  return typeof value === "string" && value.includes("(") && value.includes(")");
};
var gradientTransform = function gradientTransform(value, theme) {
  return parseGradient(value, theme != null ? theme : {});
};

// src/utils/transform-functions.ts
function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
}
var analyzeCSSValue = function analyzeCSSValue(value) {
  var num = parseFloat(value.toString());
  var unit = value.toString().replace(String(num), "");
  return {
    unitless: !unit,
    value: num,
    unit: unit
  };
};
var wrap = function wrap(str) {
  return function (value) {
    return "".concat(str, "(").concat(value, ")");
  };
};
var transformFunctions = {
  filter: function filter(value) {
    return value !== "auto" ? value : filterTemplate;
  },
  backdropFilter: function backdropFilter(value) {
    return value !== "auto" ? value : backdropFilterTemplate;
  },
  ring: function ring(value) {
    return getRingTemplate(transformFunctions.px(value));
  },
  bgClip: function bgClip(value) {
    return value === "text" ? {
      color: "transparent",
      backgroundClip: "text"
    } : {
      backgroundClip: value
    };
  },
  transform: function transform(value) {
    if (value === "auto") return getTransformTemplate();
    if (value === "auto-gpu") return getTransformGpuTemplate();
    return value;
  },
  vh: function vh(value) {
    return value === "$100vh" ? "var(--chakra-vh)" : value;
  },
  px: function px(value) {
    if (value == null) return value;
    var _analyzeCSSValue = analyzeCSSValue(value),
      unitless = _analyzeCSSValue.unitless;
    return unitless || typeof value === "number" ? "".concat(value, "px") : value;
  },
  fraction: function fraction(value) {
    return !(typeof value === "number") || value > 1 ? value : "".concat(value * 100, "%");
  },
  "float": function float(value, theme) {
    var map = {
      left: "right",
      right: "left"
    };
    return theme.direction === "rtl" ? map[value] : value;
  },
  degree: function degree(value) {
    if (isCssVar(value) || value == null) return value;
    var unitless = typeof value === "string" && !value.endsWith("deg");
    return typeof value === "number" || unitless ? "".concat(value, "deg") : value;
  },
  gradient: gradientTransform,
  blur: wrap("blur"),
  opacity: wrap("opacity"),
  brightness: wrap("brightness"),
  contrast: wrap("contrast"),
  dropShadow: wrap("drop-shadow"),
  grayscale: wrap("grayscale"),
  hueRotate: function hueRotate(value) {
    return wrap("hue-rotate")(transformFunctions.degree(value));
  },
  invert: wrap("invert"),
  saturate: wrap("saturate"),
  sepia: wrap("sepia"),
  bgImage: function bgImage(value) {
    if (value == null) return value;
    var prevent = isCSSFunction(value) || globalSet.has(value);
    return !prevent ? "url(".concat(value, ")") : value;
  },
  outline: function outline(value) {
    var isNoneOrZero = String(value) === "0" || String(value) === "none";
    return value !== null && isNoneOrZero ? {
      outline: "2px solid transparent",
      outlineOffset: "2px"
    } : {
      outline: value
    };
  },
  flexDirection: function flexDirection(value) {
    var _a;
    var _ref4 = (_a = flexDirectionTemplate[value]) != null ? _a : {},
      space2 = _ref4.space,
      divide2 = _ref4.divide;
    var result = {
      flexDirection: value
    };
    if (space2) result[space2] = 1;
    if (divide2) result[divide2] = 1;
    return result;
  }
};

// src/utils/index.ts
var t = {
  borderWidths: toConfig("borderWidths"),
  borderStyles: toConfig("borderStyles"),
  colors: toConfig("colors"),
  borders: toConfig("borders"),
  gradients: toConfig("gradients", transformFunctions.gradient),
  radii: toConfig("radii", transformFunctions.px),
  space: toConfig("space", pipe$2(transformFunctions.vh, transformFunctions.px)),
  spaceT: toConfig("space", pipe$2(transformFunctions.vh, transformFunctions.px)),
  degreeT: function degreeT(property) {
    return {
      property: property,
      transform: transformFunctions.degree
    };
  },
  prop: function prop(property, scale, transform2) {
    return _objectSpread2$1({
      property: property,
      scale: scale
    }, scale && {
      transform: createTransform({
        scale: scale,
        transform: transform2
      })
    });
  },
  propT: function propT(property, transform2) {
    return {
      property: property,
      transform: transform2
    };
  },
  sizes: toConfig("sizes", pipe$2(transformFunctions.vh, transformFunctions.px)),
  sizesT: toConfig("sizes", pipe$2(transformFunctions.vh, transformFunctions.fraction)),
  shadows: toConfig("shadows"),
  logical: logical,
  blur: toConfig("blur", transformFunctions.blur)
};

// src/config/background.ts
var background = {
  background: t.colors("background"),
  backgroundColor: t.colors("backgroundColor"),
  backgroundImage: t.gradients("backgroundImage"),
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundAttachment: true,
  backgroundClip: {
    transform: transformFunctions.bgClip
  },
  bgSize: t.prop("backgroundSize"),
  bgPosition: t.prop("backgroundPosition"),
  bg: t.colors("background"),
  bgColor: t.colors("backgroundColor"),
  bgPos: t.prop("backgroundPosition"),
  bgRepeat: t.prop("backgroundRepeat"),
  bgAttachment: t.prop("backgroundAttachment"),
  bgGradient: t.gradients("backgroundImage"),
  bgClip: {
    transform: transformFunctions.bgClip
  }
};
Object.assign(background, {
  bgImage: background.backgroundImage,
  bgImg: background.backgroundImage
});

// src/config/border.ts
var border = {
  border: t.borders("border"),
  borderWidth: t.borderWidths("borderWidth"),
  borderStyle: t.borderStyles("borderStyle"),
  borderColor: t.colors("borderColor"),
  borderRadius: t.radii("borderRadius"),
  borderTop: t.borders("borderTop"),
  borderBlockStart: t.borders("borderBlockStart"),
  borderTopLeftRadius: t.radii("borderTopLeftRadius"),
  borderStartStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: t.radii("borderTopRightRadius"),
  borderStartEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: t.borders("borderRight"),
  borderInlineEnd: t.borders("borderInlineEnd"),
  borderBottom: t.borders("borderBottom"),
  borderBlockEnd: t.borders("borderBlockEnd"),
  borderBottomLeftRadius: t.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: t.radii("borderBottomRightRadius"),
  borderLeft: t.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: t.borders(["borderLeft", "borderRight"]),
  borderInline: t.borders("borderInline"),
  borderY: t.borders(["borderTop", "borderBottom"]),
  borderBlock: t.borders("borderBlock"),
  borderTopWidth: t.borderWidths("borderTopWidth"),
  borderBlockStartWidth: t.borderWidths("borderBlockStartWidth"),
  borderTopColor: t.colors("borderTopColor"),
  borderBlockStartColor: t.colors("borderBlockStartColor"),
  borderTopStyle: t.borderStyles("borderTopStyle"),
  borderBlockStartStyle: t.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: t.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: t.borderWidths("borderBlockEndWidth"),
  borderBottomColor: t.colors("borderBottomColor"),
  borderBlockEndColor: t.colors("borderBlockEndColor"),
  borderBottomStyle: t.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: t.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: t.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: t.borderWidths("borderInlineStartWidth"),
  borderLeftColor: t.colors("borderLeftColor"),
  borderInlineStartColor: t.colors("borderInlineStartColor"),
  borderLeftStyle: t.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: t.borderStyles("borderInlineStartStyle"),
  borderRightWidth: t.borderWidths("borderRightWidth"),
  borderInlineEndWidth: t.borderWidths("borderInlineEndWidth"),
  borderRightColor: t.colors("borderRightColor"),
  borderInlineEndColor: t.colors("borderInlineEndColor"),
  borderRightStyle: t.borderStyles("borderRightStyle"),
  borderInlineEndStyle: t.borderStyles("borderInlineEndStyle"),
  borderTopRadius: t.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: t.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
  borderLeftRadius: t.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: t.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(border, {
  rounded: border.borderRadius,
  roundedTop: border.borderTopRadius,
  roundedTopLeft: border.borderTopLeftRadius,
  roundedTopRight: border.borderTopRightRadius,
  roundedTopStart: border.borderStartStartRadius,
  roundedTopEnd: border.borderStartEndRadius,
  roundedBottom: border.borderBottomRadius,
  roundedBottomLeft: border.borderBottomLeftRadius,
  roundedBottomRight: border.borderBottomRightRadius,
  roundedBottomStart: border.borderEndStartRadius,
  roundedBottomEnd: border.borderEndEndRadius,
  roundedLeft: border.borderLeftRadius,
  roundedRight: border.borderRightRadius,
  roundedStart: border.borderInlineStartRadius,
  roundedEnd: border.borderInlineEndRadius,
  borderStart: border.borderInlineStart,
  borderEnd: border.borderInlineEnd,
  borderTopStartRadius: border.borderStartStartRadius,
  borderTopEndRadius: border.borderStartEndRadius,
  borderBottomStartRadius: border.borderEndStartRadius,
  borderBottomEndRadius: border.borderEndEndRadius,
  borderStartRadius: border.borderInlineStartRadius,
  borderEndRadius: border.borderInlineEndRadius,
  borderStartWidth: border.borderInlineStartWidth,
  borderEndWidth: border.borderInlineEndWidth,
  borderStartColor: border.borderInlineStartColor,
  borderEndColor: border.borderInlineEndColor,
  borderStartStyle: border.borderInlineStartStyle,
  borderEndStyle: border.borderInlineEndStyle
});

// src/config/color.ts
var color$1 = {
  color: t.colors("color"),
  textColor: t.colors("color"),
  fill: t.colors("fill"),
  stroke: t.colors("stroke")
};

// src/config/effect.ts
var effect$3 = {
  boxShadow: t.shadows("boxShadow"),
  mixBlendMode: true,
  blendMode: t.prop("mixBlendMode"),
  backgroundBlendMode: true,
  bgBlendMode: t.prop("backgroundBlendMode"),
  opacity: true
};
Object.assign(effect$3, {
  shadow: effect$3.boxShadow
});

// src/config/filter.ts
var filter$1 = {
  filter: {
    transform: transformFunctions.filter
  },
  blur: t.blur("--chakra-blur"),
  brightness: t.propT("--chakra-brightness", transformFunctions.brightness),
  contrast: t.propT("--chakra-contrast", transformFunctions.contrast),
  hueRotate: t.propT("--chakra-hue-rotate", transformFunctions.hueRotate),
  invert: t.propT("--chakra-invert", transformFunctions.invert),
  saturate: t.propT("--chakra-saturate", transformFunctions.saturate),
  dropShadow: t.propT("--chakra-drop-shadow", transformFunctions.dropShadow),
  backdropFilter: {
    transform: transformFunctions.backdropFilter
  },
  backdropBlur: t.blur("--chakra-backdrop-blur"),
  backdropBrightness: t.propT("--chakra-backdrop-brightness", transformFunctions.brightness),
  backdropContrast: t.propT("--chakra-backdrop-contrast", transformFunctions.contrast),
  backdropHueRotate: t.propT("--chakra-backdrop-hue-rotate", transformFunctions.hueRotate),
  backdropInvert: t.propT("--chakra-backdrop-invert", transformFunctions.invert),
  backdropSaturate: t.propT("--chakra-backdrop-saturate", transformFunctions.saturate)
};

// src/config/flexbox.ts
var flexbox = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: {
    transform: transformFunctions.flexDirection
  },
  flex: true,
  flexFlow: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: t.sizes("flexBasis"),
  justifySelf: true,
  alignSelf: true,
  order: true,
  placeItems: true,
  placeContent: true,
  placeSelf: true,
  gap: t.space("gap"),
  rowGap: t.space("rowGap"),
  columnGap: t.space("columnGap")
};
Object.assign(flexbox, {
  flexDir: flexbox.flexDirection
});

// src/config/grid.ts
var grid = {
  gridGap: t.space("gridGap"),
  gridColumnGap: t.space("gridColumnGap"),
  gridRowGap: t.space("gridRowGap"),
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridAutoRows: true,
  gridTemplate: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};

// src/config/interactivity.ts
var interactivity = {
  appearance: true,
  cursor: true,
  resize: true,
  userSelect: true,
  pointerEvents: true,
  outline: {
    transform: transformFunctions.outline
  },
  outlineOffset: true,
  outlineColor: t.colors("outlineColor")
};

// src/config/layout.ts
var layout$1 = {
  width: t.sizesT("width"),
  inlineSize: t.sizesT("inlineSize"),
  height: t.sizes("height"),
  blockSize: t.sizes("blockSize"),
  boxSize: t.sizes(["width", "height"]),
  minWidth: t.sizes("minWidth"),
  minInlineSize: t.sizes("minInlineSize"),
  minHeight: t.sizes("minHeight"),
  minBlockSize: t.sizes("minBlockSize"),
  maxWidth: t.sizes("maxWidth"),
  maxInlineSize: t.sizes("maxInlineSize"),
  maxHeight: t.sizes("maxHeight"),
  maxBlockSize: t.sizes("maxBlockSize"),
  overflow: true,
  overflowX: true,
  overflowY: true,
  overscrollBehavior: true,
  overscrollBehaviorX: true,
  overscrollBehaviorY: true,
  display: true,
  aspectRatio: true,
  hideFrom: {
    scale: "breakpoints",
    transform: function transform(value, theme) {
      var _a, _b, _c;
      var breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b.minW) != null ? _c : value;
      var mq = "@media screen and (min-width: ".concat(breakpoint, ")");
      return _defineProperty$3({}, mq, {
        display: "none"
      });
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: function transform(value, theme) {
      var _a, _b, _c;
      var breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b._minW) != null ? _c : value;
      var mq = "@media screen and (max-width: ".concat(breakpoint, ")");
      return _defineProperty$3({}, mq, {
        display: "none"
      });
    }
  },
  verticalAlign: true,
  boxSizing: true,
  boxDecorationBreak: true,
  "float": t.propT("float", transformFunctions["float"]),
  objectFit: true,
  objectPosition: true,
  visibility: true,
  isolation: true
};
Object.assign(layout$1, {
  w: layout$1.width,
  h: layout$1.height,
  minW: layout$1.minWidth,
  maxW: layout$1.maxWidth,
  minH: layout$1.minHeight,
  maxH: layout$1.maxHeight,
  overscroll: layout$1.overscrollBehavior,
  overscrollX: layout$1.overscrollBehaviorX,
  overscrollY: layout$1.overscrollBehaviorY
});

// src/config/list.ts
var list = {
  listStyleType: true,
  listStylePosition: true,
  listStylePos: t.prop("listStylePosition"),
  listStyleImage: true,
  listStyleImg: t.prop("listStyleImage")
};

// src/get.ts
function get$1(obj, path, fallback, index) {
  var key = typeof path === "string" ? path.split(".") : [path];
  for (index = 0; index < key.length; index += 1) {
    if (!obj) break;
    obj = obj[key[index]];
  }
  return obj === void 0 ? fallback : obj;
}
var memoize$2 = function memoize(fn) {
  var cache = /* @__PURE__ */new WeakMap();
  var memoizedFn = function memoizedFn(obj, path, fallback, index) {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }
    if (!cache.has(obj)) {
      cache.set(obj, /* @__PURE__ */new Map());
    }
    var map = cache.get(obj);
    if (map.has(path)) {
      return map.get(path);
    }
    var value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };
  return memoizedFn;
};
var memoizedGet$1 = memoize$2(get$1);

// src/config/others.ts
var srOnly = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
var srFocusable = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
};
var getWithPriority = function getWithPriority(theme, key, styles) {
  var result = {};
  var obj = memoizedGet$1(theme, key, {});
  for (var prop in obj) {
    var isInStyles = prop in styles && styles[prop] != null;
    if (!isInStyles) result[prop] = obj[prop];
  }
  return result;
};
var others = {
  srOnly: {
    transform: function transform(value) {
      if (value === true) return srOnly;
      if (value === "focusable") return srFocusable;
      return {};
    }
  },
  layerStyle: {
    processResult: true,
    transform: function transform(value, theme, styles) {
      return getWithPriority(theme, "layerStyles.".concat(value), styles);
    }
  },
  textStyle: {
    processResult: true,
    transform: function transform(value, theme, styles) {
      return getWithPriority(theme, "textStyles.".concat(value), styles);
    }
  },
  apply: {
    processResult: true,
    transform: function transform(value, theme, styles) {
      return getWithPriority(theme, value, styles);
    }
  }
};

// src/config/position.ts
var position = {
  position: true,
  pos: t.prop("position"),
  zIndex: t.prop("zIndex", "zIndices"),
  inset: t.spaceT("inset"),
  insetX: t.spaceT(["left", "right"]),
  insetInline: t.spaceT("insetInline"),
  insetY: t.spaceT(["top", "bottom"]),
  insetBlock: t.spaceT("insetBlock"),
  top: t.spaceT("top"),
  insetBlockStart: t.spaceT("insetBlockStart"),
  bottom: t.spaceT("bottom"),
  insetBlockEnd: t.spaceT("insetBlockEnd"),
  left: t.spaceT("left"),
  insetInlineStart: t.logical({
    scale: "space",
    property: {
      ltr: "left",
      rtl: "right"
    }
  }),
  right: t.spaceT("right"),
  insetInlineEnd: t.logical({
    scale: "space",
    property: {
      ltr: "right",
      rtl: "left"
    }
  })
};
Object.assign(position, {
  insetStart: position.insetInlineStart,
  insetEnd: position.insetInlineEnd
});

// src/config/ring.ts
var ring = {
  ring: {
    transform: transformFunctions.ring
  },
  ringColor: t.colors("--chakra-ring-color"),
  ringOffset: t.prop("--chakra-ring-offset-width"),
  ringOffsetColor: t.colors("--chakra-ring-offset-color"),
  ringInset: t.prop("--chakra-ring-inset")
};

// src/config/space.ts
var space = {
  margin: t.spaceT("margin"),
  marginTop: t.spaceT("marginTop"),
  marginBlockStart: t.spaceT("marginBlockStart"),
  marginRight: t.spaceT("marginRight"),
  marginInlineEnd: t.spaceT("marginInlineEnd"),
  marginBottom: t.spaceT("marginBottom"),
  marginBlockEnd: t.spaceT("marginBlockEnd"),
  marginLeft: t.spaceT("marginLeft"),
  marginInlineStart: t.spaceT("marginInlineStart"),
  marginX: t.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: t.spaceT("marginInline"),
  marginY: t.spaceT(["marginTop", "marginBottom"]),
  marginBlock: t.spaceT("marginBlock"),
  padding: t.space("padding"),
  paddingTop: t.space("paddingTop"),
  paddingBlockStart: t.space("paddingBlockStart"),
  paddingRight: t.space("paddingRight"),
  paddingBottom: t.space("paddingBottom"),
  paddingBlockEnd: t.space("paddingBlockEnd"),
  paddingLeft: t.space("paddingLeft"),
  paddingInlineStart: t.space("paddingInlineStart"),
  paddingInlineEnd: t.space("paddingInlineEnd"),
  paddingX: t.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: t.space("paddingInline"),
  paddingY: t.space(["paddingTop", "paddingBottom"]),
  paddingBlock: t.space("paddingBlock")
};
Object.assign(space, {
  m: space.margin,
  mt: space.marginTop,
  mr: space.marginRight,
  me: space.marginInlineEnd,
  marginEnd: space.marginInlineEnd,
  mb: space.marginBottom,
  ml: space.marginLeft,
  ms: space.marginInlineStart,
  marginStart: space.marginInlineStart,
  mx: space.marginX,
  my: space.marginY,
  p: space.padding,
  pt: space.paddingTop,
  py: space.paddingY,
  px: space.paddingX,
  pb: space.paddingBottom,
  pl: space.paddingLeft,
  ps: space.paddingInlineStart,
  paddingStart: space.paddingInlineStart,
  pr: space.paddingRight,
  pe: space.paddingInlineEnd,
  paddingEnd: space.paddingInlineEnd
});

// src/config/text-decoration.ts
var textDecoration = {
  textDecorationColor: t.colors("textDecorationColor"),
  textDecoration: true,
  textDecor: {
    property: "textDecoration"
  },
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationThickness: true,
  textUnderlineOffset: true,
  textShadow: t.shadows("textShadow")
};

// src/config/transform.ts
var transform = {
  clipPath: true,
  transform: t.propT("transform", transformFunctions.transform),
  transformOrigin: true,
  translateX: t.spaceT("--chakra-translate-x"),
  translateY: t.spaceT("--chakra-translate-y"),
  skewX: t.degreeT("--chakra-skew-x"),
  skewY: t.degreeT("--chakra-skew-y"),
  scaleX: t.prop("--chakra-scale-x"),
  scaleY: t.prop("--chakra-scale-y"),
  scale: t.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: t.degreeT("--chakra-rotate")
};

// src/config/transition.ts
var transition$1 = {
  transition: true,
  transitionDelay: true,
  animation: true,
  willChange: true,
  transitionDuration: t.prop("transitionDuration", "transition.duration"),
  transitionProperty: t.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: t.prop("transitionTimingFunction", "transition.easing")
};

// src/config/typography.ts
var typography$1 = {
  fontFamily: t.prop("fontFamily", "fonts"),
  fontSize: t.prop("fontSize", "fontSizes", transformFunctions.px),
  fontWeight: t.prop("fontWeight", "fontWeights"),
  lineHeight: t.prop("lineHeight", "lineHeights"),
  letterSpacing: t.prop("letterSpacing", "letterSpacings"),
  textAlign: true,
  fontStyle: true,
  textIndent: true,
  wordBreak: true,
  overflowWrap: true,
  textOverflow: true,
  textTransform: true,
  whiteSpace: true,
  isTruncated: {
    transform: function transform(value) {
      if (value === true) {
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
      }
    }
  },
  noOfLines: {
    "static": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
};

// src/config/scroll.ts
var scroll = {
  scrollBehavior: true,
  scrollSnapAlign: true,
  scrollSnapStop: true,
  scrollSnapType: true,
  // scroll margin
  scrollMargin: t.spaceT("scrollMargin"),
  scrollMarginTop: t.spaceT("scrollMarginTop"),
  scrollMarginBottom: t.spaceT("scrollMarginBottom"),
  scrollMarginLeft: t.spaceT("scrollMarginLeft"),
  scrollMarginRight: t.spaceT("scrollMarginRight"),
  scrollMarginX: t.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: t.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: t.spaceT("scrollPadding"),
  scrollPaddingTop: t.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: t.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: t.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: t.spaceT("scrollPaddingRight"),
  scrollPaddingX: t.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: t.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function resolveReference(operand) {
  if (isObject(operand) && operand.reference) {
    return operand.reference;
  }
  return String(operand);
}
var toExpression = function toExpression(operator) {
  for (var _len2 = arguments.length, operands = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    operands[_key2 - 1] = arguments[_key2];
  }
  return operands.map(resolveReference).join(" ".concat(operator, " ")).replace(/calc/g, "");
};
var _add$1 = function add() {
  for (var _len3 = arguments.length, operands = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    operands[_key3] = arguments[_key3];
  }
  return "calc(".concat(toExpression.apply(void 0, ["+"].concat(operands)), ")");
};
var _subtract$1 = function subtract() {
  for (var _len4 = arguments.length, operands = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    operands[_key4] = arguments[_key4];
  }
  return "calc(".concat(toExpression.apply(void 0, ["-"].concat(operands)), ")");
};
var _multiply$1 = function multiply() {
  for (var _len5 = arguments.length, operands = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    operands[_key5] = arguments[_key5];
  }
  return "calc(".concat(toExpression.apply(void 0, ["*"].concat(operands)), ")");
};
var _divide$1 = function divide() {
  for (var _len6 = arguments.length, operands = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    operands[_key6] = arguments[_key6];
  }
  return "calc(".concat(toExpression.apply(void 0, ["/"].concat(operands)), ")");
};
var _negate$1 = function negate(x) {
  var value = resolveReference(x);
  if (value != null && !Number.isNaN(parseFloat(value))) {
    return String(value).startsWith("-") ? String(value).slice(1) : "-".concat(value);
  }
  return _multiply$1(value, -1);
};
var calc$1 = Object.assign(function (x) {
  return {
    add: function add() {
      for (var _len7 = arguments.length, operands = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        operands[_key7] = arguments[_key7];
      }
      return calc$1(_add$1.apply(void 0, [x].concat(operands)));
    },
    subtract: function subtract() {
      for (var _len8 = arguments.length, operands = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        operands[_key8] = arguments[_key8];
      }
      return calc$1(_subtract$1.apply(void 0, [x].concat(operands)));
    },
    multiply: function multiply() {
      for (var _len9 = arguments.length, operands = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        operands[_key9] = arguments[_key9];
      }
      return calc$1(_multiply$1.apply(void 0, [x].concat(operands)));
    },
    divide: function divide() {
      for (var _len10 = arguments.length, operands = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        operands[_key10] = arguments[_key10];
      }
      return calc$1(_divide$1.apply(void 0, [x].concat(operands)));
    },
    negate: function negate() {
      return calc$1(_negate$1(x));
    },
    toString: function toString() {
      return x.toString();
    }
  };
}, {
  add: _add$1,
  subtract: _subtract$1,
  multiply: _multiply$1,
  divide: _divide$1,
  negate: _negate$1
});

// src/create-theme-vars/css-var.ts
function replaceWhiteSpace$1(value) {
  var replaceValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
  return value.replace(/\s+/g, replaceValue);
}
function escape$1(value) {
  var valueStr = replaceWhiteSpace$1(value.toString());
  return escapeSymbol(escapeDot(valueStr));
}
function escapeDot(value) {
  if (value.includes("\\.")) return value;
  var isDecimal = !Number.isInteger(parseFloat(value.toString()));
  return isDecimal ? value.replace(".", "\\.") : value;
}
function escapeSymbol(value) {
  return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function addPrefix$1(value) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return [prefix, value].filter(Boolean).join("-");
}
function toVarReference(name, fallback) {
  return "var(".concat(name).concat(fallback ? ", ".concat(fallback) : "", ")");
}
function toVarDefinition(value) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return escape$1("--".concat(addPrefix$1(value, prefix)));
}
function cssVar$1(name, fallback, cssVarPrefix) {
  var cssVariable = toVarDefinition(name, cssVarPrefix);
  return {
    variable: cssVariable,
    reference: toVarReference(cssVariable, fallback)
  };
}
function defineCssVars(scope, keys2) {
  var vars = {};
  var _iterator = _createForOfIteratorHelper(keys2),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (Array.isArray(key)) {
        var _key11 = _slicedToArray$1(key, 2),
          name = _key11[0],
          fallback = _key11[1];
        vars[name] = cssVar$1("".concat(scope, "-").concat(name), fallback);
        continue;
      }
      vars[key] = cssVar$1("".concat(scope, "-").concat(key));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return vars;
}
function getLastItem(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
function analyzeCSSValue2(value) {
  var num = parseFloat(value.toString());
  var unit = value.toString().replace(String(num), "");
  return {
    unitless: !unit,
    value: num,
    unit: unit
  };
}
function px$1(value) {
  if (value == null) return value;
  var _analyzeCSSValue2 = analyzeCSSValue2(value),
    unitless = _analyzeCSSValue2.unitless;
  return unitless || typeof value === "number" ? "".concat(value, "px") : value;
}
var sortByBreakpointValue = function sortByBreakpointValue(a, b) {
  return parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
};
var sortBps = function sortBps(breakpoints) {
  return Object.fromEntries(Object.entries(breakpoints).sort(sortByBreakpointValue));
};
function normalize(breakpoints) {
  var sorted = sortBps(breakpoints);
  return Object.assign(Object.values(sorted), sorted);
}
function keys(breakpoints) {
  var value = Object.keys(sortBps(breakpoints));
  return new Set(value);
}
function subtract2(value) {
  var _a;
  if (!value) return value;
  value = (_a = px$1(value)) != null ? _a : value;
  var OFFSET = -0.02;
  return typeof value === "number" ? "".concat(value + OFFSET) : value.replace(/([0-9]+\.?[0-9]*)/, function (m) {
    return "".concat(parseFloat(m) + OFFSET);
  });
}
function toMediaQueryString(min, max) {
  var query = ["@media screen"];
  if (min) query.push("and", "(min-width: ".concat(px$1(min), ")"));
  if (max) query.push("and", "(max-width: ".concat(px$1(max), ")"));
  return query.join(" ");
}
function analyzeBreakpoints(breakpoints) {
  var _a;
  if (!breakpoints) return null;
  breakpoints.base = (_a = breakpoints.base) != null ? _a : "0px";
  var normalized = normalize(breakpoints);
  var queries = Object.entries(breakpoints).sort(sortByBreakpointValue).map(function (_ref7, index, entry) {
    var _ref8 = _slicedToArray$1(_ref7, 2),
      breakpoint = _ref8[0],
      minW = _ref8[1];
    var _a2;
    var _ref9 = (_a2 = entry[index + 1]) != null ? _a2 : [],
      _ref10 = _slicedToArray$1(_ref9, 2),
      maxW = _ref10[1];
    maxW = parseFloat(maxW) > 0 ? subtract2(maxW) : void 0;
    return {
      _minW: subtract2(minW),
      breakpoint: breakpoint,
      minW: minW,
      maxW: maxW,
      maxWQuery: toMediaQueryString(null, maxW),
      minWQuery: toMediaQueryString(minW),
      minMaxQuery: toMediaQueryString(minW, maxW)
    };
  });
  var _keys = keys(breakpoints);
  var _keysArr = Array.from(_keys.values());
  return {
    keys: _keys,
    normalized: normalized,
    isResponsive: function isResponsive(test) {
      var keys2 = Object.keys(test);
      return keys2.length > 0 && keys2.every(function (key) {
        return _keys.has(key);
      });
    },
    asObject: sortBps(breakpoints),
    asArray: normalize(breakpoints),
    details: queries,
    get: function get(key) {
      return queries.find(function (q) {
        return q.breakpoint === key;
      });
    },
    media: [null].concat(_toConsumableArray$1(normalized.map(function (minW) {
      return toMediaQueryString(minW);
    }).slice(1))),
    /**
     * Converts the object responsive syntax to array syntax
     *
     * @example
     * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
     */
    toArrayValue: function toArrayValue(test) {
      if (!isObject(test)) {
        throw new Error("toArrayValue: value must be an object");
      }
      var result = _keysArr.map(function (bp) {
        var _a2;
        return (_a2 = test[bp]) != null ? _a2 : null;
      });
      while (getLastItem(result) === null) {
        result.pop();
      }
      return result;
    },
    /**
     * Converts the array responsive syntax to object syntax
     *
     * @example
     * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
     */
    toObjectValue: function toObjectValue(test) {
      if (!Array.isArray(test)) {
        throw new Error("toObjectValue: value must be an array");
      }
      return test.reduce(function (acc, value, index) {
        var key = _keysArr[index];
        if (key != null && value != null) acc[key] = value;
        return acc;
      }, {});
    }
  };
}

// src/pseudos.ts
var state = {
  hover: function hover(str, post) {
    return "".concat(str, ":hover ").concat(post, ", ").concat(str, "[data-hover] ").concat(post);
  },
  focus: function focus(str, post) {
    return "".concat(str, ":focus ").concat(post, ", ").concat(str, "[data-focus] ").concat(post);
  },
  focusVisible: function focusVisible(str, post) {
    return "".concat(str, ":focus-visible ").concat(post);
  },
  focusWithin: function focusWithin(str, post) {
    return "".concat(str, ":focus-within ").concat(post);
  },
  active: function active(str, post) {
    return "".concat(str, ":active ").concat(post, ", ").concat(str, "[data-active] ").concat(post);
  },
  disabled: function disabled(str, post) {
    return "".concat(str, ":disabled ").concat(post, ", ").concat(str, "[data-disabled] ").concat(post);
  },
  invalid: function invalid(str, post) {
    return "".concat(str, ":invalid ").concat(post, ", ").concat(str, "[data-invalid] ").concat(post);
  },
  checked: function checked(str, post) {
    return "".concat(str, ":checked ").concat(post, ", ").concat(str, "[data-checked] ").concat(post);
  },
  indeterminate: function indeterminate(str, post) {
    return "".concat(str, ":indeterminate ").concat(post, ", ").concat(str, "[aria-checked=mixed] ").concat(post, ", ").concat(str, "[data-indeterminate] ").concat(post);
  },
  readOnly: function readOnly(str, post) {
    return "".concat(str, ":read-only ").concat(post, ", ").concat(str, "[readonly] ").concat(post, ", ").concat(str, "[data-read-only] ").concat(post);
  },
  expanded: function expanded(str, post) {
    return "".concat(str, ":read-only ").concat(post, ", ").concat(str, "[aria-expanded=true] ").concat(post, ", ").concat(str, "[data-expanded] ").concat(post);
  },
  placeholderShown: function placeholderShown(str, post) {
    return "".concat(str, ":placeholder-shown ").concat(post);
  }
};
var toGroup = function toGroup(fn) {
  return merge$2(function (v) {
    return fn(v, "&");
  }, "[role=group]", "[data-group]", ".group");
};
var toPeer = function toPeer(fn) {
  return merge$2(function (v) {
    return fn(v, "~ &");
  }, "[data-peer]", ".peer");
};
var merge$2 = function merge(fn) {
  for (var _len11 = arguments.length, selectors = new Array(_len11 > 1 ? _len11 - 1 : 0), _key12 = 1; _key12 < _len11; _key12++) {
    selectors[_key12 - 1] = arguments[_key12];
  }
  return selectors.map(fn).join(", ");
};
var pseudoSelectors = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */
  _firstLetter: "&::first-letter",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: toGroup(state.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: toPeer(state.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: toGroup(state.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: toPeer(state.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: toGroup(state.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: toPeer(state.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: toGroup(state.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: toPeer(state.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: toGroup(state.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: toPeer(state.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: toGroup(state.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: toPeer(state.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: toGroup(state.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: toPeer(state.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: toGroup(state.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: toPeer(state.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: toPeer(state.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */
  _horizontal: "&[data-orientation=horizontal]",
  /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */
  _vertical: "&[data-orientation=vertical]"
};
var pseudoPropNames = Object.keys(pseudoSelectors);
function tokenToCssVar(token, prefix) {
  return cssVar$1(String(token).replace(/\./g, "-"), void 0, prefix);
}
function createThemeVars(flatTokens, options) {
  var cssVars = {};
  var cssMap = {};
  var _loop = function _loop() {
    var _Object$entries$_i = _slicedToArray$1(_Object$entries[_i], 2),
      token = _Object$entries$_i[0],
      tokenValue = _Object$entries$_i[1];
    var isSemantic = tokenValue.isSemantic,
      value = tokenValue.value;
    var _tokenToCssVar = tokenToCssVar(token, options == null ? void 0 : options.cssVarPrefix),
      variable = _tokenToCssVar.variable,
      reference = _tokenToCssVar.reference;
    if (!isSemantic) {
      if (token.startsWith("space")) {
        var keys2 = token.split(".");
        var _keys2 = _toArray(keys2),
          firstKey = _keys2[0],
          referenceKeys = _keys2.slice(1);
        var negativeLookupKey = "".concat(firstKey, ".-").concat(referenceKeys.join("."));
        var negativeValue = calc$1.negate(value);
        var negatedReference = calc$1.negate(reference);
        cssMap[negativeLookupKey] = {
          value: negativeValue,
          "var": variable,
          varRef: negatedReference
        };
      }
      cssVars[variable] = value;
      cssMap[token] = {
        value: value,
        "var": variable,
        varRef: reference
      };
      return 1; // continue
    }
    var lookupToken = function lookupToken(maybeToken) {
      var scale = String(token).split(".")[0];
      var withScale = [scale, maybeToken].join(".");
      var resolvedTokenValue = flatTokens[withScale];
      if (!resolvedTokenValue) return maybeToken;
      var _tokenToCssVar2 = tokenToCssVar(withScale, options == null ? void 0 : options.cssVarPrefix),
        reference2 = _tokenToCssVar2.reference;
      return reference2;
    };
    var normalizedValue = isObject(value) ? value : {
      "default": value
    };
    cssVars = mergeWith(cssVars, Object.entries(normalizedValue).reduce(function (acc, _ref11) {
      var _ref12 = _slicedToArray$1(_ref11, 2),
        conditionAlias = _ref12[0],
        conditionValue = _ref12[1];
      var _a, _b;
      if (!conditionValue) return acc;
      var tokenReference = lookupToken("".concat(conditionValue));
      if (conditionAlias === "default") {
        acc[variable] = tokenReference;
        return acc;
      }
      var conditionSelector = (_b = (_a = pseudoSelectors) == null ? void 0 : _a[conditionAlias]) != null ? _b : conditionAlias;
      acc[conditionSelector] = _defineProperty$3({}, variable, tokenReference);
      return acc;
    }, {}));
    cssMap[token] = {
      value: reference,
      "var": variable,
      varRef: reference
    };
  };
  for (var _i = 0, _Object$entries = Object.entries(flatTokens); _i < _Object$entries.length; _i++) {
    if (_loop()) continue;
  }
  return {
    cssVars: cssVars,
    cssMap: cssMap
  };
}

// ../../utilities/object-utils/src/omit.ts
function omit$5(object) {
  var keysToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var clone = Object.assign({}, object);
  var _iterator2 = _createForOfIteratorHelper(keysToOmit),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var key = _step2.value;
      if (key in clone) {
        delete clone[key];
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return clone;
}

// ../../utilities/object-utils/src/pick.ts
function pick$1(object, keysToPick) {
  var result = {};
  var _iterator3 = _createForOfIteratorHelper(keysToPick),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var key = _step3.value;
      if (key in object) {
        result[key] = object[key];
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return result;
}

// ../../utilities/object-utils/src/walk-object.ts
function isObject5(value) {
  return _typeof$1(value) === "object" && value != null && !Array.isArray(value);
}
function walkObject(target, predicate) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var stop = options.stop,
    getKey = options.getKey;
  function inner(value) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var _a;
    if (isObject5(value) || Array.isArray(value)) {
      var result = {};
      for (var _i2 = 0, _Object$entries2 = Object.entries(value); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray$1(_Object$entries2[_i2], 2),
          prop = _Object$entries2$_i[0],
          child = _Object$entries2$_i[1];
        var key = (_a = getKey == null ? void 0 : getKey(prop)) != null ? _a : prop;
        var childPath = [].concat(_toConsumableArray$1(path), [key]);
        if (stop == null ? void 0 : stop(value, childPath)) {
          return predicate(value, path);
        }
        result[key] = inner(child, childPath);
      }
      return result;
    }
    return predicate(value, path);
  }
  return inner(target);
}

// src/create-theme-vars/theme-tokens.ts
var tokens = ["colors", "borders", "borderWidths", "borderStyles", "fonts", "fontSizes", "fontWeights", "gradients", "letterSpacings", "lineHeights", "radii", "space", "shadows", "sizes", "zIndices", "transition", "blur", "breakpoints"];
function extractTokens(theme) {
  var _tokens = tokens;
  return pick$1(theme, _tokens);
}
function extractSemanticTokens(theme) {
  return theme.semanticTokens;
}
function omitVars(rawTheme) {
  rawTheme.__cssMap;
    rawTheme.__cssVars;
    rawTheme.__breakpoints;
    var cleanTheme = _objectWithoutProperties$1(rawTheme, _excluded$2m);
  return cleanTheme;
}

// src/create-theme-vars/flatten-tokens.ts
var isSemanticCondition = function isSemanticCondition(key) {
  return pseudoPropNames.includes(key) || "default" === key;
};
function flattenTokens(_ref13) {
  var tokens2 = _ref13.tokens,
    semanticTokens = _ref13.semanticTokens;
  var result = {};
  walkObject(tokens2, function (value, path) {
    if (value == null) return;
    result[path.join(".")] = {
      isSemantic: false,
      value: value
    };
  });
  walkObject(semanticTokens, function (value, path) {
    if (value == null) return;
    result[path.join(".")] = {
      isSemantic: true,
      value: value
    };
  }, {
    stop: function stop(value) {
      return Object.keys(value).every(isSemanticCondition);
    }
  });
  return result;
}

// src/create-theme-vars/to-css-var.ts
function toCSSVar(rawTheme) {
  var _a;
  var theme = omitVars(rawTheme);
  var tokens2 = extractTokens(theme);
  var semanticTokens = extractSemanticTokens(theme);
  var flatTokens = flattenTokens({
    tokens: tokens2,
    semanticTokens: semanticTokens
  });
  var cssVarPrefix = (_a = theme.config) == null ? void 0 : _a.cssVarPrefix;
  var _createThemeVars = createThemeVars(flatTokens, {
      cssVarPrefix: cssVarPrefix
    }),
    cssMap = _createThemeVars.cssMap,
    cssVars = _createThemeVars.cssVars;
  var defaultCssVars = {
    "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-ring-offset-width": "0px",
    "--chakra-ring-offset-color": "#fff",
    "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
    "--chakra-ring-offset-shadow": "0 0 #0000",
    "--chakra-ring-shadow": "0 0 #0000",
    "--chakra-space-x-reverse": "0",
    "--chakra-space-y-reverse": "0"
  };
  Object.assign(theme, {
    __cssVars: _objectSpread2$1(_objectSpread2$1({}, defaultCssVars), cssVars),
    __cssMap: cssMap,
    __breakpoints: analyzeBreakpoints(theme.breakpoints)
  });
  return theme;
}
var systemProps = mergeWith({}, background, border, color$1, flexbox, layout$1, filter$1, ring, interactivity, grid, others, position, effect$3, space, scroll, typography$1, textDecoration, transform, list, transition$1);
var layoutSystem = Object.assign({}, space, layout$1, flexbox, grid, position);
var layoutPropNames = Object.keys(layoutSystem);
var propNames = [].concat(_toConsumableArray$1(Object.keys(systemProps)), pseudoPropNames);
var styleProps = _objectSpread2$1(_objectSpread2$1({}, systemProps), pseudoSelectors);
var isStyleProp = function isStyleProp(prop) {
  return prop in styleProps;
};
var expandResponsive = function expandResponsive(styles) {
  return function (theme) {
    if (!theme.__breakpoints) return styles;
    var _theme$__breakpoints = theme.__breakpoints,
      isResponsive = _theme$__breakpoints.isResponsive,
      toArrayValue = _theme$__breakpoints.toArrayValue,
      medias = _theme$__breakpoints.media;
    var computedStyles = {};
    for (var key in styles) {
      var value = runIfFn$2(styles[key], theme);
      if (value == null) continue;
      value = isObject(value) && isResponsive(value) ? toArrayValue(value) : value;
      if (!Array.isArray(value)) {
        computedStyles[key] = value;
        continue;
      }
      var queries = value.slice(0, medias.length).length;
      for (var index = 0; index < queries; index += 1) {
        var media = medias == null ? void 0 : medias[index];
        if (!media) {
          computedStyles[key] = value[index];
          continue;
        }
        computedStyles[media] = computedStyles[media] || {};
        if (value[index] == null) {
          continue;
        }
        computedStyles[media][key] = value[index];
      }
    }
    return computedStyles;
  };
};

// src/utils/split-by-comma.ts
function splitByComma(value) {
  var chunks = [];
  var chunk = "";
  var inParens = false;
  for (var i = 0; i < value.length; i++) {
    var _char = value[i];
    if (_char === "(") {
      inParens = true;
      chunk += _char;
    } else if (_char === ")") {
      inParens = false;
      chunk += _char;
    } else if (_char === "," && !inParens) {
      chunks.push(chunk);
      chunk = "";
    } else {
      chunk += _char;
    }
  }
  chunk = chunk.trim();
  if (chunk) {
    chunks.push(chunk);
  }
  return chunks;
}

// src/css.ts
function isCssVar2(value) {
  return /^var\(--.+\)$/.test(value);
}
var isCSSVariableTokenValue = function isCSSVariableTokenValue(key, value) {
  return key.startsWith("--") && typeof value === "string" && !isCssVar2(value);
};
var resolveTokenValue = function resolveTokenValue(theme, value) {
  var _a, _b;
  if (value == null) return value;
  var getVar = function getVar(val) {
    var _a2, _b2;
    return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.varRef;
  };
  var getValue = function getValue(val) {
    var _a2;
    return (_a2 = getVar(val)) != null ? _a2 : val;
  };
  var _splitByComma = splitByComma(value),
    _splitByComma2 = _slicedToArray$1(_splitByComma, 2),
    tokenValue = _splitByComma2[0],
    fallbackValue = _splitByComma2[1];
  value = (_b = (_a = getVar(tokenValue)) != null ? _a : getValue(fallbackValue)) != null ? _b : getValue(value);
  return value;
};
function getCss(options) {
  var _options$configs = options.configs,
    configs = _options$configs === void 0 ? {} : _options$configs,
    _options$pseudos = options.pseudos,
    pseudos = _options$pseudos === void 0 ? {} : _options$pseudos,
    theme = options.theme;
  var _css = function css2(stylesOrFn) {
    var nested = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _a, _b, _c;
    var _styles = runIfFn$2(stylesOrFn, theme);
    var styles = expandResponsive(_styles)(theme);
    var computedStyles = {};
    for (var key in styles) {
      var valueOrFn = styles[key];
      var value = runIfFn$2(valueOrFn, theme);
      if (key in pseudos) {
        key = pseudos[key];
      }
      if (isCSSVariableTokenValue(key, value)) {
        value = resolveTokenValue(theme, value);
      }
      var config = configs[key];
      if (config === true) {
        config = {
          property: key
        };
      }
      if (isObject(value)) {
        computedStyles[key] = (_a = computedStyles[key]) != null ? _a : {};
        computedStyles[key] = mergeWith({}, computedStyles[key], _css(value, true));
        continue;
      }
      var rawValue = (_c = (_b = config == null ? void 0 : config.transform) == null ? void 0 : _b.call(config, value, theme, _styles)) != null ? _c : value;
      rawValue = (config == null ? void 0 : config.processResult) ? _css(rawValue, true) : rawValue;
      var configProperty = runIfFn$2(config == null ? void 0 : config.property, theme);
      if (!nested && (config == null ? void 0 : config["static"])) {
        var staticStyles = runIfFn$2(config["static"], theme);
        computedStyles = mergeWith({}, computedStyles, staticStyles);
      }
      if (configProperty && Array.isArray(configProperty)) {
        var _iterator4 = _createForOfIteratorHelper(configProperty),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var property = _step4.value;
            computedStyles[property] = rawValue;
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        continue;
      }
      if (configProperty) {
        if (configProperty === "&" && isObject(rawValue)) {
          computedStyles = mergeWith({}, computedStyles, rawValue);
        } else {
          computedStyles[configProperty] = rawValue;
        }
        continue;
      }
      if (isObject(rawValue)) {
        computedStyles = mergeWith({}, computedStyles, rawValue);
        continue;
      }
      computedStyles[key] = rawValue;
    }
    return computedStyles;
  };
  return _css;
}
var css$3 = function css(styles) {
  return function (theme) {
    var cssFn = getCss({
      theme: theme,
      pseudos: pseudoSelectors,
      configs: systemProps
    });
    return cssFn(styles);
  };
};

// src/define-styles.ts
function defineStyle(styles) {
  return styles;
}
function defineStyleConfig(config) {
  return config;
}
function createMultiStyleConfigHelpers(parts) {
  return {
    definePartsStyle: function definePartsStyle(config) {
      return config;
    },
    defineMultiStyleConfig: function defineMultiStyleConfig(config) {
      return _objectSpread2$1({
        parts: parts
      }, config);
    }
  };
}
function normalize2(value, toArray) {
  if (Array.isArray(value)) return value;
  if (isObject(value)) return toArray(value);
  if (value != null) return [value];
}
function getNextIndex$1(values, i) {
  for (var j = i + 1; j < values.length; j++) {
    if (values[j] != null) return j;
  }
  return -1;
}
function createResolver(theme) {
  var breakpointUtil = theme.__breakpoints;
  return function resolver(config, prop, value, props) {
    var _a, _b;
    if (!breakpointUtil) return;
    var result = {};
    var normalized = normalize2(value, breakpointUtil.toArrayValue);
    if (!normalized) return result;
    var len = normalized.length;
    var isSingle = len === 1;
    var isMultipart = !!config.parts;
    var _loop2 = function _loop2() {
        var key = breakpointUtil.details[i];
        var nextKey = breakpointUtil.details[getNextIndex$1(normalized, i)];
        var query = toMediaQueryString(key.minW, nextKey == null ? void 0 : nextKey._minW);
        var styles = runIfFn$2((_a = config[prop]) == null ? void 0 : _a[normalized[i]], props);
        if (!styles) return 0; // continue
        if (isMultipart) {
          (_b = config.parts) == null ? void 0 : _b.forEach(function (part) {
            mergeWith(result, _defineProperty$3({}, part, isSingle ? styles[part] : _defineProperty$3({}, query, styles[part])));
          });
          return 0; // continue
        }
        if (!isMultipart) {
          if (isSingle) mergeWith(result, styles);else result[query] = styles;
          return 0; // continue
        }
        result[query] = styles;
      },
      _ret;
    for (var i = 0; i < len; i++) {
      _ret = _loop2();
      if (_ret === 0) continue;
    }
    return result;
  };
}
function resolveStyleConfig(config) {
  return function (props) {
    var _a;
    var variant = props.variant,
      size = props.size,
      theme = props.theme;
    var recipe = createResolver(theme);
    return mergeWith({}, runIfFn$2((_a = config.baseStyle) != null ? _a : {}, props), recipe(config, "sizes", size, props), recipe(config, "variants", variant, props));
  };
}

// src/get-css-var.ts
function getCSSVar(theme, scale, value) {
  var _a, _b, _c;
  return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a["".concat(scale, ".").concat(value)]) == null ? void 0 : _b.varRef) != null ? _c : value;
}

// src/theming-props.ts
function omitThemingProps(props) {
  return omit$5(props, ["styleConfig", "size", "variant", "colorScheme"]);
}

// src/utils/is-chakra-theme.ts
var requiredChakraThemeKeys = ["borders", "breakpoints", "colors", "components", "config", "direction", "fonts", "fontSizes", "fontWeights", "letterSpacings", "lineHeights", "radii", "shadows", "sizes", "space", "styles", "transition", "zIndices"];
function isChakraTheme(unit) {
  if (!isObject(unit)) {
    return false;
  }
  return requiredChakraThemeKeys.every(function (propertyName) {
    return Object.prototype.hasOwnProperty.call(unit, propertyName);
  });
}

// src/foundations/transition.ts
var transitionProperty = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
};
var transitionTimingFunction = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
var transitionDuration = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
};
var transition = {
  property: transitionProperty,
  easing: transitionTimingFunction,
  duration: transitionDuration
};
var transition_default = transition;

// src/foundations/z-index.ts
var zIndices = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
};
var z_index_default = zIndices;

// src/foundations/borders.ts
var borders$1 = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
};
var borders_default = borders$1;

// src/foundations/breakpoints.ts
var breakpoints$2 = {
  base: "0em",
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
};
var breakpoints_default = breakpoints$2;

// src/foundations/colors.ts
var colors$2 = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  },
  linkedin: {
    50: "#E8F4F9",
    100: "#CFEDFB",
    200: "#9BDAF3",
    300: "#68C7EC",
    400: "#34B3E4",
    500: "#00A0DC",
    600: "#008CC9",
    700: "#0077B5",
    800: "#005E93",
    900: "#004471"
  },
  facebook: {
    50: "#E8F4F9",
    100: "#D9DEE9",
    200: "#B7C2DA",
    300: "#6482C0",
    400: "#4267B2",
    500: "#385898",
    600: "#314E89",
    700: "#29487D",
    800: "#223B67",
    900: "#1E355B"
  },
  messenger: {
    50: "#D0E6FF",
    100: "#B9DAFF",
    200: "#A2CDFF",
    300: "#7AB8FF",
    400: "#2E90FF",
    500: "#0078FF",
    600: "#0063D1",
    700: "#0052AC",
    800: "#003C7E",
    900: "#002C5C"
  },
  whatsapp: {
    50: "#dffeec",
    100: "#b9f5d0",
    200: "#90edb3",
    300: "#65e495",
    400: "#3cdd78",
    500: "#22c35e",
    600: "#179848",
    700: "#0c6c33",
    800: "#01421c",
    900: "#001803"
  },
  twitter: {
    50: "#E5F4FD",
    100: "#C8E9FB",
    200: "#A8DCFA",
    300: "#83CDF7",
    400: "#57BBF5",
    500: "#1DA1F2",
    600: "#1A94DA",
    700: "#1681BF",
    800: "#136B9E",
    900: "#0D4D71"
  },
  telegram: {
    50: "#E3F2F9",
    100: "#C5E4F3",
    200: "#A2D4EC",
    300: "#7AC1E4",
    400: "#47A9DA",
    500: "#0088CC",
    600: "#007AB8",
    700: "#006BA1",
    800: "#005885",
    900: "#003F5E"
  }
};
var colors_default = colors$2;

// src/foundations/radius.ts
var radii = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
};
var radius_default = radii;

// src/foundations/shadows.ts
var shadows$2 = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
};
var shadows_default = shadows$2;

// src/foundations/blur.ts
var blur = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
};
var blur_default = blur;

// src/foundations/typography.ts
var typography = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    "short": 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    "3": ".75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "7": "1.75rem",
    "8": "2rem",
    "9": "2.25rem",
    "10": "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
    body: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
    mono: "SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace"
  },
  fontSizes: {
    "3xs": "0.45rem",
    "2xs": "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
};
var typography_default = typography;

// src/foundations/spacing.ts
var spacing$1 = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
};

// src/foundations/sizes.ts
var largeSizes = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem",
  prose: "60ch"
};
var container$1 = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
};
var sizes$t = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, spacing$1), largeSizes), {}, {
  container: container$1
});
var sizes_default = sizes$t;

// src/foundations/index.ts
var foundations = _objectSpread2$1(_objectSpread2$1({
  breakpoints: breakpoints_default,
  zIndices: z_index_default,
  radii: radius_default,
  blur: blur_default,
  colors: colors_default
}, typography_default), {}, {
  sizes: sizes_default,
  shadows: shadows_default,
  space: spacing$1,
  borders: borders_default,
  transition: transition_default
});

var _createMultiStyleConf$p = createMultiStyleConfigHelpers(["stepper", "step", "title", "description", "indicator", "separator", "icon", "number"]),
  defineMultiStyleConfig$q = _createMultiStyleConf$p.defineMultiStyleConfig,
  definePartsStyle$q = _createMultiStyleConf$p.definePartsStyle;
var $size$4 = cssVar$1("stepper-indicator-size");
var $iconSize = cssVar$1("stepper-icon-size");
var $titleFontSize = cssVar$1("stepper-title-font-size");
var $descFontSize = cssVar$1("stepper-description-font-size");
var $accentColor = cssVar$1("stepper-accent-color");
var baseStyle$V = definePartsStyle$q(function (_ref) {
  var c = _ref.colorScheme;
  return {
    stepper: _defineProperty$3(_defineProperty$3({
      display: "flex",
      justifyContent: "space-between",
      gap: "4",
      "&[data-orientation=vertical]": {
        flexDirection: "column",
        alignItems: "flex-start"
      },
      "&[data-orientation=horizontal]": {
        flexDirection: "row",
        alignItems: "center"
      }
    }, $accentColor.variable, "colors.".concat(c, ".500")), "_dark", _defineProperty$3({}, $accentColor.variable, "colors.".concat(c, ".200"))),
    title: {
      fontSize: $titleFontSize.reference,
      fontWeight: "medium"
    },
    description: {
      fontSize: $descFontSize.reference,
      color: "chakra-subtle-text"
    },
    number: {
      fontSize: $titleFontSize.reference
    },
    step: {
      flexShrink: 0,
      position: "relative",
      display: "flex",
      gap: "2",
      "&[data-orientation=horizontal]": {
        alignItems: "center"
      },
      flex: "1",
      "&:last-of-type:not([data-stretch])": {
        flex: "initial"
      }
    },
    icon: {
      flexShrink: 0,
      width: $iconSize.reference,
      height: $iconSize.reference
    },
    indicator: {
      flexShrink: 0,
      borderRadius: "full",
      width: $size$4.reference,
      height: $size$4.reference,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&[data-status=active]": {
        borderWidth: "2px",
        borderColor: $accentColor.reference
      },
      "&[data-status=complete]": {
        bg: $accentColor.reference,
        color: "chakra-inverse-text"
      },
      "&[data-status=incomplete]": {
        borderWidth: "2px"
      }
    },
    separator: {
      bg: "chakra-border-color",
      flex: "1",
      "&[data-status=complete]": {
        bg: $accentColor.reference
      },
      "&[data-orientation=horizontal]": {
        width: "100%",
        height: "2px",
        marginStart: "2"
      },
      "&[data-orientation=vertical]": {
        width: "2px",
        position: "absolute",
        height: "100%",
        maxHeight: "calc(100% - ".concat($size$4.reference, " - 8px)"),
        top: "calc(".concat($size$4.reference, " + 4px)"),
        insetStart: "calc(".concat($size$4.reference, " / 2 - 1px)")
      }
    }
  };
});
var stepperTheme = defineMultiStyleConfig$q({
  baseStyle: baseStyle$V,
  sizes: {
    xs: definePartsStyle$q({
      stepper: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $size$4.variable, "sizes.4"), $iconSize.variable, "sizes.3"), $titleFontSize.variable, "fontSizes.xs"), $descFontSize.variable, "fontSizes.xs")
    }),
    sm: definePartsStyle$q({
      stepper: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $size$4.variable, "sizes.6"), $iconSize.variable, "sizes.4"), $titleFontSize.variable, "fontSizes.sm"), $descFontSize.variable, "fontSizes.xs")
    }),
    md: definePartsStyle$q({
      stepper: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $size$4.variable, "sizes.8"), $iconSize.variable, "sizes.5"), $titleFontSize.variable, "fontSizes.md"), $descFontSize.variable, "fontSizes.sm")
    }),
    lg: definePartsStyle$q({
      stepper: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $size$4.variable, "sizes.10"), $iconSize.variable, "sizes.6"), $titleFontSize.variable, "fontSizes.lg"), $descFontSize.variable, "fontSizes.md")
    })
  },
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

// src/anatomy.ts
function anatomy$1(name) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var called = false;
  function assert() {
    if (!called) {
      called = true;
      return;
    }
    throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
  }
  function parts() {
    assert();
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    for (var _i = 0, _values = values; _i < _values.length; _i++) {
      var part = _values[_i];
      map[part] = toPart(part);
    }
    return anatomy$1(name, map);
  }
  function extend() {
    for (var _len2 = arguments.length, parts2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      parts2[_key2] = arguments[_key2];
    }
    for (var _i2 = 0, _parts = parts2; _i2 < _parts.length; _i2++) {
      var part = _parts[_i2];
      if (part in map) continue;
      map[part] = toPart(part);
    }
    return anatomy$1(name, map);
  }
  function selectors() {
    var value = Object.fromEntries(Object.entries(map).map(function (_ref) {
      var _ref2 = _slicedToArray$1(_ref, 2),
        key = _ref2[0],
        part = _ref2[1];
      return [key, part.selector];
    }));
    return value;
  }
  function classnames() {
    var value = Object.fromEntries(Object.entries(map).map(function (_ref3) {
      var _ref4 = _slicedToArray$1(_ref3, 2),
        key = _ref4[0],
        part = _ref4[1];
      return [key, part.className];
    }));
    return value;
  }
  function toPart(part) {
    var el = ["container", "root"].includes(part != null ? part : "") ? [name] : [name, part];
    var attr = el.filter(Boolean).join("__");
    var className = "chakra-".concat(attr);
    var partObj = {
      className: className,
      selector: ".".concat(className),
      toString: function toString() {
        return part;
      }
    };
    return partObj;
  }
  var __type = {};
  return {
    parts: parts,
    toPart: toPart,
    extend: extend,
    selectors: selectors,
    classnames: classnames,
    get keys() {
      return Object.keys(map);
    },
    __type: __type
  };
}

// src/components.ts
var accordionAnatomy$1 = anatomy$1("accordion").parts("root", "container", "button", "panel").extend("icon");
var alertAnatomy = anatomy$1("alert").parts("title", "description", "container").extend("icon", "spinner");
var avatarAnatomy = anatomy$1("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var breadcrumbAnatomy = anatomy$1("breadcrumb").parts("link", "item", "container").extend("separator");
anatomy$1("button").parts();
var checkboxAnatomy = anatomy$1("checkbox").parts("control", "icon", "container").extend("label");
anatomy$1("progress").parts("track", "filledTrack").extend("label");
var drawerAnatomy = anatomy$1("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var editableAnatomy = anatomy$1("editable").parts("preview", "input", "textarea");
var formAnatomy = anatomy$1("form").parts("container", "requiredIndicator", "helperText");
var formErrorAnatomy = anatomy$1("formError").parts("text", "icon");
var inputAnatomy = anatomy$1("input").parts("addon", "field", "element", "group");
var listAnatomy = anatomy$1("list").parts("container", "item", "icon");
var menuAnatomy = anatomy$1("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");
var modalAnatomy = anatomy$1("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var numberInputAnatomy = anatomy$1("numberinput").parts("root", "field", "stepperGroup", "stepper");
anatomy$1("pininput").parts("field");
var popoverAnatomy = anatomy$1("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
var progressAnatomy = anatomy$1("progress").parts("label", "filledTrack", "track");
var radioAnatomy = anatomy$1("radio").parts("container", "control", "label");
var selectAnatomy = anatomy$1("select").parts("field", "icon");
var sliderAnatomy = anatomy$1("slider").parts("container", "track", "thumb", "filledTrack", "mark");
var statAnatomy = anatomy$1("stat").parts("container", "label", "helpText", "number", "icon");
var switchAnatomy = anatomy$1("switch").parts("container", "track", "thumb", "label");
var tableAnatomy = anatomy$1("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
var tabsAnatomy = anatomy$1("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
var tagAnatomy = anatomy$1("tag").parts("container", "label", "closeButton");
var cardAnatomy = anatomy$1("card").parts("container", "header", "body", "footer");
anatomy$1("stepper").parts("stepper", "step", "title", "description", "indicator", "separator", "icon", "number");

/**
 * A simple guard function:
 *
 * ```js
 * Math.min(Math.max(low, value), high)
 * ```
 */
function guard(low, high, value) {
  return Math.min(Math.max(low, value), high);
}
var ColorError = /*#__PURE__*/function (_Error) {
  function ColorError(color) {
    _classCallCheck$1(this, ColorError);
    return _callSuper(this, ColorError, ["Failed to parse color: \"".concat(color, "\"")]);
  }
  _inherits$1(ColorError, _Error);
  return _createClass$1(ColorError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var ColorError$1 = ColorError;

/**
 * Parses a color into red, gree, blue, alpha parts
 *
 * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
 */
function parseToRgba(color) {
  if (typeof color !== 'string') throw new ColorError$1(color);
  if (color.trim().toLowerCase() === 'transparent') return [0, 0, 0, 0];
  var normalizedColor = color.trim();
  normalizedColor = namedColorRegex.test(color) ? nameToHex(color) : color;
  var reducedHexMatch = reducedHexRegex.exec(normalizedColor);
  if (reducedHexMatch) {
    var arr = Array.from(reducedHexMatch).slice(1);
    return [].concat(_toConsumableArray$1(arr.slice(0, 3).map(function (x) {
      return parseInt(r(x, 2), 16);
    })), [parseInt(r(arr[3] || 'f', 2), 16) / 255]);
  }
  var hexMatch = hexRegex.exec(normalizedColor);
  if (hexMatch) {
    var _arr = Array.from(hexMatch).slice(1);
    return [].concat(_toConsumableArray$1(_arr.slice(0, 3).map(function (x) {
      return parseInt(x, 16);
    })), [parseInt(_arr[3] || 'ff', 16) / 255]);
  }
  var rgbaMatch = rgbaRegex.exec(normalizedColor);
  if (rgbaMatch) {
    var _arr2 = Array.from(rgbaMatch).slice(1);
    return [].concat(_toConsumableArray$1(_arr2.slice(0, 3).map(function (x) {
      return parseInt(x, 10);
    })), [parseFloat(_arr2[3] || '1')]);
  }
  var hslaMatch = hslaRegex.exec(normalizedColor);
  if (hslaMatch) {
    var _Array$from$slice$map = Array.from(hslaMatch).slice(1).map(parseFloat),
      _Array$from$slice$map2 = _slicedToArray$1(_Array$from$slice$map, 4),
      h = _Array$from$slice$map2[0],
      s = _Array$from$slice$map2[1],
      l = _Array$from$slice$map2[2],
      a = _Array$from$slice$map2[3];
    if (guard(0, 100, s) !== s) throw new ColorError$1(color);
    if (guard(0, 100, l) !== l) throw new ColorError$1(color);
    return [].concat(_toConsumableArray$1(hslToRgb(h, s, l)), [Number.isNaN(a) ? 1 : a]);
  }
  throw new ColorError$1(color);
}
function hash$2(str) {
  var hash = 5381;
  var i = str.length;
  while (i) {
    hash = hash * 33 ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return (hash >>> 0) % 2341;
}
var colorToInt = function colorToInt(x) {
  return parseInt(x.replace(/_/g, ''), 36);
};
var compressedColorMap = '1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm'.split(' ').reduce(function (acc, next) {
  var key = colorToInt(next.substring(0, 3));
  var hex = colorToInt(next.substring(3)).toString(16);

  // NOTE: padStart could be used here but it breaks Node 6 compat
  // https://github.com/ricokahler/color2k/issues/351
  var prefix = '';
  for (var i = 0; i < 6 - hex.length; i++) {
    prefix += '0';
  }
  acc[key] = "".concat(prefix).concat(hex);
  return acc;
}, {});

/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 */
function nameToHex(color) {
  var normalizedColorName = color.toLowerCase().trim();
  var result = compressedColorMap[hash$2(normalizedColorName)];
  if (!result) throw new ColorError$1(color);
  return "#".concat(result);
}
var r = function r(str, amount) {
  return Array.from(Array(amount)).map(function () {
    return str;
  }).join('');
};
var reducedHexRegex = new RegExp("^#".concat(r('([a-f0-9])', 3), "([a-f0-9])?$"), 'i');
var hexRegex = new RegExp("^#".concat(r('([a-f0-9]{2})', 3), "([a-f0-9]{2})?$"), 'i');
var rgbaRegex = new RegExp("^rgba?\\(\\s*(\\d+)\\s*".concat(r(',\\s*(\\d+)\\s*', 2), "(?:,\\s*([\\d.]+))?\\s*\\)$"), 'i');
var hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
var namedColorRegex = /^[a-z]+$/i;
var roundColor = function roundColor(color) {
  return Math.round(color * 255);
};
var hslToRgb = function hslToRgb(hue, saturation, lightness) {
  var l = lightness / 100;
  if (saturation === 0) {
    // achromatic
    return [l, l, l].map(roundColor);
  }

  // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = l - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return [finalRed, finalGreen, finalBlue].map(roundColor);
};

/**
 * Takes in rgba parts and returns an rgba string
 *
 * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
 * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
 * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */
function rgba$1(red, green, blue, alpha) {
  return "rgba(".concat(guard(0, 255, red).toFixed(), ", ").concat(guard(0, 255, green).toFixed(), ", ").concat(guard(0, 255, blue).toFixed(), ", ").concat(parseFloat(guard(0, 1, alpha).toFixed(3)), ")");
}

/**
 * Takes in a color and makes it more transparent by convert to `rgba` and
 * decreasing the amount in the alpha channel.
 *
 * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
 */
function transparentize$1(color, amount) {
  var _parseToRgba3 = parseToRgba(color),
    _parseToRgba4 = _slicedToArray$1(_parseToRgba3, 4),
    r = _parseToRgba4[0],
    g = _parseToRgba4[1],
    b = _parseToRgba4[2],
    a = _parseToRgba4[3];
  return rgba$1(r, g, b, a - amount);
}

/**
 * Takes in any color and returns it as a hex code.
 */
function toHex(color) {
  var _parseToRgba5 = parseToRgba(color),
    _parseToRgba6 = _slicedToArray$1(_parseToRgba5, 4),
    r = _parseToRgba6[0],
    g = _parseToRgba6[1],
    b = _parseToRgba6[2],
    a = _parseToRgba6[3];
  var hex = function hex(x) {
    var h = guard(0, 255, x).toString(16);
    // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351
    return h.length === 1 ? "0".concat(h) : h;
  };
  return "#".concat(hex(r)).concat(hex(g)).concat(hex(b)).concat(a < 1 ? hex(Math.round(a * 255)) : '');
}

// ../../../node_modules/.pnpm/dlv@1.1.3/node_modules/dlv/dist/dlv.es.js
function dlv_es_default(t, e, l, n, r) {
  for (e = e.split ? e.split(".") : e, n = 0; n < e.length; n++) t = t ? t[e[n]] : r;
  return t === r ? l : t;
}

// src/color.ts
var isEmptyObject = function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
};
var getColor = function getColor(theme, color, fallback) {
  var hex = dlv_es_default(theme, "colors.".concat(color), color);
  try {
    toHex(hex);
    return hex;
  } catch (_unused) {
    return fallback != null ? fallback : "#000000";
  }
};
var getBrightness = function getBrightness(color) {
  var _parseToRgba = parseToRgba(color),
    _parseToRgba2 = _slicedToArray$1(_parseToRgba, 3),
    r = _parseToRgba2[0],
    g = _parseToRgba2[1],
    b = _parseToRgba2[2];
  return (r * 299 + g * 587 + b * 114) / 1e3;
};
var tone = function tone(color) {
  return function (theme) {
    var hex = getColor(theme, color);
    var brightness = getBrightness(hex);
    var isDark2 = brightness < 128;
    return isDark2 ? "dark" : "light";
  };
};
var isDark = function isDark(color) {
  return function (theme) {
    return tone(color)(theme) === "dark";
  };
};
var transparentize = function transparentize(color, opacity) {
  return function (theme) {
    var raw = getColor(theme, color);
    return transparentize$1(raw, 1 - opacity);
  };
};
function generateStripe() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "1rem";
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "rgba(255, 255, 255, 0.15)";
  return {
    backgroundImage: "linear-gradient(\n    45deg,\n    ".concat(color, " 25%,\n    transparent 25%,\n    transparent 50%,\n    ").concat(color, " 50%,\n    ").concat(color, " 75%,\n    transparent 75%,\n    transparent\n  )"),
    backgroundSize: "".concat(size, " ").concat(size)
  };
}
var randomHex = function randomHex() {
  return "#".concat(Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0"));
};
function randomColor(opts) {
  var fallback = randomHex();
  if (!opts || isEmptyObject(opts)) {
    return fallback;
  }
  if (opts.string && opts.colors) {
    return randomColorFromList(opts.string, opts.colors);
  }
  if (opts.string && !opts.colors) {
    return randomColorFromString(opts.string);
  }
  if (opts.colors && !opts.string) {
    return randomFromList(opts.colors);
  }
  return fallback;
}
function randomColorFromString(str) {
  var hash = 0;
  if (str.length === 0) return hash.toString();
  for (var i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }
  var color = "#";
  for (var j = 0; j < 3; j += 1) {
    var value = hash >> j * 8 & 255;
    color += "00".concat(value.toString(16)).substr(-2);
  }
  return color;
}
function randomColorFromList(str, list) {
  var index = 0;
  if (str.length === 0) return list[0];
  for (var i = 0; i < str.length; i += 1) {
    index = str.charCodeAt(i) + ((index << 5) - index);
    index = index & index;
  }
  index = (index % list.length + list.length) % list.length;
  return list[index];
}
function randomFromList(list) {
  return list[Math.floor(Math.random() * list.length)];
}

// src/component.ts
function mode(light, dark) {
  return function (props) {
    return props.colorMode === "dark" ? dark : light;
  };
}
function orient(options) {
  var orientation = options.orientation,
    vertical = options.vertical,
    horizontal = options.horizontal;
  if (!orientation) return {};
  return orientation === "vertical" ? vertical : horizontal;
}

// src/css-calc.ts
function toRef(operand) {
  if (isObject(operand) && operand.reference) {
    return operand.reference;
  }
  return String(operand);
}
var toExpr = function toExpr(operator) {
  for (var _len = arguments.length, operands = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    operands[_key - 1] = arguments[_key];
  }
  return operands.map(toRef).join(" ".concat(operator, " ")).replace(/calc/g, "");
};
var _add = function add() {
  for (var _len2 = arguments.length, operands = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    operands[_key2] = arguments[_key2];
  }
  return "calc(".concat(toExpr.apply(void 0, ["+"].concat(operands)), ")");
};
var _subtract = function subtract() {
  for (var _len3 = arguments.length, operands = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    operands[_key3] = arguments[_key3];
  }
  return "calc(".concat(toExpr.apply(void 0, ["-"].concat(operands)), ")");
};
var _multiply = function multiply() {
  for (var _len4 = arguments.length, operands = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    operands[_key4] = arguments[_key4];
  }
  return "calc(".concat(toExpr.apply(void 0, ["*"].concat(operands)), ")");
};
var _divide = function divide() {
  for (var _len5 = arguments.length, operands = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    operands[_key5] = arguments[_key5];
  }
  return "calc(".concat(toExpr.apply(void 0, ["/"].concat(operands)), ")");
};
var _negate = function negate(x) {
  var value = toRef(x);
  if (value != null && !Number.isNaN(parseFloat(value))) {
    return String(value).startsWith("-") ? String(value).slice(1) : "-".concat(value);
  }
  return _multiply(value, -1);
};
var calc = Object.assign(function (x) {
  return {
    add: function add() {
      for (var _len6 = arguments.length, operands = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        operands[_key6] = arguments[_key6];
      }
      return calc(_add.apply(void 0, [x].concat(operands)));
    },
    subtract: function subtract() {
      for (var _len7 = arguments.length, operands = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        operands[_key7] = arguments[_key7];
      }
      return calc(_subtract.apply(void 0, [x].concat(operands)));
    },
    multiply: function multiply() {
      for (var _len8 = arguments.length, operands = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        operands[_key8] = arguments[_key8];
      }
      return calc(_multiply.apply(void 0, [x].concat(operands)));
    },
    divide: function divide() {
      for (var _len9 = arguments.length, operands = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        operands[_key9] = arguments[_key9];
      }
      return calc(_divide.apply(void 0, [x].concat(operands)));
    },
    negate: function negate() {
      return calc(_negate(x));
    },
    toString: function toString() {
      return x.toString();
    }
  };
}, {
  add: _add,
  subtract: _subtract,
  multiply: _multiply,
  divide: _divide,
  negate: _negate
});

// src/css-var.ts
function isDecimal(value) {
  return !Number.isInteger(parseFloat(value.toString()));
}
function replaceWhiteSpace(value) {
  var replaceValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
  return value.replace(/\s+/g, replaceValue);
}
function escape(value) {
  var valueStr = replaceWhiteSpace(value.toString());
  if (valueStr.includes("\\.")) return value;
  return isDecimal(value) ? valueStr.replace(".", "\\.") : value;
}
function addPrefix(value) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return [prefix, escape(value)].filter(Boolean).join("-");
}
function toVarRef(name, fallback) {
  return "var(".concat(escape(name)).concat(fallback ? ", ".concat(fallback) : "", ")");
}
function toVar$1(value) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return "--".concat(addPrefix(value, prefix));
}
function cssVar(name, options) {
  var cssVariable = toVar$1(name, void 0 );
  return {
    variable: cssVariable,
    reference: toVarRef(cssVariable, getFallback(void 0 ))
  };
}
function getFallback(fallback) {
  if (typeof fallback === "string") return fallback;
  return fallback == null ? void 0 : fallback.reference;
}

var _createMultiStyleConf$o = createMultiStyleConfigHelpers(switchAnatomy.keys),
  defineMultiStyleConfig$p = _createMultiStyleConf$o.defineMultiStyleConfig,
  definePartsStyle$p = _createMultiStyleConf$o.definePartsStyle;
var $width = cssVar("switch-track-width");
var $height$1 = cssVar("switch-track-height");
var $diff = cssVar("switch-track-diff");
var diffValue = calc.subtract($width, $height$1);
var $translateX = cssVar("switch-thumb-x");
var $bg$f = cssVar("switch-bg");
var baseStyleTrack$2 = defineStyle(function (props) {
  var c = props.colorScheme;
  return _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({
    borderRadius: "full",
    p: "0.5",
    width: [$width.reference],
    height: [$height$1.reference],
    transitionProperty: "common",
    transitionDuration: "fast"
  }, $bg$f.variable, "colors.gray.300"), "_dark", _defineProperty$3({}, $bg$f.variable, "colors.whiteAlpha.400")), "_focusVisible", {
    boxShadow: "outline"
  }), "_disabled", {
    opacity: 0.4,
    cursor: "not-allowed"
  }), "_checked", _defineProperty$3(_defineProperty$3({}, $bg$f.variable, "colors.".concat(c, ".500")), "_dark", _defineProperty$3({}, $bg$f.variable, "colors.".concat(c, ".200")))), "bg", $bg$f.reference);
});
var baseStyleThumb$1 = defineStyle({
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [$height$1.reference],
  height: [$height$1.reference],
  _checked: {
    transform: "translateX(".concat($translateX.reference, ")")
  }
});
var baseStyle$U = definePartsStyle$p(function (props) {
  return {
    container: _defineProperty$3(_defineProperty$3(_defineProperty$3({}, $diff.variable, diffValue), $translateX.variable, $diff.reference), "_rtl", _defineProperty$3({}, $translateX.variable, calc($diff).negate().toString())),
    track: baseStyleTrack$2(props),
    thumb: baseStyleThumb$1
  };
});
var sizes$s = {
  sm: definePartsStyle$p({
    container: _defineProperty$3(_defineProperty$3({}, $width.variable, "1.375rem"), $height$1.variable, "sizes.3")
  }),
  md: definePartsStyle$p({
    container: _defineProperty$3(_defineProperty$3({}, $width.variable, "1.875rem"), $height$1.variable, "sizes.4")
  }),
  lg: definePartsStyle$p({
    container: _defineProperty$3(_defineProperty$3({}, $width.variable, "2.875rem"), $height$1.variable, "sizes.6")
  })
};
var switchTheme = defineMultiStyleConfig$p({
  baseStyle: baseStyle$U,
  sizes: sizes$s,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

var _createMultiStyleConf$n = createMultiStyleConfigHelpers(tableAnatomy.keys),
  defineMultiStyleConfig$o = _createMultiStyleConf$n.defineMultiStyleConfig,
  definePartsStyle$o = _createMultiStyleConf$n.definePartsStyle;
var baseStyle$T = definePartsStyle$o({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
});
var numericStyles = defineStyle({
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
});
var variantSimple = definePartsStyle$o(function (props) {
  var c = props.colorScheme;
  return {
    th: _objectSpread2$1({
      color: mode("gray.600", "gray.400")(props),
      borderBottom: "1px",
      borderColor: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
    }, numericStyles),
    td: _objectSpread2$1({
      borderBottom: "1px",
      borderColor: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
    }, numericStyles),
    caption: {
      color: mode("gray.600", "gray.100")(props)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
});
var variantStripe = definePartsStyle$o(function (props) {
  var c = props.colorScheme;
  return {
    th: _objectSpread2$1({
      color: mode("gray.600", "gray.400")(props),
      borderBottom: "1px",
      borderColor: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
    }, numericStyles),
    td: _objectSpread2$1({
      borderBottom: "1px",
      borderColor: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
    }, numericStyles),
    caption: {
      color: mode("gray.600", "gray.100")(props)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
          },
          td: {
            background: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
});
var variants$v = {
  simple: variantSimple,
  striped: variantStripe,
  unstyled: defineStyle({})
};
var sizes$r = {
  sm: definePartsStyle$o({
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  }),
  md: definePartsStyle$o({
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  }),
  lg: definePartsStyle$o({
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  })
};
var tableTheme = defineMultiStyleConfig$o({
  baseStyle: baseStyle$T,
  variants: variants$v,
  sizes: sizes$r,
  defaultProps: {
    variant: "simple",
    size: "md",
    colorScheme: "gray"
  }
});

var $fg$5 = cssVar$1("tabs-color");
var $bg$e = cssVar$1("tabs-bg");
var $border$3 = cssVar$1("tabs-border-color");
var _createMultiStyleConf$m = createMultiStyleConfigHelpers(tabsAnatomy.keys),
  defineMultiStyleConfig$n = _createMultiStyleConf$m.defineMultiStyleConfig,
  definePartsStyle$n = _createMultiStyleConf$m.definePartsStyle;
var baseStyleRoot$1 = defineStyle(function (props) {
  var orientation = props.orientation;
  return {
    display: orientation === "vertical" ? "flex" : "block"
  };
});
var baseStyleTab = defineStyle(function (props) {
  var isFitted = props.isFitted;
  return {
    flex: isFitted ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
});
var baseStyleTablist = defineStyle(function (props) {
  var _props$align = props.align,
    align = _props$align === void 0 ? "start" : _props$align,
    orientation = props.orientation;
  var alignments = {
    end: "flex-end",
    center: "center",
    start: "flex-start"
  };
  return {
    justifyContent: alignments[align],
    flexDirection: orientation === "vertical" ? "column" : "row"
  };
});
var baseStyleTabpanel = defineStyle({
  p: 4
});
var baseStyle$S = definePartsStyle$n(function (props) {
  return {
    root: baseStyleRoot$1(props),
    tab: baseStyleTab(props),
    tablist: baseStyleTablist(props),
    tabpanel: baseStyleTabpanel
  };
});
var sizes$q = {
  sm: definePartsStyle$n({
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  }),
  md: definePartsStyle$n({
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  }),
  lg: definePartsStyle$n({
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  })
};
var variantLine = definePartsStyle$n(function (props) {
  var c = props.colorScheme,
    orientation = props.orientation;
  var isVertical = orientation === "vertical";
  var borderProp = isVertical ? "borderStart" : "borderBottom";
  var marginProp = isVertical ? "marginStart" : "marginBottom";
  return {
    tablist: _defineProperty$3(_defineProperty$3({}, borderProp, "2px solid"), "borderColor", "inherit"),
    tab: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, borderProp, "2px solid"), "borderColor", "transparent"), marginProp, "-2px"), "_selected", _defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fg$5.variable, "colors.".concat(c, ".600")), "_dark", _defineProperty$3({}, $fg$5.variable, "colors.".concat(c, ".300"))), "borderColor", "currentColor")), "_active", _defineProperty$3(_defineProperty$3({}, $bg$e.variable, "colors.gray.200"), "_dark", _defineProperty$3({}, $bg$e.variable, "colors.whiteAlpha.300"))), "_disabled", {
      _active: {
        bg: "none"
      }
    }), "color", $fg$5.reference), "bg", $bg$e.reference)
  };
});
var variantEnclosed = definePartsStyle$n(function (props) {
  var c = props.colorScheme;
  return {
    tab: _defineProperty$3(_defineProperty$3(_defineProperty$3({
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px"
    }, $border$3.variable, "transparent"), "_selected", _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fg$5.variable, "colors.".concat(c, ".600")), $border$3.variable, "colors.white"), "_dark", _defineProperty$3(_defineProperty$3({}, $fg$5.variable, "colors.".concat(c, ".300")), $border$3.variable, "colors.gray.800")), "borderColor", "inherit"), "borderBottomColor", $border$3.reference)), "color", $fg$5.reference),
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
});
var variantEnclosedColored = definePartsStyle$n(function (props) {
  var c = props.colorScheme;
  return {
    tab: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({
      border: "1px solid",
      borderColor: "inherit"
    }, $bg$e.variable, "colors.gray.50"), "_dark", _defineProperty$3({}, $bg$e.variable, "colors.whiteAlpha.50")), "mb", "-1px"), "_notLast", {
      marginEnd: "-1px"
    }), "_selected", _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $bg$e.variable, "colors.white"), $fg$5.variable, "colors.".concat(c, ".600")), "_dark", _defineProperty$3(_defineProperty$3({}, $bg$e.variable, "colors.gray.800"), $fg$5.variable, "colors.".concat(c, ".300"))), "borderColor", "inherit"), "borderTopColor", "currentColor"), "borderBottomColor", "transparent")), "color", $fg$5.reference), "bg", $bg$e.reference),
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
});
var variantSoftRounded = definePartsStyle$n(function (props) {
  var c = props.colorScheme,
    theme = props.theme;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: getColor(theme, "".concat(c, ".700")),
        bg: getColor(theme, "".concat(c, ".100"))
      }
    }
  };
});
var variantSolidRounded = definePartsStyle$n(function (props) {
  var c = props.colorScheme;
  return {
    tab: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({
      borderRadius: "full",
      fontWeight: "semibold"
    }, $fg$5.variable, "colors.gray.600"), "_dark", _defineProperty$3({}, $fg$5.variable, "inherit")), "_selected", _defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fg$5.variable, "colors.white"), $bg$e.variable, "colors.".concat(c, ".600")), "_dark", _defineProperty$3(_defineProperty$3({}, $fg$5.variable, "colors.gray.800"), $bg$e.variable, "colors.".concat(c, ".300")))), "color", $fg$5.reference), "bg", $bg$e.reference)
  };
});
var variantUnstyled$2 = definePartsStyle$n({});
var variants$u = {
  line: variantLine,
  enclosed: variantEnclosed,
  "enclosed-colored": variantEnclosedColored,
  "soft-rounded": variantSoftRounded,
  "solid-rounded": variantSolidRounded,
  unstyled: variantUnstyled$2
};
var tabsTheme = defineMultiStyleConfig$n({
  baseStyle: baseStyle$S,
  sizes: sizes$q,
  variants: variants$u,
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
});

var vars = defineCssVars("badge", ["bg", "color", "shadow"]);
var baseStyle$R = defineStyle({
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: vars.bg.reference,
  color: vars.color.reference,
  boxShadow: vars.shadow.reference
});
var variantSolid$4 = defineStyle(function (props) {
  var c = props.colorScheme,
    theme = props.theme;
  var dark = transparentize("".concat(c, ".500"), 0.6)(theme);
  return _defineProperty$3(_defineProperty$3(_defineProperty$3({}, vars.bg.variable, "colors.".concat(c, ".500")), vars.color.variable, "colors.white"), "_dark", _defineProperty$3(_defineProperty$3({}, vars.bg.variable, dark), vars.color.variable, "colors.whiteAlpha.800"));
});
var variantSubtle$1 = defineStyle(function (props) {
  var c = props.colorScheme,
    theme = props.theme;
  var darkBg = transparentize("".concat(c, ".200"), 0.16)(theme);
  return _defineProperty$3(_defineProperty$3(_defineProperty$3({}, vars.bg.variable, "colors.".concat(c, ".100")), vars.color.variable, "colors.".concat(c, ".800")), "_dark", _defineProperty$3(_defineProperty$3({}, vars.bg.variable, darkBg), vars.color.variable, "colors.".concat(c, ".200")));
});
var variantOutline$2 = defineStyle(function (props) {
  var c = props.colorScheme,
    theme = props.theme;
  var darkColor = transparentize("".concat(c, ".200"), 0.8)(theme);
  return _defineProperty$3(_defineProperty$3(_defineProperty$3({}, vars.color.variable, "colors.".concat(c, ".500")), "_dark", _defineProperty$3({}, vars.color.variable, darkColor)), vars.shadow.variable, "inset 0 0 0px 1px ".concat(vars.color.reference));
});
var variants$t = {
  solid: variantSolid$4,
  subtle: variantSubtle$1,
  outline: variantOutline$2
};
var badgeTheme = defineStyleConfig({
  baseStyle: baseStyle$R,
  variants: variants$t,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
});

var _defineStyle$4;
var _createMultiStyleConf$l = createMultiStyleConfigHelpers(tagAnatomy.keys),
  defineMultiStyleConfig$m = _createMultiStyleConf$l.defineMultiStyleConfig,
  definePartsStyle$m = _createMultiStyleConf$l.definePartsStyle;
var $bg$d = cssVar$1("tag-bg");
var $color = cssVar$1("tag-color");
var $shadow$3 = cssVar$1("tag-shadow");
var $minH = cssVar$1("tag-min-height");
var $minW = cssVar$1("tag-min-width");
var $fontSize$1 = cssVar$1("tag-font-size");
var $paddingX = cssVar$1("tag-padding-inline");
var baseStyleContainer$4 = defineStyle((_defineStyle$4 = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0
}, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineStyle$4, $color.variable, vars.color.reference), $bg$d.variable, vars.bg.reference), $shadow$3.variable, vars.shadow.reference), "color", $color.reference), "bg", $bg$d.reference), "boxShadow", $shadow$3.reference), "borderRadius", "md"), "minH", $minH.reference), "minW", $minW.reference), "fontSize", $fontSize$1.reference), _defineProperty$3(_defineProperty$3(_defineStyle$4, "px", $paddingX.reference), "_focusVisible", _defineProperty$3({}, $shadow$3.variable, "shadows.outline"))));
var baseStyleLabel$4 = defineStyle({
  lineHeight: 1.2,
  overflow: "visible"
});
var baseStyleCloseButton$3 = defineStyle({
  fontSize: "lg",
  w: "5",
  h: "5",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "1.5",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focusVisible: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
});
var baseStyle$Q = definePartsStyle$m({
  container: baseStyleContainer$4,
  label: baseStyleLabel$4,
  closeButton: baseStyleCloseButton$3
});
var sizes$p = {
  sm: definePartsStyle$m({
    container: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $minH.variable, "sizes.5"), $minW.variable, "sizes.5"), $fontSize$1.variable, "fontSizes.xs"), $paddingX.variable, "space.2"),
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  }),
  md: definePartsStyle$m({
    container: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $minH.variable, "sizes.6"), $minW.variable, "sizes.6"), $fontSize$1.variable, "fontSizes.sm"), $paddingX.variable, "space.2")
  }),
  lg: definePartsStyle$m({
    container: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $minH.variable, "sizes.8"), $minW.variable, "sizes.8"), $fontSize$1.variable, "fontSizes.md"), $paddingX.variable, "space.3")
  })
};
var variants$s = {
  subtle: definePartsStyle$m(function (props) {
    var _a;
    return {
      container: (_a = badgeTheme.variants) == null ? void 0 : _a.subtle(props)
    };
  }),
  solid: definePartsStyle$m(function (props) {
    var _a;
    return {
      container: (_a = badgeTheme.variants) == null ? void 0 : _a.solid(props)
    };
  }),
  outline: definePartsStyle$m(function (props) {
    var _a;
    return {
      container: (_a = badgeTheme.variants) == null ? void 0 : _a.outline(props)
    };
  })
};
var tagTheme = defineMultiStyleConfig$m({
  variants: variants$s,
  baseStyle: baseStyle$Q,
  sizes: sizes$p,
  defaultProps: {
    size: "md",
    variant: "subtle",
    colorScheme: "gray"
  }
});

var _createMultiStyleConf$k = createMultiStyleConfigHelpers(inputAnatomy.keys),
  definePartsStyle$l = _createMultiStyleConf$k.definePartsStyle,
  defineMultiStyleConfig$l = _createMultiStyleConf$k.defineMultiStyleConfig;
var $height = cssVar$1("input-height");
var $fontSize = cssVar$1("input-font-size");
var $padding$1 = cssVar$1("input-padding");
var $borderRadius = cssVar$1("input-border-radius");
var baseStyle$P = definePartsStyle$l({
  addon: {
    height: $height.reference,
    fontSize: $fontSize.reference,
    px: $padding$1.reference,
    borderRadius: $borderRadius.reference
  },
  field: {
    width: "100%",
    height: $height.reference,
    fontSize: $fontSize.reference,
    px: $padding$1.reference,
    borderRadius: $borderRadius.reference,
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
});
var size = {
  lg: defineStyle(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fontSize.variable, "fontSizes.lg"), $padding$1.variable, "space.4"), $borderRadius.variable, "radii.md"), $height.variable, "sizes.12")),
  md: defineStyle(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fontSize.variable, "fontSizes.md"), $padding$1.variable, "space.4"), $borderRadius.variable, "radii.md"), $height.variable, "sizes.10")),
  sm: defineStyle(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fontSize.variable, "fontSizes.sm"), $padding$1.variable, "space.3"), $borderRadius.variable, "radii.sm"), $height.variable, "sizes.8")),
  xs: defineStyle(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fontSize.variable, "fontSizes.xs"), $padding$1.variable, "space.2"), $borderRadius.variable, "radii.sm"), $height.variable, "sizes.6"))
};
var sizes$o = {
  lg: definePartsStyle$l({
    field: size.lg,
    group: size.lg
  }),
  md: definePartsStyle$l({
    field: size.md,
    group: size.md
  }),
  sm: definePartsStyle$l({
    field: size.sm,
    group: size.sm
  }),
  xs: definePartsStyle$l({
    field: size.xs,
    group: size.xs
  })
};
function getDefaults(props) {
  var fc = props.focusBorderColor,
    ec = props.errorBorderColor;
  return {
    focusBorderColor: fc || mode("blue.500", "blue.300")(props),
    errorBorderColor: ec || mode("red.500", "red.300")(props)
  };
}
var variantOutline$1 = definePartsStyle$l(function (props) {
  var theme = props.theme;
  var _getDefaults = getDefaults(props),
    fc = _getDefaults.focusBorderColor,
    ec = _getDefaults.errorBorderColor;
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: mode("gray.300", "whiteAlpha.400")(props)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: getColor(theme, ec),
        boxShadow: "0 0 0 1px ".concat(getColor(theme, ec))
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: getColor(theme, fc),
        boxShadow: "0 0 0 1px ".concat(getColor(theme, fc))
      }
    },
    addon: {
      border: "1px solid",
      borderColor: mode("inherit", "whiteAlpha.50")(props),
      bg: mode("gray.100", "whiteAlpha.300")(props)
    }
  };
});
var variantFilled = definePartsStyle$l(function (props) {
  var theme = props.theme;
  var _getDefaults2 = getDefaults(props),
    fc = _getDefaults2.focusBorderColor,
    ec = _getDefaults2.errorBorderColor;
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: mode("gray.100", "whiteAlpha.50")(props),
      _hover: {
        bg: mode("gray.200", "whiteAlpha.100")(props)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: getColor(theme, ec)
      },
      _focusVisible: {
        bg: "transparent",
        borderColor: getColor(theme, fc)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: mode("gray.100", "whiteAlpha.50")(props)
    }
  };
});
var variantFlushed = definePartsStyle$l(function (props) {
  var theme = props.theme;
  var _getDefaults3 = getDefaults(props),
    fc = _getDefaults3.focusBorderColor,
    ec = _getDefaults3.errorBorderColor;
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: getColor(theme, ec),
        boxShadow: "0px 1px 0px 0px ".concat(getColor(theme, ec))
      },
      _focusVisible: {
        borderColor: getColor(theme, fc),
        boxShadow: "0px 1px 0px 0px ".concat(getColor(theme, fc))
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent"
    }
  };
});
var variantUnstyled$1 = definePartsStyle$l({
  field: {
    bg: "transparent",
    px: "0",
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: "0",
    height: "auto"
  }
});
var variants$r = {
  outline: variantOutline$1,
  filled: variantFilled,
  flushed: variantFlushed,
  unstyled: variantUnstyled$1
};
var inputTheme = defineMultiStyleConfig$l({
  baseStyle: baseStyle$P,
  sizes: sizes$o,
  variants: variants$r,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
});

var _a$4;
var baseStyle$O = defineStyle(_objectSpread2$1(_objectSpread2$1({}, (_a$4 = inputTheme.baseStyle) == null ? void 0 : _a$4.field), {}, {
  paddingY: "2",
  minHeight: "20",
  lineHeight: "short",
  verticalAlign: "top"
}));
var _a2$2, _b$2;
var variants$q = {
  outline: defineStyle(function (props) {
    var _a4, _b3;
    return (_b3 = (_a4 = inputTheme.variants) == null ? void 0 : _a4.outline(props).field) != null ? _b3 : {};
  }),
  flushed: defineStyle(function (props) {
    var _a4, _b3;
    return (_b3 = (_a4 = inputTheme.variants) == null ? void 0 : _a4.flushed(props).field) != null ? _b3 : {};
  }),
  filled: defineStyle(function (props) {
    var _a4, _b3;
    return (_b3 = (_a4 = inputTheme.variants) == null ? void 0 : _a4.filled(props).field) != null ? _b3 : {};
  }),
  unstyled: (_b$2 = (_a2$2 = inputTheme.variants) == null ? void 0 : _a2$2.unstyled.field) != null ? _b$2 : {}
};
var _a3, _b2, _c$1, _d$1, _e$1, _f$1, _g$1, _h$1;
var sizes$n = {
  xs: (_b2 = (_a3 = inputTheme.sizes) == null ? void 0 : _a3.xs.field) != null ? _b2 : {},
  sm: (_d$1 = (_c$1 = inputTheme.sizes) == null ? void 0 : _c$1.sm.field) != null ? _d$1 : {},
  md: (_f$1 = (_e$1 = inputTheme.sizes) == null ? void 0 : _e$1.md.field) != null ? _f$1 : {},
  lg: (_h$1 = (_g$1 = inputTheme.sizes) == null ? void 0 : _g$1.lg.field) != null ? _h$1 : {}
};
var textareaTheme = defineStyleConfig({
  baseStyle: baseStyle$O,
  sizes: sizes$n,
  variants: variants$q,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
});

var _defineStyle$3;
var $bg$c = cssVar("tooltip-bg");
var $fg$4 = cssVar("tooltip-fg");
var $arrowBg$1 = cssVar("popper-arrow-bg");
var baseStyle$N = defineStyle((_defineStyle$3 = {
  bg: $bg$c.reference,
  color: $fg$4.reference
}, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineStyle$3, $bg$c.variable, "colors.gray.700"), $fg$4.variable, "colors.whiteAlpha.900"), "_dark", _defineProperty$3(_defineProperty$3({}, $bg$c.variable, "colors.gray.300"), $fg$4.variable, "colors.gray.900")), $arrowBg$1.variable, $bg$c.reference), "px", "2"), "py", "0.5"), "borderRadius", "sm"), "fontWeight", "medium"), "fontSize", "sm"), "boxShadow", "md"), _defineProperty$3(_defineProperty$3(_defineStyle$3, "maxW", "xs"), "zIndex", "tooltip")));
var tooltipTheme = defineStyleConfig({
  baseStyle: baseStyle$N
});

var _createMultiStyleConf$j = createMultiStyleConfigHelpers(progressAnatomy.keys),
  defineMultiStyleConfig$k = _createMultiStyleConf$j.defineMultiStyleConfig,
  definePartsStyle$k = _createMultiStyleConf$j.definePartsStyle;
var filledStyle$1 = defineStyle(function (props) {
  var c = props.colorScheme,
    t = props.theme,
    isIndeterminate = props.isIndeterminate,
    hasStripe = props.hasStripe;
  var stripeStyle = mode(generateStripe(), generateStripe("1rem", "rgba(0,0,0,0.1)"))(props);
  var bgColor = mode("".concat(c, ".500"), "".concat(c, ".200"))(props);
  var gradient = "linear-gradient(\n    to right,\n    transparent 0%,\n    ".concat(getColor(t, bgColor), " 50%,\n    transparent 100%\n  )");
  var addStripe = !isIndeterminate && hasStripe;
  return _objectSpread2$1(_objectSpread2$1({}, addStripe && stripeStyle), isIndeterminate ? {
    bgImage: gradient
  } : {
    bgColor: bgColor
  });
});
var baseStyleLabel$3 = defineStyle({
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
});
var baseStyleTrack$1 = defineStyle(function (props) {
  return {
    bg: mode("gray.100", "whiteAlpha.300")(props)
  };
});
var baseStyleFilledTrack$1 = defineStyle(function (props) {
  return _objectSpread2$1({
    transitionProperty: "common",
    transitionDuration: "slow"
  }, filledStyle$1(props));
});
var baseStyle$M = definePartsStyle$k(function (props) {
  return {
    label: baseStyleLabel$3,
    filledTrack: baseStyleFilledTrack$1(props),
    track: baseStyleTrack$1(props)
  };
});
var sizes$m = {
  xs: definePartsStyle$k({
    track: {
      h: "1"
    }
  }),
  sm: definePartsStyle$k({
    track: {
      h: "2"
    }
  }),
  md: definePartsStyle$k({
    track: {
      h: "3"
    }
  }),
  lg: definePartsStyle$k({
    track: {
      h: "4"
    }
  })
};
var progressTheme = defineMultiStyleConfig$k({
  sizes: sizes$m,
  baseStyle: baseStyle$M,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

// src/utils/run-if-fn.ts
var isFunction$2 = function isFunction(value) {
  return typeof value === "function";
};
function runIfFn$1(valueOrFn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return isFunction$2(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}

var _createMultiStyleConf$i = createMultiStyleConfigHelpers(checkboxAnatomy.keys),
  definePartsStyle$j = _createMultiStyleConf$i.definePartsStyle,
  defineMultiStyleConfig$j = _createMultiStyleConf$i.defineMultiStyleConfig;
var $size$3 = cssVar$1("checkbox-size");
var baseStyleControl$1 = defineStyle(function (props) {
  var c = props.colorScheme;
  return {
    w: $size$3.reference,
    h: $size$3.reference,
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: mode("".concat(c, ".500"), "".concat(c, ".200"))(props),
      borderColor: mode("".concat(c, ".500"), "".concat(c, ".200"))(props),
      color: mode("white", "gray.900")(props),
      _hover: {
        bg: mode("".concat(c, ".600"), "".concat(c, ".300"))(props),
        borderColor: mode("".concat(c, ".600"), "".concat(c, ".300"))(props)
      },
      _disabled: {
        borderColor: mode("gray.200", "transparent")(props),
        bg: mode("gray.200", "whiteAlpha.300")(props),
        color: mode("gray.500", "whiteAlpha.500")(props)
      }
    },
    _indeterminate: {
      bg: mode("".concat(c, ".500"), "".concat(c, ".200"))(props),
      borderColor: mode("".concat(c, ".500"), "".concat(c, ".200"))(props),
      color: mode("white", "gray.900")(props)
    },
    _disabled: {
      bg: mode("gray.100", "whiteAlpha.100")(props),
      borderColor: mode("gray.100", "transparent")(props)
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: mode("red.500", "red.300")(props)
    }
  };
});
var baseStyleContainer$3 = defineStyle({
  _disabled: {
    cursor: "not-allowed"
  }
});
var baseStyleLabel$2 = defineStyle({
  userSelect: "none",
  _disabled: {
    opacity: 0.4
  }
});
var baseStyleIcon$6 = defineStyle({
  transitionProperty: "transform",
  transitionDuration: "normal"
});
var baseStyle$L = definePartsStyle$j(function (props) {
  return {
    icon: baseStyleIcon$6,
    container: baseStyleContainer$3,
    control: runIfFn$1(baseStyleControl$1, props),
    label: baseStyleLabel$2
  };
});
var sizes$l = {
  sm: definePartsStyle$j({
    control: _defineProperty$3({}, $size$3.variable, "sizes.3"),
    label: {
      fontSize: "sm"
    },
    icon: {
      fontSize: "3xs"
    }
  }),
  md: definePartsStyle$j({
    control: _defineProperty$3({}, $size$3.variable, "sizes.4"),
    label: {
      fontSize: "md"
    },
    icon: {
      fontSize: "2xs"
    }
  }),
  lg: definePartsStyle$j({
    control: _defineProperty$3({}, $size$3.variable, "sizes.5"),
    label: {
      fontSize: "lg"
    },
    icon: {
      fontSize: "2xs"
    }
  })
};
var checkboxTheme = defineMultiStyleConfig$j({
  baseStyle: baseStyle$L,
  sizes: sizes$l,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

var _createMultiStyleConf$h = createMultiStyleConfigHelpers(radioAnatomy.keys),
  defineMultiStyleConfig$i = _createMultiStyleConf$h.defineMultiStyleConfig,
  definePartsStyle$i = _createMultiStyleConf$h.definePartsStyle;
var baseStyleControl = defineStyle(function (props) {
  var _a;
  var controlStyle = (_a = runIfFn$1(checkboxTheme.baseStyle, props)) == null ? void 0 : _a.control;
  return _objectSpread2$1(_objectSpread2$1({}, controlStyle), {}, {
    borderRadius: "full",
    _checked: _objectSpread2$1(_objectSpread2$1({}, controlStyle == null ? void 0 : controlStyle["_checked"]), {}, {
      _before: {
        content: "\"\"",
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    })
  });
});
var baseStyle$K = definePartsStyle$i(function (props) {
  var _a, _b, _c, _d;
  return {
    label: (_b = (_a = checkboxTheme).baseStyle) == null ? void 0 : _b.call(_a, props).label,
    container: (_d = (_c = checkboxTheme).baseStyle) == null ? void 0 : _d.call(_c, props).container,
    control: baseStyleControl(props)
  };
});
var sizes$k = {
  md: definePartsStyle$i({
    control: {
      w: "4",
      h: "4"
    },
    label: {
      fontSize: "md"
    }
  }),
  lg: definePartsStyle$i({
    control: {
      w: "5",
      h: "5"
    },
    label: {
      fontSize: "lg"
    }
  }),
  sm: definePartsStyle$i({
    control: {
      width: "3",
      height: "3"
    },
    label: {
      fontSize: "sm"
    }
  })
};
var radioTheme = defineMultiStyleConfig$i({
  baseStyle: baseStyle$K,
  sizes: sizes$k,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

var _createMultiStyleConf$g = createMultiStyleConfigHelpers(selectAnatomy.keys),
  defineMultiStyleConfig$h = _createMultiStyleConf$g.defineMultiStyleConfig,
  definePartsStyle$h = _createMultiStyleConf$g.definePartsStyle;
var $bg$b = cssVar$1("select-bg");
var _a$3;
var baseStyleField$1 = defineStyle(_objectSpread2$1(_objectSpread2$1({}, (_a$3 = inputTheme.baseStyle) == null ? void 0 : _a$3.field), {}, _defineProperty$3(_defineProperty$3(_defineProperty$3({
  appearance: "none",
  paddingBottom: "1px",
  lineHeight: "normal",
  bg: $bg$b.reference
}, $bg$b.variable, "colors.white"), "_dark", _defineProperty$3({}, $bg$b.variable, "colors.gray.700")), "> option, > optgroup", {
  bg: $bg$b.reference
})));
var baseStyleIcon$5 = defineStyle({
  width: "6",
  height: "100%",
  insetEnd: "2",
  position: "relative",
  color: "currentColor",
  fontSize: "xl",
  _disabled: {
    opacity: 0.5
  }
});
var baseStyle$J = definePartsStyle$h({
  field: baseStyleField$1,
  icon: baseStyleIcon$5
});
var iconSpacing = defineStyle({
  paddingInlineEnd: "8"
});
var _a2$1, _b$1, _c, _d, _e, _f, _g, _h;
var sizes$j = {
  lg: _objectSpread2$1(_objectSpread2$1({}, (_a2$1 = inputTheme.sizes) == null ? void 0 : _a2$1.lg), {}, {
    field: _objectSpread2$1(_objectSpread2$1({}, (_b$1 = inputTheme.sizes) == null ? void 0 : _b$1.lg.field), iconSpacing)
  }),
  md: _objectSpread2$1(_objectSpread2$1({}, (_c = inputTheme.sizes) == null ? void 0 : _c.md), {}, {
    field: _objectSpread2$1(_objectSpread2$1({}, (_d = inputTheme.sizes) == null ? void 0 : _d.md.field), iconSpacing)
  }),
  sm: _objectSpread2$1(_objectSpread2$1({}, (_e = inputTheme.sizes) == null ? void 0 : _e.sm), {}, {
    field: _objectSpread2$1(_objectSpread2$1({}, (_f = inputTheme.sizes) == null ? void 0 : _f.sm.field), iconSpacing)
  }),
  xs: _objectSpread2$1(_objectSpread2$1({}, (_g = inputTheme.sizes) == null ? void 0 : _g.xs), {}, {
    field: _objectSpread2$1(_objectSpread2$1({}, (_h = inputTheme.sizes) == null ? void 0 : _h.xs.field), iconSpacing),
    icon: {
      insetEnd: "1"
    }
  })
};
var selectTheme = defineMultiStyleConfig$h({
  baseStyle: baseStyle$J,
  sizes: sizes$j,
  variants: inputTheme.variants,
  defaultProps: inputTheme.defaultProps
});

var $startColor$1 = cssVar$1("skeleton-start-color");
var $endColor$1 = cssVar$1("skeleton-end-color");
var baseStyle$I = defineStyle(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $startColor$1.variable, "colors.gray.100"), $endColor$1.variable, "colors.gray.400"), "_dark", _defineProperty$3(_defineProperty$3({}, $startColor$1.variable, "colors.gray.800"), $endColor$1.variable, "colors.gray.600")), "background", $startColor$1.reference), "borderColor", $endColor$1.reference), "opacity", 0.7), "borderRadius", "sm"));
var skeletonTheme = defineStyleConfig({
  baseStyle: baseStyle$I
});

var $bg$a = cssVar$1("skip-link-bg");
var baseStyle$H = defineStyle({
  borderRadius: "md",
  fontWeight: "semibold",
  _focusVisible: _defineProperty$3(_defineProperty$3(_defineProperty$3({
    boxShadow: "outline",
    padding: "4",
    position: "fixed",
    top: "6",
    insetStart: "6"
  }, $bg$a.variable, "colors.white"), "_dark", _defineProperty$3({}, $bg$a.variable, "colors.gray.700")), "bg", $bg$a.reference)
});
var skipLinkTheme = defineStyleConfig({
  baseStyle: baseStyle$H
});

var _createMultiStyleConf$f = createMultiStyleConfigHelpers(sliderAnatomy.keys),
  defineMultiStyleConfig$g = _createMultiStyleConf$f.defineMultiStyleConfig,
  definePartsStyle$g = _createMultiStyleConf$f.definePartsStyle;
var $thumbSize = cssVar$1("slider-thumb-size");
var $trackSize = cssVar$1("slider-track-size");
var $bg$9 = cssVar$1("slider-bg");
var baseStyleContainer$2 = defineStyle(function (props) {
  var orientation = props.orientation;
  return _objectSpread2$1({
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    }
  }, orient({
    orientation: orientation,
    vertical: {
      h: "100%"
    },
    horizontal: {
      w: "100%"
    }
  }));
});
var baseStyleTrack = defineStyle(function (props) {
  var orientationStyles = orient({
    orientation: props.orientation,
    horizontal: {
      h: $trackSize.reference
    },
    vertical: {
      w: $trackSize.reference
    }
  });
  return _objectSpread2$1(_objectSpread2$1({}, orientationStyles), {}, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({
    overflow: "hidden",
    borderRadius: "sm"
  }, $bg$9.variable, "colors.gray.200"), "_dark", _defineProperty$3({}, $bg$9.variable, "colors.whiteAlpha.200")), "_disabled", _defineProperty$3(_defineProperty$3({}, $bg$9.variable, "colors.gray.300"), "_dark", _defineProperty$3({}, $bg$9.variable, "colors.whiteAlpha.300"))), "bg", $bg$9.reference));
});
var baseStyleThumb = defineStyle(function (props) {
  var orientation = props.orientation;
  var orientationStyle = orient({
    orientation: orientation,
    vertical: {
      left: "50%",
      transform: "translateX(-50%)",
      _active: {
        transform: "translateX(-50%) scale(1.15)"
      }
    },
    horizontal: {
      top: "50%",
      transform: "translateY(-50%)",
      _active: {
        transform: "translateY(-50%) scale(1.15)"
      }
    }
  });
  return _objectSpread2$1(_objectSpread2$1({}, orientationStyle), {}, {
    w: $thumbSize.reference,
    h: $thumbSize.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      bg: "gray.300"
    }
  });
});
var baseStyleFilledTrack = defineStyle(function (props) {
  var c = props.colorScheme;
  return _defineProperty$3(_defineProperty$3(_defineProperty$3({
    width: "inherit",
    height: "inherit"
  }, $bg$9.variable, "colors.".concat(c, ".500")), "_dark", _defineProperty$3({}, $bg$9.variable, "colors.".concat(c, ".200"))), "bg", $bg$9.reference);
});
var baseStyle$G = definePartsStyle$g(function (props) {
  return {
    container: baseStyleContainer$2(props),
    track: baseStyleTrack(props),
    thumb: baseStyleThumb(props),
    filledTrack: baseStyleFilledTrack(props)
  };
});
var sizeLg = definePartsStyle$g({
  container: _defineProperty$3(_defineProperty$3({}, $thumbSize.variable, "sizes.4"), $trackSize.variable, "sizes.1")
});
var sizeMd = definePartsStyle$g({
  container: _defineProperty$3(_defineProperty$3({}, $thumbSize.variable, "sizes.3.5"), $trackSize.variable, "sizes.1")
});
var sizeSm = definePartsStyle$g({
  container: _defineProperty$3(_defineProperty$3({}, $thumbSize.variable, "sizes.2.5"), $trackSize.variable, "sizes.0.5")
});
var sizes$i = {
  lg: sizeLg,
  md: sizeMd,
  sm: sizeSm
};
var sliderTheme = defineMultiStyleConfig$g({
  baseStyle: baseStyle$G,
  sizes: sizes$i,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

var $size$2 = cssVar("spinner-size");
var baseStyle$F = defineStyle({
  width: [$size$2.reference],
  height: [$size$2.reference]
});
var sizes$h = {
  xs: defineStyle(_defineProperty$3({}, $size$2.variable, "sizes.3")),
  sm: defineStyle(_defineProperty$3({}, $size$2.variable, "sizes.4")),
  md: defineStyle(_defineProperty$3({}, $size$2.variable, "sizes.6")),
  lg: defineStyle(_defineProperty$3({}, $size$2.variable, "sizes.8")),
  xl: defineStyle(_defineProperty$3({}, $size$2.variable, "sizes.12"))
};
var spinnerTheme = defineStyleConfig({
  baseStyle: baseStyle$F,
  sizes: sizes$h,
  defaultProps: {
    size: "md"
  }
});

// src/components/stat.ts
var _createMultiStyleConf$e = createMultiStyleConfigHelpers(statAnatomy.keys),
  defineMultiStyleConfig$f = _createMultiStyleConf$e.defineMultiStyleConfig,
  definePartsStyle$f = _createMultiStyleConf$e.definePartsStyle;
var baseStyleLabel$1 = defineStyle({
  fontWeight: "medium"
});
var baseStyleHelpText = defineStyle({
  opacity: 0.8,
  marginBottom: "2"
});
var baseStyleNumber = defineStyle({
  verticalAlign: "baseline",
  fontWeight: "semibold"
});
var baseStyleIcon$4 = defineStyle({
  marginEnd: 1,
  w: "3.5",
  h: "3.5",
  verticalAlign: "middle"
});
var baseStyle$E = definePartsStyle$f({
  container: {},
  label: baseStyleLabel$1,
  helpText: baseStyleHelpText,
  number: baseStyleNumber,
  icon: baseStyleIcon$4
});
var sizes$g = {
  md: definePartsStyle$f({
    label: {
      fontSize: "sm"
    },
    helpText: {
      fontSize: "sm"
    },
    number: {
      fontSize: "2xl"
    }
  })
};
var statTheme = defineMultiStyleConfig$f({
  baseStyle: baseStyle$E,
  sizes: sizes$g,
  defaultProps: {
    size: "md"
  }
});

var _defineStyle$2;
var $bg$8 = cssVar$1("kbd-bg");
var baseStyle$D = defineStyle((_defineStyle$2 = {}, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineStyle$2, $bg$8.variable, "colors.gray.100"), "_dark", _defineProperty$3({}, $bg$8.variable, "colors.whiteAlpha.100")), "bg", $bg$8.reference), "borderRadius", "md"), "borderWidth", "1px"), "borderBottomWidth", "3px"), "fontSize", "0.8em"), "fontWeight", "bold"), "lineHeight", "normal"), "px", "0.4em"), _defineProperty$3(_defineStyle$2, "whiteSpace", "nowrap")));
var kbdTheme = defineStyleConfig({
  baseStyle: baseStyle$D
});

// src/components/link.ts
var baseStyle$C = defineStyle({
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focusVisible: {
    boxShadow: "outline"
  }
});
var linkTheme = defineStyleConfig({
  baseStyle: baseStyle$C
});

// src/components/list.ts
var _createMultiStyleConf$d = createMultiStyleConfigHelpers(listAnatomy.keys),
  defineMultiStyleConfig$e = _createMultiStyleConf$d.defineMultiStyleConfig,
  definePartsStyle$e = _createMultiStyleConf$d.definePartsStyle;
var baseStyleIcon$3 = defineStyle({
  marginEnd: "2",
  display: "inline",
  verticalAlign: "text-bottom"
});
var baseStyle$B = definePartsStyle$e({
  icon: baseStyleIcon$3
});
var listTheme = defineMultiStyleConfig$e({
  baseStyle: baseStyle$B
});

var _defineStyle$1;
var _createMultiStyleConf$c = createMultiStyleConfigHelpers(menuAnatomy.keys),
  defineMultiStyleConfig$d = _createMultiStyleConf$c.defineMultiStyleConfig,
  definePartsStyle$d = _createMultiStyleConf$c.definePartsStyle;
var $bg$7 = cssVar$1("menu-bg");
var $shadow$2 = cssVar$1("menu-shadow");
var baseStyleList = defineStyle((_defineStyle$1 = {}, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineStyle$1, $bg$7.variable, "#fff"), $shadow$2.variable, "shadows.sm"), "_dark", _defineProperty$3(_defineProperty$3({}, $bg$7.variable, "colors.gray.700"), $shadow$2.variable, "shadows.dark-lg")), "color", "inherit"), "minW", "3xs"), "py", "2"), "zIndex", 1), "borderRadius", "md"), "borderWidth", "1px"), "bg", $bg$7.reference), _defineProperty$3(_defineStyle$1, "boxShadow", $shadow$2.reference)));
var baseStyleItem = defineStyle({
  py: "1.5",
  px: "3",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  _focus: _defineProperty$3(_defineProperty$3({}, $bg$7.variable, "colors.gray.100"), "_dark", _defineProperty$3({}, $bg$7.variable, "colors.whiteAlpha.100")),
  _active: _defineProperty$3(_defineProperty$3({}, $bg$7.variable, "colors.gray.200"), "_dark", _defineProperty$3({}, $bg$7.variable, "colors.whiteAlpha.200")),
  _expanded: _defineProperty$3(_defineProperty$3({}, $bg$7.variable, "colors.gray.100"), "_dark", _defineProperty$3({}, $bg$7.variable, "colors.whiteAlpha.100")),
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  bg: $bg$7.reference
});
var baseStyleGroupTitle = defineStyle({
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
});
var baseStyleIcon$2 = defineStyle({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
});
var baseStyleCommand = defineStyle({
  opacity: 0.6
});
var baseStyleDivider = defineStyle({
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
});
var baseStyleButton$1 = defineStyle({
  transitionProperty: "common",
  transitionDuration: "normal"
});
var baseStyle$A = definePartsStyle$d({
  button: baseStyleButton$1,
  list: baseStyleList,
  item: baseStyleItem,
  groupTitle: baseStyleGroupTitle,
  icon: baseStyleIcon$2,
  command: baseStyleCommand,
  divider: baseStyleDivider
});
var menuTheme = defineMultiStyleConfig$d({
  baseStyle: baseStyle$A
});

var _createMultiStyleConf$b = createMultiStyleConfigHelpers(modalAnatomy.keys),
  defineMultiStyleConfig$c = _createMultiStyleConf$b.defineMultiStyleConfig,
  definePartsStyle$c = _createMultiStyleConf$b.definePartsStyle;
var $bg$6 = cssVar$1("modal-bg");
var $shadow$1 = cssVar$1("modal-shadow");
var baseStyleOverlay$1 = defineStyle({
  bg: "blackAlpha.600",
  zIndex: "modal"
});
var baseStyleDialogContainer$1 = defineStyle(function (props) {
  var isCentered = props.isCentered,
    scrollBehavior = props.scrollBehavior;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: isCentered ? "center" : "flex-start",
    overflow: scrollBehavior === "inside" ? "hidden" : "auto",
    overscrollBehaviorY: "none"
  };
});
var baseStyleDialog$1 = defineStyle(function (props) {
  var isCentered = props.isCentered,
    scrollBehavior = props.scrollBehavior;
  return _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({
    borderRadius: "md",
    color: "inherit",
    my: isCentered ? "auto" : "16",
    mx: isCentered ? "auto" : void 0,
    zIndex: "modal",
    maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0
  }, $bg$6.variable, "colors.white"), $shadow$1.variable, "shadows.lg"), "_dark", _defineProperty$3(_defineProperty$3({}, $bg$6.variable, "colors.gray.700"), $shadow$1.variable, "shadows.dark-lg")), "bg", $bg$6.reference), "boxShadow", $shadow$1.reference);
});
var baseStyleHeader$2 = defineStyle({
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
});
var baseStyleCloseButton$2 = defineStyle({
  position: "absolute",
  top: "2",
  insetEnd: "3"
});
var baseStyleBody$2 = defineStyle(function (props) {
  var scrollBehavior = props.scrollBehavior;
  return {
    px: "6",
    py: "2",
    flex: "1",
    overflow: scrollBehavior === "inside" ? "auto" : void 0
  };
});
var baseStyleFooter$2 = defineStyle({
  px: "6",
  py: "4"
});
var baseStyle$z = definePartsStyle$c(function (props) {
  return {
    overlay: baseStyleOverlay$1,
    dialogContainer: runIfFn$1(baseStyleDialogContainer$1, props),
    dialog: runIfFn$1(baseStyleDialog$1, props),
    header: baseStyleHeader$2,
    closeButton: baseStyleCloseButton$2,
    body: runIfFn$1(baseStyleBody$2, props),
    footer: baseStyleFooter$2
  };
});
function getSize$3(value) {
  if (value === "full") {
    return definePartsStyle$c({
      dialog: {
        maxW: "100vw",
        minH: "$100vh",
        my: "0",
        borderRadius: "0"
      }
    });
  }
  return definePartsStyle$c({
    dialog: {
      maxW: value
    }
  });
}
var sizes$f = {
  xs: getSize$3("xs"),
  sm: getSize$3("sm"),
  md: getSize$3("md"),
  lg: getSize$3("lg"),
  xl: getSize$3("xl"),
  "2xl": getSize$3("2xl"),
  "3xl": getSize$3("3xl"),
  "4xl": getSize$3("4xl"),
  "5xl": getSize$3("5xl"),
  "6xl": getSize$3("6xl"),
  full: getSize$3("full")
};
var modalTheme = defineMultiStyleConfig$c({
  baseStyle: baseStyle$z,
  sizes: sizes$f,
  defaultProps: {
    size: "md"
  }
});

var _createMultiStyleConf$a = createMultiStyleConfigHelpers(numberInputAnatomy.keys),
  defineMultiStyleConfig$b = _createMultiStyleConf$a.defineMultiStyleConfig,
  definePartsStyle$b = _createMultiStyleConf$a.definePartsStyle;
var $stepperWidth = cssVar("number-input-stepper-width");
var $inputPadding = cssVar("number-input-input-padding");
var inputPaddingValue = calc($stepperWidth).add("0.5rem").toString();
var $bg$5 = cssVar("number-input-bg");
var $fg$3 = cssVar("number-input-color");
var $border$2 = cssVar("number-input-border-color");
var baseStyleRoot = defineStyle(_defineProperty$3(_defineProperty$3({}, $stepperWidth.variable, "sizes.6"), $inputPadding.variable, inputPaddingValue));
var baseStyleField = defineStyle(function (props) {
  var _a, _b;
  return (_b = (_a = runIfFn$1(inputTheme.baseStyle, props)) == null ? void 0 : _a.field) != null ? _b : {};
});
var baseStyleStepperGroup = defineStyle({
  width: $stepperWidth.reference
});
var baseStyleStepper = defineStyle(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({
  borderStart: "1px solid",
  borderStartColor: $border$2.reference,
  color: $fg$3.reference,
  bg: $bg$5.reference
}, $fg$3.variable, "colors.chakra-body-text"), $border$2.variable, "colors.chakra-border-color"), "_dark", _defineProperty$3(_defineProperty$3({}, $fg$3.variable, "colors.whiteAlpha.800"), $border$2.variable, "colors.whiteAlpha.300")), "_active", _defineProperty$3(_defineProperty$3({}, $bg$5.variable, "colors.gray.200"), "_dark", _defineProperty$3({}, $bg$5.variable, "colors.whiteAlpha.300"))), "_disabled", {
  opacity: 0.4,
  cursor: "not-allowed"
}));
var baseStyle$y = definePartsStyle$b(function (props) {
  var _a;
  return {
    root: baseStyleRoot,
    field: (_a = runIfFn$1(baseStyleField, props)) != null ? _a : {},
    stepperGroup: baseStyleStepperGroup,
    stepper: baseStyleStepper
  };
});
function getSize$2(size) {
  var _a, _b, _c;
  var sizeStyle = (_a = inputTheme.sizes) == null ? void 0 : _a[size];
  var radius = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  };
  var _fontSize = (_c = (_b = sizeStyle.field) == null ? void 0 : _b.fontSize) != null ? _c : "md";
  var fontSize = typography_default.fontSizes[_fontSize];
  return definePartsStyle$b({
    field: _objectSpread2$1(_objectSpread2$1({}, sizeStyle.field), {}, {
      paddingInlineEnd: $inputPadding.reference,
      verticalAlign: "top"
    }),
    stepper: {
      fontSize: calc(fontSize).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: radius[size]
      },
      _last: {
        borderBottomEndRadius: radius[size],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  });
}
var sizes$e = {
  xs: getSize$2("xs"),
  sm: getSize$2("sm"),
  md: getSize$2("md"),
  lg: getSize$2("lg")
};
var numberInputTheme = defineMultiStyleConfig$b({
  baseStyle: baseStyle$y,
  sizes: sizes$e,
  variants: inputTheme.variants,
  defaultProps: inputTheme.defaultProps
});

var _a$2;
var baseStyle$x = defineStyle(_objectSpread2$1(_objectSpread2$1({}, (_a$2 = inputTheme.baseStyle) == null ? void 0 : _a$2.field), {}, {
  textAlign: "center"
}));
var sizes$d = {
  lg: defineStyle({
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  }),
  md: defineStyle({
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  }),
  sm: defineStyle({
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  }),
  xs: defineStyle({
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  })
};
var _a2, _b;
var variants$p = {
  outline: defineStyle(function (props) {
    var _a3, _b2, _c;
    return (_c = (_b2 = runIfFn$1((_a3 = inputTheme.variants) == null ? void 0 : _a3.outline, props)) == null ? void 0 : _b2.field) != null ? _c : {};
  }),
  flushed: defineStyle(function (props) {
    var _a3, _b2, _c;
    return (_c = (_b2 = runIfFn$1((_a3 = inputTheme.variants) == null ? void 0 : _a3.flushed, props)) == null ? void 0 : _b2.field) != null ? _c : {};
  }),
  filled: defineStyle(function (props) {
    var _a3, _b2, _c;
    return (_c = (_b2 = runIfFn$1((_a3 = inputTheme.variants) == null ? void 0 : _a3.filled, props)) == null ? void 0 : _b2.field) != null ? _c : {};
  }),
  unstyled: (_b = (_a2 = inputTheme.variants) == null ? void 0 : _a2.unstyled.field) != null ? _b : {}
};
var pinInputTheme = defineStyleConfig({
  baseStyle: baseStyle$x,
  sizes: sizes$d,
  variants: variants$p,
  defaultProps: inputTheme.defaultProps
});

var _defineStyle;
var _createMultiStyleConf$9 = createMultiStyleConfigHelpers(popoverAnatomy.keys),
  defineMultiStyleConfig$a = _createMultiStyleConf$9.defineMultiStyleConfig,
  definePartsStyle$a = _createMultiStyleConf$9.definePartsStyle;
var $popperBg = cssVar("popper-bg");
var $arrowBg = cssVar("popper-arrow-bg");
var $arrowShadowColor = cssVar("popper-arrow-shadow-color");
var baseStylePopper = defineStyle({
  zIndex: 10
});
var baseStyleContent = defineStyle((_defineStyle = {}, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineStyle, $popperBg.variable, "colors.white"), "bg", $popperBg.reference), $arrowBg.variable, $popperBg.reference), $arrowShadowColor.variable, "colors.gray.200"), "_dark", _defineProperty$3(_defineProperty$3({}, $popperBg.variable, "colors.gray.700"), $arrowShadowColor.variable, "colors.whiteAlpha.300")), "width", "xs"), "border", "1px solid"), "borderColor", "inherit"), "borderRadius", "md"), "boxShadow", "sm"), _defineProperty$3(_defineProperty$3(_defineStyle, "zIndex", "inherit"), "_focusVisible", {
  outline: 0,
  boxShadow: "outline"
})));
var baseStyleHeader$1 = defineStyle({
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
});
var baseStyleBody$1 = defineStyle({
  px: 3,
  py: 2
});
var baseStyleFooter$1 = defineStyle({
  px: 3,
  py: 2,
  borderTopWidth: "1px"
});
var baseStyleCloseButton$1 = defineStyle({
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
});
var baseStyle$w = definePartsStyle$a({
  popper: baseStylePopper,
  content: baseStyleContent,
  header: baseStyleHeader$1,
  body: baseStyleBody$1,
  footer: baseStyleFooter$1,
  closeButton: baseStyleCloseButton$1
});
var popoverTheme = defineMultiStyleConfig$a({
  baseStyle: baseStyle$w
});

var _createMultiStyleConf$8 = createMultiStyleConfigHelpers(drawerAnatomy.keys),
  definePartsStyle$9 = _createMultiStyleConf$8.definePartsStyle,
  defineMultiStyleConfig$9 = _createMultiStyleConf$8.defineMultiStyleConfig;
var $bg$4 = cssVar$1("drawer-bg");
var $bs = cssVar$1("drawer-box-shadow");
function getSize$1(value) {
  if (value === "full") {
    return definePartsStyle$9({
      dialog: {
        maxW: "100vw",
        h: "100vh"
      }
    });
  }
  return definePartsStyle$9({
    dialog: {
      maxW: value
    }
  });
}
var baseStyleOverlay = defineStyle({
  bg: "blackAlpha.600",
  zIndex: "modal"
});
var baseStyleDialogContainer = defineStyle({
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
});
var baseStyleDialog = defineStyle(function (props) {
  var isFullHeight = props.isFullHeight;
  return _objectSpread2$1(_objectSpread2$1({}, isFullHeight && {
    height: "100vh"
  }), {}, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({
    zIndex: "modal",
    maxH: "100vh",
    color: "inherit"
  }, $bg$4.variable, "colors.white"), $bs.variable, "shadows.lg"), "_dark", _defineProperty$3(_defineProperty$3({}, $bg$4.variable, "colors.gray.700"), $bs.variable, "shadows.dark-lg")), "bg", $bg$4.reference), "boxShadow", $bs.reference));
});
var baseStyleHeader = defineStyle({
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
});
var baseStyleCloseButton = defineStyle({
  position: "absolute",
  top: "2",
  insetEnd: "3"
});
var baseStyleBody = defineStyle({
  px: "6",
  py: "2",
  flex: "1",
  overflow: "auto"
});
var baseStyleFooter = defineStyle({
  px: "6",
  py: "4"
});
var baseStyle$v = definePartsStyle$9(function (props) {
  return {
    overlay: baseStyleOverlay,
    dialogContainer: baseStyleDialogContainer,
    dialog: runIfFn$1(baseStyleDialog, props),
    header: baseStyleHeader,
    closeButton: baseStyleCloseButton,
    body: baseStyleBody,
    footer: baseStyleFooter
  };
});
var sizes$c = {
  xs: getSize$1("xs"),
  sm: getSize$1("md"),
  md: getSize$1("lg"),
  lg: getSize$1("2xl"),
  xl: getSize$1("4xl"),
  full: getSize$1("full")
};
var drawerTheme = defineMultiStyleConfig$9({
  baseStyle: baseStyle$v,
  sizes: sizes$c,
  defaultProps: {
    size: "xs"
  }
});

// src/components/editable.ts
var _createMultiStyleConf$7 = createMultiStyleConfigHelpers(editableAnatomy.keys),
  definePartsStyle$8 = _createMultiStyleConf$7.definePartsStyle,
  defineMultiStyleConfig$8 = _createMultiStyleConf$7.defineMultiStyleConfig;
var baseStylePreview = defineStyle({
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal"
});
var baseStyleInput = defineStyle({
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: {
    boxShadow: "outline"
  },
  _placeholder: {
    opacity: 0.6
  }
});
var baseStyleTextarea = defineStyle({
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: {
    boxShadow: "outline"
  },
  _placeholder: {
    opacity: 0.6
  }
});
var baseStyle$u = definePartsStyle$8({
  preview: baseStylePreview,
  input: baseStyleInput,
  textarea: baseStyleTextarea
});
var editableTheme = defineMultiStyleConfig$8({
  baseStyle: baseStyle$u
});

var _createMultiStyleConf$6 = createMultiStyleConfigHelpers(formAnatomy.keys),
  definePartsStyle$7 = _createMultiStyleConf$6.definePartsStyle,
  defineMultiStyleConfig$7 = _createMultiStyleConf$6.defineMultiStyleConfig;
var $fg$2 = cssVar$1("form-control-color");
var baseStyleRequiredIndicator = defineStyle(_defineProperty$3(_defineProperty$3(_defineProperty$3({
  marginStart: "1"
}, $fg$2.variable, "colors.red.500"), "_dark", _defineProperty$3({}, $fg$2.variable, "colors.red.300")), "color", $fg$2.reference));
var baseStyleHelperText = defineStyle(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({
  mt: "2"
}, $fg$2.variable, "colors.gray.600"), "_dark", _defineProperty$3({}, $fg$2.variable, "colors.whiteAlpha.600")), "color", $fg$2.reference), "lineHeight", "normal"), "fontSize", "sm"));
var baseStyle$t = definePartsStyle$7({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: baseStyleRequiredIndicator,
  helperText: baseStyleHelperText
});
var formTheme = defineMultiStyleConfig$7({
  baseStyle: baseStyle$t
});

var _createMultiStyleConf$5 = createMultiStyleConfigHelpers(formErrorAnatomy.keys),
  definePartsStyle$6 = _createMultiStyleConf$5.definePartsStyle,
  defineMultiStyleConfig$6 = _createMultiStyleConf$5.defineMultiStyleConfig;
var $fg$1 = cssVar$1("form-error-color");
var baseStyleText = defineStyle(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fg$1.variable, "colors.red.500"), "_dark", _defineProperty$3({}, $fg$1.variable, "colors.red.300")), "color", $fg$1.reference), "mt", "2"), "fontSize", "sm"), "lineHeight", "normal"));
var baseStyleIcon$1 = defineStyle(_defineProperty$3(_defineProperty$3(_defineProperty$3({
  marginEnd: "0.5em"
}, $fg$1.variable, "colors.red.500"), "_dark", _defineProperty$3({}, $fg$1.variable, "colors.red.300")), "color", $fg$1.reference));
var baseStyle$s = definePartsStyle$6({
  text: baseStyleText,
  icon: baseStyleIcon$1
});
var formErrorTheme = defineMultiStyleConfig$6({
  baseStyle: baseStyle$s
});

// src/components/form-label.ts
var baseStyle$r = defineStyle({
  fontSize: "md",
  marginEnd: "3",
  mb: "2",
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
});
var formLabelTheme = defineStyleConfig({
  baseStyle: baseStyle$r
});

// src/components/heading.ts
var baseStyle$q = defineStyle({
  fontFamily: "heading",
  fontWeight: "bold"
});
var sizes$b = {
  "4xl": defineStyle({
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  }),
  "3xl": defineStyle({
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  }),
  "2xl": defineStyle({
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  }),
  xl: defineStyle({
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  }),
  lg: defineStyle({
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  }),
  md: defineStyle({
    fontSize: "xl",
    lineHeight: 1.2
  }),
  sm: defineStyle({
    fontSize: "md",
    lineHeight: 1.2
  }),
  xs: defineStyle({
    fontSize: "sm",
    lineHeight: 1.2
  })
};
var headingTheme = defineStyleConfig({
  baseStyle: baseStyle$q,
  sizes: sizes$b,
  defaultProps: {
    size: "xl"
  }
});

var _createMultiStyleConf$4 = createMultiStyleConfigHelpers(breadcrumbAnatomy.keys),
  defineMultiStyleConfig$5 = _createMultiStyleConf$4.defineMultiStyleConfig,
  definePartsStyle$5 = _createMultiStyleConf$4.definePartsStyle;
var $decor = cssVar$1("breadcrumb-link-decor");
var baseStyleLink = defineStyle(_defineProperty$3(_defineProperty$3({
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  outline: "none",
  color: "inherit",
  textDecoration: $decor.reference
}, $decor.variable, "none"), "&:not([aria-current=page])", {
  cursor: "pointer",
  _hover: _defineProperty$3({}, $decor.variable, "underline"),
  _focusVisible: {
    boxShadow: "outline"
  }
}));
var baseStyle$p = definePartsStyle$5({
  link: baseStyleLink
});
var breadcrumbTheme = defineMultiStyleConfig$5({
  baseStyle: baseStyle$p
});

var baseStyle$o = defineStyle({
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
});
var variantGhost = defineStyle(function (props) {
  var c = props.colorScheme,
    theme = props.theme;
  if (c === "gray") {
    return {
      color: mode("gray.800", "whiteAlpha.900")(props),
      _hover: {
        bg: mode("gray.100", "whiteAlpha.200")(props)
      },
      _active: {
        bg: mode("gray.200", "whiteAlpha.300")(props)
      }
    };
  }
  var darkHoverBg = transparentize("".concat(c, ".200"), 0.12)(theme);
  var darkActiveBg = transparentize("".concat(c, ".200"), 0.24)(theme);
  return {
    color: mode("".concat(c, ".600"), "".concat(c, ".200"))(props),
    bg: "transparent",
    _hover: {
      bg: mode("".concat(c, ".50"), darkHoverBg)(props)
    },
    _active: {
      bg: mode("".concat(c, ".100"), darkActiveBg)(props)
    }
  };
});
var variantOutline = defineStyle(function (props) {
  var c = props.colorScheme;
  var borderColor = mode("gray.200", "whiteAlpha.300")(props);
  return _objectSpread2$1({
    border: "1px solid",
    borderColor: c === "gray" ? borderColor : "currentColor",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": {
      marginEnd: "-1px"
    },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": {
      marginBottom: "-1px"
    }
  }, runIfFn$1(variantGhost, props));
});
var accessibleColorMap = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
};
var variantSolid$3 = defineStyle(function (props) {
  var _a;
  var c = props.colorScheme;
  if (c === "gray") {
    var bg2 = mode("gray.100", "whiteAlpha.200")(props);
    return {
      bg: bg2,
      color: mode("gray.800", "whiteAlpha.900")(props),
      _hover: {
        bg: mode("gray.200", "whiteAlpha.300")(props),
        _disabled: {
          bg: bg2
        }
      },
      _active: {
        bg: mode("gray.300", "whiteAlpha.400")(props)
      }
    };
  }
  var _ref = (_a = accessibleColorMap[c]) != null ? _a : {},
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? "".concat(c, ".500") : _ref$bg,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "white" : _ref$color,
    _ref$hoverBg = _ref.hoverBg,
    hoverBg = _ref$hoverBg === void 0 ? "".concat(c, ".600") : _ref$hoverBg,
    _ref$activeBg = _ref.activeBg,
    activeBg = _ref$activeBg === void 0 ? "".concat(c, ".700") : _ref$activeBg;
  var background = mode(bg, "".concat(c, ".200"))(props);
  return {
    bg: background,
    color: mode(color, "gray.800")(props),
    _hover: {
      bg: mode(hoverBg, "".concat(c, ".300"))(props),
      _disabled: {
        bg: background
      }
    },
    _active: {
      bg: mode(activeBg, "".concat(c, ".400"))(props)
    }
  };
});
var variantLink = defineStyle(function (props) {
  var c = props.colorScheme;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: mode("".concat(c, ".500"), "".concat(c, ".200"))(props),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: mode("".concat(c, ".700"), "".concat(c, ".500"))(props)
    }
  };
});
var variantUnstyled = defineStyle({
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: "0",
  p: "0"
});
var variants$o = {
  ghost: variantGhost,
  outline: variantOutline,
  solid: variantSolid$3,
  link: variantLink,
  unstyled: variantUnstyled
};
var sizes$a = {
  lg: defineStyle({
    h: "12",
    minW: "12",
    fontSize: "lg",
    px: "6"
  }),
  md: defineStyle({
    h: "10",
    minW: "10",
    fontSize: "md",
    px: "4"
  }),
  sm: defineStyle({
    h: "8",
    minW: "8",
    fontSize: "sm",
    px: "3"
  }),
  xs: defineStyle({
    h: "6",
    minW: "6",
    fontSize: "xs",
    px: "2"
  })
};
var buttonTheme = defineStyleConfig({
  baseStyle: baseStyle$o,
  variants: variants$o,
  sizes: sizes$a,
  defaultProps: {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
  }
});

var _createMultiStyleConf$3 = createMultiStyleConfigHelpers(cardAnatomy.keys),
  definePartsStyle$4 = _createMultiStyleConf$3.definePartsStyle,
  defineMultiStyleConfig$4 = _createMultiStyleConf$3.defineMultiStyleConfig;
var $bg$3 = cssVar$1("card-bg");
var $padding = cssVar$1("card-padding");
var $shadow = cssVar$1("card-shadow");
var $radius = cssVar$1("card-radius");
var $border$1 = cssVar$1("card-border-width", "0");
var $borderColor = cssVar$1("card-border-color");
var baseStyle$n = definePartsStyle$4({
  container: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $bg$3.variable, "colors.chakra-body-bg"), "backgroundColor", $bg$3.reference), "boxShadow", $shadow.reference), "borderRadius", $radius.reference), "color", "chakra-body-text"), "borderWidth", $border$1.reference), "borderColor", $borderColor.reference),
  body: {
    padding: $padding.reference,
    flex: "1 1 0%"
  },
  header: {
    padding: $padding.reference
  },
  footer: {
    padding: $padding.reference
  }
});
var sizes$9 = {
  sm: definePartsStyle$4({
    container: _defineProperty$3(_defineProperty$3({}, $radius.variable, "radii.base"), $padding.variable, "space.3")
  }),
  md: definePartsStyle$4({
    container: _defineProperty$3(_defineProperty$3({}, $radius.variable, "radii.md"), $padding.variable, "space.5")
  }),
  lg: definePartsStyle$4({
    container: _defineProperty$3(_defineProperty$3({}, $radius.variable, "radii.xl"), $padding.variable, "space.7")
  })
};
var variants$n = {
  elevated: definePartsStyle$4({
    container: _defineProperty$3(_defineProperty$3({}, $shadow.variable, "shadows.base"), "_dark", _defineProperty$3({}, $bg$3.variable, "colors.gray.700"))
  }),
  outline: definePartsStyle$4({
    container: _defineProperty$3(_defineProperty$3({}, $border$1.variable, "1px"), $borderColor.variable, "colors.chakra-border-color")
  }),
  filled: definePartsStyle$4({
    container: _defineProperty$3({}, $bg$3.variable, "colors.chakra-subtle-bg")
  }),
  unstyled: {
    body: _defineProperty$3({}, $padding.variable, 0),
    header: _defineProperty$3({}, $padding.variable, 0),
    footer: _defineProperty$3({}, $padding.variable, 0)
  }
};
var cardTheme = defineMultiStyleConfig$4({
  baseStyle: baseStyle$n,
  variants: variants$n,
  sizes: sizes$9,
  defaultProps: {
    variant: "elevated",
    size: "md"
  }
});

var $size$1 = cssVar("close-button-size");
var $bg$2 = cssVar("close-button-bg");
var baseStyle$m = defineStyle({
  w: [$size$1.reference],
  h: [$size$1.reference],
  borderRadius: "md",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: _defineProperty$3(_defineProperty$3({}, $bg$2.variable, "colors.blackAlpha.100"), "_dark", _defineProperty$3({}, $bg$2.variable, "colors.whiteAlpha.100")),
  _active: _defineProperty$3(_defineProperty$3({}, $bg$2.variable, "colors.blackAlpha.200"), "_dark", _defineProperty$3({}, $bg$2.variable, "colors.whiteAlpha.200")),
  _focusVisible: {
    boxShadow: "outline"
  },
  bg: $bg$2.reference
});
var sizes$8 = {
  lg: defineStyle(_defineProperty$3(_defineProperty$3({}, $size$1.variable, "sizes.10"), "fontSize", "md")),
  md: defineStyle(_defineProperty$3(_defineProperty$3({}, $size$1.variable, "sizes.8"), "fontSize", "xs")),
  sm: defineStyle(_defineProperty$3(_defineProperty$3({}, $size$1.variable, "sizes.6"), "fontSize", "2xs"))
};
var closeButtonTheme = defineStyleConfig({
  baseStyle: baseStyle$m,
  sizes: sizes$8,
  defaultProps: {
    size: "md"
  }
});

var variants$m = badgeTheme.variants,
  defaultProps$c = badgeTheme.defaultProps;
var baseStyle$l = defineStyle({
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm",
  bg: vars.bg.reference,
  color: vars.color.reference,
  boxShadow: vars.shadow.reference
});
var codeTheme = defineStyleConfig({
  baseStyle: baseStyle$l,
  variants: variants$m,
  defaultProps: defaultProps$c
});

// src/components/container.ts
var baseStyle$k = defineStyle({
  w: "100%",
  mx: "auto",
  maxW: "prose",
  px: "4"
});
var containerTheme = defineStyleConfig({
  baseStyle: baseStyle$k
});

// src/components/divider.ts
var baseStyle$j = defineStyle({
  opacity: 0.6,
  borderColor: "inherit"
});
var variantSolid$2 = defineStyle({
  borderStyle: "solid"
});
var variantDashed = defineStyle({
  borderStyle: "dashed"
});
var variants$l = {
  solid: variantSolid$2,
  dashed: variantDashed
};
var dividerTheme = defineStyleConfig({
  baseStyle: baseStyle$j,
  variants: variants$l,
  defaultProps: {
    variant: "solid"
  }
});

// src/components/accordion.ts
var _createMultiStyleConf$2 = createMultiStyleConfigHelpers(accordionAnatomy$1.keys),
  definePartsStyle$3 = _createMultiStyleConf$2.definePartsStyle,
  defineMultiStyleConfig$3 = _createMultiStyleConf$2.defineMultiStyleConfig;
var baseStyleContainer$1 = defineStyle({
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
});
var baseStyleButton = defineStyle({
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "md",
  _focusVisible: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: "4",
  py: "2"
});
var baseStylePanel = defineStyle({
  pt: "2",
  px: "4",
  pb: "5"
});
var baseStyleIcon = defineStyle({
  fontSize: "1.25em"
});
var baseStyle$i = definePartsStyle$3({
  container: baseStyleContainer$1,
  button: baseStyleButton,
  panel: baseStylePanel,
  icon: baseStyleIcon
});
var accordionTheme$1 = defineMultiStyleConfig$3({
  baseStyle: baseStyle$i
});

var _createMultiStyleConf$1 = createMultiStyleConfigHelpers(alertAnatomy.keys),
  definePartsStyle$2 = _createMultiStyleConf$1.definePartsStyle,
  defineMultiStyleConfig$2 = _createMultiStyleConf$1.defineMultiStyleConfig;
var $fg = cssVar$1("alert-fg");
var $bg$1 = cssVar$1("alert-bg");
var baseStyle$h = definePartsStyle$2({
  container: {
    bg: $bg$1.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: $fg.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: $fg.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
});
function getBg(props) {
  var theme = props.theme,
    c = props.colorScheme;
  var darkBg = transparentize("".concat(c, ".200"), 0.16)(theme);
  return {
    light: "colors.".concat(c, ".100"),
    dark: darkBg
  };
}
var variantSubtle = definePartsStyle$2(function (props) {
  var c = props.colorScheme;
  var bg = getBg(props);
  return {
    container: _defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fg.variable, "colors.".concat(c, ".600")), $bg$1.variable, bg.light), "_dark", _defineProperty$3(_defineProperty$3({}, $fg.variable, "colors.".concat(c, ".200")), $bg$1.variable, bg.dark))
  };
});
var variantLeftAccent = definePartsStyle$2(function (props) {
  var c = props.colorScheme;
  var bg = getBg(props);
  return {
    container: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fg.variable, "colors.".concat(c, ".600")), $bg$1.variable, bg.light), "_dark", _defineProperty$3(_defineProperty$3({}, $fg.variable, "colors.".concat(c, ".200")), $bg$1.variable, bg.dark)), "paddingStart", "3"), "borderStartWidth", "4px"), "borderStartColor", $fg.reference)
  };
});
var variantTopAccent = definePartsStyle$2(function (props) {
  var c = props.colorScheme;
  var bg = getBg(props);
  return {
    container: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fg.variable, "colors.".concat(c, ".600")), $bg$1.variable, bg.light), "_dark", _defineProperty$3(_defineProperty$3({}, $fg.variable, "colors.".concat(c, ".200")), $bg$1.variable, bg.dark)), "pt", "2"), "borderTopWidth", "4px"), "borderTopColor", $fg.reference)
  };
});
var variantSolid$1 = definePartsStyle$2(function (props) {
  var c = props.colorScheme;
  return {
    container: _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, $fg.variable, "colors.white"), $bg$1.variable, "colors.".concat(c, ".600")), "_dark", _defineProperty$3(_defineProperty$3({}, $fg.variable, "colors.gray.900"), $bg$1.variable, "colors.".concat(c, ".200"))), "color", $fg.reference)
  };
});
var variants$k = {
  subtle: variantSubtle,
  "left-accent": variantLeftAccent,
  "top-accent": variantTopAccent,
  solid: variantSolid$1
};
var alertTheme = defineMultiStyleConfig$2({
  baseStyle: baseStyle$h,
  variants: variants$k,
  defaultProps: {
    variant: "subtle",
    colorScheme: "blue"
  }
});

var _createMultiStyleConf = createMultiStyleConfigHelpers(avatarAnatomy.keys),
  definePartsStyle$1 = _createMultiStyleConf.definePartsStyle,
  defineMultiStyleConfig$1 = _createMultiStyleConf.defineMultiStyleConfig;
var $border = cssVar$1("avatar-border-color");
var $bg = cssVar$1("avatar-bg");
var $fs = cssVar$1("avatar-font-size");
var $size = cssVar$1("avatar-size");
var baseStyleBadge = defineStyle(_defineProperty$3(_defineProperty$3({
  borderRadius: "full",
  border: "0.2em solid",
  borderColor: $border.reference
}, $border.variable, "white"), "_dark", _defineProperty$3({}, $border.variable, "colors.gray.800")));
var baseStyleExcessLabel = defineStyle(_defineProperty$3(_defineProperty$3({
  bg: $bg.reference,
  fontSize: $fs.reference,
  width: $size.reference,
  height: $size.reference,
  lineHeight: "1"
}, $bg.variable, "colors.gray.200"), "_dark", _defineProperty$3({}, $bg.variable, "colors.whiteAlpha.400")));
var baseStyleContainer = defineStyle(function (props) {
  var name = props.name,
    theme = props.theme;
  var bg = name ? randomColor({
    string: name
  }) : "colors.gray.400";
  var isBgDark = isDark(bg)(theme);
  var color = "white";
  if (!isBgDark) color = "gray.800";
  return _defineProperty$3(_defineProperty$3({
    bg: $bg.reference,
    fontSize: $fs.reference,
    color: color,
    borderColor: $border.reference,
    verticalAlign: "top",
    width: $size.reference,
    height: $size.reference,
    "&:not([data-loaded])": _defineProperty$3({}, $bg.variable, bg)
  }, $border.variable, "colors.white"), "_dark", _defineProperty$3({}, $border.variable, "colors.gray.800"));
});
var baseStyleLabel = defineStyle({
  fontSize: $fs.reference,
  lineHeight: "1"
});
var baseStyle$g = definePartsStyle$1(function (props) {
  return {
    badge: runIfFn$1(baseStyleBadge, props),
    excessLabel: runIfFn$1(baseStyleExcessLabel, props),
    container: runIfFn$1(baseStyleContainer, props),
    label: baseStyleLabel
  };
});
function getSize(size) {
  var themeSize = size !== "100%" ? sizes_default[size] : void 0;
  return definePartsStyle$1({
    container: _defineProperty$3(_defineProperty$3({}, $size.variable, themeSize != null ? themeSize : size), $fs.variable, "calc(".concat(themeSize != null ? themeSize : size, " / 2.5)")),
    excessLabel: _defineProperty$3(_defineProperty$3({}, $size.variable, themeSize != null ? themeSize : size), $fs.variable, "calc(".concat(themeSize != null ? themeSize : size, " / 2.5)"))
  });
}
var sizes$7 = {
  "2xs": getSize(4),
  xs: getSize(6),
  sm: getSize(8),
  md: getSize(12),
  lg: getSize(16),
  xl: getSize(24),
  "2xl": getSize(32),
  full: getSize("100%")
};
var avatarTheme = defineMultiStyleConfig$1({
  baseStyle: baseStyle$g,
  sizes: sizes$7,
  defaultProps: {
    size: "md"
  }
});

// src/components/index.ts
var components$2 = {
  Accordion: accordionTheme$1,
  Alert: alertTheme,
  Avatar: avatarTheme,
  Badge: badgeTheme,
  Breadcrumb: breadcrumbTheme,
  Button: buttonTheme,
  Checkbox: checkboxTheme,
  CloseButton: closeButtonTheme,
  Code: codeTheme,
  Container: containerTheme,
  Divider: dividerTheme,
  Drawer: drawerTheme,
  Editable: editableTheme,
  Form: formTheme,
  FormError: formErrorTheme,
  FormLabel: formLabelTheme,
  Heading: headingTheme,
  Input: inputTheme,
  Kbd: kbdTheme,
  Link: linkTheme,
  List: listTheme,
  Menu: menuTheme,
  Modal: modalTheme,
  NumberInput: numberInputTheme,
  PinInput: pinInputTheme,
  Popover: popoverTheme,
  Progress: progressTheme,
  Radio: radioTheme,
  Select: selectTheme,
  Skeleton: skeletonTheme,
  SkipLink: skipLinkTheme,
  Slider: sliderTheme,
  Spinner: spinnerTheme,
  Stat: statTheme,
  Switch: switchTheme,
  Table: tableTheme,
  Tabs: tabsTheme,
  Tag: tagTheme,
  Textarea: textareaTheme,
  Tooltip: tooltipTheme,
  Card: cardTheme,
  Stepper: stepperTheme
};

// src/semantic-tokens.ts
var semanticTokens = {
  colors: {
    "chakra-body-text": {
      _light: "gray.800",
      _dark: "whiteAlpha.900"
    },
    "chakra-body-bg": {
      _light: "white",
      _dark: "gray.800"
    },
    "chakra-border-color": {
      _light: "gray.200",
      _dark: "whiteAlpha.300"
    },
    "chakra-inverse-text": {
      _light: "white",
      _dark: "gray.800"
    },
    "chakra-subtle-bg": {
      _light: "gray.100",
      _dark: "gray.700"
    },
    "chakra-subtle-text": {
      _light: "gray.600",
      _dark: "gray.400"
    },
    "chakra-placeholder-color": {
      _light: "gray.500",
      _dark: "whiteAlpha.400"
    }
  }
};

// src/styles.ts
var styles$3 = {
  global: {
    body: {
      fontFamily: "body",
      color: "chakra-body-text",
      bg: "chakra-body-bg",
      transitionProperty: "background-color",
      transitionDuration: "normal",
      lineHeight: "base"
    },
    "*::placeholder": {
      color: "chakra-placeholder-color"
    },
    "*, *::before, &::after": {
      borderColor: "chakra-border-color"
    }
  }
};

// src/index.ts
var direction = "ltr";
var config = {
  useSystemColorMode: false,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
};
var theme$1 = _objectSpread2$1(_objectSpread2$1({
  semanticTokens: semanticTokens,
  direction: direction
}, foundations), {}, {
  components: components$2,
  styles: styles$3,
  config: config
});
_objectSpread2$1(_objectSpread2$1({
  semanticTokens: semanticTokens,
  direction: direction,
  components: {}
}, foundations), {}, {
  styles: styles$3,
  config: config
});

function isFunction$1(value) {
  return typeof value === "function";
}
function pipe$1() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (v) {
    return fns.reduce(function (a, b) {
      return b(a);
    }, v);
  };
}
var createExtendTheme = function createExtendTheme(theme2) {
  return function extendTheme2() {
    for (var _len2 = arguments.length, extensions = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      extensions[_key2] = arguments[_key2];
    }
    var overrides = [].concat(extensions);
    var activeTheme = extensions[extensions.length - 1];
    if (isChakraTheme(activeTheme) &&
    // this ensures backward compatibility
    // previously only `extendTheme(override, activeTheme?)` was allowed
    overrides.length > 1) {
      overrides = overrides.slice(0, overrides.length - 1);
    } else {
      activeTheme = theme2;
    }
    return pipe$1.apply(void 0, _toConsumableArray$1(overrides.map(function (extension) {
      return function (prevTheme) {
        return isFunction$1(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension);
      };
    })))(activeTheme);
  };
};
var extendTheme = createExtendTheme(theme$1);
function mergeThemeOverride() {
  for (var _len3 = arguments.length, overrides = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    overrides[_key3] = arguments[_key3];
  }
  return mergeWith.apply(void 0, [{}].concat(overrides, [mergeThemeCustomizer]));
}
function mergeThemeCustomizer(source, override, key, object) {
  if ((isFunction$1(source) || isFunction$1(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
    return function () {
      var sourceValue = isFunction$1(source) ? source.apply(void 0, arguments) : source;
      var overrideValue = isFunction$1(override) ? override.apply(void 0, arguments) : override;
      return mergeWith({}, sourceValue, overrideValue, mergeThemeCustomizer);
    };
  }
  return void 0;
}

function canUseDOM$1() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var isBrowser$5 = /* @__PURE__ */canUseDOM$1();

function omit$4(object, keys) {
  var result = {};
  Object.keys(object).forEach(function (key) {
    if (keys.includes(key)) return;
    result[key] = object[key];
  });
  return result;
}
function get(obj, path, fallback, index) {
  var key = typeof path === "string" ? path.split(".") : [path];
  for (index = 0; index < key.length; index += 1) {
    if (!obj) break;
    obj = obj[key[index]];
  }
  return obj === void 0 ? fallback : obj;
}
var memoize$1 = function memoize(fn) {
  var cache = /* @__PURE__ */new WeakMap();
  var memoizedFn = function memoizedFn(obj, path, fallback, index) {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }
    if (!cache.has(obj)) {
      cache.set(obj, /* @__PURE__ */new Map());
    }
    var map = cache.get(obj);
    if (map.has(path)) {
      return map.get(path);
    }
    var value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };
  return memoizedFn;
};
var memoizedGet = memoize$1(get);
function objectFilter(object, fn) {
  var result = {};
  Object.keys(object).forEach(function (key) {
    var value = object[key];
    var shouldPass = fn(value, key, object);
    if (shouldPass) {
      result[key] = value;
    }
  });
  return result;
}
var filterUndefined = function filterUndefined(object) {
  return objectFilter(object, function (val) {
    return val !== null && val !== void 0;
  });
};

function isFunction(value) {
  return typeof value === "function";
}
process.env.NODE_ENV !== "production";
process.env.NODE_ENV === "test";

// src/function.ts
function runIfFn(valueOrFn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return isFunction(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
function callAllHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return function func(event) {
    fns.some(function (fn) {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}

var reactFastCompare;
var hasRequiredReactFastCompare;
function requireReactFastCompare() {
  if (hasRequiredReactFastCompare) return reactFastCompare;
  hasRequiredReactFastCompare = 1;
  var hasElementType = typeof Element !== 'undefined';
  var hasMap = typeof Map === 'function';
  var hasSet = typeof Set === 'function';
  var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

  // Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

  function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && _typeof$1(a) == 'object' && _typeof$1(b) == 'object') {
      if (a.constructor !== b.constructor) return false;
      var length, i, keys;
      if (Array.isArray(a)) {
        length = a.length;
        if (length != b.length) return false;
        for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
        return true;
      }

      // START: Modifications:
      // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
      //    to co-exist with es5.
      // 2. Replace `for of` with es5 compliant iteration using `for`.
      //    Basically, take:
      //
      //    ```js
      //    for (i of a.entries())
      //      if (!b.has(i[0])) return false;
      //    ```
      //
      //    ... and convert to:
      //
      //    ```js
      //    it = a.entries();
      //    while (!(i = it.next()).done)
      //      if (!b.has(i.value[0])) return false;
      //    ```
      //
      //    **Note**: `i` access switches to `i.value`.
      var it;
      if (hasMap && a instanceof Map && b instanceof Map) {
        if (a.size !== b.size) return false;
        it = a.entries();
        while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
        it = a.entries();
        while (!(i = it.next()).done) if (!equal(i.value[1], b.get(i.value[0]))) return false;
        return true;
      }
      if (hasSet && a instanceof Set && b instanceof Set) {
        if (a.size !== b.size) return false;
        it = a.entries();
        while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
        return true;
      }
      // END: Modifications

      if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
        length = a.length;
        if (length != b.length) return false;
        for (i = length; i-- !== 0;) if (a[i] !== b[i]) return false;
        return true;
      }
      if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
      // START: Modifications:
      // Apply guards for `Object.create(null)` handling. See:
      // - https://github.com/FormidableLabs/react-fast-compare/issues/64
      // - https://github.com/epoberezkin/fast-deep-equal/issues/49
      if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
      if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
      // END: Modifications

      keys = Object.keys(a);
      length = keys.length;
      if (length !== Object.keys(b).length) return false;
      for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
      // END: fast-deep-equal

      // START: react-fast-compare
      // custom handling for DOM elements
      if (hasElementType && a instanceof Element) return false;

      // custom handling for React/Preact
      for (i = length; i-- !== 0;) {
        if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
          // React-specific: avoid traversing React elements' _owner
          // Preact-specific: avoid traversing Preact elements' __v and __o
          //    __v = $_original / $_vnode
          //    __o = $_owner
          // These properties contain circular references and are not needed when
          // comparing the actual elements (and not their owners)
          // .$$typeof and ._store on just reasonable markers of elements

          continue;
        }

        // all other properties should be traversed as usual
        if (!equal(a[keys[i]], b[keys[i]])) return false;
      }
      // END: react-fast-compare

      // START: fast-deep-equal
      return true;
    }
    return a !== a && b !== b;
  }
  // end fast-deep-equal

  reactFastCompare = function isEqual(a, b) {
    try {
      return equal(a, b);
    } catch (error) {
      if ((error.message || '').match(/stack|recursion/i)) {
        // warn on circular references, don't crash
        // browsers give this different errors name and messages:
        // chrome/safari: "RangeError", "Maximum call stack size exceeded"
        // firefox: "InternalError", too much recursion"
        // edge: "Error", "Out of stack space"
        console.warn('react-fast-compare cannot handle circular refs');
        return false;
      }
      // some other error. we should definitely know about these
      throw error;
    }
  };
  return reactFastCompare;
}

var reactFastCompareExports = requireReactFastCompare();
var isEqual$1 = /*@__PURE__*/getDefaultExportFromCjs(reactFastCompareExports);

var _excluded$2l = ["styleConfig"];
function useStyleConfigImpl(themeKey) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a;
  var styleConfigProp = props.styleConfig,
    rest = _objectWithoutProperties$1(props, _excluded$2l);
  var _useChakra = useChakra(),
    theme = _useChakra.theme,
    colorMode = _useChakra.colorMode;
  var themeStyleConfig = themeKey ? memoizedGet(theme, "components.".concat(themeKey)) : void 0;
  var styleConfig = styleConfigProp || themeStyleConfig;
  var mergedProps = mergeWith({
    theme: theme,
    colorMode: colorMode
  }, (_a = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a : {}, filterUndefined(omit$4(rest, ["children"])));
  var stylesRef = useRef({});
  if (styleConfig) {
    var getStyles = resolveStyleConfig(styleConfig);
    var styles = getStyles(mergedProps);
    var isStyleEqual = isEqual$1(stylesRef.current, styles);
    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }
  return stylesRef.current;
}
function useStyleConfig(themeKey) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return useStyleConfigImpl(themeKey, props);
}
function useMultiStyleConfig(themeKey) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return useStyleConfigImpl(themeKey, props);
}

var allPropNames = /* @__PURE__ */new Set([].concat(_toConsumableArray$1(propNames), ["textStyle", "layerStyle", "apply", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"]));
var validHTMLProps = /* @__PURE__ */new Set(["htmlWidth", "htmlHeight", "htmlSize", "htmlTranslate"]);
function shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
}

// src/assign-after.ts
function assignAfter(target) {
  if (target == null) {
    throw new TypeError("Cannot convert undefined or null to object");
  }
  var result = _objectSpread2$1({}, target);
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
    var nextSource = _sources[_i];
    if (nextSource == null) continue;
    for (var nextKey in nextSource) {
      if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey)) continue;
      if (nextKey in result) delete result[nextKey];
      result[nextKey] = nextSource[nextKey];
    }
  }
  return result;
}

// src/compact.ts
function compact(object) {
  var clone = Object.assign({}, object);
  for (var key in clone) {
    if (clone[key] === void 0) delete clone[key];
  }
  return clone;
}

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);

var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }
  return shouldForwardProp;
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var isBrowser$4 = typeof document !== 'undefined';
var createStyled = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;
  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }
      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }
        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class

    var Styled = withEmotionCache$1(function (props, cache, ref) {
      var finalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key in props) {
          mergedProps[key] = props[key];
        }
        mergedProps.theme = useContext(ThemeContext$1);
      }
      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      var rules = insertStyles(cache, serialized, typeof finalTag === 'string');
      className += cache.key + "-" + serialized.name;
      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;
        if (
        // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      newProps.ref = ref;
      var ele = /*#__PURE__*/createElement(finalTag, newProps);
      if (!isBrowser$4 && rules !== undefined) {
        var _ref;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while (next !== undefined) {
          serializedNames += ' ' + next.name;
          next = next.next;
        }
        return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedNames, _ref.dangerouslySetInnerHTML = {
          __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
      }
      return ele;
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string

        return "." + targetClassName;
      }
    });
    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends$6({}, options, {}, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };
    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

var _excluded$2k = ["theme", "css", "__css", "sx"],
  _excluded2$g = ["baseStyle"];
var _a$1;
var emotion_styled = (_a$1 = newStyled["default"]) != null ? _a$1 : newStyled;
var toCSSObject = function toCSSObject(_ref) {
  var baseStyle = _ref.baseStyle;
  return function (props) {
    props.theme;
      var cssProp = props.css,
      __css = props.__css,
      sx = props.sx,
      rest = _objectWithoutProperties$1(props, _excluded$2k);
    var styleProps = objectFilter(rest, function (_, prop) {
      return isStyleProp(prop);
    });
    var finalBaseStyle = runIfFn(baseStyle, props);
    var finalStyles = assignAfter({}, __css, finalBaseStyle, filterUndefined(styleProps), sx);
    var computedCSS = css$3(finalStyles)(props.theme);
    return cssProp ? [computedCSS, cssProp] : computedCSS;
  };
};
function styled(component, options) {
  var _ref2 = options != null ? options : {},
    baseStyle = _ref2.baseStyle,
    styledOptions = _objectWithoutProperties$1(_ref2, _excluded2$g);
  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }
  var styleObject = toCSSObject({
    baseStyle: baseStyle
  });
  var Component = emotion_styled(component, styledOptions)(styleObject);
  var chakraComponent = /*#__PURE__*/React__default.forwardRef(function ChakraComponent(props, ref) {
    var _useColorMode = useColorMode(),
      colorMode = _useColorMode.colorMode,
      forced = _useColorMode.forced;
    return /*#__PURE__*/React__default.createElement(Component, _objectSpread2$1({
      ref: ref,
      "data-theme": forced ? colorMode : void 0
    }, props));
  });
  return chakraComponent;
}

// src/factory.ts
function factory() {
  var cache = /* @__PURE__ */new Map();
  return new Proxy(styled, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function apply(target, thisArg, argArray) {
      return styled.apply(void 0, _toConsumableArray$1(argArray));
    },
    /**
     * @example
     * <chakra.div />
     */
    get: function get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }
      return cache.get(element);
    }
  });
}
var chakra = factory();

function forwardRef(component) {
  return /*#__PURE__*/forwardRef$1(component);
}

// src/context.ts
function createContext() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$strict = options.strict,
    strict = _options$strict === void 0 ? true : _options$strict,
    _options$errorMessage = options.errorMessage,
    errorMessage = _options$errorMessage === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : _options$errorMessage,
    name = options.name;
  var Context = /*#__PURE__*/createContext$2(void 0);
  Context.displayName = name;
  function useContext$1() {
    var _a;
    var context = useContext(Context);
    if (!context && strict) {
      var error = new Error(errorMessage);
      error.name = "ContextError";
      (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext$1);
      throw error;
    }
    return context;
  }
  return [Context.Provider, useContext$1, Context];
}

function ThemeProvider$1(props) {
  var cssVarsRoot = props.cssVarsRoot,
    theme = props.theme,
    children = props.children;
  var computedTheme = useMemo(function () {
    return toCSSVar(theme);
  }, [theme]);
  return /* @__PURE__ */jsxRuntimeExports.jsxs(ThemeProvider$2, {
    theme: computedTheme,
    children: [/* @__PURE__ */jsxRuntimeExports.jsx(CSSVars, {
      root: cssVarsRoot
    }), children]
  });
}
function CSSVars(_ref) {
  var _ref$root = _ref.root,
    root = _ref$root === void 0 ? ":host, :root" : _ref$root;
  var selector = [root, "[data-theme]"].join(",");
  return /* @__PURE__ */jsxRuntimeExports.jsx(Global$1, {
    styles: function styles(theme) {
      return _defineProperty$3({}, selector, theme.__cssVars);
    }
  });
}
var _createContext$m = createContext({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
  }),
  _createContext2$m = _slicedToArray$1(_createContext$m, 2);
  _createContext2$m[0];
  _createContext2$m[1];
function GlobalStyle() {
  var _useColorMode = useColorMode(),
    colorMode = _useColorMode.colorMode;
  return /* @__PURE__ */jsxRuntimeExports.jsx(Global$1, {
    styles: function styles(theme) {
      var styleObjectOrFn = memoizedGet(theme, "styles.global");
      var globalStyles = runIfFn(styleObjectOrFn, {
        theme: theme,
        colorMode: colorMode
      });
      if (!globalStyles) return void 0;
      var styles = css$3(globalStyles)(theme);
      return styles;
    }
  });
}

var EnvironmentContext = /*#__PURE__*/createContext$2({
  getDocument: function getDocument() {
    return document;
  },
  getWindow: function getWindow() {
    return window;
  }
});
EnvironmentContext.displayName = "EnvironmentContext";
function useEnvironment() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    defer = _ref.defer;
  var _useReducer = useReducer(function (c) {
      return c + 1;
    }, 0),
    _useReducer2 = _slicedToArray$1(_useReducer, 2),
    forceUpdate = _useReducer2[1];
  useSafeLayoutEffect$2(function () {
    if (!defer) return;
    forceUpdate();
  }, [defer]);
  return useContext(EnvironmentContext);
}
function EnvironmentProvider(props) {
  var children = props.children,
    environmentProp = props.environment,
    disabled = props.disabled;
  var ref = useRef(null);
  var context = useMemo(function () {
    if (environmentProp) return environmentProp;
    return {
      getDocument: function getDocument() {
        var _a, _b;
        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
      },
      getWindow: function getWindow() {
        var _a, _b;
        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument.defaultView) != null ? _b : window;
      }
    };
  }, [environmentProp]);
  var showSpan = !disabled || !environmentProp;
  return /* @__PURE__ */jsxRuntimeExports.jsxs(EnvironmentContext.Provider, {
    value: context,
    children: [children, showSpan && /* @__PURE__ */jsxRuntimeExports.jsx("span", {
      id: "__chakra_env",
      hidden: true,
      ref: ref
    })]
  });
}
EnvironmentProvider.displayName = "EnvironmentProvider";

var ChakraProvider$1 = function ChakraProvider(props) {
  var children = props.children,
    colorModeManager = props.colorModeManager,
    portalZIndex = props.portalZIndex,
    resetScope = props.resetScope,
    _props$resetCSS = props.resetCSS,
    resetCSS = _props$resetCSS === void 0 ? true : _props$resetCSS,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? {} : _props$theme,
    environment = props.environment,
    cssVarsRoot = props.cssVarsRoot,
    disableEnvironment = props.disableEnvironment,
    disableGlobalStyle = props.disableGlobalStyle;
  var _children = /* @__PURE__ */jsxRuntimeExports.jsx(EnvironmentProvider, {
    environment: environment,
    disabled: disableEnvironment,
    children: children
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(ThemeProvider$1, {
    theme: theme,
    cssVarsRoot: cssVarsRoot,
    children: /* @__PURE__ */jsxRuntimeExports.jsxs(ColorModeProvider, {
      colorModeManager: colorModeManager,
      options: theme.config,
      children: [resetCSS ? /* @__PURE__ */jsxRuntimeExports.jsx(CSSReset, {
        scope: resetScope
      }) : /* @__PURE__ */jsxRuntimeExports.jsx(CSSPolyfill, {}), !disableGlobalStyle && /* @__PURE__ */jsxRuntimeExports.jsx(GlobalStyle, {}), portalZIndex ? /* @__PURE__ */jsxRuntimeExports.jsx(PortalManager, {
        zIndex: portalZIndex,
        children: _children
      }) : _children]
    })
  });
};

var findById = function findById(arr, id) {
  return arr.find(function (toast) {
    return toast.id === id;
  });
};
function findToast(toasts, id) {
  var position = getToastPosition(toasts, id);
  var index = position ? toasts[position].findIndex(function (toast) {
    return toast.id === id;
  }) : -1;
  return {
    position: position,
    index: index
  };
}
function getToastPosition(toasts, id) {
  for (var _i = 0, _Object$entries = Object.entries(toasts); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray$1(_Object$entries[_i], 2),
      position = _Object$entries$_i[0],
      values = _Object$entries$_i[1];
    if (findById(values, id)) {
      return position;
    }
  }
}
function getToastStyle(position) {
  var isRighty = position.includes("right");
  var isLefty = position.includes("left");
  var alignItems = "center";
  if (isRighty) alignItems = "flex-end";
  if (isLefty) alignItems = "flex-start";
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: alignItems
  };
}
function getToastListStyle(position) {
  var isTopOrBottom = position === "top" || position === "bottom";
  var margin = isTopOrBottom ? "0 auto" : void 0;
  var top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
  var bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
  var right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
  var left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
  return {
    position: "fixed",
    zIndex: "var(--toast-z-index, 5500)",
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin: margin,
    top: top,
    bottom: bottom,
    right: right,
    left: left
  };
}

function useCallbackRef$3(callback) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var callbackRef = useRef(callback);
  useEffect(function () {
    callbackRef.current = callback;
  });
  return useCallback(function () {
    var _a2;
    var _a;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_a = callbackRef.current) == null ? void 0 : (_a2 = _a).call.apply(_a2, [callbackRef].concat(args));
  }, deps);
}

function useTimeout(callback, delay) {
  var fn = useCallbackRef$3(callback);
  useEffect(function () {
    if (delay == null) return void 0;
    var timeoutId = null;
    timeoutId = window.setTimeout(function () {
      fn();
    }, delay);
    return function () {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [delay, fn]);
}

function useUpdateEffect(callback, deps) {
  var renderCycleRef = useRef(false);
  var effectCycleRef = useRef(false);
  useEffect(function () {
    var mounted = renderCycleRef.current;
    var run = mounted && effectCycleRef.current;
    if (run) {
      return callback();
    }
    effectCycleRef.current = true;
  }, deps);
  useEffect(function () {
    renderCycleRef.current = true;
    return function () {
      renderCycleRef.current = false;
    };
  }, []);
}

/**
 * @public
 */
var MotionConfigContext = /*#__PURE__*/createContext$2({
  transformPagePoint: function transformPagePoint(p) {
    return p;
  },
  isStatic: false,
  reducedMotion: "never"
});

var MotionContext = /*#__PURE__*/createContext$2({});

/**
 * @public
 */
var PresenceContext = /*#__PURE__*/createContext$2(null);

var isBrowser$3 = typeof document !== "undefined";

var useIsomorphicLayoutEffect$1 = isBrowser$3 ? useLayoutEffect : useEffect;

var LazyContext = /*#__PURE__*/createContext$2({
  strict: false
});

/**
 * Convert camelCase to dash-case properties.
 */
var camelToDash = function camelToDash(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};

var optimizedAppearDataId = "framerAppearId";
var optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

function useVisualElement(Component, visualState, props, createVisualElement) {
  var _useContext = useContext(MotionContext),
    parent = _useContext.visualElement;
  var lazyContext = useContext(LazyContext);
  var presenceContext = useContext(PresenceContext);
  var reducedMotionConfig = useContext(MotionConfigContext).reducedMotion;
  var visualElementRef = useRef();
  /**
   * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
   */
  createVisualElement = createVisualElement || lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component, {
      visualState: visualState,
      parent: parent,
      props: props,
      presenceContext: presenceContext,
      blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
      reducedMotionConfig: reducedMotionConfig
    });
  }
  var visualElement = visualElementRef.current;
  useInsertionEffect$1(function () {
    visualElement && visualElement.update(props, presenceContext);
  });
  /**
   * Cache this value as we want to know whether HandoffAppearAnimations
   * was present on initial render - it will be deleted after this.
   */
  var wantsHandoff = useRef(Boolean(props[optimizedAppearDataAttribute] && !window.HandoffComplete));
  useIsomorphicLayoutEffect$1(function () {
    if (!visualElement) return;
    visualElement.render();
    /**
     * Ideally this function would always run in a useEffect.
     *
     * However, if we have optimised appear animations to handoff from,
     * it needs to happen synchronously to ensure there's no flash of
     * incorrect styles in the event of a hydration error.
     *
     * So if we detect a situtation where optimised appear animations
     * are running, we use useLayoutEffect to trigger animations.
     */
    if (wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
  });
  useEffect(function () {
    if (!visualElement) return;
    visualElement.updateFeatures();
    if (!wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
    if (wantsHandoff.current) {
      wantsHandoff.current = false;
      // This ensures all future calls to animateChanges() will run in useEffect
      window.HandoffComplete = true;
    }
  });
  return visualElement;
}

function isRefObject$2(ref) {
  return ref && _typeof$1(ref) === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */
function useMotionRef(visualState, visualElement, externalRef) {
  return useCallback(function (instance) {
    instance && visualState.mount && visualState.mount(instance);
    if (visualElement) {
      instance ? visualElement.mount(instance) : visualElement.unmount();
    }
    if (externalRef) {
      if (typeof externalRef === "function") {
        externalRef(instance);
      } else if (isRefObject$2(externalRef)) {
        externalRef.current = instance;
      }
    }
  },
  /**
   * Only pass a new ref callback to React if we've received a visual element
   * factory. Otherwise we'll be mounting/remounting every time externalRef
   * or other dependencies change.
   */
  [visualElement]);
}

/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
  return typeof v === "string" || Array.isArray(v);
}

function isAnimationControls(v) {
  return v !== null && _typeof$1(v) === "object" && typeof v.start === "function";
}

var variantPriorityOrder = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"];
var variantProps = ["initial"].concat(variantPriorityOrder);

function isControllingVariants(props) {
  return isAnimationControls(props.animate) || variantProps.some(function (name) {
    return isVariantLabel(props[name]);
  });
}
function isVariantNode(props) {
  return Boolean(isControllingVariants(props) || props.variants);
}

function getCurrentTreeVariants(props, context) {
  if (isControllingVariants(props)) {
    var initial = props.initial,
      animate = props.animate;
    return {
      initial: initial === false || isVariantLabel(initial) ? initial : undefined,
      animate: isVariantLabel(animate) ? animate : undefined
    };
  }
  return props.inherit !== false ? context : {};
}

function useCreateMotionContext(props) {
  var _getCurrentTreeVarian = getCurrentTreeVariants(props, useContext(MotionContext)),
    initial = _getCurrentTreeVarian.initial,
    animate = _getCurrentTreeVarian.animate;
  return useMemo(function () {
    return {
      initial: initial,
      animate: animate
    };
  }, [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}

var featureProps = {
  animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
var featureDefinitions = {};
var _loop = function _loop(key) {
  featureDefinitions[key] = {
    isEnabled: function isEnabled(props) {
      return featureProps[key].some(function (name) {
        return !!props[name];
      });
    }
  };
};
for (var key in featureProps) {
  _loop(key);
}

function loadFeatures(features) {
  for (var key in features) {
    featureDefinitions[key] = _objectSpread2$1(_objectSpread2$1({}, featureDefinitions[key]), features[key]);
  }
}

var LayoutGroupContext = /*#__PURE__*/createContext$2({});

/**
 * Internal, exported only for usage in Framer
 */
var SwitchLayoutGroupContext = /*#__PURE__*/createContext$2({});

var motionComponentSymbol = Symbol["for"]("motionComponentSymbol");

/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */
function createMotionComponent(_ref) {
  var preloadedFeatures = _ref.preloadedFeatures,
    createVisualElement = _ref.createVisualElement,
    useRender = _ref.useRender,
    useVisualState = _ref.useVisualState,
    Component = _ref.Component;
  preloadedFeatures && loadFeatures(preloadedFeatures);
  function MotionComponent(props, externalRef) {
    /**
     * If we need to measure the element we load this functionality in a
     * separate class component in order to gain access to getSnapshotBeforeUpdate.
     */
    var MeasureLayout;
    var configAndProps = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, useContext(MotionConfigContext)), props), {}, {
      layoutId: useLayoutId(props)
    });
    var isStatic = configAndProps.isStatic;
    var context = useCreateMotionContext(props);
    var visualState = useVisualState(props, isStatic);
    if (!isStatic && isBrowser$3) {
      /**
       * Create a VisualElement for this component. A VisualElement provides a common
       * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
       * providing a way of rendering to these APIs outside of the React render loop
       * for more performant animations and interactions
       */
      context.visualElement = useVisualElement(Component, visualState, configAndProps, createVisualElement);
      /**
       * Load Motion gesture and animation features. These are rendered as renderless
       * components so each feature can optionally make use of React lifecycle methods.
       */
      var initialLayoutGroupConfig = useContext(SwitchLayoutGroupContext);
      var isStrict = useContext(LazyContext).strict;
      if (context.visualElement) {
        MeasureLayout = context.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
      }
    }
    /**
     * The mount order and hierarchy is specific to ensure our element ref
     * is hydrated by the time features fire their effects.
     */
    return /*#__PURE__*/React.createElement(MotionContext.Provider, {
      value: context
    }, MeasureLayout && context.visualElement ? (/*#__PURE__*/React.createElement(MeasureLayout, _objectSpread2$1({
      visualElement: context.visualElement
    }, configAndProps))) : null, useRender(Component, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
  }
  var ForwardRefComponent = /*#__PURE__*/forwardRef$1(MotionComponent);
  ForwardRefComponent[motionComponentSymbol] = Component;
  return ForwardRefComponent;
}
function useLayoutId(_ref2) {
  var layoutId = _ref2.layoutId;
  var layoutGroupId = useContext(LayoutGroupContext).id;
  return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}

/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */
function createMotionProxy(createConfig) {
  function custom(Component) {
    var customMotionComponentConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return createMotionComponent(createConfig(Component, customMotionComponentConfig));
  }
  if (typeof Proxy === "undefined") {
    return custom;
  }
  /**
   * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
   * Rather than generating them anew every render.
   */
  var componentCache = new Map();
  return new Proxy(custom, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function get(_target, key) {
      /**
       * If this element doesn't exist in the component cache, create it and cache.
       */
      if (!componentCache.has(key)) {
        componentCache.set(key, custom(key));
      }
      return componentCache.get(key);
    }
  });
}

/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */
var lowercaseSVGElements = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "switch", "symbol", "svg", "text", "tspan", "use", "view"];

function isSVGComponent(Component) {
  if (
  /**
   * If it's not a string, it's a custom React component. Currently we only support
   * HTML custom React components.
   */
  typeof Component !== "string" ||
  /**
   * If it contains a dash, the element is a custom HTML webcomponent.
   */
  Component.includes("-")) {
    return false;
  } else if (
  /**
   * If it's in our list of lowercase SVG tags, it's an SVG component
   */
  lowercaseSVGElements.indexOf(Component) > -1 ||
  /**
   * If it contains a capital letter, it's an SVG component
   */
  /[A-Z]/.test(Component)) {
    return true;
  }
  return false;
}

var scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}

/**
 * Generate a list of every possible transform key.
 */
var transformPropOrder = ["transformPerspective", "x", "y", "z", "translateX", "translateY", "translateZ", "scale", "scaleX", "scaleY", "rotate", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY"];
/**
 * A quick lookup for transform props.
 */
var transformProps = new Set(transformPropOrder);

function isForcedMotionValue(key, _ref) {
  var layout = _ref.layout,
    layoutId = _ref.layoutId;
  return transformProps.has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!scaleCorrectors[key] || key === "opacity");
}

var isMotionValue = function isMotionValue(value) {
  return Boolean(value && value.getVelocity);
};

var translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
var numTransforms = transformPropOrder.length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform(transform, _ref, transformIsDefault, transformTemplate) {
  var _ref$enableHardwareAc = _ref.enableHardwareAcceleration,
    enableHardwareAcceleration = _ref$enableHardwareAc === void 0 ? true : _ref$enableHardwareAc,
    _ref$allowTransformNo = _ref.allowTransformNone,
    allowTransformNone = _ref$allowTransformNo === void 0 ? true : _ref$allowTransformNo;
  // The transform string we're going to build into.
  var transformString = "";
  /**
   * Loop over all possible transforms in order, adding the ones that
   * are present to the transform string.
   */
  for (var i = 0; i < numTransforms; i++) {
    var key = transformPropOrder[i];
    if (transform[key] !== undefined) {
      var transformName = translateAlias[key] || key;
      transformString += "".concat(transformName, "(").concat(transform[key], ") ");
    }
  }
  if (enableHardwareAcceleration && !transform.z) {
    transformString += "translateZ(0)";
  }
  transformString = transformString.trim();
  // If we have a custom `transform` template, pass our transform values and
  // generated transformString to that before returning
  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
  } else if (allowTransformNone && transformIsDefault) {
    transformString = "none";
  }
  return transformString;
}

var checkStringStartsWith = function checkStringStartsWith(token) {
  return function (key) {
    return typeof key === "string" && key.startsWith(token);
  };
};
var isCSSVariableName = checkStringStartsWith("--");
var isCSSVariableToken = checkStringStartsWith("var(--");
var cssVariableRegex = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;

/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
var getValueAsType = function getValueAsType(value, type) {
  return type && typeof value === "number" ? type.transform(value) : value;
};

var clamp = function clamp(min, max, v) {
  return Math.min(Math.max(v, min), max);
};

var number = {
  test: function test(v) {
    return typeof v === "number";
  },
  parse: parseFloat,
  transform: function transform(v) {
    return v;
  }
};
var alpha = _objectSpread2$1(_objectSpread2$1({}, number), {}, {
  transform: function transform(v) {
    return clamp(0, 1, v);
  }
});
var scale$1 = _objectSpread2$1(_objectSpread2$1({}, number), {}, {
  "default": 1
});

/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */
// If this number is a decimal, make it just five decimal places
// to avoid exponents
var sanitize = function sanitize(v) {
  return Math.round(v * 100000) / 100000;
};
var floatRegex = /(-)?([\d]*\.?[\d])+/g;
var colorRegex = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
var singleColorRegex = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString(v) {
  return typeof v === "string";
}

var createUnitType = function createUnitType(unit) {
  return {
    test: function test(v) {
      return isString(v) && v.endsWith(unit) && v.split(" ").length === 1;
    },
    parse: parseFloat,
    transform: function transform(v) {
      return "".concat(v).concat(unit);
    }
  };
};
var degrees = createUnitType("deg");
var percent = createUnitType("%");
var px = createUnitType("px");
var vh = createUnitType("vh");
var vw = createUnitType("vw");
var progressPercentage = _objectSpread2$1(_objectSpread2$1({}, percent), {}, {
  parse: function parse(v) {
    return percent.parse(v) / 100;
  },
  transform: function transform(v) {
    return percent.transform(v * 100);
  }
});

var _int = _objectSpread2$1(_objectSpread2$1({}, number), {}, {
  transform: Math.round
});

var numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale: scale$1,
  scaleX: scale$1,
  scaleY: scale$1,
  scaleZ: scale$1,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: _int,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: _int
};

function buildHTMLStyles(state, latestValues, options, transformTemplate) {
  var style = state.style,
    vars = state.vars,
    transform = state.transform,
    transformOrigin = state.transformOrigin;
  // Track whether we encounter any transform or transformOrigin values.
  var hasTransform = false;
  var hasTransformOrigin = false;
  // Does the calculated transform essentially equal "none"?
  var transformIsNone = true;
  /**
   * Loop over all our latest animated values and decide whether to handle them
   * as a style or CSS variable.
   *
   * Transforms and transform origins are kept seperately for further processing.
   */
  for (var key in latestValues) {
    var value = latestValues[key];
    /**
     * If this is a CSS variable we don't do any further processing.
     */
    if (isCSSVariableName(key)) {
      vars[key] = value;
      continue;
    }
    // Convert the value to its default value type, ie 0 -> "0px"
    var valueType = numberValueTypes[key];
    var valueAsType = getValueAsType(value, valueType);
    if (transformProps.has(key)) {
      // If this is a transform, flag to enable further transform processing
      hasTransform = true;
      transform[key] = valueAsType;
      // If we already know we have a non-default transform, early return
      if (!transformIsNone) continue;
      // Otherwise check to see if this is a default transform
      if (value !== (valueType["default"] || 0)) transformIsNone = false;
    } else if (key.startsWith("origin")) {
      // If this is a transform origin, flag and enable further transform-origin processing
      hasTransformOrigin = true;
      transformOrigin[key] = valueAsType;
    } else {
      style[key] = valueAsType;
    }
  }
  if (!latestValues.transform) {
    if (hasTransform || transformTemplate) {
      style.transform = buildTransform(state.transform, options, transformIsNone, transformTemplate);
    } else if (style.transform) {
      /**
       * If we have previously created a transform but currently don't have any,
       * reset transform style to none.
       */
      style.transform = "none";
    }
  }
  /**
   * Build a transformOrigin style. Uses the same defaults as the browser for
   * undefined origins.
   */
  if (hasTransformOrigin) {
    var _transformOrigin$orig = transformOrigin.originX,
      originX = _transformOrigin$orig === void 0 ? "50%" : _transformOrigin$orig,
      _transformOrigin$orig2 = transformOrigin.originY,
      originY = _transformOrigin$orig2 === void 0 ? "50%" : _transformOrigin$orig2,
      _transformOrigin$orig3 = transformOrigin.originZ,
      originZ = _transformOrigin$orig3 === void 0 ? 0 : _transformOrigin$orig3;
    style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
  }
}

var createHtmlRenderState = function createHtmlRenderState() {
  return {
    style: {},
    transform: {},
    transformOrigin: {},
    vars: {}
  };
};

function copyRawValuesOnly(target, source, props) {
  for (var key in source) {
    if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
      target[key] = source[key];
    }
  }
}
function useInitialMotionValues(_ref, visualState, isStatic) {
  var transformTemplate = _ref.transformTemplate;
  return useMemo(function () {
    var state = createHtmlRenderState();
    buildHTMLStyles(state, visualState, {
      enableHardwareAcceleration: !isStatic
    }, transformTemplate);
    return Object.assign({}, state.vars, state.style);
  }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
  var styleProp = props.style || {};
  var style = {};
  /**
   * Copy non-Motion Values straight into style
   */
  copyRawValuesOnly(style, styleProp, props);
  Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
  return props.transformValues ? props.transformValues(style) : style;
}
function useHTMLProps(props, visualState, isStatic) {
  // The `any` isn't ideal but it is the type of createElement props argument
  var htmlProps = {};
  var style = useStyle(props, visualState, isStatic);
  if (props.drag && props.dragListener !== false) {
    // Disable the ghost element when a user drags
    htmlProps.draggable = false;
    // Disable text selection
    style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
    // Disable scrolling on the draggable direction
    style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
  }
  if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) {
    htmlProps.tabIndex = 0;
  }
  htmlProps.style = style;
  return htmlProps;
}

/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */
var validMotionProps = new Set(["animate", "exit", "variants", "initial", "style", "values", "variants", "transition", "transformTemplate", "transformValues", "custom", "inherit", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "_dragX", "_dragY", "onHoverStart", "onHoverEnd", "onViewportEnter", "onViewportLeave", "globalTapTarget", "ignoreStrict", "viewport"]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */
function isValidMotionProp(key) {
  return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || validMotionProps.has(key);
}

var shouldForward = function shouldForward(key) {
  return !isValidMotionProp(key);
};
function loadExternalIsValidProp(isValidProp) {
  if (!isValidProp) return;
  // Explicitly filter our events
  shouldForward = function shouldForward(key) {
    return key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
  };
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */
try {
  /**
   * We attempt to import this package but require won't be defined in esm environments, in that case
   * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
   * in favour of explicit injection.
   */
  loadExternalIsValidProp(require("@emotion/is-prop-valid")["default"]);
} catch (_a) {
  // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
  var filteredProps = {};
  for (var key in props) {
    /**
     * values is considered a valid prop by Emotion, so if it's present
     * this will be rendered out to the DOM unless explicitly filtered.
     *
     * We check the type as it could be used with the `feColorMatrix`
     * element, which we support.
     */
    if (key === "values" && _typeof$1(props.values) === "object") continue;
    if (shouldForward(key) || forwardMotionProps === true && isValidMotionProp(key) || !isDom && !isValidMotionProp(key) ||
    // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) {
      filteredProps[key] = props[key];
    }
  }
  return filteredProps;
}

function calcOrigin$1(origin, offset, size) {
  return typeof origin === "string" ? origin : px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
  var pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
  var pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
  return "".concat(pxOriginX, " ").concat(pxOriginY);
}

var dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
};
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, length) {
  var spacing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var useDashCase = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  // Normalise path length by setting SVG attribute pathLength to 1
  attrs.pathLength = 1;
  // We use dash case when setting attributes directly to the DOM node and camel case
  // when defining props on a React component.
  var keys = useDashCase ? dashKeys : camelKeys;
  // Build the dash offset
  attrs[keys.offset] = px.transform(-offset);
  // Build the dash array
  var pathLength = px.transform(length);
  var pathSpacing = px.transform(spacing);
  attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}

var _excluded$2j = ["attrX", "attrY", "attrScale", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"];

/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(state, _ref, options, isSVGTag, transformTemplate) {
  var attrX = _ref.attrX,
    attrY = _ref.attrY,
    attrScale = _ref.attrScale,
    originX = _ref.originX,
    originY = _ref.originY,
    pathLength = _ref.pathLength,
    _ref$pathSpacing = _ref.pathSpacing,
    pathSpacing = _ref$pathSpacing === void 0 ? 1 : _ref$pathSpacing,
    _ref$pathOffset = _ref.pathOffset,
    pathOffset = _ref$pathOffset === void 0 ? 0 : _ref$pathOffset,
    latest = _objectWithoutProperties$1(_ref, _excluded$2j);
  buildHTMLStyles(state, latest, options, transformTemplate);
  /**
   * For svg tags we just want to make sure viewBox is animatable and treat all the styles
   * as normal HTML tags.
   */
  if (isSVGTag) {
    if (state.style.viewBox) {
      state.attrs.viewBox = state.style.viewBox;
    }
    return;
  }
  state.attrs = state.style;
  state.style = {};
  var attrs = state.attrs,
    style = state.style,
    dimensions = state.dimensions;
  /**
   * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
   * and copy it into style.
   */
  if (attrs.transform) {
    if (dimensions) style.transform = attrs.transform;
    delete attrs.transform;
  }
  // Parse transformOrigin
  if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) {
    style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
  }
  // Render attrX/attrY/attrScale as attributes
  if (attrX !== undefined) attrs.x = attrX;
  if (attrY !== undefined) attrs.y = attrY;
  if (attrScale !== undefined) attrs.scale = attrScale;
  // Build SVG path if one has been defined
  if (pathLength !== undefined) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}

var createSvgRenderState = function createSvgRenderState() {
  return _objectSpread2$1(_objectSpread2$1({}, createHtmlRenderState()), {}, {
    attrs: {}
  });
};

var isSVGTag = function isSVGTag(tag) {
  return typeof tag === "string" && tag.toLowerCase() === "svg";
};

function useSVGProps(props, visualState, _isStatic, Component) {
  var visualProps = useMemo(function () {
    var state = createSvgRenderState();
    buildSVGAttrs(state, visualState, {
      enableHardwareAcceleration: false
    }, isSVGTag(Component), props.transformTemplate);
    return _objectSpread2$1(_objectSpread2$1({}, state.attrs), {}, {
      style: _objectSpread2$1({}, state.style)
    });
  }, [visualState]);
  if (props.style) {
    var rawStyles = {};
    copyRawValuesOnly(rawStyles, props.style, props);
    visualProps.style = _objectSpread2$1(_objectSpread2$1({}, rawStyles), visualProps.style);
  }
  return visualProps;
}

function createUseRender() {
  var forwardMotionProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var useRender = function useRender(Component, props, ref, _ref, isStatic) {
    var latestValues = _ref.latestValues;
    var useVisualProps = isSVGComponent(Component) ? useSVGProps : useHTMLProps;
    var visualProps = useVisualProps(props, latestValues, isStatic, Component);
    var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
    var elementProps = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, filteredProps), visualProps), {}, {
      ref: ref
    });
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */
    var children = props.children;
    var renderedChildren = useMemo(function () {
      return isMotionValue(children) ? children.get() : children;
    }, [children]);
    return /*#__PURE__*/createElement(Component, _objectSpread2$1(_objectSpread2$1({}, elementProps), {}, {
      children: renderedChildren
    }));
  };
  return useRender;
}

function renderHTML(element, _ref, styleProp, projection) {
  var style = _ref.style,
    vars = _ref.vars;
  Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
  // Loop over any CSS variables and assign those.
  for (var key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}

/**
 * A set of attribute names that are always read/written as camel case.
 */
var camelCaseAttributes = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform", "pathLength", "startOffset", "textLength", "lengthAdjust"]);

function renderSVG(element, renderState, _styleProp, projection) {
  renderHTML(element, renderState, undefined, projection);
  for (var key in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
  }
}

function scrapeMotionValuesFromProps$1(props, prevProps) {
  var style = props.style;
  var newValues = {};
  for (var key in style) {
    if (isMotionValue(style[key]) || prevProps.style && isMotionValue(prevProps.style[key]) || isForcedMotionValue(key, props)) {
      newValues[key] = style[key];
    }
  }
  return newValues;
}

function scrapeMotionValuesFromProps(props, prevProps) {
  var newValues = scrapeMotionValuesFromProps$1(props, prevProps);
  for (var key in props) {
    if (isMotionValue(props[key]) || isMotionValue(prevProps[key])) {
      var targetKey = transformPropOrder.indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
      newValues[targetKey] = props[key];
    }
  }
  return newValues;
}

function resolveVariantFromProps(props, definition, custom) {
  var currentValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var currentVelocity = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  /**
   * If the variant definition is a function, resolve.
   */
  if (typeof definition === "function") {
    definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
  }
  /**
   * If the variant definition is a variant label, or
   * the function returned a variant label, resolve.
   */
  if (typeof definition === "string") {
    definition = props.variants && props.variants[definition];
  }
  /**
   * At this point we've resolved both functions and variant labels,
   * but the resolved variant label might itself have been a function.
   * If so, resolve. This can only have returned a valid target object.
   */
  if (typeof definition === "function") {
    definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
  }
  return definition;
}

/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
  var ref = useRef(null);
  if (ref.current === null) {
    ref.current = init();
  }
  return ref.current;
}

var isKeyframesTarget = function isKeyframesTarget(v) {
  return Array.isArray(v);
};

var isCustomValue = function isCustomValue(v) {
  return Boolean(v && _typeof$1(v) === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = function resolveFinalValueInKeyframes(v) {
  // TODO maybe throw if v.length - 1 is placeholder token?
  return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */
function resolveMotionValue(value) {
  var unwrappedValue = isMotionValue(value) ? value.get() : value;
  return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

var _excluded$2i = ["transitionEnd", "transition"];
function makeState(_ref, props, context, presenceContext) {
  var scrapeMotionValuesFromProps = _ref.scrapeMotionValuesFromProps,
    createRenderState = _ref.createRenderState,
    onMount = _ref.onMount;
  var state = {
    latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
    renderState: createRenderState()
  };
  if (onMount) {
    state.mount = function (instance) {
      return onMount(props, instance, state);
    };
  }
  return state;
}
var makeUseVisualState = function makeUseVisualState(config) {
  return function (props, isStatic) {
    var context = useContext(MotionContext);
    var presenceContext = useContext(PresenceContext);
    var make = function make() {
      return makeState(config, props, context, presenceContext);
    };
    return isStatic ? make() : useConstant(make);
  };
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
  var values = {};
  var motionValues = scrapeMotionValues(props, {});
  for (var key in motionValues) {
    values[key] = resolveMotionValue(motionValues[key]);
  }
  var initial = props.initial,
    animate = props.animate;
  var isControllingVariants$1 = isControllingVariants(props);
  var isVariantNode$1 = isVariantNode(props);
  if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
    if (initial === undefined) initial = context.initial;
    if (animate === undefined) animate = context.animate;
  }
  var isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
  isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
  var variantToSet = isInitialAnimationBlocked ? animate : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
    var list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
    list.forEach(function (definition) {
      var resolved = resolveVariantFromProps(props, definition);
      if (!resolved) return;
      var transitionEnd = resolved.transitionEnd;
        resolved.transition;
        var target = _objectWithoutProperties$1(resolved, _excluded$2i);
      for (var _key in target) {
        var valueTarget = target[_key];
        if (Array.isArray(valueTarget)) {
          /**
           * Take final keyframe if the initial animation is blocked because
           * we want to initialise at the end of that blocked animation.
           */
          var index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
          valueTarget = valueTarget[index];
        }
        if (valueTarget !== null) {
          values[_key] = valueTarget;
        }
      }
      for (var _key2 in transitionEnd) values[_key2] = transitionEnd[_key2];
    });
  }
  return values;
}

var noop$1 = function noop(any) {
  return any;
};

var Queue = /*#__PURE__*/function () {
  function Queue() {
    _classCallCheck$1(this, Queue);
    this.order = [];
    this.scheduled = new Set();
  }
  return _createClass$1(Queue, [{
    key: "add",
    value: function add(process) {
      if (!this.scheduled.has(process)) {
        this.scheduled.add(process);
        this.order.push(process);
        return true;
      }
    }
  }, {
    key: "remove",
    value: function remove(process) {
      var index = this.order.indexOf(process);
      if (index !== -1) {
        this.order.splice(index, 1);
        this.scheduled["delete"](process);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.order.length = 0;
      this.scheduled.clear();
    }
  }]);
}();
function createRenderStep(runNextFrame) {
  /**
   * We create and reuse two queues, one to queue jobs for the current frame
   * and one for the next. We reuse to avoid triggering GC after x frames.
   */
  var thisFrame = new Queue();
  var nextFrame = new Queue();
  var numToRun = 0;
  /**
   * Track whether we're currently processing jobs in this step. This way
   * we can decide whether to schedule new jobs for this frame or next.
   */
  var isProcessing = false;
  var flushNextFrame = false;
  /**
   * A set of processes which were marked keepAlive when scheduled.
   */
  var toKeepAlive = new WeakSet();
  var step = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: function schedule(callback) {
      var keepAlive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var addToCurrentFrame = immediate && isProcessing;
      var queue = addToCurrentFrame ? thisFrame : nextFrame;
      if (keepAlive) toKeepAlive.add(callback);
      if (queue.add(callback) && addToCurrentFrame && isProcessing) {
        // If we're adding it to the currently running queue, update its measured size
        numToRun = thisFrame.order.length;
      }
      return callback;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: function cancel(callback) {
      nextFrame.remove(callback);
      toKeepAlive["delete"](callback);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: function process(frameData) {
      /**
       * If we're already processing we've probably been triggered by a flushSync
       * inside an existing process. Instead of executing, mark flushNextFrame
       * as true and ensure we flush the following frame at the end of this one.
       */
      if (isProcessing) {
        flushNextFrame = true;
        return;
      }
      isProcessing = true;
      // Clear the next frame queue
      var _ref = [nextFrame, thisFrame];
      thisFrame = _ref[0];
      nextFrame = _ref[1];
      nextFrame.clear();
      // Execute this frame
      numToRun = thisFrame.order.length;
      if (numToRun) {
        for (var i = 0; i < numToRun; i++) {
          var callback = thisFrame.order[i];
          callback(frameData);
          if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
          }
        }
      }
      isProcessing = false;
      if (flushNextFrame) {
        flushNextFrame = false;
        step.process(frameData);
      }
    }
  };
  return step;
}

var stepsOrder = ["prepare", "read", "update", "preRender", "render", "postRender"];
var maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  var runNextFrame = false;
  var useDefaultElapsed = true;
  var state = {
    delta: 0,
    timestamp: 0,
    isProcessing: false
  };
  var steps = stepsOrder.reduce(function (acc, key) {
    acc[key] = createRenderStep(function () {
      return runNextFrame = true;
    });
    return acc;
  }, {});
  var processStep = function processStep(stepId) {
    return steps[stepId].process(state);
  };
  var _processBatch = function processBatch() {
    var timestamp = performance.now();
    runNextFrame = false;
    state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
    state.timestamp = timestamp;
    state.isProcessing = true;
    stepsOrder.forEach(processStep);
    state.isProcessing = false;
    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(_processBatch);
    }
  };
  var wake = function wake() {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!state.isProcessing) {
      scheduleNextBatch(_processBatch);
    }
  };
  var schedule = stepsOrder.reduce(function (acc, key) {
    var step = steps[key];
    acc[key] = function (process) {
      var keepAlive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!runNextFrame) wake();
      return step.schedule(process, keepAlive, immediate);
    };
    return acc;
  }, {});
  var cancel = function cancel(process) {
    return stepsOrder.forEach(function (key) {
      return steps[key].cancel(process);
    });
  };
  return {
    schedule: schedule,
    cancel: cancel,
    state: state,
    steps: steps
  };
}

var _createRenderBatcher = createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop$1, true),
  frame = _createRenderBatcher.schedule,
  cancelFrame = _createRenderBatcher.cancel,
  frameData = _createRenderBatcher.state,
  steps = _createRenderBatcher.steps;

var svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
    createRenderState: createSvgRenderState,
    onMount: function onMount(props, instance, _ref) {
      var renderState = _ref.renderState,
        latestValues = _ref.latestValues;
      frame.read(function () {
        try {
          renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
        } catch (e) {
          // Most likely trying to measure an unrendered element under Firefox
          renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      });
      frame.render(function () {
        buildSVGAttrs(renderState, latestValues, {
          enableHardwareAcceleration: false
        }, isSVGTag(instance.tagName), props.transformTemplate);
        renderSVG(instance, renderState);
      });
    }
  })
};

var htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    createRenderState: createHtmlRenderState
  })
};

function createDomMotionConfig(Component, _ref, preloadedFeatures, createVisualElement) {
  var _ref$forwardMotionPro = _ref.forwardMotionProps,
    forwardMotionProps = _ref$forwardMotionPro === void 0 ? false : _ref$forwardMotionPro;
  var baseConfig = isSVGComponent(Component) ? svgMotionConfig : htmlMotionConfig;
  return _objectSpread2$1(_objectSpread2$1({}, baseConfig), {}, {
    preloadedFeatures: preloadedFeatures,
    useRender: createUseRender(forwardMotionProps),
    createVisualElement: createVisualElement,
    Component: Component
  });
}

function addDomEvent(target, eventName, handler) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    passive: true
  };
  target.addEventListener(eventName, handler, options);
  return function () {
    return target.removeEventListener(eventName, handler);
  };
}

var isPrimaryPointer = function isPrimaryPointer(event) {
  if (event.pointerType === "mouse") {
    return typeof event.button !== "number" || event.button <= 0;
  } else {
    /**
     * isPrimary is true for all mice buttons, whereas every touch point
     * is regarded as its own input. So subsequent concurrent touch points
     * will be false.
     *
     * Specifically match against false here as incomplete versions of
     * PointerEvents in very old browser might have it set as undefined.
     */
    return event.isPrimary !== false;
  }
};

function extractEventInfo(event) {
  var pointType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page";
  return {
    point: {
      x: event[pointType + "X"],
      y: event[pointType + "Y"]
    }
  };
}
var addPointerInfo = function addPointerInfo(handler) {
  return function (event) {
    return isPrimaryPointer(event) && handler(event, extractEventInfo(event));
  };
};

function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, eventName, addPointerInfo(handler), options);
}

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */
var combineFunctions = function combineFunctions(a, b) {
  return function (v) {
    return b(a(v));
  };
};
var pipe = function pipe() {
  for (var _len = arguments.length, transformers = new Array(_len), _key = 0; _key < _len; _key++) {
    transformers[_key] = arguments[_key];
  }
  return transformers.reduce(combineFunctions);
};

function createLock(name) {
  var lock = null;
  return function () {
    var openLock = function openLock() {
      lock = null;
    };
    if (lock === null) {
      lock = name;
      return openLock;
    }
    return false;
  };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
  var lock = false;
  if (drag === "y") {
    lock = globalVerticalLock();
  } else if (drag === "x") {
    lock = globalHorizontalLock();
  } else {
    var openHorizontal = globalHorizontalLock();
    var openVertical = globalVerticalLock();
    if (openHorizontal && openVertical) {
      lock = function lock() {
        openHorizontal();
        openVertical();
      };
    } else {
      // Release the locks because we don't use them
      if (openHorizontal) openHorizontal();
      if (openVertical) openVertical();
    }
  }
  return lock;
}
function isDragActive() {
  // Check the gesture lock - if we get it, it means no drag gesture is active
  // and we can safely fire the tap gesture.
  var openGestureLock = getGlobalLock(true);
  if (!openGestureLock) return true;
  openGestureLock();
  return false;
}

var Feature = /*#__PURE__*/function () {
  function Feature(node) {
    _classCallCheck$1(this, Feature);
    this.isMounted = false;
    this.node = node;
  }
  return _createClass$1(Feature, [{
    key: "update",
    value: function update() {}
  }]);
}();

function addHoverEvent(node, isActive) {
  var eventName = "pointer" + (isActive ? "enter" : "leave");
  var callbackName = "onHover" + (isActive ? "Start" : "End");
  var handleEvent = function handleEvent(event, info) {
    if (event.pointerType === "touch" || isDragActive()) return;
    var props = node.getProps();
    if (node.animationState && props.whileHover) {
      node.animationState.setActive("whileHover", isActive);
    }
    if (props[callbackName]) {
      frame.update(function () {
        return props[callbackName](event, info);
      });
    }
  };
  return addPointerEvent(node.current, eventName, handleEvent, {
    passive: !node.getProps()[callbackName]
  });
}
var HoverGesture = /*#__PURE__*/function (_Feature) {
  function HoverGesture() {
    _classCallCheck$1(this, HoverGesture);
    return _callSuper(this, HoverGesture, arguments);
  }
  _inherits$1(HoverGesture, _Feature);
  return _createClass$1(HoverGesture, [{
    key: "mount",
    value: function mount() {
      this.unmount = pipe(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
}(Feature);

var FocusGesture = /*#__PURE__*/function (_Feature) {
  function FocusGesture() {
    var _this;
    _classCallCheck$1(this, FocusGesture);
    _this = _callSuper(this, FocusGesture, arguments);
    _this.isActive = false;
    return _this;
  }
  _inherits$1(FocusGesture, _Feature);
  return _createClass$1(FocusGesture, [{
    key: "onFocus",
    value: function onFocus() {
      var isFocusVisible = false;
      /**
       * If this element doesn't match focus-visible then don't
       * apply whileHover. But, if matches throws that focus-visible
       * is not a valid selector then in that browser outline styles will be applied
       * to the element by default and we want to match that behaviour with whileFocus.
       */
      try {
        isFocusVisible = this.node.current.matches(":focus-visible");
      } catch (e) {
        isFocusVisible = true;
      }
      if (!isFocusVisible || !this.node.animationState) return;
      this.node.animationState.setActive("whileFocus", true);
      this.isActive = true;
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      if (!this.isActive || !this.node.animationState) return;
      this.node.animationState.setActive("whileFocus", false);
      this.isActive = false;
    }
  }, {
    key: "mount",
    value: function mount() {
      var _this2 = this;
      this.unmount = pipe(addDomEvent(this.node.current, "focus", function () {
        return _this2.onFocus();
      }), addDomEvent(this.node.current, "blur", function () {
        return _this2.onBlur();
      }));
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
}(Feature);

/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */
var _isNodeOrChild = function isNodeOrChild(parent, child) {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return _isNodeOrChild(parent, child.parentElement);
  }
};

function fireSyntheticPointerEvent(name, handler) {
  if (!handler) return;
  var syntheticPointerEvent = new PointerEvent("pointer" + name);
  handler(syntheticPointerEvent, extractEventInfo(syntheticPointerEvent));
}
var PressGesture = /*#__PURE__*/function (_Feature) {
  function PressGesture() {
    var _this;
    _classCallCheck$1(this, PressGesture);
    _this = _callSuper(this, PressGesture, arguments);
    _this.removeStartListeners = noop$1;
    _this.removeEndListeners = noop$1;
    _this.removeAccessibleListeners = noop$1;
    _this.startPointerPress = function (startEvent, startInfo) {
      if (_this.isPressing) return;
      _this.removeEndListeners();
      var props = _this.node.getProps();
      var endPointerPress = function endPointerPress(endEvent, endInfo) {
        if (!_this.checkPressEnd()) return;
        var _this$node$getProps = _this.node.getProps(),
          onTap = _this$node$getProps.onTap,
          onTapCancel = _this$node$getProps.onTapCancel,
          globalTapTarget = _this$node$getProps.globalTapTarget;
        frame.update(function () {
          /**
           * We only count this as a tap gesture if the event.target is the same
           * as, or a child of, this component's element
           */
          !globalTapTarget && !_isNodeOrChild(_this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
        });
      };
      var removePointerUpListener = addPointerEvent(window, "pointerup", endPointerPress, {
        passive: !(props.onTap || props["onPointerUp"])
      });
      var removePointerCancelListener = addPointerEvent(window, "pointercancel", function (cancelEvent, cancelInfo) {
        return _this.cancelPress(cancelEvent, cancelInfo);
      }, {
        passive: !(props.onTapCancel || props["onPointerCancel"])
      });
      _this.removeEndListeners = pipe(removePointerUpListener, removePointerCancelListener);
      _this.startPress(startEvent, startInfo);
    };
    _this.startAccessiblePress = function () {
      var handleKeydown = function handleKeydown(keydownEvent) {
        if (keydownEvent.key !== "Enter" || _this.isPressing) return;
        var handleKeyup = function handleKeyup(keyupEvent) {
          if (keyupEvent.key !== "Enter" || !_this.checkPressEnd()) return;
          fireSyntheticPointerEvent("up", function (event, info) {
            var _this$node$getProps2 = _this.node.getProps(),
              onTap = _this$node$getProps2.onTap;
            if (onTap) {
              frame.update(function () {
                return onTap(event, info);
              });
            }
          });
        };
        _this.removeEndListeners();
        _this.removeEndListeners = addDomEvent(_this.node.current, "keyup", handleKeyup);
        fireSyntheticPointerEvent("down", function (event, info) {
          _this.startPress(event, info);
        });
      };
      var removeKeydownListener = addDomEvent(_this.node.current, "keydown", handleKeydown);
      var handleBlur = function handleBlur() {
        if (!_this.isPressing) return;
        fireSyntheticPointerEvent("cancel", function (cancelEvent, cancelInfo) {
          return _this.cancelPress(cancelEvent, cancelInfo);
        });
      };
      var removeBlurListener = addDomEvent(_this.node.current, "blur", handleBlur);
      _this.removeAccessibleListeners = pipe(removeKeydownListener, removeBlurListener);
    };
    return _this;
  }
  _inherits$1(PressGesture, _Feature);
  return _createClass$1(PressGesture, [{
    key: "startPress",
    value: function startPress(event, info) {
      this.isPressing = true;
      var _this$node$getProps3 = this.node.getProps(),
        onTapStart = _this$node$getProps3.onTapStart,
        whileTap = _this$node$getProps3.whileTap;
      /**
       * Ensure we trigger animations before firing event callback
       */
      if (whileTap && this.node.animationState) {
        this.node.animationState.setActive("whileTap", true);
      }
      if (onTapStart) {
        frame.update(function () {
          return onTapStart(event, info);
        });
      }
    }
  }, {
    key: "checkPressEnd",
    value: function checkPressEnd() {
      this.removeEndListeners();
      this.isPressing = false;
      var props = this.node.getProps();
      if (props.whileTap && this.node.animationState) {
        this.node.animationState.setActive("whileTap", false);
      }
      return !isDragActive();
    }
  }, {
    key: "cancelPress",
    value: function cancelPress(event, info) {
      if (!this.checkPressEnd()) return;
      var _this$node$getProps4 = this.node.getProps(),
        onTapCancel = _this$node$getProps4.onTapCancel;
      if (onTapCancel) {
        frame.update(function () {
          return onTapCancel(event, info);
        });
      }
    }
  }, {
    key: "mount",
    value: function mount() {
      var props = this.node.getProps();
      var removePointerListener = addPointerEvent(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
        passive: !(props.onTapStart || props["onPointerStart"])
      });
      var removeFocusListener = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
      this.removeStartListeners = pipe(removePointerListener, removeFocusListener);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      this.removeStartListeners();
      this.removeEndListeners();
      this.removeAccessibleListeners();
    }
  }]);
}(Feature);

var _excluded$2h = ["root"];
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */
var observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */
var observers = new WeakMap();
var fireObserverCallback = function fireObserverCallback(entry) {
  var callback = observerCallbacks.get(entry.target);
  callback && callback(entry);
};
var fireAllObserverCallbacks = function fireAllObserverCallbacks(entries) {
  entries.forEach(fireObserverCallback);
};
function initIntersectionObserver(_ref) {
  var root = _ref.root,
    options = _objectWithoutProperties$1(_ref, _excluded$2h);
  var lookupRoot = root || document;
  /**
   * If we don't have an observer lookup map for this root, create one.
   */
  if (!observers.has(lookupRoot)) {
    observers.set(lookupRoot, {});
  }
  var rootObservers = observers.get(lookupRoot);
  var key = JSON.stringify(options);
  /**
   * If we don't have an observer for this combination of root and settings,
   * create one.
   */
  if (!rootObservers[key]) {
    rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, _objectSpread2$1({
      root: root
    }, options));
  }
  return rootObservers[key];
}
function observeIntersection(element, options, callback) {
  var rootInteresectionObserver = initIntersectionObserver(options);
  observerCallbacks.set(element, callback);
  rootInteresectionObserver.observe(element);
  return function () {
    observerCallbacks["delete"](element);
    rootInteresectionObserver.unobserve(element);
  };
}

var thresholdNames = {
  some: 0,
  all: 1
};
var InViewFeature = /*#__PURE__*/function (_Feature) {
  function InViewFeature() {
    var _this;
    _classCallCheck$1(this, InViewFeature);
    _this = _callSuper(this, InViewFeature, arguments);
    _this.hasEnteredView = false;
    _this.isInView = false;
    return _this;
  }
  _inherits$1(InViewFeature, _Feature);
  return _createClass$1(InViewFeature, [{
    key: "startObserver",
    value: function startObserver() {
      var _this2 = this;
      this.unmount();
      var _this$node$getProps = this.node.getProps(),
        _this$node$getProps$v = _this$node$getProps.viewport,
        viewport = _this$node$getProps$v === void 0 ? {} : _this$node$getProps$v;
      var root = viewport.root,
        rootMargin = viewport.margin,
        _viewport$amount = viewport.amount,
        amount = _viewport$amount === void 0 ? "some" : _viewport$amount,
        once = viewport.once;
      var options = {
        root: root ? root.current : undefined,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : thresholdNames[amount]
      };
      var onIntersectionUpdate = function onIntersectionUpdate(entry) {
        var isIntersecting = entry.isIntersecting;
        /**
         * If there's been no change in the viewport state, early return.
         */
        if (_this2.isInView === isIntersecting) return;
        _this2.isInView = isIntersecting;
        /**
         * Handle hasEnteredView. If this is only meant to run once, and
         * element isn't visible, early return. Otherwise set hasEnteredView to true.
         */
        if (once && !isIntersecting && _this2.hasEnteredView) {
          return;
        } else if (isIntersecting) {
          _this2.hasEnteredView = true;
        }
        if (_this2.node.animationState) {
          _this2.node.animationState.setActive("whileInView", isIntersecting);
        }
        /**
         * Use the latest committed props rather than the ones in scope
         * when this observer is created
         */
        var _this2$node$getProps = _this2.node.getProps(),
          onViewportEnter = _this2$node$getProps.onViewportEnter,
          onViewportLeave = _this2$node$getProps.onViewportLeave;
        var callback = isIntersecting ? onViewportEnter : onViewportLeave;
        callback && callback(entry);
      };
      return observeIntersection(this.node.current, options, onIntersectionUpdate);
    }
  }, {
    key: "mount",
    value: function mount() {
      this.startObserver();
    }
  }, {
    key: "update",
    value: function update() {
      if (typeof IntersectionObserver === "undefined") return;
      var _this$node = this.node,
        props = _this$node.props,
        prevProps = _this$node.prevProps;
      var hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps));
      if (hasOptionsChanged) {
        this.startObserver();
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
}(Feature);
function hasViewportOptionChanged(_ref) {
  var _ref$viewport = _ref.viewport,
    viewport = _ref$viewport === void 0 ? {} : _ref$viewport;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$viewport = _ref2.viewport,
    prevViewport = _ref2$viewport === void 0 ? {} : _ref2$viewport;
  return function (name) {
    return viewport[name] !== prevViewport[name];
  };
}

var gestureAnimations = {
  inView: {
    Feature: InViewFeature
  },
  tap: {
    Feature: PressGesture
  },
  focus: {
    Feature: FocusGesture
  },
  hover: {
    Feature: HoverGesture
  }
};

function shallowCompare(next, prev) {
  if (!Array.isArray(prev)) return false;
  var prevLength = prev.length;
  if (prevLength !== next.length) return false;
  for (var i = 0; i < prevLength; i++) {
    if (prev[i] !== next[i]) return false;
  }
  return true;
}

/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */
function getCurrent(visualElement) {
  var current = {};
  visualElement.values.forEach(function (value, key) {
    return current[key] = value.get();
  });
  return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */
function getVelocity$1(visualElement) {
  var velocity = {};
  visualElement.values.forEach(function (value, key) {
    return velocity[key] = value.getVelocity();
  });
  return velocity;
}
function resolveVariant(visualElement, definition, custom) {
  var props = visualElement.getProps();
  return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, getCurrent(visualElement), getVelocity$1(visualElement));
}

var warning = noop$1;
var invariant = noop$1;
if (process.env.NODE_ENV !== "production") {
  warning = function warning(check, message) {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant = function invariant(check, message) {
    if (!check) {
      throw new Error(message);
    }
  };
}

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
var secondsToMilliseconds = function secondsToMilliseconds(seconds) {
  return seconds * 1000;
};
var millisecondsToSeconds = function millisecondsToSeconds(milliseconds) {
  return milliseconds / 1000;
};

var instantAnimationState = {
  current: false
};

var isBezierDefinition = function isBezierDefinition(easing) {
  return Array.isArray(easing) && typeof easing[0] === "number";
};

function isWaapiSupportedEasing(easing) {
  return Boolean(!easing || typeof easing === "string" && supportedWaapiEasing[easing] || isBezierDefinition(easing) || Array.isArray(easing) && easing.every(isWaapiSupportedEasing));
}
var cubicBezierAsString = function cubicBezierAsString(_ref) {
  var _ref2 = _slicedToArray$1(_ref, 4),
    a = _ref2[0],
    b = _ref2[1],
    c = _ref2[2],
    d = _ref2[3];
  return "cubic-bezier(".concat(a, ", ").concat(b, ", ").concat(c, ", ").concat(d, ")");
};
var supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasing(easing) {
  if (!easing) return undefined;
  return isBezierDefinition(easing) ? cubicBezierAsString(easing) : Array.isArray(easing) ? easing.map(mapEasingToNativeEasing) : supportedWaapiEasing[easing];
}

function animateStyle(element, valueName, keyframes) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    duration = _ref.duration,
    _ref$repeat = _ref.repeat,
    repeat = _ref$repeat === void 0 ? 0 : _ref$repeat,
    _ref$repeatType = _ref.repeatType,
    repeatType = _ref$repeatType === void 0 ? "loop" : _ref$repeatType,
    ease = _ref.ease,
    times = _ref.times;
  var keyframeOptions = _defineProperty$3({}, valueName, keyframes);
  if (times) keyframeOptions.offset = times;
  var easing = mapEasingToNativeEasing(ease);
  /**
   * If this is an easing array, apply to keyframes, not animation as a whole
   */
  if (Array.isArray(easing)) keyframeOptions.easing = easing;
  return element.animate(keyframeOptions, {
    delay: delay,
    duration: duration,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}

function getFinalKeyframe(keyframes, _ref) {
  var repeat = _ref.repeat,
    _ref$repeatType = _ref.repeatType,
    repeatType = _ref$repeatType === void 0 ? "loop" : _ref$repeatType;
  var index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
  return keyframes[index];
}

/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
var calcBezier = function calcBezier(t, a1, a2) {
  return (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
};
var subdivisionPrecision = 0.0000001;
var subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
  var currentX;
  var currentT;
  var i = 0;
  do {
    currentT = lowerBound + (upperBound - lowerBound) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - x;
    if (currentX > 0.0) {
      upperBound = currentT;
    } else {
      lowerBound = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
  return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
  // If this is a linear gradient, return linear easing
  if (mX1 === mY1 && mX2 === mY2) return noop$1;
  var getTForX = function getTForX(aX) {
    return binarySubdivide(aX, 0, 1, mX1, mX2);
  };
  // If animation is at start/end, return t without easing
  return function (t) {
    return t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
  };
}

var easeIn = cubicBezier(0.42, 0, 1, 1);
var easeOut = cubicBezier(0, 0, 0.58, 1);
var easeInOut = cubicBezier(0.42, 0, 0.58, 1);

var isEasingArray = function isEasingArray(ease) {
  return Array.isArray(ease) && typeof ease[0] !== "number";
};

// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
var mirrorEasing = function mirrorEasing(easing) {
  return function (p) {
    return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
  };
};

// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
var reverseEasing = function reverseEasing(easing) {
  return function (p) {
    return 1 - easing(1 - p);
  };
};

var circIn = function circIn(p) {
  return 1 - Math.sin(Math.acos(p));
};
var circOut = reverseEasing(circIn);
var circInOut = mirrorEasing(circIn);

var backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
var backIn = reverseEasing(backOut);
var backInOut = mirrorEasing(backIn);

var anticipate = function anticipate(p) {
  return (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};

var easingLookup = {
  linear: noop$1,
  easeIn: easeIn,
  easeInOut: easeInOut,
  easeOut: easeOut,
  circIn: circIn,
  circInOut: circInOut,
  circOut: circOut,
  backIn: backIn,
  backInOut: backInOut,
  backOut: backOut,
  anticipate: anticipate
};
var easingDefinitionToFunction = function easingDefinitionToFunction(definition) {
  if (Array.isArray(definition)) {
    // If cubic bezier definition, create bezier curve
    invariant(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var _definition = _slicedToArray$1(definition, 4),
      x1 = _definition[0],
      y1 = _definition[1],
      x2 = _definition[2],
      y2 = _definition[3];
    return cubicBezier(x1, y1, x2, y2);
  } else if (typeof definition === "string") {
    // Else lookup from table
    invariant(easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"));
    return easingLookup[definition];
  }
  return definition;
};

/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */
var isColorString = function isColorString(type, testProp) {
  return function (v) {
    return Boolean(isString(v) && singleColorRegex.test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
  };
};
var splitColor = function splitColor(aName, bName, cName) {
  return function (v) {
    if (!isString(v)) return v;
    var _v$match = v.match(floatRegex),
      _v$match2 = _slicedToArray$1(_v$match, 4),
      a = _v$match2[0],
      b = _v$match2[1],
      c = _v$match2[2],
      alpha = _v$match2[3];
    return _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, aName, parseFloat(a)), bName, parseFloat(b)), cName, parseFloat(c)), "alpha", alpha !== undefined ? parseFloat(alpha) : 1);
  };
};

var clampRgbUnit = function clampRgbUnit(v) {
  return clamp(0, 255, v);
};
var rgbUnit = _objectSpread2$1(_objectSpread2$1({}, number), {}, {
  transform: function transform(v) {
    return Math.round(clampRgbUnit(v));
  }
});
var rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: function transform(_ref) {
    var red = _ref.red,
      green = _ref.green,
      blue = _ref.blue,
      _ref$alpha = _ref.alpha,
      alpha$1 = _ref$alpha === void 0 ? 1 : _ref$alpha;
    return "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};

function parseHex(v) {
  var r = "";
  var g = "";
  var b = "";
  var a = "";
  // If we have 6 characters, ie #FF0000
  if (v.length > 5) {
    r = v.substring(1, 3);
    g = v.substring(3, 5);
    b = v.substring(5, 7);
    a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
  } else {
    r = v.substring(1, 2);
    g = v.substring(2, 3);
    b = v.substring(3, 4);
    a = v.substring(4, 5);
    r += r;
    g += g;
    b += b;
    a += a;
  }
  return {
    red: parseInt(r, 16),
    green: parseInt(g, 16),
    blue: parseInt(b, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
var hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
};

var hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: function transform(_ref) {
    var hue = _ref.hue,
      saturation = _ref.saturation,
      lightness = _ref.lightness,
      _ref$alpha = _ref.alpha,
      alpha$1 = _ref$alpha === void 0 ? 1 : _ref$alpha;
    return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};

var color = {
  test: function test(v) {
    return rgba.test(v) || hex.test(v) || hsla.test(v);
  },
  parse: function parse(v) {
    if (rgba.test(v)) {
      return rgba.parse(v);
    } else if (hsla.test(v)) {
      return hsla.parse(v);
    } else {
      return hex.parse(v);
    }
  },
  transform: function transform(v) {
    return isString(v) ? v : v.hasOwnProperty("red") ? rgba.transform(v) : hsla.transform(v);
  }
};

/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/
var mix = function mix(from, to, progress) {
  return -progress * from + progress * to + from;
};

// Adapted from https://gist.github.com/mjackson/5311256
function hueToRgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function hslaToRgba(_ref) {
  var hue = _ref.hue,
    saturation = _ref.saturation,
    lightness = _ref.lightness,
    alpha = _ref.alpha;
  hue /= 360;
  saturation /= 100;
  lightness /= 100;
  var red = 0;
  var green = 0;
  var blue = 0;
  if (!saturation) {
    red = green = blue = lightness;
  } else {
    var q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
    var p = 2 * lightness - q;
    red = hueToRgb(p, q, hue + 1 / 3);
    green = hueToRgb(p, q, hue);
    blue = hueToRgb(p, q, hue - 1 / 3);
  }
  return {
    red: Math.round(red * 255),
    green: Math.round(green * 255),
    blue: Math.round(blue * 255),
    alpha: alpha
  };
}

// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
var mixLinearColor = function mixLinearColor(from, to, v) {
  var fromExpo = from * from;
  return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
var colorTypes = [hex, rgba, hsla];
var getColorType = function getColorType(v) {
  return colorTypes.find(function (type) {
    return type.test(v);
  });
};
function asRGBA(color) {
  var type = getColorType(color);
  invariant(Boolean(type), "'".concat(color, "' is not an animatable color. Use the equivalent color code instead."));
  var model = type.parse(color);
  if (type === hsla) {
    // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = hslaToRgba(model);
  }
  return model;
}
var mixColor = function mixColor(from, to) {
  var fromRGBA = asRGBA(from);
  var toRGBA = asRGBA(to);
  var blended = _objectSpread2$1({}, fromRGBA);
  return function (v) {
    blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
    blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
    blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
    blended.alpha = mix(fromRGBA.alpha, toRGBA.alpha, v);
    return rgba.transform(blended);
  };
};

function test(v) {
  var _a, _b;
  return isNaN(v) && isString(v) && (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
var cssVarTokeniser = {
  regex: cssVariableRegex,
  countKey: "Vars",
  token: "${v}",
  parse: noop$1
};
var colorTokeniser = {
  regex: colorRegex,
  countKey: "Colors",
  token: "${c}",
  parse: color.parse
};
var numberTokeniser = {
  regex: floatRegex,
  countKey: "Numbers",
  token: "${n}",
  parse: number.parse
};
function tokenise(info, _ref) {
  var _info$values;
  var regex = _ref.regex,
    countKey = _ref.countKey,
    token = _ref.token,
    parse = _ref.parse;
  var matches = info.tokenised.match(regex);
  if (!matches) return;
  info["num" + countKey] = matches.length;
  info.tokenised = info.tokenised.replace(regex, token);
  (_info$values = info.values).push.apply(_info$values, _toConsumableArray$1(matches.map(parse)));
}
function analyseComplexValue(value) {
  var originalValue = value.toString();
  var info = {
    value: originalValue,
    tokenised: originalValue,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  if (info.value.includes("var(--")) tokenise(info, cssVarTokeniser);
  tokenise(info, colorTokeniser);
  tokenise(info, numberTokeniser);
  return info;
}
function parseComplexValue(v) {
  return analyseComplexValue(v).values;
}
function createTransformer(source) {
  var _analyseComplexValue = analyseComplexValue(source),
    values = _analyseComplexValue.values,
    numColors = _analyseComplexValue.numColors,
    numVars = _analyseComplexValue.numVars,
    tokenised = _analyseComplexValue.tokenised;
  var numValues = values.length;
  return function (v) {
    var output = tokenised;
    for (var i = 0; i < numValues; i++) {
      if (i < numVars) {
        output = output.replace(cssVarTokeniser.token, v[i]);
      } else if (i < numVars + numColors) {
        output = output.replace(colorTokeniser.token, color.transform(v[i]));
      } else {
        output = output.replace(numberTokeniser.token, sanitize(v[i]));
      }
    }
    return output;
  };
}
var convertNumbersToZero = function convertNumbersToZero(v) {
  return typeof v === "number" ? 0 : v;
};
function getAnimatableNone$1(v) {
  var parsed = parseComplexValue(v);
  var transformer = createTransformer(v);
  return transformer(parsed.map(convertNumbersToZero));
}
var complex = {
  test: test,
  parse: parseComplexValue,
  createTransformer: createTransformer,
  getAnimatableNone: getAnimatableNone$1
};

var mixImmediate = function mixImmediate(origin, target) {
  return function (p) {
    return "".concat(p > 0 ? target : origin);
  };
};
function getMixer(origin, target) {
  if (typeof origin === "number") {
    return function (v) {
      return mix(origin, target, v);
    };
  } else if (color.test(origin)) {
    return mixColor(origin, target);
  } else {
    return origin.startsWith("var(") ? mixImmediate(origin, target) : mixComplex(origin, target);
  }
}
var mixArray = function mixArray(from, to) {
  var output = _toConsumableArray$1(from);
  var numValues = output.length;
  var blendValue = from.map(function (fromThis, i) {
    return getMixer(fromThis, to[i]);
  });
  return function (v) {
    for (var i = 0; i < numValues; i++) {
      output[i] = blendValue[i](v);
    }
    return output;
  };
};
var mixObject = function mixObject(origin, target) {
  var output = _objectSpread2$1(_objectSpread2$1({}, origin), target);
  var blendValue = {};
  for (var key in output) {
    if (origin[key] !== undefined && target[key] !== undefined) {
      blendValue[key] = getMixer(origin[key], target[key]);
    }
  }
  return function (v) {
    for (var _key in blendValue) {
      output[_key] = blendValue[_key](v);
    }
    return output;
  };
};
var mixComplex = function mixComplex(origin, target) {
  var template = complex.createTransformer(target);
  var originStats = analyseComplexValue(origin);
  var targetStats = analyseComplexValue(target);
  var canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
  if (canInterpolate) {
    return pipe(mixArray(originStats.values, targetStats.values), template);
  } else {
    warning(true, "Complex values '".concat(origin, "' and '").concat(target, "' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition."));
    return mixImmediate(origin, target);
  }
};

/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/
var progress$1 = function progress(from, to, value) {
  var toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

var mixNumber = function mixNumber(from, to) {
  return function (p) {
    return mix(from, to, p);
  };
};
function detectMixerFactory(v) {
  if (typeof v === "number") {
    return mixNumber;
  } else if (typeof v === "string") {
    return color.test(v) ? mixColor : mixComplex;
  } else if (Array.isArray(v)) {
    return mixArray;
  } else if (_typeof$1(v) === "object") {
    return mixObject;
  }
  return mixNumber;
}
function createMixers(output, ease, customMixer) {
  var mixers = [];
  var mixerFactory = customMixer || detectMixerFactory(output[0]);
  var numMixers = output.length - 1;
  for (var i = 0; i < numMixers; i++) {
    var mixer = mixerFactory(output[i], output[i + 1]);
    if (ease) {
      var easingFunction = Array.isArray(ease) ? ease[i] || noop$1 : ease;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */
function interpolate(input, output) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$clamp = _ref.clamp,
    isClamp = _ref$clamp === void 0 ? true : _ref$clamp,
    ease = _ref.ease,
    mixer = _ref.mixer;
  var inputLength = input.length;
  invariant(inputLength === output.length, "Both input and output ranges must be the same length");
  /**
   * If we're only provided a single input, we can just make a function
   * that returns the output.
   */
  if (inputLength === 1) return function () {
    return output[0];
  };
  // If input runs highest -> lowest, reverse both arrays
  if (input[0] > input[inputLength - 1]) {
    input = _toConsumableArray$1(input).reverse();
    output = _toConsumableArray$1(output).reverse();
  }
  var mixers = createMixers(output, ease, mixer);
  var numMixers = mixers.length;
  var interpolator = function interpolator(v) {
    var i = 0;
    if (numMixers > 1) {
      for (; i < input.length - 2; i++) {
        if (v < input[i + 1]) break;
      }
    }
    var progressInRange = progress$1(input[i], input[i + 1], v);
    return mixers[i](progressInRange);
  };
  return isClamp ? function (v) {
    return interpolator(clamp(input[0], input[inputLength - 1], v));
  } : interpolator;
}

function fillOffset(offset, remaining) {
  var min = offset[offset.length - 1];
  for (var i = 1; i <= remaining; i++) {
    var offsetProgress = progress$1(0, remaining, i);
    offset.push(mix(min, 1, offsetProgress));
  }
}

function defaultOffset(arr) {
  var offset = [0];
  fillOffset(offset, arr.length - 1);
  return offset;
}

function convertOffsetToTimes(offset, duration) {
  return offset.map(function (o) {
    return o * duration;
  });
}

function defaultEasing(values, easing) {
  return values.map(function () {
    return easing || easeInOut;
  }).splice(0, values.length - 1);
}
function keyframes$1(_ref) {
  var _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 300 : _ref$duration,
    keyframeValues = _ref.keyframes,
    times = _ref.times,
    _ref$ease = _ref.ease,
    ease = _ref$ease === void 0 ? "easeInOut" : _ref$ease;
  /**
   * Easing functions can be externally defined as strings. Here we convert them
   * into actual functions.
   */
  var easingFunctions = isEasingArray(ease) ? ease.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease);
  /**
   * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
   * to reduce GC during animation.
   */
  var state = {
    done: false,
    value: keyframeValues[0]
  };
  /**
   * Create a times array based on the provided 0-1 offsets
   */
  var absoluteTimes = convertOffsetToTimes(
  // Only use the provided offsets if they're the correct length
  // TODO Maybe we should warn here if there's a length mismatch
  times && times.length === keyframeValues.length ? times : defaultOffset(keyframeValues), duration);
  var mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
    ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
  });
  return {
    calculatedDuration: duration,
    next: function next(t) {
      state.value = mapTimeToKeyframe(t);
      state.done = t >= duration;
      return state;
    }
  };
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

var velocitySampleDuration = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
  var prevT = Math.max(t - velocitySampleDuration, 0);
  return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}

var safeMin = 0.001;
var minDuration = 0.01;
var maxDuration$1 = 10.0;
var minDamping = 0.05;
var maxDamping = 1;
function findSpring(_ref) {
  var _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 800 : _ref$duration,
    _ref$bounce = _ref.bounce,
    bounce = _ref$bounce === void 0 ? 0.25 : _ref$bounce,
    _ref$velocity = _ref.velocity,
    velocity = _ref$velocity === void 0 ? 0 : _ref$velocity,
    _ref$mass = _ref.mass,
    mass = _ref$mass === void 0 ? 1 : _ref$mass;
  var envelope;
  var derivative;
  warning(duration <= secondsToMilliseconds(maxDuration$1), "Spring duration must be 10 seconds or less");
  var dampingRatio = 1 - bounce;
  /**
   * Restrict dampingRatio and duration to within acceptable ranges.
   */
  dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
  duration = clamp(minDuration, maxDuration$1, millisecondsToSeconds(duration));
  if (dampingRatio < 1) {
    /**
     * Underdamped spring
     */
    envelope = function envelope(undampedFreq) {
      var exponentialDecay = undampedFreq * dampingRatio;
      var delta = exponentialDecay * duration;
      var a = exponentialDecay - velocity;
      var b = calcAngularFreq(undampedFreq, dampingRatio);
      var c = Math.exp(-delta);
      return safeMin - a / b * c;
    };
    derivative = function derivative(undampedFreq) {
      var exponentialDecay = undampedFreq * dampingRatio;
      var delta = exponentialDecay * duration;
      var d = delta * velocity + velocity;
      var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
      var f = Math.exp(-delta);
      var g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
      var factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
      return factor * ((d - e) * f) / g;
    };
  } else {
    /**
     * Critically-damped spring
     */
    envelope = function envelope(undampedFreq) {
      var a = Math.exp(-undampedFreq * duration);
      var b = (undampedFreq - velocity) * duration + 1;
      return -safeMin + a * b;
    };
    derivative = function derivative(undampedFreq) {
      var a = Math.exp(-undampedFreq * duration);
      var b = (velocity - undampedFreq) * (duration * duration);
      return a * b;
    };
  }
  var initialGuess = 5 / duration;
  var undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  duration = secondsToMilliseconds(duration);
  if (isNaN(undampedFreq)) {
    return {
      stiffness: 100,
      damping: 10,
      duration: duration
    };
  } else {
    var stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness: stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration: duration
    };
  }
}
var rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  var result = initialGuess;
  for (var i = 1; i < rootIterations; i++) {
    result = result - envelope(result) / derivative(result);
  }
  return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

var _excluded$2g = ["keyframes", "restDelta", "restSpeed"];
var durationKeys = ["duration", "bounce"];
var physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
  return keys.some(function (key) {
    return options[key] !== undefined;
  });
}
function getSpringOptions(options) {
  var springOptions = _objectSpread2$1({
    velocity: 0.0,
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    isResolvedFromDuration: false
  }, options);
  // stiffness/damping/mass overrides duration/bounce
  if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
    var derived = findSpring(options);
    springOptions = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, springOptions), derived), {}, {
      mass: 1.0
    });
    springOptions.isResolvedFromDuration = true;
  }
  return springOptions;
}
function spring(_ref) {
  var keyframes = _ref.keyframes,
    restDelta = _ref.restDelta,
    restSpeed = _ref.restSpeed,
    options = _objectWithoutProperties$1(_ref, _excluded$2g);
  var origin = keyframes[0];
  var target = keyframes[keyframes.length - 1];
  /**
   * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
   * to reduce GC during animation.
   */
  var state = {
    done: false,
    value: origin
  };
  var _getSpringOptions = getSpringOptions(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
      velocity: -millisecondsToSeconds(options.velocity || 0)
    })),
    stiffness = _getSpringOptions.stiffness,
    damping = _getSpringOptions.damping,
    mass = _getSpringOptions.mass,
    duration = _getSpringOptions.duration,
    velocity = _getSpringOptions.velocity,
    isResolvedFromDuration = _getSpringOptions.isResolvedFromDuration;
  var initialVelocity = velocity || 0.0;
  var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
  var initialDelta = target - origin;
  var undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
  /**
   * If we're working on a granular scale, use smaller defaults for determining
   * when the spring is finished.
   *
   * These defaults have been selected emprically based on what strikes a good
   * ratio between feeling good and finishing as soon as changes are imperceptible.
   */
  var isGranularScale = Math.abs(initialDelta) < 5;
  restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
  restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
  var resolveSpring;
  if (dampingRatio < 1) {
    var angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
    // Underdamped spring
    resolveSpring = function resolveSpring(t) {
      var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
    };
  } else if (dampingRatio === 1) {
    // Critically damped spring
    resolveSpring = function resolveSpring(t) {
      return target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    };
  } else {
    // Overdamped spring
    var dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
    resolveSpring = function resolveSpring(t) {
      var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      // When performing sinh or cosh values can hit Infinity so we cap them here
      var freqForT = Math.min(dampedAngularFreq * t, 300);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
    };
  }
  return {
    calculatedDuration: isResolvedFromDuration ? duration || null : null,
    next: function next(t) {
      var current = resolveSpring(t);
      if (!isResolvedFromDuration) {
        var currentVelocity = initialVelocity;
        if (t !== 0) {
          /**
           * We only need to calculate velocity for under-damped springs
           * as over- and critically-damped springs can't overshoot, so
           * checking only for displacement is enough.
           */
          if (dampingRatio < 1) {
            currentVelocity = calcGeneratorVelocity(resolveSpring, t, current);
          } else {
            currentVelocity = 0;
          }
        }
        var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        var isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state.done = t >= duration;
      }
      state.value = state.done ? target : current;
      return state;
    }
  };
}

function inertia(_ref) {
  var keyframes = _ref.keyframes,
    _ref$velocity = _ref.velocity,
    velocity = _ref$velocity === void 0 ? 0.0 : _ref$velocity,
    _ref$power = _ref.power,
    power = _ref$power === void 0 ? 0.8 : _ref$power,
    _ref$timeConstant = _ref.timeConstant,
    timeConstant = _ref$timeConstant === void 0 ? 325 : _ref$timeConstant,
    _ref$bounceDamping = _ref.bounceDamping,
    bounceDamping = _ref$bounceDamping === void 0 ? 10 : _ref$bounceDamping,
    _ref$bounceStiffness = _ref.bounceStiffness,
    bounceStiffness = _ref$bounceStiffness === void 0 ? 500 : _ref$bounceStiffness,
    modifyTarget = _ref.modifyTarget,
    min = _ref.min,
    max = _ref.max,
    _ref$restDelta = _ref.restDelta,
    restDelta = _ref$restDelta === void 0 ? 0.5 : _ref$restDelta,
    restSpeed = _ref.restSpeed;
  var origin = keyframes[0];
  var state = {
    done: false,
    value: origin
  };
  var isOutOfBounds = function isOutOfBounds(v) {
    return min !== undefined && v < min || max !== undefined && v > max;
  };
  var nearestBoundary = function nearestBoundary(v) {
    if (min === undefined) return max;
    if (max === undefined) return min;
    return Math.abs(min - v) < Math.abs(max - v) ? min : max;
  };
  var amplitude = power * velocity;
  var ideal = origin + amplitude;
  var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
  /**
   * If the target has changed we need to re-calculate the amplitude, otherwise
   * the animation will start from the wrong position.
   */
  if (target !== ideal) amplitude = target - origin;
  var calcDelta = function calcDelta(t) {
    return -amplitude * Math.exp(-t / timeConstant);
  };
  var calcLatest = function calcLatest(t) {
    return target + calcDelta(t);
  };
  var applyFriction = function applyFriction(t) {
    var delta = calcDelta(t);
    var latest = calcLatest(t);
    state.done = Math.abs(delta) <= restDelta;
    state.value = state.done ? target : latest;
  };
  /**
   * Ideally this would resolve for t in a stateless way, we could
   * do that by always precalculating the animation but as we know
   * this will be done anyway we can assume that spring will
   * be discovered during that.
   */
  var timeReachedBoundary;
  var spring$1;
  var checkCatchBoundary = function checkCatchBoundary(t) {
    if (!isOutOfBounds(state.value)) return;
    timeReachedBoundary = t;
    spring$1 = spring({
      keyframes: [state.value, nearestBoundary(state.value)],
      velocity: calcGeneratorVelocity(calcLatest, t, state.value),
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDelta: restDelta,
      restSpeed: restSpeed
    });
  };
  checkCatchBoundary(0);
  return {
    calculatedDuration: null,
    next: function next(t) {
      /**
       * We need to resolve the friction to figure out if we need a
       * spring but we don't want to do this twice per frame. So here
       * we flag if we updated for this frame and later if we did
       * we can skip doing it again.
       */
      var hasUpdatedFrame = false;
      if (!spring$1 && timeReachedBoundary === undefined) {
        hasUpdatedFrame = true;
        applyFriction(t);
        checkCatchBoundary(t);
      }
      /**
       * If we have a spring and the provided t is beyond the moment the friction
       * animation crossed the min/max boundary, use the spring.
       */
      if (timeReachedBoundary !== undefined && t > timeReachedBoundary) {
        return spring$1.next(t - timeReachedBoundary);
      } else {
        !hasUpdatedFrame && applyFriction(t);
        return state;
      }
    }
  };
}

var frameloopDriver = function frameloopDriver(update) {
  var passTimestamp = function passTimestamp(_ref) {
    var timestamp = _ref.timestamp;
    return update(timestamp);
  };
  return {
    start: function start() {
      return frame.update(passTimestamp, true);
    },
    stop: function stop() {
      return cancelFrame(passTimestamp);
    },
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: function now() {
      return frameData.isProcessing ? frameData.timestamp : performance.now();
    }
  };
};

/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
var maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
  var duration = 0;
  var timeStep = 50;
  var state = generator.next(duration);
  while (!state.done && duration < maxGeneratorDuration) {
    duration += timeStep;
    state = generator.next(duration);
  }
  return duration >= maxGeneratorDuration ? Infinity : duration;
}

var _excluded$2f = ["autoplay", "delay", "driver", "keyframes", "type", "repeat", "repeatDelay", "repeatType", "onPlay", "onStop", "onComplete", "onUpdate"];
var types = {
  decay: inertia,
  inertia: inertia,
  tween: keyframes$1,
  keyframes: keyframes$1,
  spring: spring
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */
function animateValue(_ref) {
  var _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    _ref$driver = _ref.driver,
    driver = _ref$driver === void 0 ? frameloopDriver : _ref$driver,
    keyframes$1$1 = _ref.keyframes,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "keyframes" : _ref$type,
    _ref$repeat = _ref.repeat,
    repeat = _ref$repeat === void 0 ? 0 : _ref$repeat,
    _ref$repeatDelay = _ref.repeatDelay,
    repeatDelay = _ref$repeatDelay === void 0 ? 0 : _ref$repeatDelay,
    _ref$repeatType = _ref.repeatType,
    repeatType = _ref$repeatType === void 0 ? "loop" : _ref$repeatType,
    onPlay = _ref.onPlay,
    onStop = _ref.onStop,
    onComplete = _ref.onComplete,
    onUpdate = _ref.onUpdate,
    options = _objectWithoutProperties$1(_ref, _excluded$2f);
  var speed = 1;
  var hasStopped = false;
  var resolveFinishedPromise;
  var currentFinishedPromise;
  /**
   * Resolve the current Promise every time we enter the
   * finished state. This is WAAPI-compatible behaviour.
   */
  var updateFinishedPromise = function updateFinishedPromise() {
    currentFinishedPromise = new Promise(function (resolve) {
      resolveFinishedPromise = resolve;
    });
  };
  // Create the first finished promise
  updateFinishedPromise();
  var animationDriver;
  var generatorFactory = types[type] || keyframes$1;
  /**
   * If this isn't the keyframes generator and we've been provided
   * strings as keyframes, we need to interpolate these.
   */
  var mapNumbersToKeyframes;
  if (generatorFactory !== keyframes$1 && typeof keyframes$1$1[0] !== "number") {
    if (process.env.NODE_ENV !== "production") {
      invariant(keyframes$1$1.length === 2, "Only two keyframes currently supported with spring and inertia animations. Trying to animate ".concat(keyframes$1$1));
    }
    mapNumbersToKeyframes = interpolate([0, 100], keyframes$1$1, {
      clamp: false
    });
    keyframes$1$1 = [0, 100];
  }
  var generator = generatorFactory(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
    keyframes: keyframes$1$1
  }));
  var mirroredGenerator;
  if (repeatType === "mirror") {
    mirroredGenerator = generatorFactory(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
      keyframes: _toConsumableArray$1(keyframes$1$1).reverse(),
      velocity: -(options.velocity || 0)
    }));
  }
  var playState = "idle";
  var holdTime = null;
  var startTime = null;
  var cancelTime = null;
  /**
   * If duration is undefined and we have repeat options,
   * we need to calculate a duration from the generator.
   *
   * We set it to the generator itself to cache the duration.
   * Any timeline resolver will need to have already precalculated
   * the duration by this step.
   */
  if (generator.calculatedDuration === null && repeat) {
    generator.calculatedDuration = calcGeneratorDuration(generator);
  }
  var calculatedDuration = generator.calculatedDuration;
  var resolvedDuration = Infinity;
  var totalDuration = Infinity;
  if (calculatedDuration !== null) {
    resolvedDuration = calculatedDuration + repeatDelay;
    totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
  }
  var currentTime = 0;
  var tick = function tick(timestamp) {
    if (startTime === null) return;
    /**
     * requestAnimationFrame timestamps can come through as lower than
     * the startTime as set by performance.now(). Here we prevent this,
     * though in the future it could be possible to make setting startTime
     * a pending operation that gets resolved here.
     */
    if (speed > 0) startTime = Math.min(startTime, timestamp);
    if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
    if (holdTime !== null) {
      currentTime = holdTime;
    } else {
      // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
      // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
      // example.
      currentTime = Math.round(timestamp - startTime) * speed;
    }
    // Rebase on delay
    var timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
    var isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
    currentTime = Math.max(timeWithoutDelay, 0);
    /**
     * If this animation has finished, set the current time
     * to the total duration.
     */
    if (playState === "finished" && holdTime === null) {
      currentTime = totalDuration;
    }
    var elapsed = currentTime;
    var frameGenerator = generator;
    if (repeat) {
      /**
       * Get the current progress (0-1) of the animation. If t is >
       * than duration we'll get values like 2.5 (midway through the
       * third iteration)
       */
      var progress = Math.min(currentTime, totalDuration) / resolvedDuration;
      /**
       * Get the current iteration (0 indexed). For instance the floor of
       * 2.5 is 2.
       */
      var currentIteration = Math.floor(progress);
      /**
       * Get the current progress of the iteration by taking the remainder
       * so 2.5 is 0.5 through iteration 2
       */
      var iterationProgress = progress % 1.0;
      /**
       * If iteration progress is 1 we count that as the end
       * of the previous iteration.
       */
      if (!iterationProgress && progress >= 1) {
        iterationProgress = 1;
      }
      iterationProgress === 1 && currentIteration--;
      currentIteration = Math.min(currentIteration, repeat + 1);
      /**
       * Reverse progress if we're not running in "normal" direction
       */
      var isOddIteration = Boolean(currentIteration % 2);
      if (isOddIteration) {
        if (repeatType === "reverse") {
          iterationProgress = 1 - iterationProgress;
          if (repeatDelay) {
            iterationProgress -= repeatDelay / resolvedDuration;
          }
        } else if (repeatType === "mirror") {
          frameGenerator = mirroredGenerator;
        }
      }
      elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
    }
    /**
     * If we're in negative time, set state as the initial keyframe.
     * This prevents delay: x, duration: 0 animations from finishing
     * instantly.
     */
    var state = isInDelayPhase ? {
      done: false,
      value: keyframes$1$1[0]
    } : frameGenerator.next(elapsed);
    if (mapNumbersToKeyframes) {
      state.value = mapNumbersToKeyframes(state.value);
    }
    var done = state.done;
    if (!isInDelayPhase && calculatedDuration !== null) {
      done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
    }
    var isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
    if (onUpdate) {
      onUpdate(state.value);
    }
    if (isAnimationFinished) {
      finish();
    }
    return state;
  };
  var stopAnimationDriver = function stopAnimationDriver() {
    animationDriver && animationDriver.stop();
    animationDriver = undefined;
  };
  var _cancel = function cancel() {
    playState = "idle";
    stopAnimationDriver();
    resolveFinishedPromise();
    updateFinishedPromise();
    startTime = cancelTime = null;
  };
  var finish = function finish() {
    playState = "finished";
    onComplete && onComplete();
    stopAnimationDriver();
    resolveFinishedPromise();
  };
  var play = function play() {
    if (hasStopped) return;
    if (!animationDriver) animationDriver = driver(tick);
    var now = animationDriver.now();
    onPlay && onPlay();
    if (holdTime !== null) {
      startTime = now - holdTime;
    } else if (!startTime || playState === "finished") {
      startTime = now;
    }
    if (playState === "finished") {
      updateFinishedPromise();
    }
    cancelTime = startTime;
    holdTime = null;
    /**
     * Set playState to running only after we've used it in
     * the previous logic.
     */
    playState = "running";
    animationDriver.start();
  };
  if (autoplay) {
    play();
  }
  var controls = {
    then: function then(resolve, reject) {
      return currentFinishedPromise.then(resolve, reject);
    },
    get time() {
      return millisecondsToSeconds(currentTime);
    },
    set time(newTime) {
      newTime = secondsToMilliseconds(newTime);
      currentTime = newTime;
      if (holdTime !== null || !animationDriver || speed === 0) {
        holdTime = newTime;
      } else {
        startTime = animationDriver.now() - newTime / speed;
      }
    },
    get duration() {
      var duration = generator.calculatedDuration === null ? calcGeneratorDuration(generator) : generator.calculatedDuration;
      return millisecondsToSeconds(duration);
    },
    get speed() {
      return speed;
    },
    set speed(newSpeed) {
      if (newSpeed === speed || !animationDriver) return;
      speed = newSpeed;
      controls.time = millisecondsToSeconds(currentTime);
    },
    get state() {
      return playState;
    },
    play: play,
    pause: function pause() {
      playState = "paused";
      holdTime = currentTime;
    },
    stop: function stop() {
      hasStopped = true;
      if (playState === "idle") return;
      playState = "idle";
      onStop && onStop();
      _cancel();
    },
    cancel: function cancel() {
      if (cancelTime !== null) tick(cancelTime);
      _cancel();
    },
    complete: function complete() {
      playState = "finished";
    },
    sample: function sample(elapsed) {
      startTime = 0;
      return tick(elapsed);
    }
  };
  return controls;
}

function memo(callback) {
  var result;
  return function () {
    if (result === undefined) result = callback();
    return result;
  };
}

var _excluded$2e = ["onUpdate", "onComplete"];
var supportsWaapi = memo(function () {
  return Object.hasOwnProperty.call(Element.prototype, "animate");
});
/**
 * A list of values that can be hardware-accelerated.
 */
var acceleratedValues = new Set(["opacity", "clipPath", "filter", "transform", "backgroundColor"]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
var sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
var maxDuration = 20000;
var requiresPregeneratedKeyframes = function requiresPregeneratedKeyframes(valueName, options) {
  return options.type === "spring" || valueName === "backgroundColor" || !isWaapiSupportedEasing(options.ease);
};
function createAcceleratedAnimation(value, valueName, _ref) {
  _ref.onUpdate;
    var onComplete = _ref.onComplete,
    options = _objectWithoutProperties$1(_ref, _excluded$2e);
  var canAccelerateAnimation = supportsWaapi() && acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
  if (!canAccelerateAnimation) return false;
  /**
   * TODO: Unify with js/index
   */
  var hasStopped = false;
  var resolveFinishedPromise;
  var currentFinishedPromise;
  /**
   * Cancelling an animation will write to the DOM. For safety we want to defer
   * this until the next `update` frame lifecycle. This flag tracks whether we
   * have a pending cancel, if so we shouldn't allow animations to finish.
   */
  var pendingCancel = false;
  /**
   * Resolve the current Promise every time we enter the
   * finished state. This is WAAPI-compatible behaviour.
   */
  var updateFinishedPromise = function updateFinishedPromise() {
    currentFinishedPromise = new Promise(function (resolve) {
      resolveFinishedPromise = resolve;
    });
  };
  // Create the first finished promise
  updateFinishedPromise();
  var keyframes = options.keyframes,
    _options$duration = options.duration,
    duration = _options$duration === void 0 ? 300 : _options$duration,
    ease = options.ease,
    times = options.times;
  /**
   * If this animation needs pre-generated keyframes then generate.
   */
  if (requiresPregeneratedKeyframes(valueName, options)) {
    var sampleAnimation = animateValue(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
      repeat: 0,
      delay: 0
    }));
    var state = {
      done: false,
      value: keyframes[0]
    };
    var pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */
    var t = 0;
    while (!state.done && t < maxDuration) {
      state = sampleAnimation.sample(t);
      pregeneratedKeyframes.push(state.value);
      t += sampleDelta;
    }
    times = undefined;
    keyframes = pregeneratedKeyframes;
    duration = t - sampleDelta;
    ease = "linear";
  }
  var animation = animateStyle(value.owner.current, valueName, keyframes, _objectSpread2$1(_objectSpread2$1({}, options), {}, {
    duration: duration,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: ease,
    times: times
  }));
  var cancelAnimation = function cancelAnimation() {
    pendingCancel = false;
    animation.cancel();
  };
  var safeCancel = function safeCancel() {
    pendingCancel = true;
    frame.update(cancelAnimation);
    resolveFinishedPromise();
    updateFinishedPromise();
  };
  /**
   * Prefer the `onfinish` prop as it's more widely supported than
   * the `finished` promise.
   *
   * Here, we synchronously set the provided MotionValue to the end
   * keyframe. If we didn't, when the WAAPI animation is finished it would
   * be removed from the element which would then revert to its old styles.
   */
  animation.onfinish = function () {
    if (pendingCancel) return;
    value.set(getFinalKeyframe(keyframes, options));
    onComplete && onComplete();
    safeCancel();
  };
  /**
   * Animation interrupt callback.
   */
  var controls = {
    then: function then(resolve, reject) {
      return currentFinishedPromise.then(resolve, reject);
    },
    attachTimeline: function attachTimeline(timeline) {
      animation.timeline = timeline;
      animation.onfinish = null;
      return noop$1;
    },
    get time() {
      return millisecondsToSeconds(animation.currentTime || 0);
    },
    set time(newTime) {
      animation.currentTime = secondsToMilliseconds(newTime);
    },
    get speed() {
      return animation.playbackRate;
    },
    set speed(newSpeed) {
      animation.playbackRate = newSpeed;
    },
    get duration() {
      return millisecondsToSeconds(duration);
    },
    play: function play() {
      if (hasStopped) return;
      animation.play();
      /**
       * Cancel any pending cancel tasks
       */
      cancelFrame(cancelAnimation);
    },
    pause: function pause() {
      return animation.pause();
    },
    stop: function stop() {
      hasStopped = true;
      if (animation.playState === "idle") return;
      /**
       * WAAPI doesn't natively have any interruption capabilities.
       *
       * Rather than read commited styles back out of the DOM, we can
       * create a renderless JS animation and sample it twice to calculate
       * its current value, "previous" value, and therefore allow
       * Motion to calculate velocity for any subsequent animation.
       */
      var currentTime = animation.currentTime;
      if (currentTime) {
        var _sampleAnimation = animateValue(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
          autoplay: false
        }));
        value.setWithVelocity(_sampleAnimation.sample(currentTime - sampleDelta).value, _sampleAnimation.sample(currentTime).value, sampleDelta);
      }
      safeCancel();
    },
    complete: function complete() {
      if (pendingCancel) return;
      animation.finish();
    },
    cancel: safeCancel
  };
  return controls;
}

function createInstantAnimation(_ref) {
  var keyframes = _ref.keyframes,
    delay = _ref.delay,
    onUpdate = _ref.onUpdate,
    onComplete = _ref.onComplete;
  var setValue = function setValue() {
    onUpdate && onUpdate(keyframes[keyframes.length - 1]);
    onComplete && onComplete();
    /**
     * TODO: As this API grows it could make sense to always return
     * animateValue. This will be a bigger project as animateValue
     * is frame-locked whereas this function resolves instantly.
     * This is a behavioural change and also has ramifications regarding
     * assumptions within tests.
     */
    return {
      time: 0,
      speed: 1,
      duration: 0,
      play: noop$1,
      pause: noop$1,
      stop: noop$1,
      then: function then(resolve) {
        resolve();
        return Promise.resolve();
      },
      cancel: noop$1,
      complete: noop$1
    };
  };
  return delay ? animateValue({
    keyframes: [0, 1],
    duration: 0,
    delay: delay,
    onComplete: setValue
  }) : setValue();
}

var underDampedSpring = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
};
var criticallyDampedSpring = function criticallyDampedSpring(target) {
  return {
    type: "spring",
    stiffness: 550,
    damping: target === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
};
var keyframesTransition = {
  type: "keyframes",
  duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */
var ease = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
};
var getDefaultTransition = function getDefaultTransition(valueKey, _ref) {
  var keyframes = _ref.keyframes;
  if (keyframes.length > 2) {
    return keyframesTransition;
  } else if (transformProps.has(valueKey)) {
    return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes[1]) : underDampedSpring;
  }
  return ease;
};

/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
var isAnimatable = function isAnimatable(key, value) {
  // If the list of keys tat might be non-animatable grows, replace with Set
  if (key === "zIndex") return false;
  // If it's a number or a keyframes array, we can animate it. We might at some point
  // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
  // but for now lets leave it like this for performance reasons
  if (typeof value === "number" || Array.isArray(value)) return true;
  if (typeof value === "string" && (
  // It's animatable if we have a string
  complex.test(value) || value === "0") &&
  // And it contains numbers and/or colors
  !value.startsWith("url(") // Unless it starts with "url("
  ) {
    return true;
  }
  return false;
};

/**
 * Properties that should default to 1 or 100%
 */
var maxDefaults = new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
  var _v$slice$split = v.slice(0, -1).split("("),
    _v$slice$split2 = _slicedToArray$1(_v$slice$split, 2),
    name = _v$slice$split2[0],
    value = _v$slice$split2[1];
  if (name === "drop-shadow") return v;
  var _ref = value.match(floatRegex) || [],
    _ref2 = _slicedToArray$1(_ref, 1),
    number = _ref2[0];
  if (!number) return v;
  var unit = value.replace(number, "");
  var defaultValue = maxDefaults.has(name) ? 1 : 0;
  if (number !== value) defaultValue *= 100;
  return name + "(" + defaultValue + unit + ")";
}
var functionRegex = /([a-z-]*)\(.*?\)/g;
var filter = _objectSpread2$1(_objectSpread2$1({}, complex), {}, {
  getAnimatableNone: function getAnimatableNone(v) {
    var functions = v.match(functionRegex);
    return functions ? functions.map(applyDefaultFilter).join(" ") : v;
  }
});

/**
 * A map of default value types for common values
 */
var defaultValueTypes = _objectSpread2$1(_objectSpread2$1({}, numberValueTypes), {}, {
  // Color props
  color: color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter: filter,
  WebkitFilter: filter
});
/**
 * Gets the default ValueType for the provided value key
 */
var getDefaultValueType = function getDefaultValueType(key) {
  return defaultValueTypes[key];
};

function getAnimatableNone(key, value) {
  var defaultValueType = getDefaultValueType(key);
  if (defaultValueType !== filter) defaultValueType = complex;
  // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
  return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
var isZeroValueString = function isZeroValueString(v) {
  return /^0[^.\s]+$/.test(v);
};

function isNone(value) {
  if (typeof value === "number") {
    return value === 0;
  } else if (value !== null) {
    return value === "none" || value === "0" || isZeroValueString(value);
  }
}

function getKeyframes(value, valueName, target, transition) {
  var isTargetAnimatable = isAnimatable(valueName, target);
  var keyframes;
  if (Array.isArray(target)) {
    keyframes = _toConsumableArray$1(target);
  } else {
    keyframes = [null, target];
  }
  var defaultOrigin = transition.from !== undefined ? transition.from : value.get();
  var animatableTemplateValue = undefined;
  var noneKeyframeIndexes = [];
  for (var i = 0; i < keyframes.length; i++) {
    /**
     * Fill null/wildcard keyframes
     */
    if (keyframes[i] === null) {
      keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
    }
    if (isNone(keyframes[i])) {
      noneKeyframeIndexes.push(i);
    }
    // TODO: Clean this conditional, it works for now
    if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") {
      animatableTemplateValue = keyframes[i];
    }
  }
  if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) {
    for (var _i = 0; _i < noneKeyframeIndexes.length; _i++) {
      var index = noneKeyframeIndexes[_i];
      keyframes[index] = getAnimatableNone(valueName, animatableTemplateValue);
    }
  }
  return keyframes;
}

var _excluded$2d = ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from", "elapsed"];
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined(_ref) {
  _ref.when;
    _ref.delay;
    _ref.delayChildren;
    _ref.staggerChildren;
    _ref.staggerDirection;
    _ref.repeat;
    _ref.repeatType;
    _ref.repeatDelay;
    _ref.from;
    _ref.elapsed;
    var transition = _objectWithoutProperties$1(_ref, _excluded$2d);
  return !!Object.keys(transition).length;
}
function getValueTransition(transition, key) {
  return transition[key] || transition["default"] || transition;
}

var MotionGlobalConfig = {
  skipAnimations: false
};

var animateMotionValue = function animateMotionValue(valueName, value, target) {
  var transition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return function (_onComplete) {
    var valueTransition = getValueTransition(transition, valueName) || {};
    /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */
    var delay = valueTransition.delay || transition.delay || 0;
    /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */
    var _transition$elapsed = transition.elapsed,
      elapsed = _transition$elapsed === void 0 ? 0 : _transition$elapsed;
    elapsed = elapsed - secondsToMilliseconds(delay);
    var keyframes = getKeyframes(value, valueName, target, valueTransition);
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */
    var originKeyframe = keyframes[0];
    var targetKeyframe = keyframes[keyframes.length - 1];
    var isOriginAnimatable = isAnimatable(valueName, originKeyframe);
    var isTargetAnimatable = isAnimatable(valueName, targetKeyframe);
    warning(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(valueName, " from \"").concat(originKeyframe, "\" to \"").concat(targetKeyframe, "\". ").concat(originKeyframe, " is not an animatable value - to enable this animation set ").concat(originKeyframe, " to a value animatable to ").concat(targetKeyframe, " via the `style` property."));
    var options = _objectSpread2$1(_objectSpread2$1({
      keyframes: keyframes,
      velocity: value.getVelocity(),
      ease: "easeOut"
    }, valueTransition), {}, {
      delay: -elapsed,
      onUpdate: function onUpdate(v) {
        value.set(v);
        valueTransition.onUpdate && valueTransition.onUpdate(v);
      },
      onComplete: function onComplete() {
        _onComplete();
        valueTransition.onComplete && valueTransition.onComplete();
      }
    });
    /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */
    if (!isTransitionDefined(valueTransition)) {
      options = _objectSpread2$1(_objectSpread2$1({}, options), getDefaultTransition(valueName, options));
    }
    /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */
    if (options.duration) {
      options.duration = secondsToMilliseconds(options.duration);
    }
    if (options.repeatDelay) {
      options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
    }
    if (!isOriginAnimatable || !isTargetAnimatable || instantAnimationState.current || valueTransition.type === false || MotionGlobalConfig.skipAnimations) {
      /**
       * If we can't animate this value, or the global instant animation flag is set,
       * or this is simply defined as an instant transition, return an instant transition.
       */
      return createInstantAnimation(options);
    }
    /**
     * Animate via WAAPI if possible.
     */
    if (
    /**
     * If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    !transition.isHandoff && value.owner && value.owner.current instanceof HTMLElement &&
    /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !value.owner.getProps().onUpdate) {
      var acceleratedAnimation = createAcceleratedAnimation(value, valueName, options);
      if (acceleratedAnimation) return acceleratedAnimation;
    }
    /**
     * If we didn't create an accelerated animation, create a JS animation
     */
    return animateValue(options);
  };
};

function isWillChangeMotionValue(value) {
  return Boolean(isMotionValue(value) && value.add);
}

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
var isNumericalString = function isNumericalString(v) {
  return /^\-?\d*\.?\d+$/.test(v);
};

function addUniqueItem(arr, item) {
  if (arr.indexOf(item) === -1) arr.push(item);
}
function removeItem(arr, item) {
  var index = arr.indexOf(item);
  if (index > -1) arr.splice(index, 1);
}

var SubscriptionManager = /*#__PURE__*/function () {
  function SubscriptionManager() {
    _classCallCheck$1(this, SubscriptionManager);
    this.subscriptions = [];
  }
  return _createClass$1(SubscriptionManager, [{
    key: "add",
    value: function add(handler) {
      var _this = this;
      addUniqueItem(this.subscriptions, handler);
      return function () {
        return removeItem(_this.subscriptions, handler);
      };
    }
  }, {
    key: "notify",
    value: function notify(a, b, c) {
      var numSubscriptions = this.subscriptions.length;
      if (!numSubscriptions) return;
      if (numSubscriptions === 1) {
        /**
         * If there's only a single handler we can just call it without invoking a loop.
         */
        this.subscriptions[0](a, b, c);
      } else {
        for (var i = 0; i < numSubscriptions; i++) {
          /**
           * Check whether the handler exists before firing as it's possible
           * the subscriptions were modified during this loop running.
           */
          var handler = this.subscriptions[i];
          handler && handler(a, b, c);
        }
      }
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return this.subscriptions.length;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.subscriptions.length = 0;
    }
  }]);
}();

var warned = new Set();
function warnOnce(condition, message, element) {
  if (condition || warned.has(message)) return;
  console.warn(message);
  warned.add(message);
}

var isFloat = function isFloat(value) {
  return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
var MotionValue = /*#__PURE__*/function () {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  function MotionValue(init) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck$1(this, MotionValue);
    /**
     * This will be replaced by the build step with the latest version number.
     * When MotionValues are provided to motion components, warn if versions are mixed.
     */
    this.version = "10.18.0";
    /**
     * Duration, in milliseconds, since last updating frame.
     *
     * @internal
     */
    this.timeDelta = 0;
    /**
     * Timestamp of the last time this `MotionValue` was updated.
     *
     * @internal
     */
    this.lastUpdated = 0;
    /**
     * Tracks whether this value can output a velocity. Currently this is only true
     * if the value is numerical, but we might be able to widen the scope here and support
     * other value types.
     *
     * @internal
     */
    this.canTrackVelocity = false;
    /**
     * An object containing a SubscriptionManager for each active event.
     */
    this.events = {};
    this.updateAndNotify = function (v) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      _this.prev = _this.current;
      _this.current = v;
      // Update timestamp
      var delta = frameData.delta,
        timestamp = frameData.timestamp;
      if (_this.lastUpdated !== timestamp) {
        _this.timeDelta = delta;
        _this.lastUpdated = timestamp;
        frame.postRender(_this.scheduleVelocityCheck);
      }
      // Update update subscribers
      if (_this.prev !== _this.current && _this.events.change) {
        _this.events.change.notify(_this.current);
      }
      // Update velocity subscribers
      if (_this.events.velocityChange) {
        _this.events.velocityChange.notify(_this.getVelocity());
      }
      // Update render subscribers
      if (render && _this.events.renderRequest) {
        _this.events.renderRequest.notify(_this.current);
      }
    };
    /**
     * Schedule a velocity check for the next frame.
     *
     * This is an instanced and bound function to prevent generating a new
     * function once per frame.
     *
     * @internal
     */
    this.scheduleVelocityCheck = function () {
      return frame.postRender(_this.velocityCheck);
    };
    /**
     * Updates `prev` with `current` if the value hasn't been updated this frame.
     * This ensures velocity calculations return `0`.
     *
     * This is an instanced and bound function to prevent generating a new
     * function once per frame.
     *
     * @internal
     */
    this.velocityCheck = function (_ref) {
      var timestamp = _ref.timestamp;
      if (timestamp !== _this.lastUpdated) {
        _this.prev = _this.current;
        if (_this.events.velocityChange) {
          _this.events.velocityChange.notify(_this.getVelocity());
        }
      }
    };
    this.hasAnimated = false;
    this.prev = this.current = init;
    this.canTrackVelocity = isFloat(this.current);
    this.owner = options.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  return _createClass$1(MotionValue, [{
    key: "onChange",
    value: function onChange(subscription) {
      if (process.env.NODE_ENV !== "production") {
        warnOnce(false, "value.onChange(callback) is deprecated. Switch to value.on(\"change\", callback).");
      }
      return this.on("change", subscription);
    }
  }, {
    key: "on",
    value: function on(eventName, callback) {
      var _this2 = this;
      if (!this.events[eventName]) {
        this.events[eventName] = new SubscriptionManager();
      }
      var unsubscribe = this.events[eventName].add(callback);
      if (eventName === "change") {
        return function () {
          unsubscribe();
          /**
           * If we have no more change listeners by the start
           * of the next frame, stop active animations.
           */
          frame.read(function () {
            if (!_this2.events.change.getSize()) {
              _this2.stop();
            }
          });
        };
      }
      return unsubscribe;
    }
  }, {
    key: "clearListeners",
    value: function clearListeners() {
      for (var eventManagers in this.events) {
        this.events[eventManagers].clear();
      }
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
  }, {
    key: "attach",
    value: function attach(passiveEffect, stopPassiveEffect) {
      this.passiveEffect = passiveEffect;
      this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
  }, {
    key: "set",
    value: function set(v) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!render || !this.passiveEffect) {
        this.updateAndNotify(v, render);
      } else {
        this.passiveEffect(v, this.updateAndNotify);
      }
    }
  }, {
    key: "setWithVelocity",
    value: function setWithVelocity(prev, current, delta) {
      this.set(current);
      this.prev = prev;
      this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */
  }, {
    key: "jump",
    value: function jump(v) {
      this.updateAndNotify(v);
      this.prev = v;
      this.stop();
      if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
  }, {
    key: "get",
    value: function get() {
      return this.current;
    }
    /**
     * @public
     */
  }, {
    key: "getPrevious",
    value: function getPrevious() {
      return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
  }, {
    key: "getVelocity",
    value: function getVelocity() {
      // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
      return this.canTrackVelocity ?
      // These casts could be avoided if parseFloat would be typed better
      velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
  }, {
    key: "start",
    value: function start(startAnimation) {
      var _this3 = this;
      this.stop();
      return new Promise(function (resolve) {
        _this3.hasAnimated = true;
        _this3.animation = startAnimation(resolve);
        if (_this3.events.animationStart) {
          _this3.events.animationStart.notify();
        }
      }).then(function () {
        if (_this3.events.animationComplete) {
          _this3.events.animationComplete.notify();
        }
        _this3.clearAnimation();
      });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */
  }, {
    key: "stop",
    value: function stop() {
      if (this.animation) {
        this.animation.stop();
        if (this.events.animationCancel) {
          this.events.animationCancel.notify();
        }
      }
      this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
  }, {
    key: "isAnimating",
    value: function isAnimating() {
      return !!this.animation;
    }
  }, {
    key: "clearAnimation",
    value: function clearAnimation() {
      delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.clearListeners();
      this.stop();
      if (this.stopPassiveEffect) {
        this.stopPassiveEffect();
      }
    }
  }]);
}();
function motionValue(init, options) {
  return new MotionValue(init, options);
}

/**
 * Tests a provided value against a ValueType
 */
var testValueType = function testValueType(v) {
  return function (type) {
    return type.test(v);
  };
};

/**
 * ValueType for "auto"
 */
var auto$1 = {
  test: function test(v) {
    return v === "auto";
  },
  parse: function parse(v) {
    return v;
  }
};

/**
 * A list of value types commonly used for dimensions
 */
var dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto$1];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
var findDimensionValueType = function findDimensionValueType(v) {
  return dimensionValueTypes.find(testValueType(v));
};

/**
 * A list of all ValueTypes
 */
var valueTypes = [].concat(_toConsumableArray$1(dimensionValueTypes), [color, complex]);
/**
 * Tests a value against the list of ValueTypes
 */
var findValueType = function findValueType(v) {
  return valueTypes.find(testValueType(v));
};

var _excluded$2c = ["transitionEnd", "transition"];

/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
  if (visualElement.hasValue(key)) {
    visualElement.getValue(key).set(value);
  } else {
    visualElement.addValue(key, motionValue(value));
  }
}
function setTarget(visualElement, definition) {
  var resolved = resolveVariant(visualElement, definition);
  var _ref = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {},
    _ref$transitionEnd = _ref.transitionEnd,
    transitionEnd = _ref$transitionEnd === void 0 ? {} : _ref$transitionEnd;
    _ref.transition;
    var target = _objectWithoutProperties$1(_ref, _excluded$2c);
  target = _objectSpread2$1(_objectSpread2$1({}, target), transitionEnd);
  for (var key in target) {
    var value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement, key, value);
  }
}
function checkTargetForNewValues(visualElement, target, origin) {
  var _a, _b;
  var newValueKeys = Object.keys(target).filter(function (key) {
    return !visualElement.hasValue(key);
  });
  var numNewValues = newValueKeys.length;
  if (!numNewValues) return;
  for (var i = 0; i < numNewValues; i++) {
    var key = newValueKeys[i];
    var targetValue = target[key];
    var value = null;
    /**
     * If the target is a series of keyframes, we can use the first value
     * in the array. If this first value is null, we'll still need to read from the DOM.
     */
    if (Array.isArray(targetValue)) {
      value = targetValue[0];
    }
    /**
     * If the target isn't keyframes, or the first keyframe was null, we need to
     * first check if an origin value was explicitly defined in the transition as "from",
     * if not read the value from the DOM. As an absolute fallback, take the defined target value.
     */
    if (value === null) {
      value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
    }
    /**
     * If value is still undefined or null, ignore it. Preferably this would throw,
     * but this was causing issues in Framer.
     */
    if (value === undefined || value === null) continue;
    if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) {
      // If this is a number read as a string, ie "0" or "200", convert it to a number
      value = parseFloat(value);
    } else if (!findValueType(value) && complex.test(targetValue)) {
      value = getAnimatableNone(key, targetValue);
    }
    visualElement.addValue(key, motionValue(value, {
      owner: visualElement
    }));
    if (origin[key] === undefined) {
      origin[key] = value;
    }
    if (value !== null) visualElement.setBaseTarget(key, value);
  }
}
function getOriginFromTransition(key, transition) {
  if (!transition) return;
  var valueTransition = transition[key] || transition["default"] || transition;
  return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
  var origin = {};
  for (var key in target) {
    var transitionOrigin = getOriginFromTransition(key, transition);
    if (transitionOrigin !== undefined) {
      origin[key] = transitionOrigin;
    } else {
      var value = visualElement.getValue(key);
      if (value) {
        origin[key] = value.get();
      }
    }
  }
  return origin;
}

var _excluded$2b = ["transition", "transitionEnd"];

/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation(_ref, key) {
  var protectedKeys = _ref.protectedKeys,
    needsAnimating = _ref.needsAnimating;
  var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}
function hasKeyframesChanged(value, target) {
  var current = value.get();
  if (Array.isArray(target)) {
    for (var i = 0; i < target.length; i++) {
      if (target[i] !== current) return true;
    }
  } else {
    return current !== target;
  }
}
function animateTarget(visualElement, definition) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref2$delay = _ref2.delay,
    delay = _ref2$delay === void 0 ? 0 : _ref2$delay,
    transitionOverride = _ref2.transitionOverride,
    type = _ref2.type;
  var _visualElement$makeTa = visualElement.makeTargetAnimatable(definition),
    _visualElement$makeTa2 = _visualElement$makeTa.transition,
    transition = _visualElement$makeTa2 === void 0 ? visualElement.getDefaultTransition() : _visualElement$makeTa2,
    transitionEnd = _visualElement$makeTa.transitionEnd,
    target = _objectWithoutProperties$1(_visualElement$makeTa, _excluded$2b);
  var willChange = visualElement.getValue("willChange");
  if (transitionOverride) transition = transitionOverride;
  var animations = [];
  var animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
  var _loop = function _loop(key) {
      var value = visualElement.getValue(key);
      var valueTarget = target[key];
      if (!value || valueTarget === undefined || animationTypeState && shouldBlockAnimation(animationTypeState, key)) {
        return 0; // continue
      }
      var valueTransition = _objectSpread2$1({
        delay: delay,
        elapsed: 0
      }, getValueTransition(transition || {}, key));
      /**
       * If this is the first time a value is being animated, check
       * to see if we're handling off from an existing animation.
       */
      if (window.HandoffAppearAnimations) {
        var appearId = visualElement.getProps()[optimizedAppearDataAttribute];
        if (appearId) {
          var elapsed = window.HandoffAppearAnimations(appearId, key, value, frame);
          if (elapsed !== null) {
            valueTransition.elapsed = elapsed;
            valueTransition.isHandoff = true;
          }
        }
      }
      var canSkip = !valueTransition.isHandoff && !hasKeyframesChanged(value, valueTarget);
      if (valueTransition.type === "spring" && (value.getVelocity() || valueTransition.velocity)) {
        canSkip = false;
      }
      /**
       * Temporarily disable skipping animations if there's an animation in
       * progress. Better would be to track the current target of a value
       * and compare that against valueTarget.
       */
      if (value.animation) {
        canSkip = false;
      }
      if (canSkip) return 0; // continue
      value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && transformProps.has(key) ? {
        type: false
      } : valueTransition));
      var animation = value.animation;
      if (isWillChangeMotionValue(willChange)) {
        willChange.add(key);
        animation.then(function () {
          return willChange.remove(key);
        });
      }
      animations.push(animation);
    },
    _ret;
  for (var key in target) {
    _ret = _loop(key);
    if (_ret === 0) continue;
  }
  if (transitionEnd) {
    Promise.all(animations).then(function () {
      transitionEnd && setTarget(visualElement, transitionEnd);
    });
  }
  return animations;
}

function animateVariant(visualElement, variant) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var resolved = resolveVariant(visualElement, variant, options.custom);
  var _ref = resolved || {},
    _ref$transition = _ref.transition,
    transition = _ref$transition === void 0 ? visualElement.getDefaultTransition() || {} : _ref$transition;
  if (options.transitionOverride) {
    transition = options.transitionOverride;
  }
  /**
   * If we have a variant, create a callback that runs it as an animation.
   * Otherwise, we resolve a Promise immediately for a composable no-op.
   */
  var getAnimation = resolved ? function () {
    return Promise.all(animateTarget(visualElement, resolved, options));
  } : function () {
    return Promise.resolve();
  };
  /**
   * If we have children, create a callback that runs all their animations.
   * Otherwise, we resolve a Promise immediately for a composable no-op.
   */
  var getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? function () {
    var forwardDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var _transition = transition,
      _transition$delayChil = _transition.delayChildren,
      delayChildren = _transition$delayChil === void 0 ? 0 : _transition$delayChil,
      staggerChildren = _transition.staggerChildren,
      staggerDirection = _transition.staggerDirection;
    return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
  } : function () {
    return Promise.resolve();
  };
  /**
   * If the transition explicitly defines a "when" option, we need to resolve either
   * this animation or all children animations before playing the other.
   */
  var _transition2 = transition,
    when = _transition2.when;
  if (when) {
    var _ref2 = when === "beforeChildren" ? [getAnimation, getChildAnimations] : [getChildAnimations, getAnimation],
      _ref3 = _slicedToArray$1(_ref2, 2),
      first = _ref3[0],
      last = _ref3[1];
    return first().then(function () {
      return last();
    });
  } else {
    return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
  }
}
function animateChildren(visualElement, variant) {
  var delayChildren = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var staggerChildren = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var staggerDirection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var options = arguments.length > 5 ? arguments[5] : undefined;
  var animations = [];
  var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
  var generateStaggerDuration = staggerDirection === 1 ? function () {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return i * staggerChildren;
  } : function () {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return maxStaggerDuration - i * staggerChildren;
  };
  Array.from(visualElement.variantChildren).sort(sortByTreeOrder).forEach(function (child, i) {
    child.notify("AnimationStart", variant);
    animations.push(animateVariant(child, variant, _objectSpread2$1(_objectSpread2$1({}, options), {}, {
      delay: delayChildren + generateStaggerDuration(i)
    })).then(function () {
      return child.notify("AnimationComplete", variant);
    }));
  });
  return Promise.all(animations);
}
function sortByTreeOrder(a, b) {
  return a.sortNodePosition(b);
}

function animateVisualElement(visualElement, definition) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  visualElement.notify("AnimationStart", definition);
  var animation;
  if (Array.isArray(definition)) {
    var animations = definition.map(function (variant) {
      return animateVariant(visualElement, variant, options);
    });
    animation = Promise.all(animations);
  } else if (typeof definition === "string") {
    animation = animateVariant(visualElement, definition, options);
  } else {
    var resolvedDefinition = typeof definition === "function" ? resolveVariant(visualElement, definition, options.custom) : definition;
    animation = Promise.all(animateTarget(visualElement, resolvedDefinition, options));
  }
  return animation.then(function () {
    return visualElement.notify("AnimationComplete", definition);
  });
}

var _excluded$2a = ["transition", "transitionEnd"];
var reversePriorityOrder = _toConsumableArray$1(variantPriorityOrder).reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
  return function (animations) {
    return Promise.all(animations.map(function (_ref) {
      var animation = _ref.animation,
        options = _ref.options;
      return animateVisualElement(visualElement, animation, options);
    }));
  };
}
function createAnimationState(visualElement) {
  var animate = animateList(visualElement);
  var state = createState();
  var isInitialRender = true;
  /**
   * This function will be used to reduce the animation definitions for
   * each active animation type into an object of resolved values for it.
   */
  var buildResolvedTypeValues = function buildResolvedTypeValues(acc, definition) {
    var resolved = resolveVariant(visualElement, definition);
    if (resolved) {
      resolved.transition;
        var transitionEnd = resolved.transitionEnd,
        target = _objectWithoutProperties$1(resolved, _excluded$2a);
      acc = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, acc), target), transitionEnd);
    }
    return acc;
  };
  /**
   * This just allows us to inject mocked animation functions
   * @internal
   */
  function setAnimateFunction(makeAnimator) {
    animate = makeAnimator(visualElement);
  }
  /**
   * When we receive new props, we need to:
   * 1. Create a list of protected keys for each type. This is a directory of
   *    value keys that are currently being "handled" by types of a higher priority
   *    so that whenever an animation is played of a given type, these values are
   *    protected from being animated.
   * 2. Determine if an animation type needs animating.
   * 3. Determine if any values have been removed from a type and figure out
   *    what to animate those to.
   */
  function animateChanges(options, changedActiveType) {
    var props = visualElement.getProps();
    var context = visualElement.getVariantContext(true) || {};
    /**
     * A list of animations that we'll build into as we iterate through the animation
     * types. This will get executed at the end of the function.
     */
    var animations = [];
    /**
     * Keep track of which values have been removed. Then, as we hit lower priority
     * animation types, we can check if they contain removed values and animate to that.
     */
    var removedKeys = new Set();
    /**
     * A dictionary of all encountered keys. This is an object to let us build into and
     * copy it without iteration. Each time we hit an animation type we set its protected
     * keys - the keys its not allowed to animate - to the latest version of this object.
     */
    var encounteredKeys = {};
    /**
     * If a variant has been removed at a given index, and this component is controlling
     * variant animations, we want to ensure lower-priority variants are forced to animate.
     */
    var removedVariantIndex = Infinity;
    /**
     * Iterate through all animation types in reverse priority order. For each, we want to
     * detect which values it's handling and whether or not they've changed (and therefore
     * need to be animated). If any values have been removed, we want to detect those in
     * lower priority props and flag for animation.
     */
    var _loop = function _loop() {
      var type = reversePriorityOrder[i];
      var typeState = state[type];
      var prop = props[type] !== undefined ? props[type] : context[type];
      var propIsVariant = isVariantLabel(prop);
      /**
       * If this type has *just* changed isActive status, set activeDelta
       * to that status. Otherwise set to null.
       */
      var activeDelta = type === changedActiveType ? typeState.isActive : null;
      if (activeDelta === false) removedVariantIndex = i;
      /**
       * If this prop is an inherited variant, rather than been set directly on the
       * component itself, we want to make sure we allow the parent to trigger animations.
       *
       * TODO: Can probably change this to a !isControllingVariants check
       */
      var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
      /**
       *
       */
      if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) {
        isInherited = false;
      }
      /**
       * Set all encountered keys so far as the protected keys for this type. This will
       * be any key that has been animated or otherwise handled by active, higher-priortiy types.
       */
      typeState.protectedKeys = _objectSpread2$1({}, encounteredKeys);
      // Check if we can skip analysing this prop early
      if (
      // If it isn't active and hasn't *just* been set as inactive
      !typeState.isActive && activeDelta === null ||
      // If we didn't and don't have any defined prop for this animation type
      !prop && !typeState.prevProp ||
      // Or if the prop doesn't define an animation
      isAnimationControls(prop) || typeof prop === "boolean") {
        return 1; // continue
      }
      /**
       * As we go look through the values defined on this type, if we detect
       * a changed value or a value that was removed in a higher priority, we set
       * this to true and add this prop to the animation list.
       */
      var variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
      var shouldAnimateType = variantDidChange ||
      // If we're making this variant active, we want to always make it active
      type === changedActiveType && typeState.isActive && !isInherited && propIsVariant ||
      // If we removed a higher-priority variant (i is in reverse order)
      i > removedVariantIndex && propIsVariant;
      var handledRemovedValues = false;
      /**
       * As animations can be set as variant lists, variants or target objects, we
       * coerce everything to an array if it isn't one already
       */
      var definitionList = Array.isArray(prop) ? prop : [prop];
      /**
       * Build an object of all the resolved values. We'll use this in the subsequent
       * animateChanges calls to determine whether a value has changed.
       */
      var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
      if (activeDelta === false) resolvedValues = {};
      /**
       * Now we need to loop through all the keys in the prev prop and this prop,
       * and decide:
       * 1. If the value has changed, and needs animating
       * 2. If it has been removed, and needs adding to the removedKeys set
       * 3. If it has been removed in a higher priority type and needs animating
       * 4. If it hasn't been removed in a higher priority but hasn't changed, and
       *    needs adding to the type's protectedKeys list.
       */
      var _typeState$prevResolv = typeState.prevResolvedValues,
        prevResolvedValues = _typeState$prevResolv === void 0 ? {} : _typeState$prevResolv;
      var allKeys = _objectSpread2$1(_objectSpread2$1({}, prevResolvedValues), resolvedValues);
      var markToAnimate = function markToAnimate(key) {
        shouldAnimateType = true;
        if (removedKeys.has(key)) {
          handledRemovedValues = true;
          removedKeys["delete"](key);
        }
        typeState.needsAnimating[key] = true;
      };
      for (var key in allKeys) {
        var next = resolvedValues[key];
        var prev = prevResolvedValues[key];
        // If we've already handled this we can just skip ahead
        if (encounteredKeys.hasOwnProperty(key)) continue;
        /**
         * If the value has changed, we probably want to animate it.
         */
        var valueHasChanged = false;
        if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
          valueHasChanged = !shallowCompare(next, prev);
        } else {
          valueHasChanged = next !== prev;
        }
        if (valueHasChanged) {
          if (next !== undefined) {
            // If next is defined and doesn't equal prev, it needs animating
            markToAnimate(key);
          } else {
            // If it's undefined, it's been removed.
            removedKeys.add(key);
          }
        } else if (next !== undefined && removedKeys.has(key)) {
          /**
           * If next hasn't changed and it isn't undefined, we want to check if it's
           * been removed by a higher priority
           */
          markToAnimate(key);
        } else {
          /**
           * If it hasn't changed, we add it to the list of protected values
           * to ensure it doesn't get animated.
           */
          typeState.protectedKeys[key] = true;
        }
      }
      /**
       * Update the typeState so next time animateChanges is called we can compare the
       * latest prop and resolvedValues to these.
       */
      typeState.prevProp = prop;
      typeState.prevResolvedValues = resolvedValues;
      /**
       *
       */
      if (typeState.isActive) {
        encounteredKeys = _objectSpread2$1(_objectSpread2$1({}, encounteredKeys), resolvedValues);
      }
      if (isInitialRender && visualElement.blockInitialAnimation) {
        shouldAnimateType = false;
      }
      /**
       * If this is an inherited prop we want to hard-block animations
       */
      if (shouldAnimateType && (!isInherited || handledRemovedValues)) {
        animations.push.apply(animations, _toConsumableArray$1(definitionList.map(function (animation) {
          return {
            animation: animation,
            options: _objectSpread2$1({
              type: type
            }, options)
          };
        })));
      }
    };
    for (var i = 0; i < numAnimationTypes; i++) {
      if (_loop()) continue;
    }
    /**
     * If there are some removed value that haven't been dealt with,
     * we need to create a new animation that falls back either to the value
     * defined in the style prop, or the last read value.
     */
    if (removedKeys.size) {
      var fallbackAnimation = {};
      removedKeys.forEach(function (key) {
        var fallbackTarget = visualElement.getBaseTarget(key);
        if (fallbackTarget !== undefined) {
          fallbackAnimation[key] = fallbackTarget;
        }
      });
      animations.push({
        animation: fallbackAnimation
      });
    }
    var shouldAnimate = Boolean(animations.length);
    if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) {
      shouldAnimate = false;
    }
    isInitialRender = false;
    return shouldAnimate ? animate(animations) : Promise.resolve();
  }
  /**
   * Change whether a certain animation type is active.
   */
  function setActive(type, isActive, options) {
    var _a;
    // If the active state hasn't changed, we can safely do nothing here
    if (state[type].isActive === isActive) return Promise.resolve();
    // Propagate active change to children
    (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
      var _a;
      return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
    });
    state[type].isActive = isActive;
    var animations = animateChanges(options, type);
    for (var key in state) {
      state[key].protectedKeys = {};
    }
    return animations;
  }
  return {
    animateChanges: animateChanges,
    setActive: setActive,
    setAnimateFunction: setAnimateFunction,
    getState: function getState() {
      return state;
    }
  };
}
function checkVariantsDidChange(prev, next) {
  if (typeof next === "string") {
    return next !== prev;
  } else if (Array.isArray(next)) {
    return !shallowCompare(next, prev);
  }
  return false;
}
function createTypeState() {
  var isActive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    isActive: isActive,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  return {
    animate: createTypeState(true),
    whileInView: createTypeState(),
    whileHover: createTypeState(),
    whileTap: createTypeState(),
    whileDrag: createTypeState(),
    whileFocus: createTypeState(),
    exit: createTypeState()
  };
}

var AnimationFeature = /*#__PURE__*/function (_Feature) {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  function AnimationFeature(node) {
    var _this;
    _classCallCheck$1(this, AnimationFeature);
    _this = _callSuper(this, AnimationFeature, [node]);
    node.animationState || (node.animationState = createAnimationState(node));
    return _this;
  }
  _inherits$1(AnimationFeature, _Feature);
  return _createClass$1(AnimationFeature, [{
    key: "updateAnimationControlsSubscription",
    value: function updateAnimationControlsSubscription() {
      var _this$node$getProps = this.node.getProps(),
        animate = _this$node$getProps.animate;
      this.unmount();
      if (isAnimationControls(animate)) {
        this.unmount = animate.subscribe(this.node);
      }
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */
  }, {
    key: "mount",
    value: function mount() {
      this.updateAnimationControlsSubscription();
    }
  }, {
    key: "update",
    value: function update() {
      var _this$node$getProps2 = this.node.getProps(),
        animate = _this$node$getProps2.animate;
      var _ref = this.node.prevProps || {},
        prevAnimate = _ref.animate;
      if (animate !== prevAnimate) {
        this.updateAnimationControlsSubscription();
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
}(Feature);

var id$1 = 0;
var ExitAnimationFeature = /*#__PURE__*/function (_Feature) {
  function ExitAnimationFeature() {
    var _this;
    _classCallCheck$1(this, ExitAnimationFeature);
    _this = _callSuper(this, ExitAnimationFeature, arguments);
    _this.id = id$1++;
    return _this;
  }
  _inherits$1(ExitAnimationFeature, _Feature);
  return _createClass$1(ExitAnimationFeature, [{
    key: "update",
    value: function update() {
      var _this2 = this;
      if (!this.node.presenceContext) return;
      var _this$node$presenceCo = this.node.presenceContext,
        isPresent = _this$node$presenceCo.isPresent,
        onExitComplete = _this$node$presenceCo.onExitComplete,
        custom = _this$node$presenceCo.custom;
      var _ref = this.node.prevPresenceContext || {},
        prevIsPresent = _ref.isPresent;
      if (!this.node.animationState || isPresent === prevIsPresent) {
        return;
      }
      var exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
        custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
      });
      if (onExitComplete && !isPresent) {
        exitAnimation.then(function () {
          return onExitComplete(_this2.id);
        });
      }
    }
  }, {
    key: "mount",
    value: function mount() {
      var _ref2 = this.node.presenceContext || {},
        register = _ref2.register;
      if (register) {
        this.unmount = register(this.id);
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
}(Feature);

var animations = {
  animation: {
    Feature: AnimationFeature
  },
  exit: {
    Feature: ExitAnimationFeature
  }
};

var distance = function distance(a, b) {
  return Math.abs(a - b);
};
function distance2D(a, b) {
  // Multi-dimensional
  var xDelta = distance(a.x, b.x);
  var yDelta = distance(a.y, b.y);
  return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
}

/**
 * @internal
 */
var PanSession = /*#__PURE__*/function () {
  function PanSession(event, handlers) {
    var _this = this;
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      transformPagePoint = _ref.transformPagePoint,
      contextWindow = _ref.contextWindow,
      _ref$dragSnapToOrigin = _ref.dragSnapToOrigin,
      dragSnapToOrigin = _ref$dragSnapToOrigin === void 0 ? false : _ref$dragSnapToOrigin;
    _classCallCheck$1(this, PanSession);
    /**
     * @internal
     */
    this.startEvent = null;
    /**
     * @internal
     */
    this.lastMoveEvent = null;
    /**
     * @internal
     */
    this.lastMoveEventInfo = null;
    /**
     * @internal
     */
    this.handlers = {};
    /**
     * @internal
     */
    this.contextWindow = window;
    this.updatePoint = function () {
      if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
      var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
      var isPanStarted = _this.startEvent !== null;
      // Only start panning if the offset is larger than 3 pixels. If we make it
      // any larger than this we'll want to reset the pointer history
      // on the first update to avoid visual snapping to the cursoe.
      var isDistancePastThreshold = distance2D(info.offset, {
        x: 0,
        y: 0
      }) >= 3;
      if (!isPanStarted && !isDistancePastThreshold) return;
      var point = info.point;
      var timestamp = frameData.timestamp;
      _this.history.push(_objectSpread2$1(_objectSpread2$1({}, point), {}, {
        timestamp: timestamp
      }));
      var _this$handlers = _this.handlers,
        onStart = _this$handlers.onStart,
        onMove = _this$handlers.onMove;
      if (!isPanStarted) {
        onStart && onStart(_this.lastMoveEvent, info);
        _this.startEvent = _this.lastMoveEvent;
      }
      onMove && onMove(_this.lastMoveEvent, info);
    };
    this.handlePointerMove = function (event, info) {
      _this.lastMoveEvent = event;
      _this.lastMoveEventInfo = transformPoint(info, _this.transformPagePoint);
      // Throttle mouse move event to once per frame
      frame.update(_this.updatePoint, true);
    };
    this.handlePointerUp = function (event, info) {
      _this.end();
      var _this$handlers2 = _this.handlers,
        onEnd = _this$handlers2.onEnd,
        onSessionEnd = _this$handlers2.onSessionEnd,
        resumeAnimation = _this$handlers2.resumeAnimation;
      if (_this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
      if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
      var panInfo = getPanInfo(event.type === "pointercancel" ? _this.lastMoveEventInfo : transformPoint(info, _this.transformPagePoint), _this.history);
      if (_this.startEvent && onEnd) {
        onEnd(event, panInfo);
      }
      onSessionEnd && onSessionEnd(event, panInfo);
    };
    // If we have more than one touch, don't start detecting this gesture
    if (!isPrimaryPointer(event)) return;
    this.dragSnapToOrigin = dragSnapToOrigin;
    this.handlers = handlers;
    this.transformPagePoint = transformPagePoint;
    this.contextWindow = contextWindow || window;
    var info = extractEventInfo(event);
    var initialInfo = transformPoint(info, this.transformPagePoint);
    var point = initialInfo.point;
    var timestamp = frameData.timestamp;
    this.history = [_objectSpread2$1(_objectSpread2$1({}, point), {}, {
      timestamp: timestamp
    })];
    var onSessionStart = handlers.onSessionStart;
    onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
    this.removeListeners = pipe(addPointerEvent(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  return _createClass$1(PanSession, [{
    key: "updateHandlers",
    value: function updateHandlers(handlers) {
      this.handlers = handlers;
    }
  }, {
    key: "end",
    value: function end() {
      this.removeListeners && this.removeListeners();
      cancelFrame(this.updatePoint);
    }
  }]);
}();
function transformPoint(info, transformPagePoint) {
  return transformPagePoint ? {
    point: transformPagePoint(info.point)
  } : info;
}
function subtractPoint(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}
function getPanInfo(_ref2, history) {
  var point = _ref2.point;
  return {
    point: point,
    delta: subtractPoint(point, lastDevicePoint(history)),
    offset: subtractPoint(point, startDevicePoint(history)),
    velocity: getVelocity(history, 0.1)
  };
}
function startDevicePoint(history) {
  return history[0];
}
function lastDevicePoint(history) {
  return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
  if (history.length < 2) {
    return {
      x: 0,
      y: 0
    };
  }
  var i = history.length - 1;
  var timestampedPoint = null;
  var lastPoint = lastDevicePoint(history);
  while (i >= 0) {
    timestampedPoint = history[i];
    if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) {
      break;
    }
    i--;
  }
  if (!timestampedPoint) {
    return {
      x: 0,
      y: 0
    };
  }
  var time = millisecondsToSeconds(lastPoint.timestamp - timestampedPoint.timestamp);
  if (time === 0) {
    return {
      x: 0,
      y: 0
    };
  }
  var currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time,
    y: (lastPoint.y - timestampedPoint.y) / time
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}

function calcLength(axis) {
  return axis.max - axis.min;
}
function isNear(value) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var maxDistance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.01;
  return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target) {
  var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
  delta.origin = origin;
  delta.originPoint = mix(source.min, source.max, delta.origin);
  delta.scale = calcLength(target) / calcLength(source);
  if (isNear(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
  delta.translate = mix(target.min, target.max, delta.origin) - delta.originPoint;
  if (isNear(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
  calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : undefined);
  calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function calcRelativeAxis(target, relative, parent) {
  target.min = parent.min + relative.min;
  target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
  calcRelativeAxis(target.x, relative.x, parent.x);
  calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
  target.min = layout.min - parent.min;
  target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
  calcRelativeAxisPosition(target.x, layout.x, parent.x);
  calcRelativeAxisPosition(target.y, layout.y, parent.y);
}

/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */
function applyConstraints(point, _ref, elastic) {
  var min = _ref.min,
    max = _ref.max;
  if (min !== undefined && point < min) {
    // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
  } else if (max !== undefined && point > max) {
    // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
  }
  return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */
function calcRelativeAxisConstraints(axis, min, max) {
  return {
    min: min !== undefined ? axis.min + min : undefined,
    max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
  };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */
function calcRelativeConstraints(layoutBox, _ref2) {
  var top = _ref2.top,
    left = _ref2.left,
    bottom = _ref2.bottom,
    right = _ref2.right;
  return {
    x: calcRelativeAxisConstraints(layoutBox.x, left, right),
    y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
  };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
  var min = constraintsAxis.min - layoutAxis.min;
  var max = constraintsAxis.max - layoutAxis.max;
  // If the constraints axis is actually smaller than the layout axis then we can
  // flip the constraints
  if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) {
    var _ref3 = [max, min];
    min = _ref3[0];
    max = _ref3[1];
  }
  return {
    min: min,
    max: max
  };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */
function calcViewportConstraints(layoutBox, constraintsBox) {
  return {
    x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
    y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
  };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function calcOrigin(source, target) {
  var origin = 0.5;
  var sourceLength = calcLength(source);
  var targetLength = calcLength(target);
  if (targetLength > sourceLength) {
    origin = progress$1(target.min, target.max - sourceLength, source.min);
  } else if (sourceLength > targetLength) {
    origin = progress$1(source.min, source.max - targetLength, target.min);
  }
  return clamp(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */
function rebaseAxisConstraints(layout, constraints) {
  var relativeConstraints = {};
  if (constraints.min !== undefined) {
    relativeConstraints.min = constraints.min - layout.min;
  }
  if (constraints.max !== undefined) {
    relativeConstraints.max = constraints.max - layout.min;
  }
  return relativeConstraints;
}
var defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */
function resolveDragElastic() {
  var dragElastic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultElastic;
  if (dragElastic === false) {
    dragElastic = 0;
  } else if (dragElastic === true) {
    dragElastic = defaultElastic;
  }
  return {
    x: resolveAxisElastic(dragElastic, "left", "right"),
    y: resolveAxisElastic(dragElastic, "top", "bottom")
  };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
  return {
    min: resolvePointElastic(dragElastic, minLabel),
    max: resolvePointElastic(dragElastic, maxLabel)
  };
}
function resolvePointElastic(dragElastic, label) {
  return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

var createAxisDelta = function createAxisDelta() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
};
var createDelta = function createDelta() {
  return {
    x: createAxisDelta(),
    y: createAxisDelta()
  };
};
var createAxis = function createAxis() {
  return {
    min: 0,
    max: 0
  };
};
var createBox = function createBox() {
  return {
    x: createAxis(),
    y: createAxis()
  };
};

function eachAxis(callback) {
  return [callback("x"), callback("y")];
}

/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToBox(_ref) {
  var top = _ref.top,
    left = _ref.left,
    right = _ref.right,
    bottom = _ref.bottom;
  return {
    x: {
      min: left,
      max: right
    },
    y: {
      min: top,
      max: bottom
    }
  };
}
function convertBoxToBoundingBox(_ref2) {
  var x = _ref2.x,
    y = _ref2.y;
  return {
    top: y.min,
    right: x.max,
    bottom: y.max,
    left: x.min
  };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoxPoints(point, transformPoint) {
  if (!transformPoint) return point;
  var topLeft = transformPoint({
    x: point.left,
    y: point.top
  });
  var bottomRight = transformPoint({
    x: point.right,
    y: point.bottom
  });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}

function isIdentityScale(scale) {
  return scale === undefined || scale === 1;
}
function hasScale(_ref) {
  var scale = _ref.scale,
    scaleX = _ref.scaleX,
    scaleY = _ref.scaleY;
  return !isIdentityScale(scale) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
  return hasScale(values) || has2DTranslate(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function has2DTranslate(values) {
  return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
  return value && value !== "0%";
}

/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
  var distanceFromOrigin = point - originPoint;
  var scaled = scale * distanceFromOrigin;
  return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
  if (boxScale !== undefined) {
    point = scalePoint(point, boxScale, originPoint);
  }
  return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis) {
  var translate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var originPoint = arguments.length > 3 ? arguments[3] : undefined;
  var boxScale = arguments.length > 4 ? arguments[4] : undefined;
  axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
  axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, _ref) {
  var x = _ref.x,
    y = _ref.y;
  applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
  applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */
function applyTreeDeltas(box, treeScale, treePath) {
  var isSharedTransition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var treeLength = treePath.length;
  if (!treeLength) return;
  // Reset the treeScale
  treeScale.x = treeScale.y = 1;
  var node;
  var delta;
  for (var i = 0; i < treeLength; i++) {
    node = treePath[i];
    delta = node.projectionDelta;
    /**
     * TODO: Prefer to remove this, but currently we have motion components with
     * display: contents in Framer.
     */
    var instance = node.instance;
    if (instance && instance.style && instance.style.display === "contents") {
      continue;
    }
    if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
      transformBox(box, {
        x: -node.scroll.offset.x,
        y: -node.scroll.offset.y
      });
    }
    if (delta) {
      // Incoporate each ancestor's scale into a culmulative treeScale for this component
      treeScale.x *= delta.x.scale;
      treeScale.y *= delta.y.scale;
      // Apply each ancestor's calculated delta into this component's recorded layout box
      applyBoxDelta(box, delta);
    }
    if (isSharedTransition && hasTransform(node.latestValues)) {
      transformBox(box, node.latestValues);
    }
  }
  /**
   * Snap tree scale back to 1 if it's within a non-perceivable threshold.
   * This will help reduce useless scales getting rendered.
   */
  treeScale.x = snapToDefault(treeScale.x);
  treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale) {
  if (Number.isInteger(scale)) return scale;
  return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function translateAxis(axis, distance) {
  axis.min = axis.min + distance;
  axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function transformAxis(axis, transforms, _ref2) {
  var _ref3 = _slicedToArray$1(_ref2, 3),
    key = _ref3[0],
    scaleKey = _ref3[1],
    originKey = _ref3[2];
  var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
  var originPoint = mix(axis.min, axis.max, axisOrigin);
  // Apply the axis delta to the final axis
  applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
var xKeys$1 = ["x", "scaleX", "originX"];
var yKeys$1 = ["y", "scaleY", "originY"];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function transformBox(box, transform) {
  transformAxis(box.x, transform, xKeys$1);
  transformAxis(box.y, transform, yKeys$1);
}

function measureViewportBox(instance, transformPoint) {
  return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
  var viewportBox = measureViewportBox(element, transformPagePoint);
  var scroll = rootProjectionNode.scroll;
  if (scroll) {
    translateAxis(viewportBox.x, scroll.offset.x);
    translateAxis(viewportBox.y, scroll.offset.y);
  }
  return viewportBox;
}

// Fixes https://github.com/framer/motion/issues/2270
var getContextWindow = function getContextWindow(_ref) {
  var current = _ref.current;
  return current ? current.ownerDocument.defaultView : null;
};

var elementDragControls = new WeakMap();
/**
 *
 */
// let latestPointerEvent: PointerEvent
var VisualElementDragControls = /*#__PURE__*/function () {
  function VisualElementDragControls(visualElement) {
    _classCallCheck$1(this, VisualElementDragControls);
    // This is a reference to the global drag gesture lock, ensuring only one component
    // can "capture" the drag of one or both axes.
    // TODO: Look into moving this into pansession?
    this.openGlobalLock = null;
    this.isDragging = false;
    this.currentDirection = null;
    this.originPoint = {
      x: 0,
      y: 0
    };
    /**
     * The permitted boundaries of travel, in pixels.
     */
    this.constraints = false;
    this.hasMutatedConstraints = false;
    /**
     * The per-axis resolved elastic values.
     */
    this.elastic = createBox();
    this.visualElement = visualElement;
  }
  return _createClass$1(VisualElementDragControls, [{
    key: "start",
    value: function start(originEvent) {
      var _this = this;
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$snapToCursor = _ref.snapToCursor,
        snapToCursor = _ref$snapToCursor === void 0 ? false : _ref$snapToCursor;
      /**
       * Don't start dragging if this component is exiting
       */
      var presenceContext = this.visualElement.presenceContext;
      if (presenceContext && presenceContext.isPresent === false) return;
      var onSessionStart = function onSessionStart(event) {
        var _this$getProps = _this.getProps(),
          dragSnapToOrigin = _this$getProps.dragSnapToOrigin;
        // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
        // the component.
        dragSnapToOrigin ? _this.pauseAnimation() : _this.stopAnimation();
        if (snapToCursor) {
          _this.snapToCursor(extractEventInfo(event, "page").point);
        }
      };
      var onStart = function onStart(event, info) {
        // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
        var _this$getProps2 = _this.getProps(),
          drag = _this$getProps2.drag,
          dragPropagation = _this$getProps2.dragPropagation,
          onDragStart = _this$getProps2.onDragStart;
        if (drag && !dragPropagation) {
          if (_this.openGlobalLock) _this.openGlobalLock();
          _this.openGlobalLock = getGlobalLock(drag);
          // If we don 't have the lock, don't start dragging
          if (!_this.openGlobalLock) return;
        }
        _this.isDragging = true;
        _this.currentDirection = null;
        _this.resolveConstraints();
        if (_this.visualElement.projection) {
          _this.visualElement.projection.isAnimationBlocked = true;
          _this.visualElement.projection.target = undefined;
        }
        /**
         * Record gesture origin
         */
        eachAxis(function (axis) {
          var current = _this.getAxisMotionValue(axis).get() || 0;
          /**
           * If the MotionValue is a percentage value convert to px
           */
          if (percent.test(current)) {
            var projection = _this.visualElement.projection;
            if (projection && projection.layout) {
              var measuredAxis = projection.layout.layoutBox[axis];
              if (measuredAxis) {
                var length = calcLength(measuredAxis);
                current = length * (parseFloat(current) / 100);
              }
            }
          }
          _this.originPoint[axis] = current;
        });
        // Fire onDragStart event
        if (onDragStart) {
          frame.update(function () {
            return onDragStart(event, info);
          }, false, true);
        }
        var animationState = _this.visualElement.animationState;
        animationState && animationState.setActive("whileDrag", true);
      };
      var onMove = function onMove(event, info) {
        // latestPointerEvent = event
        var _this$getProps3 = _this.getProps(),
          dragPropagation = _this$getProps3.dragPropagation,
          dragDirectionLock = _this$getProps3.dragDirectionLock,
          onDirectionLock = _this$getProps3.onDirectionLock,
          onDrag = _this$getProps3.onDrag;
        // If we didn't successfully receive the gesture lock, early return.
        if (!dragPropagation && !_this.openGlobalLock) return;
        var offset = info.offset;
        // Attempt to detect drag direction if directionLock is true
        if (dragDirectionLock && _this.currentDirection === null) {
          _this.currentDirection = getCurrentDirection(offset);
          // If we've successfully set a direction, notify listener
          if (_this.currentDirection !== null) {
            onDirectionLock && onDirectionLock(_this.currentDirection);
          }
          return;
        }
        // Update each point with the latest position
        _this.updateAxis("x", info.point, offset);
        _this.updateAxis("y", info.point, offset);
        /**
         * Ideally we would leave the renderer to fire naturally at the end of
         * this frame but if the element is about to change layout as the result
         * of a re-render we want to ensure the browser can read the latest
         * bounding box to ensure the pointer and element don't fall out of sync.
         */
        _this.visualElement.render();
        /**
         * This must fire after the render call as it might trigger a state
         * change which itself might trigger a layout update.
         */
        onDrag && onDrag(event, info);
      };
      var onSessionEnd = function onSessionEnd(event, info) {
        return _this.stop(event, info);
      };
      var resumeAnimation = function resumeAnimation() {
        return eachAxis(function (axis) {
          var _a;
          return _this.getAnimationState(axis) === "paused" && ((_a = _this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
        });
      };
      var _this$getProps4 = this.getProps(),
        dragSnapToOrigin = _this$getProps4.dragSnapToOrigin;
      this.panSession = new PanSession(originEvent, {
        onSessionStart: onSessionStart,
        onStart: onStart,
        onMove: onMove,
        onSessionEnd: onSessionEnd,
        resumeAnimation: resumeAnimation
      }, {
        transformPagePoint: this.visualElement.getTransformPagePoint(),
        dragSnapToOrigin: dragSnapToOrigin,
        contextWindow: getContextWindow(this.visualElement)
      });
    }
  }, {
    key: "stop",
    value: function stop(event, info) {
      var isDragging = this.isDragging;
      this.cancel();
      if (!isDragging) return;
      var velocity = info.velocity;
      this.startAnimation(velocity);
      var _this$getProps5 = this.getProps(),
        onDragEnd = _this$getProps5.onDragEnd;
      if (onDragEnd) {
        frame.update(function () {
          return onDragEnd(event, info);
        });
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.isDragging = false;
      var _this$visualElement = this.visualElement,
        projection = _this$visualElement.projection,
        animationState = _this$visualElement.animationState;
      if (projection) {
        projection.isAnimationBlocked = false;
      }
      this.panSession && this.panSession.end();
      this.panSession = undefined;
      var _this$getProps6 = this.getProps(),
        dragPropagation = _this$getProps6.dragPropagation;
      if (!dragPropagation && this.openGlobalLock) {
        this.openGlobalLock();
        this.openGlobalLock = null;
      }
      animationState && animationState.setActive("whileDrag", false);
    }
  }, {
    key: "updateAxis",
    value: function updateAxis(axis, _point, offset) {
      var _this$getProps7 = this.getProps(),
        drag = _this$getProps7.drag;
      // If we're not dragging this axis, do an early return.
      if (!offset || !shouldDrag(axis, drag, this.currentDirection)) return;
      var axisValue = this.getAxisMotionValue(axis);
      var next = this.originPoint[axis] + offset[axis];
      // Apply constraints
      if (this.constraints && this.constraints[axis]) {
        next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
      }
      axisValue.set(next);
    }
  }, {
    key: "resolveConstraints",
    value: function resolveConstraints() {
      var _this2 = this;
      var _a;
      var _this$getProps8 = this.getProps(),
        dragConstraints = _this$getProps8.dragConstraints,
        dragElastic = _this$getProps8.dragElastic;
      var layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
      var prevConstraints = this.constraints;
      if (dragConstraints && isRefObject$2(dragConstraints)) {
        if (!this.constraints) {
          this.constraints = this.resolveRefConstraints();
        }
      } else {
        if (dragConstraints && layout) {
          this.constraints = calcRelativeConstraints(layout.layoutBox, dragConstraints);
        } else {
          this.constraints = false;
        }
      }
      this.elastic = resolveDragElastic(dragElastic);
      /**
       * If we're outputting to external MotionValues, we want to rebase the measured constraints
       * from viewport-relative to component-relative.
       */
      if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) {
        eachAxis(function (axis) {
          if (_this2.getAxisMotionValue(axis)) {
            _this2.constraints[axis] = rebaseAxisConstraints(layout.layoutBox[axis], _this2.constraints[axis]);
          }
        });
      }
    }
  }, {
    key: "resolveRefConstraints",
    value: function resolveRefConstraints() {
      var _this$getProps9 = this.getProps(),
        constraints = _this$getProps9.dragConstraints,
        onMeasureDragConstraints = _this$getProps9.onMeasureDragConstraints;
      if (!constraints || !isRefObject$2(constraints)) return false;
      var constraintsElement = constraints.current;
      invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var projection = this.visualElement.projection;
      // TODO
      if (!projection || !projection.layout) return false;
      var constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
      var measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
      /**
       * If there's an onMeasureDragConstraints listener we call it and
       * if different constraints are returned, set constraints to that
       */
      if (onMeasureDragConstraints) {
        var userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
        this.hasMutatedConstraints = !!userConstraints;
        if (userConstraints) {
          measuredConstraints = convertBoundingBoxToBox(userConstraints);
        }
      }
      return measuredConstraints;
    }
  }, {
    key: "startAnimation",
    value: function startAnimation(velocity) {
      var _this3 = this;
      var _this$getProps10 = this.getProps(),
        drag = _this$getProps10.drag,
        dragMomentum = _this$getProps10.dragMomentum,
        dragElastic = _this$getProps10.dragElastic,
        dragTransition = _this$getProps10.dragTransition,
        dragSnapToOrigin = _this$getProps10.dragSnapToOrigin,
        onDragTransitionEnd = _this$getProps10.onDragTransitionEnd;
      var constraints = this.constraints || {};
      var momentumAnimations = eachAxis(function (axis) {
        if (!shouldDrag(axis, drag, _this3.currentDirection)) {
          return;
        }
        var transition = constraints && constraints[axis] || {};
        if (dragSnapToOrigin) transition = {
          min: 0,
          max: 0
        };
        /**
         * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
         * of spring animations so we should look into adding a disable spring option to `inertia`.
         * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
         * using the value of `dragElastic`.
         */
        var bounceStiffness = dragElastic ? 200 : 1000000;
        var bounceDamping = dragElastic ? 40 : 10000000;
        var inertia = _objectSpread2$1(_objectSpread2$1({
          type: "inertia",
          velocity: dragMomentum ? velocity[axis] : 0,
          bounceStiffness: bounceStiffness,
          bounceDamping: bounceDamping,
          timeConstant: 750,
          restDelta: 1,
          restSpeed: 10
        }, dragTransition), transition);
        // If we're not animating on an externally-provided `MotionValue` we can use the
        // component's animation controls which will handle interactions with whileHover (etc),
        // otherwise we just have to animate the `MotionValue` itself.
        return _this3.startAxisValueAnimation(axis, inertia);
      });
      // Run all animations and then resolve the new drag constraints.
      return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
  }, {
    key: "startAxisValueAnimation",
    value: function startAxisValueAnimation(axis, transition) {
      var axisValue = this.getAxisMotionValue(axis);
      return axisValue.start(animateMotionValue(axis, axisValue, 0, transition));
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      var _this4 = this;
      eachAxis(function (axis) {
        return _this4.getAxisMotionValue(axis).stop();
      });
    }
  }, {
    key: "pauseAnimation",
    value: function pauseAnimation() {
      var _this5 = this;
      eachAxis(function (axis) {
        var _a;
        return (_a = _this5.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
      });
    }
  }, {
    key: "getAnimationState",
    value: function getAnimationState(axis) {
      var _a;
      return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */
  }, {
    key: "getAxisMotionValue",
    value: function getAxisMotionValue(axis) {
      var dragKey = "_drag" + axis.toUpperCase();
      var props = this.visualElement.getProps();
      var externalMotionValue = props[dragKey];
      return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
  }, {
    key: "snapToCursor",
    value: function snapToCursor(point) {
      var _this6 = this;
      eachAxis(function (axis) {
        var _this6$getProps = _this6.getProps(),
          drag = _this6$getProps.drag;
        // If we're not dragging this axis, do an early return.
        if (!shouldDrag(axis, drag, _this6.currentDirection)) return;
        var projection = _this6.visualElement.projection;
        var axisValue = _this6.getAxisMotionValue(axis);
        if (projection && projection.layout) {
          var _projection$layout$la = projection.layout.layoutBox[axis],
            min = _projection$layout$la.min,
            max = _projection$layout$la.max;
          axisValue.set(point[axis] - mix(min, max, 0.5));
        }
      });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */
  }, {
    key: "scalePositionWithinConstraints",
    value: function scalePositionWithinConstraints() {
      var _this7 = this;
      if (!this.visualElement.current) return;
      var _this$getProps11 = this.getProps(),
        drag = _this$getProps11.drag,
        dragConstraints = _this$getProps11.dragConstraints;
      var projection = this.visualElement.projection;
      if (!isRefObject$2(dragConstraints) || !projection || !this.constraints) return;
      /**
       * Stop current animations as there can be visual glitching if we try to do
       * this mid-animation
       */
      this.stopAnimation();
      /**
       * Record the relative position of the dragged element relative to the
       * constraints box and save as a progress value.
       */
      var boxProgress = {
        x: 0,
        y: 0
      };
      eachAxis(function (axis) {
        var axisValue = _this7.getAxisMotionValue(axis);
        if (axisValue) {
          var latest = axisValue.get();
          boxProgress[axis] = calcOrigin({
            min: latest,
            max: latest
          }, _this7.constraints[axis]);
        }
      });
      /**
       * Update the layout of this element and resolve the latest drag constraints
       */
      var _this$visualElement$g = this.visualElement.getProps(),
        transformTemplate = _this$visualElement$g.transformTemplate;
      this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
      projection.root && projection.root.updateScroll();
      projection.updateLayout();
      this.resolveConstraints();
      /**
       * For each axis, calculate the current progress of the layout axis
       * within the new constraints.
       */
      eachAxis(function (axis) {
        if (!shouldDrag(axis, drag, null)) return;
        /**
         * Calculate a new transform based on the previous box progress
         */
        var axisValue = _this7.getAxisMotionValue(axis);
        var _this7$constraints$ax = _this7.constraints[axis],
          min = _this7$constraints$ax.min,
          max = _this7$constraints$ax.max;
        axisValue.set(mix(min, max, boxProgress[axis]));
      });
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      var _this8 = this;
      if (!this.visualElement.current) return;
      elementDragControls.set(this.visualElement, this);
      var element = this.visualElement.current;
      /**
       * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
       */
      var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
        var _this8$getProps = _this8.getProps(),
          drag = _this8$getProps.drag,
          _this8$getProps$dragL = _this8$getProps.dragListener,
          dragListener = _this8$getProps$dragL === void 0 ? true : _this8$getProps$dragL;
        drag && dragListener && _this8.start(event);
      });
      var measureDragConstraints = function measureDragConstraints() {
        var _this8$getProps2 = _this8.getProps(),
          dragConstraints = _this8$getProps2.dragConstraints;
        if (isRefObject$2(dragConstraints)) {
          _this8.constraints = _this8.resolveRefConstraints();
        }
      };
      var projection = this.visualElement.projection;
      var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
      if (projection && !projection.layout) {
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
      }
      measureDragConstraints();
      /**
       * Attach a window resize listener to scale the draggable target within its defined
       * constraints as the window resizes.
       */
      var stopResizeListener = addDomEvent(window, "resize", function () {
        return _this8.scalePositionWithinConstraints();
      });
      /**
       * If the element's layout changes, calculate the delta and apply that to
       * the drag gesture's origin point.
       */
      var stopLayoutUpdateListener = projection.addEventListener("didUpdate", function (_ref2) {
        var delta = _ref2.delta,
          hasLayoutChanged = _ref2.hasLayoutChanged;
        if (_this8.isDragging && hasLayoutChanged) {
          eachAxis(function (axis) {
            var motionValue = _this8.getAxisMotionValue(axis);
            if (!motionValue) return;
            _this8.originPoint[axis] += delta[axis].translate;
            motionValue.set(motionValue.get() + delta[axis].translate);
          });
          _this8.visualElement.render();
        }
      });
      return function () {
        stopResizeListener();
        stopPointerListener();
        stopMeasureLayoutListener();
        stopLayoutUpdateListener && stopLayoutUpdateListener();
      };
    }
  }, {
    key: "getProps",
    value: function getProps() {
      var props = this.visualElement.getProps();
      var _props$drag = props.drag,
        drag = _props$drag === void 0 ? false : _props$drag,
        _props$dragDirectionL = props.dragDirectionLock,
        dragDirectionLock = _props$dragDirectionL === void 0 ? false : _props$dragDirectionL,
        _props$dragPropagatio = props.dragPropagation,
        dragPropagation = _props$dragPropagatio === void 0 ? false : _props$dragPropagatio,
        _props$dragConstraint = props.dragConstraints,
        dragConstraints = _props$dragConstraint === void 0 ? false : _props$dragConstraint,
        _props$dragElastic = props.dragElastic,
        dragElastic = _props$dragElastic === void 0 ? defaultElastic : _props$dragElastic,
        _props$dragMomentum = props.dragMomentum,
        dragMomentum = _props$dragMomentum === void 0 ? true : _props$dragMomentum;
      return _objectSpread2$1(_objectSpread2$1({}, props), {}, {
        drag: drag,
        dragDirectionLock: dragDirectionLock,
        dragPropagation: dragPropagation,
        dragConstraints: dragConstraints,
        dragElastic: dragElastic,
        dragMomentum: dragMomentum
      });
    }
  }]);
}();
function shouldDrag(direction, drag, currentDirection) {
  return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset) {
  var lockThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var direction = null;
  if (Math.abs(offset.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}

var DragGesture = /*#__PURE__*/function (_Feature) {
  function DragGesture(node) {
    var _this;
    _classCallCheck$1(this, DragGesture);
    _this = _callSuper(this, DragGesture, [node]);
    _this.removeGroupControls = noop$1;
    _this.removeListeners = noop$1;
    _this.controls = new VisualElementDragControls(node);
    return _this;
  }
  _inherits$1(DragGesture, _Feature);
  return _createClass$1(DragGesture, [{
    key: "mount",
    value: function mount() {
      // If we've been provided a DragControls for manual control over the drag gesture,
      // subscribe this component to it on mount.
      var _this$node$getProps = this.node.getProps(),
        dragControls = _this$node$getProps.dragControls;
      if (dragControls) {
        this.removeGroupControls = dragControls.subscribe(this.controls);
      }
      this.removeListeners = this.controls.addListeners() || noop$1;
    }
  }, {
    key: "unmount",
    value: function unmount() {
      this.removeGroupControls();
      this.removeListeners();
    }
  }]);
}(Feature);

var asyncHandler = function asyncHandler(handler) {
  return function (event, info) {
    if (handler) {
      frame.update(function () {
        return handler(event, info);
      });
    }
  };
};
var PanGesture = /*#__PURE__*/function (_Feature) {
  function PanGesture() {
    var _this;
    _classCallCheck$1(this, PanGesture);
    _this = _callSuper(this, PanGesture, arguments);
    _this.removePointerDownListener = noop$1;
    return _this;
  }
  _inherits$1(PanGesture, _Feature);
  return _createClass$1(PanGesture, [{
    key: "onPointerDown",
    value: function onPointerDown(pointerDownEvent) {
      this.session = new PanSession(pointerDownEvent, this.createPanHandlers(), {
        transformPagePoint: this.node.getTransformPagePoint(),
        contextWindow: getContextWindow(this.node)
      });
    }
  }, {
    key: "createPanHandlers",
    value: function createPanHandlers() {
      var _this2 = this;
      var _this$node$getProps = this.node.getProps(),
        onPanSessionStart = _this$node$getProps.onPanSessionStart,
        onPanStart = _this$node$getProps.onPanStart,
        onPan = _this$node$getProps.onPan,
        onPanEnd = _this$node$getProps.onPanEnd;
      return {
        onSessionStart: asyncHandler(onPanSessionStart),
        onStart: asyncHandler(onPanStart),
        onMove: onPan,
        onEnd: function onEnd(event, info) {
          delete _this2.session;
          if (onPanEnd) {
            frame.update(function () {
              return onPanEnd(event, info);
            });
          }
        }
      };
    }
  }, {
    key: "mount",
    value: function mount() {
      var _this3 = this;
      this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", function (event) {
        return _this3.onPointerDown(event);
      });
    }
  }, {
    key: "update",
    value: function update() {
      this.session && this.session.updateHandlers(this.createPanHandlers());
    }
  }, {
    key: "unmount",
    value: function unmount() {
      this.removePointerDownListener();
      this.session && this.session.end();
    }
  }]);
}(Feature);

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */
function usePresence() {
  var context = useContext(PresenceContext);
  if (context === null) return [true, null];
  var isPresent = context.isPresent,
    onExitComplete = context.onExitComplete,
    register = context.register;
  // It's safe to call the following hooks conditionally (after an early return) because the context will always
  // either be null or non-null for the lifespan of the component.
  var id = useId$1();
  useEffect(function () {
    return register(id);
  }, []);
  var safeToRemove = function safeToRemove() {
    return onExitComplete && onExitComplete(id);
  };
  return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */
function useIsPresent() {
  return isPresent(useContext(PresenceContext));
}
function isPresent(context) {
  return context === null ? true : context.isPresent;
}

/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */
var globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: true,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: false
};

function pixelsToPercent(pixels, axis) {
  if (axis.max === axis.min) return 0;
  return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */
var correctBorderRadius = {
  correct: function correct(latest, node) {
    if (!node.target) return latest;
    /**
     * If latest is a string, if it's a percentage we can return immediately as it's
     * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
     */
    if (typeof latest === "string") {
      if (px.test(latest)) {
        latest = parseFloat(latest);
      } else {
        return latest;
      }
    }
    /**
     * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
     * pixel value as a percentage of each axis
     */
    var x = pixelsToPercent(latest, node.target.x);
    var y = pixelsToPercent(latest, node.target.y);
    return "".concat(x, "% ").concat(y, "%");
  }
};

var correctBoxShadow = {
  correct: function correct(latest, _ref) {
    var treeScale = _ref.treeScale,
      projectionDelta = _ref.projectionDelta;
    var original = latest;
    var shadow = complex.parse(latest);
    // TODO: Doesn't support multiple shadows
    if (shadow.length > 5) return original;
    var template = complex.createTransformer(latest);
    var offset = typeof shadow[0] !== "number" ? 1 : 0;
    // Calculate the overall context scale
    var xScale = projectionDelta.x.scale * treeScale.x;
    var yScale = projectionDelta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    /**
     * Ideally we'd correct x and y scales individually, but because blur and
     * spread apply to both we have to take a scale average and apply that instead.
     * We could potentially improve the outcome of this by incorporating the ratio between
     * the two scales.
     */
    var averageScale = mix(xScale, yScale, 0.5);
    // Blur
    if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
    // Spread
    if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
    return template(shadow);
  }
};

var MeasureLayoutWithContext = /*#__PURE__*/function (_React__default$Compo) {
  function MeasureLayoutWithContext() {
    _classCallCheck$1(this, MeasureLayoutWithContext);
    return _callSuper(this, MeasureLayoutWithContext, arguments);
  }
  _inherits$1(MeasureLayoutWithContext, _React__default$Compo);
  return _createClass$1(MeasureLayoutWithContext, [{
    key: "componentDidMount",
    value:
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */
    function componentDidMount() {
      var _this = this;
      var _this$props = this.props,
        visualElement = _this$props.visualElement,
        layoutGroup = _this$props.layoutGroup,
        switchLayoutGroup = _this$props.switchLayoutGroup,
        layoutId = _this$props.layoutId;
      var projection = visualElement.projection;
      addScaleCorrector(defaultScaleCorrectors);
      if (projection) {
        if (layoutGroup.group) layoutGroup.group.add(projection);
        if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
          switchLayoutGroup.register(projection);
        }
        projection.root.didUpdate();
        projection.addEventListener("animationComplete", function () {
          _this.safeToRemove();
        });
        projection.setOptions(_objectSpread2$1(_objectSpread2$1({}, projection.options), {}, {
          onExitComplete: function onExitComplete() {
            return _this.safeToRemove();
          }
        }));
      }
      globalProjectionState.hasEverUpdated = true;
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var _this2 = this;
      var _this$props2 = this.props,
        layoutDependency = _this$props2.layoutDependency,
        visualElement = _this$props2.visualElement,
        drag = _this$props2.drag,
        isPresent = _this$props2.isPresent;
      var projection = visualElement.projection;
      if (!projection) return null;
      /**
       * TODO: We use this data in relegate to determine whether to
       * promote a previous element. There's no guarantee its presence data
       * will have updated by this point - if a bug like this arises it will
       * have to be that we markForRelegation and then find a new lead some other way,
       * perhaps in didUpdate
       */
      projection.isPresent = isPresent;
      if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) {
        projection.willUpdate();
      } else {
        this.safeToRemove();
      }
      if (prevProps.isPresent !== isPresent) {
        if (isPresent) {
          projection.promote();
        } else if (!projection.relegate()) {
          /**
           * If there's another stack member taking over from this one,
           * it's in charge of the exit animation and therefore should
           * be in charge of the safe to remove. Otherwise we call it here.
           */
          frame.postRender(function () {
            var stack = projection.getStack();
            if (!stack || !stack.members.length) {
              _this2.safeToRemove();
            }
          });
        }
      }
      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;
      var projection = this.props.visualElement.projection;
      if (projection) {
        projection.root.didUpdate();
        queueMicrotask(function () {
          if (!projection.currentAnimation && projection.isLead()) {
            _this3.safeToRemove();
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
        visualElement = _this$props3.visualElement,
        layoutGroup = _this$props3.layoutGroup,
        promoteContext = _this$props3.switchLayoutGroup;
      var projection = visualElement.projection;
      if (projection) {
        projection.scheduleCheckAfterUnmount();
        if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
        if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
      }
    }
  }, {
    key: "safeToRemove",
    value: function safeToRemove() {
      var safeToRemove = this.props.safeToRemove;
      safeToRemove && safeToRemove();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(React__default.Component);
function MeasureLayout(props) {
  var _usePresence = usePresence(),
    _usePresence2 = _slicedToArray$1(_usePresence, 2),
    isPresent = _usePresence2[0],
    safeToRemove = _usePresence2[1];
  var layoutGroup = useContext(LayoutGroupContext);
  return /*#__PURE__*/React__default.createElement(MeasureLayoutWithContext, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    layoutGroup: layoutGroup,
    switchLayoutGroup: useContext(SwitchLayoutGroupContext),
    isPresent: isPresent,
    safeToRemove: safeToRemove
  }));
}
var defaultScaleCorrectors = {
  borderRadius: _objectSpread2$1(_objectSpread2$1({}, correctBorderRadius), {}, {
    applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
  }),
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};

var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
var numBorders = borders.length;
var asNumber = function asNumber(value) {
  return typeof value === "string" ? parseFloat(value) : value;
};
var isPx = function isPx(value) {
  return typeof value === "number" || px.test(value);
};
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
  if (shouldCrossfadeOpacity) {
    target.opacity = mix(0,
    // TODO Reinstate this if only child
    lead.opacity !== undefined ? lead.opacity : 1, easeCrossfadeIn(progress));
    target.opacityExit = mix(follow.opacity !== undefined ? follow.opacity : 1, 0, easeCrossfadeOut(progress));
  } else if (isOnlyMember) {
    target.opacity = mix(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
  }
  /**
   * Mix border radius
   */
  for (var i = 0; i < numBorders; i++) {
    var borderLabel = "border".concat(borders[i], "Radius");
    var followRadius = getRadius(follow, borderLabel);
    var leadRadius = getRadius(lead, borderLabel);
    if (followRadius === undefined && leadRadius === undefined) continue;
    followRadius || (followRadius = 0);
    leadRadius || (leadRadius = 0);
    var canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
    if (canMix) {
      target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress), 0);
      if (percent.test(leadRadius) || percent.test(followRadius)) {
        target[borderLabel] += "%";
      }
    } else {
      target[borderLabel] = leadRadius;
    }
  }
  /**
   * Mix rotation
   */
  if (follow.rotate || lead.rotate) {
    target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress);
  }
}
function getRadius(values, radiusName) {
  return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
var easeCrossfadeIn = compress(0, 0.5, circOut);
var easeCrossfadeOut = compress(0.5, 0.95, noop$1);
function compress(min, max, easing) {
  return function (p) {
    // Could replace ifs with clamp
    if (p < min) return 0;
    if (p > max) return 1;
    return easing(progress$1(min, max, p));
  };
}

/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyAxisInto(axis, originAxis) {
  axis.min = originAxis.min;
  axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyBoxInto(box, originBox) {
  copyAxisInto(box.x, originBox.x);
  copyAxisInto(box.y, originBox.y);
}

/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */
function removePointDelta(point, translate, scale, originPoint, boxScale) {
  point -= translate;
  point = scalePoint(point, 1 / scale, originPoint);
  if (boxScale !== undefined) {
    point = scalePoint(point, 1 / boxScale, originPoint);
  }
  return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */
function removeAxisDelta(axis) {
  var translate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
  var boxScale = arguments.length > 4 ? arguments[4] : undefined;
  var originAxis = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : axis;
  var sourceAxis = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : axis;
  if (percent.test(translate)) {
    translate = parseFloat(translate);
    var relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
    translate = relativeProgress - sourceAxis.min;
  }
  if (typeof translate !== "number") return;
  var originPoint = mix(originAxis.min, originAxis.max, origin);
  if (axis === originAxis) originPoint -= translate;
  axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
  axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeAxisTransforms(axis, transforms, _ref, origin, sourceAxis) {
  var _ref2 = _slicedToArray$1(_ref, 3),
    key = _ref2[0],
    scaleKey = _ref2[1],
    originKey = _ref2[2];
  removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
  removeAxisTransforms(box.x, transforms, xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
  removeAxisTransforms(box.y, transforms, yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

function isAxisDeltaZero(delta) {
  return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
  return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
  return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function boxEqualsRounded(a, b) {
  return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function aspectRatio(box) {
  return calcLength(box.x) / calcLength(box.y);
}

var NodeStack = /*#__PURE__*/function () {
  function NodeStack() {
    _classCallCheck$1(this, NodeStack);
    this.members = [];
  }
  return _createClass$1(NodeStack, [{
    key: "add",
    value: function add(node) {
      addUniqueItem(this.members, node);
      node.scheduleRender();
    }
  }, {
    key: "remove",
    value: function remove(node) {
      removeItem(this.members, node);
      if (node === this.prevLead) {
        this.prevLead = undefined;
      }
      if (node === this.lead) {
        var prevLead = this.members[this.members.length - 1];
        if (prevLead) {
          this.promote(prevLead);
        }
      }
    }
  }, {
    key: "relegate",
    value: function relegate(node) {
      var indexOfNode = this.members.findIndex(function (member) {
        return node === member;
      });
      if (indexOfNode === 0) return false;
      /**
       * Find the next projection node that is present
       */
      var prevLead;
      for (var i = indexOfNode; i >= 0; i--) {
        var member = this.members[i];
        if (member.isPresent !== false) {
          prevLead = member;
          break;
        }
      }
      if (prevLead) {
        this.promote(prevLead);
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "promote",
    value: function promote(node, preserveFollowOpacity) {
      var prevLead = this.lead;
      if (node === prevLead) return;
      this.prevLead = prevLead;
      this.lead = node;
      node.show();
      if (prevLead) {
        prevLead.instance && prevLead.scheduleRender();
        node.scheduleRender();
        node.resumeFrom = prevLead;
        if (preserveFollowOpacity) {
          node.resumeFrom.preserveOpacity = true;
        }
        if (prevLead.snapshot) {
          node.snapshot = prevLead.snapshot;
          node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
        }
        if (node.root && node.root.isUpdating) {
          node.isLayoutDirty = true;
        }
        var crossfade = node.options.crossfade;
        if (crossfade === false) {
          prevLead.hide();
        }
        /**
         * TODO:
         *   - Test border radius when previous node was deleted
         *   - boxShadow mixing
         *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
         *   - Shared between element A in transformed container and element B (transform stays the same or changes)
         *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
         * ---
         *   - Crossfade opacity of root nodes
         *   - layoutId changes after animation
         *   - layoutId changes mid animation
         */
      }
    }
  }, {
    key: "exitAnimationComplete",
    value: function exitAnimationComplete() {
      this.members.forEach(function (node) {
        var options = node.options,
          resumingFrom = node.resumingFrom;
        options.onExitComplete && options.onExitComplete();
        if (resumingFrom) {
          resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        }
      });
    }
  }, {
    key: "scheduleRender",
    value: function scheduleRender() {
      this.members.forEach(function (node) {
        node.instance && node.scheduleRender(false);
      });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */
  }, {
    key: "removeLeadSnapshot",
    value: function removeLeadSnapshot() {
      if (this.lead && this.lead.snapshot) {
        this.lead.snapshot = undefined;
      }
    }
  }]);
}();

function buildProjectionTransform(delta, treeScale, latestTransform) {
  var transform = "";
  /**
   * The translations we use to calculate are always relative to the viewport coordinate space.
   * But when we apply scales, we also scale the coordinate space of an element and its children.
   * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
   * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
   */
  var xTranslate = delta.x.translate / treeScale.x;
  var yTranslate = delta.y.translate / treeScale.y;
  if (xTranslate || yTranslate) {
    transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, 0) ");
  }
  /**
   * Apply scale correction for the tree transform.
   * This will apply scale to the screen-orientated axes.
   */
  if (treeScale.x !== 1 || treeScale.y !== 1) {
    transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
  }
  if (latestTransform) {
    var rotate = latestTransform.rotate,
      rotateX = latestTransform.rotateX,
      rotateY = latestTransform.rotateY;
    if (rotate) transform += "rotate(".concat(rotate, "deg) ");
    if (rotateX) transform += "rotateX(".concat(rotateX, "deg) ");
    if (rotateY) transform += "rotateY(".concat(rotateY, "deg) ");
  }
  /**
   * Apply scale to match the size of the element to the size we want it.
   * This will apply scale to the element-orientated axes.
   */
  var elementScaleX = delta.x.scale * treeScale.x;
  var elementScaleY = delta.y.scale * treeScale.y;
  if (elementScaleX !== 1 || elementScaleY !== 1) {
    transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
  }
  return transform || "none";
}

var compareByDepth = function compareByDepth(a, b) {
  return a.depth - b.depth;
};

var FlatTree = /*#__PURE__*/function () {
  function FlatTree() {
    _classCallCheck$1(this, FlatTree);
    this.children = [];
    this.isDirty = false;
  }
  return _createClass$1(FlatTree, [{
    key: "add",
    value: function add(child) {
      addUniqueItem(this.children, child);
      this.isDirty = true;
    }
  }, {
    key: "remove",
    value: function remove(child) {
      removeItem(this.children, child);
      this.isDirty = true;
    }
  }, {
    key: "forEach",
    value: function forEach(callback) {
      this.isDirty && this.children.sort(compareByDepth);
      this.isDirty = false;
      this.children.forEach(callback);
    }
  }]);
}();

/**
 * Timeout defined in ms
 */
function delay(callback, timeout) {
  var start = performance.now();
  var _checkElapsed = function checkElapsed(_ref) {
    var timestamp = _ref.timestamp;
    var elapsed = timestamp - start;
    if (elapsed >= timeout) {
      cancelFrame(_checkElapsed);
      callback(elapsed - timeout);
    }
  };
  frame.read(_checkElapsed, true);
  return function () {
    return cancelFrame(_checkElapsed);
  };
}

function record(data) {
  if (window.MotionDebug) {
    window.MotionDebug.record(data);
  }
}

function isSVGElement(element) {
  return element instanceof SVGElement && element.tagName !== "svg";
}

function animateSingleValue(value, keyframes, options) {
  var motionValue$1 = isMotionValue(value) ? value : motionValue(value);
  motionValue$1.start(animateMotionValue("", motionValue$1, keyframes, options));
  return motionValue$1.animation;
}

var transformAxes = ["", "X", "Y", "Z"];
var hiddenVisibility = {
  visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */
var animationTarget = 1000;
var id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */
var projectionFrameData = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function createProjectionNode(_ref) {
  var attachResizeListener = _ref.attachResizeListener,
    defaultParent = _ref.defaultParent,
    measureScroll = _ref.measureScroll,
    checkIsScrollRoot = _ref.checkIsScrollRoot,
    _resetTransform = _ref.resetTransform;
  return /*#__PURE__*/function () {
    function ProjectionNode() {
      var _this = this;
      var latestValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
      _classCallCheck$1(this, ProjectionNode);
      /**
       * A unique ID generated for every projection node.
       */
      this.id = id++;
      /**
       * An id that represents a unique session instigated by startUpdate.
       */
      this.animationId = 0;
      /**
       * A Set containing all this component's children. This is used to iterate
       * through the children.
       *
       * TODO: This could be faster to iterate as a flat array stored on the root node.
       */
      this.children = new Set();
      /**
       * Options for the node. We use this to configure what kind of layout animations
       * we should perform (if any).
       */
      this.options = {};
      /**
       * We use this to detect when its safe to shut down part of a projection tree.
       * We have to keep projecting children for scale correction and relative projection
       * until all their parents stop performing layout animations.
       */
      this.isTreeAnimating = false;
      this.isAnimationBlocked = false;
      /**
       * Flag to true if we think this layout has been changed. We can't always know this,
       * currently we set it to true every time a component renders, or if it has a layoutDependency
       * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
       * and if one node is dirtied, they all are.
       */
      this.isLayoutDirty = false;
      /**
       * Flag to true if we think the projection calculations for this node needs
       * recalculating as a result of an updated transform or layout animation.
       */
      this.isProjectionDirty = false;
      /**
       * Flag to true if the layout *or* transform has changed. This then gets propagated
       * throughout the projection tree, forcing any element below to recalculate on the next frame.
       */
      this.isSharedProjectionDirty = false;
      /**
       * Flag transform dirty. This gets propagated throughout the whole tree but is only
       * respected by shared nodes.
       */
      this.isTransformDirty = false;
      /**
       * Block layout updates for instant layout transitions throughout the tree.
       */
      this.updateManuallyBlocked = false;
      this.updateBlockedByResize = false;
      /**
       * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
       * call.
       */
      this.isUpdating = false;
      /**
       * If this is an SVG element we currently disable projection transforms
       */
      this.isSVG = false;
      /**
       * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
       * its projection styles.
       */
      this.needsReset = false;
      /**
       * Flags whether this node should have its transform reset prior to measuring.
       */
      this.shouldResetTransform = false;
      /**
       * An object representing the calculated contextual/accumulated/tree scale.
       * This will be used to scale calculcated projection transforms, as these are
       * calculated in screen-space but need to be scaled for elements to layoutly
       * make it to their calculated destinations.
       *
       * TODO: Lazy-init
       */
      this.treeScale = {
        x: 1,
        y: 1
      };
      /**
       *
       */
      this.eventHandlers = new Map();
      this.hasTreeAnimated = false;
      // Note: Currently only running on root node
      this.updateScheduled = false;
      this.projectionUpdateScheduled = false;
      this.checkUpdateFailed = function () {
        if (_this.isUpdating) {
          _this.isUpdating = false;
          _this.clearAllSnapshots();
        }
      };
      /**
       * This is a multi-step process as shared nodes might be of different depths. Nodes
       * are sorted by depth order, so we need to resolve the entire tree before moving to
       * the next step.
       */
      this.updateProjection = function () {
        _this.projectionUpdateScheduled = false;
        /**
         * Reset debug counts. Manually resetting rather than creating a new
         * object each frame.
         */
        projectionFrameData.totalNodes = projectionFrameData.resolvedTargetDeltas = projectionFrameData.recalculatedProjection = 0;
        _this.nodes.forEach(propagateDirtyNodes);
        _this.nodes.forEach(resolveTargetDelta);
        _this.nodes.forEach(calcProjection);
        _this.nodes.forEach(cleanDirtyNodes);
        record(projectionFrameData);
      };
      this.hasProjected = false;
      this.isVisible = true;
      this.animationProgress = 0;
      /**
       * Shared layout
       */
      // TODO Only running on root node
      this.sharedNodes = new Map();
      this.latestValues = latestValues;
      this.root = parent ? parent.root || parent : this;
      this.path = parent ? [].concat(_toConsumableArray$1(parent.path), [parent]) : [];
      this.parent = parent;
      this.depth = parent ? parent.depth + 1 : 0;
      for (var i = 0; i < this.path.length; i++) {
        this.path[i].shouldResetTransform = true;
      }
      if (this.root === this) this.nodes = new FlatTree();
    }
    return _createClass$1(ProjectionNode, [{
      key: "addEventListener",
      value: function addEventListener(name, handler) {
        if (!this.eventHandlers.has(name)) {
          this.eventHandlers.set(name, new SubscriptionManager());
        }
        return this.eventHandlers.get(name).add(handler);
      }
    }, {
      key: "notifyListeners",
      value: function notifyListeners(name) {
        var subscriptionManager = this.eventHandlers.get(name);
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        subscriptionManager && subscriptionManager.notify.apply(subscriptionManager, args);
      }
    }, {
      key: "hasListeners",
      value: function hasListeners(name) {
        return this.eventHandlers.has(name);
      }
      /**
       * Lifecycles
       */
    }, {
      key: "mount",
      value: function mount(instance) {
        var _this2 = this;
        var isLayoutDirty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.root.hasTreeAnimated;
        if (this.instance) return;
        this.isSVG = isSVGElement(instance);
        this.instance = instance;
        var _this$options = this.options,
          layoutId = _this$options.layoutId,
          layout = _this$options.layout,
          visualElement = _this$options.visualElement;
        if (visualElement && !visualElement.current) {
          visualElement.mount(instance);
        }
        this.root.nodes.add(this);
        this.parent && this.parent.children.add(this);
        if (isLayoutDirty && (layout || layoutId)) {
          this.isLayoutDirty = true;
        }
        if (attachResizeListener) {
          var cancelDelay;
          var resizeUnblockUpdate = function resizeUnblockUpdate() {
            return _this2.root.updateBlockedByResize = false;
          };
          attachResizeListener(instance, function () {
            _this2.root.updateBlockedByResize = true;
            cancelDelay && cancelDelay();
            cancelDelay = delay(resizeUnblockUpdate, 250);
            if (globalProjectionState.hasAnimatedSinceResize) {
              globalProjectionState.hasAnimatedSinceResize = false;
              _this2.nodes.forEach(finishAnimation);
            }
          });
        }
        if (layoutId) {
          this.root.registerSharedNode(layoutId, this);
        }
        // Only register the handler if it requires layout animation
        if (this.options.animate !== false && visualElement && (layoutId || layout)) {
          this.addEventListener("didUpdate", function (_ref2) {
            var delta = _ref2.delta,
              hasLayoutChanged = _ref2.hasLayoutChanged,
              hasRelativeTargetChanged = _ref2.hasRelativeTargetChanged,
              newLayout = _ref2.layout;
            if (_this2.isTreeAnimationBlocked()) {
              _this2.target = undefined;
              _this2.relativeTarget = undefined;
              return;
            }
            // TODO: Check here if an animation exists
            var layoutTransition = _this2.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition;
            var _visualElement$getPro = visualElement.getProps(),
              onLayoutAnimationStart = _visualElement$getPro.onLayoutAnimationStart,
              onLayoutAnimationComplete = _visualElement$getPro.onLayoutAnimationComplete;
            /**
             * The target layout of the element might stay the same,
             * but its position relative to its parent has changed.
             */
            var targetChanged = !_this2.targetLayout || !boxEqualsRounded(_this2.targetLayout, newLayout) || hasRelativeTargetChanged;
            /**
             * If the layout hasn't seemed to have changed, it might be that the
             * element is visually in the same place in the document but its position
             * relative to its parent has indeed changed. So here we check for that.
             */
            var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
            if (_this2.options.layoutRoot || _this2.resumeFrom && _this2.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !_this2.currentAnimation)) {
              if (_this2.resumeFrom) {
                _this2.resumingFrom = _this2.resumeFrom;
                _this2.resumingFrom.resumingFrom = undefined;
              }
              _this2.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
              var animationOptions = _objectSpread2$1(_objectSpread2$1({}, getValueTransition(layoutTransition, "layout")), {}, {
                onPlay: onLayoutAnimationStart,
                onComplete: onLayoutAnimationComplete
              });
              if (visualElement.shouldReduceMotion || _this2.options.layoutRoot) {
                animationOptions.delay = 0;
                animationOptions.type = false;
              }
              _this2.startAnimation(animationOptions);
            } else {
              /**
               * If the layout hasn't changed and we have an animation that hasn't started yet,
               * finish it immediately. Otherwise it will be animating from a location
               * that was probably never commited to screen and look like a jumpy box.
               */
              if (!hasLayoutChanged) {
                finishAnimation(_this2);
              }
              if (_this2.isLead() && _this2.options.onExitComplete) {
                _this2.options.onExitComplete();
              }
            }
            _this2.targetLayout = newLayout;
          });
        }
      }
    }, {
      key: "unmount",
      value: function unmount() {
        this.options.layoutId && this.willUpdate();
        this.root.nodes.remove(this);
        var stack = this.getStack();
        stack && stack.remove(this);
        this.parent && this.parent.children["delete"](this);
        this.instance = undefined;
        cancelFrame(this.updateProjection);
      }
      // only on the root
    }, {
      key: "blockUpdate",
      value: function blockUpdate() {
        this.updateManuallyBlocked = true;
      }
    }, {
      key: "unblockUpdate",
      value: function unblockUpdate() {
        this.updateManuallyBlocked = false;
      }
    }, {
      key: "isUpdateBlocked",
      value: function isUpdateBlocked() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }
    }, {
      key: "isTreeAnimationBlocked",
      value: function isTreeAnimationBlocked() {
        return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
      }
      // Note: currently only running on root node
    }, {
      key: "startUpdate",
      value: function startUpdate() {
        if (this.isUpdateBlocked()) return;
        this.isUpdating = true;
        this.nodes && this.nodes.forEach(resetRotation);
        this.animationId++;
      }
    }, {
      key: "getTransformTemplate",
      value: function getTransformTemplate() {
        var visualElement = this.options.visualElement;
        return visualElement && visualElement.getProps().transformTemplate;
      }
    }, {
      key: "willUpdate",
      value: function willUpdate() {
        var shouldNotifyListeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.root.hasTreeAnimated = true;
        if (this.root.isUpdateBlocked()) {
          this.options.onExitComplete && this.options.onExitComplete();
          return;
        }
        !this.root.isUpdating && this.root.startUpdate();
        if (this.isLayoutDirty) return;
        this.isLayoutDirty = true;
        for (var i = 0; i < this.path.length; i++) {
          var node = this.path[i];
          node.shouldResetTransform = true;
          node.updateScroll("snapshot");
          if (node.options.layoutRoot) {
            node.willUpdate(false);
          }
        }
        var _this$options2 = this.options,
          layoutId = _this$options2.layoutId,
          layout = _this$options2.layout;
        if (layoutId === undefined && !layout) return;
        var transformTemplate = this.getTransformTemplate();
        this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
        this.updateSnapshot();
        shouldNotifyListeners && this.notifyListeners("willUpdate");
      }
    }, {
      key: "update",
      value: function update() {
        this.updateScheduled = false;
        var updateWasBlocked = this.isUpdateBlocked();
        // When doing an instant transition, we skip the layout update,
        // but should still clean up the measurements so that the next
        // snapshot could be taken correctly.
        if (updateWasBlocked) {
          this.unblockUpdate();
          this.clearAllSnapshots();
          this.nodes.forEach(clearMeasurements);
          return;
        }
        if (!this.isUpdating) {
          this.nodes.forEach(clearIsLayoutDirty);
        }
        this.isUpdating = false;
        /**
         * Write
         */
        this.nodes.forEach(resetTransformStyle);
        /**
         * Read ==================
         */
        // Update layout measurements of updated children
        this.nodes.forEach(updateLayout);
        /**
         * Write
         */
        // Notify listeners that the layout is updated
        this.nodes.forEach(notifyLayoutUpdate);
        this.clearAllSnapshots();
        /**
         * Manually flush any pending updates. Ideally
         * we could leave this to the following requestAnimationFrame but this seems
         * to leave a flash of incorrectly styled content.
         */
        var now = performance.now();
        frameData.delta = clamp(0, 1000 / 60, now - frameData.timestamp);
        frameData.timestamp = now;
        frameData.isProcessing = true;
        steps.update.process(frameData);
        steps.preRender.process(frameData);
        steps.render.process(frameData);
        frameData.isProcessing = false;
      }
    }, {
      key: "didUpdate",
      value: function didUpdate() {
        var _this3 = this;
        if (!this.updateScheduled) {
          this.updateScheduled = true;
          queueMicrotask(function () {
            return _this3.update();
          });
        }
      }
    }, {
      key: "clearAllSnapshots",
      value: function clearAllSnapshots() {
        this.nodes.forEach(clearSnapshot);
        this.sharedNodes.forEach(removeLeadSnapshots);
      }
    }, {
      key: "scheduleUpdateProjection",
      value: function scheduleUpdateProjection() {
        if (!this.projectionUpdateScheduled) {
          this.projectionUpdateScheduled = true;
          frame.preRender(this.updateProjection, false, true);
        }
      }
    }, {
      key: "scheduleCheckAfterUnmount",
      value: function scheduleCheckAfterUnmount() {
        var _this4 = this;
        /**
         * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
         * we manually call didUpdate to give a chance to the siblings to animate.
         * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
         */
        frame.postRender(function () {
          if (_this4.isLayoutDirty) {
            _this4.root.didUpdate();
          } else {
            _this4.root.checkUpdateFailed();
          }
        });
      }
      /**
       * Update measurements
       */
    }, {
      key: "updateSnapshot",
      value: function updateSnapshot() {
        if (this.snapshot || !this.instance) return;
        this.snapshot = this.measure();
      }
    }, {
      key: "updateLayout",
      value: function updateLayout() {
        if (!this.instance) return;
        // TODO: Incorporate into a forwarded scroll offset
        this.updateScroll();
        if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) {
          return;
        }
        /**
         * When a node is mounted, it simply resumes from the prevLead's
         * snapshot instead of taking a new one, but the ancestors scroll
         * might have updated while the prevLead is unmounted. We need to
         * update the scroll again to make sure the layout we measure is
         * up to date.
         */
        if (this.resumeFrom && !this.resumeFrom.instance) {
          for (var i = 0; i < this.path.length; i++) {
            var node = this.path[i];
            node.updateScroll();
          }
        }
        var prevLayout = this.layout;
        this.layout = this.measure(false);
        this.layoutCorrected = createBox();
        this.isLayoutDirty = false;
        this.projectionDelta = undefined;
        this.notifyListeners("measure", this.layout.layoutBox);
        var visualElement = this.options.visualElement;
        visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
      }
    }, {
      key: "updateScroll",
      value: function updateScroll() {
        var phase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "measure";
        var needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
        if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) {
          needsMeasurement = false;
        }
        if (needsMeasurement) {
          this.scroll = {
            animationId: this.root.animationId,
            phase: phase,
            isRoot: checkIsScrollRoot(this.instance),
            offset: measureScroll(this.instance)
          };
        }
      }
    }, {
      key: "resetTransform",
      value: function resetTransform() {
        if (!_resetTransform) return;
        var isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
        var hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
        var transformTemplate = this.getTransformTemplate();
        var transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
        var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
        if (isResetRequested && (hasProjection || hasTransform(this.latestValues) || transformTemplateHasChanged)) {
          _resetTransform(this.instance, transformTemplateValue);
          this.shouldResetTransform = false;
          this.scheduleRender();
        }
      }
    }, {
      key: "measure",
      value: function measure() {
        var removeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var pageBox = this.measurePageBox();
        var layoutBox = this.removeElementScroll(pageBox);
        /**
         * Measurements taken during the pre-render stage
         * still have transforms applied so we remove them
         * via calculation.
         */
        if (removeTransform) {
          layoutBox = this.removeTransform(layoutBox);
        }
        roundBox(layoutBox);
        return {
          animationId: this.root.animationId,
          measuredBox: pageBox,
          layoutBox: layoutBox,
          latestValues: {},
          source: this.id
        };
      }
    }, {
      key: "measurePageBox",
      value: function measurePageBox() {
        var visualElement = this.options.visualElement;
        if (!visualElement) return createBox();
        var box = visualElement.measureViewportBox();
        // Remove viewport scroll to give page-relative coordinates
        var scroll = this.root.scroll;
        if (scroll) {
          translateAxis(box.x, scroll.offset.x);
          translateAxis(box.y, scroll.offset.y);
        }
        return box;
      }
    }, {
      key: "removeElementScroll",
      value: function removeElementScroll(box) {
        var boxWithoutScroll = createBox();
        copyBoxInto(boxWithoutScroll, box);
        /**
         * Performance TODO: Keep a cumulative scroll offset down the tree
         * rather than loop back up the path.
         */
        for (var i = 0; i < this.path.length; i++) {
          var node = this.path[i];
          var scroll = node.scroll,
            options = node.options;
          if (node !== this.root && scroll && options.layoutScroll) {
            /**
             * If this is a new scroll root, we want to remove all previous scrolls
             * from the viewport box.
             */
            if (scroll.isRoot) {
              copyBoxInto(boxWithoutScroll, box);
              var rootScroll = this.root.scroll;
              /**
               * Undo the application of page scroll that was originally added
               * to the measured bounding box.
               */
              if (rootScroll) {
                translateAxis(boxWithoutScroll.x, -rootScroll.offset.x);
                translateAxis(boxWithoutScroll.y, -rootScroll.offset.y);
              }
            }
            translateAxis(boxWithoutScroll.x, scroll.offset.x);
            translateAxis(boxWithoutScroll.y, scroll.offset.y);
          }
        }
        return boxWithoutScroll;
      }
    }, {
      key: "applyTransform",
      value: function applyTransform(box) {
        var transformOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var withTransforms = createBox();
        copyBoxInto(withTransforms, box);
        for (var i = 0; i < this.path.length; i++) {
          var node = this.path[i];
          if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) {
            transformBox(withTransforms, {
              x: -node.scroll.offset.x,
              y: -node.scroll.offset.y
            });
          }
          if (!hasTransform(node.latestValues)) continue;
          transformBox(withTransforms, node.latestValues);
        }
        if (hasTransform(this.latestValues)) {
          transformBox(withTransforms, this.latestValues);
        }
        return withTransforms;
      }
    }, {
      key: "removeTransform",
      value: function removeTransform(box) {
        var boxWithoutTransform = createBox();
        copyBoxInto(boxWithoutTransform, box);
        for (var i = 0; i < this.path.length; i++) {
          var node = this.path[i];
          if (!node.instance) continue;
          if (!hasTransform(node.latestValues)) continue;
          hasScale(node.latestValues) && node.updateSnapshot();
          var sourceBox = createBox();
          var nodeBox = node.measurePageBox();
          copyBoxInto(sourceBox, nodeBox);
          removeBoxTransforms(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
        }
        if (hasTransform(this.latestValues)) {
          removeBoxTransforms(boxWithoutTransform, this.latestValues);
        }
        return boxWithoutTransform;
      }
    }, {
      key: "setTargetDelta",
      value: function setTargetDelta(delta) {
        this.targetDelta = delta;
        this.root.scheduleUpdateProjection();
        this.isProjectionDirty = true;
      }
    }, {
      key: "setOptions",
      value: function setOptions(options) {
        this.options = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, this.options), options), {}, {
          crossfade: options.crossfade !== undefined ? options.crossfade : true
        });
      }
    }, {
      key: "clearMeasurements",
      value: function clearMeasurements() {
        this.scroll = undefined;
        this.layout = undefined;
        this.snapshot = undefined;
        this.prevTransformTemplateValue = undefined;
        this.targetDelta = undefined;
        this.target = undefined;
        this.isLayoutDirty = false;
      }
    }, {
      key: "forceRelativeParentToResolveTarget",
      value: function forceRelativeParentToResolveTarget() {
        if (!this.relativeParent) return;
        /**
         * If the parent target isn't up-to-date, force it to update.
         * This is an unfortunate de-optimisation as it means any updating relative
         * projection will cause all the relative parents to recalculate back
         * up the tree.
         */
        if (this.relativeParent.resolvedRelativeTargetAt !== frameData.timestamp) {
          this.relativeParent.resolveTargetDelta(true);
        }
      }
    }, {
      key: "resolveTargetDelta",
      value: function resolveTargetDelta() {
        var forceRecalculation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var _a;
        /**
         * Once the dirty status of nodes has been spread through the tree, we also
         * need to check if we have a shared node of a different depth that has itself
         * been dirtied.
         */
        var lead = this.getLead();
        this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
        this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
        this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
        var isShared = Boolean(this.resumingFrom) || this !== lead;
        /**
         * We don't use transform for this step of processing so we don't
         * need to check whether any nodes have changed transform.
         */
        var canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
        if (canSkip) return;
        var _this$options3 = this.options,
          layout = _this$options3.layout,
          layoutId = _this$options3.layoutId;
        /**
         * If we have no layout, we can't perform projection, so early return
         */
        if (!this.layout || !(layout || layoutId)) return;
        this.resolvedRelativeTargetAt = frameData.timestamp;
        /**
         * If we don't have a targetDelta but do have a layout, we can attempt to resolve
         * a relativeParent. This will allow a component to perform scale correction
         * even if no animation has started.
         */
        // TODO If this is unsuccessful this currently happens every frame
        if (!this.targetDelta && !this.relativeTarget) {
          // TODO: This is a semi-repetition of further down this function, make DRY
          var relativeParent = this.getClosestProjectingParent();
          if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
            this.relativeParent = relativeParent;
            this.forceRelativeParentToResolveTarget();
            this.relativeTarget = createBox();
            this.relativeTargetOrigin = createBox();
            calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
            copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
          } else {
            this.relativeParent = this.relativeTarget = undefined;
          }
        }
        /**
         * If we have no relative target or no target delta our target isn't valid
         * for this frame.
         */
        if (!this.relativeTarget && !this.targetDelta) return;
        /**
         * Lazy-init target data structure
         */
        if (!this.target) {
          this.target = createBox();
          this.targetWithTransforms = createBox();
        }
        /**
         * If we've got a relative box for this component, resolve it into a target relative to the parent.
         */
        if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
          this.forceRelativeParentToResolveTarget();
          calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
          /**
           * If we've only got a targetDelta, resolve it into a target
           */
        } else if (this.targetDelta) {
          if (Boolean(this.resumingFrom)) {
            // TODO: This is creating a new object every frame
            this.target = this.applyTransform(this.layout.layoutBox);
          } else {
            copyBoxInto(this.target, this.layout.layoutBox);
          }
          applyBoxDelta(this.target, this.targetDelta);
        } else {
          /**
           * If no target, use own layout as target
           */
          copyBoxInto(this.target, this.layout.layoutBox);
        }
        /**
         * If we've been told to attempt to resolve a relative target, do so.
         */
        if (this.attemptToResolveRelativeTarget) {
          this.attemptToResolveRelativeTarget = false;
          var _relativeParent = this.getClosestProjectingParent();
          if (_relativeParent && Boolean(_relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !_relativeParent.options.layoutScroll && _relativeParent.target && this.animationProgress !== 1) {
            this.relativeParent = _relativeParent;
            this.forceRelativeParentToResolveTarget();
            this.relativeTarget = createBox();
            this.relativeTargetOrigin = createBox();
            calcRelativePosition(this.relativeTargetOrigin, this.target, _relativeParent.target);
            copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
          } else {
            this.relativeParent = this.relativeTarget = undefined;
          }
        }
        /**
         * Increase debug counter for resolved target deltas
         */
        projectionFrameData.resolvedTargetDeltas++;
      }
    }, {
      key: "getClosestProjectingParent",
      value: function getClosestProjectingParent() {
        if (!this.parent || hasScale(this.parent.latestValues) || has2DTranslate(this.parent.latestValues)) {
          return undefined;
        }
        if (this.parent.isProjecting()) {
          return this.parent;
        } else {
          return this.parent.getClosestProjectingParent();
        }
      }
    }, {
      key: "isProjecting",
      value: function isProjecting() {
        return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
      }
    }, {
      key: "calcProjection",
      value: function calcProjection() {
        var _a;
        var lead = this.getLead();
        var isShared = Boolean(this.resumingFrom) || this !== lead;
        var canSkip = true;
        /**
         * If this is a normal layout animation and neither this node nor its nearest projecting
         * is dirty then we can't skip.
         */
        if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) {
          canSkip = false;
        }
        /**
         * If this is a shared layout animation and this node's shared projection is dirty then
         * we can't skip.
         */
        if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) {
          canSkip = false;
        }
        /**
         * If we have resolved the target this frame we must recalculate the
         * projection to ensure it visually represents the internal calculations.
         */
        if (this.resolvedRelativeTargetAt === frameData.timestamp) {
          canSkip = false;
        }
        if (canSkip) return;
        var _this$options4 = this.options,
          layout = _this$options4.layout,
          layoutId = _this$options4.layoutId;
        /**
         * If this section of the tree isn't animating we can
         * delete our target sources for the following frame.
         */
        this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
        if (!this.isTreeAnimating) {
          this.targetDelta = this.relativeTarget = undefined;
        }
        if (!this.layout || !(layout || layoutId)) return;
        /**
         * Reset the corrected box with the latest values from box, as we're then going
         * to perform mutative operations on it.
         */
        copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
        /**
         * Record previous tree scales before updating.
         */
        var prevTreeScaleX = this.treeScale.x;
        var prevTreeScaleY = this.treeScale.y;
        /**
         * Apply all the parent deltas to this box to produce the corrected box. This
         * is the layout box, as it will appear on screen as a result of the transforms of its parents.
         */
        applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
        /**
         * If this layer needs to perform scale correction but doesn't have a target,
         * use the layout as the target.
         */
        if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
          lead.target = lead.layout.layoutBox;
        }
        var target = lead.target;
        if (!target) {
          /**
           * If we don't have a target to project into, but we were previously
           * projecting, we want to remove the stored transform and schedule
           * a render to ensure the elements reflect the removed transform.
           */
          if (this.projectionTransform) {
            this.projectionDelta = createDelta();
            this.projectionTransform = "none";
            this.scheduleRender();
          }
          return;
        }
        if (!this.projectionDelta) {
          this.projectionDelta = createDelta();
          this.projectionDeltaWithTransform = createDelta();
        }
        var prevProjectionTransform = this.projectionTransform;
        /**
         * Update the delta between the corrected box and the target box before user-set transforms were applied.
         * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
         * for our layout reprojection, but still allow them to be scaled correctly by the user.
         * It might be that to simplify this we may want to accept that user-set scale is also corrected
         * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
         * to allow people to choose whether these styles are corrected based on just the
         * layout reprojection or the final bounding box.
         */
        calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
        this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
        if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
          this.hasProjected = true;
          this.scheduleRender();
          this.notifyListeners("projectionUpdate", target);
        }
        /**
         * Increase debug counter for recalculated projections
         */
        projectionFrameData.recalculatedProjection++;
      }
    }, {
      key: "hide",
      value: function hide() {
        this.isVisible = false;
        // TODO: Schedule render
      }
    }, {
      key: "show",
      value: function show() {
        this.isVisible = true;
        // TODO: Schedule render
      }
    }, {
      key: "scheduleRender",
      value: function scheduleRender() {
        var notifyAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.options.scheduleRender && this.options.scheduleRender();
        if (notifyAll) {
          var stack = this.getStack();
          stack && stack.scheduleRender();
        }
        if (this.resumingFrom && !this.resumingFrom.instance) {
          this.resumingFrom = undefined;
        }
      }
    }, {
      key: "setAnimationOrigin",
      value: function setAnimationOrigin(delta) {
        var _this5 = this;
        var hasOnlyRelativeTargetChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var snapshot = this.snapshot;
        var snapshotLatestValues = snapshot ? snapshot.latestValues : {};
        var mixedValues = _objectSpread2$1({}, this.latestValues);
        var targetDelta = createDelta();
        if (!this.relativeParent || !this.relativeParent.options.layoutRoot) {
          this.relativeTarget = this.relativeTargetOrigin = undefined;
        }
        this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
        var relativeLayout = createBox();
        var snapshotSource = snapshot ? snapshot.source : undefined;
        var layoutSource = this.layout ? this.layout.source : undefined;
        var isSharedLayoutAnimation = snapshotSource !== layoutSource;
        var stack = this.getStack();
        var isOnlyMember = !stack || stack.members.length <= 1;
        var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
        this.animationProgress = 0;
        var prevRelativeTarget;
        this.mixTargetDelta = function (latest) {
          var progress = latest / 1000;
          mixAxisDelta(targetDelta.x, delta.x, progress);
          mixAxisDelta(targetDelta.y, delta.y, progress);
          _this5.setTargetDelta(targetDelta);
          if (_this5.relativeTarget && _this5.relativeTargetOrigin && _this5.layout && _this5.relativeParent && _this5.relativeParent.layout) {
            calcRelativePosition(relativeLayout, _this5.layout.layoutBox, _this5.relativeParent.layout.layoutBox);
            mixBox(_this5.relativeTarget, _this5.relativeTargetOrigin, relativeLayout, progress);
            /**
             * If this is an unchanged relative target we can consider the
             * projection not dirty.
             */
            if (prevRelativeTarget && boxEquals(_this5.relativeTarget, prevRelativeTarget)) {
              _this5.isProjectionDirty = false;
            }
            if (!prevRelativeTarget) prevRelativeTarget = createBox();
            copyBoxInto(prevRelativeTarget, _this5.relativeTarget);
          }
          if (isSharedLayoutAnimation) {
            _this5.animationValues = mixedValues;
            mixValues(mixedValues, snapshotLatestValues, _this5.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
          }
          _this5.root.scheduleUpdateProjection();
          _this5.scheduleRender();
          _this5.animationProgress = progress;
        };
        this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
      }
    }, {
      key: "startAnimation",
      value: function startAnimation(options) {
        var _this6 = this;
        this.notifyListeners("animationStart");
        this.currentAnimation && this.currentAnimation.stop();
        if (this.resumingFrom && this.resumingFrom.currentAnimation) {
          this.resumingFrom.currentAnimation.stop();
        }
        if (this.pendingAnimation) {
          cancelFrame(this.pendingAnimation);
          this.pendingAnimation = undefined;
        }
        /**
         * Start the animation in the next frame to have a frame with progress 0,
         * where the target is the same as when the animation started, so we can
         * calculate the relative positions correctly for instant transitions.
         */
        this.pendingAnimation = frame.update(function () {
          globalProjectionState.hasAnimatedSinceResize = true;
          _this6.currentAnimation = animateSingleValue(0, animationTarget, _objectSpread2$1(_objectSpread2$1({}, options), {}, {
            onUpdate: function onUpdate(latest) {
              _this6.mixTargetDelta(latest);
              options.onUpdate && options.onUpdate(latest);
            },
            onComplete: function onComplete() {
              options.onComplete && options.onComplete();
              _this6.completeAnimation();
            }
          }));
          if (_this6.resumingFrom) {
            _this6.resumingFrom.currentAnimation = _this6.currentAnimation;
          }
          _this6.pendingAnimation = undefined;
        });
      }
    }, {
      key: "completeAnimation",
      value: function completeAnimation() {
        if (this.resumingFrom) {
          this.resumingFrom.currentAnimation = undefined;
          this.resumingFrom.preserveOpacity = undefined;
        }
        var stack = this.getStack();
        stack && stack.exitAnimationComplete();
        this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
        this.notifyListeners("animationComplete");
      }
    }, {
      key: "finishAnimation",
      value: function finishAnimation() {
        if (this.currentAnimation) {
          this.mixTargetDelta && this.mixTargetDelta(animationTarget);
          this.currentAnimation.stop();
        }
        this.completeAnimation();
      }
    }, {
      key: "applyTransformsToTarget",
      value: function applyTransformsToTarget() {
        var lead = this.getLead();
        var targetWithTransforms = lead.targetWithTransforms,
          target = lead.target,
          layout = lead.layout,
          latestValues = lead.latestValues;
        if (!targetWithTransforms || !target || !layout) return;
        /**
         * If we're only animating position, and this element isn't the lead element,
         * then instead of projecting into the lead box we instead want to calculate
         * a new target that aligns the two boxes but maintains the layout shape.
         */
        if (this !== lead && this.layout && layout && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
          target = this.target || createBox();
          var xLength = calcLength(this.layout.layoutBox.x);
          target.x.min = lead.target.x.min;
          target.x.max = target.x.min + xLength;
          var yLength = calcLength(this.layout.layoutBox.y);
          target.y.min = lead.target.y.min;
          target.y.max = target.y.min + yLength;
        }
        copyBoxInto(targetWithTransforms, target);
        /**
         * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
         * This is the final box that we will then project into by calculating a transform delta and
         * applying it to the corrected box.
         */
        transformBox(targetWithTransforms, latestValues);
        /**
         * Update the delta between the corrected box and the final target box, after
         * user-set transforms are applied to it. This will be used by the renderer to
         * create a transform style that will reproject the element from its layout layout
         * into the desired bounding box.
         */
        calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
      }
    }, {
      key: "registerSharedNode",
      value: function registerSharedNode(layoutId, node) {
        if (!this.sharedNodes.has(layoutId)) {
          this.sharedNodes.set(layoutId, new NodeStack());
        }
        var stack = this.sharedNodes.get(layoutId);
        stack.add(node);
        var config = node.options.initialPromotionConfig;
        node.promote({
          transition: config ? config.transition : undefined,
          preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
        });
      }
    }, {
      key: "isLead",
      value: function isLead() {
        var stack = this.getStack();
        return stack ? stack.lead === this : true;
      }
    }, {
      key: "getLead",
      value: function getLead() {
        var _a;
        var layoutId = this.options.layoutId;
        return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
      }
    }, {
      key: "getPrevLead",
      value: function getPrevLead() {
        var _a;
        var layoutId = this.options.layoutId;
        return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
      }
    }, {
      key: "getStack",
      value: function getStack() {
        var layoutId = this.options.layoutId;
        if (layoutId) return this.root.sharedNodes.get(layoutId);
      }
    }, {
      key: "promote",
      value: function promote() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          needsReset = _ref3.needsReset,
          transition = _ref3.transition,
          preserveFollowOpacity = _ref3.preserveFollowOpacity;
        var stack = this.getStack();
        if (stack) stack.promote(this, preserveFollowOpacity);
        if (needsReset) {
          this.projectionDelta = undefined;
          this.needsReset = true;
        }
        if (transition) this.setOptions({
          transition: transition
        });
      }
    }, {
      key: "relegate",
      value: function relegate() {
        var stack = this.getStack();
        if (stack) {
          return stack.relegate(this);
        } else {
          return false;
        }
      }
    }, {
      key: "resetRotation",
      value: function resetRotation() {
        var visualElement = this.options.visualElement;
        if (!visualElement) return;
        // If there's no detected rotation values, we can early return without a forced render.
        var hasRotate = false;
        /**
         * An unrolled check for rotation values. Most elements don't have any rotation and
         * skipping the nested loop and new object creation is 50% faster.
         */
        var latestValues = visualElement.latestValues;
        if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) {
          hasRotate = true;
        }
        // If there's no rotation values, we don't need to do any more.
        if (!hasRotate) return;
        var resetValues = {};
        // Check the rotate value of all axes and reset to 0
        for (var i = 0; i < transformAxes.length; i++) {
          var key = "rotate" + transformAxes[i];
          // Record the rotation and then temporarily set it to 0
          if (latestValues[key]) {
            resetValues[key] = latestValues[key];
            visualElement.setStaticValue(key, 0);
          }
        }
        // Force a render of this element to apply the transform with all rotations
        // set to 0.
        visualElement.render();
        // Put back all the values we reset
        for (var _key2 in resetValues) {
          visualElement.setStaticValue(_key2, resetValues[_key2]);
        }
        // Schedule a render for the next frame. This ensures we won't visually
        // see the element with the reset rotate value applied.
        visualElement.scheduleRender();
      }
    }, {
      key: "getProjectionStyles",
      value: function getProjectionStyles(styleProp) {
        var _a, _b;
        if (!this.instance || this.isSVG) return undefined;
        if (!this.isVisible) {
          return hiddenVisibility;
        }
        var styles = {
          visibility: ""
        };
        var transformTemplate = this.getTransformTemplate();
        if (this.needsReset) {
          this.needsReset = false;
          styles.opacity = "";
          styles.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
          styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
          return styles;
        }
        var lead = this.getLead();
        if (!this.projectionDelta || !this.layout || !lead.target) {
          var emptyStyles = {};
          if (this.options.layoutId) {
            emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
            emptyStyles.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
          }
          if (this.hasProjected && !hasTransform(this.latestValues)) {
            emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
            this.hasProjected = false;
          }
          return emptyStyles;
        }
        var valuesToRender = lead.animationValues || lead.latestValues;
        this.applyTransformsToTarget();
        styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
        if (transformTemplate) {
          styles.transform = transformTemplate(valuesToRender, styles.transform);
        }
        var _this$projectionDelta = this.projectionDelta,
          x = _this$projectionDelta.x,
          y = _this$projectionDelta.y;
        styles.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
        if (lead.animationValues) {
          /**
           * If the lead component is animating, assign this either the entering/leaving
           * opacity
           */
          styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
        } else {
          /**
           * Or we're not animating at all, set the lead component to its layout
           * opacity and other components to hidden.
           */
          styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
        }
        /**
         * Apply scale correction
         */
        for (var key in scaleCorrectors) {
          if (valuesToRender[key] === undefined) continue;
          var _scaleCorrectors$key = scaleCorrectors[key],
            correct = _scaleCorrectors$key.correct,
            applyTo = _scaleCorrectors$key.applyTo;
          /**
           * Only apply scale correction to the value if we have an
           * active projection transform. Otherwise these values become
           * vulnerable to distortion if the element changes size without
           * a corresponding layout animation.
           */
          var corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
          if (applyTo) {
            var num = applyTo.length;
            for (var i = 0; i < num; i++) {
              styles[applyTo[i]] = corrected;
            }
          } else {
            styles[key] = corrected;
          }
        }
        /**
         * Disable pointer events on follow components. This is to ensure
         * that if a follow component covers a lead component it doesn't block
         * pointer events on the lead.
         */
        if (this.options.layoutId) {
          styles.pointerEvents = lead === this ? resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
        }
        return styles;
      }
    }, {
      key: "clearSnapshot",
      value: function clearSnapshot() {
        this.resumeFrom = this.snapshot = undefined;
      }
      // Only run on root
    }, {
      key: "resetTree",
      value: function resetTree() {
        this.root.nodes.forEach(function (node) {
          var _a;
          return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
        });
        this.root.nodes.forEach(clearMeasurements);
        this.root.sharedNodes.clear();
      }
    }]);
  }();
}
function updateLayout(node) {
  node.updateLayout();
}
function notifyLayoutUpdate(node) {
  var _a;
  var snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
  if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
    var _node$layout = node.layout,
      layout = _node$layout.layoutBox,
      measuredLayout = _node$layout.measuredBox;
    var animationType = node.options.animationType;
    var isShared = snapshot.source !== node.layout.source;
    // TODO Maybe we want to also resize the layout snapshot so we don't trigger
    // animations for instance if layout="size" and an element has only changed position
    if (animationType === "size") {
      eachAxis(function (axis) {
        var axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        var length = calcLength(axisSnapshot);
        axisSnapshot.min = layout[axis].min;
        axisSnapshot.max = axisSnapshot.min + length;
      });
    } else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) {
      eachAxis(function (axis) {
        var axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        var length = calcLength(layout[axis]);
        axisSnapshot.max = axisSnapshot.min + length;
        /**
         * Ensure relative target gets resized and rerendererd
         */
        if (node.relativeTarget && !node.currentAnimation) {
          node.isProjectionDirty = true;
          node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
        }
      });
    }
    var layoutDelta = createDelta();
    calcBoxDelta(layoutDelta, layout, snapshot.layoutBox);
    var visualDelta = createDelta();
    if (isShared) {
      calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
    } else {
      calcBoxDelta(visualDelta, layout, snapshot.layoutBox);
    }
    var hasLayoutChanged = !isDeltaZero(layoutDelta);
    var hasRelativeTargetChanged = false;
    if (!node.resumeFrom) {
      var relativeParent = node.getClosestProjectingParent();
      /**
       * If the relativeParent is itself resuming from a different element then
       * the relative snapshot is not relavent
       */
      if (relativeParent && !relativeParent.resumeFrom) {
        var parentSnapshot = relativeParent.snapshot,
          parentLayout = relativeParent.layout;
        if (parentSnapshot && parentLayout) {
          var relativeSnapshot = createBox();
          calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
          var relativeLayout = createBox();
          calcRelativePosition(relativeLayout, layout, parentLayout.layoutBox);
          if (!boxEqualsRounded(relativeSnapshot, relativeLayout)) {
            hasRelativeTargetChanged = true;
          }
          if (relativeParent.options.layoutRoot) {
            node.relativeTarget = relativeLayout;
            node.relativeTargetOrigin = relativeSnapshot;
            node.relativeParent = relativeParent;
          }
        }
      }
    }
    node.notifyListeners("didUpdate", {
      layout: layout,
      snapshot: snapshot,
      delta: visualDelta,
      layoutDelta: layoutDelta,
      hasLayoutChanged: hasLayoutChanged,
      hasRelativeTargetChanged: hasRelativeTargetChanged
    });
  } else if (node.isLead()) {
    var onExitComplete = node.options.onExitComplete;
    onExitComplete && onExitComplete();
  }
  /**
   * Clearing transition
   * TODO: Investigate why this transition is being passed in as {type: false } from Framer
   * and why we need it at all
   */
  node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
  /**
   * Increase debug counter for nodes encountered this frame
   */
  projectionFrameData.totalNodes++;
  if (!node.parent) return;
  /**
   * If this node isn't projecting, propagate isProjectionDirty. It will have
   * no performance impact but it will allow the next child that *is* projecting
   * but *isn't* dirty to just check its parent to see if *any* ancestor needs
   * correcting.
   */
  if (!node.isProjecting()) {
    node.isProjectionDirty = node.parent.isProjectionDirty;
  }
  /**
   * Propagate isSharedProjectionDirty and isTransformDirty
   * throughout the whole tree. A future revision can take another look at
   * this but for safety we still recalcualte shared nodes.
   */
  node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
  node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function cleanDirtyNodes(node) {
  node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function clearSnapshot(node) {
  node.clearSnapshot();
}
function clearMeasurements(node) {
  node.clearMeasurements();
}
function clearIsLayoutDirty(node) {
  node.isLayoutDirty = false;
}
function resetTransformStyle(node) {
  var visualElement = node.options.visualElement;
  if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) {
    visualElement.notify("BeforeLayoutMeasure");
  }
  node.resetTransform();
}
function finishAnimation(node) {
  node.finishAnimation();
  node.targetDelta = node.relativeTarget = node.target = undefined;
  node.isProjectionDirty = true;
}
function resolveTargetDelta(node) {
  node.resolveTargetDelta();
}
function calcProjection(node) {
  node.calcProjection();
}
function resetRotation(node) {
  node.resetRotation();
}
function removeLeadSnapshots(stack) {
  stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
  output.translate = mix(delta.translate, 0, p);
  output.scale = mix(delta.scale, 1, p);
  output.origin = delta.origin;
  output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
  output.min = mix(from.min, to.min, p);
  output.max = mix(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
  mixAxis(output.x, from.x, to.x, p);
  mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
  return node.animationValues && node.animationValues.opacityExit !== undefined;
}
var defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
var userAgentContains = function userAgentContains(string) {
  return typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
};
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */
var roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : noop$1;
function roundAxis(axis) {
  // Round to the nearest .5 pixels to support subpixel layouts
  axis.min = roundPoint(axis.min);
  axis.max = roundPoint(axis.max);
}
function roundBox(box) {
  roundAxis(box.x);
  roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
  return animationType === "position" || animationType === "preserve-aspect" && !isNear(aspectRatio(snapshot), aspectRatio(layout), 0.2);
}

var DocumentProjectionNode = createProjectionNode({
  attachResizeListener: function attachResizeListener(ref, notify) {
    return addDomEvent(ref, "resize", notify);
  },
  measureScroll: function measureScroll() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function checkIsScrollRoot() {
    return true;
  }
});

var rootProjectionNode = {
  current: undefined
};
var HTMLProjectionNode = createProjectionNode({
  measureScroll: function measureScroll(instance) {
    return {
      x: instance.scrollLeft,
      y: instance.scrollTop
    };
  },
  defaultParent: function defaultParent() {
    if (!rootProjectionNode.current) {
      var documentNode = new DocumentProjectionNode({});
      documentNode.mount(window);
      documentNode.setOptions({
        layoutScroll: true
      });
      rootProjectionNode.current = documentNode;
    }
    return rootProjectionNode.current;
  },
  resetTransform: function resetTransform(instance, value) {
    instance.style.transform = value !== undefined ? value : "none";
  },
  checkIsScrollRoot: function checkIsScrollRoot(instance) {
    return Boolean(window.getComputedStyle(instance).position === "fixed");
  }
});

var drag = {
  pan: {
    Feature: PanGesture
  },
  drag: {
    Feature: DragGesture,
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout: MeasureLayout
  }
};

/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
var splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
  var match = splitCSSVariableRegex.exec(current);
  if (!match) return [,];
  var _match = _slicedToArray$1(match, 3),
    token = _match[1],
    fallback = _match[2];
  return [token, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  invariant(depth <= maxDepth, "Max CSS variable fallback depth detected in property \"".concat(current, "\". This may indicate a circular fallback dependency."));
  var _parseCSSVariable = parseCSSVariable(current),
    _parseCSSVariable2 = _slicedToArray$1(_parseCSSVariable, 2),
    token = _parseCSSVariable2[0],
    fallback = _parseCSSVariable2[1];
  // No CSS variable detected
  if (!token) return;
  // Attempt to read this CSS variable off the element
  var resolved = window.getComputedStyle(element).getPropertyValue(token);
  if (resolved) {
    var trimmed = resolved.trim();
    return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
  } else if (isCSSVariableToken(fallback)) {
    // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return getVariableValue(fallback, element, depth + 1);
  } else {
    return fallback;
  }
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */
function resolveCSSVariables(visualElement, _ref, transitionEnd) {
  var target = _extends$7({}, (_objectDestructuringEmpty(_ref), _ref));
  var element = visualElement.current;
  if (!(element instanceof Element)) return {
    target: target,
    transitionEnd: transitionEnd
  };
  // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
  // only if they change but I think this reads clearer and this isn't a performance-critical path.
  if (transitionEnd) {
    transitionEnd = _objectSpread2$1({}, transitionEnd);
  }
  // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
  visualElement.values.forEach(function (value) {
    var current = value.get();
    if (!isCSSVariableToken(current)) return;
    var resolved = getVariableValue(current, element);
    if (resolved) value.set(resolved);
  });
  // Cycle through every target property and resolve CSS variables. Currently
  // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
  for (var key in target) {
    var current = target[key];
    if (!isCSSVariableToken(current)) continue;
    var resolved = getVariableValue(current, element);
    if (!resolved) continue;
    // Clone target if it hasn't already been
    target[key] = resolved;
    if (!transitionEnd) transitionEnd = {};
    // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
    // CSS variable. This will ensure that after the animation the component will reflect
    // changes in the value of the CSS variable.
    if (transitionEnd[key] === undefined) {
      transitionEnd[key] = current;
    }
  }
  return {
    target: target,
    transitionEnd: transitionEnd
  };
}

var positionalKeys = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y", "translateX", "translateY"]);
var isPositionalKey = function isPositionalKey(key) {
  return positionalKeys.has(key);
};
var hasPositionalKey = function hasPositionalKey(target) {
  return Object.keys(target).some(isPositionalKey);
};
var isNumOrPxType = function isNumOrPxType(v) {
  return v === number || v === px;
};
var getPosFromMatrix = function getPosFromMatrix(matrix, pos) {
  return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function getTranslateFromMatrix(pos2, pos3) {
  return function (_bbox, _ref) {
    var transform = _ref.transform;
    if (transform === "none" || !transform) return 0;
    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
      return getPosFromMatrix(matrix3d[1], pos3);
    } else {
      var matrix = transform.match(/^matrix\((.+)\)$/);
      if (matrix) {
        return getPosFromMatrix(matrix[1], pos2);
      } else {
        return 0;
      }
    }
  };
};
var transformKeys = new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformPropOrder.filter(function (key) {
  return !transformKeys.has(key);
});
function removeNonTranslationalTransform(visualElement) {
  var removedTransforms = [];
  nonTranslationalTransformKeys.forEach(function (key) {
    var value = visualElement.getValue(key);
    if (value !== undefined) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  // Apply changes to element before measurement
  if (removedTransforms.length) visualElement.render();
  return removedTransforms;
}
var positionalValues = {
  // Dimensions
  width: function width(_ref2, _ref3) {
    var x = _ref2.x;
    var _ref3$paddingLeft = _ref3.paddingLeft,
      paddingLeft = _ref3$paddingLeft === void 0 ? "0" : _ref3$paddingLeft,
      _ref3$paddingRight = _ref3.paddingRight,
      paddingRight = _ref3$paddingRight === void 0 ? "0" : _ref3$paddingRight;
    return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
  },
  height: function height(_ref4, _ref5) {
    var y = _ref4.y;
    var _ref5$paddingTop = _ref5.paddingTop,
      paddingTop = _ref5$paddingTop === void 0 ? "0" : _ref5$paddingTop,
      _ref5$paddingBottom = _ref5.paddingBottom,
      paddingBottom = _ref5$paddingBottom === void 0 ? "0" : _ref5$paddingBottom;
    return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
  },
  top: function top(_bbox, _ref6) {
    var _top = _ref6.top;
    return parseFloat(_top);
  },
  left: function left(_bbox, _ref7) {
    var _left = _ref7.left;
    return parseFloat(_left);
  },
  bottom: function bottom(_ref8, _ref9) {
    var y = _ref8.y;
    var top = _ref9.top;
    return parseFloat(top) + (y.max - y.min);
  },
  right: function right(_ref10, _ref11) {
    var x = _ref10.x;
    var left = _ref11.left;
    return parseFloat(left) + (x.max - x.min);
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
var convertChangedValueTypes = function convertChangedValueTypes(target, visualElement, changedKeys) {
  var originBbox = visualElement.measureViewportBox();
  var element = visualElement.current;
  var elementComputedStyle = getComputedStyle(element);
  var display = elementComputedStyle.display;
  var origin = {};
  // If the element is currently set to display: "none", make it visible before
  // measuring the target bounding box
  if (display === "none") {
    visualElement.setStaticValue("display", target.display || "block");
  }
  /**
   * Record origins before we render and update styles
   */
  changedKeys.forEach(function (key) {
    origin[key] = positionalValues[key](originBbox, elementComputedStyle);
  });
  // Apply the latest values (as set in checkAndConvertChangedValueTypes)
  visualElement.render();
  var targetBbox = visualElement.measureViewportBox();
  changedKeys.forEach(function (key) {
    // Restore styles to their **calculated computed style**, not their actual
    // originally set style. This allows us to animate between equivalent pixel units.
    var value = visualElement.getValue(key);
    value && value.jump(origin[key]);
    target[key] = positionalValues[key](targetBbox, elementComputedStyle);
  });
  return target;
};
var checkAndConvertChangedValueTypes = function checkAndConvertChangedValueTypes(visualElement, target) {
  var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var transitionEnd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  target = _objectSpread2$1({}, target);
  transitionEnd = _objectSpread2$1({}, transitionEnd);
  var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
  // We want to remove any transform values that could affect the element's bounding box before
  // it's measured. We'll reapply these later.
  var removedTransformValues = [];
  var hasAttemptedToRemoveTransformValues = false;
  var changedValueTypeKeys = [];
  targetPositionalKeys.forEach(function (key) {
    var value = visualElement.getValue(key);
    if (!visualElement.hasValue(key)) return;
    var from = origin[key];
    var fromType = findDimensionValueType(from);
    var to = target[key];
    var toType;
    // TODO: The current implementation of this basically throws an error
    // if you try and do value conversion via keyframes. There's probably
    // a way of doing this but the performance implications would need greater scrutiny,
    // as it'd be doing multiple resize-remeasure operations.
    if (isKeyframesTarget(to)) {
      var numKeyframes = to.length;
      var fromIndex = to[0] === null ? 1 : 0;
      from = to[fromIndex];
      fromType = findDimensionValueType(from);
      for (var i = fromIndex; i < numKeyframes; i++) {
        /**
         * Don't allow wildcard keyframes to be used to detect
         * a difference in value types.
         */
        if (to[i] === null) break;
        if (!toType) {
          toType = findDimensionValueType(to[i]);
          invariant(toType === fromType || isNumOrPxType(fromType) && isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
        } else {
          invariant(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
        }
      }
    } else {
      toType = findDimensionValueType(to);
    }
    if (fromType !== toType) {
      // If they're both just number or px, convert them both to numbers rather than
      // relying on resize/remeasure to convert (which is wasteful in this situation)
      if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
        var current = value.get();
        if (typeof current === "string") {
          value.set(parseFloat(current));
        }
        if (typeof to === "string") {
          target[key] = parseFloat(to);
        } else if (Array.isArray(to) && toType === px) {
          target[key] = to.map(parseFloat);
        }
      } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
        // If one or the other value is 0, it's safe to coerce it to the
        // type of the other without measurement
        if (from === 0) {
          value.set(toType.transform(from));
        } else {
          target[key] = fromType.transform(to);
        }
      } else {
        // If we're going to do value conversion via DOM measurements, we first
        // need to remove non-positional transform values that could affect the bbox measurements.
        if (!hasAttemptedToRemoveTransformValues) {
          removedTransformValues = removeNonTranslationalTransform(visualElement);
          hasAttemptedToRemoveTransformValues = true;
        }
        changedValueTypeKeys.push(key);
        transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
        value.jump(to);
      }
    }
  });
  if (changedValueTypeKeys.length) {
    var scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
    var convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
    // If we removed transform values, reapply them before the next render
    if (removedTransformValues.length) {
      removedTransformValues.forEach(function (_ref12) {
        var _ref13 = _slicedToArray$1(_ref12, 2),
          key = _ref13[0],
          value = _ref13[1];
        visualElement.getValue(key).set(value);
      });
    }
    // Reapply original values
    visualElement.render();
    // Restore scroll position
    if (isBrowser$3 && scrollY !== null) {
      window.scrollTo({
        top: scrollY
      });
    }
    return {
      target: convertedTarget,
      transitionEnd: transitionEnd
    };
  } else {
    return {
      target: target,
      transitionEnd: transitionEnd
    };
  }
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */
function unitConversion(visualElement, target, origin, transitionEnd) {
  return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
    target: target,
    transitionEnd: transitionEnd
  };
}

/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */
var parseDomVariant = function parseDomVariant(visualElement, target, origin, transitionEnd) {
  var resolved = resolveCSSVariables(visualElement, target, transitionEnd);
  target = resolved.target;
  transitionEnd = resolved.transitionEnd;
  return unitConversion(visualElement, target, origin, transitionEnd);
};

// Does this device prefer reduced motion? Returns `null` server-side.
var prefersReducedMotion = {
  current: null
};
var hasReducedMotionListener = {
  current: false
};

function initPrefersReducedMotion() {
  hasReducedMotionListener.current = true;
  if (!isBrowser$3) return;
  if (window.matchMedia) {
    var motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
    var setReducedMotionPreferences = function setReducedMotionPreferences() {
      return prefersReducedMotion.current = motionMediaQuery.matches;
    };
    motionMediaQuery.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}

function updateMotionValuesFromProps(element, next, prev) {
  var willChange = next.willChange;
  for (var key in next) {
    var nextValue = next[key];
    var prevValue = prev[key];
    if (isMotionValue(nextValue)) {
      /**
       * If this is a motion value found in props or style, we want to add it
       * to our visual element's motion value map.
       */
      element.addValue(key, nextValue);
      if (isWillChangeMotionValue(willChange)) {
        willChange.add(key);
      }
      /**
       * Check the version of the incoming motion value with this version
       * and warn against mismatches.
       */
      if (process.env.NODE_ENV === "development") {
        warnOnce(nextValue.version === "10.18.0", "Attempting to mix Framer Motion versions ".concat(nextValue.version, " with 10.18.0 may not work as expected."));
      }
    } else if (isMotionValue(prevValue)) {
      /**
       * If we're swapping from a motion value to a static value,
       * create a new motion value from that
       */
      element.addValue(key, motionValue(nextValue, {
        owner: element
      }));
      if (isWillChangeMotionValue(willChange)) {
        willChange.remove(key);
      }
    } else if (prevValue !== nextValue) {
      /**
       * If this is a flat value that has changed, update the motion value
       * or create one if it doesn't exist. We only want to do this if we're
       * not handling the value with our animation state.
       */
      if (element.hasValue(key)) {
        var existingValue = element.getValue(key);
        // TODO: Only update values that aren't being animated or even looked at
        !existingValue.hasAnimated && existingValue.set(nextValue);
      } else {
        var latestValue = element.getStaticValue(key);
        element.addValue(key, motionValue(latestValue !== undefined ? latestValue : nextValue, {
          owner: element
        }));
      }
    }
  }
  // Handle removed values
  for (var _key in prev) {
    if (next[_key] === undefined) element.removeValue(_key);
  }
  return next;
}

var visualElementStore = new WeakMap();

var _excluded$29 = ["willChange"],
  _excluded2$f = ["children"];
var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
var propEventHandlers = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"];
var numVariantProps = variantProps.length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */
var VisualElement = /*#__PURE__*/function () {
  function VisualElement(_ref) {
    var _this = this;
    var parent = _ref.parent,
      props = _ref.props,
      presenceContext = _ref.presenceContext,
      reducedMotionConfig = _ref.reducedMotionConfig,
      visualState = _ref.visualState;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck$1(this, VisualElement);
    /**
     * A reference to the current underlying Instance, e.g. a HTMLElement
     * or Three.Mesh etc.
     */
    this.current = null;
    /**
     * A set containing references to this VisualElement's children.
     */
    this.children = new Set();
    /**
     * Determine what role this visual element should take in the variant tree.
     */
    this.isVariantNode = false;
    this.isControllingVariants = false;
    /**
     * Decides whether this VisualElement should animate in reduced motion
     * mode.
     *
     * TODO: This is currently set on every individual VisualElement but feels
     * like it could be set globally.
     */
    this.shouldReduceMotion = null;
    /**
     * A map of all motion values attached to this visual element. Motion
     * values are source of truth for any given animated value. A motion
     * value might be provided externally by the component via props.
     */
    this.values = new Map();
    /**
     * Cleanup functions for active features (hover/tap/exit etc)
     */
    this.features = {};
    /**
     * A map of every subscription that binds the provided or generated
     * motion values onChange listeners to this visual element.
     */
    this.valueSubscriptions = new Map();
    /**
     * A reference to the previously-provided motion values as returned
     * from scrapeMotionValuesFromProps. We use the keys in here to determine
     * if any motion values need to be removed after props are updated.
     */
    this.prevMotionValues = {};
    /**
     * An object containing a SubscriptionManager for each active event.
     */
    this.events = {};
    /**
     * An object containing an unsubscribe function for each prop event subscription.
     * For example, every "Update" event can have multiple subscribers via
     * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
     */
    this.propEventSubscriptions = {};
    this.notifyUpdate = function () {
      return _this.notify("Update", _this.latestValues);
    };
    this.render = function () {
      if (!_this.current) return;
      _this.triggerBuild();
      _this.renderInstance(_this.current, _this.renderState, _this.props.style, _this.projection);
    };
    this.scheduleRender = function () {
      return frame.render(_this.render, false, true);
    };
    var latestValues = visualState.latestValues,
      renderState = visualState.renderState;
    this.latestValues = latestValues;
    this.baseTarget = _objectSpread2$1({}, latestValues);
    this.initialValues = props.initial ? _objectSpread2$1({}, latestValues) : {};
    this.renderState = renderState;
    this.parent = parent;
    this.props = props;
    this.presenceContext = presenceContext;
    this.depth = parent ? parent.depth + 1 : 0;
    this.reducedMotionConfig = reducedMotionConfig;
    this.options = options;
    this.isControllingVariants = isControllingVariants(props);
    this.isVariantNode = isVariantNode(props);
    if (this.isVariantNode) {
      this.variantChildren = new Set();
    }
    this.manuallyAnimateOnMount = Boolean(parent && parent.current);
    /**
     * Any motion values that are provided to the element when created
     * aren't yet bound to the element, as this would technically be impure.
     * However, we iterate through the motion values and set them to the
     * initial values for this component.
     *
     * TODO: This is impure and we should look at changing this to run on mount.
     * Doing so will break some tests but this isn't neccessarily a breaking change,
     * more a reflection of the test.
     */
    var _this$scrapeMotionVal = this.scrapeMotionValuesFromProps(props, {}),
      willChange = _this$scrapeMotionVal.willChange,
      initialMotionValues = _objectWithoutProperties$1(_this$scrapeMotionVal, _excluded$29);
    for (var key in initialMotionValues) {
      var value = initialMotionValues[key];
      if (latestValues[key] !== undefined && isMotionValue(value)) {
        value.set(latestValues[key], false);
        if (isWillChangeMotionValue(willChange)) {
          willChange.add(key);
        }
      }
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  return _createClass$1(VisualElement, [{
    key: "scrapeMotionValuesFromProps",
    value: function scrapeMotionValuesFromProps(_props, _prevProps) {
      return {};
    }
  }, {
    key: "mount",
    value: function mount(instance) {
      var _this2 = this;
      this.current = instance;
      visualElementStore.set(instance, this);
      if (this.projection && !this.projection.instance) {
        this.projection.mount(instance);
      }
      if (this.parent && this.isVariantNode && !this.isControllingVariants) {
        this.removeFromVariantTree = this.parent.addVariantChild(this);
      }
      this.values.forEach(function (value, key) {
        return _this2.bindToMotionValue(key, value);
      });
      if (!hasReducedMotionListener.current) {
        initPrefersReducedMotion();
      }
      this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : prefersReducedMotion.current;
      if (process.env.NODE_ENV !== "production") {
        warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
      }
      if (this.parent) this.parent.children.add(this);
      this.update(this.props, this.presenceContext);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      visualElementStore["delete"](this.current);
      this.projection && this.projection.unmount();
      cancelFrame(this.notifyUpdate);
      cancelFrame(this.render);
      this.valueSubscriptions.forEach(function (remove) {
        return remove();
      });
      this.removeFromVariantTree && this.removeFromVariantTree();
      this.parent && this.parent.children["delete"](this);
      for (var key in this.events) {
        this.events[key].clear();
      }
      for (var _key in this.features) {
        this.features[_key].unmount();
      }
      this.current = null;
    }
  }, {
    key: "bindToMotionValue",
    value: function bindToMotionValue(key, value) {
      var _this3 = this;
      var valueIsTransform = transformProps.has(key);
      var removeOnChange = value.on("change", function (latestValue) {
        _this3.latestValues[key] = latestValue;
        _this3.props.onUpdate && frame.update(_this3.notifyUpdate, false, true);
        if (valueIsTransform && _this3.projection) {
          _this3.projection.isTransformDirty = true;
        }
      });
      var removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
      this.valueSubscriptions.set(key, function () {
        removeOnChange();
        removeOnRenderRequest();
      });
    }
  }, {
    key: "sortNodePosition",
    value: function sortNodePosition(other) {
      /**
       * If these nodes aren't even of the same type we can't compare their depth.
       */
      if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
        return 0;
      }
      return this.sortInstanceNodePosition(this.current, other.current);
    }
  }, {
    key: "loadFeatures",
    value: function loadFeatures(_ref2, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
      var _this4 = this;
      _ref2.children;
        var renderedProps = _objectWithoutProperties$1(_ref2, _excluded2$f);
      var ProjectionNodeConstructor;
      var MeasureLayout;
      /**
       * If we're in development mode, check to make sure we're not rendering a motion component
       * as a child of LazyMotion, as this will break the file-size benefits of using it.
       */
      if (process.env.NODE_ENV !== "production" && preloadedFeatures && isStrict) {
        var strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
        renderedProps.ignoreStrict ? warning(false, strictMessage) : invariant(false, strictMessage);
      }
      for (var i = 0; i < numFeatures; i++) {
        var name = featureNames[i];
        var _featureDefinitions$n = featureDefinitions[name],
          isEnabled = _featureDefinitions$n.isEnabled,
          FeatureConstructor = _featureDefinitions$n.Feature,
          ProjectionNode = _featureDefinitions$n.ProjectionNode,
          MeasureLayoutComponent = _featureDefinitions$n.MeasureLayout;
        if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
        if (isEnabled(renderedProps)) {
          if (!this.features[name] && FeatureConstructor) {
            this.features[name] = new FeatureConstructor(this);
          }
          if (MeasureLayoutComponent) {
            MeasureLayout = MeasureLayoutComponent;
          }
        }
      }
      if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
        this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
        var layoutId = renderedProps.layoutId,
          layout = renderedProps.layout,
          drag = renderedProps.drag,
          dragConstraints = renderedProps.dragConstraints,
          layoutScroll = renderedProps.layoutScroll,
          layoutRoot = renderedProps.layoutRoot;
        this.projection.setOptions({
          layoutId: layoutId,
          layout: layout,
          alwaysMeasureLayout: Boolean(drag) || dragConstraints && isRefObject$2(dragConstraints),
          visualElement: this,
          scheduleRender: function scheduleRender() {
            return _this4.scheduleRender();
          },
          /**
           * TODO: Update options in an effect. This could be tricky as it'll be too late
           * to update by the time layout animations run.
           * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
           * ensuring it gets called if there's no potential layout animations.
           *
           */
          animationType: typeof layout === "string" ? layout : "both",
          initialPromotionConfig: initialLayoutGroupConfig,
          layoutScroll: layoutScroll,
          layoutRoot: layoutRoot
        });
      }
      return MeasureLayout;
    }
  }, {
    key: "updateFeatures",
    value: function updateFeatures() {
      for (var key in this.features) {
        var feature = this.features[key];
        if (feature.isMounted) {
          feature.update();
        } else {
          feature.mount();
          feature.isMounted = true;
        }
      }
    }
  }, {
    key: "triggerBuild",
    value: function triggerBuild() {
      this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */
  }, {
    key: "measureViewportBox",
    value: function measureViewportBox() {
      return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
    }
  }, {
    key: "getStaticValue",
    value: function getStaticValue(key) {
      return this.latestValues[key];
    }
  }, {
    key: "setStaticValue",
    value: function setStaticValue(key, value) {
      this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */
  }, {
    key: "makeTargetAnimatable",
    value: function makeTargetAnimatable(target) {
      var canMutate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */
  }, {
    key: "update",
    value: function update(props, presenceContext) {
      if (props.transformTemplate || this.props.transformTemplate) {
        this.scheduleRender();
      }
      this.prevProps = this.props;
      this.props = props;
      this.prevPresenceContext = this.presenceContext;
      this.presenceContext = presenceContext;
      /**
       * Update prop event handlers ie onAnimationStart, onAnimationComplete
       */
      for (var i = 0; i < propEventHandlers.length; i++) {
        var key = propEventHandlers[i];
        if (this.propEventSubscriptions[key]) {
          this.propEventSubscriptions[key]();
          delete this.propEventSubscriptions[key];
        }
        var listener = props["on" + key];
        if (listener) {
          this.propEventSubscriptions[key] = this.on(key, listener);
        }
      }
      this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
      if (this.handleChildMotionValue) {
        this.handleChildMotionValue();
      }
    }
  }, {
    key: "getProps",
    value: function getProps() {
      return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */
  }, {
    key: "getVariant",
    value: function getVariant(name) {
      return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */
  }, {
    key: "getDefaultTransition",
    value: function getDefaultTransition() {
      return this.props.transition;
    }
  }, {
    key: "getTransformPagePoint",
    value: function getTransformPagePoint() {
      return this.props.transformPagePoint;
    }
  }, {
    key: "getClosestVariantNode",
    value: function getClosestVariantNode() {
      return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
  }, {
    key: "getVariantContext",
    value: function getVariantContext() {
      var startAtParent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (startAtParent) {
        return this.parent ? this.parent.getVariantContext() : undefined;
      }
      if (!this.isControllingVariants) {
        var _context = this.parent ? this.parent.getVariantContext() || {} : {};
        if (this.props.initial !== undefined) {
          _context.initial = this.props.initial;
        }
        return _context;
      }
      var context = {};
      for (var i = 0; i < numVariantProps; i++) {
        var name = variantProps[i];
        var prop = this.props[name];
        if (isVariantLabel(prop) || prop === false) {
          context[name] = prop;
        }
      }
      return context;
    }
    /**
     * Add a child visual element to our set of children.
     */
  }, {
    key: "addVariantChild",
    value: function addVariantChild(child) {
      var closestVariantNode = this.getClosestVariantNode();
      if (closestVariantNode) {
        closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
        return function () {
          return closestVariantNode.variantChildren["delete"](child);
        };
      }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */
  }, {
    key: "addValue",
    value: function addValue(key, value) {
      // Remove existing value if it exists
      if (value !== this.values.get(key)) {
        this.removeValue(key);
        this.bindToMotionValue(key, value);
      }
      this.values.set(key, value);
      this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */
  }, {
    key: "removeValue",
    value: function removeValue(key) {
      this.values["delete"](key);
      var unsubscribe = this.valueSubscriptions.get(key);
      if (unsubscribe) {
        unsubscribe();
        this.valueSubscriptions["delete"](key);
      }
      delete this.latestValues[key];
      this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */
  }, {
    key: "hasValue",
    value: function hasValue(key) {
      return this.values.has(key);
    }
  }, {
    key: "getValue",
    value: function getValue(key, defaultValue) {
      if (this.props.values && this.props.values[key]) {
        return this.props.values[key];
      }
      var value = this.values.get(key);
      if (value === undefined && defaultValue !== undefined) {
        value = motionValue(defaultValue, {
          owner: this
        });
        this.addValue(key, value);
      }
      return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */
  }, {
    key: "readValue",
    value: function readValue(key) {
      var _a;
      return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */
  }, {
    key: "setBaseTarget",
    value: function setBaseTarget(key, value) {
      this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */
  }, {
    key: "getBaseTarget",
    value: function getBaseTarget(key) {
      var _a;
      var initial = this.props.initial;
      var valueFromInitial = typeof initial === "string" || _typeof$1(initial) === "object" ? (_a = resolveVariantFromProps(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
      /**
       * If this value still exists in the current initial variant, read that.
       */
      if (initial && valueFromInitial !== undefined) {
        return valueFromInitial;
      }
      /**
       * Alternatively, if this VisualElement config has defined a getBaseTarget
       * so we can read the value from an alternative source, try that.
       */
      var target = this.getBaseTargetFromProps(this.props, key);
      if (target !== undefined && !isMotionValue(target)) return target;
      /**
       * If the value was initially defined on initial, but it doesn't any more,
       * return undefined. Otherwise return the value as initially read from the DOM.
       */
      return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (!this.events[eventName]) {
        this.events[eventName] = new SubscriptionManager();
      }
      return this.events[eventName].add(callback);
    }
  }, {
    key: "notify",
    value: function notify(eventName) {
      if (this.events[eventName]) {
        var _this$events$eventNam;
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        (_this$events$eventNam = this.events[eventName]).notify.apply(_this$events$eventNam, args);
      }
    }
  }]);
}();

var _excluded$28 = ["transition", "transitionEnd"];
var DOMVisualElement = /*#__PURE__*/function (_VisualElement) {
  function DOMVisualElement() {
    _classCallCheck$1(this, DOMVisualElement);
    return _callSuper(this, DOMVisualElement, arguments);
  }
  _inherits$1(DOMVisualElement, _VisualElement);
  return _createClass$1(DOMVisualElement, [{
    key: "sortInstanceNodePosition",
    value: function sortInstanceNodePosition(a, b) {
      /**
       * compareDocumentPosition returns a bitmask, by using the bitwise &
       * we're returning true if 2 in that bitmask is set to true. 2 is set
       * to true if b preceeds a.
       */
      return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
  }, {
    key: "getBaseTargetFromProps",
    value: function getBaseTargetFromProps(props, key) {
      return props.style ? props.style[key] : undefined;
    }
  }, {
    key: "removeValueFromRenderState",
    value: function removeValueFromRenderState(key, _ref) {
      var vars = _ref.vars,
        style = _ref.style;
      delete vars[key];
      delete style[key];
    }
  }, {
    key: "makeTargetAnimatableFromInstance",
    value: function makeTargetAnimatableFromInstance(_ref2, _ref3, isMounted) {
      var transition = _ref2.transition,
        transitionEnd = _ref2.transitionEnd,
        target = _objectWithoutProperties$1(_ref2, _excluded$28);
      var transformValues = _ref3.transformValues;
      var origin = getOrigin(target, transition || {}, this);
      /**
       * If Framer has provided a function to convert `Color` etc value types, convert them
       */
      if (transformValues) {
        if (transitionEnd) transitionEnd = transformValues(transitionEnd);
        if (target) target = transformValues(target);
        if (origin) origin = transformValues(origin);
      }
      if (isMounted) {
        checkTargetForNewValues(this, target, origin);
        var parsed = parseDomVariant(this, target, origin, transitionEnd);
        transitionEnd = parsed.transitionEnd;
        target = parsed.target;
      }
      return _objectSpread2$1({
        transition: transition,
        transitionEnd: transitionEnd
      }, target);
    }
  }]);
}(VisualElement);

function getComputedStyle$2(element) {
  return window.getComputedStyle(element);
}
var HTMLVisualElement = /*#__PURE__*/function (_DOMVisualElement) {
  function HTMLVisualElement() {
    var _this;
    _classCallCheck$1(this, HTMLVisualElement);
    _this = _callSuper(this, HTMLVisualElement, arguments);
    _this.type = "html";
    return _this;
  }
  _inherits$1(HTMLVisualElement, _DOMVisualElement);
  return _createClass$1(HTMLVisualElement, [{
    key: "readValueFromInstance",
    value: function readValueFromInstance(instance, key) {
      if (transformProps.has(key)) {
        var defaultType = getDefaultValueType(key);
        return defaultType ? defaultType["default"] || 0 : 0;
      } else {
        var computedStyle = getComputedStyle$2(instance);
        var value = (isCSSVariableName(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        return typeof value === "string" ? value.trim() : value;
      }
    }
  }, {
    key: "measureInstanceViewportBox",
    value: function measureInstanceViewportBox(instance, _ref) {
      var transformPagePoint = _ref.transformPagePoint;
      return measureViewportBox(instance, transformPagePoint);
    }
  }, {
    key: "build",
    value: function build(renderState, latestValues, options, props) {
      buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
    }
  }, {
    key: "scrapeMotionValuesFromProps",
    value: function scrapeMotionValuesFromProps(props, prevProps) {
      return scrapeMotionValuesFromProps$1(props, prevProps);
    }
  }, {
    key: "handleChildMotionValue",
    value: function handleChildMotionValue() {
      var _this2 = this;
      if (this.childSubscription) {
        this.childSubscription();
        delete this.childSubscription;
      }
      var children = this.props.children;
      if (isMotionValue(children)) {
        this.childSubscription = children.on("change", function (latest) {
          if (_this2.current) _this2.current.textContent = "".concat(latest);
        });
      }
    }
  }, {
    key: "renderInstance",
    value: function renderInstance(instance, renderState, styleProp, projection) {
      renderHTML(instance, renderState, styleProp, projection);
    }
  }]);
}(DOMVisualElement);

var SVGVisualElement = /*#__PURE__*/function (_DOMVisualElement) {
  function SVGVisualElement() {
    var _this;
    _classCallCheck$1(this, SVGVisualElement);
    _this = _callSuper(this, SVGVisualElement, arguments);
    _this.type = "svg";
    _this.isSVGTag = false;
    return _this;
  }
  _inherits$1(SVGVisualElement, _DOMVisualElement);
  return _createClass$1(SVGVisualElement, [{
    key: "getBaseTargetFromProps",
    value: function getBaseTargetFromProps(props, key) {
      return props[key];
    }
  }, {
    key: "readValueFromInstance",
    value: function readValueFromInstance(instance, key) {
      if (transformProps.has(key)) {
        var defaultType = getDefaultValueType(key);
        return defaultType ? defaultType["default"] || 0 : 0;
      }
      key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
      return instance.getAttribute(key);
    }
  }, {
    key: "measureInstanceViewportBox",
    value: function measureInstanceViewportBox() {
      return createBox();
    }
  }, {
    key: "scrapeMotionValuesFromProps",
    value: function scrapeMotionValuesFromProps$1(props, prevProps) {
      return scrapeMotionValuesFromProps(props, prevProps);
    }
  }, {
    key: "build",
    value: function build(renderState, latestValues, options, props) {
      buildSVGAttrs(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
  }, {
    key: "renderInstance",
    value: function renderInstance(instance, renderState, styleProp, projection) {
      renderSVG(instance, renderState, styleProp, projection);
    }
  }, {
    key: "mount",
    value: function mount(instance) {
      this.isSVGTag = isSVGTag(instance.tagName);
      _superPropGet(SVGVisualElement, "mount", this)([instance]);
    }
  }]);
}(DOMVisualElement);

var createDomVisualElement = function createDomVisualElement(Component, options) {
  return isSVGComponent(Component) ? new SVGVisualElement(options, {
    enableHardwareAcceleration: false
  }) : new HTMLVisualElement(options, {
    enableHardwareAcceleration: true
  });
};

var layout = {
  layout: {
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout: MeasureLayout
  }
};

var preloadedFeatures = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, animations), gestureAnimations), drag), layout);
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */
var motion = /*@__PURE__*/createMotionProxy(function (Component, config) {
  return createDomMotionConfig(Component, config, preloadedFeatures, createDomVisualElement);
});

function useIsMounted() {
  var isMounted = useRef(false);
  useIsomorphicLayoutEffect$1(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
}

function useForceUpdate() {
  var isMounted = useIsMounted();
  var _useState = useState(0),
    _useState2 = _slicedToArray$1(_useState, 2),
    forcedRenderCount = _useState2[0],
    setForcedRenderCount = _useState2[1];
  var forceRender = useCallback(function () {
    isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
  }, [forcedRenderCount]);
  /**
   * Defer this to the end of the next animation frame in case there are multiple
   * synchronous calls.
   */
  var deferredForceRender = useCallback(function () {
    return frame.postRender(forceRender);
  }, [forceRender]);
  return [deferredForceRender, forcedRenderCount];
}

/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */
var PopChildMeasure = /*#__PURE__*/function (_React$Component) {
  function PopChildMeasure() {
    _classCallCheck$1(this, PopChildMeasure);
    return _callSuper(this, PopChildMeasure, arguments);
  }
  _inherits$1(PopChildMeasure, _React$Component);
  return _createClass$1(PopChildMeasure, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var element = this.props.childRef.current;
      if (element && prevProps.isPresent && !this.props.isPresent) {
        var size = this.props.sizeRef.current;
        size.height = element.offsetHeight || 0;
        size.width = element.offsetWidth || 0;
        size.top = element.offsetTop;
        size.left = element.offsetLeft;
      }
      return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
}(React.Component);
function PopChild(_ref) {
  var children = _ref.children,
    isPresent = _ref.isPresent;
  var id = useId$1();
  var ref = useRef(null);
  var size = useRef({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  /**
   * We create and inject a style block so we can apply this explicit
   * sizing in a non-destructive manner by just deleting the style block.
   *
   * We can't apply size via render as the measurement happens
   * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
   * styles directly on the DOM node, we might be overwriting
   * styles set via the style prop.
   */
  useInsertionEffect$1(function () {
    var _size$current = size.current,
      width = _size$current.width,
      height = _size$current.height,
      top = _size$current.top,
      left = _size$current.left;
    if (isPresent || !ref.current || !width || !height) return;
    ref.current.dataset.motionPopId = id;
    var style = document.createElement("style");
    document.head.appendChild(style);
    if (style.sheet) {
      style.sheet.insertRule("\n          [data-motion-pop-id=\"".concat(id, "\"] {\n            position: absolute !important;\n            width: ").concat(width, "px !important;\n            height: ").concat(height, "px !important;\n            top: ").concat(top, "px !important;\n            left: ").concat(left, "px !important;\n          }\n        "));
    }
    return function () {
      document.head.removeChild(style);
    };
  }, [isPresent]);
  return /*#__PURE__*/React.createElement(PopChildMeasure, {
    isPresent: isPresent,
    childRef: ref,
    sizeRef: size
  }, /*#__PURE__*/React.cloneElement(children, {
    ref: ref
  }));
}

var PresenceChild = function PresenceChild(_ref) {
  var children = _ref.children,
    initial = _ref.initial,
    isPresent = _ref.isPresent,
    _onExitComplete = _ref.onExitComplete,
    custom = _ref.custom,
    presenceAffectsLayout = _ref.presenceAffectsLayout,
    mode = _ref.mode;
  var presenceChildren = useConstant(newChildrenMap);
  var id = useId$1();
  var context = useMemo(function () {
    return {
      id: id,
      initial: initial,
      isPresent: isPresent,
      custom: custom,
      onExitComplete: function onExitComplete(childId) {
        presenceChildren.set(childId, true);
        var _iterator = _createForOfIteratorHelper(presenceChildren.values()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var isComplete = _step.value;
            if (!isComplete) return; // can stop searching when any is incomplete
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _onExitComplete && _onExitComplete();
      },
      register: function register(childId) {
        presenceChildren.set(childId, false);
        return function () {
          return presenceChildren["delete"](childId);
        };
      }
    };
  },
  /**
   * If the presence of a child affects the layout of the components around it,
   * we want to make a new context value to ensure they get re-rendered
   * so they can detect that layout change.
   */
  presenceAffectsLayout ? undefined : [isPresent]);
  useMemo(function () {
    presenceChildren.forEach(function (_, key) {
      return presenceChildren.set(key, false);
    });
  }, [isPresent]);
  /**
   * If there's no `motion` components to fire exit animations, we want to remove this
   * component immediately.
   */
  React.useEffect(function () {
    !isPresent && !presenceChildren.size && _onExitComplete && _onExitComplete();
  }, [isPresent]);
  if (mode === "popLayout") {
    children = /*#__PURE__*/React.createElement(PopChild, {
      isPresent: isPresent
    }, children);
  }
  return /*#__PURE__*/React.createElement(PresenceContext.Provider, {
    value: context
  }, children);
};
function newChildrenMap() {
  return new Map();
}

function useUnmountEffect(callback) {
  return useEffect(function () {
    return function () {
      return callback();
    };
  }, []);
}

var getChildKey = function getChildKey(child) {
  return child.key || "";
};
function updateChildLookup(children, allChildren) {
  children.forEach(function (child) {
    var key = getChildKey(child);
    allChildren.set(key, child);
  });
}
function onlyElements(children) {
  var filtered = [];
  // We use forEach here instead of map as map mutates the component key by preprending `.$`
  Children.forEach(children, function (child) {
    if (/*#__PURE__*/isValidElement$1(child)) filtered.push(child);
  });
  return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
var AnimatePresence = function AnimatePresence(_ref) {
  var children = _ref.children,
    custom = _ref.custom,
    _ref$initial = _ref.initial,
    initial = _ref$initial === void 0 ? true : _ref$initial,
    onExitComplete = _ref.onExitComplete,
    exitBeforeEnter = _ref.exitBeforeEnter,
    _ref$presenceAffectsL = _ref.presenceAffectsLayout,
    presenceAffectsLayout = _ref$presenceAffectsL === void 0 ? true : _ref$presenceAffectsL,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? "sync" : _ref$mode;
  invariant(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
  // We want to force a re-render once all exiting animations have finished. We
  // either use a local forceRender function, or one from a parent context if it exists.
  var forceRender = useContext(LayoutGroupContext).forceRender || useForceUpdate()[0];
  var isMounted = useIsMounted();
  // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
  var filteredChildren = onlyElements(children);
  var childrenToRender = filteredChildren;
  var exitingChildren = useRef(new Map()).current;
  // Keep a living record of the children we're actually rendering so we
  // can diff to figure out which are entering and exiting
  var presentChildren = useRef(childrenToRender);
  // A lookup table to quickly reference components by key
  var allChildren = useRef(new Map()).current;
  // If this is the initial component render, just deal with logic surrounding whether
  // we play onMount animations or not.
  var isInitialRender = useRef(true);
  useIsomorphicLayoutEffect$1(function () {
    isInitialRender.current = false;
    updateChildLookup(filteredChildren, allChildren);
    presentChildren.current = childrenToRender;
  });
  useUnmountEffect(function () {
    isInitialRender.current = true;
    allChildren.clear();
    exitingChildren.clear();
  });
  if (isInitialRender.current) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, childrenToRender.map(function (child) {
      return /*#__PURE__*/React.createElement(PresenceChild, {
        key: getChildKey(child),
        isPresent: true,
        initial: initial ? undefined : false,
        presenceAffectsLayout: presenceAffectsLayout,
        mode: mode
      }, child);
    }));
  }
  // If this is a subsequent render, deal with entering and exiting children
  childrenToRender = _toConsumableArray$1(childrenToRender);
  // Diff the keys of the currently-present and target children to update our
  // exiting list.
  var presentKeys = presentChildren.current.map(getChildKey);
  var targetKeys = filteredChildren.map(getChildKey);
  // Diff the present children with our target children and mark those that are exiting
  var numPresent = presentKeys.length;
  for (var i = 0; i < numPresent; i++) {
    var key = presentKeys[i];
    if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) {
      exitingChildren.set(key, undefined);
    }
  }
  // If we currently have exiting children, and we're deferring rendering incoming children
  // until after all current children have exiting, empty the childrenToRender array
  if (mode === "wait" && exitingChildren.size) {
    childrenToRender = [];
  }
  // Loop through all currently exiting components and clone them to overwrite `animate`
  // with any `exit` prop they might have defined.
  exitingChildren.forEach(function (component, key) {
    // If this component is actually entering again, early return
    if (targetKeys.indexOf(key) !== -1) return;
    var child = allChildren.get(key);
    if (!child) return;
    var insertionIndex = presentKeys.indexOf(key);
    var exitingComponent = component;
    if (!exitingComponent) {
      var onExit = function onExit() {
        // clean up the exiting children map
        exitingChildren["delete"](key);
        // compute the keys of children that were rendered once but are no longer present
        // this could happen in case of too many fast consequent renderings
        // @link https://github.com/framer/motion/issues/2023
        var leftOverKeys = Array.from(allChildren.keys()).filter(function (childKey) {
          return !targetKeys.includes(childKey);
        });
        // clean up the all children map
        leftOverKeys.forEach(function (leftOverKey) {
          return allChildren["delete"](leftOverKey);
        });
        // make sure to render only the children that are actually visible
        presentChildren.current = filteredChildren.filter(function (presentChild) {
          var presentChildKey = getChildKey(presentChild);
          return (
            // filter out the node exiting
            presentChildKey === key ||
            // filter out the leftover children
            leftOverKeys.includes(presentChildKey)
          );
        });
        // Defer re-rendering until all exiting children have indeed left
        if (!exitingChildren.size) {
          if (isMounted.current === false) return;
          forceRender();
          onExitComplete && onExitComplete();
        }
      };
      exitingComponent = /*#__PURE__*/React.createElement(PresenceChild, {
        key: getChildKey(child),
        isPresent: false,
        onExitComplete: onExit,
        custom: custom,
        presenceAffectsLayout: presenceAffectsLayout,
        mode: mode
      }, child);
      exitingChildren.set(key, exitingComponent);
    }
    childrenToRender.splice(insertionIndex, 0, exitingComponent);
  });
  // Add `MotionContext` even to children that don't need it to ensure we're rendering
  // the same tree between renders
  childrenToRender = childrenToRender.map(function (child) {
    var key = child.key;
    return exitingChildren.has(key) ? child : (/*#__PURE__*/React.createElement(PresenceChild, {
      key: getChildKey(child),
      isPresent: true,
      presenceAffectsLayout: presenceAffectsLayout,
      mode: mode
    }, child));
  });
  if (process.env.NODE_ENV !== "production" && mode === "wait" && childrenToRender.length > 1) {
    console.warn("You're attempting to animate multiple children within AnimatePresence, but its mode is set to \"wait\". This will lead to odd visual behaviour.");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map(function (child) {
    return /*#__PURE__*/cloneElement(child);
  }));
};

var toastMotionVariants = {
  initial: function initial(props) {
    var position = props.position;
    var dir = ["top", "bottom"].includes(position) ? "y" : "x";
    var factor = ["top-right", "bottom-right"].includes(position) ? 1 : -1;
    if (position === "bottom") factor = 1;
    return _defineProperty$3({
      opacity: 0
    }, dir, factor * 24);
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
};
var ToastComponent = /*#__PURE__*/memo$1(function (props) {
  var id = props.id,
    message = props.message,
    onCloseComplete = props.onCloseComplete,
    onRequestRemove = props.onRequestRemove,
    _props$requestClose = props.requestClose,
    requestClose = _props$requestClose === void 0 ? false : _props$requestClose,
    _props$position = props.position,
    position = _props$position === void 0 ? "bottom" : _props$position,
    _props$duration = props.duration,
    duration = _props$duration === void 0 ? 5e3 : _props$duration,
    containerStyle = props.containerStyle,
    _props$motionVariants = props.motionVariants,
    motionVariants = _props$motionVariants === void 0 ? toastMotionVariants : _props$motionVariants,
    _props$toastSpacing = props.toastSpacing,
    toastSpacing = _props$toastSpacing === void 0 ? "0.5rem" : _props$toastSpacing;
  var _useState = useState(duration),
    _useState2 = _slicedToArray$1(_useState, 2),
    delay = _useState2[0],
    setDelay = _useState2[1];
  var isPresent = useIsPresent();
  useUpdateEffect(function () {
    if (!isPresent) {
      onCloseComplete == null ? void 0 : onCloseComplete();
    }
  }, [isPresent]);
  useUpdateEffect(function () {
    setDelay(duration);
  }, [duration]);
  var onMouseEnter = function onMouseEnter() {
    return setDelay(null);
  };
  var onMouseLeave = function onMouseLeave() {
    return setDelay(duration);
  };
  var close = function close() {
    if (isPresent) onRequestRemove();
  };
  useEffect(function () {
    if (isPresent && requestClose) {
      onRequestRemove();
    }
  }, [isPresent, requestClose, onRequestRemove]);
  useTimeout(close, delay);
  var containerStyles = useMemo(function () {
    return _objectSpread2$1({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 300,
      margin: toastSpacing
    }, containerStyle);
  }, [containerStyle, toastSpacing]);
  var toastStyle = useMemo(function () {
    return getToastStyle(position);
  }, [position]);
  return /* @__PURE__ */jsxRuntimeExports.jsx(motion.div, {
    layout: true,
    className: "chakra-toast",
    variants: motionVariants,
    initial: "initial",
    animate: "animate",
    exit: "exit",
    onHoverStart: onMouseEnter,
    onHoverEnd: onMouseLeave,
    custom: {
      position: position
    },
    style: toastStyle,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, {
      role: "status",
      "aria-atomic": "true",
      className: "chakra-toast__inner",
      __css: containerStyles,
      children: runIfFn$2(message, {
        id: id,
        onClose: close
      })
    })
  });
});
ToastComponent.displayName = "ToastComponent";

// src/toast.placement.ts
function getToastPlacement(position, dir) {
  var _a;
  var computedPosition = position != null ? position : "bottom";
  var logicals = {
    "top-start": {
      ltr: "top-left",
      rtl: "top-right"
    },
    "top-end": {
      ltr: "top-right",
      rtl: "top-left"
    },
    "bottom-start": {
      ltr: "bottom-left",
      rtl: "bottom-right"
    },
    "bottom-end": {
      ltr: "bottom-right",
      rtl: "bottom-left"
    }
  };
  var logical = logicals[computedPosition];
  return (_a = logical == null ? void 0 : logical[dir]) != null ? _a : computedPosition;
}

var _excluded$27 = ["as", "viewBox", "color", "focusable", "children", "className", "__css"];
var fallbackIcon = {
  path: /* @__PURE__ */jsxRuntimeExports.jsxs("g", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("path", {
      strokeLinecap: "round",
      fill: "none",
      d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fill: "currentColor",
      strokeLinecap: "round",
      d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
    }), /* @__PURE__ */jsxRuntimeExports.jsx("circle", {
      fill: "none",
      strokeMiterlimit: "10",
      cx: "12",
      cy: "12",
      r: "11.25"
    })]
  }),
  viewBox: "0 0 24 24"
};
var Icon = forwardRef(function (props, ref) {
  var element = props.as,
    viewBox = props.viewBox,
    _props$color = props.color,
    color = _props$color === void 0 ? "currentColor" : _props$color,
    _props$focusable = props.focusable,
    focusable = _props$focusable === void 0 ? false : _props$focusable,
    children = props.children,
    className = props.className,
    __css = props.__css,
    rest = _objectWithoutProperties$1(props, _excluded$27);
  var _className = cx("chakra-icon", className);
  var customStyles = useStyleConfig("Icon", props);
  var styles = _objectSpread2$1(_objectSpread2$1({
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: color
  }, __css), customStyles);
  var shared = {
    ref: ref,
    focusable: focusable,
    className: _className,
    __css: styles
  };
  var _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;
  if (element && typeof element !== "string") {
    return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.svg, _objectSpread2$1(_objectSpread2$1({
      as: element
    }, shared), rest));
  }
  var _path = children != null ? children : fallbackIcon.path;
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.svg, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
    verticalAlign: "middle",
    viewBox: _viewBox
  }, shared), rest), {}, {
    children: _path
  }));
});
Icon.displayName = "Icon";

function createIcon(options) {
  var _options$viewBox = options.viewBox,
    viewBox = _options$viewBox === void 0 ? "0 0 24 24" : _options$viewBox,
    pathDefinition = options.d,
    displayName = options.displayName,
    _options$defaultProps = options.defaultProps,
    defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps;
  var path = Children.toArray(options.path);
  var Comp = forwardRef(function (props, ref) {
    return /* @__PURE__ */jsxRuntimeExports.jsx(Icon, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
      ref: ref,
      viewBox: viewBox
    }, defaultProps), props), {}, {
      children: path.length ? path : /* @__PURE__ */jsxRuntimeExports.jsx("path", {
        fill: "currentColor",
        d: pathDefinition
      })
    }));
  });
  Comp.displayName = displayName;
  return Comp;
}

function CheckIcon$2(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(Icon, _objectSpread2$1(_objectSpread2$1({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
    })
  }));
}
function InfoIcon(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(Icon, _objectSpread2$1(_objectSpread2$1({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    })
  }));
}
function WarningIcon(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(Icon, _objectSpread2$1(_objectSpread2$1({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    })
  }));
}

var _excluded$26 = ["label", "thickness", "speed", "emptyColor", "className"];
var spin$1 = keyframes$2({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});
var Spinner$1 = forwardRef(function (props, ref) {
  var styles = useStyleConfig("Spinner", props);
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$lab = _omitThemingProps.label,
    label = _omitThemingProps$lab === void 0 ? "Loading..." : _omitThemingProps$lab,
    _omitThemingProps$thi = _omitThemingProps.thickness,
    thickness = _omitThemingProps$thi === void 0 ? "2px" : _omitThemingProps$thi,
    _omitThemingProps$spe = _omitThemingProps.speed,
    speed = _omitThemingProps$spe === void 0 ? "0.45s" : _omitThemingProps$spe,
    _omitThemingProps$emp = _omitThemingProps.emptyColor,
    emptyColor = _omitThemingProps$emp === void 0 ? "transparent" : _omitThemingProps$emp,
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$26);
  var _className = cx("chakra-spinner", className);
  var spinnerStyles = _objectSpread2$1({
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: thickness,
    borderBottomColor: emptyColor,
    borderLeftColor: emptyColor,
    animation: "".concat(spin$1, " ").concat(speed, " linear infinite")
  }, styles);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    __css: spinnerStyles,
    className: _className
  }, rest), {}, {
    children: label && /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, {
      srOnly: true,
      children: label
    })
  }));
});
Spinner$1.displayName = "Spinner";

var _createContext$l = createContext$1({
    name: "AlertContext",
    hookName: "useAlertContext",
    providerName: "<Alert />"
  }),
  _createContext2$l = _slicedToArray$1(_createContext$l, 2),
  AlertProvider = _createContext2$l[0],
  useAlertContext = _createContext2$l[1];
var _createContext3$5 = createContext$1({
    name: "AlertStylesContext",
    hookName: "useAlertStyles",
    providerName: "<Alert />"
  }),
  _createContext4$5 = _slicedToArray$1(_createContext3$5, 2),
  AlertStylesProvider = _createContext4$5[0],
  useAlertStyles = _createContext4$5[1];
var STATUSES = {
  info: {
    icon: InfoIcon,
    colorScheme: "blue"
  },
  warning: {
    icon: WarningIcon,
    colorScheme: "orange"
  },
  success: {
    icon: CheckIcon$2,
    colorScheme: "green"
  },
  error: {
    icon: WarningIcon,
    colorScheme: "red"
  },
  loading: {
    icon: Spinner$1,
    colorScheme: "blue"
  }
};
function getStatusColorScheme(status) {
  return STATUSES[status].colorScheme;
}
function getStatusIcon(status) {
  return STATUSES[status].icon;
}

var AlertDescription = forwardRef(function AlertDescription2(props, ref) {
  var styles = useAlertStyles();
  var _useAlertContext = useAlertContext(),
    status = _useAlertContext.status;
  var descriptionStyles = _objectSpread2$1({
    display: "inline"
  }, styles.description);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    "data-status": status
  }, props), {}, {
    className: cx("chakra-alert__desc", props.className),
    __css: descriptionStyles
  }));
});
AlertDescription.displayName = "AlertDescription";

function AlertIcon(props) {
  var _useAlertContext = useAlertContext(),
    status = _useAlertContext.status;
  var BaseIcon = getStatusIcon(status);
  var styles = useAlertStyles();
  var css = status === "loading" ? styles.spinner : styles.icon;
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
    display: "inherit",
    "data-status": status
  }, props), {}, {
    className: cx("chakra-alert__icon", props.className),
    __css: css,
    children: props.children || /* @__PURE__ */jsxRuntimeExports.jsx(BaseIcon, {
      h: "100%",
      w: "100%"
    })
  }));
}
AlertIcon.displayName = "AlertIcon";

var AlertTitle = forwardRef(function AlertTitle2(props, ref) {
  var styles = useAlertStyles();
  var _useAlertContext = useAlertContext(),
    status = _useAlertContext.status;
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    "data-status": status
  }, props), {}, {
    className: cx("chakra-alert__title", props.className),
    __css: styles.title
  }));
});
AlertTitle.displayName = "AlertTitle";

var _excluded$25 = ["status", "addRole"];
var Alert$1 = forwardRef(function Alert2(props, ref) {
  var _a;
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$sta = _omitThemingProps.status,
    status = _omitThemingProps$sta === void 0 ? "info" : _omitThemingProps$sta,
    _omitThemingProps$add = _omitThemingProps.addRole,
    addRole = _omitThemingProps$add === void 0 ? true : _omitThemingProps$add,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$25);
  var colorScheme = (_a = props.colorScheme) != null ? _a : getStatusColorScheme(status);
  var styles = useMultiStyleConfig("Alert", _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    colorScheme: colorScheme
  }));
  var alertStyles = _objectSpread2$1({
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden"
  }, styles.container);
  return /* @__PURE__ */jsxRuntimeExports.jsx(AlertProvider, {
    value: {
      status: status
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(AlertStylesProvider, {
      value: styles,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
        "data-status": status,
        role: addRole ? "alert" : void 0,
        ref: ref
      }, rest), {}, {
        className: cx("chakra-alert", props.className),
        __css: alertStyles
      }))
    })
  });
});
Alert$1.displayName = "Alert";

var _excluded$24 = ["children", "isDisabled", "__css"];
function CloseIcon(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(Icon, _objectSpread2$1(_objectSpread2$1({
    focusable: "false",
    "aria-hidden": true
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fill: "currentColor",
      d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
    })
  }));
}
var CloseButton = forwardRef(function CloseButton2(props, ref) {
  var styles = useStyleConfig("CloseButton", props);
  var _omitThemingProps = omitThemingProps(props),
    children = _omitThemingProps.children,
    isDisabled = _omitThemingProps.isDisabled,
    __css = _omitThemingProps.__css,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$24);
  var baseStyle = {
    outline: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  };
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.button, _objectSpread2$1(_objectSpread2$1({
    type: "button",
    "aria-label": "Close",
    ref: ref,
    disabled: isDisabled,
    __css: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, baseStyle), styles), __css)
  }, rest), {}, {
    children: children || /* @__PURE__ */jsxRuntimeExports.jsx(CloseIcon, {
      width: "1em",
      height: "1em"
    })
  }));
});
CloseButton.displayName = "CloseButton";

// src/toast.store.ts
var initialState = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
};
var toastStore = createStore(initialState);
function createStore(initialState2) {
  var state = initialState2;
  var listeners = /* @__PURE__ */new Set();
  var setState = function setState(setStateFn) {
    state = setStateFn(state);
    listeners.forEach(function (l) {
      return l();
    });
  };
  return {
    getState: function getState() {
      return state;
    },
    subscribe: function subscribe(listener) {
      listeners.add(listener);
      return function () {
        setState(function () {
          return initialState2;
        });
        listeners["delete"](listener);
      };
    },
    /**
     * Delete a toast record at its position
     */
    removeToast: function removeToast(id, position) {
      setState(function (prevState) {
        return _objectSpread2$1(_objectSpread2$1({}, prevState), {}, _defineProperty$3({}, position, prevState[position].filter(function (toast) {
          return toast.id != id;
        })));
      });
    },
    notify: function notify(message, options) {
      var toast = createToast(message, options);
      var position = toast.position,
        id = toast.id;
      setState(function (prevToasts) {
        var _a, _b;
        var isTop = position.includes("top");
        var toasts = isTop ? [toast].concat(_toConsumableArray$1((_a = prevToasts[position]) != null ? _a : [])) : [].concat(_toConsumableArray$1((_b = prevToasts[position]) != null ? _b : []), [toast]);
        return _objectSpread2$1(_objectSpread2$1({}, prevToasts), {}, _defineProperty$3({}, position, toasts));
      });
      return id;
    },
    update: function update(id, options) {
      if (!id) return;
      setState(function (prevState) {
        var nextState = _objectSpread2$1({}, prevState);
        var _findToast = findToast(nextState, id),
          position = _findToast.position,
          index = _findToast.index;
        if (position && index !== -1) {
          nextState[position][index] = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, nextState[position][index]), options), {}, {
            message: createRenderToast(options)
          });
        }
        return nextState;
      });
    },
    closeAll: function closeAll() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        positions = _ref.positions;
      setState(function (prev) {
        var allPositions = ["bottom", "bottom-right", "bottom-left", "top", "top-left", "top-right"];
        var positionsToClose = positions != null ? positions : allPositions;
        return positionsToClose.reduce(function (acc, position) {
          acc[position] = prev[position].map(function (toast) {
            return _objectSpread2$1(_objectSpread2$1({}, toast), {}, {
              requestClose: true
            });
          });
          return acc;
        }, _objectSpread2$1({}, prev));
      });
    },
    close: function close(id) {
      setState(function (prevState) {
        var position = getToastPosition(prevState, id);
        if (!position) return prevState;
        return _objectSpread2$1(_objectSpread2$1({}, prevState), {}, _defineProperty$3({}, position, prevState[position].map(function (toast) {
          if (toast.id == id) {
            return _objectSpread2$1(_objectSpread2$1({}, toast), {}, {
              requestClose: true
            });
          }
          return toast;
        })));
      });
    },
    isActive: function isActive(id) {
      return Boolean(findToast(toastStore.getState(), id).position);
    }
  };
}
var counter = 0;
function createToast(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a, _b;
  counter += 1;
  var id = (_a = options.id) != null ? _a : counter;
  var position = (_b = options.position) != null ? _b : "bottom";
  return {
    id: id,
    message: message,
    position: position,
    duration: options.duration,
    onCloseComplete: options.onCloseComplete,
    onRequestRemove: function onRequestRemove() {
      return toastStore.removeToast(String(id), position);
    },
    status: options.status,
    requestClose: false,
    containerStyle: options.containerStyle
  };
}
var Toast = function Toast(props) {
  var status = props.status,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? "solid" : _props$variant,
    id = props.id,
    title = props.title,
    isClosable = props.isClosable,
    onClose = props.onClose,
    description = props.description,
    colorScheme = props.colorScheme,
    icon = props.icon;
  var ids = id ? {
    root: "toast-".concat(id),
    title: "toast-".concat(id, "-title"),
    description: "toast-".concat(id, "-description")
  } : void 0;
  return /* @__PURE__ */jsxRuntimeExports.jsxs(Alert$1, {
    addRole: false,
    status: status,
    variant: variant,
    id: ids == null ? void 0 : ids.root,
    alignItems: "start",
    borderRadius: "md",
    boxShadow: "lg",
    paddingEnd: 8,
    textAlign: "start",
    width: "auto",
    colorScheme: colorScheme,
    children: [/* @__PURE__ */jsxRuntimeExports.jsx(AlertIcon, {
      children: icon
    }), /* @__PURE__ */jsxRuntimeExports.jsxs(chakra.div, {
      flex: "1",
      maxWidth: "100%",
      children: [title && /* @__PURE__ */jsxRuntimeExports.jsx(AlertTitle, {
        id: ids == null ? void 0 : ids.title,
        children: title
      }), description && /* @__PURE__ */jsxRuntimeExports.jsx(AlertDescription, {
        id: ids == null ? void 0 : ids.description,
        display: "block",
        children: description
      })]
    }), isClosable && /* @__PURE__ */jsxRuntimeExports.jsx(CloseButton, {
      size: "sm",
      onClick: onClose,
      position: "absolute",
      insetEnd: 1,
      top: 1
    })]
  });
};
function createRenderToast() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var render = options.render,
    _options$toastCompone = options.toastComponent,
    ToastComponent = _options$toastCompone === void 0 ? Toast : _options$toastCompone;
  var renderToast = function renderToast(props) {
    if (typeof render === "function") {
      return render(_objectSpread2$1(_objectSpread2$1({}, props), options));
    }
    return /* @__PURE__ */jsxRuntimeExports.jsx(ToastComponent, _objectSpread2$1(_objectSpread2$1({}, props), options));
  };
  return renderToast;
}
function createToastFn(dir, defaultOptions) {
  var normalizeToastOptions = function normalizeToastOptions(options) {
    var _a;
    return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, defaultOptions), options), {}, {
      position: getToastPlacement((_a = options == null ? void 0 : options.position) != null ? _a : defaultOptions == null ? void 0 : defaultOptions.position, dir)
    });
  };
  var toast = function toast(options) {
    var normalizedToastOptions = normalizeToastOptions(options);
    var Message = createRenderToast(normalizedToastOptions);
    return toastStore.notify(Message, normalizedToastOptions);
  };
  toast.update = function (id, options) {
    toastStore.update(id, normalizeToastOptions(options));
  };
  toast.promise = function (promise, options) {
    var id = toast(_objectSpread2$1(_objectSpread2$1({}, options.loading), {}, {
      status: "loading",
      duration: null
    }));
    promise.then(function (data) {
      return toast.update(id, _objectSpread2$1({
        status: "success",
        duration: 5e3
      }, runIfFn$2(options.success, data)));
    })["catch"](function (error) {
      return toast.update(id, _objectSpread2$1({
        status: "error",
        duration: 5e3
      }, runIfFn$2(options.error, error)));
    });
  };
  toast.closeAll = toastStore.closeAll;
  toast.close = toastStore.close;
  toast.isActive = toastStore.isActive;
  return toast;
}

var _createContext$k = createContext$1({
    name: "ToastOptionsContext",
    strict: false
  }),
  _createContext2$k = _slicedToArray$1(_createContext$k, 2),
  ToastOptionProvider = _createContext2$k[0],
  useToastOptionContext = _createContext2$k[1];
var ToastProvider = function ToastProvider(props) {
  var state = useSyncExternalStore(toastStore.subscribe, toastStore.getState, toastStore.getState);
  var motionVariants = props.motionVariants,
    _props$component = props.component,
    Component = _props$component === void 0 ? ToastComponent : _props$component,
    portalProps = props.portalProps;
  var stateKeys = Object.keys(state);
  var toastList = stateKeys.map(function (position) {
    var toasts = state[position];
    return /* @__PURE__ */jsxRuntimeExports.jsx("div", {
      role: "region",
      "aria-live": "polite",
      "aria-label": "Notifications-".concat(position),
      id: "chakra-toast-manager-".concat(position),
      style: getToastListStyle(position),
      children: /* @__PURE__ */jsxRuntimeExports.jsx(AnimatePresence, {
        initial: false,
        children: toasts.map(function (toast) {
          return /* @__PURE__ */jsxRuntimeExports.jsx(Component, _objectSpread2$1({
            motionVariants: motionVariants
          }, toast), toast.id);
        })
      })
    }, position);
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(Portal, _objectSpread2$1(_objectSpread2$1({}, portalProps), {}, {
    children: toastList
  }));
};

function useToast(options) {
  var _useChakra = useChakra(),
    theme = _useChakra.theme;
  var defaultOptions = useToastOptionContext();
  return useMemo(function () {
    return createToastFn(theme.direction, _objectSpread2$1(_objectSpread2$1({}, defaultOptions), options));
  }, [options, theme.direction, defaultOptions]);
}

var _excluded$23 = ["children", "theme", "toastOptions"];
var createChakraProvider = function createChakraProvider(providerTheme) {
  return function ChakraProvider2(_ref) {
    var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? providerTheme : _ref$theme,
      toastOptions = _ref.toastOptions,
      restProps = _objectWithoutProperties$1(_ref, _excluded$23);
    return /* @__PURE__ */jsxRuntimeExports.jsxs(ChakraProvider$1, _objectSpread2$1(_objectSpread2$1({
      theme: theme
    }, restProps), {}, {
      children: [/* @__PURE__ */jsxRuntimeExports.jsx(ToastOptionProvider, {
        value: toastOptions == null ? void 0 : toastOptions.defaultOptions,
        children: children
      }), /* @__PURE__ */jsxRuntimeExports.jsx(ToastProvider, _objectSpread2$1({}, toastOptions))]
    }));
  };
};
var ChakraProvider = createChakraProvider(theme$1);

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField$1 = function __publicField(obj, key, value) {
  __defNormalProp$1(obj, _typeof$1(key) !== "symbol" ? key + "" : key, value);
  return value;
};
function sortNodes(nodes) {
  return nodes.sort(function (a, b) {
    var compare = a.compareDocumentPosition(b);
    if (compare & Node.DOCUMENT_POSITION_FOLLOWING || compare & Node.DOCUMENT_POSITION_CONTAINED_BY) {
      return -1;
    }
    if (compare & Node.DOCUMENT_POSITION_PRECEDING || compare & Node.DOCUMENT_POSITION_CONTAINS) {
      return 1;
    }
    if (compare & Node.DOCUMENT_POSITION_DISCONNECTED || compare & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC) {
      throw Error("Cannot sort the given nodes.");
    } else {
      return 0;
    }
  });
}
var isElement$3 = function isElement(el) {
  return _typeof$1(el) == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
};
function getNextIndex(current, max, loop) {
  var next = current + 1;
  if (loop && next >= max) next = 0;
  return next;
}
function getPrevIndex(current, max, loop) {
  var next = current - 1;
  if (loop && next < 0) next = max;
  return next;
}
var useSafeLayoutEffect$1 = typeof window !== "undefined" ? useLayoutEffect : useEffect;
var cast = function cast(value) {
  return value;
};

// src/descendant.ts
var DescendantsManager = /*#__PURE__*/_createClass$1(function DescendantsManager() {
  var _this = this;
  _classCallCheck$1(this, DescendantsManager);
  __publicField$1(this, "descendants", /* @__PURE__ */new Map());
  __publicField$1(this, "register", function (nodeOrOptions) {
    if (nodeOrOptions == null) return;
    if (isElement$3(nodeOrOptions)) {
      return _this.registerNode(nodeOrOptions);
    }
    return function (node) {
      _this.registerNode(node, nodeOrOptions);
    };
  });
  __publicField$1(this, "unregister", function (node) {
    _this.descendants["delete"](node);
    var sorted = sortNodes(Array.from(_this.descendants.keys()));
    _this.assignIndex(sorted);
  });
  __publicField$1(this, "destroy", function () {
    _this.descendants.clear();
  });
  __publicField$1(this, "assignIndex", function (descendants) {
    _this.descendants.forEach(function (descendant) {
      var index = descendants.indexOf(descendant.node);
      descendant.index = index;
      descendant.node.dataset["index"] = descendant.index.toString();
    });
  });
  __publicField$1(this, "count", function () {
    return _this.descendants.size;
  });
  __publicField$1(this, "enabledCount", function () {
    return _this.enabledValues().length;
  });
  __publicField$1(this, "values", function () {
    var values = Array.from(_this.descendants.values());
    return values.sort(function (a, b) {
      return a.index - b.index;
    });
  });
  __publicField$1(this, "enabledValues", function () {
    return _this.values().filter(function (descendant) {
      return !descendant.disabled;
    });
  });
  __publicField$1(this, "item", function (index) {
    if (_this.count() === 0) return void 0;
    return _this.values()[index];
  });
  __publicField$1(this, "enabledItem", function (index) {
    if (_this.enabledCount() === 0) return void 0;
    return _this.enabledValues()[index];
  });
  __publicField$1(this, "first", function () {
    return _this.item(0);
  });
  __publicField$1(this, "firstEnabled", function () {
    return _this.enabledItem(0);
  });
  __publicField$1(this, "last", function () {
    return _this.item(_this.descendants.size - 1);
  });
  __publicField$1(this, "lastEnabled", function () {
    var lastIndex = _this.enabledValues().length - 1;
    return _this.enabledItem(lastIndex);
  });
  __publicField$1(this, "indexOf", function (node) {
    var _a, _b;
    if (!node) return -1;
    return (_b = (_a = _this.descendants.get(node)) == null ? void 0 : _a.index) != null ? _b : -1;
  });
  __publicField$1(this, "enabledIndexOf", function (node) {
    if (node == null) return -1;
    return _this.enabledValues().findIndex(function (i) {
      return i.node.isSameNode(node);
    });
  });
  __publicField$1(this, "next", function (index) {
    var loop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var next = getNextIndex(index, _this.count(), loop);
    return _this.item(next);
  });
  __publicField$1(this, "nextEnabled", function (index) {
    var loop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var item = _this.item(index);
    if (!item) return;
    var enabledIndex = _this.enabledIndexOf(item.node);
    var nextEnabledIndex = getNextIndex(enabledIndex, _this.enabledCount(), loop);
    return _this.enabledItem(nextEnabledIndex);
  });
  __publicField$1(this, "prev", function (index) {
    var loop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var prev = getPrevIndex(index, _this.count() - 1, loop);
    return _this.item(prev);
  });
  __publicField$1(this, "prevEnabled", function (index) {
    var loop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var item = _this.item(index);
    if (!item) return;
    var enabledIndex = _this.enabledIndexOf(item.node);
    var prevEnabledIndex = getPrevIndex(enabledIndex, _this.enabledCount() - 1, loop);
    return _this.enabledItem(prevEnabledIndex);
  });
  __publicField$1(this, "registerNode", function (node, options) {
    if (!node || _this.descendants.has(node)) return;
    var keys = Array.from(_this.descendants.keys()).concat(node);
    var sorted = sortNodes(keys);
    if (options == null ? void 0 : options.disabled) {
      options.disabled = !!options.disabled;
    }
    var descendant = _objectSpread2$1({
      node: node,
      index: -1
    }, options);
    _this.descendants.set(node, descendant);
    _this.assignIndex(sorted);
  });
});

function assignRef$2(ref, value) {
  if (ref == null) return;
  if (typeof ref === "function") {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value '".concat(value, "' to ref '").concat(ref, "'"));
  }
}
function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function (node) {
    refs.forEach(function (ref) {
      assignRef$2(ref, node);
    });
  };
}
function useMergeRefs$2() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return useMemo(function () {
    return mergeRefs.apply(void 0, refs);
  }, refs);
}

function useDescendants() {
  var descendants = useRef(new DescendantsManager());
  useSafeLayoutEffect$1(function () {
    return function () {
      return descendants.current.destroy();
    };
  });
  return descendants.current;
}
var _createContext$j = createContext$1({
    name: "DescendantsProvider",
    errorMessage: "useDescendantsContext must be used within DescendantsProvider"
  }),
  _createContext2$j = _slicedToArray$1(_createContext$j, 2),
  DescendantsContextProvider = _createContext2$j[0],
  useDescendantsContext = _createContext2$j[1];
function useDescendant(options) {
  var descendants = useDescendantsContext();
  var _useState = useState(-1),
    _useState2 = _slicedToArray$1(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var ref = useRef(null);
  useSafeLayoutEffect$1(function () {
    return function () {
      if (!ref.current) return;
      descendants.unregister(ref.current);
    };
  }, []);
  useSafeLayoutEffect$1(function () {
    if (!ref.current) return;
    var dataIndex = Number(ref.current.dataset["index"]);
    if (index != dataIndex && !Number.isNaN(dataIndex)) {
      setIndex(dataIndex);
    }
  });
  var refCallback = options ? cast(descendants.register(options)) : cast(descendants.register);
  return {
    descendants: descendants,
    index: index,
    enabledIndex: descendants.enabledIndexOf(ref.current),
    register: mergeRefs(refCallback, ref)
  };
}
function createDescendantContext() {
  var ContextProvider = cast(DescendantsContextProvider);
  var _useDescendantsContext = function _useDescendantsContext() {
    return cast(useDescendantsContext());
  };
  var _useDescendant = function _useDescendant(options) {
    return useDescendant(options);
  };
  var _useDescendants = function _useDescendants() {
    return useDescendants();
  };
  return [
  // context provider
  ContextProvider,
  // call this when you need to read from context
  _useDescendantsContext,
  // descendants state information, to be called and passed to `ContextProvider`
  _useDescendants,
  // descendant index information
  _useDescendant];
}

var _createContext$i = createContext$1({
    name: "AccordionStylesContext",
    hookName: "useAccordionStyles",
    providerName: "<Accordion />"
  }),
  _createContext2$i = _slicedToArray$1(_createContext$i, 2),
  AccordionStylesProvider = _createContext2$i[0],
  useAccordionStyles = _createContext2$i[1];
var _createContext3$4 = createContext$1({
    name: "AccordionItemContext",
    hookName: "useAccordionItemContext",
    providerName: "<AccordionItem />"
  }),
  _createContext4$4 = _slicedToArray$1(_createContext3$4, 2),
  AccordionItemProvider = _createContext4$4[0],
  useAccordionItemContext = _createContext4$4[1];
var _createDescendantCont$2 = createDescendantContext(),
  _createDescendantCont2$2 = _slicedToArray$1(_createDescendantCont$2, 4),
  AccordionDescendantsProvider = _createDescendantCont2$2[0];
  _createDescendantCont2$2[1];
  var useAccordionDescendants = _createDescendantCont2$2[2],
  useAccordionDescendant = _createDescendantCont2$2[3];

var AccordionButton = forwardRef(function AccordionButton2(props, ref) {
  var _useAccordionItemCont = useAccordionItemContext(),
    getButtonProps = _useAccordionItemCont.getButtonProps;
  var buttonProps = getButtonProps(props, ref);
  var styles = useAccordionStyles();
  var buttonStyles = _objectSpread2$1({
    display: "flex",
    alignItems: "center",
    width: "100%",
    outline: 0
  }, styles.button);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.button, _objectSpread2$1(_objectSpread2$1({}, buttonProps), {}, {
    className: cx("chakra-accordion__button", props.className),
    __css: buttonStyles
  }));
});
AccordionButton.displayName = "AccordionButton";

function useControllableState$1(props) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    onChange = props.onChange,
    _props$shouldUpdate = props.shouldUpdate,
    shouldUpdate = _props$shouldUpdate === void 0 ? function (prev, next) {
      return prev !== next;
    } : _props$shouldUpdate;
  var onChangeProp = useCallbackRef$3(onChange);
  var shouldUpdateProp = useCallbackRef$3(shouldUpdate);
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray$1(_useState, 2),
    uncontrolledState = _useState2[0],
    setUncontrolledState = _useState2[1];
  var controlled = valueProp !== void 0;
  var value = controlled ? valueProp : uncontrolledState;
  var setValue = useCallbackRef$3(function (next) {
    var setter = next;
    var nextValue = typeof next === "function" ? setter(value) : next;
    if (!shouldUpdateProp(value, nextValue)) {
      return;
    }
    if (!controlled) {
      setUncontrolledState(nextValue);
    }
    onChangeProp(nextValue);
  }, [controlled, onChangeProp, value, shouldUpdateProp]);
  return [value, setValue];
}

var _excluded$22 = ["onChange", "defaultIndex", "index", "allowMultiple", "allowToggle"],
  _excluded2$e = ["isDisabled", "isFocusable", "id"];
function useAccordion(props) {
  var onChange = props.onChange,
    defaultIndex = props.defaultIndex,
    indexProp = props.index,
    allowMultiple = props.allowMultiple,
    allowToggle = props.allowToggle,
    htmlProps = _objectWithoutProperties$1(props, _excluded$22);
  allowMultipleWarning(props);
  allowMultipleAndAllowToggleWarning(props);
  var descendants = useAccordionDescendants();
  var _useState = useState(-1),
    _useState2 = _slicedToArray$1(_useState, 2),
    focusedIndex = _useState2[0],
    setFocusedIndex = _useState2[1];
  useEffect(function () {
    return function () {
      setFocusedIndex(-1);
    };
  }, []);
  var _useControllableState = useControllableState$1({
      value: indexProp,
      defaultValue: function defaultValue() {
        if (allowMultiple) return defaultIndex != null ? defaultIndex : [];
        return defaultIndex != null ? defaultIndex : -1;
      },
      onChange: onChange
    }),
    _useControllableState2 = _slicedToArray$1(_useControllableState, 2),
    index = _useControllableState2[0],
    setIndex = _useControllableState2[1];
  var getAccordionItemProps = function getAccordionItemProps(idx) {
    var isOpen = false;
    if (idx !== null) {
      isOpen = Array.isArray(index) ? index.includes(idx) : index === idx;
    }
    var onChange2 = function onChange2(isOpen2) {
      if (idx === null) return;
      if (allowMultiple && Array.isArray(index)) {
        var nextState = isOpen2 ? index.concat(idx) : index.filter(function (i) {
          return i !== idx;
        });
        setIndex(nextState);
      } else if (isOpen2) {
        setIndex(idx);
      } else if (allowToggle) {
        setIndex(-1);
      }
    };
    return {
      isOpen: isOpen,
      onChange: onChange2
    };
  };
  return {
    index: index,
    setIndex: setIndex,
    htmlProps: htmlProps,
    getAccordionItemProps: getAccordionItemProps,
    focusedIndex: focusedIndex,
    setFocusedIndex: setFocusedIndex,
    descendants: descendants
  };
}
var _createContext$h = createContext$1({
    name: "AccordionContext",
    hookName: "useAccordionContext",
    providerName: "Accordion"
  }),
  _createContext2$h = _slicedToArray$1(_createContext$h, 2),
  AccordionProvider = _createContext2$h[0],
  useAccordionContext = _createContext2$h[1];
function useAccordionItem(props) {
  var isDisabled = props.isDisabled,
    isFocusable = props.isFocusable,
    id = props.id,
    htmlProps = _objectWithoutProperties$1(props, _excluded2$e);
  var _useAccordionContext = useAccordionContext(),
    getAccordionItemProps = _useAccordionContext.getAccordionItemProps,
    setFocusedIndex = _useAccordionContext.setFocusedIndex;
  var buttonRef = useRef(null);
  var reactId = useId$1();
  var uid = id != null ? id : reactId;
  var buttonId = "accordion-button-".concat(uid);
  var panelId = "accordion-panel-".concat(uid);
  focusableNotDisabledWarning(props);
  var _useAccordionDescenda = useAccordionDescendant({
      disabled: isDisabled && !isFocusable
    }),
    register = _useAccordionDescenda.register,
    index = _useAccordionDescenda.index,
    descendants = _useAccordionDescenda.descendants;
  var _getAccordionItemProp = getAccordionItemProps(index === -1 ? null : index),
    isOpen = _getAccordionItemProp.isOpen,
    onChange = _getAccordionItemProp.onChange;
  warnIfOpenAndDisabled({
    isOpen: isOpen,
    isDisabled: isDisabled
  });
  var onOpen = function onOpen() {
    onChange == null ? void 0 : onChange(true);
  };
  var onClose = function onClose() {
    onChange == null ? void 0 : onChange(false);
  };
  var onClick = useCallback(function () {
    onChange == null ? void 0 : onChange(!isOpen);
    setFocusedIndex(index);
  }, [index, setFocusedIndex, isOpen, onChange]);
  var onKeyDown = useCallback(function (event) {
    var keyMap = {
      ArrowDown: function ArrowDown() {
        var next = descendants.nextEnabled(index);
        next == null ? void 0 : next.node.focus();
      },
      ArrowUp: function ArrowUp() {
        var prev = descendants.prevEnabled(index);
        prev == null ? void 0 : prev.node.focus();
      },
      Home: function Home() {
        var first = descendants.firstEnabled();
        first == null ? void 0 : first.node.focus();
      },
      End: function End() {
        var last = descendants.lastEnabled();
        last == null ? void 0 : last.node.focus();
      }
    };
    var action = keyMap[event.key];
    if (action) {
      event.preventDefault();
      action(event);
    }
  }, [descendants, index]);
  var onFocus = useCallback(function () {
    setFocusedIndex(index);
  }, [setFocusedIndex, index]);
  var getButtonProps = useCallback(function getButtonProps2() {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      type: "button",
      ref: mergeRefs(register, buttonRef, ref),
      id: buttonId,
      disabled: !!isDisabled,
      "aria-expanded": !!isOpen,
      "aria-controls": panelId,
      onClick: callAllHandlers$1(props2.onClick, onClick),
      onFocus: callAllHandlers$1(props2.onFocus, onFocus),
      onKeyDown: callAllHandlers$1(props2.onKeyDown, onKeyDown)
    });
  }, [buttonId, isDisabled, isOpen, onClick, onFocus, onKeyDown, panelId, register]);
  var getPanelProps = useCallback(function getPanelProps2() {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: ref,
      role: "region",
      id: panelId,
      "aria-labelledby": buttonId,
      hidden: !isOpen
    });
  }, [buttonId, isOpen, panelId]);
  return {
    isOpen: isOpen,
    isDisabled: isDisabled,
    isFocusable: isFocusable,
    onOpen: onOpen,
    onClose: onClose,
    getButtonProps: getButtonProps,
    getPanelProps: getPanelProps,
    htmlProps: htmlProps
  };
}
function allowMultipleWarning(props) {
  var index = props.index || props.defaultIndex;
  var condition = index != null && !Array.isArray(index) && props.allowMultiple;
  warn({
    condition: !!condition,
    message: "If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ".concat(_typeof$1(index), ",")
  });
}
function allowMultipleAndAllowToggleWarning(props) {
  warn({
    condition: !!(props.allowMultiple && props.allowToggle),
    message: "If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not"
  });
}
function focusableNotDisabledWarning(props) {
  warn({
    condition: !!(props.isFocusable && !props.isDisabled),
    message: "Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.\n    "
  });
}
function warnIfOpenAndDisabled(props) {
  warn({
    condition: props.isOpen && !!props.isDisabled,
    message: "Cannot open a disabled accordion item"
  });
}

function AccordionIcon(props) {
  var _useAccordionItemCont = useAccordionItemContext(),
    isOpen = _useAccordionItemCont.isOpen,
    isDisabled = _useAccordionItemCont.isDisabled;
  var _useAccordionContext = useAccordionContext(),
    reduceMotion = _useAccordionContext.reduceMotion;
  var _className = cx("chakra-accordion__icon", props.className);
  var styles = useAccordionStyles();
  var iconStyles = _objectSpread2$1({
    opacity: isDisabled ? 0.4 : 1,
    transform: isOpen ? "rotate(-180deg)" : void 0,
    transition: reduceMotion ? void 0 : "transform 0.2s",
    transformOrigin: "center"
  }, styles.icon);
  return /* @__PURE__ */jsxRuntimeExports.jsx(Icon, _objectSpread2$1(_objectSpread2$1({
    viewBox: "0 0 24 24",
    "aria-hidden": true,
    className: _className,
    __css: iconStyles
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fill: "currentColor",
      d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    })
  }));
}
AccordionIcon.displayName = "AccordionIcon";

var _excluded$21 = ["htmlProps"];
var AccordionItem = forwardRef(function AccordionItem2(props, ref) {
  var children = props.children,
    className = props.className;
  var _useAccordionItem = useAccordionItem(props),
    htmlProps = _useAccordionItem.htmlProps,
    context = _objectWithoutProperties$1(_useAccordionItem, _excluded$21);
  var styles = useAccordionStyles();
  var containerStyles = _objectSpread2$1(_objectSpread2$1({}, styles.container), {}, {
    overflowAnchor: "none"
  });
  var ctx = useMemo(function () {
    return context;
  }, [context]);
  return /* @__PURE__ */jsxRuntimeExports.jsx(AccordionItemProvider, {
    value: ctx,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
      ref: ref
    }, htmlProps), {}, {
      className: cx("chakra-accordion__item", className),
      __css: containerStyles,
      children: typeof children === "function" ? children({
        isExpanded: !!context.isOpen,
        isDisabled: !!context.isDisabled
      }) : children
    }))
  });
});
AccordionItem.displayName = "AccordionItem";

var TRANSITION_EASINGS = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
};
var TRANSITION_VARIANTS = {
  scale: {
    enter: {
      scale: 1
    },
    exit: {
      scale: 0.95
    }
  },
  fade: {
    enter: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  },
  pushLeft: {
    enter: {
      x: "100%"
    },
    exit: {
      x: "-30%"
    }
  },
  pushRight: {
    enter: {
      x: "-100%"
    },
    exit: {
      x: "30%"
    }
  },
  pushUp: {
    enter: {
      y: "100%"
    },
    exit: {
      y: "-30%"
    }
  },
  pushDown: {
    enter: {
      y: "-100%"
    },
    exit: {
      y: "30%"
    }
  },
  slideLeft: {
    position: {
      left: 0,
      top: 0,
      bottom: 0,
      width: "100%"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: "-100%",
      y: 0
    }
  },
  slideRight: {
    position: {
      right: 0,
      top: 0,
      bottom: 0,
      width: "100%"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: "100%",
      y: 0
    }
  },
  slideUp: {
    position: {
      top: 0,
      left: 0,
      right: 0,
      maxWidth: "100vw"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: "-100%"
    }
  },
  slideDown: {
    position: {
      bottom: 0,
      left: 0,
      right: 0,
      maxWidth: "100vw"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: "100%"
    }
  }
};
function getSlideTransition(options) {
  var _a;
  var side = (_a = options == null ? void 0 : options.direction) != null ? _a : "right";
  switch (side) {
    case "right":
      return TRANSITION_VARIANTS.slideRight;
    case "left":
      return TRANSITION_VARIANTS.slideLeft;
    case "bottom":
      return TRANSITION_VARIANTS.slideDown;
    case "top":
      return TRANSITION_VARIANTS.slideUp;
    default:
      return TRANSITION_VARIANTS.slideRight;
  }
}
var TRANSITION_DEFAULTS = {
  enter: {
    duration: 0.2,
    ease: TRANSITION_EASINGS.easeOut
  },
  exit: {
    duration: 0.1,
    ease: TRANSITION_EASINGS.easeIn
  }
};
var withDelay = {
  enter: function enter(transition, delay) {
    return _objectSpread2$1(_objectSpread2$1({}, transition), {}, {
      delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["enter"]
    });
  },
  exit: function exit(transition, delay) {
    return _objectSpread2$1(_objectSpread2$1({}, transition), {}, {
      delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["exit"]
    });
  }
};

var _excluded$20 = ["in", "unmountOnExit", "animateOpacity", "startingHeight", "endingHeight", "style", "className", "transition", "transitionEnd"];
var isNumeric = function isNumeric(value) {
  return value != null && parseInt(value.toString(), 10) > 0;
};
var defaultTransitions = {
  exit: {
    height: {
      duration: 0.2,
      ease: TRANSITION_EASINGS.ease
    },
    opacity: {
      duration: 0.3,
      ease: TRANSITION_EASINGS.ease
    }
  },
  enter: {
    height: {
      duration: 0.3,
      ease: TRANSITION_EASINGS.ease
    },
    opacity: {
      duration: 0.4,
      ease: TRANSITION_EASINGS.ease
    }
  }
};
var variants$j = {
  exit: function exit(_ref) {
    var animateOpacity = _ref.animateOpacity,
      startingHeight = _ref.startingHeight,
      transition = _ref.transition,
      transitionEnd = _ref.transitionEnd,
      delay = _ref.delay;
    var _a;
    return _objectSpread2$1(_objectSpread2$1({}, animateOpacity && {
      opacity: isNumeric(startingHeight) ? 1 : 0
    }), {}, {
      height: startingHeight,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(defaultTransitions.exit, delay)
    });
  },
  enter: function enter(_ref2) {
    var animateOpacity = _ref2.animateOpacity,
      endingHeight = _ref2.endingHeight,
      transition = _ref2.transition,
      transitionEnd = _ref2.transitionEnd,
      delay = _ref2.delay;
    var _a;
    return _objectSpread2$1(_objectSpread2$1({}, animateOpacity && {
      opacity: 1
    }), {}, {
      height: endingHeight,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(defaultTransitions.enter, delay)
    });
  }
};
var Collapse = /*#__PURE__*/forwardRef$1(function (props, ref) {
  var isOpen = props["in"],
    unmountOnExit = props.unmountOnExit,
    _props$animateOpacity = props.animateOpacity,
    animateOpacity = _props$animateOpacity === void 0 ? true : _props$animateOpacity,
    _props$startingHeight = props.startingHeight,
    startingHeight = _props$startingHeight === void 0 ? 0 : _props$startingHeight,
    _props$endingHeight = props.endingHeight,
    endingHeight = _props$endingHeight === void 0 ? "auto" : _props$endingHeight,
    style = props.style,
    className = props.className,
    transition = props.transition,
    transitionEnd = props.transitionEnd,
    rest = _objectWithoutProperties$1(props, _excluded$20);
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  useEffect(function () {
    var timeout = setTimeout(function () {
      setMounted(true);
    });
    return function () {
      return clearTimeout(timeout);
    };
  }, []);
  warn({
    condition: Number(startingHeight) > 0 && !!unmountOnExit,
    message: "startingHeight and unmountOnExit are mutually exclusive. You can't use them together"
  });
  var hasStartingHeight = parseFloat(startingHeight.toString()) > 0;
  var custom = {
    startingHeight: startingHeight,
    endingHeight: endingHeight,
    animateOpacity: animateOpacity,
    transition: !mounted ? {
      enter: {
        duration: 0
      }
    } : transition,
    transitionEnd: {
      enter: transitionEnd == null ? void 0 : transitionEnd.enter,
      exit: unmountOnExit ? transitionEnd == null ? void 0 : transitionEnd.exit : _objectSpread2$1(_objectSpread2$1({}, transitionEnd == null ? void 0 : transitionEnd.exit), {}, {
        display: hasStartingHeight ? "block" : "none"
      })
    }
  };
  var show = unmountOnExit ? isOpen : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  return /* @__PURE__ */jsxRuntimeExports.jsx(AnimatePresence, {
    initial: false,
    custom: custom,
    children: show && /* @__PURE__ */jsxRuntimeExports.jsx(motion.div, _objectSpread2$1(_objectSpread2$1({
      ref: ref
    }, rest), {}, {
      className: cx("chakra-collapse", className),
      style: _objectSpread2$1({
        overflow: "hidden",
        display: "block"
      }, style),
      custom: custom,
      variants: variants$j,
      initial: unmountOnExit ? "exit" : false,
      animate: animate,
      exit: "exit"
    }))
  });
});
Collapse.displayName = "Collapse";

var _excluded$1$ = ["unmountOnExit", "in", "className", "transition", "transitionEnd", "delay"];
var variants$i = {
  enter: function enter() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      transition = _ref.transition,
      transitionEnd = _ref.transitionEnd,
      delay = _ref.delay;
    var _a;
    return {
      opacity: 1,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  },
  exit: function exit() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      transition = _ref2.transition,
      transitionEnd = _ref2.transitionEnd,
      delay = _ref2.delay;
    var _a;
    return {
      opacity: 0,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  }
};
var fadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants$i
};
var Fade = /*#__PURE__*/forwardRef$1(function Fade2(props, ref) {
  var unmountOnExit = props.unmountOnExit,
    isOpen = props["in"],
    className = props.className,
    transition = props.transition,
    transitionEnd = props.transitionEnd,
    delay = props.delay,
    rest = _objectWithoutProperties$1(props, _excluded$1$);
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var custom = {
    transition: transition,
    transitionEnd: transitionEnd,
    delay: delay
  };
  return /* @__PURE__ */jsxRuntimeExports.jsx(AnimatePresence, {
    custom: custom,
    children: show && /* @__PURE__ */jsxRuntimeExports.jsx(motion.div, _objectSpread2$1(_objectSpread2$1({
      ref: ref,
      className: cx("chakra-fade", className),
      custom: custom
    }, fadeConfig), {}, {
      animate: animate
    }, rest))
  });
});
Fade.displayName = "Fade";

var _excluded$1_ = ["unmountOnExit", "in", "reverse", "initialScale", "className", "transition", "transitionEnd", "delay"];
var variants$h = {
  exit: function exit(_ref) {
    var reverse = _ref.reverse,
      initialScale = _ref.initialScale,
      transition = _ref.transition,
      transitionEnd = _ref.transitionEnd,
      delay = _ref.delay;
    var _a;
    return _objectSpread2$1(_objectSpread2$1({
      opacity: 0
    }, reverse ? {
      scale: initialScale,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    } : {
      transitionEnd: _objectSpread2$1({
        scale: initialScale
      }, transitionEnd == null ? void 0 : transitionEnd.exit)
    }), {}, {
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(TRANSITION_DEFAULTS.exit, delay)
    });
  },
  enter: function enter(_ref2) {
    var transitionEnd = _ref2.transitionEnd,
      transition = _ref2.transition,
      delay = _ref2.delay;
    var _a;
    return {
      opacity: 1,
      scale: 1,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  }
};
var scaleFadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants$h
};
var ScaleFade = /*#__PURE__*/forwardRef$1(function ScaleFade2(props, ref) {
  var unmountOnExit = props.unmountOnExit,
    isOpen = props["in"],
    _props$reverse = props.reverse,
    reverse = _props$reverse === void 0 ? true : _props$reverse,
    _props$initialScale = props.initialScale,
    initialScale = _props$initialScale === void 0 ? 0.95 : _props$initialScale,
    className = props.className,
    transition = props.transition,
    transitionEnd = props.transitionEnd,
    delay = props.delay,
    rest = _objectWithoutProperties$1(props, _excluded$1_);
  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var custom = {
    initialScale: initialScale,
    reverse: reverse,
    transition: transition,
    transitionEnd: transitionEnd,
    delay: delay
  };
  return /* @__PURE__ */jsxRuntimeExports.jsx(AnimatePresence, {
    custom: custom,
    children: show && /* @__PURE__ */jsxRuntimeExports.jsx(motion.div, _objectSpread2$1(_objectSpread2$1({
      ref: ref,
      className: cx("chakra-offset-slide", className)
    }, scaleFadeConfig), {}, {
      animate: animate,
      custom: custom
    }, rest))
  });
});
ScaleFade.displayName = "ScaleFade";

var _excluded$1Z = ["unmountOnExit", "in", "reverse", "className", "offsetX", "offsetY", "transition", "transitionEnd", "delay"];
var variants$g = {
  initial: function initial(_ref) {
    var offsetX = _ref.offsetX,
      offsetY = _ref.offsetY,
      transition = _ref.transition,
      transitionEnd = _ref.transitionEnd,
      delay = _ref.delay;
    var _a;
    return {
      opacity: 0,
      x: offsetX,
      y: offsetY,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  },
  enter: function enter(_ref2) {
    var transition = _ref2.transition,
      transitionEnd = _ref2.transitionEnd,
      delay = _ref2.delay;
    var _a;
    return {
      opacity: 1,
      x: 0,
      y: 0,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  },
  exit: function exit(_ref3) {
    var offsetY = _ref3.offsetY,
      offsetX = _ref3.offsetX,
      transition = _ref3.transition,
      transitionEnd = _ref3.transitionEnd,
      reverse = _ref3.reverse,
      delay = _ref3.delay;
    var _a;
    var offset = {
      x: offsetX,
      y: offsetY
    };
    return _objectSpread2$1({
      opacity: 0,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(TRANSITION_DEFAULTS.exit, delay)
    }, reverse ? _objectSpread2$1(_objectSpread2$1({}, offset), {}, {
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    }) : {
      transitionEnd: _objectSpread2$1(_objectSpread2$1({}, offset), transitionEnd == null ? void 0 : transitionEnd.exit)
    });
  }
};
var slideFadeConfig = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: variants$g
};
var SlideFade = /*#__PURE__*/forwardRef$1(function SlideFade2(props, ref) {
  var unmountOnExit = props.unmountOnExit,
    isOpen = props["in"],
    _props$reverse = props.reverse,
    reverse = _props$reverse === void 0 ? true : _props$reverse,
    className = props.className,
    _props$offsetX = props.offsetX,
    offsetX = _props$offsetX === void 0 ? 0 : _props$offsetX,
    _props$offsetY = props.offsetY,
    offsetY = _props$offsetY === void 0 ? 8 : _props$offsetY,
    transition = props.transition,
    transitionEnd = props.transitionEnd,
    delay = props.delay,
    rest = _objectWithoutProperties$1(props, _excluded$1Z);
  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var custom = {
    offsetX: offsetX,
    offsetY: offsetY,
    reverse: reverse,
    transition: transition,
    transitionEnd: transitionEnd,
    delay: delay
  };
  return /* @__PURE__ */jsxRuntimeExports.jsx(AnimatePresence, {
    custom: custom,
    children: show && /* @__PURE__ */jsxRuntimeExports.jsx(motion.div, _objectSpread2$1(_objectSpread2$1({
      ref: ref,
      className: cx("chakra-offset-slide", className),
      custom: custom
    }, slideFadeConfig), {}, {
      animate: animate
    }, rest))
  });
});
SlideFade.displayName = "SlideFade";

var _excluded$1Y = ["direction", "style", "unmountOnExit", "in", "className", "transition", "transitionEnd", "delay", "motionProps"];
var defaultTransition = {
  exit: {
    duration: 0.15,
    ease: TRANSITION_EASINGS.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
};
var variants$f = {
  exit: function exit(_ref) {
    var direction = _ref.direction,
      transition = _ref.transition,
      transitionEnd = _ref.transitionEnd,
      delay = _ref.delay;
    var _a;
    var _getSlideTransition = getSlideTransition({
        direction: direction
      }),
      exitStyles = _getSlideTransition.exit;
    return _objectSpread2$1(_objectSpread2$1({}, exitStyles), {}, {
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(defaultTransition.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    });
  },
  enter: function enter(_ref2) {
    var direction = _ref2.direction,
      transitionEnd = _ref2.transitionEnd,
      transition = _ref2.transition,
      delay = _ref2.delay;
    var _a;
    var _getSlideTransition2 = getSlideTransition({
        direction: direction
      }),
      enterStyles = _getSlideTransition2.enter;
    return _objectSpread2$1(_objectSpread2$1({}, enterStyles), {}, {
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(defaultTransition.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    });
  }
};
var Slide = /*#__PURE__*/forwardRef$1(function Slide2(props, ref) {
  var _props$direction = props.direction,
    direction = _props$direction === void 0 ? "right" : _props$direction,
    style = props.style,
    unmountOnExit = props.unmountOnExit,
    isOpen = props["in"],
    className = props.className,
    transition = props.transition,
    transitionEnd = props.transitionEnd,
    delay = props.delay,
    motionProps = props.motionProps,
    rest = _objectWithoutProperties$1(props, _excluded$1Y);
  var transitionStyles = getSlideTransition({
    direction: direction
  });
  var computedStyle = Object.assign({
    position: "fixed"
  }, transitionStyles.position, style);
  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var custom = {
    transitionEnd: transitionEnd,
    transition: transition,
    direction: direction,
    delay: delay
  };
  return /* @__PURE__ */jsxRuntimeExports.jsx(AnimatePresence, {
    custom: custom,
    children: show && /* @__PURE__ */jsxRuntimeExports.jsx(motion.div, _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
      ref: ref,
      initial: "exit",
      className: cx("chakra-slide", className),
      animate: animate,
      exit: "exit",
      custom: custom,
      variants: variants$f,
      style: computedStyle
    }, motionProps))
  });
});
Slide.displayName = "Slide";

var _excluded$1X = ["className", "motionProps"];
var AccordionPanel = forwardRef(function AccordionPanel2(props, ref) {
  var className = props.className,
    motionProps = props.motionProps,
    rest = _objectWithoutProperties$1(props, _excluded$1X);
  var _useAccordionContext = useAccordionContext(),
    reduceMotion = _useAccordionContext.reduceMotion;
  var _useAccordionItemCont = useAccordionItemContext(),
    getPanelProps = _useAccordionItemCont.getPanelProps,
    isOpen = _useAccordionItemCont.isOpen;
  var panelProps = getPanelProps(rest, ref);
  var _className = cx("chakra-accordion__panel", className);
  var styles = useAccordionStyles();
  if (!reduceMotion) {
    delete panelProps.hidden;
  }
  var child = /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, panelProps), {}, {
    __css: styles.panel,
    className: _className
  }));
  if (!reduceMotion) {
    return /* @__PURE__ */jsxRuntimeExports.jsx(Collapse, _objectSpread2$1(_objectSpread2$1({
      "in": isOpen
    }, motionProps), {}, {
      children: child
    }));
  }
  return child;
});
AccordionPanel.displayName = "AccordionPanel";

var _excluded$1W = ["children", "reduceMotion"],
  _excluded2$d = ["htmlProps", "descendants"];
var Accordion = forwardRef(function Accordion2(_ref, ref) {
  var children = _ref.children,
    reduceMotion = _ref.reduceMotion,
    props = _objectWithoutProperties$1(_ref, _excluded$1W);
  var styles = useMultiStyleConfig("Accordion", props);
  var ownProps = omitThemingProps(props);
  var _useAccordion = useAccordion(ownProps),
    htmlProps = _useAccordion.htmlProps,
    descendants = _useAccordion.descendants,
    context = _objectWithoutProperties$1(_useAccordion, _excluded2$d);
  var ctx = useMemo(function () {
    return _objectSpread2$1(_objectSpread2$1({}, context), {}, {
      reduceMotion: !!reduceMotion
    });
  }, [context, reduceMotion]);
  return /* @__PURE__ */jsxRuntimeExports.jsx(AccordionDescendantsProvider, {
    value: descendants,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(AccordionProvider, {
      value: ctx,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(AccordionStylesProvider, {
        value: styles,
        children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
          ref: ref
        }, htmlProps), {}, {
          className: cx("chakra-accordion", props.className),
          __css: styles.root,
          children: children
        }))
      })
    })
  });
});
Accordion.displayName = "Accordion";

var _excluded$1V = ["htmlWidth", "htmlHeight", "alt"];
var NativeImage = forwardRef(function NativeImage2(props, ref) {
  var htmlWidth = props.htmlWidth,
    htmlHeight = props.htmlHeight,
    alt = props.alt,
    rest = _objectWithoutProperties$1(props, _excluded$1V);
  return /* @__PURE__ */jsxRuntimeExports.jsx("img", _objectSpread2$1({
    width: htmlWidth,
    height: htmlHeight,
    ref: ref,
    alt: alt
  }, rest));
});
NativeImage.displayName = "NativeImage";

function useImage(props) {
  var loading = props.loading,
    src = props.src,
    srcSet = props.srcSet,
    onLoad = props.onLoad,
    onError = props.onError,
    crossOrigin = props.crossOrigin,
    sizes = props.sizes,
    ignoreFallback = props.ignoreFallback;
  var _useState = useState("pending"),
    _useState2 = _slicedToArray$1(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  useEffect(function () {
    setStatus(src ? "loading" : "pending");
  }, [src]);
  var imageRef = useRef();
  var load = useCallback(function () {
    if (!src) return;
    flush();
    var img = new Image();
    img.src = src;
    if (crossOrigin) img.crossOrigin = crossOrigin;
    if (srcSet) img.srcset = srcSet;
    if (sizes) img.sizes = sizes;
    if (loading) img.loading = loading;
    img.onload = function (event) {
      flush();
      setStatus("loaded");
      onLoad == null ? void 0 : onLoad(event);
    };
    img.onerror = function (error) {
      flush();
      setStatus("failed");
      onError == null ? void 0 : onError(error);
    };
    imageRef.current = img;
  }, [src, crossOrigin, srcSet, sizes, onLoad, onError, loading]);
  var flush = function flush() {
    if (imageRef.current) {
      imageRef.current.onload = null;
      imageRef.current.onerror = null;
      imageRef.current = null;
    }
  };
  useSafeLayoutEffect$2(function () {
    if (ignoreFallback) return void 0;
    if (status === "loading") {
      load();
    }
    return function () {
      flush();
    };
  }, [status, load, ignoreFallback]);
  return ignoreFallback ? "loaded" : status;
}
var shouldShowFallbackImage = function shouldShowFallbackImage(status, fallbackStrategy) {
  return status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";
};

var _excluded$1U = ["fallbackSrc", "fallback", "src", "srcSet", "align", "fit", "loading", "ignoreFallback", "crossOrigin", "fallbackStrategy", "referrerPolicy"];

// ../../utilities/object-utils/src/omit.ts
function omit$3(object) {
  var keysToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var clone = Object.assign({}, object);
  var _iterator = _createForOfIteratorHelper(keysToOmit),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (key in clone) {
        delete clone[key];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return clone;
}
var Image$2 = forwardRef(function Image2(props, ref) {
  var fallbackSrc = props.fallbackSrc,
    fallback = props.fallback,
    src = props.src,
    srcSet = props.srcSet,
    align = props.align,
    fit = props.fit,
    loading = props.loading,
    ignoreFallback = props.ignoreFallback,
    crossOrigin = props.crossOrigin,
    _props$fallbackStrate = props.fallbackStrategy,
    fallbackStrategy = _props$fallbackStrate === void 0 ? "beforeLoadOrError" : _props$fallbackStrate,
    referrerPolicy = props.referrerPolicy,
    rest = _objectWithoutProperties$1(props, _excluded$1U);
  var providedFallback = fallbackSrc !== void 0 || fallback !== void 0;
  var shouldIgnoreFallbackImage = loading != null ||
  // use can opt out of fallback image
  ignoreFallback ||
  // if the user doesn't provide any kind of fallback we should ignore it
  !providedFallback;
  var status = useImage(_objectSpread2$1(_objectSpread2$1({}, props), {}, {
    crossOrigin: crossOrigin,
    ignoreFallback: shouldIgnoreFallbackImage
  }));
  var showFallbackImage = shouldShowFallbackImage(status, fallbackStrategy);
  var shared = _objectSpread2$1({
    ref: ref,
    objectFit: fit,
    objectPosition: align
  }, shouldIgnoreFallbackImage ? rest : omit$3(rest, ["onError", "onLoad"]));
  if (showFallbackImage) {
    if (fallback) return fallback;
    return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.img, _objectSpread2$1({
      as: NativeImage,
      className: "chakra-image__placeholder",
      src: fallbackSrc
    }, shared));
  }
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.img, _objectSpread2$1({
    as: NativeImage,
    src: src,
    srcSet: srcSet,
    crossOrigin: crossOrigin,
    loading: loading,
    referrerPolicy: referrerPolicy,
    className: "chakra-image"
  }, shared));
});
Image$2.displayName = "Image";

var Img = forwardRef(function (props, ref) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.img, _objectSpread2$1({
    ref: ref,
    as: NativeImage,
    className: "chakra-image"
  }, props));
});

// src/index.ts
function getValidChildren(children) {
  return Children.toArray(children).filter(function (child) {
    return /*#__PURE__*/isValidElement$1(child);
  });
}

var _createContext$g = createContext$1({
    name: "BreadcrumbStylesContext",
    errorMessage: "useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Breadcrumb />\" "
  }),
  _createContext2$g = _slicedToArray$1(_createContext$g, 2),
  BreadcrumbStylesProvider = _createContext2$g[0],
  useBreadcrumbStyles = _createContext2$g[1];

var _excluded$1T = ["isCurrentPage", "as", "className", "href"];
var BreadcrumbLink = forwardRef(function BreadcrumbLink2(props, ref) {
  var isCurrentPage = props.isCurrentPage,
    as = props.as,
    className = props.className,
    href = props.href,
    rest = _objectWithoutProperties$1(props, _excluded$1T);
  var styles = useBreadcrumbStyles();
  var sharedProps = _objectSpread2$1({
    ref: ref,
    as: as,
    className: cx("chakra-breadcrumb__link", className)
  }, rest);
  if (isCurrentPage) {
    return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1({
      "aria-current": "page",
      __css: styles.link
    }, sharedProps));
  }
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.a, _objectSpread2$1({
    __css: styles.link,
    href: href
  }, sharedProps));
});
BreadcrumbLink.displayName = "BreadcrumbLink";

var _excluded$1S = ["spacing"];
var BreadcrumbSeparator = forwardRef(function BreadcrumbSeparator2(props, ref) {
  var spacing = props.spacing,
    rest = _objectWithoutProperties$1(props, _excluded$1S);
  var styles = useBreadcrumbStyles();
  var separatorStyles = _objectSpread2$1({
    mx: spacing
  }, styles.separator);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    role: "presentation"
  }, rest), {}, {
    __css: separatorStyles
  }));
});
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";

var _excluded$1R = ["isCurrentPage", "separator", "isLastChild", "spacing", "children", "className"];
var BreadcrumbItem = forwardRef(function BreadcrumbItem2(props, ref) {
  var isCurrentPage = props.isCurrentPage,
    separator = props.separator,
    isLastChild = props.isLastChild,
    spacing = props.spacing,
    children = props.children,
    className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$1R);
  var validChildren = getValidChildren(children);
  var clones = validChildren.map(function (child) {
    if (child.type === BreadcrumbLink) {
      return /*#__PURE__*/cloneElement(child, {
        isCurrentPage: isCurrentPage
      });
    }
    if (child.type === BreadcrumbSeparator) {
      return /*#__PURE__*/cloneElement(child, {
        spacing: spacing,
        children: child.props.children || separator
      });
    }
    return child;
  });
  var styles = useBreadcrumbStyles();
  var itemStyles = _objectSpread2$1({
    display: "inline-flex",
    alignItems: "center"
  }, styles.item);
  var _className = cx("chakra-breadcrumb__list-item", className);
  return /* @__PURE__ */jsxRuntimeExports.jsxs(chakra.li, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: _className
  }, rest), {}, {
    __css: itemStyles,
    children: [clones, !isLastChild && /* @__PURE__ */jsxRuntimeExports.jsx(BreadcrumbSeparator, {
      spacing: spacing,
      children: separator
    })]
  }));
});
BreadcrumbItem.displayName = "BreadcrumbItem";

var _excluded$1Q = ["children", "spacing", "separator", "className", "listProps"];
var Breadcrumb = forwardRef(function Breadcrumb2(props, ref) {
  var styles = useMultiStyleConfig("Breadcrumb", props);
  var ownProps = omitThemingProps(props);
  var children = ownProps.children,
    _ownProps$spacing = ownProps.spacing,
    spacing = _ownProps$spacing === void 0 ? "0.5rem" : _ownProps$spacing,
    _ownProps$separator = ownProps.separator,
    separator = _ownProps$separator === void 0 ? "/" : _ownProps$separator,
    className = ownProps.className,
    listProps = ownProps.listProps,
    rest = _objectWithoutProperties$1(ownProps, _excluded$1Q);
  var validChildren = getValidChildren(children);
  var count = validChildren.length;
  var clones = validChildren.map(function (child, index) {
    return /*#__PURE__*/cloneElement(child, {
      separator: separator,
      spacing: spacing,
      isLastChild: count === index + 1
    });
  });
  var _className = cx("chakra-breadcrumb", className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.nav, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    "aria-label": "breadcrumb",
    className: _className,
    __css: styles.container
  }, rest), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx(BreadcrumbStylesProvider, {
      value: styles,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.ol, _objectSpread2$1(_objectSpread2$1({
        className: "chakra-breadcrumb__list"
      }, listProps), {}, {
        __css: _objectSpread2$1({
          display: "flex",
          alignItems: "center"
        }, styles.list),
        children: clones
      }))
    })
  }));
});
Breadcrumb.displayName = "Breadcrumb";

var _createContext$f = createContext$1({
    strict: false,
    name: "ButtonGroupContext"
  }),
  _createContext2$f = _slicedToArray$1(_createContext$f, 2),
  ButtonGroupProvider = _createContext2$f[0],
  useButtonGroup = _createContext2$f[1];

var _excluded$1P = ["size", "colorScheme", "variant", "className", "spacing", "isAttached", "isDisabled", "orientation"];
var attachedStyles = {
  horizontal: {
    "> *:first-of-type:not(:last-of-type)": {
      borderEndRadius: 0
    },
    "> *:not(:first-of-type):not(:last-of-type)": {
      borderRadius: 0
    },
    "> *:not(:first-of-type):last-of-type": {
      borderStartRadius: 0
    }
  },
  vertical: {
    "> *:first-of-type:not(:last-of-type)": {
      borderBottomRadius: 0
    },
    "> *:not(:first-of-type):not(:last-of-type)": {
      borderRadius: 0
    },
    "> *:not(:first-of-type):last-of-type": {
      borderTopRadius: 0
    }
  }
};
var gapStyles = {
  horizontal: function horizontal(spacing) {
    return {
      "& > *:not(style) ~ *:not(style)": {
        marginStart: spacing
      }
    };
  },
  vertical: function vertical(spacing) {
    return {
      "& > *:not(style) ~ *:not(style)": {
        marginTop: spacing
      }
    };
  }
};
var ButtonGroup = forwardRef(function ButtonGroup2(props, ref) {
  var size = props.size,
    colorScheme = props.colorScheme,
    variant = props.variant,
    className = props.className,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
    isAttached = props.isAttached,
    isDisabled = props.isDisabled,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation,
    rest = _objectWithoutProperties$1(props, _excluded$1P);
  var _className = cx("chakra-button__group", className);
  var context = useMemo(function () {
    return {
      size: size,
      colorScheme: colorScheme,
      variant: variant,
      isDisabled: isDisabled
    };
  }, [size, colorScheme, variant, isDisabled]);
  var groupStyles = _objectSpread2$1({
    display: "inline-flex"
  }, isAttached ? attachedStyles[orientation] : gapStyles[orientation](spacing));
  var isVertical = orientation === "vertical";
  return /* @__PURE__ */jsxRuntimeExports.jsx(ButtonGroupProvider, {
    value: context,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1({
      ref: ref,
      role: "group",
      __css: groupStyles,
      className: _className,
      "data-attached": isAttached ? "" : void 0,
      "data-orientation": orientation,
      flexDir: isVertical ? "column" : void 0
    }, rest))
  });
});
ButtonGroup.displayName = "ButtonGroup";

function useButtonType(value) {
  var _useState = useState(!value),
    _useState2 = _slicedToArray$1(_useState, 2),
    isButton = _useState2[0],
    setIsButton = _useState2[1];
  var refCallback = useCallback(function (node) {
    if (!node) return;
    setIsButton(node.tagName === "BUTTON");
  }, []);
  var type = isButton ? "button" : void 0;
  return {
    ref: refCallback,
    type: type
  };
}

var _excluded$1O = ["children", "className"];
function ButtonIcon(props) {
  var children = props.children,
    className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$1O);
  var _children = /*#__PURE__*/isValidElement$1(children) ? /*#__PURE__*/cloneElement(children, {
    "aria-hidden": true,
    focusable: false
  }) : children;
  var _className = cx("chakra-button__icon", className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
    display: "inline-flex",
    alignSelf: "center",
    flexShrink: 0
  }, rest), {}, {
    className: _className,
    children: _children
  }));
}
ButtonIcon.displayName = "ButtonIcon";

var _excluded$1N = ["label", "placement", "spacing", "children", "className", "__css"];
function ButtonSpinner(props) {
  var label = props.label,
    placement = props.placement,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
    _props$children = props.children,
    children = _props$children === void 0 ? /* @__PURE__ */jsxRuntimeExports.jsx(Spinner$1, {
      color: "currentColor",
      width: "1em",
      height: "1em"
    }) : _props$children,
    className = props.className,
    __css = props.__css,
    rest = _objectWithoutProperties$1(props, _excluded$1N);
  var _className = cx("chakra-button__spinner", className);
  var marginProp = placement === "start" ? "marginEnd" : "marginStart";
  var spinnerStyles = useMemo(function () {
    return _objectSpread2$1(_defineProperty$3(_defineProperty$3(_defineProperty$3({
      display: "flex",
      alignItems: "center",
      position: label ? "relative" : "absolute"
    }, marginProp, label ? spacing : 0), "fontSize", "1em"), "lineHeight", "normal"), __css);
  }, [__css, label, marginProp, spacing]);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    className: _className
  }, rest), {}, {
    __css: spinnerStyles,
    children: children
  }));
}
ButtonSpinner.displayName = "ButtonSpinner";

var _excluded$1M = ["isDisabled", "isLoading", "isActive", "children", "leftIcon", "rightIcon", "loadingText", "iconSpacing", "type", "spinner", "spinnerPlacement", "className", "as"];
var Button$2 = forwardRef(function (props, ref) {
  var group = useButtonGroup();
  var styles = useStyleConfig("Button", _objectSpread2$1(_objectSpread2$1({}, group), props));
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$isD = _omitThemingProps.isDisabled,
    isDisabled = _omitThemingProps$isD === void 0 ? group == null ? void 0 : group.isDisabled : _omitThemingProps$isD,
    isLoading = _omitThemingProps.isLoading,
    isActive = _omitThemingProps.isActive,
    children = _omitThemingProps.children,
    leftIcon = _omitThemingProps.leftIcon,
    rightIcon = _omitThemingProps.rightIcon,
    loadingText = _omitThemingProps.loadingText,
    _omitThemingProps$ico = _omitThemingProps.iconSpacing,
    iconSpacing = _omitThemingProps$ico === void 0 ? "0.5rem" : _omitThemingProps$ico,
    type = _omitThemingProps.type,
    spinner = _omitThemingProps.spinner,
    _omitThemingProps$spi = _omitThemingProps.spinnerPlacement,
    spinnerPlacement = _omitThemingProps$spi === void 0 ? "start" : _omitThemingProps$spi,
    className = _omitThemingProps.className,
    as = _omitThemingProps.as,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$1M);
  var buttonStyles = useMemo(function () {
    var _focus = _objectSpread2$1(_objectSpread2$1({}, styles == null ? void 0 : styles["_focus"]), {}, {
      zIndex: 1
    });
    return _objectSpread2$1(_objectSpread2$1({
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none"
    }, styles), !!group && {
      _focus: _focus
    });
  }, [styles, group]);
  var _useButtonType = useButtonType(as),
    _ref = _useButtonType.ref,
    defaultType = _useButtonType.type;
  var contentProps = {
    rightIcon: rightIcon,
    leftIcon: leftIcon,
    iconSpacing: iconSpacing,
    children: children
  };
  return /* @__PURE__ */jsxRuntimeExports.jsxs(chakra.button, _objectSpread2$1(_objectSpread2$1({
    ref: useMergeRefs$2(ref, _ref),
    as: as,
    type: type != null ? type : defaultType,
    "data-active": dataAttr(isActive),
    "data-loading": dataAttr(isLoading),
    __css: buttonStyles,
    className: cx("chakra-button", className)
  }, rest), {}, {
    disabled: isDisabled || isLoading,
    children: [isLoading && spinnerPlacement === "start" && /* @__PURE__ */jsxRuntimeExports.jsx(ButtonSpinner, {
      className: "chakra-button__spinner--start",
      label: loadingText,
      placement: "start",
      spacing: iconSpacing,
      children: spinner
    }), isLoading ? loadingText || /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, {
      opacity: 0,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(ButtonContent, _objectSpread2$1({}, contentProps))
    }) : /* @__PURE__ */jsxRuntimeExports.jsx(ButtonContent, _objectSpread2$1({}, contentProps)), isLoading && spinnerPlacement === "end" && /* @__PURE__ */jsxRuntimeExports.jsx(ButtonSpinner, {
      className: "chakra-button__spinner--end",
      label: loadingText,
      placement: "end",
      spacing: iconSpacing,
      children: spinner
    })]
  }));
});
Button$2.displayName = "Button";
function ButtonContent(props) {
  var leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    children = props.children,
    iconSpacing = props.iconSpacing;
  return /* @__PURE__ */jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [leftIcon && /* @__PURE__ */jsxRuntimeExports.jsx(ButtonIcon, {
      marginEnd: iconSpacing,
      children: leftIcon
    }), children, rightIcon && /* @__PURE__ */jsxRuntimeExports.jsx(ButtonIcon, {
      marginStart: iconSpacing,
      children: rightIcon
    })]
  });
}

var _createContext$e = createContext$1({
    name: "CheckboxGroupContext",
    strict: false
  }),
  _createContext2$e = _slicedToArray$1(_createContext$e, 2),
  CheckboxGroupProvider = _createContext2$e[0],
  useCheckboxGroupContext = _createContext2$e[1];

function isInputEvent$1(value) {
  return value && isObject(value) && isObject(value.target);
}
function useCheckboxGroup() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultValue = props.defaultValue,
    valueProp = props.value,
    onChange = props.onChange,
    isDisabled = props.isDisabled,
    isNative = props.isNative;
  var onChangeProp = useCallbackRef$3(onChange);
  var _useControllableState = useControllableState$1({
      value: valueProp,
      defaultValue: defaultValue || [],
      onChange: onChangeProp
    }),
    _useControllableState2 = _slicedToArray$1(_useControllableState, 2),
    value = _useControllableState2[0],
    setValue = _useControllableState2[1];
  var handleChange = useCallback(function (eventOrValue) {
    if (!value) return;
    var isChecked = isInputEvent$1(eventOrValue) ? eventOrValue.target.checked : !value.includes(eventOrValue);
    var selectedValue = isInputEvent$1(eventOrValue) ? eventOrValue.target.value : eventOrValue;
    var nextValue = isChecked ? [].concat(_toConsumableArray$1(value), [selectedValue]) : value.filter(function (v) {
      return String(v) !== String(selectedValue);
    });
    setValue(nextValue);
  }, [setValue, value]);
  var getCheckboxProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var checkedKey = isNative ? "checked" : "isChecked";
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, _defineProperty$3(_defineProperty$3({}, checkedKey, value.some(function (val) {
      return String(props2.value) === String(val);
    })), "onChange", handleChange));
  }, [handleChange, isNative, value]);
  return {
    value: value,
    isDisabled: isDisabled,
    onChange: handleChange,
    setValue: setValue,
    getCheckboxProps: getCheckboxProps
  };
}

function CheckboxGroup(props) {
  var colorScheme = props.colorScheme,
    size = props.size,
    variant = props.variant,
    children = props.children,
    isDisabled = props.isDisabled;
  var _useCheckboxGroup = useCheckboxGroup(props),
    value = _useCheckboxGroup.value,
    onChange = _useCheckboxGroup.onChange;
  var group = useMemo(function () {
    return {
      size: size,
      onChange: onChange,
      colorScheme: colorScheme,
      value: value,
      variant: variant,
      isDisabled: isDisabled
    };
  }, [size, onChange, colorScheme, value, variant, isDisabled]);
  return /* @__PURE__ */jsxRuntimeExports.jsx(CheckboxGroupProvider, {
    value: group,
    children: children
  });
}
CheckboxGroup.displayName = "CheckboxGroup";

function useInitialAnimationState(isChecked) {
  var _useState = useState(isChecked),
    _useState2 = _slicedToArray$1(_useState, 2),
    previousIsChecked = _useState2[0],
    setPreviousIsChecked = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    shouldAnimate = _useState4[0],
    setShouldAnimate = _useState4[1];
  if (isChecked !== previousIsChecked) {
    setShouldAnimate(true);
    setPreviousIsChecked(isChecked);
  }
  return shouldAnimate;
}

var _excluded$1L = ["isIndeterminate", "isChecked"];
function CheckIcon$1(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.svg, _objectSpread2$1(_objectSpread2$1({
    width: "1.2em",
    viewBox: "0 0 12 10",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "currentColor",
      strokeDasharray: 16
    }
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("polyline", {
      points: "1.5 6 4.5 9 10.5 1"
    })
  }));
}
function IndeterminateIcon(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.svg, _objectSpread2$1(_objectSpread2$1({
    width: "1.2em",
    viewBox: "0 0 24 24",
    style: {
      stroke: "currentColor",
      strokeWidth: 4
    }
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("line", {
      x1: "21",
      x2: "3",
      y1: "12",
      y2: "12"
    })
  }));
}
function CheckboxIcon(props) {
  var isIndeterminate = props.isIndeterminate,
    isChecked = props.isChecked,
    rest = _objectWithoutProperties$1(props, _excluded$1L);
  var BaseIcon = isIndeterminate ? IndeterminateIcon : CheckIcon$1;
  return isChecked || isIndeterminate ? /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%"
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(BaseIcon, _objectSpread2$1({}, rest))
  }) : null;
}

var _excluded$1K = ["id", "isRequired", "isInvalid", "isDisabled", "isReadOnly"],
  _excluded2$c = ["getRootProps", "htmlProps"];
var _createContext$d = createContext$1({
    name: "FormControlStylesContext",
    errorMessage: "useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<FormControl />\" "
  }),
  _createContext2$d = _slicedToArray$1(_createContext$d, 2),
  FormControlStylesProvider = _createContext2$d[0],
  useFormControlStyles = _createContext2$d[1];
var _createContext3$3 = createContext$1({
    strict: false,
    name: "FormControlContext"
  }),
  _createContext4$3 = _slicedToArray$1(_createContext3$3, 2),
  FormControlProvider = _createContext4$3[0],
  useFormControlContext = _createContext4$3[1];
function useFormControlProvider(props) {
  var idProp = props.id,
    isRequired = props.isRequired,
    isInvalid = props.isInvalid,
    isDisabled = props.isDisabled,
    isReadOnly = props.isReadOnly,
    htmlProps = _objectWithoutProperties$1(props, _excluded$1K);
  var uuid = useId$1();
  var id = idProp || "field-".concat(uuid);
  var labelId = "".concat(id, "-label");
  var feedbackId = "".concat(id, "-feedback");
  var helpTextId = "".concat(id, "-helptext");
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    hasFeedbackText = _useState2[0],
    setHasFeedbackText = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    hasHelpText = _useState4[0],
    setHasHelpText = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray$1(_useState5, 2),
    isFocused = _useState6[0],
    setFocus = _useState6[1];
  var getHelpTextProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({
      id: helpTextId
    }, props2), {}, {
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: mergeRefs(forwardedRef, function (node) {
        if (!node) return;
        setHasHelpText(true);
      })
    });
  }, [helpTextId]);
  var getLabelProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: forwardedRef,
      "data-focus": dataAttr(isFocused),
      "data-disabled": dataAttr(isDisabled),
      "data-invalid": dataAttr(isInvalid),
      "data-readonly": dataAttr(isReadOnly),
      id: props2.id !== void 0 ? props2.id : labelId,
      htmlFor: props2.htmlFor !== void 0 ? props2.htmlFor : id
    });
  }, [id, isDisabled, isFocused, isInvalid, isReadOnly, labelId]);
  var getErrorMessageProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({
      id: feedbackId
    }, props2), {}, {
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: mergeRefs(forwardedRef, function (node) {
        if (!node) return;
        setHasFeedbackText(true);
      }),
      "aria-live": "polite"
    });
  }, [feedbackId]);
  var getRootProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, props2), htmlProps), {}, {
      ref: forwardedRef,
      role: "group",
      "data-focus": dataAttr(isFocused),
      "data-disabled": dataAttr(isDisabled),
      "data-invalid": dataAttr(isInvalid),
      "data-readonly": dataAttr(isReadOnly)
    });
  }, [htmlProps, isDisabled, isFocused, isInvalid, isReadOnly]);
  var getRequiredIndicatorProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: forwardedRef,
      role: "presentation",
      "aria-hidden": true,
      children: props2.children || "*"
    });
  }, []);
  return {
    isRequired: !!isRequired,
    isInvalid: !!isInvalid,
    isReadOnly: !!isReadOnly,
    isDisabled: !!isDisabled,
    isFocused: !!isFocused,
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur() {
      return setFocus(false);
    },
    hasFeedbackText: hasFeedbackText,
    setHasFeedbackText: setHasFeedbackText,
    hasHelpText: hasHelpText,
    setHasHelpText: setHasHelpText,
    id: id,
    labelId: labelId,
    feedbackId: feedbackId,
    helpTextId: helpTextId,
    htmlProps: htmlProps,
    getHelpTextProps: getHelpTextProps,
    getErrorMessageProps: getErrorMessageProps,
    getRootProps: getRootProps,
    getLabelProps: getLabelProps,
    getRequiredIndicatorProps: getRequiredIndicatorProps
  };
}
var FormControl$2 = forwardRef(function FormControl2(props, ref) {
  var styles = useMultiStyleConfig("Form", props);
  var ownProps = omitThemingProps(props);
  var _useFormControlProvid = useFormControlProvider(ownProps),
    getRootProps = _useFormControlProvid.getRootProps;
    _useFormControlProvid.htmlProps;
    var context = _objectWithoutProperties$1(_useFormControlProvid, _excluded2$c);
  var className = cx("chakra-form-control", props.className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(FormControlProvider, {
    value: context,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(FormControlStylesProvider, {
      value: styles,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, getRootProps({}, ref)), {}, {
        className: className,
        __css: styles["container"]
      }))
    })
  });
});
FormControl$2.displayName = "FormControl";
var FormHelperText = forwardRef(function FormHelperText2(props, ref) {
  var field = useFormControlContext();
  var styles = useFormControlStyles();
  var className = cx("chakra-form__helper-text", props.className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, field == null ? void 0 : field.getHelpTextProps(props, ref)), {}, {
    __css: styles.helperText,
    className: className
  }));
});
FormHelperText.displayName = "FormHelperText";

var _createContext$c = createContext$1({
    name: "FormErrorStylesContext",
    errorMessage: "useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<FormError />\" "
  }),
  _createContext2$c = _slicedToArray$1(_createContext$c, 2),
  FormErrorStylesProvider = _createContext2$c[0],
  useFormErrorStyles = _createContext2$c[1];
var FormErrorMessage = forwardRef(function (props, ref) {
  var styles = useMultiStyleConfig("FormError", props);
  var ownProps = omitThemingProps(props);
  var field = useFormControlContext();
  if (!(field == null ? void 0 : field.isInvalid)) return null;
  return /* @__PURE__ */jsxRuntimeExports.jsx(FormErrorStylesProvider, {
    value: styles,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, field == null ? void 0 : field.getErrorMessageProps(ownProps, ref)), {}, {
      className: cx("chakra-form__error-message", props.className),
      __css: _objectSpread2$1({
        display: "flex",
        alignItems: "center"
      }, styles.text)
    }))
  });
});
FormErrorMessage.displayName = "FormErrorMessage";
var FormErrorIcon = forwardRef(function (props, ref) {
  var styles = useFormErrorStyles();
  var field = useFormControlContext();
  if (!(field == null ? void 0 : field.isInvalid)) return null;
  var _className = cx("chakra-form__error-icon", props.className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(Icon, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    "aria-hidden": true
  }, props), {}, {
    __css: styles.icon,
    className: _className,
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    })
  }));
});
FormErrorIcon.displayName = "FormErrorIcon";

var _excluded$1J = ["className", "children", "requiredIndicator", "optionalIndicator"];
var FormLabel = forwardRef(function FormLabel2(passedProps, ref) {
  var _a;
  var styles = useStyleConfig("FormLabel", passedProps);
  var props = omitThemingProps(passedProps);
  props.className;
    var children = props.children,
    _props$requiredIndica = props.requiredIndicator,
    requiredIndicator = _props$requiredIndica === void 0 ? /* @__PURE__ */jsxRuntimeExports.jsx(RequiredIndicator, {}) : _props$requiredIndica,
    _props$optionalIndica = props.optionalIndicator,
    optionalIndicator = _props$optionalIndica === void 0 ? null : _props$optionalIndica,
    rest = _objectWithoutProperties$1(props, _excluded$1J);
  var field = useFormControlContext();
  var ownProps = (_a = field == null ? void 0 : field.getLabelProps(rest, ref)) != null ? _a : _objectSpread2$1({
    ref: ref
  }, rest);
  return /* @__PURE__ */jsxRuntimeExports.jsxs(chakra.label, _objectSpread2$1(_objectSpread2$1({}, ownProps), {}, {
    className: cx("chakra-form__label", props.className),
    __css: _objectSpread2$1({
      display: "block",
      textAlign: "start"
    }, styles),
    children: [children, (field == null ? void 0 : field.isRequired) ? requiredIndicator : optionalIndicator]
  }));
});
FormLabel.displayName = "FormLabel";
var RequiredIndicator = forwardRef(function RequiredIndicator2(props, ref) {
  var field = useFormControlContext();
  var styles = useFormControlStyles();
  if (!(field == null ? void 0 : field.isRequired)) return null;
  var className = cx("chakra-form__required-indicator", props.className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({}, field == null ? void 0 : field.getRequiredIndicatorProps(props, ref)), {}, {
    __css: styles.requiredIndicator,
    className: className
  }));
});
RequiredIndicator.displayName = "RequiredIndicator";

var _excluded$1I = ["isDisabled", "isInvalid", "isReadOnly", "isRequired"],
  _excluded2$b = ["id", "disabled", "readOnly", "required", "isRequired", "isInvalid", "isReadOnly", "isDisabled", "onFocus", "onBlur"];
function useFormControl(props) {
  var _useFormControlProps = useFormControlProps(props),
    isDisabled = _useFormControlProps.isDisabled,
    isInvalid = _useFormControlProps.isInvalid,
    isReadOnly = _useFormControlProps.isReadOnly,
    isRequired = _useFormControlProps.isRequired,
    rest = _objectWithoutProperties$1(_useFormControlProps, _excluded$1I);
  return _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
    disabled: isDisabled,
    readOnly: isReadOnly,
    required: isRequired,
    "aria-invalid": ariaAttr(isInvalid),
    "aria-required": ariaAttr(isRequired),
    "aria-readonly": ariaAttr(isReadOnly)
  });
}
function useFormControlProps(props) {
  var _a, _b, _c;
  var field = useFormControlContext();
  var id = props.id,
    disabled = props.disabled,
    readOnly = props.readOnly,
    required = props.required,
    isRequired = props.isRequired,
    isInvalid = props.isInvalid,
    isReadOnly = props.isReadOnly,
    isDisabled = props.isDisabled,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    rest = _objectWithoutProperties$1(props, _excluded2$b);
  var labelIds = props["aria-describedby"] ? [props["aria-describedby"]] : [];
  if ((field == null ? void 0 : field.hasFeedbackText) && (field == null ? void 0 : field.isInvalid)) {
    labelIds.push(field.feedbackId);
  }
  if (field == null ? void 0 : field.hasHelpText) {
    labelIds.push(field.helpTextId);
  }
  return _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
    "aria-describedby": labelIds.join(" ") || void 0,
    id: id != null ? id : field == null ? void 0 : field.id,
    isDisabled: (_a = disabled != null ? disabled : isDisabled) != null ? _a : field == null ? void 0 : field.isDisabled,
    isReadOnly: (_b = readOnly != null ? readOnly : isReadOnly) != null ? _b : field == null ? void 0 : field.isReadOnly,
    isRequired: (_c = required != null ? required : isRequired) != null ? _c : field == null ? void 0 : field.isRequired,
    isInvalid: isInvalid != null ? isInvalid : field == null ? void 0 : field.isInvalid,
    onFocus: callAllHandlers$1(field == null ? void 0 : field.onFocus, onFocus),
    onBlur: callAllHandlers$1(field == null ? void 0 : field.onBlur, onBlur)
  });
}

// src/visually-hidden.style.ts
var visuallyHiddenStyle$1 = {
  border: "0",
  clip: "rect(0, 0, 0, 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};

// src/platform.ts
var isDom$1 = function isDom() {
  return typeof document !== "undefined";
};

// src/index.ts
var hasSetup = false;
var modality = null;
var hasEventBeforeFocus = false;
var hasBlurredWindowRecently = false;
var handlers = /* @__PURE__ */new Set();
function trigger(modality2, event) {
  handlers.forEach(function (handler) {
    return handler(modality2, event);
  });
}
var isMac = typeof window !== "undefined" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : false;
function isValidKey(e) {
  return !(e.metaKey || !isMac && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function onKeyboardEvent(event) {
  hasEventBeforeFocus = true;
  if (isValidKey(event)) {
    modality = "keyboard";
    trigger("keyboard", event);
  }
}
function onPointerEvent(event) {
  modality = "pointer";
  if (event.type === "mousedown" || event.type === "pointerdown") {
    hasEventBeforeFocus = true;
    var target = event.composedPath ? event.composedPath()[0] : event.target;
    var matches = false;
    try {
      matches = target.matches(":focus-visible");
    } catch (_unused) {}
    if (matches) return;
    trigger("pointer", event);
  }
}
function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted) return true;
  return event.detail === 0 && !event.pointerType;
}
function onClickEvent(e) {
  if (isVirtualClick(e)) {
    hasEventBeforeFocus = true;
    modality = "virtual";
  }
}
function onWindowFocus$1(event) {
  if (event.target === window || event.target === document) {
    return;
  }
  if (!hasEventBeforeFocus && !hasBlurredWindowRecently) {
    modality = "virtual";
    trigger("virtual", event);
  }
  hasEventBeforeFocus = false;
  hasBlurredWindowRecently = false;
}
function onWindowBlur$1() {
  hasEventBeforeFocus = false;
  hasBlurredWindowRecently = true;
}
function isFocusVisible() {
  return modality !== "pointer";
}
function setupGlobalFocusEvents() {
  if (!isDom$1() || hasSetup) {
    return;
  }
  var focus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function focusElement() {
    hasEventBeforeFocus = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    focus.apply(this, args);
  };
  document.addEventListener("keydown", onKeyboardEvent, true);
  document.addEventListener("keyup", onKeyboardEvent, true);
  document.addEventListener("click", onClickEvent, true);
  window.addEventListener("focus", onWindowFocus$1, true);
  window.addEventListener("blur", onWindowBlur$1, false);
  if (typeof PointerEvent !== "undefined") {
    document.addEventListener("pointerdown", onPointerEvent, true);
    document.addEventListener("pointermove", onPointerEvent, true);
    document.addEventListener("pointerup", onPointerEvent, true);
  } else {
    document.addEventListener("mousedown", onPointerEvent, true);
    document.addEventListener("mousemove", onPointerEvent, true);
    document.addEventListener("mouseup", onPointerEvent, true);
  }
  hasSetup = true;
}
function trackFocusVisible(fn) {
  setupGlobalFocusEvents();
  fn(isFocusVisible());
  var handler = function handler() {
    return fn(isFocusVisible());
  };
  handlers.add(handler);
  return function () {
    handlers["delete"](handler);
  };
}

var _excluded$1H = ["defaultChecked", "isChecked", "isFocusable", "onChange", "isIndeterminate", "name", "value", "tabIndex", "aria-label", "aria-labelledby", "aria-invalid"];

// ../../utilities/object-utils/src/omit.ts
function omit$2(object) {
  var keysToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var clone = Object.assign({}, object);
  var _iterator = _createForOfIteratorHelper(keysToOmit),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (key in clone) {
        delete clone[key];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return clone;
}
function useCheckbox() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var formControlProps = useFormControlProps(props);
  var isDisabled = formControlProps.isDisabled,
    isReadOnly = formControlProps.isReadOnly,
    isRequired = formControlProps.isRequired,
    isInvalid = formControlProps.isInvalid,
    id = formControlProps.id,
    onBlur = formControlProps.onBlur,
    onFocus = formControlProps.onFocus,
    ariaDescribedBy = formControlProps["aria-describedby"];
  var defaultChecked = props.defaultChecked,
    checkedProp = props.isChecked,
    isFocusable = props.isFocusable,
    onChange = props.onChange,
    isIndeterminate = props.isIndeterminate,
    name = props.name,
    value = props.value,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? void 0 : _props$tabIndex,
    ariaLabel = props["aria-label"],
    ariaLabelledBy = props["aria-labelledby"],
    ariaInvalid = props["aria-invalid"],
    rest = _objectWithoutProperties$1(props, _excluded$1H);
  var htmlProps = omit$2(rest, ["isDisabled", "isReadOnly", "isRequired", "isInvalid", "id", "onBlur", "onFocus", "aria-describedby"]);
  var onChangeProp = useCallbackRef$3(onChange);
  var onBlurProp = useCallbackRef$3(onBlur);
  var onFocusProp = useCallbackRef$3(onFocus);
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    isFocusVisible = _useState2[0],
    setIsFocusVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    isFocused = _useState4[0],
    setFocused = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray$1(_useState5, 2),
    isHovered = _useState6[0],
    setHovered = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray$1(_useState7, 2),
    isActive = _useState8[0],
    setActive = _useState8[1];
  useEffect(function () {
    return trackFocusVisible(setIsFocusVisible);
  }, []);
  var inputRef = useRef(null);
  var _useState9 = useState(true),
    _useState10 = _slicedToArray$1(_useState9, 2),
    rootIsLabelElement = _useState10[0],
    setRootIsLabelElement = _useState10[1];
  var _useState11 = useState(!!defaultChecked),
    _useState12 = _slicedToArray$1(_useState11, 2),
    checkedState = _useState12[0],
    setCheckedState = _useState12[1];
  var isControlled = checkedProp !== void 0;
  var isChecked = isControlled ? checkedProp : checkedState;
  var handleChange = useCallback(function (event) {
    if (isReadOnly || isDisabled) {
      event.preventDefault();
      return;
    }
    if (!isControlled) {
      if (isChecked) {
        setCheckedState(event.target.checked);
      } else {
        setCheckedState(isIndeterminate ? true : event.target.checked);
      }
    }
    onChangeProp == null ? void 0 : onChangeProp(event);
  }, [isReadOnly, isDisabled, isChecked, isControlled, isIndeterminate, onChangeProp]);
  useSafeLayoutEffect$2(function () {
    if (inputRef.current) {
      inputRef.current.indeterminate = Boolean(isIndeterminate);
    }
  }, [isIndeterminate]);
  useUpdateEffect(function () {
    if (isDisabled) {
      setFocused(false);
    }
  }, [isDisabled, setFocused]);
  useSafeLayoutEffect$2(function () {
    var el = inputRef.current;
    if (!(el == null ? void 0 : el.form)) return;
    var formResetListener = function formResetListener() {
      setCheckedState(!!defaultChecked);
    };
    el.form.addEventListener("reset", formResetListener);
    return function () {
      var _a;
      return (_a = el.form) == null ? void 0 : _a.removeEventListener("reset", formResetListener);
    };
  }, []);
  var trulyDisabled = isDisabled && !isFocusable;
  var onKeyDown = useCallback(function (event) {
    if (event.key === " ") {
      setActive(true);
    }
  }, [setActive]);
  var onKeyUp = useCallback(function (event) {
    if (event.key === " ") {
      setActive(false);
    }
  }, [setActive]);
  useSafeLayoutEffect$2(function () {
    if (!inputRef.current) return;
    var notInSync = inputRef.current.checked !== isChecked;
    if (notInSync) {
      setCheckedState(inputRef.current.checked);
    }
  }, [inputRef.current]);
  var getCheckboxProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var onPressDown = function onPressDown(event) {
      if (isFocused) {
        event.preventDefault();
      }
      setActive(true);
    };
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: forwardedRef,
      "data-active": dataAttr(isActive),
      "data-hover": dataAttr(isHovered),
      "data-checked": dataAttr(isChecked),
      "data-focus": dataAttr(isFocused),
      "data-focus-visible": dataAttr(isFocused && isFocusVisible),
      "data-indeterminate": dataAttr(isIndeterminate),
      "data-disabled": dataAttr(isDisabled),
      "data-invalid": dataAttr(isInvalid),
      "data-readonly": dataAttr(isReadOnly),
      "aria-hidden": true,
      onMouseDown: callAllHandlers$1(props2.onMouseDown, onPressDown),
      onMouseUp: callAllHandlers$1(props2.onMouseUp, function () {
        return setActive(false);
      }),
      onMouseEnter: callAllHandlers$1(props2.onMouseEnter, function () {
        return setHovered(true);
      }),
      onMouseLeave: callAllHandlers$1(props2.onMouseLeave, function () {
        return setHovered(false);
      })
    });
  }, [isActive, isChecked, isDisabled, isFocused, isFocusVisible, isHovered, isIndeterminate, isInvalid, isReadOnly]);
  var getIndicatorProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: forwardedRef,
      "data-active": dataAttr(isActive),
      "data-hover": dataAttr(isHovered),
      "data-checked": dataAttr(isChecked),
      "data-focus": dataAttr(isFocused),
      "data-focus-visible": dataAttr(isFocused && isFocusVisible),
      "data-indeterminate": dataAttr(isIndeterminate),
      "data-disabled": dataAttr(isDisabled),
      "data-invalid": dataAttr(isInvalid),
      "data-readonly": dataAttr(isReadOnly)
    });
  }, [isActive, isChecked, isDisabled, isFocused, isFocusVisible, isHovered, isIndeterminate, isInvalid, isReadOnly]);
  var getRootProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, htmlProps), props2), {}, {
      ref: mergeRefs(forwardedRef, function (node) {
        if (!node) return;
        setRootIsLabelElement(node.tagName === "LABEL");
      }),
      onClick: callAllHandlers$1(props2.onClick, function () {
        var _a;
        if (!rootIsLabelElement) {
          (_a = inputRef.current) == null ? void 0 : _a.click();
          requestAnimationFrame(function () {
            var _a2;
            (_a2 = inputRef.current) == null ? void 0 : _a2.focus({
              preventScroll: true
            });
          });
        }
      }),
      "data-disabled": dataAttr(isDisabled),
      "data-checked": dataAttr(isChecked),
      "data-invalid": dataAttr(isInvalid)
    });
  }, [htmlProps, isDisabled, isChecked, isInvalid, rootIsLabelElement]);
  var getInputProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: mergeRefs(inputRef, forwardedRef),
      type: "checkbox",
      name: name,
      value: value,
      id: id,
      tabIndex: tabIndex,
      onChange: callAllHandlers$1(props2.onChange, handleChange),
      onBlur: callAllHandlers$1(props2.onBlur, onBlurProp, function () {
        return setFocused(false);
      }),
      onFocus: callAllHandlers$1(props2.onFocus, onFocusProp, function () {
        return setFocused(true);
      }),
      onKeyDown: callAllHandlers$1(props2.onKeyDown, onKeyDown),
      onKeyUp: callAllHandlers$1(props2.onKeyUp, onKeyUp),
      required: isRequired,
      checked: isChecked,
      disabled: trulyDisabled,
      readOnly: isReadOnly,
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy,
      "aria-invalid": ariaInvalid ? Boolean(ariaInvalid) : isInvalid,
      "aria-describedby": ariaDescribedBy,
      "aria-disabled": isDisabled,
      style: visuallyHiddenStyle$1
    });
  }, [name, value, id, handleChange, onBlurProp, onFocusProp, onKeyDown, onKeyUp, isRequired, isChecked, trulyDisabled, isReadOnly, ariaLabel, ariaLabelledBy, ariaInvalid, isInvalid, ariaDescribedBy, isDisabled, tabIndex]);
  var getLabelProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: forwardedRef,
      onMouseDown: callAllHandlers$1(props2.onMouseDown, stopEvent$1),
      "data-disabled": dataAttr(isDisabled),
      "data-checked": dataAttr(isChecked),
      "data-invalid": dataAttr(isInvalid)
    });
  }, [isChecked, isDisabled, isInvalid]);
  var state = {
    isInvalid: isInvalid,
    isFocused: isFocused,
    isChecked: isChecked,
    isActive: isActive,
    isHovered: isHovered,
    isIndeterminate: isIndeterminate,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired
  };
  return {
    state: state,
    getRootProps: getRootProps,
    getCheckboxProps: getCheckboxProps,
    getIndicatorProps: getIndicatorProps,
    getInputProps: getInputProps,
    getLabelProps: getLabelProps,
    htmlProps: htmlProps
  };
}
function stopEvent$1(event) {
  event.preventDefault();
  event.stopPropagation();
}

var _excluded$1G = ["spacing", "className", "children", "iconColor", "iconSize", "icon", "isChecked", "isDisabled", "onChange", "inputProps"];
var controlStyles$1 = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "top",
  userSelect: "none",
  flexShrink: 0
};
var rootStyles = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "top",
  position: "relative"
};
var checkAnim = keyframes$2({
  from: {
    opacity: 0,
    strokeDashoffset: 16,
    transform: "scale(0.95)"
  },
  to: {
    opacity: 1,
    strokeDashoffset: 0,
    transform: "scale(1)"
  }
});
var indeterminateOpacityAnim = keyframes$2({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
var indeterminateScaleAnim = keyframes$2({
  from: {
    transform: "scaleX(0.65)"
  },
  to: {
    transform: "scaleX(1)"
  }
});
var Checkbox$1 = forwardRef(function Checkbox2(props, ref) {
  var group = useCheckboxGroupContext();
  var mergedProps = _objectSpread2$1(_objectSpread2$1({}, group), props);
  var styles = useMultiStyleConfig("Checkbox", mergedProps);
  var ownProps = omitThemingProps(props);
  var _ownProps$spacing = ownProps.spacing,
    spacing = _ownProps$spacing === void 0 ? "0.5rem" : _ownProps$spacing,
    className = ownProps.className,
    children = ownProps.children,
    iconColor = ownProps.iconColor,
    iconSize = ownProps.iconSize,
    _ownProps$icon = ownProps.icon,
    icon = _ownProps$icon === void 0 ? /* @__PURE__ */jsxRuntimeExports.jsx(CheckboxIcon, {}) : _ownProps$icon,
    isCheckedProp = ownProps.isChecked,
    _ownProps$isDisabled = ownProps.isDisabled,
    isDisabled = _ownProps$isDisabled === void 0 ? group == null ? void 0 : group.isDisabled : _ownProps$isDisabled,
    onChangeProp = ownProps.onChange,
    inputProps = ownProps.inputProps,
    rest = _objectWithoutProperties$1(ownProps, _excluded$1G);
  var isChecked = isCheckedProp;
  if ((group == null ? void 0 : group.value) && ownProps.value) {
    isChecked = group.value.includes(ownProps.value);
  }
  var onChange = onChangeProp;
  if ((group == null ? void 0 : group.onChange) && ownProps.value) {
    onChange = callAll(group.onChange, onChangeProp);
  }
  var _useCheckbox = useCheckbox(_objectSpread2$1(_objectSpread2$1({}, rest), {}, {
      isDisabled: isDisabled,
      isChecked: isChecked,
      onChange: onChange
    })),
    state = _useCheckbox.state,
    getInputProps = _useCheckbox.getInputProps,
    getCheckboxProps = _useCheckbox.getCheckboxProps,
    getLabelProps = _useCheckbox.getLabelProps,
    getRootProps = _useCheckbox.getRootProps;
  var shouldAnimate = useInitialAnimationState(state.isChecked);
  var iconStyles = useMemo(function () {
    return _objectSpread2$1({
      animation: !shouldAnimate ? void 0 : state.isIndeterminate ? "".concat(indeterminateOpacityAnim, " 20ms linear, ").concat(indeterminateScaleAnim, " 200ms linear") : "".concat(checkAnim, " 200ms linear"),
      fontSize: iconSize,
      color: iconColor
    }, styles.icon);
  }, [iconColor, iconSize, shouldAnimate, state.isIndeterminate, styles.icon]);
  var clonedIcon = /*#__PURE__*/cloneElement(icon, {
    __css: iconStyles,
    isIndeterminate: state.isIndeterminate,
    isChecked: state.isChecked
  });
  return /* @__PURE__ */jsxRuntimeExports.jsxs(chakra.label, _objectSpread2$1(_objectSpread2$1({
    __css: _objectSpread2$1(_objectSpread2$1({}, rootStyles), styles.container),
    className: cx("chakra-checkbox", className)
  }, getRootProps()), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("input", _objectSpread2$1({
      className: "chakra-checkbox__input"
    }, getInputProps(inputProps, ref))), /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
      __css: _objectSpread2$1(_objectSpread2$1({}, controlStyles$1), styles.control),
      className: "chakra-checkbox__control"
    }, getCheckboxProps()), {}, {
      children: clonedIcon
    })), children && /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
      className: "chakra-checkbox__label"
    }, getLabelProps()), {}, {
      __css: _objectSpread2$1({
        marginStart: spacing
      }, styles.label),
      children: children
    }))]
  }));
});
Checkbox$1.displayName = "Checkbox";

function useEventListener(target, event, handler, options) {
  var listener = useCallbackRef$3(handler);
  useEffect(function () {
    var node = typeof target === "function" ? target() : target != null ? target : document;
    if (!handler || !node) return;
    node.addEventListener(event, listener, options);
    return function () {
      node.removeEventListener(event, listener, options);
    };
  }, [event, target, options, listener, handler]);
  return function () {
    var node = typeof target === "function" ? target() : target != null ? target : document;
    node == null ? void 0 : node.removeEventListener(event, listener, options);
  };
}

function isRefObject$1(val) {
  return "current" in val;
}
var isDom = function isDom() {
  return typeof window !== "undefined";
};
function getPlatform() {
  var _a;
  var agent = navigator.userAgentData;
  return (_a = agent == null ? void 0 : agent.platform) != null ? _a : navigator.platform;
}
var vn = function vn(v) {
  return isDom() && v.test(navigator.vendor);
};
var pt = function pt(v) {
  return isDom() && v.test(getPlatform());
};
var isApple = function isApple() {
  return pt(/mac|iphone|ipad|ipod/i);
};
var isSafari = function isSafari() {
  return isApple() && vn(/apple/i);
};
function useFocusOnPointerDown(props) {
  var ref = props.ref,
    elements = props.elements,
    enabled = props.enabled;
  var doc = function doc() {
    var _a, _b;
    return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
  };
  useEventListener(doc, "pointerdown", function (event) {
    if (!isSafari() || !enabled) return;
    var target = event.target;
    var els = elements != null ? elements : [ref];
    var isValidTarget = els.some(function (elementOrRef) {
      var el = isRefObject$1(elementOrRef) ? elementOrRef.current : elementOrRef;
      return (el == null ? void 0 : el.contains(target)) || el === target;
    });
    if (doc().activeElement !== target && isValidTarget) {
      event.preventDefault();
      target.focus();
    }
  });
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/**
 * defines a focus group
 */
var FOCUS_GROUP = 'data-focus-lock';
/**
 * disables element discovery inside a group marked by key
 */
var FOCUS_DISABLED = 'data-focus-lock-disabled';
/**
 * allows uncontrolled focus within the marked area, effectively disabling focus lock for it's content
 */
var FOCUS_ALLOW = 'data-no-focus-lock';
/**
 * instructs autofocus engine to pick default autofocus inside a given node
 * can be set on the element or container
 */
var FOCUS_AUTO = 'data-autofocus-inside';
/**
 * instructs autofocus to ignore elements within a given node
 * can be set on the element or container
 */
var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef$1(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef$2(initialValue, callback) {
  var ref = useState(function () {
    return {
      // value
      value: initialValue,
      // last callback
      callback: callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  // update callback
  ref.callback = callback;
  return ref.facade;
}

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
var currentValues = new WeakMap();
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs$1(refs, defaultValue) {
  var callbackRef = useCallbackRef$2(null, function (newValue) {
    return refs.forEach(function (ref) {
      return assignRef$1(ref, newValue);
    });
  });
  // handle refs changes - added or removed
  useIsomorphicLayoutEffect(function () {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function (ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef$1(ref, null);
        }
      });
      nextRefs_1.forEach(function (ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef$1(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}

var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};
process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function ItoI$1(a) {
  return a;
}
function innerCreateMedium$1(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI$1;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function read() {
      if (assigned) {
        throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function useMedium(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function () {
        buffer = buffer.filter(function (x) {
          return x !== item;
        });
      };
    },
    assignSyncMedium: function assignSyncMedium(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function push(x) {
          return cb(x);
        },
        filter: function filter() {
          return buffer;
        }
      };
    },
    assignMedium: function assignMedium(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function executeQueue() {
        var cbs = pendingQueue;
        pendingQueue = [];
        cbs.forEach(cb);
      };
      var cycle = function cycle() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function push(x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function filter(_filter) {
          pendingQueue = pendingQueue.filter(_filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI$1;
  }
  return innerCreateMedium$1(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium$1(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium$1(null);
  medium.options = _assign({
    async: true,
    ssr: false
  }, options);
  return medium;
}

var mediumFocus = createMedium({}, function (_ref) {
  var target = _ref.target,
    currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = createMedium();
var mediumEffect = createMedium();
var mediumSidecar = createSidecarMedium$1({
  async: true,
  ssr: typeof document !== 'undefined'
});

var focusScope = /*#__PURE__*/createContext$2(undefined);

var emptyArray = [];
var FocusLock$1 = /*#__PURE__*/forwardRef$1(function FocusLockUI(props, parentRef) {
  var _extends2;
  var _useState = useState(),
    realObserved = _useState[0],
    setObserved = _useState[1];
  var observed = useRef();
  var isActive = useRef(false);
  var originalFocusedElement = useRef(null);
  var _useState2 = useState({}),
    update = _useState2[1];
  var children = props.children,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$noFocusGuards = props.noFocusGuards,
    noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards,
    _props$persistentFocu = props.persistentFocus,
    persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu,
    _props$crossFrame = props.crossFrame,
    crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
    allowTextSelection = props.allowTextSelection,
    group = props.group,
    className = props.className,
    whiteList = props.whiteList,
    hasPositiveIndices = props.hasPositiveIndices,
    _props$shards = props.shards,
    shards = _props$shards === void 0 ? emptyArray : _props$shards,
    _props$as = props.as,
    Container = _props$as === void 0 ? 'div' : _props$as,
    _props$lockProps = props.lockProps,
    containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
    SideCar = props.sideCar,
    _props$returnFocus = props.returnFocus,
    shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus,
    focusOptions = props.focusOptions,
    onActivationCallback = props.onActivation,
    onDeactivationCallback = props.onDeactivation;
  var _useState3 = useState({}),
    id = _useState3[0];
  var onActivation = useCallback(function (_ref) {
    var captureFocusRestore = _ref.captureFocusRestore;
    if (!originalFocusedElement.current) {
      var _document;
      var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
      originalFocusedElement.current = activeElement;
      if (activeElement !== document.body) {
        originalFocusedElement.current = captureFocusRestore(activeElement);
      }
    }
    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }
    isActive.current = true;
    update();
  }, [onActivationCallback]);
  var onDeactivation = useCallback(function () {
    isActive.current = false;
    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
    update();
  }, [onDeactivationCallback]);
  var returnFocus = useCallback(function (allowDefer) {
    var focusRestore = originalFocusedElement.current;
    if (focusRestore) {
      var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
      var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
      if (howToReturnFocus) {
        var returnFocusOptions = _typeof$1(howToReturnFocus) === 'object' ? howToReturnFocus : undefined;
        originalFocusedElement.current = null;
        if (allowDefer) {
          Promise.resolve().then(function () {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]);
  var onFocus = useCallback(function (event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur = mediumBlur.useMedium;
  var setObserveNode = useCallback(function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof allowTextSelection !== 'undefined') {
      console.warn('React-Focus-Lock: allowTextSelection is deprecated and enabled by default');
    }
    useEffect(function () {
      if (!observed.current && typeof Container !== 'string') {
        console.error('FocusLock: could not obtain ref to internal node');
      }
    }, []);
  }
  var lockProps = _extends$6((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);
  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = useMergeRefs$1([parentRef, setObserveNode]);
  var focusScopeValue = useMemo(function () {
    return {
      observed: observed,
      shards: shards,
      enabled: !disabled,
      active: isActive.current
    };
  }, [disabled, isActive.current, shards, realObserved]);
  return /*#__PURE__*/React__default.createElement(Fragment, null, hasLeadingGuards && [/*#__PURE__*/
  React__default.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }), hasPositiveIndices ? /*#__PURE__*/React__default.createElement("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: hiddenGuard
  }) : null], !disabled && /*#__PURE__*/React__default.createElement(SideCar, {
    id: id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    crossFrame: crossFrame,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus,
    focusOptions: focusOptions,
    noFocusGuards: noFocusGuards
  }), /*#__PURE__*/React__default.createElement(Container, _extends$6({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), /*#__PURE__*/React__default.createElement(focusScope.Provider, {
    value: focusScopeValue
  }, children)), hasTailingGuards && /*#__PURE__*/React__default.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock$1.propTypes = process.env.NODE_ENV !== "production" ? {
  children: node$1,
  disabled: bool,
  returnFocus: oneOfType([bool, object, func]),
  focusOptions: object,
  noFocusGuards: bool,
  hasPositiveIndices: bool,
  allowTextSelection: bool,
  autoFocus: bool,
  persistentFocus: bool,
  crossFrame: bool,
  group: string,
  className: string,
  whiteList: func,
  shards: arrayOf(any),
  as: oneOfType([string, func, object]),
  lockProps: object,
  onActivation: func,
  onDeactivation: func,
  sideCar: any.isRequired
} : {};

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint);
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (String )(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}

function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof reducePropsToState !== 'function') {
      throw new Error('Expected reducePropsToState to be a function.');
    }
    if (typeof handleStateChangeOnClient !== 'function') {
      throw new Error('Expected handleStateChangeOnClient to be a function.');
    }
  }
  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }
  return function wrap(WrappedComponent) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof WrappedComponent !== 'function') {
        throw new Error('Expected WrappedComponent to be a React component.');
      }
    }
    var mountedInstances = [];
    var state;
    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }
    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);
      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };
      var _proto = SideEffect.prototype;
      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };
      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };
      _proto.render = function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      };
      return SideEffect;
    }(PureComponent);
    _defineProperty$2(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
    return SideEffect;
  };
}

/*
IE11 support
 */
var toArray = function toArray(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; ++i) {
    ret[i] = a[i];
  }
  return ret;
};
var asArray = function asArray(a) {
  return Array.isArray(a) ? a : [a];
};
var getFirst = function getFirst(a) {
  return Array.isArray(a) ? a[0] : a;
};

var isElementHidden = function isElementHidden(node) {
  // we can measure only "elements"
  // consider others as "visible"
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return false;
  }
  var computedStyle = window.getComputedStyle(node, null);
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var getParentNode$1 = function getParentNode(node) {
  // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
  return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ?
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  node.parentNode.host : node.parentNode;
};
var isTopNode = function isTopNode(node) {
  // @ts-ignore
  return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var isInert = function isInert(node) {
  return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */
var isVisibleUncached = function isVisibleUncached(node, checkParent) {
  return !node || isTopNode(node) || !isElementHidden(node) && !isInert(node) && checkParent(getParentNode$1(node));
};
var _isVisibleCached = function isVisibleCached(visibilityCache, node) {
  var cached = visibilityCache.get(node);
  if (cached !== undefined) {
    return cached;
  }
  var result = isVisibleUncached(node, _isVisibleCached.bind(undefined, visibilityCache));
  visibilityCache.set(node, result);
  return result;
};
var isAutoFocusAllowedUncached = function isAutoFocusAllowedUncached(node, checkParent) {
  return node && !isTopNode(node) ? isAutoFocusAllowed(node) ? checkParent(getParentNode$1(node)) : false : true;
};
var _isAutoFocusAllowedCached = function isAutoFocusAllowedCached(cache, node) {
  var cached = cache.get(node);
  if (cached !== undefined) {
    return cached;
  }
  var result = isAutoFocusAllowedUncached(node, _isAutoFocusAllowedCached.bind(undefined, cache));
  cache.set(node, result);
  return result;
};
var getDataset = function getDataset(node) {
  // @ts-ignore
  return node.dataset;
};
var isHTMLButtonElement = function isHTMLButtonElement(node) {
  return node.tagName === 'BUTTON';
};
var isHTMLInputElement = function isHTMLInputElement(node) {
  return node.tagName === 'INPUT';
};
var isRadioElement = function isRadioElement(node) {
  return isHTMLInputElement(node) && node.type === 'radio';
};
var notHiddenInput = function notHiddenInput(node) {
  return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
};
var isAutoFocusAllowed = function isAutoFocusAllowed(node) {
  var attribute = node.getAttribute(FOCUS_NO_AUTOFOCUS);
  return ![true, 'true', ''].includes(attribute);
};
var isGuard = function isGuard(node) {
  var _a;
  return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var isNotAGuard = function isNotAGuard(node) {
  return !isGuard(node);
};
var isDefined = function isDefined(x) {
  return Boolean(x);
};

var tabSort = function tabSort(a, b) {
  var aTab = Math.max(0, a.tabIndex);
  var bTab = Math.max(0, b.tabIndex);
  var tabDiff = aTab - bTab;
  var indexDiff = a.index - b.index;
  if (tabDiff) {
    if (!aTab) {
      return 1;
    }
    if (!bTab) {
      return -1;
    }
  }
  return tabDiff || indexDiff;
};
var getTabIndex = function getTabIndex(node) {
  if (node.tabIndex < 0) {
    // all "focusable" elements are already preselected
    // but some might have implicit negative tabIndex
    // return 0 for <audio without tabIndex attribute - it is "tabbable"
    if (!node.hasAttribute('tabindex')) {
      return 0;
    }
  }
  return node.tabIndex;
};
var orderByTabIndex = function orderByTabIndex(nodes, filterNegative, keepGuards) {
  return toArray(nodes).map(function (node, index) {
    var tabIndex = getTabIndex(node);
    return {
      node: node,
      index: index,
      tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
    };
  }).filter(function (data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};

/**
 * list of the object to be considered as focusable
 */
var tabbables = ['button:enabled', 'select:enabled', 'textarea:enabled', 'input:enabled',
// elements with explicit roles will also use explicit tabindex
// '[role="button"]',
'a[href]', 'area[href]', 'summary', 'iframe', 'object', 'embed', 'audio[controls]', 'video[controls]', '[tabindex]', '[contenteditable]', '[autofocus]'];

var queryTabbables = tabbables.join(',');
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var _getFocusablesWithShadowDom = function getFocusablesWithShadowDom(parent, withGuards) {
  return toArray((parent.shadowRoot || parent).children).reduce(function (acc, child) {
    return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], _getFocusablesWithShadowDom(child));
  }, []);
};
var getFocusablesWithIFrame = function getFocusablesWithIFrame(parent, withGuards) {
  var _a;
  // contentDocument of iframe will be null if current origin cannot access it
  if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
    return getFocusables([parent.contentDocument.body], withGuards);
  }
  return [parent];
};
var getFocusables = function getFocusables(parents, withGuards) {
  return parents.reduce(function (acc, parent) {
    var _a;
    var focusableWithShadowDom = _getFocusablesWithShadowDom(parent, withGuards);
    var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function (node) {
      return getFocusablesWithIFrame(node, withGuards);
    }));
    return acc.concat(
    // add all tabbables inside and within shadow DOMs in DOM order
    focusableWithIframes,
    // add if node is tabbable itself
    parent.parentNode ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function (node) {
      return node === parent;
    }) : []);
  }, []);
};
/**
 * return a list of focusable nodes within an area marked as "auto-focusable"
 * @param parent
 */
var getParentAutofocusables = function getParentAutofocusables(parent) {
  var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
  return toArray(parentFocus).map(function (node) {
    return getFocusables([node]);
  }).reduce(function (acc, nodes) {
    return acc.concat(nodes);
  }, []);
};

/**
 * given list of focusable elements keeps the ones user can interact with
 * @param nodes
 * @param visibilityCache
 */
var filterFocusable = function filterFocusable(nodes, visibilityCache) {
  return toArray(nodes).filter(function (node) {
    return _isVisibleCached(visibilityCache, node);
  }).filter(function (node) {
    return notHiddenInput(node);
  });
};
var filterAutoFocusable = function filterAutoFocusable(nodes, cache) {
  if (cache === void 0) {
    cache = new Map();
  }
  return toArray(nodes).filter(function (node) {
    return _isAutoFocusAllowedCached(cache, node);
  });
};
/**
 * !__WARNING__! Low level API.
 * @returns all tabbable nodes
 *
 * @see {@link getFocusableNodes} to get any focusable element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getTabbableNodes = function getTabbableNodes(topNodes, visibilityCache, withGuards) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
/**
 * !__WARNING__! Low level API.
 *
 * @returns anything "focusable", not only tabbable. The difference is in `tabIndex=-1`
 * (without guards, as long as they are not expected to be ever focused)
 *
 * @see {@link getTabbableNodes} to get only tabble nodes element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getFocusableNodes = function getFocusableNodes(topNodes, visibilityCache) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
/**
 * return list of nodes which are expected to be auto-focused
 * @param topNode
 * @param visibilityCache
 */
var parentAutofocusables = function parentAutofocusables(topNode, visibilityCache) {
  return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
/*
 * Determines if element is contained in scope, including nested shadow DOMs
 */
var _contains = function contains(scope, element) {
  if (scope.shadowRoot) {
    return _contains(scope.shadowRoot, element);
  } else {
    if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) {
      return true;
    }
    return toArray(scope.children).some(function (child) {
      var _a;
      if (child instanceof HTMLIFrameElement) {
        var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
        if (iframeBody) {
          return _contains(iframeBody, element);
        }
        return false;
      }
      return _contains(child, element);
    });
  }
};

/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */
var filterNested = function filterNested(nodes) {
  var contained = new Set();
  var l = nodes.length;
  for (var i = 0; i < l; i += 1) {
    for (var j = i + 1; j < l; j += 1) {
      var position = nodes[i].compareDocumentPosition(nodes[j]);
      /* eslint-disable no-bitwise */
      if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
        contained.add(j);
      }
      if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
        contained.add(i);
      }
      /* eslint-enable */
    }
  }
  return nodes.filter(function (_, index) {
    return !contained.has(index);
  });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */
var _getTopParent = function getTopParent(node) {
  return node.parentNode ? _getTopParent(node.parentNode) : node;
};
/**
 * returns all "focus containers" inside a given node
 * @param node - node or nodes to look inside
 * @returns Element[]
 */
var getAllAffectedNodes = function getAllAffectedNodes(node) {
  var nodes = asArray(node);
  return nodes.filter(Boolean).reduce(function (acc, currentNode) {
    var group = currentNode.getAttribute(FOCUS_GROUP);
    acc.push.apply(acc, group ? filterNested(toArray(_getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, "=\"").concat(group, "\"]:not([").concat(FOCUS_DISABLED, "=\"disabled\"])")))) : [currentNode]);
    return acc;
  }, []);
};

var safeProbe = function safeProbe(cb) {
  try {
    return cb();
  } catch (e) {
    return undefined;
  }
};

/**
 * returns active element from document or from nested shadowdoms
 */
/**
 * returns current active element. If the active element is a "container" itself(shadowRoot or iframe) returns active element inside it
 * @param [inDocument]
 */
var _getActiveElement = function getActiveElement(inDocument) {
  if (inDocument === void 0) {
    inDocument = document;
  }
  if (!inDocument || !inDocument.activeElement) {
    return undefined;
  }
  var activeElement = inDocument.activeElement;
  return activeElement.shadowRoot ? _getActiveElement(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && safeProbe(function () {
    return activeElement.contentWindow.document;
  }) ? _getActiveElement(activeElement.contentWindow.document) : activeElement;
};

var focusInFrame = function focusInFrame(frame, activeElement) {
  return frame === activeElement;
};
var focusInsideIframe = function focusInsideIframe(topNode, activeElement) {
  return Boolean(toArray(topNode.querySelectorAll('iframe')).some(function (node) {
    return focusInFrame(node, activeElement);
  }));
};
/**
 * @returns {Boolean} true, if the current focus is inside given node or nodes.
 * Supports nodes hidden inside shadowDom
 */
var focusInside = function focusInside(topNode, activeElement) {
  // const activeElement = document && getActiveElement();
  if (activeElement === void 0) {
    activeElement = _getActiveElement(getFirst(topNode).ownerDocument);
  }
  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return getAllAffectedNodes(topNode).some(function (node) {
    return _contains(node, activeElement) || focusInsideIframe(node, activeElement);
  });
};

/**
 * checks if focus is hidden FROM the focus-lock
 * ie contained inside a node focus-lock shall ignore
 *
 * This is a utility function coupled with {@link FOCUS_ALLOW} constant
 *
 * @returns {boolean} focus is currently is in "allow" area
 */
var focusIsHidden = function focusIsHidden(inDocument) {
  if (inDocument === void 0) {
    inDocument = document;
  }
  var activeElement = _getActiveElement(inDocument);
  if (!activeElement) {
    return false;
  }
  // this does not support setting FOCUS_ALLOW within shadow dom
  return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function (node) {
    return _contains(node, activeElement);
  });
};

var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(isRadioElement).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};
var correctNode = function correctNode(node, nodes) {
  if (isRadioElement(node) && node.name) {
    return findSelectedRadio(node, nodes);
  }
  return node;
};
/**
 * giving a set of radio inputs keeps only selected (tabbable) ones
 * @param nodes
 */
var correctNodes = function correctNodes(nodes) {
  // IE11 has no Set(array) constructor
  var resultSet = new Set();
  nodes.forEach(function (node) {
    return resultSet.add(correctNode(node, nodes));
  });
  // using filter to support IE11
  return nodes.filter(function (node) {
    return resultSet.has(node);
  });
};

var pickFirstFocus = function pickFirstFocus(nodes) {
  if (nodes[0] && nodes.length > 1) {
    return correctNode(nodes[0], nodes);
  }
  return nodes[0];
};
var pickFocusable = function pickFocusable(nodes, node) {
  return nodes.indexOf(correctNode(node, nodes));
};

var NEW_FOCUS = 'NEW_FOCUS';
/**
 * Main solver for the "find next focus" question
 * @param innerNodes - used to control "return focus"
 * @param innerTabbables - used to control "autofocus"
 * @param outerNodes
 * @param activeElement
 * @param lastNode
 * @returns {number|string|undefined|*}
 */
var newFocus = function newFocus(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];
  var isOnGuard = isGuard(activeElement);
  // focus is inside
  if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
    return undefined;
  }
  var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
  var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
  var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
  // no active focus (or focus is on the body)
  if (activeIndex === -1) {
    // known fallback
    if (lastNodeInside !== -1) {
      return lastNodeInside;
    }
    return NEW_FOCUS;
  }
  // new focus, nothing to calculate
  if (lastNodeInside === -1) {
    return NEW_FOCUS;
  }
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);
  var correctedNodes = correctNodes(outerNodes);
  var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
  var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
  var tabbableNodes = correctedNodes.filter(function (node) {
    return node.tabIndex >= 0;
  });
  var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
  var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
  var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ?
  // old/new are tabbables, measure distance in tabbable space
  previousTabbableIndex - currentTabbableIndex :
  // or else measure in focusable space
  previousFocusableIndex - currentFocusableIndex;
  // old focus
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  // no tabbable elements, autofocus is not possible
  if (innerTabbables.length === 0) {
    // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
  }
  var returnFirstNode = pickFocusable(innerNodes, innerTabbables[0]);
  var returnLastNode = pickFocusable(innerNodes, innerTabbables[innerTabbables.length - 1]);
  // first element
  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnLastNode;
  }
  // last element
  if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnFirstNode;
  }
  // jump out, but not on the guard
  if (indexDiff && Math.abs(focusIndexDiff) > 1) {
    return lastNodeInside;
  }
  // focus above lock
  if (activeIndex <= firstNodeIndex) {
    return returnLastNode;
  }
  // focus below lock
  if (activeIndex > lastNodeIndex) {
    return returnFirstNode;
  }
  // index is inside tab order, but outside Lock
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  // do nothing
  return undefined;
};

var findAutoFocused = function findAutoFocused(autoFocusables) {
  return function (node) {
    var _a;
    var autofocus = (_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
    return (
      // @ts-expect-error
      node.autofocus ||
      //
      autofocus !== undefined && autofocus !== 'false' ||
      //
      autoFocusables.indexOf(node) >= 0
    );
  };
};
var pickAutofocus = function pickAutofocus(nodesIndexes, orderedNodes, groups) {
  var nodes = nodesIndexes.map(function (_a) {
    var node = _a.node;
    return node;
  });
  var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
  if (autoFocusable && autoFocusable.length) {
    return pickFirstFocus(autoFocusable);
  }
  return pickFirstFocus(filterAutoFocusable(orderedNodes));
};

var _getParents = function getParents(node, parents) {
  if (parents === void 0) {
    parents = [];
  }
  parents.push(node);
  if (node.parentNode) {
    _getParents(node.parentNode.host || node.parentNode, parents);
  }
  return parents;
};
/**
 * finds a parent for both nodeA and nodeB
 * @param nodeA
 * @param nodeB
 * @returns {boolean|*}
 */
var getCommonParent = function getCommonParent(nodeA, nodeB) {
  var parentsA = _getParents(nodeA);
  var parentsB = _getParents(nodeB);
  // tslint:disable-next-line:prefer-for-of
  for (var i = 0; i < parentsA.length; i += 1) {
    var currentParent = parentsA[i];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};
var getTopCommonParent = function getTopCommonParent(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = asArray(baseActiveElement);
  var leftEntries = asArray(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = false;
  leftEntries.filter(Boolean).forEach(function (entry) {
    topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function (subEntry) {
      var common = getCommonParent(activeElement, subEntry);
      if (common) {
        if (!topCommon || _contains(common, topCommon)) {
          topCommon = common;
        } else {
          topCommon = getCommonParent(common, topCommon);
        }
      }
    });
  });
  // TODO: add assert here?
  return topCommon;
};
/**
 * return list of nodes which are expected to be autofocused inside a given top nodes
 * @param entries
 * @param visibilityCache
 */
var allParentAutofocusables = function allParentAutofocusables(entries, visibilityCache) {
  return entries.reduce(function (acc, node) {
    return acc.concat(parentAutofocusables(node, visibilityCache));
  }, []);
};

var reorderNodes = function reorderNodes(srcNodes, dstNodes) {
  var remap = new Map();
  // no Set(dstNodes) for IE11 :(
  dstNodes.forEach(function (entity) {
    return remap.set(entity.node, entity);
  });
  // remap to dstNodes
  return srcNodes.map(function (node) {
    return remap.get(node);
  }).filter(isDefined);
};
/**
 * contains the main logic of the `focus-lock` package.
 *
 * ! you probably dont need this function !
 *
 * given top node(s) and the last active element returns the element to be focused next
 * @returns element which should be focused to move focus inside
 * @param topNode
 * @param lastNode
 */
var focusSolver = function focusSolver(topNode, lastNode) {
  var activeElement = _getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
  var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
  var visibilityCache = new Map();
  var anyFocusable = getFocusableNodes(entries, visibilityCache);
  var innerElements = anyFocusable.filter(function (_a) {
    var node = _a.node;
    return isNotAGuard(node);
  });
  if (!innerElements[0]) {
    return undefined;
  }
  var outerNodes = getFocusableNodes([commonParent], visibilityCache).map(function (_a) {
    var node = _a.node;
    return node;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  // collect inner focusable and separately tabbables
  var innerFocusables = orderedInnerElements.map(function (_a) {
    var node = _a.node;
    return node;
  });
  var innerTabbable = orderedInnerElements.filter(function (_a) {
    var tabIndex = _a.tabIndex;
    return tabIndex >= 0;
  }).map(function (_a) {
    var node = _a.node;
    return node;
  });
  var newId = newFocus(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
  if (newId === NEW_FOCUS) {
    var focusNode =
    // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
    pickAutofocus(anyFocusable, innerTabbable, allParentAutofocusables(entries, visibilityCache)) || pickAutofocus(anyFocusable, innerFocusables, allParentAutofocusables(entries, visibilityCache));
    if (focusNode) {
      return {
        node: focusNode
      };
    } else {
      console.warn('focus-lock: cannot find any node to move focus into');
      return undefined;
    }
  }
  if (newId === undefined) {
    return newId;
  }
  return orderedInnerElements[newId];
};

/**
 * traverses all related nodes (including groups) returning a list of all nodes(outer and internal) with meta information
 * This is low-level API!
 * @returns list of focusable elements inside a given top(!) node.
 * @see {@link getFocusableNodes} providing a simpler API
 */
var expandFocusableNodes = function expandFocusableNodes(topNode) {
  var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
  var commonParent = getTopCommonParent(topNode, topNode, entries);
  var outerNodes = orderByTabIndex(getFocusables([commonParent], true), true, true);
  var innerElements = getFocusables(entries, false);
  return outerNodes.map(function (_a) {
    var node = _a.node,
      index = _a.index;
    return {
      node: node,
      index: index,
      lockItem: innerElements.indexOf(node) >= 0,
      guard: isGuard(node)
    };
  });
};

var focusOn = function focusOn(target, focusOptions) {
  if (!target) {
    // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
  }
  if ('focus' in target) {
    target.focus(focusOptions);
  }
  if ('contentWindow' in target && target.contentWindow) {
    target.contentWindow.focus();
  }
};

var guardCount = 0;
var lockDisabled = false;
/**
 * The main functionality of the focus-lock package
 *
 * Contains focus at a given node.
 * The last focused element will help to determine which element(first or last) should be focused.
 * The found element will be focused.
 *
 * This is one time action (move), not a persistent focus-lock
 *
 * HTML markers (see {@link import('./constants').FOCUS_AUTO} constants) can control autofocus
 * @see {@link focusSolver} for the same functionality without autofocus
 */
var moveFocusInside = function moveFocusInside(topNode, lastNode, options) {
  if (options === void 0) {
    options = {};
  }
  var focusable = focusSolver(topNode, lastNode);
  // global local side effect to countain recursive lock activation and resolve focus-fighting
  if (lockDisabled) {
    return;
  }
  if (focusable) {
    /** +FOCUS-FIGHTING prevention **/
    if (guardCount > 2) {
      // we have recursive entered back the lock activation
      console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
      lockDisabled = true;
      setTimeout(function () {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node, options.focusOptions);
    guardCount--;
  }
};

function weakRef(value) {
  if (!value) return null;
  // #68 Safari 14.1 dont have it yet
  // FIXME: remove in 2025
  if (typeof WeakRef === 'undefined') {
    return function () {
      return value || null;
    };
  }
  var w = value ? new WeakRef(value) : null;
  return function () {
    return (w === null || w === void 0 ? void 0 : w.deref()) || null;
  };
}
var recordElementLocation = function recordElementLocation(element) {
  if (!element) {
    return null;
  }
  var stack = [];
  var currentElement = element;
  while (currentElement && currentElement !== document.body) {
    stack.push({
      current: weakRef(currentElement),
      parent: weakRef(currentElement.parentElement),
      left: weakRef(currentElement.previousElementSibling),
      right: weakRef(currentElement.nextElementSibling)
    });
    currentElement = currentElement.parentElement;
  }
  return {
    element: weakRef(element),
    stack: stack,
    ownerDocument: element.ownerDocument
  };
};
var restoreFocusTo = function restoreFocusTo(location) {
  var _a, _b, _c, _d, _e;
  if (!location) {
    return undefined;
  }
  var stack = location.stack,
    ownerDocument = location.ownerDocument;
  var visibilityCache = new Map();
  for (var _i = 0, stack_1 = stack; _i < stack_1.length; _i++) {
    var line = stack_1[_i];
    var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
    // is it still here?
    if (parent_1 && ownerDocument.contains(parent_1)) {
      var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
      var savedCurrent = line.current();
      var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
      var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
      var focusables = getTabbableNodes([parent_1], visibilityCache);
      var aim =
      // that is element itself
      (_e = (_d = current !== null && current !== void 0 ? current :
      // or something in it's place
      left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d :
      // or somebody to the right, still close enough
      right) !== null && _e !== void 0 ? _e :
      // or somebody to the left, something?
      left;
      while (aim) {
        for (var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++) {
          var focusable = focusables_1[_f];
          if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) {
            return focusable.node;
          }
        }
        aim = aim.nextElementSibling;
      }
      if (focusables.length) {
        // if parent contains a focusable - move there
        return focusables[0].node;
      }
    }
  }
  // nothing matched
  return undefined;
};
/**
 * Captures the current focused element to restore focus as close as possible in the future
 * Handles situations where the focused element is removed from the DOM or no longer focusable
 * moving focus to the closest focusable element
 * @param targetElement - element where focus should be restored
 * @returns a function returning a new element to focus
 */
var captureFocusRestore = function captureFocusRestore(targetElement) {
  var location = recordElementLocation(targetElement);
  return function () {
    return restoreFocusTo(location);
  };
};

/**
 * for a given `element` in a given `scope` returns focusable siblings
 * @param element - base element
 * @param scope - common parent. Can be document, but better to narrow it down for performance reasons
 * @returns {prev,next} - references to a focusable element before and after
 * @returns undefined - if operation is not applicable
 */
var getRelativeFocusable = function getRelativeFocusable(element, scope, useTabbables) {
  if (!element || !scope) {
    console.error('no element or scope given');
    return {};
  }
  var shards = asArray(scope);
  if (shards.every(function (shard) {
    return !_contains(shard, element);
  })) {
    console.error('Active element is not contained in the scope');
    return {};
  }
  var focusables = useTabbables ? getTabbableNodes(shards, new Map()) : getFocusableNodes(shards, new Map());
  var current = focusables.findIndex(function (_a) {
    var node = _a.node;
    return node === element;
  });
  if (current === -1) {
    // an edge case, when anchor element is not found
    return undefined;
  }
  return {
    prev: focusables[current - 1],
    next: focusables[current + 1],
    first: focusables[0],
    last: focusables[focusables.length - 1]
  };
};
var getBoundary = function getBoundary(shards, useTabbables) {
  var set = useTabbables ? getTabbableNodes(asArray(shards), new Map()) : getFocusableNodes(asArray(shards), new Map());
  return {
    first: set[0],
    last: set[set.length - 1]
  };
};
var defaultOptions$1 = function defaultOptions(options) {
  return Object.assign({
    scope: document.body,
    cycle: true,
    onlyTabbable: true
  }, options);
};
var moveFocus = function moveFocus(fromElement, options, cb) {
  if (options === void 0) {
    options = {};
  }
  var newOptions = defaultOptions$1(options);
  var solution = getRelativeFocusable(fromElement, newOptions.scope, newOptions.onlyTabbable);
  if (!solution) {
    return;
  }
  var target = cb(solution, newOptions.cycle);
  if (target) {
    focusOn(target.node, newOptions.focusOptions);
  }
};
/**
 * focuses next element in the tab-order
 * @param fromElement - common parent to scope active element search or tab cycle order
 * @param {FocusNextOptions} [options] - focus options
 */
var focusNextElement = function focusNextElement(fromElement, options) {
  if (options === void 0) {
    options = {};
  }
  moveFocus(fromElement, options, function (_a, cycle) {
    var next = _a.next,
      first = _a.first;
    return next || cycle && first;
  });
};
/**
 * focuses prev element in the tab order
 * @param fromElement - common parent to scope active element search or tab cycle order
 * @param {FocusNextOptions} [options] - focus options
 */
var focusPrevElement = function focusPrevElement(fromElement, options) {
  if (options === void 0) {
    options = {};
  }
  moveFocus(fromElement, options, function (_a, cycle) {
    var prev = _a.prev,
      last = _a.last;
    return prev || cycle && last;
  });
};
var pickBoundary = function pickBoundary(scope, options, what) {
  var _a;
  var boundary = getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
  var node = boundary[what];
  if (node) {
    focusOn(node.node, options.focusOptions);
  }
};
/**
 * focuses first element in the tab-order
 * @param {FocusNextOptions} options - focus options
 */
var focusFirstElement = function focusFirstElement(scope, options) {
  if (options === void 0) {
    options = {};
  }
  pickBoundary(scope, options, 'first');
};
/**
 * focuses last element in the tab order
 * @param {FocusNextOptions} options - focus options
 */
var focusLastElement = function focusLastElement(scope, options) {
  if (options === void 0) {
    options = {};
  }
  pickBoundary(scope, options, 'last');
};

function deferAction(action) {
  setTimeout(action, 1);
}
var extractRef$1 = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};
var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || focusIsHidden();
};
var lastActiveTrap = null;
var lastActiveFocus = null;
var tryRestoreFocus = function tryRestoreFocus() {
  return null;
};
var lastPortaledElement = null;
var focusWasOutsideWindow = false;
var windowFocused = false;
var defaultWhitelist = function defaultWhitelist() {
  return true;
};
var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};
var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};
var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};
function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;
  do {
    var item = allNodes[i];
    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        return;
      }
      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);
  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}
var focusWasOutside = function focusWasOutside(crossFrameOption) {
  if (crossFrameOption) {
    return Boolean(focusWasOutsideWindow);
  }
  return focusWasOutsideWindow === 'meanwhile';
};
var checkInHost = function checkInHost(check, el, boundary) {
  return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var withinHost = function withinHost(activeElement, workingArea) {
  return workingArea.some(function (area) {
    return checkInHost(activeElement, area, area);
  });
};
var getNodeFocusables = function getNodeFocusables(nodes) {
  return getFocusableNodes(nodes, new Map());
};
var isNotFocusable = function isNotFocusable(node) {
  return !getNodeFocusables([node.parentNode]).some(function (el) {
    return el.node === node;
  });
};
var activateTrap = function activateTrap() {
  var result = false;
  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
      observed = _lastActiveTrap.observed,
      persistentFocus = _lastActiveTrap.persistentFocus,
      autoFocus = _lastActiveTrap.autoFocus,
      shards = _lastActiveTrap.shards,
      crossFrame = _lastActiveTrap.crossFrame,
      focusOptions = _lastActiveTrap.focusOptions,
      noFocusGuards = _lastActiveTrap.noFocusGuards;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    if (focusOnBody() && lastActiveFocus && lastActiveFocus !== document.body) {
      if (!document.body.contains(lastActiveFocus) || isNotFocusable(lastActiveFocus)) {
        var newTarget = tryRestoreFocus();
        if (newTarget) {
          newTarget.focus();
        }
      }
    }
    var activeElement = document && document.activeElement;
    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef$1).filter(Boolean));
      var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
        if (!focusWasOutside(crossFrame) || !noFocusGuards || !lastActiveFocus || windowFocused) {
          return false;
        }
        var nodes = getNodeFocusables(workingArea);
        var lastIndex = nodes.findIndex(function (_ref) {
          var node = _ref.node;
          return node === lastActiveFocus;
        });
        return lastIndex === 0 || lastIndex === nodes.length - 1;
      };
      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || shouldForceRestoreFocus() || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(focusInside(workingArea) || activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              if (activeElement.blur) {
                activeElement.blur();
              }
              document.body.focus();
            } else {
              result = moveFocusInside(workingArea, lastActiveFocus, {
                focusOptions: focusOptions
              });
              lastPortaledElement = {};
            }
          }
          lastActiveFocus = document && document.activeElement;
          if (lastActiveFocus !== document.body) {
            tryRestoreFocus = captureFocusRestore(lastActiveFocus);
          }
          focusWasOutsideWindow = false;
        }
      }
      if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
        var newActiveElement = document && document.activeElement;
        var allNodes = expandFocusableNodes(workingArea);
        var focusedIndex = allNodes.map(function (_ref2) {
          var node = _ref2.node;
          return node;
        }).indexOf(newActiveElement);
        if (focusedIndex > -1) {
          allNodes.filter(function (_ref3) {
            var guard = _ref3.guard,
              node = _ref3.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref4) {
            var node = _ref4.node;
            return node.removeAttribute('tabIndex');
          });
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }
  return result;
};
var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    event.stopPropagation();
    event.preventDefault();
  }
};
var onBlur = function onBlur() {
  return deferAction(activateTrap);
};
var onFocus = function onFocus(event) {
  var source = event.target;
  var currentNode = event.currentTarget;
  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};
var FocusWatcher = function FocusWatcher() {
  return null;
};
process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};
var onWindowFocus = function onWindowFocus() {
  windowFocused = true;
};
var onWindowBlur = function onWindowBlur() {
  windowFocused = false;
  focusWasOutsideWindow = 'just';
  deferAction(function () {
    focusWasOutsideWindow = 'meanwhile';
  });
};
var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('focus', onWindowFocus);
  window.addEventListener('blur', onWindowBlur);
};
var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('focus', onWindowFocus);
  window.removeEventListener('blur', onWindowBlur);
};
function reducePropsToState(propsList) {
  return propsList.filter(function (_ref6) {
    var disabled = _ref6.disabled;
    return !disabled;
  });
}
var focusLockAPI = {
  moveFocusInside: moveFocusInside,
  focusInside: focusInside,
  focusNextElement: focusNextElement,
  focusPrevElement: focusPrevElement,
  focusFirstElement: focusFirstElement,
  focusLastElement: focusLastElement,
  captureFocusRestore: captureFocusRestore
};
function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];
  if (trap && !lastActiveTrap) {
    attachHandler();
  }
  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;
  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
    if (!traps.filter(function (_ref7) {
      var id = _ref7.id;
      return id === lastTrap.id;
    }).length) {
      lastTrap.returnFocus(!trap);
    }
  }
  if (trap) {
    lastActiveFocus = null;
    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation(focusLockAPI);
    }
    activateTrap();
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function (cb) {
  return cb(focusLockAPI);
});
var FocusTrap$1 = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

var FocusLockCombination = /*#__PURE__*/forwardRef$1(function FocusLockUICombination(props, ref) {
  return /*#__PURE__*/React__default.createElement(FocusLock$1, _extends$6({
    sideCar: FocusTrap$1,
    ref: ref
  }, props));
});
var _ref$1 = FocusLock$1.propTypes || {};
  _ref$1.sideCar;
  var propTypes = _objectWithoutPropertiesLoose(_ref$1, ["sideCar"]);
FocusLockCombination.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};

// src/dom.ts
function isElement$2(el) {
  return el != null && _typeof$1(el) == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function isHTMLElement$2(el) {
  var _a;
  if (!isElement$2(el)) return false;
  var win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
  return el instanceof win.HTMLElement;
}
function getOwnerWindow(node) {
  var _a, _b;
  return (_b = (_a = getOwnerDocument$2(node)) == null ? void 0 : _a.defaultView) != null ? _b : window;
}
function getOwnerDocument$2(node) {
  return isElement$2(node) ? node.ownerDocument : document;
}
function getActiveElement(node) {
  return getOwnerDocument$2(node).activeElement;
}

// src/scroll.ts
function isScrollParent$1(el) {
  var win = el.ownerDocument.defaultView || window;
  var _win$getComputedStyle = win.getComputedStyle(el),
    overflow = _win$getComputedStyle.overflow,
    overflowX = _win$getComputedStyle.overflowX,
    overflowY = _win$getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getParent(el) {
  if (el.localName === "html") return el;
  return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function getScrollParent$2(el) {
  if (["html", "body", "#document"].includes(el.localName)) {
    return el.ownerDocument.body;
  }
  if (isHTMLElement$2(el) && isScrollParent$1(el)) {
    return el;
  }
  return getScrollParent$2(getParent(el));
}

var hasTabIndex = function hasTabIndex(element) {
  return element.hasAttribute("tabindex");
};
var hasNegativeTabIndex = function hasNegativeTabIndex(element) {
  return hasTabIndex(element) && element.tabIndex === -1;
};
function isDisabled(element) {
  return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function isHidden(element) {
  if (element.parentElement && isHidden(element.parentElement)) return true;
  return element.hidden;
}
function isContentEditable(element) {
  var value = element.getAttribute("contenteditable");
  return value !== "false" && value != null;
}
function isFocusable$1(element) {
  if (!isHTMLElement$2(element) || isHidden(element) || isDisabled(element)) {
    return false;
  }
  var localName = element.localName;
  var focusableTags = ["input", "select", "textarea", "button"];
  if (focusableTags.indexOf(localName) >= 0) return true;
  var others = {
    a: function a() {
      return element.hasAttribute("href");
    },
    audio: function audio() {
      return element.hasAttribute("controls");
    },
    video: function video() {
      return element.hasAttribute("controls");
    }
  };
  if (localName in others) {
    return others[localName]();
  }
  if (isContentEditable(element)) return true;
  return hasTabIndex(element);
}
function isTabbable(element) {
  if (!element) return false;
  return isHTMLElement$2(element) && isFocusable$1(element) && !hasNegativeTabIndex(element);
}

// src/index.ts
var focusableElList = ["input:not(:disabled):not([disabled])", "select:not(:disabled):not([disabled])", "textarea:not(:disabled):not([disabled])", "embed", "iframe", "object", "a[href]", "area[href]", "button:not(:disabled):not([disabled])", "[tabindex]", "audio[controls]", "video[controls]", "*[tabindex]:not([aria-disabled])", "*[contenteditable]"];
var focusableElSelector = focusableElList.join();
var isVisible = function isVisible(el) {
  return el.offsetWidth > 0 && el.offsetHeight > 0;
};
function getAllFocusable(container) {
  var focusableEls = Array.from(container.querySelectorAll(focusableElSelector));
  focusableEls.unshift(container);
  return focusableEls.filter(function (el) {
    return isFocusable$1(el) && isVisible(el);
  });
}

var _a;
var FocusTrap = (_a = FocusLockCombination["default"]) != null ? _a : FocusLockCombination;
var FocusLock = function FocusLock(props) {
  var initialFocusRef = props.initialFocusRef,
    finalFocusRef = props.finalFocusRef,
    contentRef = props.contentRef,
    restoreFocus = props.restoreFocus,
    children = props.children,
    isDisabled = props.isDisabled,
    autoFocus = props.autoFocus,
    persistentFocus = props.persistentFocus,
    lockFocusAcrossFrames = props.lockFocusAcrossFrames;
  var onActivation = useCallback(function () {
    if (initialFocusRef == null ? void 0 : initialFocusRef.current) {
      initialFocusRef.current.focus();
    } else if (contentRef == null ? void 0 : contentRef.current) {
      var focusables = getAllFocusable(contentRef.current);
      if (focusables.length === 0) {
        requestAnimationFrame(function () {
          var _a2;
          (_a2 = contentRef.current) == null ? void 0 : _a2.focus();
        });
      }
    }
  }, [initialFocusRef, contentRef]);
  var onDeactivation = useCallback(function () {
    var _a2;
    (_a2 = finalFocusRef == null ? void 0 : finalFocusRef.current) == null ? void 0 : _a2.focus();
  }, [finalFocusRef]);
  var returnFocus = restoreFocus && !finalFocusRef;
  return /* @__PURE__ */jsxRuntimeExports.jsx(FocusTrap, {
    crossFrame: lockFocusAcrossFrames,
    persistentFocus: persistentFocus,
    autoFocus: autoFocus,
    disabled: isDisabled,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus,
    children: children
  });
};
FocusLock.displayName = "FocusLock";

var useSafeLayoutEffect = isBrowser$5 ? useLayoutEffect : useEffect;

function useCallbackRef$1(fn) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ref = useRef(fn);
  useSafeLayoutEffect(function () {
    ref.current = fn;
  });
  return useCallback(function () {
    var _a2;
    var _a;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_a = ref.current) == null ? void 0 : (_a2 = _a).call.apply(_a2, [ref].concat(args));
  }, deps);
}

function useId(idProp, prefix) {
  var id = useId$1();
  return useMemo(function () {
    return idProp || [prefix, id].filter(Boolean).join("-");
  }, [idProp, prefix, id]);
}

function useControllableProp(prop, state) {
  var isControlled = prop !== void 0;
  var value = isControlled && typeof prop !== "undefined" ? prop : state;
  return [isControlled, value];
}
function useControllableState(props) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    onChange = props.onChange,
    _props$shouldUpdate = props.shouldUpdate,
    shouldUpdate = _props$shouldUpdate === void 0 ? function (prev, next) {
      return prev !== next;
    } : _props$shouldUpdate;
  var onChangeProp = useCallbackRef$1(onChange);
  var shouldUpdateProp = useCallbackRef$1(shouldUpdate);
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray$1(_useState, 2),
    valueState = _useState2[0],
    setValue = _useState2[1];
  var isControlled = valueProp !== void 0;
  var value = isControlled ? valueProp : valueState;
  var updateValue = useCallback(function (next) {
    var nextValue = runIfFn(next, value);
    if (!shouldUpdateProp(value, nextValue)) {
      return;
    }
    if (!isControlled) {
      setValue(nextValue);
    }
    onChangeProp(nextValue);
  }, [isControlled, onChangeProp, value, shouldUpdateProp]);
  return [value, updateValue];
}

function useDisclosure$1() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onCloseProp = props.onClose,
    onOpenProp = props.onOpen,
    isOpenProp = props.isOpen,
    idProp = props.id;
  var onOpenPropCallbackRef = useCallbackRef$1(onOpenProp);
  var onClosePropCallbackRef = useCallbackRef$1(onCloseProp);
  var _useState = useState(props.defaultIsOpen || false),
    _useState2 = _slicedToArray$1(_useState, 2),
    isOpenState = _useState2[0],
    setIsOpen = _useState2[1];
  var _useControllableProp = useControllableProp(isOpenProp, isOpenState),
    _useControllableProp2 = _slicedToArray$1(_useControllableProp, 2),
    isControlled = _useControllableProp2[0],
    isOpen = _useControllableProp2[1];
  var id = useId(idProp, "disclosure");
  var onClose = useCallback(function () {
    if (!isControlled) {
      setIsOpen(false);
    }
    onClosePropCallbackRef == null ? void 0 : onClosePropCallbackRef();
  }, [isControlled, onClosePropCallbackRef]);
  var onOpen = useCallback(function () {
    if (!isControlled) {
      setIsOpen(true);
    }
    onOpenPropCallbackRef == null ? void 0 : onOpenPropCallbackRef();
  }, [isControlled, onOpenPropCallbackRef]);
  var onToggle = useCallback(function () {
    var action = isOpen ? onClose : onOpen;
    action();
  }, [isOpen, onOpen, onClose]);
  return {
    isOpen: !!isOpen,
    onOpen: onOpen,
    onClose: onClose,
    onToggle: onToggle,
    isControlled: isControlled,
    getButtonProps: function getButtonProps() {
      var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
        "aria-expanded": isOpen,
        "aria-controls": id,
        onClick: callAllHandlers(props2.onClick, onToggle)
      });
    },
    getDisclosureProps: function getDisclosureProps() {
      var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
        hidden: !isOpen,
        id: id
      });
    }
  };
}

var toggleSelection;
var hasRequiredToggleSelection;
function requireToggleSelection() {
  if (hasRequiredToggleSelection) return toggleSelection;
  hasRequiredToggleSelection = 1;
  toggleSelection = function toggleSelection() {
    var selection = document.getSelection();
    if (!selection.rangeCount) {
      return function () {};
    }
    var active = document.activeElement;
    var ranges = [];
    for (var i = 0; i < selection.rangeCount; i++) {
      ranges.push(selection.getRangeAt(i));
    }
    switch (active.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case 'INPUT':
      case 'TEXTAREA':
        active.blur();
        break;
      default:
        active = null;
        break;
    }
    selection.removeAllRanges();
    return function () {
      selection.type === 'Caret' && selection.removeAllRanges();
      if (!selection.rangeCount) {
        ranges.forEach(function (range) {
          selection.addRange(range);
        });
      }
      active && active.focus();
    };
  };
  return toggleSelection;
}

var copyToClipboard;
var hasRequiredCopyToClipboard;
function requireCopyToClipboard() {
  if (hasRequiredCopyToClipboard) return copyToClipboard;
  hasRequiredCopyToClipboard = 1;
  var deselectCurrent = requireToggleSelection();
  var clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
  };
  var defaultMessage = "Copy to clipboard: #{key}, Enter";
  function format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
  }
  function copy(text, options) {
    var debug,
      message,
      reselectPrevious,
      range,
      selection,
      mark,
      success = false;
    if (!options) {
      options = {};
    }
    debug = options.debug || false;
    try {
      reselectPrevious = deselectCurrent();
      range = document.createRange();
      selection = document.getSelection();
      mark = document.createElement("span");
      mark.textContent = text;
      // avoid screen readers from reading out loud the text
      mark.ariaHidden = "true";
      // reset user styles for span element
      mark.style.all = "unset";
      // prevents scrolling to the end of the page
      mark.style.position = "fixed";
      mark.style.top = 0;
      mark.style.clip = "rect(0, 0, 0, 0)";
      // used to preserve spaces and line breaks
      mark.style.whiteSpace = "pre";
      // do not inherit user-select (it may be `none`)
      mark.style.webkitUserSelect = "text";
      mark.style.MozUserSelect = "text";
      mark.style.msUserSelect = "text";
      mark.style.userSelect = "text";
      mark.addEventListener("copy", function (e) {
        e.stopPropagation();
        if (options.format) {
          e.preventDefault();
          if (typeof e.clipboardData === "undefined") {
            // IE 11
            debug && console.warn("unable to use e.clipboardData");
            debug && console.warn("trying IE specific stuff");
            window.clipboardData.clearData();
            var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
            window.clipboardData.setData(format, text);
          } else {
            // all other browsers
            e.clipboardData.clearData();
            e.clipboardData.setData(options.format, text);
          }
        }
        if (options.onCopy) {
          e.preventDefault();
          options.onCopy(e.clipboardData);
        }
      });
      document.body.appendChild(mark);
      range.selectNodeContents(mark);
      selection.addRange(range);
      var successful = document.execCommand("copy");
      if (!successful) {
        throw new Error("copy command was unsuccessful");
      }
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using execCommand: ", err);
      debug && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(options.format || "text", text);
        options.onCopy && options.onCopy(window.clipboardData);
        success = true;
      } catch (err) {
        debug && console.error("unable to copy using clipboardData: ", err);
        debug && console.error("falling back to prompt");
        message = format("message" in options ? options.message : defaultMessage);
        window.prompt(message, text);
      }
    } finally {
      if (selection) {
        if (typeof selection.removeRange == "function") {
          selection.removeRange(range);
        } else {
          selection.removeAllRanges();
        }
      }
      if (mark) {
        document.body.removeChild(mark);
      }
      reselectPrevious();
    }
    return success;
  }
  copyToClipboard = copy;
  return copyToClipboard;
}

var copyToClipboardExports = requireCopyToClipboard();
var copy = /*@__PURE__*/getDefaultExportFromCjs(copyToClipboardExports);

var _excluded$1F = ["timeout"];
function useClipboard(value) {
  var optionsOrTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    hasCopied = _useState2[0],
    setHasCopied = _useState2[1];
  var _useState3 = useState(value),
    _useState4 = _slicedToArray$1(_useState3, 2),
    valueState = _useState4[0],
    setValueState = _useState4[1];
  useEffect(function () {
    return setValueState(value);
  }, [value]);
  var _ref = typeof optionsOrTimeout === "number" ? {
      timeout: optionsOrTimeout
    } : optionsOrTimeout,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? 1500 : _ref$timeout,
    copyOptions = _objectWithoutProperties$1(_ref, _excluded$1F);
  var onCopy = useCallback(function () {
    var didCopy = copy(valueState, copyOptions);
    setHasCopied(didCopy);
  }, [valueState, copyOptions]);
  useEffect(function () {
    var timeoutId = null;
    if (hasCopied) {
      timeoutId = window.setTimeout(function () {
        setHasCopied(false);
      }, timeout);
    }
    return function () {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [timeout, hasCopied]);
  return {
    value: valueState,
    setValue: setValueState,
    onCopy: onCopy,
    hasCopied: hasCopied
  };
}

var _excluded$1E = ["children", "className"];
var _createContext$b = createContext$1({
    name: "InputGroupStylesContext",
    errorMessage: "useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<InputGroup />\" "
  }),
  _createContext2$b = _slicedToArray$1(_createContext$b, 2),
  InputGroupStylesProvider = _createContext2$b[0],
  useInputGroupStyles = _createContext2$b[1];
var InputGroup = forwardRef(function InputGroup2(props, ref) {
  var styles = useMultiStyleConfig("Input", props);
  var _omitThemingProps = omitThemingProps(props),
    children = _omitThemingProps.children,
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$1E);
  var _className = cx("chakra-input__group", className);
  var groupStyles = {};
  var validChildren = getValidChildren(children);
  var input = styles.field;
  validChildren.forEach(function (child) {
    var _a, _b;
    if (!styles) return;
    if (input && child.type.id === "InputLeftElement") {
      groupStyles.paddingStart = (_a = input.height) != null ? _a : input.h;
    }
    if (input && child.type.id === "InputRightElement") {
      groupStyles.paddingEnd = (_b = input.height) != null ? _b : input.h;
    }
    if (child.type.id === "InputRightAddon") {
      groupStyles.borderEndRadius = 0;
    }
    if (child.type.id === "InputLeftAddon") {
      groupStyles.borderStartRadius = 0;
    }
  });
  var clones = validChildren.map(function (child) {
    var _a, _b;
    var theming = compact({
      size: ((_a = child.props) == null ? void 0 : _a.size) || props.size,
      variant: ((_b = child.props) == null ? void 0 : _b.variant) || props.variant
    });
    return child.type.id !== "Input" ? /*#__PURE__*/cloneElement(child, theming) : /*#__PURE__*/cloneElement(child, Object.assign(theming, groupStyles, child.props));
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    className: _className,
    ref: ref,
    __css: _objectSpread2$1({
      width: "100%",
      display: "flex",
      position: "relative",
      // Parts of inputs override z-index to ensure that they stack correctly on each other
      // Create a new stacking context so that these overrides don't leak out and conflict with other z-indexes
      isolation: "isolate"
    }, styles.group),
    "data-group": true
  }, rest), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx(InputGroupStylesProvider, {
      value: styles,
      children: clones
    })
  }));
});
InputGroup.displayName = "InputGroup";

var _excluded$1D = ["placement"];
var placements$1 = {
  left: {
    marginEnd: "-1px",
    borderEndRadius: 0,
    borderEndColor: "transparent"
  },
  right: {
    marginStart: "-1px",
    borderStartRadius: 0,
    borderStartColor: "transparent"
  }
};
var StyledAddon = chakra("div", {
  baseStyle: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  }
});
var InputAddon = forwardRef(function InputAddon2(props, ref) {
  var _a;
  var _props$placement = props.placement,
    placement = _props$placement === void 0 ? "left" : _props$placement,
    rest = _objectWithoutProperties$1(props, _excluded$1D);
  var placementStyles = (_a = placements$1[placement]) != null ? _a : {};
  var styles = useInputGroupStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(StyledAddon, _objectSpread2$1(_objectSpread2$1({
    ref: ref
  }, rest), {}, {
    __css: _objectSpread2$1(_objectSpread2$1({}, styles.addon), placementStyles)
  }));
});
InputAddon.displayName = "InputAddon";
var InputLeftAddon = forwardRef(function InputLeftAddon2(props, ref) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(InputAddon, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    placement: "left"
  }, props), {}, {
    className: cx("chakra-input__left-addon", props.className)
  }));
});
InputLeftAddon.displayName = "InputLeftAddon";
InputLeftAddon.id = "InputLeftAddon";
var InputRightAddon = forwardRef(function InputRightAddon2(props, ref) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(InputAddon, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    placement: "right"
  }, props), {}, {
    className: cx("chakra-input__right-addon", props.className)
  }));
});
InputRightAddon.displayName = "InputRightAddon";
InputRightAddon.id = "InputRightAddon";

var _excluded$1C = ["placement"],
  _excluded2$a = ["className"],
  _excluded3$4 = ["className"];
var StyledInputElement = chakra("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
});
var InputElement = forwardRef(function InputElement2(props, ref) {
  var _a, _b;
  var _props$placement = props.placement,
    placement = _props$placement === void 0 ? "left" : _props$placement,
    rest = _objectWithoutProperties$1(props, _excluded$1C);
  var styles = useInputGroupStyles();
  var input = styles.field;
  var attr = placement === "left" ? "insetStart" : "insetEnd";
  var elementStyles = _objectSpread2$1(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, attr, "0"), "width", (_a = input == null ? void 0 : input.height) != null ? _a : input == null ? void 0 : input.h), "height", (_b = input == null ? void 0 : input.height) != null ? _b : input == null ? void 0 : input.h), "fontSize", input == null ? void 0 : input.fontSize), styles.element);
  return /* @__PURE__ */jsxRuntimeExports.jsx(StyledInputElement, _objectSpread2$1({
    ref: ref,
    __css: elementStyles
  }, rest));
});
InputElement.id = "InputElement";
InputElement.displayName = "InputElement";
var InputLeftElement = forwardRef(function InputLeftElement2(props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded2$a);
  var _className = cx("chakra-input__left-element", className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(InputElement, _objectSpread2$1({
    ref: ref,
    placement: "left",
    className: _className
  }, rest));
});
InputLeftElement.id = "InputLeftElement";
InputLeftElement.displayName = "InputLeftElement";
var InputRightElement = forwardRef(function InputRightElement2(props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded3$4);
  var _className = cx("chakra-input__right-element", className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(InputElement, _objectSpread2$1({
    ref: ref,
    placement: "right",
    className: _className
  }, rest));
});
InputRightElement.id = "InputRightElement";
InputRightElement.displayName = "InputRightElement";

var _excluded$1B = ["htmlSize"];
var Input$3 = forwardRef(function Input2(props, ref) {
  var htmlSize = props.htmlSize,
    rest = _objectWithoutProperties$1(props, _excluded$1B);
  var styles = useMultiStyleConfig("Input", rest);
  var ownProps = omitThemingProps(rest);
  var input = useFormControl(ownProps);
  var _className = cx("chakra-input", props.className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.input, _objectSpread2$1(_objectSpread2$1({
    size: htmlSize
  }, input), {}, {
    __css: styles.field,
    ref: ref,
    className: _className
  }));
});
Input$3.displayName = "Input";
Input$3.id = "Input";

var _excluded$1A = ["className", "isExternal"];
var Link = forwardRef(function Link2(props, ref) {
  var styles = useStyleConfig("Link", props);
  var _omitThemingProps = omitThemingProps(props),
    className = _omitThemingProps.className,
    isExternal = _omitThemingProps.isExternal,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$1A);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.a, _objectSpread2$1(_objectSpread2$1({
    target: isExternal ? "_blank" : void 0,
    rel: isExternal ? "noopener" : void 0,
    ref: ref,
    className: cx("chakra-link", className)
  }, rest), {}, {
    __css: styles
  }));
});
Link.displayName = "Link";

var _excluded$1z = ["children", "styleType", "stylePosition", "spacing"],
  _excluded2$9 = ["as"],
  _excluded3$3 = ["as"];
var _createContext$a = createContext$1({
    name: "ListStylesContext",
    errorMessage: "useListStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<List />\" "
  }),
  _createContext2$a = _slicedToArray$1(_createContext$a, 2),
  ListStylesProvider = _createContext2$a[0],
  useListStyles = _createContext2$a[1];
var List$1 = forwardRef(function List2(props, ref) {
  var styles = useMultiStyleConfig("List", props);
  var _omitThemingProps = omitThemingProps(props),
    children = _omitThemingProps.children,
    _omitThemingProps$sty = _omitThemingProps.styleType,
    styleType = _omitThemingProps$sty === void 0 ? "none" : _omitThemingProps$sty,
    stylePosition = _omitThemingProps.stylePosition,
    spacing = _omitThemingProps.spacing,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$1z);
  var validChildren = getValidChildren(children);
  var selector = "& > *:not(style) ~ *:not(style)";
  var spacingStyle = spacing ? _defineProperty$3({}, selector, {
    mt: spacing
  }) : {};
  return /* @__PURE__ */jsxRuntimeExports.jsx(ListStylesProvider, {
    value: styles,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.ul, _objectSpread2$1(_objectSpread2$1({
      ref: ref,
      listStyleType: styleType,
      listStylePosition: stylePosition,
      role: "list",
      __css: _objectSpread2$1(_objectSpread2$1({}, styles.container), spacingStyle)
    }, rest), {}, {
      children: validChildren
    }))
  });
});
List$1.displayName = "List";
var OrderedList = forwardRef(function (props, ref) {
  props.as;
    var rest = _objectWithoutProperties$1(props, _excluded2$9);
  return /* @__PURE__ */jsxRuntimeExports.jsx(List$1, _objectSpread2$1({
    ref: ref,
    as: "ol",
    styleType: "decimal",
    marginStart: "1em"
  }, rest));
});
OrderedList.displayName = "OrderedList";
var UnorderedList = forwardRef(function UnorderedList2(props, ref) {
  props.as;
    var rest = _objectWithoutProperties$1(props, _excluded3$3);
  return /* @__PURE__ */jsxRuntimeExports.jsx(List$1, _objectSpread2$1({
    ref: ref,
    as: "ul",
    styleType: "initial",
    marginStart: "1em"
  }, rest));
});
UnorderedList.displayName = "UnorderedList";
var ListItem = forwardRef(function ListItem2(props, ref) {
  var styles = useListStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.li, _objectSpread2$1(_objectSpread2$1({
    ref: ref
  }, props), {}, {
    __css: styles.item
  }));
});
ListItem.displayName = "ListItem";
var ListIcon = forwardRef(function ListIcon2(props, ref) {
  var styles = useListStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(Icon, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    role: "presentation"
  }, props), {}, {
    __css: styles.icon
  }));
});
ListIcon.displayName = "ListIcon";

var _excluded$1y = ["templateAreas", "gap", "rowGap", "columnGap", "column", "row", "autoFlow", "autoRows", "templateRows", "autoColumns", "templateColumns"];
var Grid$1 = forwardRef(function Grid2(props, ref) {
  var templateAreas = props.templateAreas,
    gap = props.gap,
    rowGap = props.rowGap,
    columnGap = props.columnGap,
    column = props.column,
    row = props.row,
    autoFlow = props.autoFlow,
    autoRows = props.autoRows,
    templateRows = props.templateRows,
    autoColumns = props.autoColumns,
    templateColumns = props.templateColumns,
    rest = _objectWithoutProperties$1(props, _excluded$1y);
  var styles = {
    display: "grid",
    gridTemplateAreas: templateAreas,
    gridGap: gap,
    gridRowGap: rowGap,
    gridColumnGap: columnGap,
    gridAutoColumns: autoColumns,
    gridColumn: column,
    gridRow: row,
    gridAutoFlow: autoFlow,
    gridAutoRows: autoRows,
    gridTemplateRows: templateRows,
    gridTemplateColumns: templateColumns
  };
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1({
    ref: ref,
    __css: styles
  }, rest));
});
Grid$1.displayName = "Grid";

// src/responsive.ts
var breakpoints$1 = Object.freeze(["base", "sm", "md", "lg", "xl", "2xl"]);
function mapResponsive(prop, mapper) {
  if (Array.isArray(prop)) {
    return prop.map(function (item) {
      return item === null ? null : mapper(item);
    });
  }
  if (isObject(prop)) {
    return Object.keys(prop).reduce(function (result, key) {
      result[key] = mapper(prop[key]);
      return result;
    }, {});
  }
  if (prop != null) {
    return mapper(prop);
  }
  return null;
}
function arrayToObjectNotation(values) {
  var bps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : breakpoints$1;
  var result = {};
  values.forEach(function (value, index) {
    var key = bps[index];
    if (value == null) return;
    result[key] = value;
  });
  return result;
}

var _excluded$1x = ["columns", "spacingX", "spacingY", "spacing", "minChildWidth"];
var SimpleGrid = forwardRef(function SimpleGrid2(props, ref) {
  var columns = props.columns,
    spacingX = props.spacingX,
    spacingY = props.spacingY,
    spacing = props.spacing,
    minChildWidth = props.minChildWidth,
    rest = _objectWithoutProperties$1(props, _excluded$1x);
  var theme = useTheme();
  var templateColumns = minChildWidth ? widthToColumns(minChildWidth, theme) : countToColumns(columns);
  return /* @__PURE__ */jsxRuntimeExports.jsx(Grid$1, _objectSpread2$1({
    ref: ref,
    gap: spacing,
    columnGap: spacingX,
    rowGap: spacingY,
    templateColumns: templateColumns
  }, rest));
});
SimpleGrid.displayName = "SimpleGrid";
function toPx(n) {
  return typeof n === "number" ? "".concat(n, "px") : n;
}
function widthToColumns(width, theme) {
  return mapResponsive(width, function (value) {
    var _value = getToken("sizes", value, toPx(value))(theme);
    return value === null ? null : "repeat(auto-fit, minmax(".concat(_value, ", 1fr))");
  });
}
function countToColumns(count) {
  return mapResponsive(count, function (value) {
    return value === null ? null : "repeat(".concat(value, ", minmax(0, 1fr))");
  });
}

var _excluded$1w = ["className", "align", "decoration", "casing"];
var Text$1 = forwardRef(function Text2(props, ref) {
  var styles = useStyleConfig("Text", props);
  var _omitThemingProps = omitThemingProps(props);
    _omitThemingProps.className;
    _omitThemingProps.align;
    _omitThemingProps.decoration;
    _omitThemingProps.casing;
    var rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$1w);
  var aliasedProps = compact({
    textAlign: props.align,
    textDecoration: props.decoration,
    textTransform: props.casing
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.p, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: cx("chakra-text", props.className)
  }, aliasedProps), rest), {}, {
    __css: styles
  }));
});
Text$1.displayName = "Text";

var StackItem = function StackItem(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    className: "chakra-stack__item"
  }, props), {}, {
    __css: _objectSpread2$1({
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0
    }, props["__css"])
  }));
};
StackItem.displayName = "StackItem";

function getDividerStyles(options) {
  var spacing = options.spacing,
    direction = options.direction;
  var dividerStyles = {
    column: {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": mapResponsive(direction, function (value) {
      return dividerStyles[value];
    })
  };
}

var _excluded$1v = ["isInline", "direction", "align", "justify", "spacing", "wrap", "children", "divider", "className", "shouldWrapChildren"];
var Stack = forwardRef(function (props, ref) {
  var isInline = props.isInline,
    directionProp = props.direction,
    align = props.align,
    justify = props.justify,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
    wrap = props.wrap,
    children = props.children,
    divider = props.divider,
    className = props.className,
    shouldWrapChildren = props.shouldWrapChildren,
    rest = _objectWithoutProperties$1(props, _excluded$1v);
  var direction = isInline ? "row" : directionProp != null ? directionProp : "column";
  var dividerStyle = useMemo(function () {
    return getDividerStyles({
      spacing: spacing,
      direction: direction
    });
  }, [spacing, direction]);
  var hasDivider = !!divider;
  var shouldUseChildren = !shouldWrapChildren && !hasDivider;
  var clones = useMemo(function () {
    var validChildren = getValidChildren(children);
    return shouldUseChildren ? validChildren : validChildren.map(function (child, index) {
      var key = typeof child.key !== "undefined" ? child.key : index;
      var isLast = index + 1 === validChildren.length;
      var wrappedChild = /* @__PURE__ */jsxRuntimeExports.jsx(StackItem, {
        children: child
      }, key);
      var _child = shouldWrapChildren ? wrappedChild : child;
      if (!hasDivider) return _child;
      var clonedDivider = /*#__PURE__*/cloneElement(divider, {
        __css: dividerStyle
      });
      var _divider = isLast ? null : clonedDivider;
      return /* @__PURE__ */jsxRuntimeExports.jsxs(Fragment, {
        children: [_child, _divider]
      }, key);
    });
  }, [divider, dividerStyle, hasDivider, shouldUseChildren, shouldWrapChildren, children]);
  var _className = cx("chakra-stack", className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    display: "flex",
    alignItems: align,
    justifyContent: justify,
    flexDirection: direction,
    flexWrap: wrap,
    gap: hasDivider ? void 0 : spacing,
    className: _className
  }, rest), {}, {
    children: clones
  }));
});
Stack.displayName = "Stack";

var VStack = forwardRef(function (props, ref) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(Stack, _objectSpread2$1(_objectSpread2$1({
    align: "center"
  }, props), {}, {
    direction: "column",
    ref: ref
  }));
});
VStack.displayName = "VStack";

var HStack = forwardRef(function (props, ref) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(Stack, _objectSpread2$1(_objectSpread2$1({
    align: "center"
  }, props), {}, {
    direction: "row",
    ref: ref
  }));
});
HStack.displayName = "HStack";

var _excluded$1u = ["area", "colSpan", "colStart", "colEnd", "rowEnd", "rowSpan", "rowStart"];
function spanFn(span) {
  return mapResponsive(span, function (value) {
    return value === "auto" ? "auto" : "span ".concat(value, "/span ").concat(value);
  });
}
var GridItem$1 = forwardRef(function GridItem2(props, ref) {
  var area = props.area,
    colSpan = props.colSpan,
    colStart = props.colStart,
    colEnd = props.colEnd,
    rowEnd = props.rowEnd,
    rowSpan = props.rowSpan,
    rowStart = props.rowStart,
    rest = _objectWithoutProperties$1(props, _excluded$1u);
  var styles = compact({
    gridArea: area,
    gridColumn: spanFn(colSpan),
    gridRow: spanFn(rowSpan),
    gridColumnStart: colStart,
    gridColumnEnd: colEnd,
    gridRowStart: rowStart,
    gridRowEnd: rowEnd
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1({
    ref: ref,
    __css: styles
  }, rest));
});
GridItem$1.displayName = "GridItem";

var _excluded$1t = ["className"];
var Heading$1 = forwardRef(function Heading2(props, ref) {
  var styles = useStyleConfig("Heading", props);
  var _omitThemingProps = omitThemingProps(props);
    _omitThemingProps.className;
    var rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$1t);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.h2, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: cx("chakra-heading", props.className)
  }, rest), {}, {
    __css: styles
  }));
});
Heading$1.displayName = "Heading";

var _excluded$1s = ["size", "centerContent"],
  _excluded2$8 = ["size"];
var Box = chakra("div");
Box.displayName = "Box";
var Square = forwardRef(function Square2(props, ref) {
  var size = props.size,
    _props$centerContent = props.centerContent,
    centerContent = _props$centerContent === void 0 ? true : _props$centerContent,
    rest = _objectWithoutProperties$1(props, _excluded$1s);
  var styles = centerContent ? {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } : {};
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, _objectSpread2$1({
    ref: ref,
    boxSize: size,
    __css: _objectSpread2$1(_objectSpread2$1({}, styles), {}, {
      flexShrink: 0,
      flexGrow: 0
    })
  }, rest));
});
Square.displayName = "Square";
var Circle$1 = forwardRef(function Circle2(props, ref) {
  var size = props.size,
    rest = _objectWithoutProperties$1(props, _excluded2$8);
  return /* @__PURE__ */jsxRuntimeExports.jsx(Square, _objectSpread2$1({
    size: size,
    ref: ref,
    borderRadius: "9999px"
  }, rest));
});
Circle$1.displayName = "Circle";

var _excluded$1r = ["className"];
var Kbd = forwardRef(function Kbd2(props, ref) {
  var styles = useStyleConfig("Kbd", props);
  var _omitThemingProps = omitThemingProps(props),
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$1r);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.kbd, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: cx("chakra-kbd", className)
  }, rest), {}, {
    __css: _objectSpread2$1({
      fontFamily: "mono"
    }, styles)
  }));
});
Kbd.displayName = "Kbd";

var _excluded$1q = ["isExternal", "target", "rel", "className"],
  _excluded2$7 = ["className"];
var LinkOverlay = forwardRef(function LinkOverlay2(props, ref) {
  var isExternal = props.isExternal,
    target = props.target,
    rel = props.rel,
    className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$1q);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.a, _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
    ref: ref,
    className: cx("chakra-linkbox__overlay", className),
    rel: isExternal ? "noopener noreferrer" : rel,
    target: isExternal ? "_blank" : target,
    __css: {
      position: "static",
      "&::before": {
        content: "''",
        cursor: "inherit",
        display: "block",
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 0,
        width: "100%",
        height: "100%"
      }
    }
  }));
});
var LinkBox = forwardRef(function LinkBox2(props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded2$7);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    position: "relative"
  }, rest), {}, {
    className: cx("chakra-linkbox", className),
    __css: {
      /* Elevate the links and abbreviations up */
      "a[href]:not(.chakra-linkbox__overlay), abbr[title]": {
        position: "relative",
        zIndex: 1
      }
    }
  }));
});

var _excluded$1p = ["ratio", "children", "className"];
var AspectRatio = forwardRef(function (props, ref) {
  var _props$ratio = props.ratio,
    ratio = _props$ratio === void 0 ? 4 / 3 : _props$ratio,
    children = props.children,
    className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$1p);
  var child = Children.only(children);
  var _className = cx("chakra-aspect-ratio", className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    position: "relative",
    className: _className,
    _before: {
      height: 0,
      content: "\"\"",
      display: "block",
      paddingBottom: mapResponsive(ratio, function (r) {
        return "".concat(1 / r * 100, "%");
      })
    },
    __css: {
      "& > *:not(style)": {
        overflow: "hidden",
        position: "absolute",
        top: "0",
        right: "0",
        bottom: "0",
        left: "0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%"
      },
      "& > img, & > video": {
        objectFit: "cover"
      }
    }
  }, rest), {}, {
    children: child
  }));
});
AspectRatio.displayName = "AspectRatio";

var _excluded$1o = ["className"];
var Badge = forwardRef(function Badge2(props, ref) {
  var styles = useStyleConfig("Badge", props);
  var _omitThemingProps = omitThemingProps(props);
    _omitThemingProps.className;
    var rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$1o);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: cx("chakra-badge", props.className)
  }, rest), {}, {
    __css: _objectSpread2$1({
      display: "inline-block",
      whiteSpace: "nowrap",
      verticalAlign: "middle"
    }, styles)
  }));
});
Badge.displayName = "Badge";

var Center = chakra("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});
Center.displayName = "Center";

var _excluded$1n = ["className"];
var Code = forwardRef(function Code2(props, ref) {
  var styles = useStyleConfig("Code", props);
  var _omitThemingProps = omitThemingProps(props);
    _omitThemingProps.className;
    var rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$1n);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.code, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: cx("chakra-code", props.className)
  }, rest), {}, {
    __css: _objectSpread2$1({
      display: "inline-block"
    }, styles)
  }));
});
Code.displayName = "Code";

var _excluded$1m = ["className", "centerContent"];
var Container$1 = forwardRef(function Container2(props, ref) {
  var _omitThemingProps = omitThemingProps(props),
    className = _omitThemingProps.className,
    centerContent = _omitThemingProps.centerContent,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$1m);
  var styles = useStyleConfig("Container", props);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: cx("chakra-container", className)
  }, rest), {}, {
    __css: _objectSpread2$1(_objectSpread2$1({}, styles), centerContent && {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    })
  }));
});
Container$1.displayName = "Container";

var _excluded$1l = ["borderLeftWidth", "borderBottomWidth", "borderTopWidth", "borderRightWidth", "borderWidth", "borderStyle", "borderColor"],
  _excluded2$6 = ["className", "orientation", "__css"];
var Divider$1 = forwardRef(function Divider2(props, ref) {
  var _useStyleConfig = useStyleConfig("Divider", props),
    borderLeftWidth = _useStyleConfig.borderLeftWidth,
    borderBottomWidth = _useStyleConfig.borderBottomWidth,
    borderTopWidth = _useStyleConfig.borderTopWidth,
    borderRightWidth = _useStyleConfig.borderRightWidth,
    borderWidth = _useStyleConfig.borderWidth,
    borderStyle = _useStyleConfig.borderStyle,
    borderColor = _useStyleConfig.borderColor,
    styles = _objectWithoutProperties$1(_useStyleConfig, _excluded$1l);
  var _omitThemingProps = omitThemingProps(props),
    className = _omitThemingProps.className,
    _omitThemingProps$ori = _omitThemingProps.orientation,
    orientation = _omitThemingProps$ori === void 0 ? "horizontal" : _omitThemingProps$ori,
    __css = _omitThemingProps.__css,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded2$6);
  var dividerStyles = {
    vertical: {
      borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
      height: "100%"
    },
    horizontal: {
      borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
      width: "100%"
    }
  };
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.hr, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    "aria-orientation": orientation
  }, rest), {}, {
    __css: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, styles), {}, {
      border: "0",
      borderColor: borderColor,
      borderStyle: borderStyle
    }, dividerStyles[orientation]), __css),
    className: cx("chakra-divider", className)
  }));
});
Divider$1.displayName = "Divider";

var _excluded$1k = ["direction", "align", "justify", "wrap", "basis", "grow", "shrink"];
var Flex = forwardRef(function Flex2(props, ref) {
  var direction = props.direction,
    align = props.align,
    justify = props.justify,
    wrap = props.wrap,
    basis = props.basis,
    grow = props.grow,
    shrink = props.shrink,
    rest = _objectWithoutProperties$1(props, _excluded$1k);
  var styles = {
    display: "flex",
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap,
    flexBasis: basis,
    flexGrow: grow,
    flexShrink: shrink
  };
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1({
    ref: ref,
    __css: styles
  }, rest));
});
Flex.displayName = "Flex";

function useMediaQuery(query) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$ssr = options.ssr,
    ssr = _options$ssr === void 0 ? true : _options$ssr,
    fallback = options.fallback;
  var _useEnvironment = useEnvironment(),
    getWindow = _useEnvironment.getWindow;
  var queries = Array.isArray(query) ? query : [query];
  var fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter(function (v) {
    return v != null;
  });
  var _useState = useState(function () {
      return queries.map(function (query2, index) {
        return {
          media: query2,
          matches: ssr ? !!fallbackValues[index] : getWindow().matchMedia(query2).matches
        };
      });
    }),
    _useState2 = _slicedToArray$1(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    var win = getWindow();
    setValue(queries.map(function (query2) {
      return {
        media: query2,
        matches: win.matchMedia(query2).matches
      };
    }));
    var mql = queries.map(function (query2) {
      return win.matchMedia(query2);
    });
    var handler = function handler(evt) {
      setValue(function (prev) {
        return prev.slice().map(function (item) {
          if (item.media === evt.media) return _objectSpread2$1(_objectSpread2$1({}, item), {}, {
            matches: evt.matches
          });
          return item;
        });
      });
    };
    mql.forEach(function (mql2) {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return function () {
      mql.forEach(function (mql2) {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [getWindow]);
  return value.map(function (item) {
    return item.matches;
  });
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  var _useMediaQuery = useMediaQuery("(prefers-reduced-motion: reduce)", options),
    _useMediaQuery2 = _slicedToArray$1(_useMediaQuery, 1),
    prefersReducedMotion = _useMediaQuery2[0];
  return prefersReducedMotion;
}

function getClosestValue(values, breakpoint) {
  var breakpoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : breakpoints$1;
  var index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  var stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    var key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    var _key = breakpoints[index];
    return values[_key];
  }
  return void 0;
}

function useBreakpoint(arg) {
  var _a, _b;
  var opts = isObject(arg) ? arg : {
    fallback: arg != null ? arg : "base"
  };
  var theme = useTheme();
  var breakpoints = theme.__breakpoints.details.map(function (_ref) {
    var minMaxQuery = _ref.minMaxQuery,
      breakpoint = _ref.breakpoint;
    return {
      breakpoint: breakpoint,
      query: minMaxQuery.replace("@media screen and ", "")
    };
  });
  var fallback = breakpoints.map(function (bp) {
    return bp.breakpoint === opts.fallback;
  });
  var values = useMediaQuery(breakpoints.map(function (bp) {
    return bp.query;
  }), {
    fallback: fallback,
    ssr: opts.ssr
  });
  var index = values.findIndex(function (value) {
    return value == true;
  });
  return (_b = (_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) != null ? _b : opts.fallback;
}

function useBreakpointValue(values, arg) {
  var _a;
  var opts = isObject(arg) ? arg : {
    fallback: arg != null ? arg : "base"
  };
  var breakpoint = useBreakpoint(opts);
  var theme = useTheme();
  if (!breakpoint) return;
  var breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  var obj = Array.isArray(values) ? Object.fromEntries(Object.entries(arrayToObjectNotation(values, breakpoints)).map(function (_ref) {
    var _ref2 = _slicedToArray$1(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return [key, value];
  })) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

function isPrintableCharacter(event) {
  var key = event.key;
  return key.length === 1 || key.length > 1 && /[^a-zA-Z0-9]/.test(key);
}
function useShortcut() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$timeout = props.timeout,
    timeout = _props$timeout === void 0 ? 300 : _props$timeout,
    _props$preventDefault = props.preventDefault,
    preventDefault = _props$preventDefault === void 0 ? function () {
      return true;
    } : _props$preventDefault;
  var _useState = useState([]),
    _useState2 = _slicedToArray$1(_useState, 2),
    keys = _useState2[0],
    setKeys = _useState2[1];
  var timeoutRef = useRef();
  var flush = function flush() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };
  var clearKeysAfterDelay = function clearKeysAfterDelay() {
    flush();
    timeoutRef.current = setTimeout(function () {
      setKeys([]);
      timeoutRef.current = null;
    }, timeout);
  };
  useEffect(function () {
    return flush;
  }, []);
  function onKeyDown(fn) {
    return function (event) {
      if (event.key === "Backspace") {
        var keysCopy = _toConsumableArray$1(keys);
        keysCopy.pop();
        setKeys(keysCopy);
        return;
      }
      if (isPrintableCharacter(event)) {
        var _keysCopy = keys.concat(event.key);
        if (preventDefault(event)) {
          event.preventDefault();
          event.stopPropagation();
        }
        setKeys(_keysCopy);
        fn(_keysCopy.join(""));
        clearKeysAfterDelay();
      }
    };
  }
  return onKeyDown;
}

// src/get-next-item-from-search.ts
function getNextItemFromSearch(items, searchString, itemToString, currentItem) {
  if (searchString == null) {
    return currentItem;
  }
  if (!currentItem) {
    var foundItem = items.find(function (item) {
      return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
    });
    return foundItem;
  }
  var matchingItems = items.filter(function (item) {
    return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
  });
  if (matchingItems.length > 0) {
    var nextIndex;
    if (matchingItems.includes(currentItem)) {
      var currentIndex = matchingItems.indexOf(currentItem);
      nextIndex = currentIndex + 1;
      if (nextIndex === matchingItems.length) {
        nextIndex = 0;
      }
      return matchingItems[nextIndex];
    }
    nextIndex = items.indexOf(matchingItems[0]);
    return items[nextIndex];
  }
  return currentItem;
}

function useEventListeners() {
  var listeners = useRef(/* @__PURE__ */new Map());
  var currentListeners = listeners.current;
  var add = useCallback(function (el, type, listener, options) {
    listeners.current.set(listener, {
      type: type,
      el: el,
      options: options
    });
    el.addEventListener(type, listener, options);
  }, []);
  var remove = useCallback(function (el, type, listener, options) {
    el.removeEventListener(type, listener, options);
    listeners.current["delete"](listener);
  }, []);
  useEffect(function () {
    return function () {
      currentListeners.forEach(function (value, key) {
        remove(value.el, value.type, key, value.options);
      });
    };
  }, [remove, currentListeners]);
  return {
    add: add,
    remove: remove
  };
}

var _excluded$1j = ["ref", "isDisabled", "isFocusable", "clickOnEnter", "clickOnSpace", "onMouseDown", "onMouseUp", "onClick", "onKeyDown", "onKeyUp", "tabIndex", "onMouseOver", "onMouseLeave"];
function isValidElement(event) {
  var element = event.target;
  var tagName = element.tagName,
    isContentEditable = element.isContentEditable;
  return tagName !== "INPUT" && tagName !== "TEXTAREA" && isContentEditable !== true;
}
function useClickable() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var htmlRef = props.ref,
    isDisabled = props.isDisabled,
    isFocusable = props.isFocusable,
    _props$clickOnEnter = props.clickOnEnter,
    clickOnEnter = _props$clickOnEnter === void 0 ? true : _props$clickOnEnter,
    _props$clickOnSpace = props.clickOnSpace,
    clickOnSpace = _props$clickOnSpace === void 0 ? true : _props$clickOnSpace,
    onMouseDown = props.onMouseDown,
    onMouseUp = props.onMouseUp,
    onClick = props.onClick,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    tabIndexProp = props.tabIndex,
    onMouseOver = props.onMouseOver,
    onMouseLeave = props.onMouseLeave,
    htmlProps = _objectWithoutProperties$1(props, _excluded$1j);
  var _useState = useState(true),
    _useState2 = _slicedToArray$1(_useState, 2),
    isButton = _useState2[0],
    setIsButton = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    isPressed = _useState4[0],
    setIsPressed = _useState4[1];
  var listeners = useEventListeners();
  var refCallback = function refCallback(node) {
    if (!node) return;
    if (node.tagName !== "BUTTON") {
      setIsButton(false);
    }
  };
  var tabIndex = isButton ? tabIndexProp : tabIndexProp || 0;
  var trulyDisabled = isDisabled && !isFocusable;
  var handleClick = useCallback(function (event) {
    if (isDisabled) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    var self = event.currentTarget;
    self.focus();
    onClick == null ? void 0 : onClick(event);
  }, [isDisabled, onClick]);
  var onDocumentKeyUp = useCallback(function (e) {
    if (isPressed && isValidElement(e)) {
      e.preventDefault();
      e.stopPropagation();
      setIsPressed(false);
      listeners.remove(document, "keyup", onDocumentKeyUp, false);
    }
  }, [isPressed, listeners]);
  var handleKeyDown = useCallback(function (event) {
    onKeyDown == null ? void 0 : onKeyDown(event);
    if (isDisabled || event.defaultPrevented || event.metaKey) {
      return;
    }
    if (!isValidElement(event.nativeEvent) || isButton) return;
    var shouldClickOnEnter = clickOnEnter && event.key === "Enter";
    var shouldClickOnSpace = clickOnSpace && event.key === " ";
    if (shouldClickOnSpace) {
      event.preventDefault();
      setIsPressed(true);
    }
    if (shouldClickOnEnter) {
      event.preventDefault();
      var self = event.currentTarget;
      self.click();
    }
    listeners.add(document, "keyup", onDocumentKeyUp, false);
  }, [isDisabled, isButton, onKeyDown, clickOnEnter, clickOnSpace, listeners, onDocumentKeyUp]);
  var handleKeyUp = useCallback(function (event) {
    onKeyUp == null ? void 0 : onKeyUp(event);
    if (isDisabled || event.defaultPrevented || event.metaKey) return;
    if (!isValidElement(event.nativeEvent) || isButton) return;
    var shouldClickOnSpace = clickOnSpace && event.key === " ";
    if (shouldClickOnSpace) {
      event.preventDefault();
      setIsPressed(false);
      var self = event.currentTarget;
      self.click();
    }
  }, [clickOnSpace, isButton, isDisabled, onKeyUp]);
  var onDocumentMouseUp = useCallback(function (event) {
    if (event.button !== 0) return;
    setIsPressed(false);
    listeners.remove(document, "mouseup", onDocumentMouseUp, false);
  }, [listeners]);
  var handleMouseDown = useCallback(function (event) {
    if (event.button !== 0) return;
    if (isDisabled) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    if (!isButton) {
      setIsPressed(true);
    }
    var target = event.currentTarget;
    target.focus({
      preventScroll: true
    });
    listeners.add(document, "mouseup", onDocumentMouseUp, false);
    onMouseDown == null ? void 0 : onMouseDown(event);
  }, [isDisabled, isButton, onMouseDown, listeners, onDocumentMouseUp]);
  var handleMouseUp = useCallback(function (event) {
    if (event.button !== 0) return;
    if (!isButton) {
      setIsPressed(false);
    }
    onMouseUp == null ? void 0 : onMouseUp(event);
  }, [onMouseUp, isButton]);
  var handleMouseOver = useCallback(function (event) {
    if (isDisabled) {
      event.preventDefault();
      return;
    }
    onMouseOver == null ? void 0 : onMouseOver(event);
  }, [isDisabled, onMouseOver]);
  var handleMouseLeave = useCallback(function (event) {
    if (isPressed) {
      event.preventDefault();
      setIsPressed(false);
    }
    onMouseLeave == null ? void 0 : onMouseLeave(event);
  }, [isPressed, onMouseLeave]);
  var ref = mergeRefs(htmlRef, refCallback);
  if (isButton) {
    return _objectSpread2$1(_objectSpread2$1({}, htmlProps), {}, {
      ref: ref,
      type: "button",
      "aria-disabled": trulyDisabled ? void 0 : isDisabled,
      disabled: trulyDisabled,
      onClick: handleClick,
      onMouseDown: onMouseDown,
      onMouseUp: onMouseUp,
      onKeyUp: onKeyUp,
      onKeyDown: onKeyDown,
      onMouseOver: onMouseOver,
      onMouseLeave: onMouseLeave
    });
  }
  return _objectSpread2$1(_objectSpread2$1({}, htmlProps), {}, {
    ref: ref,
    role: "button",
    "data-active": dataAttr(isPressed),
    "aria-disabled": isDisabled ? "true" : void 0,
    tabIndex: trulyDisabled ? void 0 : tabIndex,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    onKeyUp: handleKeyUp,
    onKeyDown: handleKeyDown,
    onMouseOver: handleMouseOver,
    onMouseLeave: handleMouseLeave
  });
}

function preventReturnFocus(containerRef) {
  var el = containerRef.current;
  if (!el) return false;
  var activeElement = getActiveElement(el);
  if (!activeElement) return false;
  if (el.contains(activeElement)) return false;
  if (isTabbable(activeElement)) return true;
  return false;
}
function useFocusOnHide(containerRef, options) {
  var shouldFocusProp = options.shouldFocus,
    visible = options.visible,
    focusRef = options.focusRef;
  var shouldFocus = shouldFocusProp && !visible;
  useUpdateEffect(function () {
    if (!shouldFocus) return;
    if (preventReturnFocus(containerRef)) {
      return;
    }
    var el = (focusRef == null ? void 0 : focusRef.current) || containerRef.current;
    var rafId;
    if (el) {
      rafId = requestAnimationFrame(function () {
        el.focus({
          preventScroll: true
        });
      });
      return function () {
        cancelAnimationFrame(rafId);
      };
    }
  }, [shouldFocus, containerRef, focusRef]);
}
var defaultOptions = {
  preventScroll: true,
  shouldFocus: false
};
function useFocusOnShow(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  var focusRef = options.focusRef,
    preventScroll = options.preventScroll,
    shouldFocus = options.shouldFocus,
    visible = options.visible;
  var element = isRefObject(target) ? target.current : target;
  var autoFocusValue = shouldFocus && visible;
  var autoFocusRef = useRef(autoFocusValue);
  var lastVisibleRef = useRef(visible);
  useSafeLayoutEffect$2(function () {
    if (!lastVisibleRef.current && visible) {
      autoFocusRef.current = autoFocusValue;
    }
    lastVisibleRef.current = visible;
  }, [visible, autoFocusValue]);
  var onFocus = useCallback(function () {
    if (!visible || !element || !autoFocusRef.current) return;
    autoFocusRef.current = false;
    if (element.contains(document.activeElement)) return;
    if (focusRef == null ? void 0 : focusRef.current) {
      requestAnimationFrame(function () {
        var _a;
        (_a = focusRef.current) == null ? void 0 : _a.focus({
          preventScroll: preventScroll
        });
      });
    } else {
      var tabbableEls = getAllFocusable(element);
      if (tabbableEls.length > 0) {
        requestAnimationFrame(function () {
          tabbableEls[0].focus({
            preventScroll: preventScroll
          });
        });
      }
    }
  }, [visible, preventScroll, element, focusRef]);
  useUpdateEffect(function () {
    onFocus();
  }, [onFocus]);
  useEventListener(element, "transitionend", onFocus);
}
function isRefObject(val) {
  return "current" in val;
}

var toVar = function toVar(value, fallback) {
  return {
    "var": value,
    varRef: fallback ? "var(".concat(value, ", ").concat(fallback, ")") : "var(".concat(value, ")")
  };
};
var cssVars = {
  arrowShadowColor: toVar("--popper-arrow-shadow-color"),
  arrowSize: toVar("--popper-arrow-size", "8px"),
  arrowSizeHalf: toVar("--popper-arrow-size-half"),
  arrowBg: toVar("--popper-arrow-bg"),
  transformOrigin: toVar("--popper-transform-origin"),
  arrowOffset: toVar("--popper-arrow-offset")
};
function getBoxShadow(placement) {
  if (placement.includes("top")) return "1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (placement.includes("bottom")) return "-1px -1px 0px 0 var(--popper-arrow-shadow-color)";
  if (placement.includes("right")) return "-1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (placement.includes("left")) return "1px -1px 0px 0 var(--popper-arrow-shadow-color)";
}
var transforms = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
};
var toTransformOrigin = function toTransformOrigin(placement) {
  return transforms[placement];
};
var defaultEventListeners = {
  scroll: true,
  resize: true
};
function getEventListenerOptions(value) {
  var eventListeners;
  if (_typeof$1(value) === "object") {
    eventListeners = {
      enabled: true,
      options: _objectSpread2$1(_objectSpread2$1({}, defaultEventListeners), value)
    };
  } else {
    eventListeners = {
      enabled: value,
      options: defaultEventListeners
    };
  }
  return eventListeners;
}

// src/modifiers.ts
var matchWidth = {
  name: "matchWidth",
  enabled: true,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: function fn(_ref) {
    var state = _ref.state;
    state.styles.popper.width = "".concat(state.rects.reference.width, "px");
  },
  effect: function effect(_ref2) {
    var state = _ref2.state;
    return function () {
      var reference = state.elements.reference;
      state.elements.popper.style.width = "".concat(reference.offsetWidth, "px");
    };
  }
};
var transformOrigin = {
  name: "transformOrigin",
  enabled: true,
  phase: "write",
  fn: function fn(_ref3) {
    var state = _ref3.state;
    setTransformOrigin(state);
  },
  effect: function effect(_ref4) {
    var state = _ref4.state;
    return function () {
      setTransformOrigin(state);
    };
  }
};
var setTransformOrigin = function setTransformOrigin(state) {
  state.elements.popper.style.setProperty(cssVars.transformOrigin["var"], toTransformOrigin(state.placement));
};
var positionArrow = {
  name: "positionArrow",
  enabled: true,
  phase: "afterWrite",
  fn: function fn(_ref5) {
    var state = _ref5.state;
    setArrowStyles(state);
  }
};
var setArrowStyles = function setArrowStyles(state) {
  var _a;
  if (!state.placement) return;
  var overrides = getArrowStyle$1(state.placement);
  if (((_a = state.elements) == null ? void 0 : _a.arrow) && overrides) {
    Object.assign(state.elements.arrow.style, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, overrides.property, overrides.value), "width", cssVars.arrowSize.varRef), "height", cssVars.arrowSize.varRef), "zIndex", -1));
    var vars = _defineProperty$3(_defineProperty$3({}, cssVars.arrowSizeHalf["var"], "calc(".concat(cssVars.arrowSize.varRef, " / 2 - 1px)")), cssVars.arrowOffset["var"], "calc(".concat(cssVars.arrowSizeHalf.varRef, " * -1)"));
    for (var property in vars) {
      state.elements.arrow.style.setProperty(property, vars[property]);
    }
  }
};
var getArrowStyle$1 = function getArrowStyle(placement) {
  if (placement.startsWith("top")) {
    return {
      property: "bottom",
      value: cssVars.arrowOffset.varRef
    };
  }
  if (placement.startsWith("bottom")) {
    return {
      property: "top",
      value: cssVars.arrowOffset.varRef
    };
  }
  if (placement.startsWith("left")) {
    return {
      property: "right",
      value: cssVars.arrowOffset.varRef
    };
  }
  if (placement.startsWith("right")) {
    return {
      property: "left",
      value: cssVars.arrowOffset.varRef
    };
  }
};
var innerArrow = {
  name: "innerArrow",
  enabled: true,
  phase: "main",
  requires: ["arrow"],
  fn: function fn(_ref6) {
    var state = _ref6.state;
    setInnerArrowStyles(state);
  },
  effect: function effect(_ref7) {
    var state = _ref7.state;
    return function () {
      setInnerArrowStyles(state);
    };
  }
};
var setInnerArrowStyles = function setInnerArrowStyles(state) {
  if (!state.elements.arrow) return;
  var inner = state.elements.arrow.querySelector("[data-popper-arrow-inner]");
  if (!inner) return;
  var boxShadow = getBoxShadow(state.placement);
  if (boxShadow) {
    inner.style.setProperty("--popper-arrow-default-shadow", boxShadow);
  }
  Object.assign(inner.style, {
    transform: "rotate(45deg)",
    background: cssVars.arrowBg.varRef,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "inherit",
    boxShadow: "var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))"
  });
};

// src/popper.placement.ts
var logicals = {
  "start-start": {
    ltr: "left-start",
    rtl: "right-start"
  },
  "start-end": {
    ltr: "left-end",
    rtl: "right-end"
  },
  "end-start": {
    ltr: "right-start",
    rtl: "left-start"
  },
  "end-end": {
    ltr: "right-end",
    rtl: "left-end"
  },
  start: {
    ltr: "left",
    rtl: "right"
  },
  end: {
    ltr: "right",
    rtl: "left"
  }
};
var opposites = {
  "auto-start": "auto-end",
  "auto-end": "auto-start",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start"
};
function getPopperPlacement(placement) {
  var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ltr";
  var _a, _b;
  var value = ((_a = logicals[placement]) == null ? void 0 : _a[dir]) || placement;
  if (dir === "ltr") return value;
  return (_b = opposites[placement]) != null ? _b : value;
}

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

function isElement$1(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement$1(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement$1(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]

    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];
      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement$1(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules

var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }
  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement$1(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement$1(element) ? getWindow(element) : window,
    visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains$1(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...

      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false

  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$1(element) ? element.ownerDocument :
  // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot ||
    // step into the shadow DOM of the parent of a slotted node
    element.parentNode || (
    // DOM Element detected
    isShadowRoot(element) ? element.host : null) ||
    // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback
  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement$1(element) ||
  // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block

function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement$1(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === 'fixed') {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement$1(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.

function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state,
    name = _ref.name,
    options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';
  if (!arrowElement || !popperOffsets) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state,
    options = _ref2.options;
  var _options$element = options.element,
    arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
  if (arrowElement == null) {
    return;
  } // CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains$1(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules

var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
    y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
    popperRect = _ref2.popperRect,
    placement = _ref2.placement,
    variation = _ref2.variation,
    offsets = _ref2.offsets,
    position = _ref2.position,
    gpuAcceleration = _ref2.gpuAcceleration,
    adaptive = _ref2.adaptive,
    roundOffsets = _ref2.roundOffsets,
    isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
    x = _offsets$x === void 0 ? 0 : _offsets$x,
    _offsets$y = offsets.y,
    y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
      // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
      // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
    options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
    gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
    _options$adaptive = options.adaptive,
    adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
    _options$roundOffsets = options.roundOffsets,
    roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state,
    instance = _ref.instance,
    options = _ref.options;
  var _options$scroll = options.scroll,
    scroll = _options$scroll === void 0 ? true : _options$scroll,
    _options$resize = options.resize,
    resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }
  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules

var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
    overflow = _getComputedStyle.overflow,
    overflowX = _getComputedStyle.overflowX,
    overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent$1(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }
  if (isHTMLElement$1(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent$1(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent$1(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList :
  // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`

function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent(element) : element;
  if (!isElement$1(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

  return clippingParents.filter(function (clippingParent) {
    return isElement$1(clippingParent) && contains$1(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents

function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
    element = _ref.element,
    placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$placement = _options.placement,
    placement = _options$placement === void 0 ? state.placement : _options$placement,
    _options$strategy = _options.strategy,
    strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
    _options$boundary = _options.boundary,
    boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
    _options$rootBoundary = _options.rootBoundary,
    rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
    _options$elementConte = _options.elementContext,
    elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
    _options$altBoundary = _options.altBoundary,
    altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
    _options$padding = _options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }
  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    placement = _options.placement,
    boundary = _options.boundary,
    rootBoundary = _options.rootBoundary,
    padding = _options.padding,
    flipVariations = _options.flipVariations,
    _options$allowedAutoP = _options.allowedAutoPlacements,
    allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
    specifiedFallbackPlacements = options.fallbackPlacements,
    padding = options.padding,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    _options$flipVariatio = options.flipVariations,
    flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
    allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];
  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);
        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules

var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state,
    name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules

var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
    skidding = _ref[0],
    distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
    options = _ref2.options,
    name = _ref2.name;
  var _options$offset = options.offset,
    offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
    x = _data$state$placement.x,
    y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
    name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    padding = options.padding,
    _options$tether = options.tether,
    tether = _options$tether === void 0 ? true : _options$tether,
    _options$tetherOffset = options.tetherOffset,
    tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === 'x' ? top : left;
    var _altSide = mainAxis === 'x' ? bottom : right;
    var _offset = popperOffsets[altAxis];
    var _len = altAxis === 'y' ? 'height' : 'width';
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement$1(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  var offsetParentIsScaled = isHTMLElement$1(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' ||
    // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }
    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
    _generatorOptions$def = _generatorOptions.defaultModifiers,
    defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
    _generatorOptions$def2 = _generatorOptions.defaultOptions,
    defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers

        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
            fn = _state$orderedModifie.fn,
            _state$orderedModifie2 = _state$orderedModifie.options,
            _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
            name = _state$orderedModifie.name;
          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      return instance;
    }
    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
          _ref$options = _ref.options,
          options = _ref$options === void 0 ? {} : _ref$options,
          effect = _ref.effect;
        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });
          var noopFn = function noopFn() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

var _excluded$1i = ["size", "shadowColor", "bg", "style"];
function usePopper() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$enabled = props.enabled,
    enabled = _props$enabled === void 0 ? true : _props$enabled,
    modifiers = props.modifiers,
    _props$placement = props.placement,
    placementProp = _props$placement === void 0 ? "bottom" : _props$placement,
    _props$strategy = props.strategy,
    strategy = _props$strategy === void 0 ? "absolute" : _props$strategy,
    _props$arrowPadding = props.arrowPadding,
    arrowPadding = _props$arrowPadding === void 0 ? 8 : _props$arrowPadding,
    _props$eventListeners = props.eventListeners,
    eventListeners = _props$eventListeners === void 0 ? true : _props$eventListeners,
    offset = props.offset,
    _props$gutter = props.gutter,
    gutter = _props$gutter === void 0 ? 8 : _props$gutter,
    _props$flip = props.flip,
    flip = _props$flip === void 0 ? true : _props$flip,
    _props$boundary = props.boundary,
    boundary = _props$boundary === void 0 ? "clippingParents" : _props$boundary,
    _props$preventOverflo = props.preventOverflow,
    preventOverflow = _props$preventOverflo === void 0 ? true : _props$preventOverflo,
    matchWidth2 = props.matchWidth,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? "ltr" : _props$direction;
  var reference = useRef(null);
  var popper = useRef(null);
  var instance = useRef(null);
  var placement = getPopperPlacement(placementProp, direction);
  var cleanup = useRef(function () {});
  var setupPopper = useCallback(function () {
    var _a;
    if (!enabled || !reference.current || !popper.current) return;
    (_a = cleanup.current) == null ? void 0 : _a.call(cleanup);
    instance.current = createPopper(reference.current, popper.current, {
      placement: placement,
      modifiers: [innerArrow, positionArrow, transformOrigin, _objectSpread2$1(_objectSpread2$1({}, matchWidth), {}, {
        enabled: !!matchWidth2
      }), _objectSpread2$1({
        name: "eventListeners"
      }, getEventListenerOptions(eventListeners)), {
        name: "arrow",
        options: {
          padding: arrowPadding
        }
      }, {
        name: "offset",
        options: {
          offset: offset != null ? offset : [0, gutter]
        }
      }, {
        name: "flip",
        enabled: !!flip,
        options: {
          padding: 8
        }
      }, {
        name: "preventOverflow",
        enabled: !!preventOverflow,
        options: {
          boundary: boundary
        }
      }].concat(_toConsumableArray$1(modifiers != null ? modifiers : [])),
      strategy: strategy
    });
    instance.current.forceUpdate();
    cleanup.current = instance.current.destroy;
  }, [placement, enabled, modifiers, matchWidth2, eventListeners, arrowPadding, offset, gutter, flip, preventOverflow, boundary, strategy]);
  useEffect(function () {
    return function () {
      var _a;
      if (!reference.current && !popper.current) {
        (_a = instance.current) == null ? void 0 : _a.destroy();
        instance.current = null;
      }
    };
  }, []);
  var referenceRef = useCallback(function (node) {
    reference.current = node;
    setupPopper();
  }, [setupPopper]);
  var getReferenceProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: mergeRefs(referenceRef, ref)
    });
  }, [referenceRef]);
  var popperRef = useCallback(function (node) {
    popper.current = node;
    setupPopper();
  }, [setupPopper]);
  var getPopperProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: mergeRefs(popperRef, ref),
      style: _objectSpread2$1(_objectSpread2$1({}, props2.style), {}, {
        position: strategy,
        minWidth: matchWidth2 ? void 0 : "max-content",
        inset: "0 auto auto 0"
      })
    });
  }, [strategy, popperRef, matchWidth2]);
  var getArrowProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    props2.size;
      props2.shadowColor;
      props2.bg;
      props2.style;
      var rest = _objectWithoutProperties$1(props2, _excluded$1i);
    return _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
      ref: ref,
      "data-popper-arrow": "",
      style: getArrowStyle(props2)
    });
  }, []);
  var getArrowInnerProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: ref,
      "data-popper-arrow-inner": ""
    });
  }, []);
  return {
    update: function update() {
      var _a;
      (_a = instance.current) == null ? void 0 : _a.update();
    },
    forceUpdate: function forceUpdate() {
      var _a;
      (_a = instance.current) == null ? void 0 : _a.forceUpdate();
    },
    transformOrigin: cssVars.transformOrigin.varRef,
    referenceRef: referenceRef,
    popperRef: popperRef,
    getPopperProps: getPopperProps,
    getArrowProps: getArrowProps,
    getArrowInnerProps: getArrowInnerProps,
    getReferenceProps: getReferenceProps
  };
}
function getArrowStyle(props) {
  var size = props.size,
    shadowColor = props.shadowColor,
    bg = props.bg,
    style = props.style;
  var computedStyle = _objectSpread2$1(_objectSpread2$1({}, style), {}, {
    position: "absolute"
  });
  if (size) {
    computedStyle["--popper-arrow-size"] = size;
  }
  if (shadowColor) {
    computedStyle["--popper-arrow-shadow-color"] = shadowColor;
  }
  if (bg) {
    computedStyle["--popper-arrow-bg"] = bg;
  }
  return computedStyle;
}

function useDisclosure() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onCloseProp = props.onClose,
    onOpenProp = props.onOpen,
    isOpenProp = props.isOpen,
    idProp = props.id;
  var handleOpen = useCallbackRef$3(onOpenProp);
  var handleClose = useCallbackRef$3(onCloseProp);
  var _useState = useState(props.defaultIsOpen || false),
    _useState2 = _slicedToArray$1(_useState, 2),
    isOpenState = _useState2[0],
    setIsOpen = _useState2[1];
  var isOpen = isOpenProp !== void 0 ? isOpenProp : isOpenState;
  var isControlled = isOpenProp !== void 0;
  var uid = useId$1();
  var id = idProp != null ? idProp : "disclosure-".concat(uid);
  var onClose = useCallback(function () {
    if (!isControlled) {
      setIsOpen(false);
    }
    handleClose == null ? void 0 : handleClose();
  }, [isControlled, handleClose]);
  var onOpen = useCallback(function () {
    if (!isControlled) {
      setIsOpen(true);
    }
    handleOpen == null ? void 0 : handleOpen();
  }, [isControlled, handleOpen]);
  var onToggle = useCallback(function () {
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  }, [isOpen, onOpen, onClose]);
  function getButtonProps() {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      "aria-expanded": isOpen,
      "aria-controls": id,
      onClick: function onClick(event) {
        var _a;
        (_a = props2.onClick) == null ? void 0 : _a.call(props2, event);
        onToggle();
      }
    });
  }
  function getDisclosureProps() {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      hidden: !isOpen,
      id: id
    });
  }
  return {
    isOpen: isOpen,
    onOpen: onOpen,
    onClose: onClose,
    onToggle: onToggle,
    isControlled: isControlled,
    getButtonProps: getButtonProps,
    getDisclosureProps: getDisclosureProps
  };
}

function useOutsideClick(props) {
  var ref = props.ref,
    handler = props.handler,
    _props$enabled = props.enabled,
    enabled = _props$enabled === void 0 ? true : _props$enabled;
  var savedHandler = useCallbackRef$3(handler);
  var stateRef = useRef({
    isPointerDown: false,
    ignoreEmulatedMouseEvents: false
  });
  var state = stateRef.current;
  useEffect(function () {
    if (!enabled) return;
    var onPointerDown = function onPointerDown(e) {
      if (isValidEvent(e, ref)) {
        state.isPointerDown = true;
      }
    };
    var onMouseUp = function onMouseUp(event) {
      if (state.ignoreEmulatedMouseEvents) {
        state.ignoreEmulatedMouseEvents = false;
        return;
      }
      if (state.isPointerDown && handler && isValidEvent(event, ref)) {
        state.isPointerDown = false;
        savedHandler(event);
      }
    };
    var onTouchEnd = function onTouchEnd(event) {
      state.ignoreEmulatedMouseEvents = true;
      if (handler && state.isPointerDown && isValidEvent(event, ref)) {
        state.isPointerDown = false;
        savedHandler(event);
      }
    };
    var doc = getOwnerDocument$1(ref.current);
    doc.addEventListener("mousedown", onPointerDown, true);
    doc.addEventListener("mouseup", onMouseUp, true);
    doc.addEventListener("touchstart", onPointerDown, true);
    doc.addEventListener("touchend", onTouchEnd, true);
    return function () {
      doc.removeEventListener("mousedown", onPointerDown, true);
      doc.removeEventListener("mouseup", onMouseUp, true);
      doc.removeEventListener("touchstart", onPointerDown, true);
      doc.removeEventListener("touchend", onTouchEnd, true);
    };
  }, [handler, ref, savedHandler, state, enabled]);
}
function isValidEvent(event, ref) {
  var _a;
  var target = event.target;
  if (target) {
    var doc = getOwnerDocument$1(target);
    if (!doc.contains(target)) return false;
  }
  return !((_a = ref.current) == null ? void 0 : _a.contains(target));
}
function getOwnerDocument$1(node) {
  var _a;
  return (_a = node == null ? void 0 : node.ownerDocument) != null ? _a : document;
}

function useAnimationState(props) {
  var isOpen = props.isOpen,
    ref = props.ref;
  var _useState = useState(isOpen),
    _useState2 = _slicedToArray$1(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    once = _useState4[0],
    setOnce = _useState4[1];
  useEffect(function () {
    if (!once) {
      setMounted(isOpen);
      setOnce(true);
    }
  }, [isOpen, once, mounted]);
  useEventListener(function () {
    return ref.current;
  }, "animationend", function () {
    setMounted(isOpen);
  });
  var hidden = isOpen ? false : !mounted;
  return {
    present: !hidden,
    onComplete: function onComplete() {
      var _a;
      var win = getOwnerWindow(ref.current);
      var evt = new win.CustomEvent("animationend", {
        bubbles: true
      });
      (_a = ref.current) == null ? void 0 : _a.dispatchEvent(evt);
    }
  };
}

// src/index.ts
function lazyDisclosure(options) {
  var wasSelected = options.wasSelected,
    enabled = options.enabled,
    isSelected = options.isSelected,
    _options$mode = options.mode,
    mode = _options$mode === void 0 ? "unmount" : _options$mode;
  if (!enabled) return true;
  if (isSelected) return true;
  if (mode === "keepMounted" && wasSelected) return true;
  return false;
}

var _excluded$1h = ["id", "closeOnSelect", "closeOnBlur", "initialFocusRef", "autoSelect", "isLazy", "isOpen", "defaultIsOpen", "onClose", "onOpen", "placement", "lazyBehavior", "direction", "computePositionOnMount"],
  _excluded2$5 = ["onMouseEnter", "onMouseMove", "onMouseLeave", "onClick", "onFocus", "isDisabled", "isFocusable", "closeOnSelect", "type"],
  _excluded3$2 = ["type", "isChecked"],
  _excluded4 = ["children", "type", "value", "defaultValue", "onChange"];
var _createDescendantCont$1 = createDescendantContext(),
  _createDescendantCont2$1 = _slicedToArray$1(_createDescendantCont$1, 4),
  MenuDescendantsProvider = _createDescendantCont2$1[0],
  useMenuDescendantsContext = _createDescendantCont2$1[1],
  useMenuDescendants = _createDescendantCont2$1[2],
  useMenuDescendant = _createDescendantCont2$1[3];
var _createContext$9 = createContext$1({
    strict: false,
    name: "MenuContext"
  }),
  _createContext2$9 = _slicedToArray$1(_createContext$9, 2),
  MenuProvider = _createContext2$9[0],
  useMenuContext = _createContext2$9[1];
function useIds$1(idProp) {
  for (var _len = arguments.length, prefixes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    prefixes[_key - 1] = arguments[_key];
  }
  var reactId = useId$1();
  var id = idProp || reactId;
  return useMemo(function () {
    return prefixes.map(function (prefix) {
      return "".concat(prefix, "-").concat(id);
    });
  }, [id, prefixes]);
}
function getOwnerDocument(node) {
  var _a;
  return (_a = node == null ? void 0 : node.ownerDocument) != null ? _a : document;
}
function isActiveElement(element) {
  var doc = getOwnerDocument(element);
  return doc.activeElement === element;
}
function useMenu() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = props.id,
    _props$closeOnSelect = props.closeOnSelect,
    closeOnSelect = _props$closeOnSelect === void 0 ? true : _props$closeOnSelect,
    _props$closeOnBlur = props.closeOnBlur,
    closeOnBlur = _props$closeOnBlur === void 0 ? true : _props$closeOnBlur,
    initialFocusRef = props.initialFocusRef,
    _props$autoSelect = props.autoSelect,
    autoSelect = _props$autoSelect === void 0 ? true : _props$autoSelect,
    isLazy = props.isLazy,
    isOpenProp = props.isOpen,
    defaultIsOpen = props.defaultIsOpen,
    onCloseProp = props.onClose,
    onOpenProp = props.onOpen,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? "bottom-start" : _props$placement,
    _props$lazyBehavior = props.lazyBehavior,
    lazyBehavior = _props$lazyBehavior === void 0 ? "unmount" : _props$lazyBehavior,
    direction = props.direction,
    _props$computePositio = props.computePositionOnMount,
    computePositionOnMount = _props$computePositio === void 0 ? false : _props$computePositio,
    popperProps = _objectWithoutProperties$1(props, _excluded$1h);
  var menuRef = useRef(null);
  var buttonRef = useRef(null);
  var descendants = useMenuDescendants();
  var focusMenu = useCallback(function () {
    requestAnimationFrame(function () {
      var _a;
      (_a = menuRef.current) == null ? void 0 : _a.focus({
        preventScroll: false
      });
    });
  }, []);
  var focusFirstItem = useCallback(function () {
    var id2 = setTimeout(function () {
      var _a;
      if (initialFocusRef) {
        (_a = initialFocusRef.current) == null ? void 0 : _a.focus();
      } else {
        var first = descendants.firstEnabled();
        if (first) setFocusedIndex(first.index);
      }
    });
    timeoutIds.current.add(id2);
  }, [descendants, initialFocusRef]);
  var focusLastItem = useCallback(function () {
    var id2 = setTimeout(function () {
      var last = descendants.lastEnabled();
      if (last) setFocusedIndex(last.index);
    });
    timeoutIds.current.add(id2);
  }, [descendants]);
  var onOpenInternal = useCallback(function () {
    onOpenProp == null ? void 0 : onOpenProp();
    if (autoSelect) {
      focusFirstItem();
    } else {
      focusMenu();
    }
  }, [autoSelect, focusFirstItem, focusMenu, onOpenProp]);
  var _useDisclosure = useDisclosure({
      isOpen: isOpenProp,
      defaultIsOpen: defaultIsOpen,
      onClose: onCloseProp,
      onOpen: onOpenInternal
    }),
    isOpen = _useDisclosure.isOpen,
    onOpen = _useDisclosure.onOpen,
    onClose = _useDisclosure.onClose,
    onToggle = _useDisclosure.onToggle;
  useOutsideClick({
    enabled: isOpen && closeOnBlur,
    ref: menuRef,
    handler: function handler(event) {
      var _a;
      if (!((_a = buttonRef.current) == null ? void 0 : _a.contains(event.target))) {
        onClose();
      }
    }
  });
  var popper = usePopper(_objectSpread2$1(_objectSpread2$1({}, popperProps), {}, {
    enabled: isOpen || computePositionOnMount,
    placement: placement,
    direction: direction
  }));
  var _useState = useState(-1),
    _useState2 = _slicedToArray$1(_useState, 2),
    focusedIndex = _useState2[0],
    setFocusedIndex = _useState2[1];
  useUpdateEffect(function () {
    if (!isOpen) {
      setFocusedIndex(-1);
    }
  }, [isOpen]);
  useFocusOnHide(menuRef, {
    focusRef: buttonRef,
    visible: isOpen,
    shouldFocus: true
  });
  var animationState = useAnimationState({
    isOpen: isOpen,
    ref: menuRef
  });
  var _useIds = useIds$1(id, "menu-button", "menu-list"),
    _useIds2 = _slicedToArray$1(_useIds, 2),
    buttonId = _useIds2[0],
    menuId = _useIds2[1];
  var openAndFocusMenu = useCallback(function () {
    onOpen();
    focusMenu();
  }, [onOpen, focusMenu]);
  var timeoutIds = useRef(/* @__PURE__ */new Set([]));
  useEffect(function () {
    var ids = timeoutIds.current;
    return function () {
      ids.forEach(function (id2) {
        return clearTimeout(id2);
      });
      ids.clear();
    };
  }, []);
  var openAndFocusFirstItem = useCallback(function () {
    onOpen();
    focusFirstItem();
  }, [focusFirstItem, onOpen]);
  var openAndFocusLastItem = useCallback(function () {
    onOpen();
    focusLastItem();
  }, [onOpen, focusLastItem]);
  var refocus = useCallback(function () {
    var _a, _b;
    var doc = getOwnerDocument(menuRef.current);
    var hasFocusWithin = (_a = menuRef.current) == null ? void 0 : _a.contains(doc.activeElement);
    var shouldRefocus = isOpen && !hasFocusWithin;
    if (!shouldRefocus) return;
    var node = (_b = descendants.item(focusedIndex)) == null ? void 0 : _b.node;
    node == null ? void 0 : node.focus({
      preventScroll: true
    });
  }, [isOpen, focusedIndex, descendants]);
  var rafId = useRef(null);
  return {
    openAndFocusMenu: openAndFocusMenu,
    openAndFocusFirstItem: openAndFocusFirstItem,
    openAndFocusLastItem: openAndFocusLastItem,
    onTransitionEnd: refocus,
    unstable__animationState: animationState,
    descendants: descendants,
    popper: popper,
    buttonId: buttonId,
    menuId: menuId,
    forceUpdate: popper.forceUpdate,
    orientation: "vertical",
    isOpen: isOpen,
    onToggle: onToggle,
    onOpen: onOpen,
    onClose: onClose,
    menuRef: menuRef,
    buttonRef: buttonRef,
    focusedIndex: focusedIndex,
    closeOnSelect: closeOnSelect,
    closeOnBlur: closeOnBlur,
    autoSelect: autoSelect,
    setFocusedIndex: setFocusedIndex,
    isLazy: isLazy,
    lazyBehavior: lazyBehavior,
    initialFocusRef: initialFocusRef,
    rafId: rafId
  };
}
function useMenuButton() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var externalRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var menu = useMenuContext();
  var onToggle = menu.onToggle,
    popper = menu.popper,
    openAndFocusFirstItem = menu.openAndFocusFirstItem,
    openAndFocusLastItem = menu.openAndFocusLastItem;
  var onKeyDown = useCallback(function (event) {
    var eventKey = event.key;
    var keyMap = {
      Enter: openAndFocusFirstItem,
      ArrowDown: openAndFocusFirstItem,
      ArrowUp: openAndFocusLastItem
    };
    var action = keyMap[eventKey];
    if (action) {
      event.preventDefault();
      event.stopPropagation();
      action(event);
    }
  }, [openAndFocusFirstItem, openAndFocusLastItem]);
  return _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref: mergeRefs(menu.buttonRef, externalRef, popper.referenceRef),
    id: menu.buttonId,
    "data-active": dataAttr(menu.isOpen),
    "aria-expanded": menu.isOpen,
    "aria-haspopup": "menu",
    "aria-controls": menu.menuId,
    onClick: callAllHandlers$1(props.onClick, onToggle),
    onKeyDown: callAllHandlers$1(props.onKeyDown, onKeyDown)
  });
}
function isTargetMenuItem(target) {
  var _a;
  return isHTMLElement(target) && !!((_a = target == null ? void 0 : target.getAttribute("role")) == null ? void 0 : _a.startsWith("menuitem"));
}
function useMenuList() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var menu = useMenuContext();
  if (!menu) {
    throw new Error("useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>");
  }
  var focusedIndex = menu.focusedIndex,
    setFocusedIndex = menu.setFocusedIndex,
    menuRef = menu.menuRef,
    isOpen = menu.isOpen,
    onClose = menu.onClose,
    menuId = menu.menuId,
    isLazy = menu.isLazy,
    lazyBehavior = menu.lazyBehavior,
    animated = menu.unstable__animationState;
  var descendants = useMenuDescendantsContext();
  var createTypeaheadHandler = useShortcut({
    preventDefault: function preventDefault(event) {
      return event.key !== " " && isTargetMenuItem(event.target);
    }
  });
  var onKeyDown = useCallback(function (event) {
    if (!event.currentTarget.contains(event.target)) return;
    var eventKey = event.key;
    var keyMap = {
      Tab: function Tab(event2) {
        return event2.preventDefault();
      },
      Escape: onClose,
      ArrowDown: function ArrowDown() {
        var next = descendants.nextEnabled(focusedIndex);
        if (next) setFocusedIndex(next.index);
      },
      ArrowUp: function ArrowUp() {
        var prev = descendants.prevEnabled(focusedIndex);
        if (prev) setFocusedIndex(prev.index);
      }
    };
    var fn = keyMap[eventKey];
    if (fn) {
      event.preventDefault();
      fn(event);
      return;
    }
    var onTypeahead = createTypeaheadHandler(function (character) {
      var nextItem = getNextItemFromSearch(descendants.values(), character, function (item) {
        var _a, _b;
        return (_b = (_a = item == null ? void 0 : item.node) == null ? void 0 : _a.textContent) != null ? _b : "";
      }, descendants.item(focusedIndex));
      if (nextItem) {
        var index = descendants.indexOf(nextItem.node);
        setFocusedIndex(index);
      }
    });
    if (isTargetMenuItem(event.target)) {
      onTypeahead(event);
    }
  }, [descendants, focusedIndex, createTypeaheadHandler, onClose, setFocusedIndex]);
  var hasBeenOpened = useRef(false);
  if (isOpen) {
    hasBeenOpened.current = true;
  }
  var shouldRenderChildren = lazyDisclosure({
    wasSelected: hasBeenOpened.current,
    enabled: isLazy,
    mode: lazyBehavior,
    isSelected: animated.present
  });
  return _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref: mergeRefs(menuRef, ref),
    children: shouldRenderChildren ? props.children : null,
    tabIndex: -1,
    role: "menu",
    id: menuId,
    style: _objectSpread2$1(_objectSpread2$1({}, props.style), {}, {
      transformOrigin: "var(--popper-transform-origin)"
    }),
    "aria-orientation": "vertical",
    onKeyDown: callAllHandlers$1(props.onKeyDown, onKeyDown)
  });
}
function useMenuPositioner() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useMenuContext = useMenuContext(),
    popper = _useMenuContext.popper,
    isOpen = _useMenuContext.isOpen;
  return popper.getPopperProps(_objectSpread2$1(_objectSpread2$1({}, props), {}, {
    style: _objectSpread2$1({
      visibility: isOpen ? "visible" : "hidden"
    }, props.style)
  }));
}
function useMenuItem() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var externalRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var onMouseEnterProp = props.onMouseEnter,
    onMouseMoveProp = props.onMouseMove,
    onMouseLeaveProp = props.onMouseLeave,
    onClickProp = props.onClick,
    onFocusProp = props.onFocus,
    isDisabled = props.isDisabled,
    isFocusable = props.isFocusable,
    closeOnSelect = props.closeOnSelect,
    typeProp = props.type,
    htmlProps = _objectWithoutProperties$1(props, _excluded2$5);
  var menu = useMenuContext();
  var setFocusedIndex = menu.setFocusedIndex,
    focusedIndex = menu.focusedIndex,
    menuCloseOnSelect = menu.closeOnSelect,
    onClose = menu.onClose,
    menuRef = menu.menuRef,
    isOpen = menu.isOpen,
    menuId = menu.menuId,
    rafId = menu.rafId;
  var ref = useRef(null);
  var id = "".concat(menuId, "-menuitem-").concat(useId$1());
  var _useMenuDescendant = useMenuDescendant({
      disabled: isDisabled && !isFocusable
    }),
    index = _useMenuDescendant.index,
    register = _useMenuDescendant.register;
  var onMouseEnter = useCallback(function (event) {
    onMouseEnterProp == null ? void 0 : onMouseEnterProp(event);
    if (isDisabled) return;
    setFocusedIndex(index);
  }, [setFocusedIndex, index, isDisabled, onMouseEnterProp]);
  var onMouseMove = useCallback(function (event) {
    onMouseMoveProp == null ? void 0 : onMouseMoveProp(event);
    if (ref.current && !isActiveElement(ref.current)) {
      onMouseEnter(event);
    }
  }, [onMouseEnter, onMouseMoveProp]);
  var onMouseLeave = useCallback(function (event) {
    onMouseLeaveProp == null ? void 0 : onMouseLeaveProp(event);
    if (isDisabled) return;
    setFocusedIndex(-1);
  }, [setFocusedIndex, isDisabled, onMouseLeaveProp]);
  var onClick = useCallback(function (event) {
    onClickProp == null ? void 0 : onClickProp(event);
    if (!isTargetMenuItem(event.currentTarget)) return;
    if (closeOnSelect != null ? closeOnSelect : menuCloseOnSelect) {
      onClose();
    }
  }, [onClose, onClickProp, menuCloseOnSelect, closeOnSelect]);
  var onFocus = useCallback(function (event) {
    onFocusProp == null ? void 0 : onFocusProp(event);
    setFocusedIndex(index);
  }, [setFocusedIndex, onFocusProp, index]);
  var isFocused = index === focusedIndex;
  var trulyDisabled = isDisabled && !isFocusable;
  useUpdateEffect(function () {
    if (!isOpen) return;
    if (isFocused && !trulyDisabled && ref.current) {
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
      rafId.current = requestAnimationFrame(function () {
        var _a;
        (_a = ref.current) == null ? void 0 : _a.focus({
          preventScroll: true
        });
        rafId.current = null;
      });
    } else if (menuRef.current && !isActiveElement(menuRef.current)) {
      menuRef.current.focus({
        preventScroll: true
      });
    }
    return function () {
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
    };
  }, [isFocused, trulyDisabled, menuRef, isOpen]);
  var clickableProps = useClickable({
    onClick: onClick,
    onFocus: onFocus,
    onMouseEnter: onMouseEnter,
    onMouseMove: onMouseMove,
    onMouseLeave: onMouseLeave,
    ref: mergeRefs(register, ref, externalRef),
    isDisabled: isDisabled,
    isFocusable: isFocusable
  });
  return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, htmlProps), clickableProps), {}, {
    type: typeProp != null ? typeProp : clickableProps.type,
    id: id,
    role: "menuitem",
    tabIndex: isFocused ? 0 : -1
  });
}
function useMenuOption() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var _props$type = props.type,
    type = _props$type === void 0 ? "radio" : _props$type,
    isChecked = props.isChecked,
    rest = _objectWithoutProperties$1(props, _excluded3$2);
  var ownProps = useMenuItem(rest, ref);
  return _objectSpread2$1(_objectSpread2$1({}, ownProps), {}, {
    role: "menuitem".concat(type),
    "aria-checked": isChecked
  });
}
function useMenuOptionGroup() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var children = props.children,
    _props$type2 = props.type,
    type = _props$type2 === void 0 ? "radio" : _props$type2,
    valueProp = props.value,
    defaultValue = props.defaultValue,
    onChangeProp = props.onChange,
    htmlProps = _objectWithoutProperties$1(props, _excluded4);
  var isRadio = type === "radio";
  var fallback = isRadio ? "" : [];
  var _useControllableState = useControllableState$1({
      defaultValue: defaultValue != null ? defaultValue : fallback,
      value: valueProp,
      onChange: onChangeProp
    }),
    _useControllableState2 = _slicedToArray$1(_useControllableState, 2),
    value = _useControllableState2[0],
    setValue = _useControllableState2[1];
  var onChange = useCallback(function (selectedValue) {
    if (type === "radio" && typeof value === "string") {
      setValue(selectedValue);
    }
    if (type === "checkbox" && Array.isArray(value)) {
      var nextValue = value.includes(selectedValue) ? value.filter(function (item) {
        return item !== selectedValue;
      }) : value.concat(selectedValue);
      setValue(nextValue);
    }
  }, [value, setValue, type]);
  var validChildren = getValidChildren(children);
  var clones = validChildren.map(function (child) {
    if (child.type.id !== "MenuItemOption") return child;
    var onClick = function onClick(event) {
      var _a, _b;
      onChange(child.props.value);
      (_b = (_a = child.props).onClick) == null ? void 0 : _b.call(_a, event);
    };
    var isChecked = type === "radio" ? child.props.value === value : value.includes(child.props.value);
    return /*#__PURE__*/cloneElement(child, {
      type: type,
      onClick: onClick,
      isChecked: isChecked
    });
  });
  return _objectSpread2$1(_objectSpread2$1({}, htmlProps), {}, {
    children: clones
  });
}
function isHTMLElement(el) {
  var _a;
  if (!isElement(el)) return false;
  var win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
  return el instanceof win.HTMLElement;
}
function isElement(el) {
  return el != null && _typeof$1(el) == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}

var _excluded$1g = ["descendants"];
var _createContext$8 = createContext$1({
    name: "MenuStylesContext",
    errorMessage: "useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Menu />\" "
  }),
  _createContext2$8 = _slicedToArray$1(_createContext$8, 2),
  MenuStylesProvider = _createContext2$8[0],
  useMenuStyles = _createContext2$8[1];
var Menu$2 = function Menu(props) {
  var children = props.children;
  var styles = useMultiStyleConfig("Menu", props);
  var ownProps = omitThemingProps(props);
  var _useTheme = useTheme(),
    direction = _useTheme.direction;
  var _useMenu = useMenu(_objectSpread2$1(_objectSpread2$1({}, ownProps), {}, {
      direction: direction
    })),
    descendants = _useMenu.descendants,
    ctx = _objectWithoutProperties$1(_useMenu, _excluded$1g);
  var context = useMemo(function () {
    return ctx;
  }, [ctx]);
  var isOpen = context.isOpen,
    onClose = context.onClose,
    forceUpdate = context.forceUpdate;
  return /* @__PURE__ */jsxRuntimeExports.jsx(MenuDescendantsProvider, {
    value: descendants,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(MenuProvider, {
      value: context,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(MenuStylesProvider, {
        value: styles,
        children: runIfFn$2(children, {
          isOpen: isOpen,
          onClose: onClose,
          forceUpdate: forceUpdate
        })
      })
    })
  });
};
Menu$2.displayName = "Menu";

var MenuCommand = forwardRef(function (props, ref) {
  var styles = useMenuStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
    ref: ref
  }, props), {}, {
    __css: styles.command,
    className: "chakra-menu__command"
  }));
});
MenuCommand.displayName = "MenuCommand";

var _excluded$1f = ["type"];
var StyledMenuItem = forwardRef(function (props, ref) {
  var type = props.type,
    rest = _objectWithoutProperties$1(props, _excluded$1f);
  var styles = useMenuStyles();
  var btnType = rest.as || type ? type != null ? type : void 0 : "button";
  var buttonStyles = useMemo(function () {
    return _objectSpread2$1({
      textDecoration: "none",
      color: "inherit",
      userSelect: "none",
      display: "flex",
      width: "100%",
      alignItems: "center",
      textAlign: "start",
      flex: "0 0 auto",
      outline: 0
    }, styles.item);
  }, [styles.item]);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.button, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    type: btnType
  }, rest), {}, {
    __css: buttonStyles
  }));
});

var _excluded$1e = ["className", "children"];
var MenuIcon = function MenuIcon(props) {
  var className = props.className,
    children = props.children,
    rest = _objectWithoutProperties$1(props, _excluded$1e);
  var styles = useMenuStyles();
  var child = Children.only(children);
  var clone = /*#__PURE__*/isValidElement$1(child) ? /*#__PURE__*/cloneElement(child, {
    focusable: "false",
    "aria-hidden": true,
    className: cx("chakra-menu__icon", child.props.className)
  }) : null;
  var _className = cx("chakra-menu__icon-wrapper", className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
    className: _className
  }, rest), {}, {
    __css: styles.icon,
    children: clone
  }));
};
MenuIcon.displayName = "MenuIcon";

var _excluded$1d = ["icon", "iconSpacing", "command", "commandSpacing", "children"];
var MenuItem = forwardRef(function (props, ref) {
  var icon = props.icon,
    _props$iconSpacing = props.iconSpacing,
    iconSpacing = _props$iconSpacing === void 0 ? "0.75rem" : _props$iconSpacing,
    command = props.command,
    _props$commandSpacing = props.commandSpacing,
    commandSpacing = _props$commandSpacing === void 0 ? "0.75rem" : _props$commandSpacing,
    children = props.children,
    rest = _objectWithoutProperties$1(props, _excluded$1d);
  var menuitemProps = useMenuItem(rest, ref);
  var shouldWrap = icon || command;
  var _children = shouldWrap ? /* @__PURE__ */jsxRuntimeExports.jsx("span", {
    style: {
      pointerEvents: "none",
      flex: 1
    },
    children: children
  }) : children;
  return /* @__PURE__ */jsxRuntimeExports.jsxs(StyledMenuItem, _objectSpread2$1(_objectSpread2$1({}, menuitemProps), {}, {
    className: cx("chakra-menu__menuitem", menuitemProps.className),
    children: [icon && /* @__PURE__ */jsxRuntimeExports.jsx(MenuIcon, {
      fontSize: "0.8em",
      marginEnd: iconSpacing,
      children: icon
    }), _children, command && /* @__PURE__ */jsxRuntimeExports.jsx(MenuCommand, {
      marginStart: commandSpacing,
      children: command
    })]
  }));
});
MenuItem.displayName = "MenuItem";

var _excluded$1c = ["rootProps", "motionProps"];
var motionVariants = {
  enter: {
    visibility: "visible",
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    transitionEnd: {
      visibility: "hidden"
    },
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.1,
      easings: "easeOut"
    }
  }
};
var MenuTransition = chakra(motion.div);
var MenuList$1 = forwardRef(function MenuList2(props, ref) {
  var _a, _b;
  var rootProps = props.rootProps,
    motionProps = props.motionProps,
    rest = _objectWithoutProperties$1(props, _excluded$1c);
  var _useMenuContext = useMenuContext(),
    isOpen = _useMenuContext.isOpen,
    onTransitionEnd = _useMenuContext.onTransitionEnd,
    animated = _useMenuContext.unstable__animationState;
  var listProps = useMenuList(rest, ref);
  var positionerProps = useMenuPositioner(rootProps);
  var styles = useMenuStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, positionerProps), {}, {
    __css: {
      zIndex: (_b = props.zIndex) != null ? _b : (_a = styles.list) == null ? void 0 : _a.zIndex
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(MenuTransition, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
      variants: motionVariants,
      initial: false,
      animate: isOpen ? "enter" : "exit",
      __css: _objectSpread2$1({
        outline: 0
      }, styles.list)
    }, motionProps), {}, {
      className: cx("chakra-menu__menu-list", listProps.className)
    }, listProps), {}, {
      onUpdate: onTransitionEnd,
      onAnimationComplete: callAll(animated.onComplete, listProps.onAnimationComplete)
    }))
  }));
});
MenuList$1.displayName = "MenuList";

var _excluded$1b = ["title", "children", "className"];
var MenuGroup = forwardRef(function (props, ref) {
  var title = props.title,
    children = props.children,
    className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$1b);
  var _className = cx("chakra-menu__group__title", className);
  var styles = useMenuStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsxs("div", {
    ref: ref,
    className: "chakra-menu__group",
    role: "group",
    children: [title && /* @__PURE__ */jsxRuntimeExports.jsx(chakra.p, _objectSpread2$1(_objectSpread2$1({
      className: _className
    }, rest), {}, {
      __css: styles.groupTitle,
      children: title
    })), children]
  });
});
MenuGroup.displayName = "MenuGroup";

var _excluded$1a = ["className", "title"];
var MenuOptionGroup = function MenuOptionGroup(props) {
  var className = props.className,
    title = props.title,
    rest = _objectWithoutProperties$1(props, _excluded$1a);
  var ownProps = useMenuOptionGroup(rest);
  return /* @__PURE__ */jsxRuntimeExports.jsx(MenuGroup, _objectSpread2$1({
    title: title,
    className: cx("chakra-menu__option-group", className)
  }, ownProps));
};
MenuOptionGroup.displayName = "MenuOptionGroup";

var _excluded$19 = ["children", "as"];
var StyledMenuButton = forwardRef(function (props, ref) {
  var styles = useMenuStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.button, _objectSpread2$1(_objectSpread2$1({
    ref: ref
  }, props), {}, {
    __css: _objectSpread2$1({
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      outline: 0
    }, styles.button)
  }));
});
var MenuButton = forwardRef(function (props, ref) {
  props.children;
    var As = props.as,
    rest = _objectWithoutProperties$1(props, _excluded$19);
  var buttonProps = useMenuButton(rest, ref);
  var Element = As || StyledMenuButton;
  return /* @__PURE__ */jsxRuntimeExports.jsx(Element, _objectSpread2$1(_objectSpread2$1({}, buttonProps), {}, {
    className: cx("chakra-menu__menu-button", props.className),
    children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, {
      __css: {
        pointerEvents: "none",
        flex: "1 1 auto",
        minW: 0
      },
      children: props.children
    })
  }));
});
MenuButton.displayName = "MenuButton";

var _excluded$18 = ["className"];
var MenuDivider = function MenuDivider(props) {
  var className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$18);
  var styles = useMenuStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.hr, _objectSpread2$1(_objectSpread2$1({
    "aria-orientation": "horizontal",
    className: cx("chakra-menu__divider", className)
  }, rest), {}, {
    __css: styles.divider
  }));
};
MenuDivider.displayName = "MenuDivider";

var _excluded$17 = ["icon", "iconSpacing"];
var CheckIcon = function CheckIcon(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread2$1(_objectSpread2$1({
    viewBox: "0 0 14 14",
    width: "1em",
    height: "1em"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("polygon", {
      fill: "currentColor",
      points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
    })
  }));
};
var MenuItemOption = forwardRef(function (props, ref) {
  var icon = props.icon,
    _props$iconSpacing = props.iconSpacing,
    iconSpacing = _props$iconSpacing === void 0 ? "0.75rem" : _props$iconSpacing,
    rest = _objectWithoutProperties$1(props, _excluded$17);
  var optionProps = useMenuOption(rest, ref);
  return /* @__PURE__ */jsxRuntimeExports.jsxs(StyledMenuItem, _objectSpread2$1(_objectSpread2$1({}, optionProps), {}, {
    className: cx("chakra-menu__menuitem-option", rest.className),
    children: [icon !== null && /* @__PURE__ */jsxRuntimeExports.jsx(MenuIcon, {
      fontSize: "0.8em",
      marginEnd: iconSpacing,
      opacity: props.isChecked ? 1 : 0,
      children: icon || /* @__PURE__ */jsxRuntimeExports.jsx(CheckIcon, {})
    }), /* @__PURE__ */jsxRuntimeExports.jsx("span", {
      style: {
        flex: 1
      },
      children: optionProps.children
    })]
  }));
});
MenuItemOption.id = "MenuItemOption";
MenuItemOption.displayName = "MenuItemOption";

var _excluded$16 = ["preset", "motionProps"];
var transitions = {
  slideInBottom: _objectSpread2$1(_objectSpread2$1({}, slideFadeConfig), {}, {
    custom: {
      offsetY: 16,
      reverse: true
    }
  }),
  slideInRight: _objectSpread2$1(_objectSpread2$1({}, slideFadeConfig), {}, {
    custom: {
      offsetX: 16,
      reverse: true
    }
  }),
  slideInTop: _objectSpread2$1(_objectSpread2$1({}, slideFadeConfig), {}, {
    custom: {
      offsetY: -16,
      reverse: true
    }
  }),
  slideInLeft: _objectSpread2$1(_objectSpread2$1({}, slideFadeConfig), {}, {
    custom: {
      offsetX: -16,
      reverse: true
    }
  }),
  scale: _objectSpread2$1(_objectSpread2$1({}, scaleFadeConfig), {}, {
    custom: {
      initialScale: 0.95,
      reverse: true
    }
  }),
  none: {}
};
var MotionSection$1 = chakra(motion.section);
var getMotionProps = function getMotionProps(preset) {
  return transitions[preset || "none"];
};
var ModalTransition = /*#__PURE__*/forwardRef$1(function (props, ref) {
  var preset = props.preset,
    _props$motionProps = props.motionProps,
    motionProps = _props$motionProps === void 0 ? getMotionProps(preset) : _props$motionProps,
    rest = _objectWithoutProperties$1(props, _excluded$16);
  return /* @__PURE__ */jsxRuntimeExports.jsx(MotionSection$1, _objectSpread2$1(_objectSpread2$1({
    ref: ref
  }, motionProps), rest));
});
ModalTransition.displayName = "ModalTransition";

var __defProp = Object.defineProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, _typeof$1(key) !== "symbol" ? key + "" : key, value);
  return value;
};

var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    _classCallCheck$1(this, ModalManager);
    __publicField(this, "modals");
    this.modals = /* @__PURE__ */new Map();
  }
  return _createClass$1(ModalManager, [{
    key: "add",
    value: function add(modal) {
      this.modals.set(modal, this.modals.size + 1);
      return this.modals.size;
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      this.modals["delete"](modal);
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      if (!modal) return false;
      return this.modals.get(modal) === this.modals.size;
    }
  }]);
}();
var modalManager = new ModalManager();
function useModalManager(ref, isOpen) {
  var _useState = useState(0),
    _useState2 = _slicedToArray$1(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  useEffect(function () {
    var node = ref.current;
    if (!node) return;
    if (isOpen) {
      var index2 = modalManager.add(node);
      setIndex(index2);
    }
    return function () {
      modalManager.remove(node);
      setIndex(0);
    };
  }, [isOpen, ref]);
  return index;
}

var getDefaultParent = function getDefaultParent(originalTarget) {
  if (typeof document === 'undefined') {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var _unwrapHost = function unwrapHost(node) {
  return node && (node.host || _unwrapHost(node.parentNode));
};
var correctTargets = function correctTargets(parent, targets) {
  return targets.map(function (target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = _unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
    return null;
  }).filter(function (x) {
    return Boolean(x);
  });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function applyAttributeToOthers(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = new Set();
  var elementsToStop = new Set(targets);
  var _keep = function keep(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    _keep(el.parentNode);
  };
  targets.forEach(_keep);
  var _deep = function deep(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function (node) {
      if (elementsToKeep.has(node)) {
        _deep(node);
      } else {
        try {
          var attr = node.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== 'false';
          var counterValue = (counterMap.get(node) || 0) + 1;
          var markerValue = (markerCounter.get(node) || 0) + 1;
          counterMap.set(node, counterValue);
          markerCounter.set(node, markerValue);
          hiddenNodes.push(node);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node, true);
          }
          if (markerValue === 1) {
            node.setAttribute(markerName, 'true');
          }
          if (!alreadyHidden) {
            node.setAttribute(controlAttribute, 'true');
          }
        } catch (e) {
          console.error('aria-hidden: cannot operate on ', node, e);
        }
      }
    });
  };
  _deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function () {
    hiddenNodes.forEach(function (node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes["delete"](node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      // clear
      counterMap = new WeakMap();
      counterMap = new WeakMap();
      uncontrolledNodes = new WeakMap();
      markerMap = {};
    }
  };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function hideOthers(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = 'data-aria-hidden';
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function () {
      return null;
    };
  }
  // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
  return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};

function useModal(props) {
  var isOpen = props.isOpen,
    onClose = props.onClose,
    id = props.id,
    _props$closeOnOverlay = props.closeOnOverlayClick,
    closeOnOverlayClick = _props$closeOnOverlay === void 0 ? true : _props$closeOnOverlay,
    _props$closeOnEsc = props.closeOnEsc,
    closeOnEsc = _props$closeOnEsc === void 0 ? true : _props$closeOnEsc,
    _props$useInert = props.useInert,
    useInert = _props$useInert === void 0 ? true : _props$useInert,
    onOverlayClickProp = props.onOverlayClick,
    onEsc = props.onEsc;
  var dialogRef = useRef(null);
  var overlayRef = useRef(null);
  var _useIds = useIds(id, "chakra-modal", "chakra-modal--header", "chakra-modal--body"),
    _useIds2 = _slicedToArray$1(_useIds, 3),
    dialogId = _useIds2[0],
    headerId = _useIds2[1],
    bodyId = _useIds2[2];
  useAriaHidden(dialogRef, isOpen && useInert);
  var index = useModalManager(dialogRef, isOpen);
  var mouseDownTarget = useRef(null);
  var onMouseDown = useCallback(function (event) {
    mouseDownTarget.current = event.target;
  }, []);
  var onKeyDown = useCallback(function (event) {
    if (event.key === "Escape") {
      event.stopPropagation();
      if (closeOnEsc) {
        onClose == null ? void 0 : onClose();
      }
      onEsc == null ? void 0 : onEsc();
    }
  }, [closeOnEsc, onClose, onEsc]);
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    headerMounted = _useState2[0],
    setHeaderMounted = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    bodyMounted = _useState4[0],
    setBodyMounted = _useState4[1];
  var getDialogProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({
      role: "dialog"
    }, props2), {}, {
      ref: mergeRefs(ref, dialogRef),
      id: dialogId,
      tabIndex: -1,
      "aria-modal": true,
      "aria-labelledby": headerMounted ? headerId : void 0,
      "aria-describedby": bodyMounted ? bodyId : void 0,
      onClick: callAllHandlers$1(props2.onClick, function (event) {
        return event.stopPropagation();
      })
    });
  }, [bodyId, bodyMounted, dialogId, headerId, headerMounted]);
  var onOverlayClick = useCallback(function (event) {
    event.stopPropagation();
    if (mouseDownTarget.current !== event.target) return;
    if (!modalManager.isTopModal(dialogRef.current)) return;
    if (closeOnOverlayClick) {
      onClose == null ? void 0 : onClose();
    }
    onOverlayClickProp == null ? void 0 : onOverlayClickProp();
  }, [onClose, closeOnOverlayClick, onOverlayClickProp]);
  var getDialogContainerProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: mergeRefs(ref, overlayRef),
      onClick: callAllHandlers$1(props2.onClick, onOverlayClick),
      onKeyDown: callAllHandlers$1(props2.onKeyDown, onKeyDown),
      onMouseDown: callAllHandlers$1(props2.onMouseDown, onMouseDown)
    });
  }, [onKeyDown, onMouseDown, onOverlayClick]);
  return {
    isOpen: isOpen,
    onClose: onClose,
    headerId: headerId,
    bodyId: bodyId,
    setBodyMounted: setBodyMounted,
    setHeaderMounted: setHeaderMounted,
    dialogRef: dialogRef,
    overlayRef: overlayRef,
    getDialogProps: getDialogProps,
    getDialogContainerProps: getDialogContainerProps,
    index: index
  };
}
function useAriaHidden(ref, shouldHide) {
  var currentElement = ref.current;
  useEffect(function () {
    if (!ref.current || !shouldHide) return void 0;
    return hideOthers(ref.current);
  }, [shouldHide, ref, currentElement]);
}
function useIds(idProp) {
  for (var _len = arguments.length, prefixes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    prefixes[_key - 1] = arguments[_key];
  }
  var reactId = useId$1();
  var id = idProp || reactId;
  return useMemo(function () {
    return prefixes.map(function (prefix) {
      return "".concat(prefix, "-").concat(id);
    });
  }, [id, prefixes]);
}

var _createContext$7 = createContext$1({
    name: "ModalStylesContext",
    errorMessage: "useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Modal />\" "
  }),
  _createContext2$7 = _slicedToArray$1(_createContext$7, 2),
  ModalStylesProvider = _createContext2$7[0],
  useModalStyles = _createContext2$7[1];
var _createContext3$2 = createContext$1({
    strict: true,
    name: "ModalContext",
    errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
  }),
  _createContext4$2 = _slicedToArray$1(_createContext3$2, 2),
  ModalContextProvider = _createContext4$2[0],
  useModalContext = _createContext4$2[1];
var Modal$1 = function Modal(props) {
  var modalProps = _objectSpread2$1({
    scrollBehavior: "outside",
    autoFocus: true,
    trapFocus: true,
    returnFocusOnClose: true,
    blockScrollOnMount: true,
    allowPinchZoom: false,
    motionPreset: "scale",
    lockFocusAcrossFrames: true
  }, props);
  var portalProps = modalProps.portalProps,
    children = modalProps.children,
    autoFocus = modalProps.autoFocus,
    trapFocus = modalProps.trapFocus,
    initialFocusRef = modalProps.initialFocusRef,
    finalFocusRef = modalProps.finalFocusRef,
    returnFocusOnClose = modalProps.returnFocusOnClose,
    blockScrollOnMount = modalProps.blockScrollOnMount,
    allowPinchZoom = modalProps.allowPinchZoom,
    preserveScrollBarGap = modalProps.preserveScrollBarGap,
    motionPreset = modalProps.motionPreset,
    lockFocusAcrossFrames = modalProps.lockFocusAcrossFrames,
    onCloseComplete = modalProps.onCloseComplete;
  var styles = useMultiStyleConfig("Modal", modalProps);
  var modal = useModal(modalProps);
  var context = _objectSpread2$1(_objectSpread2$1({}, modal), {}, {
    autoFocus: autoFocus,
    trapFocus: trapFocus,
    initialFocusRef: initialFocusRef,
    finalFocusRef: finalFocusRef,
    returnFocusOnClose: returnFocusOnClose,
    blockScrollOnMount: blockScrollOnMount,
    allowPinchZoom: allowPinchZoom,
    preserveScrollBarGap: preserveScrollBarGap,
    motionPreset: motionPreset,
    lockFocusAcrossFrames: lockFocusAcrossFrames
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(ModalContextProvider, {
    value: context,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(ModalStylesProvider, {
      value: styles,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(AnimatePresence, {
        onExitComplete: onCloseComplete,
        children: context.isOpen && /* @__PURE__ */jsxRuntimeExports.jsx(Portal, _objectSpread2$1(_objectSpread2$1({}, portalProps), {}, {
          children: children
        }))
      })
    })
  });
};
Modal$1.displayName = "Modal";

var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
  var ref = useState(function () {
    return {
      // value
      value: initialValue,
      // last callback
      callback: callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  // update callback
  ref.callback = callback;
  return ref.facade;
}

/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
  return useCallbackRef(null, function (newValue) {
    return refs.forEach(function (ref) {
      return assignRef(ref, newValue);
    });
  });
}

function ItoI(a) {
  return a;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function read() {
      if (assigned) {
        throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function useMedium(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function () {
        buffer = buffer.filter(function (x) {
          return x !== item;
        });
      };
    },
    assignSyncMedium: function assignSyncMedium(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function push(x) {
          return cb(x);
        },
        filter: function filter() {
          return buffer;
        }
      };
    },
    assignMedium: function assignMedium(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function executeQueue() {
        var cbs = pendingQueue;
        pendingQueue = [];
        cbs.forEach(cb);
      };
      var cycle = function cycle() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function push(x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function filter(_filter) {
          pendingQueue = pendingQueue.filter(_filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = _assign({
    async: true,
    ssr: false
  }, options);
  return medium;
}

var SideCar$1 = function SideCar(_a) {
  var sideCar = _a.sideCar,
    rest = __rest(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error('Sidecar: please provide `sideCar` property to import the right car');
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error('Sidecar medium not found');
  }
  return /*#__PURE__*/React.createElement(Target, _assign({}, rest));
};
SideCar$1.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar$1;
}

var effectCar = createSidecarMedium();

var nothing = function nothing() {
  return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = /*#__PURE__*/React.forwardRef(function (props, parentRef) {
  var ref = React.useRef(null);
  var _a = React.useState({
      onScrollCapture: nothing,
      onWheelCapture: nothing,
      onTouchMoveCapture: nothing
    }),
    callbacks = _a[0],
    setCallbacks = _a[1];
  var forwardProps = props.forwardProps,
    children = props.children,
    className = props.className,
    removeScrollBar = props.removeScrollBar,
    enabled = props.enabled,
    shards = props.shards,
    sideCar = props.sideCar,
    noIsolation = props.noIsolation,
    inert = props.inert,
    allowPinchZoom = props.allowPinchZoom,
    _b = props.as,
    Container = _b === void 0 ? 'div' : _b,
    gapMode = props.gapMode,
    rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
  var SideCar = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = _assign(_assign({}, rest), callbacks);
  return /*#__PURE__*/React.createElement(React.Fragment, null, enabled && (/*#__PURE__*/React.createElement(SideCar, {
    sideCar: effectCar,
    removeScrollBar: removeScrollBar,
    shards: shards,
    noIsolation: noIsolation,
    inert: inert,
    setCallbacks: setCallbacks,
    allowPinchZoom: !!allowPinchZoom,
    lockRef: ref,
    gapMode: gapMode
  })), forwardProps ? (/*#__PURE__*/React.cloneElement(React.Children.only(children), _assign(_assign({}, containerProps), {
    ref: containerRef
  }))) : (/*#__PURE__*/React.createElement(Container, _assign({}, containerProps, {
    className: className,
    ref: containerRef
  }), children)));
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};

var getNonce = function getNonce() {
  if (typeof __webpack_nonce__ !== 'undefined') {
    return __webpack_nonce__;
  }
  return undefined;
};

function makeStyleTag() {
  if (!document) return null;
  var tag = document.createElement('style');
  tag.type = 'text/css';
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute('nonce', nonce);
  }
  return tag;
}
function injectStyles(tag, css) {
  // @ts-ignore
  if (tag.styleSheet) {
    // @ts-ignore
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName('head')[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function stylesheetSingleton() {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function add(style) {
      if (counter == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function remove() {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};

/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function styleHookSingleton() {
  var sheet = stylesheetSingleton();
  return function (styles, isDynamic) {
    React.useEffect(function () {
      sheet.add(styles);
      return function () {
        sheet.remove();
      };
    }, [styles && isDynamic]);
  };
};

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function styleSingleton() {
  var useStyle = styleHookSingleton();
  var Sheet = function Sheet(_a) {
    var styles = _a.styles,
      dynamic = _a.dynamic;
    useStyle(styles, dynamic);
    return null;
  };
  return Sheet;
};

var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse = function parse(x) {
  return parseInt(x || '', 10) || 0;
};
var getOffset = function getOffset(gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
  var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
  var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
  return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function getGapWidth(gapMode) {
  if (gapMode === void 0) {
    gapMode = 'margin';
  }
  if (typeof window === 'undefined') {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};

var Style = styleSingleton();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function getStyles(_a, allowRelative, gapMode, important) {
  var left = _a.left,
    top = _a.top,
    right = _a.right,
    gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = 'margin';
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([allowRelative && "position: relative ".concat(important, ";"), gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "), gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")].filter(Boolean).join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function RemoveScrollBar(props) {
  var noRelative = props.noRelative,
    noImportant = props.noImportant,
    _a = props.gapMode,
    gapMode = _a === void 0 ? 'margin' : _a;
  /*
   gap will be measured on every component mount
   however it will be used only by the "first" invocation
   due to singleton nature of <Style
   */
  var gap = React.useMemo(function () {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return /*#__PURE__*/React.createElement(Style, {
    styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
  });
};

var passiveSupported = false;
if (typeof window !== 'undefined') {
  try {
    var options$2 = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
        return true;
      }
    });
    // @ts-ignore
    window.addEventListener('test', options$2, options$2);
    // @ts-ignore
    window.removeEventListener('test', options$2, options$2);
  } catch (err) {
    passiveSupported = false;
  }
}
var nonPassive = passiveSupported ? {
  passive: false
} : false;

var alwaysContainsScroll = function alwaysContainsScroll(node) {
  // textarea will always _contain_ scroll inside self. It only can be hidden
  return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function elementCanBeScrolled(node, overflow) {
  var styles = window.getComputedStyle(node);
  return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
    // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible')
  );
};
var elementCouldBeVScrolled = function elementCouldBeVScrolled(node) {
  return elementCanBeScrolled(node, 'overflowY');
};
var elementCouldBeHScrolled = function elementCouldBeHScrolled(node) {
  return elementCanBeScrolled(node, 'overflowX');
};
var locationCouldBeScrolled = function locationCouldBeScrolled(axis, node) {
  var ownerDocument = node.ownerDocument;
  var current = node;
  do {
    // Skip over shadow root
    if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current),
        s = _a[1],
        d = _a[2];
      if (s > d) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== ownerDocument.body);
  return false;
};
var getVScrollVariables = function getVScrollVariables(_a) {
  var scrollTop = _a.scrollTop,
    scrollHeight = _a.scrollHeight,
    clientHeight = _a.clientHeight;
  return [scrollTop, scrollHeight, clientHeight];
};
var getHScrollVariables = function getHScrollVariables(_a) {
  var scrollLeft = _a.scrollLeft,
    scrollWidth = _a.scrollWidth,
    clientWidth = _a.clientWidth;
  return [scrollLeft, scrollWidth, clientWidth];
};
var elementCouldBeScrolled = function elementCouldBeScrolled(axis, node) {
  return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function getScrollVariables(axis, node) {
  return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function getDirectionFactor(axis, direction) {
  /**
   * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
   * and then increasingly negative as you scroll towards the end of the content.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
   */
  return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function handleScroll(axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  // find scrollable target
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables(axis, target),
      position = _a[0],
      scroll_1 = _a[1],
      capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    target = target.parentNode;
  } while (
  // portaled content
  !targetInLock && target !== document.body ||
  // self content
  targetInLock && (endTarget.contains(target) || endTarget === target));
  if (isDeltaPositive && (availableScroll === 0 || !noOverscroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (availableScrollTop === 0 || !noOverscroll)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};

var getTouchXY = function getTouchXY(event) {
  return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function getDeltaXY(event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function deltaCompare(x, y) {
  return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function generateStyle(id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React.useRef([]);
  var touchStartRef = React.useRef([0, 0]);
  var activeAxis = React.useRef();
  var id = React.useState(idCounter++)[0];
  var Style = React.useState(styleSingleton)[0];
  var lastProps = React.useRef(props);
  React.useEffect(function () {
    lastProps.current = props;
  }, [props]);
  React.useEffect(function () {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function (el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function () {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function (el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React.useCallback(function (event, parent) {
    if ('touches' in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
    // allow horizontal touch move on Range inputs. They will not cause any scroll
    if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === 'v' ? 'h' : 'v';
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
      // other axis might be not scrollable
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React.useCallback(function (_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
      // not the last active
      return;
    }
    var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function (e) {
      return e.name === event.type && e.target === event.target && deltaCompare(e.delta, delta);
    })[0];
    // self event, and should be canceled
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    // outside or shard event
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function (node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React.useCallback(function (name, delta, target, should) {
    var event = {
      name: name,
      delta: delta,
      target: target,
      should: should
    };
    shouldPreventQueue.current.push(event);
    setTimeout(function () {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) {
        return e !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React.useCallback(function (event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = undefined;
  }, []);
  var scrollWheel = React.useCallback(function (event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React.useCallback(function (event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React.useEffect(function () {
    lockStack.push(Style);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener('wheel', shouldPrevent, nonPassive);
    document.addEventListener('touchmove', shouldPrevent, nonPassive);
    document.addEventListener('touchstart', scrollTouchStart, nonPassive);
    return function () {
      lockStack = lockStack.filter(function (inst) {
        return inst !== Style;
      });
      document.removeEventListener('wheel', shouldPrevent, nonPassive);
      document.removeEventListener('touchmove', shouldPrevent, nonPassive);
      document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar,
    inert = props.inert;
  return /*#__PURE__*/React.createElement(React.Fragment, null, inert ? /*#__PURE__*/React.createElement(Style, {
    styles: generateStyle(id)
  }) : null, removeScrollBar ? /*#__PURE__*/React.createElement(RemoveScrollBar, {
    gapMode: props.gapMode
  }) : null);
}

var SideCar = exportSidecar(effectCar, RemoveScrollSideCar);

var ReactRemoveScroll = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(RemoveScroll, _assign({}, props, {
    ref: ref,
    sideCar: SideCar
  }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;

function ModalFocusScope(props) {
  var _useModalContext = useModalContext(),
    autoFocus = _useModalContext.autoFocus,
    trapFocus = _useModalContext.trapFocus,
    dialogRef = _useModalContext.dialogRef,
    initialFocusRef = _useModalContext.initialFocusRef,
    blockScrollOnMount = _useModalContext.blockScrollOnMount,
    allowPinchZoom = _useModalContext.allowPinchZoom,
    finalFocusRef = _useModalContext.finalFocusRef,
    returnFocusOnClose = _useModalContext.returnFocusOnClose,
    preserveScrollBarGap = _useModalContext.preserveScrollBarGap,
    lockFocusAcrossFrames = _useModalContext.lockFocusAcrossFrames,
    isOpen = _useModalContext.isOpen;
  var _usePresence = usePresence(),
    _usePresence2 = _slicedToArray$1(_usePresence, 2),
    isPresent = _usePresence2[0],
    safeToRemove = _usePresence2[1];
  useEffect(function () {
    if (!isPresent && safeToRemove) {
      setTimeout(safeToRemove);
    }
  }, [isPresent, safeToRemove]);
  var index = useModalManager(dialogRef, isOpen);
  return /* @__PURE__ */jsxRuntimeExports.jsx(FocusLock, {
    autoFocus: autoFocus,
    isDisabled: !trapFocus,
    initialFocusRef: initialFocusRef,
    finalFocusRef: finalFocusRef,
    restoreFocus: returnFocusOnClose,
    contentRef: dialogRef,
    lockFocusAcrossFrames: lockFocusAcrossFrames,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(ReactRemoveScroll, {
      removeScrollBar: !preserveScrollBarGap,
      allowPinchZoom: allowPinchZoom,
      enabled: index === 1 && blockScrollOnMount,
      forwardProps: true,
      children: props.children
    })
  });
}

var _excluded$15 = ["className", "children", "containerProps", "motionProps"];
var ModalContent = forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    rootProps = props.containerProps,
    motionProps = props.motionProps,
    rest = _objectWithoutProperties$1(props, _excluded$15);
  var _useModalContext = useModalContext(),
    getDialogProps = _useModalContext.getDialogProps,
    getDialogContainerProps = _useModalContext.getDialogContainerProps;
  var dialogProps = getDialogProps(rest, ref);
  var containerProps = getDialogContainerProps(rootProps);
  var _className = cx("chakra-modal__content", className);
  var styles = useModalStyles();
  var dialogStyles = _objectSpread2$1({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    width: "100%",
    outline: 0
  }, styles.dialog);
  var dialogContainerStyles = _objectSpread2$1({
    display: "flex",
    width: "100vw",
    height: "$100vh",
    position: "fixed",
    left: 0,
    top: 0
  }, styles.dialogContainer);
  var _useModalContext2 = useModalContext(),
    motionPreset = _useModalContext2.motionPreset;
  return /* @__PURE__ */jsxRuntimeExports.jsx(ModalFocusScope, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, containerProps), {}, {
      className: "chakra-modal__content-container",
      tabIndex: -1,
      __css: dialogContainerStyles,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(ModalTransition, _objectSpread2$1(_objectSpread2$1({
        preset: motionPreset,
        motionProps: motionProps,
        className: _className
      }, dialogProps), {}, {
        __css: dialogStyles,
        children: children
      }))
    }))
  });
});
ModalContent.displayName = "ModalContent";

var _excluded$14 = ["isOpen", "onClose", "placement", "children"];
var _createContext$6 = createContext$1(),
  _createContext2$6 = _slicedToArray$1(_createContext$6, 2),
  DrawerContextProvider = _createContext2$6[0],
  useDrawerContext = _createContext2$6[1];
var placementMap = {
  start: {
    ltr: "left",
    rtl: "right"
  },
  end: {
    ltr: "right",
    rtl: "left"
  }
};
function getDrawerPlacement(placement, dir) {
  var _a, _b;
  if (!placement) return;
  return (_b = (_a = placementMap[placement]) == null ? void 0 : _a[dir]) != null ? _b : placement;
}
function Drawer$1(props) {
  var _a;
  var isOpen = props.isOpen,
    onClose = props.onClose,
    _props$placement = props.placement,
    placementProp = _props$placement === void 0 ? "right" : _props$placement,
    children = props.children,
    rest = _objectWithoutProperties$1(props, _excluded$14);
  var theme = useTheme();
  var drawerStyleConfig = (_a = theme.components) == null ? void 0 : _a.Drawer;
  var placement = getDrawerPlacement(placementProp, theme.direction);
  return /* @__PURE__ */jsxRuntimeExports.jsx(DrawerContextProvider, {
    value: {
      placement: placement
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Modal$1, _objectSpread2$1(_objectSpread2$1({
      isOpen: isOpen,
      onClose: onClose,
      styleConfig: drawerStyleConfig
    }, rest), {}, {
      children: children
    }))
  });
}

var _excluded$13 = ["className", "children", "motionProps", "containerProps"];
var MotionDiv$2 = chakra(Slide);
var DrawerContent = forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    motionProps = props.motionProps,
    rootProps = props.containerProps,
    rest = _objectWithoutProperties$1(props, _excluded$13);
  var _useModalContext = useModalContext(),
    getDialogProps = _useModalContext.getDialogProps,
    getDialogContainerProps = _useModalContext.getDialogContainerProps,
    isOpen = _useModalContext.isOpen;
  var dialogProps = getDialogProps(rest, ref);
  var containerProps = getDialogContainerProps(rootProps);
  var _className = cx("chakra-modal__content", className);
  var styles = useModalStyles();
  var dialogStyles = _objectSpread2$1({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    width: "100%",
    outline: 0
  }, styles.dialog);
  var dialogContainerStyles = _objectSpread2$1({
    display: "flex",
    width: "100vw",
    height: "$100vh",
    position: "fixed",
    left: 0,
    top: 0
  }, styles.dialogContainer);
  var _useDrawerContext = useDrawerContext(),
    placement = _useDrawerContext.placement;
  return /* @__PURE__ */jsxRuntimeExports.jsx(ModalFocusScope, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, containerProps), {}, {
      className: "chakra-modal__content-container",
      __css: dialogContainerStyles,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(MotionDiv$2, _objectSpread2$1(_objectSpread2$1({
        motionProps: motionProps,
        direction: placement,
        "in": isOpen,
        className: _className
      }, dialogProps), {}, {
        __css: dialogStyles,
        children: children
      }))
    }))
  });
});
DrawerContent.displayName = "DrawerContent";

var _excluded$12 = ["className"];
var ModalFooter = forwardRef(function (props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$12);
  var _className = cx("chakra-modal__footer", className);
  var styles = useModalStyles();
  var footerStyles = _objectSpread2$1({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }, styles.footer);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.footer, _objectSpread2$1(_objectSpread2$1({
    ref: ref
  }, rest), {}, {
    __css: footerStyles,
    className: _className
  }));
});
ModalFooter.displayName = "ModalFooter";

var _excluded$11 = ["className"];
var ModalHeader = forwardRef(function (props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$11);
  var _useModalContext = useModalContext(),
    headerId = _useModalContext.headerId,
    setHeaderMounted = _useModalContext.setHeaderMounted;
  useEffect(function () {
    setHeaderMounted(true);
    return function () {
      return setHeaderMounted(false);
    };
  }, [setHeaderMounted]);
  var _className = cx("chakra-modal__header", className);
  var styles = useModalStyles();
  var headerStyles = _objectSpread2$1({
    flex: 0
  }, styles.header);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.header, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: _className,
    id: headerId
  }, rest), {}, {
    __css: headerStyles
  }));
});
ModalHeader.displayName = "ModalHeader";

var _excluded$10 = ["className", "transition", "motionProps"];
var MotionDiv$1 = chakra(motion.div);
var ModalOverlay = forwardRef(function (props, ref) {
  var className = props.className;
    props.transition;
    var _motionProps = props.motionProps,
    rest = _objectWithoutProperties$1(props, _excluded$10);
  var _className = cx("chakra-modal__overlay", className);
  var styles = useModalStyles();
  var overlayStyle = _objectSpread2$1({
    pos: "fixed",
    left: "0",
    top: "0",
    w: "100vw",
    h: "100vh"
  }, styles.overlay);
  var _useModalContext = useModalContext(),
    motionPreset = _useModalContext.motionPreset;
  var defaultMotionProps = motionPreset === "none" ? {} : fadeConfig;
  var motionProps = _motionProps || defaultMotionProps;
  return /* @__PURE__ */jsxRuntimeExports.jsx(MotionDiv$1, _objectSpread2$1(_objectSpread2$1({}, motionProps), {}, {
    __css: overlayStyle,
    ref: ref,
    className: _className
  }, rest));
});
ModalOverlay.displayName = "ModalOverlay";

var _excluded$$ = ["className"];
var ModalBody = forwardRef(function (props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$$);
  var _useModalContext = useModalContext(),
    bodyId = _useModalContext.bodyId,
    setBodyMounted = _useModalContext.setBodyMounted;
  useEffect(function () {
    setBodyMounted(true);
    return function () {
      return setBodyMounted(false);
    };
  }, [setBodyMounted]);
  var _className = cx("chakra-modal__body", className);
  var styles = useModalStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: _className,
    id: bodyId
  }, rest), {}, {
    __css: styles.body
  }));
});
ModalBody.displayName = "ModalBody";

var _excluded$_ = ["onClick", "className"];
var ModalCloseButton = forwardRef(function (props, ref) {
  var onClick = props.onClick,
    className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$_);
  var _useModalContext = useModalContext(),
    onClose = _useModalContext.onClose;
  var _className = cx("chakra-modal__close-btn", className);
  var styles = useModalStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(CloseButton, _objectSpread2$1({
    ref: ref,
    __css: styles.closeButton,
    className: _className,
    onClick: callAllHandlers$1(onClick, function (event) {
      event.stopPropagation();
      onClose();
    })
  }, rest));
});
ModalCloseButton.displayName = "ModalCloseButton";

var _createContext$5 = createContext$1({
    name: "PopoverContext",
    errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
  }),
  _createContext2$5 = _slicedToArray$1(_createContext$5, 2),
  PopoverProvider = _createContext2$5[0],
  usePopoverContext = _createContext2$5[1];
var _createContext3$1 = createContext$1({
    name: "PopoverStylesContext",
    errorMessage: "usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Popover />\" "
  }),
  _createContext4$1 = _slicedToArray$1(_createContext3$1, 2),
  PopoverStylesProvider = _createContext4$1[0],
  usePopoverStyles = _createContext4$1[1];

var PopoverHeader = forwardRef(function PopoverHeader2(props, ref) {
  var _usePopoverContext = usePopoverContext(),
    getHeaderProps = _usePopoverContext.getHeaderProps;
  var styles = usePopoverStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.header, _objectSpread2$1(_objectSpread2$1({}, getHeaderProps(props, ref)), {}, {
    className: cx("chakra-popover__header", props.className),
    __css: styles.header
  }));
});
PopoverHeader.displayName = "PopoverHeader";

function PopoverTrigger(props) {
  var child = Children.only(props.children);
  var _usePopoverContext = usePopoverContext(),
    getTriggerProps = _usePopoverContext.getTriggerProps;
  return /*#__PURE__*/cloneElement(child, getTriggerProps(child.props, child.ref));
}
PopoverTrigger.displayName = "PopoverTrigger";

var _excluded$Z = ["closeOnBlur", "closeOnEsc", "initialFocusRef", "id", "returnFocusOnClose", "autoFocus", "arrowSize", "arrowShadowColor", "trigger", "openDelay", "closeDelay", "isLazy", "lazyBehavior", "computePositionOnMount"];
var TRIGGER = {
  click: "click",
  hover: "hover"
};
function usePopover() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$closeOnBlur = props.closeOnBlur,
    closeOnBlur = _props$closeOnBlur === void 0 ? true : _props$closeOnBlur,
    _props$closeOnEsc = props.closeOnEsc,
    closeOnEsc = _props$closeOnEsc === void 0 ? true : _props$closeOnEsc,
    initialFocusRef = props.initialFocusRef,
    id = props.id,
    _props$returnFocusOnC = props.returnFocusOnClose,
    returnFocusOnClose = _props$returnFocusOnC === void 0 ? true : _props$returnFocusOnC,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
    arrowSize = props.arrowSize,
    arrowShadowColor = props.arrowShadowColor,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? TRIGGER.click : _props$trigger,
    _props$openDelay = props.openDelay,
    openDelay = _props$openDelay === void 0 ? 200 : _props$openDelay,
    _props$closeDelay = props.closeDelay,
    closeDelay = _props$closeDelay === void 0 ? 200 : _props$closeDelay,
    isLazy = props.isLazy,
    _props$lazyBehavior = props.lazyBehavior,
    lazyBehavior = _props$lazyBehavior === void 0 ? "unmount" : _props$lazyBehavior,
    computePositionOnMount = props.computePositionOnMount,
    popperProps = _objectWithoutProperties$1(props, _excluded$Z);
  var _useDisclosure = useDisclosure(props),
    isOpen = _useDisclosure.isOpen,
    onClose = _useDisclosure.onClose,
    onOpen = _useDisclosure.onOpen,
    onToggle = _useDisclosure.onToggle;
  var anchorRef = useRef(null);
  var triggerRef = useRef(null);
  var popoverRef = useRef(null);
  var isHoveringRef = useRef(false);
  var hasBeenOpened = useRef(false);
  if (isOpen) {
    hasBeenOpened.current = true;
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    hasHeader = _useState2[0],
    setHasHeader = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    hasBody = _useState4[0],
    setHasBody = _useState4[1];
  var uuid = useId$1();
  var uid = id != null ? id : uuid;
  var _map = ["popover-trigger", "popover-content", "popover-header", "popover-body"].map(function (id2) {
      return "".concat(id2, "-").concat(uid);
    }),
    _map2 = _slicedToArray$1(_map, 4),
    triggerId = _map2[0],
    popoverId = _map2[1],
    headerId = _map2[2],
    bodyId = _map2[3];
  var _usePopper = usePopper(_objectSpread2$1(_objectSpread2$1({}, popperProps), {}, {
      enabled: isOpen || !!computePositionOnMount
    })),
    referenceRef = _usePopper.referenceRef,
    getArrowProps = _usePopper.getArrowProps,
    getPopperProps = _usePopper.getPopperProps,
    getArrowInnerProps = _usePopper.getArrowInnerProps,
    forceUpdate = _usePopper.forceUpdate;
  var animated = useAnimationState({
    isOpen: isOpen,
    ref: popoverRef
  });
  useFocusOnPointerDown({
    enabled: isOpen,
    ref: triggerRef
  });
  useFocusOnHide(popoverRef, {
    focusRef: triggerRef,
    visible: isOpen,
    shouldFocus: returnFocusOnClose && trigger === TRIGGER.click
  });
  useFocusOnShow(popoverRef, {
    focusRef: initialFocusRef,
    visible: isOpen,
    shouldFocus: autoFocus && trigger === TRIGGER.click
  });
  var shouldRenderChildren = lazyDisclosure({
    wasSelected: hasBeenOpened.current,
    enabled: isLazy,
    mode: lazyBehavior,
    isSelected: animated.present
  });
  var getPopoverProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var popoverProps = _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      style: _objectSpread2$1(_objectSpread2$1({}, props2.style), {}, _defineProperty$3(_defineProperty$3({
        transformOrigin: cssVars.transformOrigin.varRef
      }, cssVars.arrowSize["var"], arrowSize ? "".concat(arrowSize, "px") : void 0), cssVars.arrowShadowColor["var"], arrowShadowColor)),
      ref: mergeRefs(popoverRef, _ref),
      children: shouldRenderChildren ? props2.children : null,
      id: popoverId,
      tabIndex: -1,
      role: "dialog",
      onKeyDown: callAllHandlers$1(props2.onKeyDown, function (event) {
        if (closeOnEsc && event.key === "Escape") {
          onClose();
        }
      }),
      onBlur: callAllHandlers$1(props2.onBlur, function (event) {
        var relatedTarget = getRelatedTarget(event);
        var targetIsPopover = contains(popoverRef.current, relatedTarget);
        var targetIsTrigger = contains(triggerRef.current, relatedTarget);
        var isValidBlur = !targetIsPopover && !targetIsTrigger;
        if (isOpen && closeOnBlur && isValidBlur) {
          onClose();
        }
      }),
      "aria-labelledby": hasHeader ? headerId : void 0,
      "aria-describedby": hasBody ? bodyId : void 0
    });
    if (trigger === TRIGGER.hover) {
      popoverProps.role = "tooltip";
      popoverProps.onMouseEnter = callAllHandlers$1(props2.onMouseEnter, function () {
        isHoveringRef.current = true;
      });
      popoverProps.onMouseLeave = callAllHandlers$1(props2.onMouseLeave, function (event) {
        if (event.nativeEvent.relatedTarget === null) {
          return;
        }
        isHoveringRef.current = false;
        setTimeout(function () {
          return onClose();
        }, closeDelay);
      });
    }
    return popoverProps;
  }, [shouldRenderChildren, popoverId, hasHeader, headerId, hasBody, bodyId, trigger, closeOnEsc, onClose, isOpen, closeOnBlur, closeDelay, arrowShadowColor, arrowSize]);
  var getPopoverPositionerProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return getPopperProps(_objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      style: _objectSpread2$1({
        visibility: isOpen ? "visible" : "hidden"
      }, props2.style)
    }), forwardedRef);
  }, [isOpen, getPopperProps]);
  var getAnchorProps = useCallback(function (props2) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      // If anchor is rendered, it is used as reference.
      ref: mergeRefs(_ref, anchorRef, referenceRef)
    });
  }, [anchorRef, referenceRef]);
  var openTimeout = useRef();
  var closeTimeout = useRef();
  var maybeReferenceRef = useCallback(function (node) {
    if (anchorRef.current == null) {
      referenceRef(node);
    }
  }, [referenceRef]);
  var getTriggerProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var triggerProps = _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: mergeRefs(triggerRef, _ref, maybeReferenceRef),
      id: triggerId,
      "aria-haspopup": "dialog",
      "aria-expanded": isOpen,
      "aria-controls": popoverId
    });
    if (trigger === TRIGGER.click) {
      triggerProps.onClick = callAllHandlers$1(props2.onClick, onToggle);
    }
    if (trigger === TRIGGER.hover) {
      triggerProps.onFocus = callAllHandlers$1(props2.onFocus, function () {
        if (openTimeout.current === void 0) {
          onOpen();
        }
      });
      triggerProps.onBlur = callAllHandlers$1(props2.onBlur, function (event) {
        var relatedTarget = getRelatedTarget(event);
        var isValidBlur = !contains(popoverRef.current, relatedTarget);
        if (isOpen && closeOnBlur && isValidBlur) {
          onClose();
        }
      });
      triggerProps.onKeyDown = callAllHandlers$1(props2.onKeyDown, function (event) {
        if (event.key === "Escape") {
          onClose();
        }
      });
      triggerProps.onMouseEnter = callAllHandlers$1(props2.onMouseEnter, function () {
        isHoveringRef.current = true;
        openTimeout.current = window.setTimeout(function () {
          return onOpen();
        }, openDelay);
      });
      triggerProps.onMouseLeave = callAllHandlers$1(props2.onMouseLeave, function () {
        isHoveringRef.current = false;
        if (openTimeout.current) {
          clearTimeout(openTimeout.current);
          openTimeout.current = void 0;
        }
        closeTimeout.current = window.setTimeout(function () {
          if (isHoveringRef.current === false) {
            onClose();
          }
        }, closeDelay);
      });
    }
    return triggerProps;
  }, [triggerId, isOpen, popoverId, trigger, maybeReferenceRef, onToggle, onOpen, closeOnBlur, onClose, openDelay, closeDelay]);
  useEffect(function () {
    return function () {
      if (openTimeout.current) {
        clearTimeout(openTimeout.current);
      }
      if (closeTimeout.current) {
        clearTimeout(closeTimeout.current);
      }
    };
  }, []);
  var getHeaderProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      id: headerId,
      ref: mergeRefs(ref, function (node) {
        setHasHeader(!!node);
      })
    });
  }, [headerId]);
  var getBodyProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      id: bodyId,
      ref: mergeRefs(ref, function (node) {
        setHasBody(!!node);
      })
    });
  }, [bodyId]);
  return {
    forceUpdate: forceUpdate,
    isOpen: isOpen,
    onAnimationComplete: animated.onComplete,
    onClose: onClose,
    getAnchorProps: getAnchorProps,
    getArrowProps: getArrowProps,
    getArrowInnerProps: getArrowInnerProps,
    getPopoverPositionerProps: getPopoverPositionerProps,
    getPopoverProps: getPopoverProps,
    getTriggerProps: getTriggerProps,
    getHeaderProps: getHeaderProps,
    getBodyProps: getBodyProps
  };
}
function contains(parent, child) {
  return parent === child || (parent == null ? void 0 : parent.contains(child));
}
function getRelatedTarget(event) {
  var _a;
  var activeEl = event.currentTarget.ownerDocument.activeElement;
  return (_a = event.relatedTarget) != null ? _a : activeEl;
}

var _excluded$Y = ["children"];
function Popover$1(props) {
  var styles = useMultiStyleConfig("Popover", props);
  var _omitThemingProps = omitThemingProps(props),
    children = _omitThemingProps.children,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$Y);
  var theme = useTheme();
  var context = usePopover(_objectSpread2$1(_objectSpread2$1({}, rest), {}, {
    direction: theme.direction
  }));
  return /* @__PURE__ */jsxRuntimeExports.jsx(PopoverProvider, {
    value: context,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(PopoverStylesProvider, {
      value: styles,
      children: runIfFn$2(children, {
        isOpen: context.isOpen,
        onClose: context.onClose,
        forceUpdate: context.forceUpdate
      })
    })
  });
}
Popover$1.displayName = "Popover";

function PopoverAnchor(props) {
  var child = Children.only(props.children);
  var _usePopoverContext = usePopoverContext(),
    getAnchorProps = _usePopoverContext.getAnchorProps;
  return /*#__PURE__*/cloneElement(child, getAnchorProps(child.props, child.ref));
}
PopoverAnchor.displayName = "PopoverAnchor";

var resolveVar = function resolveVar(scale, value) {
  return value ? "".concat(scale, ".").concat(value, ", ").concat(value) : void 0;
};
function PopoverArrow$1(props) {
  var _a;
  var bg = props.bg,
    bgColor = props.bgColor,
    backgroundColor = props.backgroundColor,
    shadow = props.shadow,
    boxShadow = props.boxShadow,
    shadowColor = props.shadowColor;
  var _usePopoverContext = usePopoverContext(),
    getArrowProps = _usePopoverContext.getArrowProps,
    getArrowInnerProps = _usePopoverContext.getArrowInnerProps;
  var styles = usePopoverStyles();
  var arrowBg = (_a = bg != null ? bg : bgColor) != null ? _a : backgroundColor;
  var arrowShadow = shadow != null ? shadow : boxShadow;
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, getArrowProps()), {}, {
    className: "chakra-popover__arrow-positioner",
    children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
      className: cx("chakra-popover__arrow", props.className)
    }, getArrowInnerProps(props)), {}, {
      __css: _objectSpread2$1({
        "--popper-arrow-shadow-color": resolveVar("colors", shadowColor),
        "--popper-arrow-bg": resolveVar("colors", arrowBg),
        "--popper-arrow-shadow": resolveVar("shadows", arrowShadow)
      }, styles.arrow)
    }))
  }));
}
PopoverArrow$1.displayName = "PopoverArrow";

var PopoverBody = forwardRef(function PopoverBody2(props, ref) {
  var _usePopoverContext = usePopoverContext(),
    getBodyProps = _usePopoverContext.getBodyProps;
  var styles = usePopoverStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, getBodyProps(props, ref)), {}, {
    className: cx("chakra-popover__body", props.className),
    __css: styles.body
  }));
});
PopoverBody.displayName = "PopoverBody";

var PopoverCloseButton$1 = forwardRef(function PopoverCloseButton2(props, ref) {
  var _usePopoverContext = usePopoverContext(),
    onClose = _usePopoverContext.onClose;
  var styles = usePopoverStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(CloseButton, _objectSpread2$1({
    size: "sm",
    onClick: onClose,
    className: cx("chakra-popover__close-btn", props.className),
    __css: styles.closeButton,
    ref: ref
  }, props));
});
PopoverCloseButton$1.displayName = "PopoverCloseButton";

var _excluded$X = ["variants"];
function mergeVariants(variants) {
  if (!variants) return;
  return {
    enter: _objectSpread2$1(_objectSpread2$1({}, variants.enter), {}, {
      visibility: "visible"
    }),
    exit: _objectSpread2$1(_objectSpread2$1({}, variants.exit), {}, {
      transitionEnd: {
        visibility: "hidden"
      }
    })
  };
}
var scaleFade = {
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
      ease: [0.4, 0, 1, 1]
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.15,
      ease: [0, 0, 0.2, 1]
    }
  }
};
var MotionSection = chakra(motion.section);
var PopoverTransition = forwardRef(function PopoverTransition2(props, ref) {
  var _props$variants = props.variants,
    variants = _props$variants === void 0 ? scaleFade : _props$variants,
    rest = _objectWithoutProperties$1(props, _excluded$X);
  var _usePopoverContext = usePopoverContext(),
    isOpen = _usePopoverContext.isOpen;
  return /* @__PURE__ */jsxRuntimeExports.jsx(MotionSection, _objectSpread2$1({
    ref: ref,
    variants: mergeVariants(variants),
    initial: false,
    animate: isOpen ? "enter" : "exit"
  }, rest));
});
PopoverTransition.displayName = "PopoverTransition";

var _excluded$W = ["rootProps", "motionProps"];
var PopoverContent$1 = forwardRef(function PopoverContent2(props, ref) {
  var rootProps = props.rootProps,
    motionProps = props.motionProps,
    contentProps = _objectWithoutProperties$1(props, _excluded$W);
  var _usePopoverContext = usePopoverContext(),
    getPopoverProps = _usePopoverContext.getPopoverProps,
    getPopoverPositionerProps = _usePopoverContext.getPopoverPositionerProps,
    onAnimationComplete = _usePopoverContext.onAnimationComplete;
  var styles = usePopoverStyles();
  var contentStyles = _objectSpread2$1({
    position: "relative",
    display: "flex",
    flexDirection: "column"
  }, styles.content);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, getPopoverPositionerProps(rootProps)), {}, {
    __css: styles.popper,
    className: "chakra-popover__popper",
    children: /* @__PURE__ */jsxRuntimeExports.jsx(PopoverTransition, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, motionProps), getPopoverProps(contentProps, ref)), {}, {
      onAnimationComplete: callAll(onAnimationComplete, contentProps.onAnimationComplete),
      className: cx("chakra-popover__content", props.className),
      __css: contentStyles
    }))
  }));
});
PopoverContent$1.displayName = "PopoverContent";

var Circle = function Circle(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.circle, _objectSpread2$1({
    cx: 50,
    cy: 50,
    r: 42,
    fill: "transparent"
  }, props));
};
Circle.displayName = "Circle";

function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}
var spin = keyframes$2({
  "0%": {
    strokeDasharray: "1, 400",
    strokeDashoffset: "0"
  },
  "50%": {
    strokeDasharray: "400, 400",
    strokeDashoffset: "-100"
  },
  "100%": {
    strokeDasharray: "400, 400",
    strokeDashoffset: "-260"
  }
});
var rotate = keyframes$2({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});
var progress = keyframes$2({
  "0%": {
    left: "-40%"
  },
  "100%": {
    left: "100%"
  }
});
var stripe = keyframes$2({
  from: {
    backgroundPosition: "1rem 0"
  },
  to: {
    backgroundPosition: "0 0"
  }
});
function getProgressProps(options) {
  var _options$value = options.value,
    value = _options$value === void 0 ? 0 : _options$value,
    min = options.min,
    max = options.max,
    valueText = options.valueText,
    getValueText = options.getValueText,
    isIndeterminate = options.isIndeterminate,
    _options$role = options.role,
    role = _options$role === void 0 ? "progressbar" : _options$role;
  var percent = valueToPercent(value, min, max);
  var getAriaValueText = function getAriaValueText() {
    if (value == null) return void 0;
    return typeof getValueText === "function" ? getValueText(value, percent) : valueText;
  };
  return {
    bind: {
      "data-indeterminate": isIndeterminate ? "" : void 0,
      "aria-valuemax": max,
      "aria-valuemin": min,
      "aria-valuenow": isIndeterminate ? void 0 : value,
      "aria-valuetext": getAriaValueText(),
      role: role
    },
    percent: percent,
    value: value
  };
}

var _excluded$V = ["size", "isIndeterminate"];
var Shape = function Shape(props) {
  var size = props.size,
    isIndeterminate = props.isIndeterminate,
    rest = _objectWithoutProperties$1(props, _excluded$V);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.svg, _objectSpread2$1({
    viewBox: "0 0 100 100",
    __css: {
      width: size,
      height: size,
      animation: isIndeterminate ? "".concat(rotate, " 2s linear infinite") : void 0
    }
  }, rest));
};
Shape.displayName = "Shape";

var _excluded$U = ["size", "max", "min", "valueText", "getValueText", "value", "capIsRound", "children", "thickness", "color", "trackColor", "isIndeterminate"];
var CircularProgress = forwardRef(function (props, ref) {
  var _a;
  var _props$size = props.size,
    size = _props$size === void 0 ? "48px" : _props$size,
    _props$max = props.max,
    max = _props$max === void 0 ? 100 : _props$max,
    _props$min = props.min,
    min = _props$min === void 0 ? 0 : _props$min,
    valueText = props.valueText,
    getValueText = props.getValueText,
    value = props.value,
    capIsRound = props.capIsRound,
    children = props.children,
    _props$thickness = props.thickness,
    thickness = _props$thickness === void 0 ? "10px" : _props$thickness,
    _props$color = props.color,
    color = _props$color === void 0 ? "#0078d4" : _props$color,
    _props$trackColor = props.trackColor,
    trackColor = _props$trackColor === void 0 ? "#edebe9" : _props$trackColor,
    isIndeterminate = props.isIndeterminate,
    rest = _objectWithoutProperties$1(props, _excluded$U);
  var progress = getProgressProps({
    min: min,
    max: max,
    value: value,
    valueText: valueText,
    getValueText: getValueText,
    isIndeterminate: isIndeterminate
  });
  var determinant = isIndeterminate ? void 0 : ((_a = progress.percent) != null ? _a : 0) * 2.64;
  var strokeDasharray = determinant == null ? void 0 : "".concat(determinant, " ").concat(264 - determinant);
  var indicatorProps = isIndeterminate ? {
    css: {
      animation: "".concat(spin, " 1.5s linear infinite")
    }
  } : {
    strokeDashoffset: 66,
    strokeDasharray: strokeDasharray,
    transitionProperty: "stroke-dasharray, stroke",
    transitionDuration: "0.6s",
    transitionTimingFunction: "ease"
  };
  var rootStyles = {
    display: "inline-block",
    position: "relative",
    verticalAlign: "middle",
    fontSize: size
  };
  return /* @__PURE__ */jsxRuntimeExports.jsxs(chakra.div, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: "chakra-progress"
  }, progress.bind), rest), {}, {
    __css: rootStyles,
    children: [/* @__PURE__ */jsxRuntimeExports.jsxs(Shape, {
      size: size,
      isIndeterminate: isIndeterminate,
      children: [/* @__PURE__ */jsxRuntimeExports.jsx(Circle, {
        stroke: trackColor,
        strokeWidth: thickness,
        className: "chakra-progress__track"
      }), /* @__PURE__ */jsxRuntimeExports.jsx(Circle, _objectSpread2$1({
        stroke: color,
        strokeWidth: thickness,
        className: "chakra-progress__indicator",
        strokeLinecap: capIsRound ? "round" : void 0,
        opacity: progress.value === 0 && !isIndeterminate ? 0 : void 0
      }, indicatorProps))]
    }), children]
  }));
});
CircularProgress.displayName = "CircularProgress";

var _excluded$T = ["min", "max", "value", "isIndeterminate", "role"],
  _excluded2$4 = ["value", "min", "max", "hasStripe", "isAnimated", "children", "borderRadius", "isIndeterminate", "aria-label", "aria-labelledby", "aria-valuetext", "title", "role"];
var _createContext$4 = createContext$1({
    name: "ProgressStylesContext",
    errorMessage: "useProgressStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Progress />\" "
  }),
  _createContext2$4 = _slicedToArray$1(_createContext$4, 2),
  ProgressStylesProvider = _createContext2$4[0],
  useProgressStyles = _createContext2$4[1];
var ProgressFilledTrack = forwardRef(function (props, ref) {
  var min = props.min,
    max = props.max,
    value = props.value,
    isIndeterminate = props.isIndeterminate,
    role = props.role,
    rest = _objectWithoutProperties$1(props, _excluded$T);
  var progress2 = getProgressProps({
    value: value,
    min: min,
    max: max,
    isIndeterminate: isIndeterminate,
    role: role
  });
  var styles = useProgressStyles();
  var trackStyles = _objectSpread2$1({
    height: "100%"
  }, styles.filledTrack);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
    ref: ref,
    style: _objectSpread2$1({
      width: "".concat(progress2.percent, "%")
    }, rest.style)
  }, progress2.bind), rest), {}, {
    __css: trackStyles
  }));
});
var Progress$1 = forwardRef(function (props, ref) {
  var _a;
  var _omitThemingProps = omitThemingProps(props),
    value = _omitThemingProps.value,
    _omitThemingProps$min = _omitThemingProps.min,
    min = _omitThemingProps$min === void 0 ? 0 : _omitThemingProps$min,
    _omitThemingProps$max = _omitThemingProps.max,
    max = _omitThemingProps$max === void 0 ? 100 : _omitThemingProps$max,
    hasStripe = _omitThemingProps.hasStripe,
    isAnimated = _omitThemingProps.isAnimated,
    children = _omitThemingProps.children,
    propBorderRadius = _omitThemingProps.borderRadius,
    isIndeterminate = _omitThemingProps.isIndeterminate,
    ariaLabel = _omitThemingProps["aria-label"],
    ariaLabelledBy = _omitThemingProps["aria-labelledby"],
    ariaValueText = _omitThemingProps["aria-valuetext"],
    title = _omitThemingProps.title,
    role = _omitThemingProps.role,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded2$4);
  var styles = useMultiStyleConfig("Progress", props);
  var borderRadius = propBorderRadius != null ? propBorderRadius : (_a = styles.track) == null ? void 0 : _a.borderRadius;
  var stripeAnimation = {
    animation: "".concat(stripe, " 1s linear infinite")
  };
  var shouldAddStripe = !isIndeterminate && hasStripe;
  var shouldAnimateStripe = shouldAddStripe && isAnimated;
  var css = _objectSpread2$1(_objectSpread2$1({}, shouldAnimateStripe && stripeAnimation), isIndeterminate && {
    position: "absolute",
    willChange: "left",
    minWidth: "50%",
    animation: "".concat(progress, " 1s ease infinite normal none running")
  });
  var trackStyles = _objectSpread2$1({
    overflow: "hidden",
    position: "relative"
  }, styles.track);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    borderRadius: borderRadius,
    __css: trackStyles
  }, rest), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsxs(ProgressStylesProvider, {
      value: styles,
      children: [/* @__PURE__ */jsxRuntimeExports.jsx(ProgressFilledTrack, {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-valuetext": ariaValueText,
        min: min,
        max: max,
        value: value,
        isIndeterminate: isIndeterminate,
        css: css,
        borderRadius: borderRadius,
        title: title,
        role: role
      }), children]
    })
  }));
});
Progress$1.displayName = "Progress";

var _excluded$S = ["onChange", "value", "defaultValue", "name", "isDisabled", "isFocusable", "isNative"];
function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
}
function useRadioGroup() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onChangeProp = props.onChange,
    valueProp = props.value,
    defaultValue = props.defaultValue,
    nameProp = props.name,
    isDisabled = props.isDisabled,
    isFocusable = props.isFocusable,
    isNative = props.isNative,
    htmlProps = _objectWithoutProperties$1(props, _excluded$S);
  var _useState = useState(defaultValue || ""),
    _useState2 = _slicedToArray$1(_useState, 2),
    valueState = _useState2[0],
    setValue = _useState2[1];
  var isControlled = typeof valueProp !== "undefined";
  var value = isControlled ? valueProp : valueState;
  var ref = useRef(null);
  var focus = useCallback(function () {
    var rootNode = ref.current;
    if (!rootNode) return;
    var query = "input:not(:disabled):checked";
    var firstEnabledAndCheckedInput = rootNode.querySelector(query);
    if (firstEnabledAndCheckedInput) {
      firstEnabledAndCheckedInput.focus();
      return;
    }
    query = "input:not(:disabled)";
    var firstEnabledInput = rootNode.querySelector(query);
    firstEnabledInput == null ? void 0 : firstEnabledInput.focus();
  }, []);
  var uuid = useId$1();
  var fallbackName = "radio-".concat(uuid);
  var name = nameProp || fallbackName;
  var _onChange = useCallback(function (eventOrValue) {
    var nextValue = isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
    if (!isControlled) {
      setValue(nextValue);
    }
    onChangeProp == null ? void 0 : onChangeProp(String(nextValue));
  }, [onChangeProp, isControlled]);
  var getRootProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: mergeRefs(forwardedRef, ref),
      role: "radiogroup"
    });
  }, []);
  var getRadioProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var checkedKey = isNative ? "checked" : "isChecked";
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, _defineProperty$3(_defineProperty$3(_defineProperty$3({
      ref: ref2,
      name: name
    }, checkedKey, value != null ? props2.value === value : void 0), "onChange", function onChange(event) {
      _onChange(event);
    }), "data-radiogroup", true));
  }, [isNative, name, _onChange, value]);
  return {
    getRootProps: getRootProps,
    getRadioProps: getRadioProps,
    name: name,
    ref: ref,
    focus: focus,
    setValue: setValue,
    value: value,
    onChange: _onChange,
    isDisabled: isDisabled,
    isFocusable: isFocusable,
    htmlProps: htmlProps
  };
}

var _excluded$R = ["colorScheme", "size", "variant", "children", "className", "isDisabled", "isFocusable"];
var _createContext$3 = createContext$1({
    name: "RadioGroupContext",
    strict: false
  }),
  _createContext2$3 = _slicedToArray$1(_createContext$3, 2),
  RadioGroupProvider = _createContext2$3[0],
  useRadioGroupContext = _createContext2$3[1];
var RadioGroup$1 = forwardRef(function (props, ref) {
  var colorScheme = props.colorScheme,
    size = props.size,
    variant = props.variant,
    children = props.children,
    className = props.className,
    isDisabled = props.isDisabled,
    isFocusable = props.isFocusable,
    rest = _objectWithoutProperties$1(props, _excluded$R);
  var _useRadioGroup = useRadioGroup(rest),
    value = _useRadioGroup.value,
    onChange = _useRadioGroup.onChange,
    getRootProps = _useRadioGroup.getRootProps,
    name = _useRadioGroup.name,
    htmlProps = _useRadioGroup.htmlProps;
  var group = useMemo(function () {
    return {
      name: name,
      size: size,
      onChange: onChange,
      colorScheme: colorScheme,
      value: value,
      variant: variant,
      isDisabled: isDisabled,
      isFocusable: isFocusable
    };
  }, [name, size, onChange, colorScheme, value, variant, isDisabled, isFocusable]);
  return /* @__PURE__ */jsxRuntimeExports.jsx(RadioGroupProvider, {
    value: group,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, getRootProps(htmlProps, ref)), {}, {
      className: cx("chakra-radio-group", className),
      children: children
    }))
  });
});
RadioGroup$1.displayName = "RadioGroup";

var _excluded$Q = ["defaultChecked", "isChecked", "isFocusable", "isDisabled", "isReadOnly", "isRequired", "onChange", "isInvalid", "name", "value", "id", "data-radiogroup", "aria-describedby"];

// ../visually-hidden/src/visually-hidden.style.ts
var visuallyHiddenStyle = {
  border: "0",
  clip: "rect(0, 0, 0, 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
function useRadio() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultChecked = props.defaultChecked,
    isCheckedProp = props.isChecked,
    isFocusable = props.isFocusable,
    isDisabledProp = props.isDisabled,
    isReadOnlyProp = props.isReadOnly,
    isRequiredProp = props.isRequired,
    onChange = props.onChange,
    isInvalidProp = props.isInvalid,
    name = props.name,
    value = props.value,
    idProp = props.id,
    dataRadioGroup = props["data-radiogroup"],
    ariaDescribedBy = props["aria-describedby"],
    htmlProps = _objectWithoutProperties$1(props, _excluded$Q);
  var uuid = "radio-".concat(useId$1());
  var formControl = useFormControlContext();
  var group = useRadioGroupContext();
  var isWithinRadioGroup = !!group || !!dataRadioGroup;
  var isWithinFormControl = !!formControl;
  var id = isWithinFormControl && !isWithinRadioGroup ? formControl.id : uuid;
  id = idProp != null ? idProp : id;
  var isDisabled = isDisabledProp != null ? isDisabledProp : formControl == null ? void 0 : formControl.isDisabled;
  var isReadOnly = isReadOnlyProp != null ? isReadOnlyProp : formControl == null ? void 0 : formControl.isReadOnly;
  var isRequired = isRequiredProp != null ? isRequiredProp : formControl == null ? void 0 : formControl.isRequired;
  var isInvalid = isInvalidProp != null ? isInvalidProp : formControl == null ? void 0 : formControl.isInvalid;
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    isFocusVisible = _useState2[0],
    setIsFocusVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    isFocused = _useState4[0],
    setFocused = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray$1(_useState5, 2),
    isHovered = _useState6[0],
    setHovering = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray$1(_useState7, 2),
    isActive = _useState8[0],
    setActive = _useState8[1];
  var _useState9 = useState(Boolean(defaultChecked)),
    _useState10 = _slicedToArray$1(_useState9, 2),
    isCheckedState = _useState10[0],
    setChecked = _useState10[1];
  var isControlled = typeof isCheckedProp !== "undefined";
  var isChecked = isControlled ? isCheckedProp : isCheckedState;
  useEffect(function () {
    return trackFocusVisible(setIsFocusVisible);
  }, []);
  var handleChange = useCallback(function (event) {
    if (isReadOnly || isDisabled) {
      event.preventDefault();
      return;
    }
    if (!isControlled) {
      setChecked(event.target.checked);
    }
    onChange == null ? void 0 : onChange(event);
  }, [isControlled, isDisabled, isReadOnly, onChange]);
  var onKeyDown = useCallback(function (event) {
    if (event.key === " ") {
      setActive(true);
    }
  }, [setActive]);
  var onKeyUp = useCallback(function (event) {
    if (event.key === " ") {
      setActive(false);
    }
  }, [setActive]);
  var getRadioProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: ref,
      "data-active": dataAttr(isActive),
      "data-hover": dataAttr(isHovered),
      "data-disabled": dataAttr(isDisabled),
      "data-invalid": dataAttr(isInvalid),
      "data-checked": dataAttr(isChecked),
      "data-focus": dataAttr(isFocused),
      "data-focus-visible": dataAttr(isFocused && isFocusVisible),
      "data-readonly": dataAttr(isReadOnly),
      "aria-hidden": true,
      onMouseDown: callAllHandlers$1(props2.onMouseDown, function () {
        return setActive(true);
      }),
      onMouseUp: callAllHandlers$1(props2.onMouseUp, function () {
        return setActive(false);
      }),
      onMouseEnter: callAllHandlers$1(props2.onMouseEnter, function () {
        return setHovering(true);
      }),
      onMouseLeave: callAllHandlers$1(props2.onMouseLeave, function () {
        return setHovering(false);
      })
    });
  }, [isActive, isHovered, isDisabled, isInvalid, isChecked, isFocused, isReadOnly, isFocusVisible]);
  var _ref = formControl != null ? formControl : {},
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur;
  var getInputProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var trulyDisabled = isDisabled && !isFocusable;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      id: id,
      ref: ref,
      type: "radio",
      name: name,
      value: value,
      onChange: callAllHandlers$1(props2.onChange, handleChange),
      onBlur: callAllHandlers$1(onBlur, props2.onBlur, function () {
        return setFocused(false);
      }),
      onFocus: callAllHandlers$1(onFocus, props2.onFocus, function () {
        return setFocused(true);
      }),
      onKeyDown: callAllHandlers$1(props2.onKeyDown, onKeyDown),
      onKeyUp: callAllHandlers$1(props2.onKeyUp, onKeyUp),
      checked: isChecked,
      disabled: trulyDisabled,
      readOnly: isReadOnly,
      required: isRequired,
      "aria-invalid": ariaAttr(isInvalid),
      "aria-disabled": ariaAttr(trulyDisabled),
      "aria-required": ariaAttr(isRequired),
      "data-readonly": dataAttr(isReadOnly),
      "aria-describedby": ariaDescribedBy,
      style: visuallyHiddenStyle
    });
  }, [isDisabled, isFocusable, id, name, value, handleChange, onBlur, onFocus, onKeyDown, onKeyUp, isChecked, isReadOnly, isRequired, isInvalid, ariaDescribedBy]);
  var getLabelProps = function getLabelProps() {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: ref,
      onMouseDown: callAllHandlers$1(props2.onMouseDown, stopEvent),
      "data-disabled": dataAttr(isDisabled),
      "data-checked": dataAttr(isChecked),
      "data-invalid": dataAttr(isInvalid)
    });
  };
  var getRootProps = function getRootProps(props2) {
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: ref,
      "data-disabled": dataAttr(isDisabled),
      "data-checked": dataAttr(isChecked),
      "data-invalid": dataAttr(isInvalid)
    });
  };
  var state = {
    isInvalid: isInvalid,
    isFocused: isFocused,
    isChecked: isChecked,
    isActive: isActive,
    isHovered: isHovered,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired
  };
  return {
    state: state,
    /**
     * @deprecated - use `getRadioProps` instead
     */
    getCheckboxProps: getRadioProps,
    getRadioProps: getRadioProps,
    getInputProps: getInputProps,
    getLabelProps: getLabelProps,
    getRootProps: getRootProps,
    htmlProps: htmlProps
  };
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}

var _excluded$P = ["spacing", "children", "isDisabled", "isFocusable", "inputProps"];

// ../../utilities/object-utils/src/split.ts
function split$1(object, keys) {
  var picked = {};
  var omitted = {};
  for (var _i = 0, _Object$entries = Object.entries(object); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray$1(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (keys.includes(key)) picked[key] = value;else omitted[key] = value;
  }
  return [picked, omitted];
}
var Radio$1 = forwardRef(function (props, ref) {
  var _a;
  var group = useRadioGroupContext();
  var onChangeProp = props.onChange,
    valueProp = props.value;
  var styles = useMultiStyleConfig("Radio", _objectSpread2$1(_objectSpread2$1({}, group), props));
  var ownProps = omitThemingProps(props);
  var _ownProps$spacing = ownProps.spacing,
    spacing = _ownProps$spacing === void 0 ? "0.5rem" : _ownProps$spacing,
    children = ownProps.children,
    _ownProps$isDisabled = ownProps.isDisabled,
    isDisabled = _ownProps$isDisabled === void 0 ? group == null ? void 0 : group.isDisabled : _ownProps$isDisabled,
    _ownProps$isFocusable = ownProps.isFocusable,
    isFocusable = _ownProps$isFocusable === void 0 ? group == null ? void 0 : group.isFocusable : _ownProps$isFocusable,
    htmlInputProps = ownProps.inputProps,
    rest = _objectWithoutProperties$1(ownProps, _excluded$P);
  var isChecked = props.isChecked;
  if ((group == null ? void 0 : group.value) != null && valueProp != null) {
    isChecked = group.value === valueProp;
  }
  var onChange = onChangeProp;
  if ((group == null ? void 0 : group.onChange) && valueProp != null) {
    onChange = callAll(group.onChange, onChangeProp);
  }
  var name = (_a = props == null ? void 0 : props.name) != null ? _a : group == null ? void 0 : group.name;
  var _useRadio = useRadio(_objectSpread2$1(_objectSpread2$1({}, rest), {}, {
      isChecked: isChecked,
      isFocusable: isFocusable,
      isDisabled: isDisabled,
      onChange: onChange,
      name: name
    })),
    getInputProps = _useRadio.getInputProps,
    getCheckboxProps = _useRadio.getCheckboxProps,
    getLabelProps = _useRadio.getLabelProps,
    getRootProps = _useRadio.getRootProps,
    htmlProps = _useRadio.htmlProps;
  var _split = split$1(htmlProps, layoutPropNames),
    _split2 = _slicedToArray$1(_split, 2),
    layoutProps = _split2[0],
    otherProps = _split2[1];
  var checkboxProps = getCheckboxProps(otherProps);
  var inputProps = getInputProps(htmlInputProps, ref);
  var labelProps = getLabelProps();
  var rootProps = Object.assign({}, layoutProps, getRootProps());
  var rootStyles = _objectSpread2$1({
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "top",
    cursor: "pointer",
    position: "relative"
  }, styles.container);
  var checkboxStyles = _objectSpread2$1({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  }, styles.control);
  var labelStyles = _objectSpread2$1({
    userSelect: "none",
    marginStart: spacing
  }, styles.label);
  return /* @__PURE__ */jsxRuntimeExports.jsxs(chakra.label, _objectSpread2$1(_objectSpread2$1({
    className: "chakra-radio"
  }, rootProps), {}, {
    __css: rootStyles,
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("input", _objectSpread2$1({
      className: "chakra-radio__input"
    }, inputProps)), /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
      className: "chakra-radio__control"
    }, checkboxProps), {}, {
      __css: checkboxStyles
    })), children && /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
      className: "chakra-radio__label"
    }, labelProps), {}, {
      __css: labelStyles,
      children: children
    }))]
  }));
});
Radio$1.displayName = "Radio";

var _excluded$O = ["children", "placeholder", "className"];
var SelectField = forwardRef(function SelectField2(props, ref) {
  var children = props.children,
    placeholder = props.placeholder,
    className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$O);
  return /* @__PURE__ */jsxRuntimeExports.jsxs(chakra.select, _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
    ref: ref,
    className: cx("chakra-select", className),
    children: [placeholder && /* @__PURE__ */jsxRuntimeExports.jsx("option", {
      value: "",
      children: placeholder
    }), children]
  }));
});
SelectField.displayName = "SelectField";

var _excluded$N = ["rootProps", "placeholder", "icon", "color", "height", "h", "minH", "minHeight", "iconColor", "iconSize"],
  _excluded2$3 = ["children"];

// ../../utilities/object-utils/src/split.ts
function split(object, keys) {
  var picked = {};
  var omitted = {};
  for (var _i = 0, _Object$entries = Object.entries(object); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray$1(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (keys.includes(key)) picked[key] = value;else omitted[key] = value;
  }
  return [picked, omitted];
}
var Select$3 = forwardRef(function (props, ref) {
  var _a;
  var styles = useMultiStyleConfig("Select", props);
  var _omitThemingProps = omitThemingProps(props),
    rootProps = _omitThemingProps.rootProps,
    placeholder = _omitThemingProps.placeholder,
    icon = _omitThemingProps.icon,
    color = _omitThemingProps.color,
    height = _omitThemingProps.height,
    h = _omitThemingProps.h,
    minH = _omitThemingProps.minH,
    minHeight = _omitThemingProps.minHeight,
    iconColor = _omitThemingProps.iconColor,
    iconSize = _omitThemingProps.iconSize,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$N);
  var _split = split(rest, layoutPropNames),
    _split2 = _slicedToArray$1(_split, 2),
    layoutProps = _split2[0],
    otherProps = _split2[1];
  var ownProps = useFormControl(otherProps);
  var rootStyles = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color: color
  };
  var fieldStyles = _objectSpread2$1(_objectSpread2$1({
    paddingEnd: "2rem"
  }, styles.field), {}, {
    _focus: _objectSpread2$1({
      zIndex: "unset"
    }, (_a = styles.field) == null ? void 0 : _a["_focus"])
  });
  return /* @__PURE__ */jsxRuntimeExports.jsxs(chakra.div, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
    className: "chakra-select__wrapper",
    __css: rootStyles
  }, layoutProps), rootProps), {}, {
    children: [/* @__PURE__ */jsxRuntimeExports.jsx(SelectField, _objectSpread2$1(_objectSpread2$1({
      ref: ref,
      height: h != null ? h : height,
      minH: minH != null ? minH : minHeight,
      placeholder: placeholder
    }, ownProps), {}, {
      __css: fieldStyles,
      children: props.children
    })), /* @__PURE__ */jsxRuntimeExports.jsx(SelectIcon, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
      "data-disabled": dataAttr(ownProps.disabled)
    }, (iconColor || color) && {
      color: iconColor || color
    }), {}, {
      __css: styles.icon
    }, iconSize && {
      fontSize: iconSize
    }), {}, {
      children: icon
    }))]
  }));
});
Select$3.displayName = "Select";
var DefaultIcon = function DefaultIcon(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", _objectSpread2$1(_objectSpread2$1({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /* @__PURE__ */jsxRuntimeExports.jsx("path", {
      fill: "currentColor",
      d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    })
  }));
};
var IconWrapper = chakra("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var SelectIcon = function SelectIcon(props) {
  var _props$children = props.children,
    children = _props$children === void 0 ? /* @__PURE__ */jsxRuntimeExports.jsx(DefaultIcon, {}) : _props$children,
    rest = _objectWithoutProperties$1(props, _excluded2$3);
  var clone = /*#__PURE__*/cloneElement(children, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: false,
    "aria-hidden": true,
    // force icon to adhere to `IconWrapper` styles
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(IconWrapper, _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
    className: "chakra-select__icon-wrapper",
    children: /*#__PURE__*/isValidElement$1(children) ? clone : null
  }));
};
SelectIcon.displayName = "SelectIcon";

function useIsFirstRender() {
  var isFirstRender = useRef(true);
  useEffect(function () {
    isFirstRender.current = false;
  }, []);
  return isFirstRender.current;
}

function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}

var _excluded$M = ["startColor", "endColor", "isLoaded", "fadeDuration", "speed", "className", "fitContent"];
var StyledSkeleton = chakra("div", {
  baseStyle: {
    boxShadow: "none",
    backgroundClip: "padding-box",
    cursor: "default",
    color: "transparent",
    pointerEvents: "none",
    userSelect: "none",
    "&::before, &::after, *": {
      visibility: "hidden"
    }
  }
});
var $startColor = cssVar$1("skeleton-start-color");
var $endColor = cssVar$1("skeleton-end-color");
var fade = keyframes$2({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
var bgFade = keyframes$2({
  from: {
    borderColor: $startColor.reference,
    background: $startColor.reference
  },
  to: {
    borderColor: $endColor.reference,
    background: $endColor.reference
  }
});
var Skeleton = forwardRef(function (props, ref) {
  var skeletonProps = _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    fadeDuration: typeof props.fadeDuration === "number" ? props.fadeDuration : 0.4,
    speed: typeof props.speed === "number" ? props.speed : 0.8
  });
  var styles = useStyleConfig("Skeleton", skeletonProps);
  var isFirstRender = useIsFirstRender();
  var _omitThemingProps = omitThemingProps(skeletonProps),
    _omitThemingProps$sta = _omitThemingProps.startColor,
    startColor = _omitThemingProps$sta === void 0 ? "" : _omitThemingProps$sta,
    _omitThemingProps$end = _omitThemingProps.endColor,
    endColor = _omitThemingProps$end === void 0 ? "" : _omitThemingProps$end,
    isLoaded = _omitThemingProps.isLoaded,
    fadeDuration = _omitThemingProps.fadeDuration,
    speed = _omitThemingProps.speed,
    className = _omitThemingProps.className,
    fitContent = _omitThemingProps.fitContent,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$M);
  var _useToken = useToken("colors", [startColor, endColor]),
    _useToken2 = _slicedToArray$1(_useToken, 2),
    startColorVar = _useToken2[0],
    endColorVar = _useToken2[1];
  var wasPreviouslyLoaded = usePrevious(isLoaded);
  var _className = cx("chakra-skeleton", className);
  var cssVarStyles = _objectSpread2$1(_objectSpread2$1({}, startColorVar && _defineProperty$3({}, $startColor.variable, startColorVar)), endColorVar && _defineProperty$3({}, $endColor.variable, endColorVar));
  if (isLoaded) {
    var animation = isFirstRender || wasPreviouslyLoaded ? "none" : "".concat(fade, " ").concat(fadeDuration, "s");
    return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1({
      ref: ref,
      className: _className,
      __css: {
        animation: animation
      }
    }, rest));
  }
  return /* @__PURE__ */jsxRuntimeExports.jsx(StyledSkeleton, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: _className
  }, rest), {}, {
    __css: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
      width: fitContent ? "fit-content" : void 0
    }, styles), cssVarStyles), {}, {
      _dark: _objectSpread2$1(_objectSpread2$1({}, styles["_dark"]), cssVarStyles),
      animation: "".concat(speed, "s linear infinite alternate ").concat(bgFade)
    })
  }));
});
Skeleton.displayName = "Skeleton";

var _excluded$L = ["size"];
var SkeletonCircle = function SkeletonCircle(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "2rem" : _ref$size,
    rest = _objectWithoutProperties$1(_ref, _excluded$L);
  return /* @__PURE__ */jsxRuntimeExports.jsx(Skeleton, _objectSpread2$1({
    borderRadius: "full",
    boxSize: size
  }, rest));
};
SkeletonCircle.displayName = "SkeletonCircle";

var _excluded$K = ["noOfLines", "spacing", "skeletonHeight", "className", "startColor", "endColor", "isLoaded", "fadeDuration", "speed", "variant", "size", "colorScheme", "children"];
function range(count) {
  return Array(count).fill(1).map(function (_, index) {
    return index + 1;
  });
}
var defaultNoOfLines = 3;
var SkeletonText = function SkeletonText(props) {
  var _props$noOfLines = props.noOfLines,
    noOfLines = _props$noOfLines === void 0 ? defaultNoOfLines : _props$noOfLines,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
    _props$skeletonHeight = props.skeletonHeight,
    skeletonHeight = _props$skeletonHeight === void 0 ? "0.5rem" : _props$skeletonHeight,
    className = props.className,
    startColor = props.startColor,
    endColor = props.endColor,
    isLoaded = props.isLoaded,
    fadeDuration = props.fadeDuration,
    speed = props.speed,
    variant = props.variant,
    size = props.size,
    colorScheme = props.colorScheme,
    children = props.children,
    rest = _objectWithoutProperties$1(props, _excluded$K);
  var noOfLinesValue = useBreakpointValue(typeof noOfLines === "number" ? [noOfLines] : noOfLines) || defaultNoOfLines;
  var numbers = range(noOfLinesValue);
  var getWidth = function getWidth(index) {
    if (noOfLinesValue > 1) {
      return index === numbers.length ? "80%" : "100%";
    }
    return "100%";
  };
  var _className = cx("chakra-skeleton__group", className);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    className: _className
  }, rest), {}, {
    children: numbers.map(function (number, index) {
      if (isLoaded && index > 0) {
        return null;
      }
      var sizeProps = isLoaded ? null : {
        mb: number === numbers.length ? "0" : spacing,
        width: getWidth(number),
        height: skeletonHeight
      };
      return /* @__PURE__ */jsxRuntimeExports.jsx(Skeleton, _objectSpread2$1(_objectSpread2$1({
        startColor: startColor,
        endColor: endColor,
        isLoaded: isLoaded,
        fadeDuration: fadeDuration,
        speed: speed,
        variant: variant,
        size: size,
        colorScheme: colorScheme
      }, sizeProps), {}, {
        // allows animating the children
        children: index === 0 ? children : void 0
      }), numbers.length.toString() + number);
    })
  }));
};
SkeletonText.displayName = "SkeletonText";

var _excluded$J = ["spacing", "children"];
var Switch$1 = forwardRef(function Switch2(props, ref) {
  var styles = useMultiStyleConfig("Switch", props);
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$spa = _omitThemingProps.spacing,
    spacing = _omitThemingProps$spa === void 0 ? "0.5rem" : _omitThemingProps$spa,
    children = _omitThemingProps.children,
    ownProps = _objectWithoutProperties$1(_omitThemingProps, _excluded$J);
  var _useCheckbox = useCheckbox(ownProps),
    getIndicatorProps = _useCheckbox.getIndicatorProps,
    getInputProps = _useCheckbox.getInputProps,
    getCheckboxProps = _useCheckbox.getCheckboxProps,
    getRootProps = _useCheckbox.getRootProps,
    getLabelProps = _useCheckbox.getLabelProps;
  var containerStyles = useMemo(function () {
    return _objectSpread2$1({
      display: "inline-block",
      position: "relative",
      verticalAlign: "middle",
      lineHeight: 0
    }, styles.container);
  }, [styles.container]);
  var trackStyles = useMemo(function () {
    return _objectSpread2$1({
      display: "inline-flex",
      flexShrink: 0,
      justifyContent: "flex-start",
      boxSizing: "content-box",
      cursor: "pointer"
    }, styles.track);
  }, [styles.track]);
  var labelStyles = useMemo(function () {
    return _objectSpread2$1({
      userSelect: "none",
      marginStart: spacing
    }, styles.label);
  }, [spacing, styles.label]);
  return /* @__PURE__ */jsxRuntimeExports.jsxs(chakra.label, _objectSpread2$1(_objectSpread2$1({}, getRootProps()), {}, {
    className: cx("chakra-switch", props.className),
    __css: containerStyles,
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("input", _objectSpread2$1({
      className: "chakra-switch__input"
    }, getInputProps({}, ref))), /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({}, getCheckboxProps()), {}, {
      className: "chakra-switch__track",
      __css: trackStyles,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1({
        __css: styles.thumb,
        className: "chakra-switch__thumb"
      }, getIndicatorProps()))
    })), children && /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
      className: "chakra-switch__label"
    }, getLabelProps()), {}, {
      __css: labelStyles,
      children: children
    }))]
  }));
});
Switch$1.displayName = "Switch";

var _excluded$I = ["className", "layout"];
var _createContext$2 = createContext$1({
    name: "TableStylesContext",
    errorMessage: "useTableStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Table />\" "
  }),
  _createContext2$2 = _slicedToArray$1(_createContext$2, 2),
  TableStylesProvider = _createContext2$2[0],
  useTableStyles = _createContext2$2[1];
var Table = forwardRef(function (props, ref) {
  var styles = useMultiStyleConfig("Table", props);
  var _omitThemingProps = omitThemingProps(props),
    className = _omitThemingProps.className,
    layout = _omitThemingProps.layout,
    tableProps = _objectWithoutProperties$1(_omitThemingProps, _excluded$I);
  return /* @__PURE__ */jsxRuntimeExports.jsx(TableStylesProvider, {
    value: styles,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.table, _objectSpread2$1({
      ref: ref,
      __css: _objectSpread2$1({
        tableLayout: layout
      }, styles.table),
      className: cx("chakra-table", className)
    }, tableProps))
  });
});
Table.displayName = "Table";

var Thead = forwardRef(function (props, ref) {
  var styles = useTableStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.thead, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref: ref,
    __css: styles.thead
  }));
});

var Tr = forwardRef(function (props, ref) {
  var styles = useTableStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.tr, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref: ref,
    __css: styles.tr
  }));
});

var _excluded$H = ["placement"];
var TableCaption = forwardRef(function (props, ref) {
  var _props$placement = props.placement,
    placement = _props$placement === void 0 ? "bottom" : _props$placement,
    rest = _objectWithoutProperties$1(props, _excluded$H);
  var styles = useTableStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.caption, _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
    ref: ref,
    __css: _objectSpread2$1(_objectSpread2$1({}, styles.caption), {}, {
      captionSide: placement
    })
  }));
});
TableCaption.displayName = "TableCaption";

var _excluded$G = ["overflow", "overflowX", "className"];
var TableContainer = forwardRef(function (props, ref) {
  var _a;
  var overflow = props.overflow,
    overflowX = props.overflowX,
    className = props.className,
    rest = _objectWithoutProperties$1(props, _excluded$G);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    className: cx("chakra-table__container", className)
  }, rest), {}, {
    __css: {
      display: "block",
      whiteSpace: "nowrap",
      WebkitOverflowScrolling: "touch",
      overflowX: (_a = overflow != null ? overflow : overflowX) != null ? _a : "auto",
      overflowY: "hidden",
      maxWidth: "100%"
    }
  }));
});

var Tbody = forwardRef(function (props, ref) {
  var styles = useTableStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.tbody, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref: ref,
    __css: styles.tbody
  }));
});

var _excluded$F = ["isNumeric"];
var Td = forwardRef(function (_ref, ref) {
  var isNumeric = _ref.isNumeric,
    rest = _objectWithoutProperties$1(_ref, _excluded$F);
  var styles = useTableStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.td, _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
    ref: ref,
    __css: styles.td,
    "data-is-numeric": isNumeric
  }));
});

var Tfoot = forwardRef(function (props, ref) {
  var styles = useTableStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.tfoot, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref: ref,
    __css: styles.tfoot
  }));
});

var _excluded$E = ["isNumeric"];
var Th = forwardRef(function (_ref, ref) {
  var isNumeric = _ref.isNumeric,
    rest = _objectWithoutProperties$1(_ref, _excluded$E);
  var styles = useTableStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.th, _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
    ref: ref,
    __css: styles.th,
    "data-is-numeric": isNumeric
  }));
});

var _excluded$D = ["defaultIndex", "onChange", "index", "isManual", "isLazy", "lazyBehavior", "orientation", "direction"],
  _excluded2$2 = ["isDisabled", "isFocusable"],
  _excluded3$1 = ["children"];
var _createDescendantCont = createDescendantContext(),
  _createDescendantCont2 = _slicedToArray$1(_createDescendantCont, 4),
  TabsDescendantsProvider = _createDescendantCont2[0],
  useTabsDescendantsContext = _createDescendantCont2[1],
  useTabsDescendants = _createDescendantCont2[2],
  useTabsDescendant = _createDescendantCont2[3];
function useTabs(props) {
  var _a;
  var defaultIndex = props.defaultIndex,
    onChange = props.onChange,
    index = props.index,
    isManual = props.isManual,
    isLazy = props.isLazy,
    _props$lazyBehavior = props.lazyBehavior,
    lazyBehavior = _props$lazyBehavior === void 0 ? "unmount" : _props$lazyBehavior,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? "ltr" : _props$direction,
    htmlProps = _objectWithoutProperties$1(props, _excluded$D);
  var _useState = useState(defaultIndex != null ? defaultIndex : 0),
    _useState2 = _slicedToArray$1(_useState, 2),
    focusedIndex = _useState2[0],
    setFocusedIndex = _useState2[1];
  var _useControllableState = useControllableState$1({
      defaultValue: defaultIndex != null ? defaultIndex : 0,
      value: index,
      onChange: onChange
    }),
    _useControllableState2 = _slicedToArray$1(_useControllableState, 2),
    selectedIndex = _useControllableState2[0],
    setSelectedIndex = _useControllableState2[1];
  useEffect(function () {
    if (index != null) {
      setFocusedIndex(index);
    }
  }, [index]);
  var descendants = useTabsDescendants();
  var uuid = useId$1();
  var uid = (_a = props.id) != null ? _a : uuid;
  var id = "tabs-".concat(uid);
  return {
    id: id,
    selectedIndex: selectedIndex,
    focusedIndex: focusedIndex,
    setSelectedIndex: setSelectedIndex,
    setFocusedIndex: setFocusedIndex,
    isManual: isManual,
    isLazy: isLazy,
    lazyBehavior: lazyBehavior,
    orientation: orientation,
    descendants: descendants,
    direction: direction,
    htmlProps: htmlProps
  };
}
var _createContext$1 = createContext$1({
    name: "TabsContext",
    errorMessage: "useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />"
  }),
  _createContext2$1 = _slicedToArray$1(_createContext$1, 2),
  TabsProvider = _createContext2$1[0],
  useTabsContext = _createContext2$1[1];
function useTabList(props) {
  var _useTabsContext = useTabsContext(),
    focusedIndex = _useTabsContext.focusedIndex,
    orientation = _useTabsContext.orientation,
    direction = _useTabsContext.direction;
  var descendants = useTabsDescendantsContext();
  var onKeyDown = useCallback(function (event) {
    var nextTab = function nextTab() {
      var _a;
      var next = descendants.nextEnabled(focusedIndex);
      if (next) (_a = next.node) == null ? void 0 : _a.focus();
    };
    var prevTab = function prevTab() {
      var _a;
      var prev = descendants.prevEnabled(focusedIndex);
      if (prev) (_a = prev.node) == null ? void 0 : _a.focus();
    };
    var firstTab = function firstTab() {
      var _a;
      var first = descendants.firstEnabled();
      if (first) (_a = first.node) == null ? void 0 : _a.focus();
    };
    var lastTab = function lastTab() {
      var _a;
      var last = descendants.lastEnabled();
      if (last) (_a = last.node) == null ? void 0 : _a.focus();
    };
    var isHorizontal = orientation === "horizontal";
    var isVertical = orientation === "vertical";
    var eventKey = event.key;
    var ArrowStart = direction === "ltr" ? "ArrowLeft" : "ArrowRight";
    var ArrowEnd = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
    var keyMap = _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, ArrowStart, function () {
      return isHorizontal && prevTab();
    }), ArrowEnd, function () {
      return isHorizontal && nextTab();
    }), "ArrowDown", function ArrowDown() {
      return isVertical && nextTab();
    }), "ArrowUp", function ArrowUp() {
      return isVertical && prevTab();
    }), "Home", firstTab), "End", lastTab);
    var action = keyMap[eventKey];
    if (action) {
      event.preventDefault();
      action(event);
    }
  }, [descendants, focusedIndex, orientation, direction]);
  return _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    role: "tablist",
    "aria-orientation": orientation,
    onKeyDown: callAllHandlers$1(props.onKeyDown, onKeyDown)
  });
}
function useTab(props) {
  var _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _props$isFocusable = props.isFocusable,
    isFocusable = _props$isFocusable === void 0 ? false : _props$isFocusable,
    htmlProps = _objectWithoutProperties$1(props, _excluded2$2);
  var _useTabsContext2 = useTabsContext(),
    setSelectedIndex = _useTabsContext2.setSelectedIndex,
    isManual = _useTabsContext2.isManual,
    id = _useTabsContext2.id,
    setFocusedIndex = _useTabsContext2.setFocusedIndex,
    selectedIndex = _useTabsContext2.selectedIndex;
  var _useTabsDescendant = useTabsDescendant({
      disabled: isDisabled && !isFocusable
    }),
    index = _useTabsDescendant.index,
    register = _useTabsDescendant.register;
  var isSelected = index === selectedIndex;
  var onClick = function onClick() {
    setSelectedIndex(index);
  };
  var onFocus = function onFocus() {
    setFocusedIndex(index);
    var isDisabledButFocusable = isDisabled && isFocusable;
    var shouldSelect = !isManual && !isDisabledButFocusable;
    if (shouldSelect) {
      setSelectedIndex(index);
    }
  };
  var clickableProps = useClickable(_objectSpread2$1(_objectSpread2$1({}, htmlProps), {}, {
    ref: mergeRefs(register, props.ref),
    isDisabled: isDisabled,
    isFocusable: isFocusable,
    onClick: callAllHandlers$1(props.onClick, onClick)
  }));
  var type = "button";
  return _objectSpread2$1(_objectSpread2$1({}, clickableProps), {}, {
    id: makeTabId(id, index),
    role: "tab",
    tabIndex: isSelected ? 0 : -1,
    type: type,
    "aria-selected": isSelected,
    "aria-controls": makeTabPanelId(id, index),
    onFocus: isDisabled ? void 0 : callAllHandlers$1(props.onFocus, onFocus)
  });
}
var _createContext3 = createContext$1({}),
  _createContext4 = _slicedToArray$1(_createContext3, 2),
  TabPanelProvider = _createContext4[0],
  useTabPanelContext = _createContext4[1];
function useTabPanels(props) {
  var context = useTabsContext();
  var id = context.id,
    selectedIndex = context.selectedIndex;
  var validChildren = getValidChildren(props.children);
  var children = validChildren.map(function (child, index) {
    return /*#__PURE__*/createElement(TabPanelProvider, {
      key: index,
      value: {
        isSelected: index === selectedIndex,
        id: makeTabPanelId(id, index),
        tabId: makeTabId(id, index),
        selectedIndex: selectedIndex
      }
    }, child);
  });
  return _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    children: children
  });
}
function useTabPanel(props) {
  var children = props.children,
    htmlProps = _objectWithoutProperties$1(props, _excluded3$1);
  var _useTabsContext3 = useTabsContext(),
    isLazy = _useTabsContext3.isLazy,
    lazyBehavior = _useTabsContext3.lazyBehavior;
  var _useTabPanelContext = useTabPanelContext(),
    isSelected = _useTabPanelContext.isSelected,
    id = _useTabPanelContext.id,
    tabId = _useTabPanelContext.tabId;
  var hasBeenSelected = useRef(false);
  if (isSelected) {
    hasBeenSelected.current = true;
  }
  var shouldRenderChildren = lazyDisclosure({
    wasSelected: hasBeenSelected.current,
    isSelected: isSelected,
    enabled: isLazy,
    mode: lazyBehavior
  });
  return _objectSpread2$1(_objectSpread2$1({
    // Puts the tabpanel in the page `Tab` sequence.
    tabIndex: 0
  }, htmlProps), {}, {
    children: shouldRenderChildren ? children : null,
    role: "tabpanel",
    "aria-labelledby": tabId,
    hidden: !isSelected,
    id: id
  });
}
function makeTabId(id, index) {
  return "".concat(id, "--tab-").concat(index);
}
function makeTabPanelId(id, index) {
  return "".concat(id, "--tabpanel-").concat(index);
}

var _excluded$C = ["children", "className"],
  _excluded2$1 = ["htmlProps", "descendants"],
  _excluded3 = ["isFitted"];
var _createContext = createContext$1({
    name: "TabsStylesContext",
    errorMessage: "useTabsStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Tabs />\" "
  }),
  _createContext2 = _slicedToArray$1(_createContext, 2),
  TabsStylesProvider = _createContext2[0],
  useTabsStyles = _createContext2[1];
var Tabs$1 = forwardRef(function Tabs2(props, ref) {
  var styles = useMultiStyleConfig("Tabs", props);
  var _omitThemingProps = omitThemingProps(props),
    children = _omitThemingProps.children,
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$C);
  var _useTabs = useTabs(rest),
    htmlProps = _useTabs.htmlProps,
    descendants = _useTabs.descendants,
    ctx = _objectWithoutProperties$1(_useTabs, _excluded2$1);
  var context = useMemo(function () {
    return ctx;
  }, [ctx]);
  htmlProps.isFitted;
    var rootProps = _objectWithoutProperties$1(htmlProps, _excluded3);
  var tabsStyles = _objectSpread2$1({
    position: "relative"
  }, styles.root);
  return /* @__PURE__ */jsxRuntimeExports.jsx(TabsDescendantsProvider, {
    value: descendants,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(TabsProvider, {
      value: context,
      children: /* @__PURE__ */jsxRuntimeExports.jsx(TabsStylesProvider, {
        value: styles,
        children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
          className: cx("chakra-tabs", className),
          ref: ref
        }, rootProps), {}, {
          __css: tabsStyles,
          children: children
        }))
      })
    })
  });
});
Tabs$1.displayName = "Tabs";

var TabList = forwardRef(function TabList2(props, ref) {
  var tablistProps = useTabList(_objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref: ref
  }));
  var styles = useTabsStyles();
  var tablistStyles = _objectSpread2$1({
    display: "flex"
  }, styles.tablist);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, tablistProps), {}, {
    className: cx("chakra-tabs__tablist", props.className),
    __css: tablistStyles
  }));
});
TabList.displayName = "TabList";

var TabPanel = forwardRef(function TabPanel2(props, ref) {
  var panelProps = useTabPanel(_objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref: ref
  }));
  var styles = useTabsStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({
    outline: "0"
  }, panelProps), {}, {
    className: cx("chakra-tabs__tab-panel", props.className),
    __css: styles.tabpanel
  }));
});
TabPanel.displayName = "TabPanel";

var TabPanels = forwardRef(function TabPanels2(props, ref) {
  var panelsProps = useTabPanels(props);
  var styles = useTabsStyles();
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, panelsProps), {}, {
    width: "100%",
    ref: ref,
    className: cx("chakra-tabs__tab-panels", props.className),
    __css: styles.tabpanels
  }));
});
TabPanels.displayName = "TabPanels";

var Tab = forwardRef(function Tab2(props, ref) {
  var styles = useTabsStyles();
  var tabProps = useTab(_objectSpread2$1(_objectSpread2$1({}, props), {}, {
    ref: ref
  }));
  var tabStyles = _objectSpread2$1({
    outline: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, styles.tab);
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.button, _objectSpread2$1(_objectSpread2$1({}, tabProps), {}, {
    className: cx("chakra-tabs__tab", props.className),
    __css: tabStyles
  }));
});
Tab.displayName = "Tab";

var _excluded$B = ["className", "rows"];

// ../../utilities/object-utils/src/omit.ts
function omit$1(object) {
  var keysToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var clone = Object.assign({}, object);
  var _iterator = _createForOfIteratorHelper(keysToOmit),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (key in clone) {
        delete clone[key];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return clone;
}
var omitted = ["h", "minH", "height", "minHeight"];
var Textarea$1 = forwardRef(function (props, ref) {
  var styles = useStyleConfig("Textarea", props);
  var _omitThemingProps = omitThemingProps(props),
    className = _omitThemingProps.className,
    rows = _omitThemingProps.rows,
    rest = _objectWithoutProperties$1(_omitThemingProps, _excluded$B);
  var textareaProps = useFormControl(rest);
  var textareaStyles = rows ? omit$1(styles, omitted) : styles;
  return /* @__PURE__ */jsxRuntimeExports.jsx(chakra.textarea, _objectSpread2$1(_objectSpread2$1({
    ref: ref,
    rows: rows
  }, textareaProps), {}, {
    className: cx("chakra-textarea", className),
    __css: textareaStyles
  }));
});
Textarea$1.displayName = "Textarea";

// src/tooltip.transition.tsx
var scale = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: {
        duration: 0.15,
        easings: "easeInOut"
      },
      scale: {
        duration: 0.2,
        easings: "easeInOut"
      }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: {
        easings: "easeOut",
        duration: 0.2
      },
      scale: {
        duration: 0.2,
        ease: [0.175, 0.885, 0.4, 1.1]
      }
    }
  }
};

var _excluded$A = ["openDelay", "closeDelay", "closeOnClick", "closeOnMouseDown", "closeOnScroll", "closeOnPointerDown", "closeOnEsc", "onOpen", "onClose", "placement", "id", "isOpen", "defaultIsOpen", "arrowSize", "arrowShadowColor", "arrowPadding", "modifiers", "isDisabled", "gutter", "offset", "direction"];
var getDoc = function getDoc(ref) {
  var _a;
  return ((_a = ref.current) == null ? void 0 : _a.ownerDocument) || document;
};
var getWin = function getWin(ref) {
  var _a, _b;
  return ((_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) == null ? void 0 : _b.defaultView) || window;
};
function useTooltip() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$openDelay = props.openDelay,
    openDelay = _props$openDelay === void 0 ? 0 : _props$openDelay,
    _props$closeDelay = props.closeDelay,
    closeDelay = _props$closeDelay === void 0 ? 0 : _props$closeDelay,
    _props$closeOnClick = props.closeOnClick,
    closeOnClick = _props$closeOnClick === void 0 ? true : _props$closeOnClick,
    closeOnMouseDown = props.closeOnMouseDown,
    closeOnScroll = props.closeOnScroll,
    _props$closeOnPointer = props.closeOnPointerDown,
    closeOnPointerDown = _props$closeOnPointer === void 0 ? closeOnMouseDown : _props$closeOnPointer,
    _props$closeOnEsc = props.closeOnEsc,
    closeOnEsc = _props$closeOnEsc === void 0 ? true : _props$closeOnEsc,
    onOpenProp = props.onOpen,
    onCloseProp = props.onClose,
    placement = props.placement,
    id = props.id,
    isOpenProp = props.isOpen,
    defaultIsOpen = props.defaultIsOpen,
    _props$arrowSize = props.arrowSize,
    arrowSize = _props$arrowSize === void 0 ? 10 : _props$arrowSize,
    arrowShadowColor = props.arrowShadowColor,
    arrowPadding = props.arrowPadding,
    modifiers = props.modifiers,
    isDisabled = props.isDisabled,
    gutter = props.gutter,
    offset = props.offset,
    direction = props.direction,
    htmlProps = _objectWithoutProperties$1(props, _excluded$A);
  var _useDisclosure = useDisclosure({
      isOpen: isOpenProp,
      defaultIsOpen: defaultIsOpen,
      onOpen: onOpenProp,
      onClose: onCloseProp
    }),
    isOpen = _useDisclosure.isOpen,
    onOpen = _useDisclosure.onOpen,
    onClose = _useDisclosure.onClose;
  var _usePopper = usePopper({
      enabled: isOpen,
      placement: placement,
      arrowPadding: arrowPadding,
      modifiers: modifiers,
      gutter: gutter,
      offset: offset,
      direction: direction
    }),
    referenceRef = _usePopper.referenceRef,
    getPopperProps = _usePopper.getPopperProps,
    getArrowInnerProps = _usePopper.getArrowInnerProps,
    getArrowProps = _usePopper.getArrowProps;
  var uuid = useId$1();
  var uid = id != null ? id : uuid;
  var tooltipId = "tooltip-".concat(uid);
  var ref = useRef(null);
  var enterTimeout = useRef();
  var clearEnterTimeout = useCallback(function () {
    if (enterTimeout.current) {
      clearTimeout(enterTimeout.current);
      enterTimeout.current = void 0;
    }
  }, []);
  var exitTimeout = useRef();
  var clearExitTimeout = useCallback(function () {
    if (exitTimeout.current) {
      clearTimeout(exitTimeout.current);
      exitTimeout.current = void 0;
    }
  }, []);
  var closeNow = useCallback(function () {
    clearExitTimeout();
    onClose();
  }, [onClose, clearExitTimeout]);
  var dispatchCloseEvent = useCloseEvent(ref, closeNow);
  var openWithDelay = useCallback(function () {
    if (!isDisabled && !enterTimeout.current) {
      if (isOpen) dispatchCloseEvent();
      var win = getWin(ref);
      enterTimeout.current = win.setTimeout(onOpen, openDelay);
    }
  }, [dispatchCloseEvent, isDisabled, isOpen, onOpen, openDelay]);
  var closeWithDelay = useCallback(function () {
    clearEnterTimeout();
    var win = getWin(ref);
    exitTimeout.current = win.setTimeout(closeNow, closeDelay);
  }, [closeDelay, closeNow, clearEnterTimeout]);
  var onClick = useCallback(function () {
    if (isOpen && closeOnClick) {
      closeWithDelay();
    }
  }, [closeOnClick, closeWithDelay, isOpen]);
  var onPointerDown = useCallback(function () {
    if (isOpen && closeOnPointerDown) {
      closeWithDelay();
    }
  }, [closeOnPointerDown, closeWithDelay, isOpen]);
  var onKeyDown = useCallback(function (event) {
    if (isOpen && event.key === "Escape") {
      closeWithDelay();
    }
  }, [isOpen, closeWithDelay]);
  useEventListener(function () {
    return getDoc(ref);
  }, "keydown", closeOnEsc ? onKeyDown : void 0);
  useEventListener(function () {
    if (!closeOnScroll) return null;
    var node = ref.current;
    if (!node) return null;
    var scrollParent = getScrollParent$2(node);
    return scrollParent.localName === "body" ? getWin(ref) : scrollParent;
  }, "scroll", function () {
    if (isOpen && closeOnScroll) {
      closeNow();
    }
  }, {
    passive: true,
    capture: true
  });
  useEffect(function () {
    if (!isDisabled) return;
    clearEnterTimeout();
    if (isOpen) onClose();
  }, [isDisabled, isOpen, onClose, clearEnterTimeout]);
  useEffect(function () {
    return function () {
      clearEnterTimeout();
      clearExitTimeout();
    };
  }, [clearEnterTimeout, clearExitTimeout]);
  useEventListener(function () {
    return ref.current;
  }, "pointerleave", closeWithDelay);
  var getTriggerProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var triggerProps = _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      ref: mergeRefs(ref, _ref, referenceRef),
      onPointerEnter: callAllHandlers$1(props2.onPointerEnter, function (e) {
        if (e.pointerType === "touch") return;
        openWithDelay();
      }),
      onClick: callAllHandlers$1(props2.onClick, onClick),
      onPointerDown: callAllHandlers$1(props2.onPointerDown, onPointerDown),
      onFocus: callAllHandlers$1(props2.onFocus, openWithDelay),
      onBlur: callAllHandlers$1(props2.onBlur, closeWithDelay),
      "aria-describedby": isOpen ? tooltipId : void 0
    });
    return triggerProps;
  }, [openWithDelay, closeWithDelay, onPointerDown, isOpen, tooltipId, onClick, referenceRef]);
  var getTooltipPositionerProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return getPopperProps(_objectSpread2$1(_objectSpread2$1({}, props2), {}, {
      style: _objectSpread2$1(_objectSpread2$1({}, props2.style), {}, _defineProperty$3(_defineProperty$3({}, cssVars.arrowSize["var"], arrowSize ? "".concat(arrowSize, "px") : void 0), cssVars.arrowShadowColor["var"], arrowShadowColor))
    }), forwardedRef);
  }, [getPopperProps, arrowSize, arrowShadowColor]);
  var getTooltipProps = useCallback(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var styles = _objectSpread2$1(_objectSpread2$1({}, props2.style), {}, {
      position: "relative",
      transformOrigin: cssVars.transformOrigin.varRef
    });
    return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
      ref: ref2
    }, htmlProps), props2), {}, {
      id: tooltipId,
      role: "tooltip",
      style: styles
    });
  }, [htmlProps, tooltipId]);
  return {
    isOpen: isOpen,
    show: openWithDelay,
    hide: closeWithDelay,
    getTriggerProps: getTriggerProps,
    getTooltipProps: getTooltipProps,
    getTooltipPositionerProps: getTooltipPositionerProps,
    getArrowProps: getArrowProps,
    getArrowInnerProps: getArrowInnerProps
  };
}
var closeEventName = "chakra-ui:close-tooltip";
function useCloseEvent(ref, close) {
  useEffect(function () {
    var doc = getDoc(ref);
    doc.addEventListener(closeEventName, close);
    return function () {
      return doc.removeEventListener(closeEventName, close);
    };
  }, [close, ref]);
  return function () {
    var doc = getDoc(ref);
    var win = getWin(ref);
    doc.dispatchEvent(new win.CustomEvent(closeEventName));
  };
}

var _excluded$z = ["children", "label", "shouldWrapChildren", "aria-label", "hasArrow", "bg", "portalProps", "background", "backgroundColor", "bgColor", "motionProps"];

// ../../utilities/object-utils/src/omit.ts
function omit(object) {
  var keysToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var clone = Object.assign({}, object);
  var _iterator = _createForOfIteratorHelper(keysToOmit),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (key in clone) {
        delete clone[key];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return clone;
}

// ../../utilities/object-utils/src/pick.ts
function pick(object, keysToPick) {
  var result = {};
  var _iterator2 = _createForOfIteratorHelper(keysToPick),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var key = _step2.value;
      if (key in object) {
        result[key] = object[key];
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return result;
}
var MotionDiv = chakra(motion.div);
var Tooltip = forwardRef(function (props, ref) {
  var _a, _b;
  var styles = useStyleConfig("Tooltip", props);
  var ownProps = omitThemingProps(props);
  var theme = useTheme();
  var children = ownProps.children,
    label = ownProps.label,
    shouldWrapChildren = ownProps.shouldWrapChildren,
    ariaLabel = ownProps["aria-label"],
    hasArrow = ownProps.hasArrow,
    bg = ownProps.bg,
    portalProps = ownProps.portalProps,
    background = ownProps.background,
    backgroundColor = ownProps.backgroundColor,
    bgColor = ownProps.bgColor,
    motionProps = ownProps.motionProps,
    rest = _objectWithoutProperties$1(ownProps, _excluded$z);
  var userDefinedBg = (_b = (_a = background != null ? background : backgroundColor) != null ? _a : bg) != null ? _b : bgColor;
  if (userDefinedBg) {
    styles.bg = userDefinedBg;
    var bgVar = getCSSVar(theme, "colors", userDefinedBg);
    styles[cssVars.arrowBg["var"]] = bgVar;
  }
  var tooltip = useTooltip(_objectSpread2$1(_objectSpread2$1({}, rest), {}, {
    direction: theme.direction
  }));
  var shouldWrap = typeof children === "string" || shouldWrapChildren;
  var trigger;
  if (shouldWrap) {
    trigger = /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
      display: "inline-block",
      tabIndex: 0
    }, tooltip.getTriggerProps()), {}, {
      children: children
    }));
  } else {
    var child = Children.only(children);
    trigger = /*#__PURE__*/cloneElement(child, tooltip.getTriggerProps(child.props, child.ref));
  }
  var hasAriaLabel = !!ariaLabel;
  var _tooltipProps = tooltip.getTooltipProps({}, ref);
  var tooltipProps = hasAriaLabel ? omit(_tooltipProps, ["role", "id"]) : _tooltipProps;
  var srOnlyProps = pick(_tooltipProps, ["role", "id"]);
  if (!label) {
    return /* @__PURE__ */jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
      children: children
    });
  }
  return /* @__PURE__ */jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [trigger, /* @__PURE__ */jsxRuntimeExports.jsx(AnimatePresence, {
      children: tooltip.isOpen && /* @__PURE__ */jsxRuntimeExports.jsx(Portal, _objectSpread2$1(_objectSpread2$1({}, portalProps), {}, {
        children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, _objectSpread2$1(_objectSpread2$1({}, tooltip.getTooltipPositionerProps()), {}, {
          __css: {
            zIndex: styles.zIndex,
            pointerEvents: "none"
          },
          children: /* @__PURE__ */jsxRuntimeExports.jsxs(MotionDiv, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
            variants: scale,
            initial: "exit",
            animate: "enter",
            exit: "exit"
          }, motionProps), tooltipProps), {}, {
            __css: styles,
            children: [label, hasAriaLabel && /* @__PURE__ */jsxRuntimeExports.jsx(chakra.span, _objectSpread2$1(_objectSpread2$1({
              srOnly: true
            }, srOnlyProps), {}, {
              children: ariaLabel
            })), hasArrow && /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, {
              "data-popper-arrow": true,
              className: "chakra-tooltip__arrow-wrapper",
              children: /* @__PURE__ */jsxRuntimeExports.jsx(chakra.div, {
                "data-popper-arrow-inner": true,
                className: "chakra-tooltip__arrow",
                __css: {
                  bg: styles.bg
                }
              })
            })]
          }))
        }))
      }))
    })]
  });
});
Tooltip.displayName = "Tooltip";

var header$1 = (function (_ref) {
  var hideCloseButton = _ref.hideCloseButton,
    hasHeader = _ref.hasHeader;
  return {
    padding: !hideCloseButton || hasHeader ? 4 : 2,
    fontSize: 'xl',
    fontWeight: 'semibold',
    // If just close button, still have 'header' section at top
    minHeight: hasHeader || hideCloseButton ? null : 12
  };
});

/**
 * @param {boolean} isMobile - Whether or not the Modal is opened in a mobile viewport
 * @param {boolean} isOpen - Whether or not the Modal is open
 * @param {React.ReactNode} children - The header text of the modal
 * @param {()=>void} [onClose] - Callback invoked to close the Modal. Not required, but strongly suggested.
 * @param {('sm'|'md'|'lg')} [size] - The size of the modal. If unspecified, uses "md" styles.
 * @param {object} [contentStyling] - Style props to be passed into the modal content
 * @param {object} [overlayProps] - Props to be passed into the ModalOverlay component. See: https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/modal/src/modal-overlay.tsx
 * @param {boolean} [hasHeader] - Whether or not ModalHeader is a child. Will change the styling
 * @param {boolean} [hasFooter] - Whether or not ModalFooter is a child. Will change the styling
 * @param {React.ReactNode} [hideCloseButton] - Whether or not to show the close button
 * @returns {React.ReactElement} - The Modal component
 */
var Modal = /*#__PURE__*/forwardRef$1(function (props, ref) {
  var children = props.children,
    hideCloseButton = props.hideCloseButton,
    hasHeader = props.hasHeader,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    _props$contentStyling = props.contentStyling,
    contentStyling = _props$contentStyling === void 0 ? {} : _props$contentStyling,
    _props$overlayProps = props.overlayProps,
    overlayProps = _props$overlayProps === void 0 ? {} : _props$overlayProps;
  return /*#__PURE__*/React__default.createElement(Modal$1, _extends$7({
    motionPreset: isMobile ? 'slideInBottom' : 'scale'
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement(ModalOverlay, overlayProps), /*#__PURE__*/React__default.createElement(ModalContent, _extends$7({
    "data-testid": "ModalContent"
  }, contentStyling), !hasHeader ? /*#__PURE__*/React__default.createElement(Box, header$1(props)) : null, hideCloseButton ? null : /*#__PURE__*/React__default.createElement(ModalCloseButton, {
    "data-testid": "ModalClose-button"
  }), children));
});
Modal.propTypes = {
  /** Whether or not the Modal is opened in a mobile viewport */
  isMobile: PropTypes.bool,
  /** Whether or not the Modal is open */
  isOpen: PropTypes.bool.isRequired,
  /** React children. Body of the Modal. */
  children: PropTypes.node.isRequired,
  /** Whether or not ModalHeader is a child. Will change the styling */
  hasHeader: PropTypes.bool.isRequired,
  /** Whether or not ModalFooter is a child. Will change the styling */
  hasFooter: PropTypes.bool.isRequired,
  /** Callback invoked to close the Modal. Not required, but strongly suggested. */
  onClose: PropTypes.func,
  /** The size of the modal. If unspecified, uses md styles. */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Whether or not to show the close button (optional) */
  hideCloseButton: PropTypes.bool,
  /** Objects containing css-in-js styling*/
  contentStyling: PropTypes.object,
  /** Objects containing props to apply to ModalOverlay component */
  overlayProps: PropTypes.object
};

var _templateObject$1, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var fadeIn = keyframes$2(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral$1(["\n     0% { opacity: 0%; }\n     100% { opacity: 100%; }\n\n"])));
var fadeOut = keyframes$2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral$1(["\n    0% { opacity: 100%; }\n    100% { opacity: 0% }\n"])));
var fadeInAndEnlarge = keyframes$2(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral$1(["\n     0% { opacity: 0%; transform: scale(0.9);}\n     100% { opacity: 100%; transform: scale(1);}\n"])));
var fadeOutAndShrink = keyframes$2(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral$1(["\n    0% { opacity: 100%; transform: scale(1); }\n    100% { opacity: 0%; transform: scale(0.9); }\n"])));
var fadeInAndSlideUp = keyframes$2(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral$1(["\n     0% { opacity: 0%; transform: translateY(2rem) scale(1);}\n     100% { opacity: 100%; transform: translateY(0) scale(1);}\n"])));
var fadeOutAndSlideDown = keyframes$2(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral$1(["\n    0% { opacity: 100%; transform: translateY(0) scale(1); }\n    100% { opacity: 0%; transform: translateY(2rem) scale(1); }\n"])));

// This is a modified version of our Modal that will always be mounted, even when it is closed.
// We need this for things like Stripe where payment Elements need to be mounted to get a token on checkout
/**
 * @param {boolean} isMobile - Whether or not the Modal is opened in a mobile viewport
 * @param {boolean} isOpen - Whether or not the Modal is open
 * @param {React.ReactNode} children - The header text of the modal
 * @param {()=>void} [onClose] - Callback invoked to close the Modal. Not required, but strongly suggested.
 * @param {('sm'|'md'|'lg')} [size] - The size of the modal. If unspecified, uses "md" styles.
 * @param {object} [contentStyling] - Style props to be passed into the modal content
 * @param {object} [overlayProps] - Props to be passed into the ModalOverlay component. See: https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/modal/src/modal-overlay.tsx
 * @param {boolean} [hasHeader] - Whether or not ModalHeader is a child. Will change the styling
 * @param {boolean} [hasFooter] - Whether or not ModalFooter is a child. Will change the styling
 * @param {React.ReactNode} [hideCloseButton] - Whether or not to show the close button
 * @returns {React.ReactElement} - The Modal component
 */
var AlwaysMountedModal = /*#__PURE__*/forwardRef$1(function (props, ref) {
  var children = props.children,
    hideCloseButton = props.hideCloseButton,
    onCloseComplete = props.onCloseComplete,
    hasHeader = props.hasHeader,
    isOpen = props.isOpen,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    _props$contentStyling = props.contentStyling,
    contentStyling = _props$contentStyling === void 0 ? {} : _props$contentStyling,
    _props$overlayProps = props.overlayProps,
    overlayProps = _props$overlayProps === void 0 ? {} : _props$overlayProps;
  var _useState = useState(isOpen),
    _useState2 = _slicedToArray$1(_useState, 2),
    internalOpen = _useState2[0],
    setInternalOpen = _useState2[1];
  useEffect(function () {
    if (!isOpen) {
      setTimeout(function () {
        setInternalOpen(false);
        onCloseComplete();
        // Want this to be a bit shorter than fade out animation
      }, 175);
    } else {
      setInternalOpen(true);
    }
  }, [isOpen]);
  var fadeInAnimation = isMobile ? fadeInAndSlideUp : fadeInAndEnlarge;
  var fadeOutAnimation = isMobile ? fadeOutAndSlideDown : fadeOutAndShrink;
  return /*#__PURE__*/React__default.createElement(Modal$1, _extends$7({
    motionPreset: isMobile ? 'slideInBottom' : 'scale'
  }, props, {
    blockScrollOnMount: isOpen,
    isOpen: true,
    ref: ref
  }), /*#__PURE__*/React__default.createElement(Box, {
    visibility: internalOpen ? 'visible' : 'hidden',
    animation: "".concat(isOpen ? fadeIn : fadeOut, " 0.2s ease-in-out"),
    zIndex: 3,
    as: motion.div,
    position: "relative"
  }, /*#__PURE__*/React__default.createElement(ModalOverlay, overlayProps)), /*#__PURE__*/React__default.createElement(Box, {
    visibility: internalOpen ? 'visible' : 'hidden',
    animation: "".concat(isOpen ? fadeIn : fadeOut, " 0.2s ease-in-out"),
    zIndex: 4,
    as: motion.div,
    position: "relative"
  }, /*#__PURE__*/React__default.createElement(ModalContent, _extends$7({}, contentStyling, {
    animation: "".concat(isOpen ? fadeInAnimation : fadeOutAnimation, " 0.2s ease-in-out")
  }), !hasHeader ? /*#__PURE__*/React__default.createElement(Box, header$1(props)) : null, hideCloseButton ? null : /*#__PURE__*/React__default.createElement(ModalCloseButton, null), children)));
});
AlwaysMountedModal.propTypes = {
  /** Whether or not the Modal is opened in a mobile viewport */
  isMobile: PropTypes.bool,
  /** Whether or not the Modal is open */
  isOpen: PropTypes.bool.isRequired,
  /** React children. Body of the Modal. */
  children: PropTypes.node.isRequired,
  /** Whether or not ModalHeader is a child. Will change the styling */
  hasHeader: PropTypes.bool.isRequired,
  /** Whether or not ModalFooter is a child. Will change the styling */
  hasFooter: PropTypes.bool.isRequired,
  /** Callback invoked to close the Modal. Not required, but strongly suggested. */
  onClose: PropTypes.func,
  /** The size of the modal. If unspecified, uses md styles. */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Whether or not to show the close button (optional) */
  hideCloseButton: PropTypes.bool,
  /** Objects containing css-in-js styling*/
  contentStyling: PropTypes.object,
  /** Objects containing props to apply to ModalOverlay component */
  overlayProps: PropTypes.object
};

var container = {
  base: '100%',
  // 640px
  tablet: '45rem',
  // 720px
  desktop: '72rem' // 1152px
};
var sizes$6 = {
  container: container,
  0: '0',
  0.5: '0.125rem',
  // 2px
  1: '0.25rem',
  // 4px
  1.5: '0.375rem',
  // 6px
  2: '0.5rem',
  // 8px
  2.5: '0.625rem',
  // 10px
  3: '0.75rem',
  // 12px
  3.5: '0.875rem',
  // 14px
  4: '1rem',
  // 16px
  4.5: '1.125rem',
  // 18px
  5: '1.25rem',
  // 20px
  5.5: '1.375rem',
  // 22px
  6: '1.5rem',
  // 24px
  7: '1.75rem',
  // 28px
  8: '2rem',
  // 32px
  9: '2.25rem',
  // 36px
  10: '2.5rem',
  // 40px
  12: '3rem',
  // 48px
  14: '3.5rem',
  // 56px
  16: '4rem',
  // 64px
  20: '5rem',
  // 80px
  24: '6rem',
  // 96px
  28: '7rem',
  // 112px
  32: '8rem',
  // 128px
  36: '9rem',
  // 144px
  40: '10rem',
  // 160px
  44: '11rem',
  // 176px
  48: '12rem',
  // 192px
  52: '13rem',
  // 208px
  56: '14rem',
  // 224px
  60: '15rem',
  // 240px
  64: '16rem',
  // 256px
  72: '18rem',
  // 272px
  80: '20rem',
  // 288px
  96: '24rem',
  // 384px
  px: '1px',
  full: '100%',
  max: 'max-content',
  min: 'min-content'
};

var white = '#ffffff';
var black = '#000000';
var brandBlue = '#0082ff';
var modalOverlay = '#21212160';
var gray = {
  50: '#f6f7f9',
  100: '#e1e6ec',
  200: '#cbd4de',
  300: '#afbdcc',
  400: '#94a7ba',
  500: '#7890a8',
  600: '#537495',
  700: '#3b5261',
  800: '#2f3f4b',
  900: '#26323c'
};
var blue = {
  50: '#f6fbfd',
  100: '#e6f8fd',
  200: '#c0e9fb',
  300: '#96d3fa',
  400: '#5baafa',
  500: '#1271eb',
  600: '#1d58f2',
  700: '#1b46da',
  800: '#1735a6',
  900: '#132b7f'
};
var navy = {
  50: '#f4fafc',
  100: '#e4f7fb',
  200: '#bfebf6',
  300: '#92d9f4',
  400: '#51b7f0',
  500: '#2590ea',
  600: '#1a6cda',
  700: '#1b55b6',
  800: '#194185',
  900: '#002d5b'
};
var green = {
  50: '#ecf8f7',
  100: '#d3f7ef',
  200: '#a4f3d9',
  300: '#65eabf',
  400: '#1edb96',
  500: '#09c66a',
  600: '#08ad50',
  700: '#008547',
  800: '#11703e',
  900: '#115a35'
};
var yellow = {
  50: '#f9f5e5',
  100: '#faf0bd',
  200: '#f6e67c',
  300: '#f1d439',
  400: '#ffbf02',
  500: '#e19706',
  600: '#cf7404',
  700: '#ae5708',
  800: '#8e440e',
  900: '#743710'
};
var red = {
  50: '#fdf9f8',
  100: '#fdeef3',
  200: '#fbcee6',
  300: '#fba4d1',
  400: '#fc6bad',
  500: '#fc4086',
  600: '#f7265f',
  700: '#e01438',
  800: '#b4193c',
  900: '#901530'
};
var colors$1 = {
  gray: _objectSpread2$1(_objectSpread2$1({}, gray), {}, {
    light: gray['50'],
    medium: gray['200'],
    dark: gray['600']
  }),
  blue: blue,
  navy: navy,
  red: _objectSpread2$1(_objectSpread2$1({}, red), {}, {
    "default": red['700']
  }),
  green: _objectSpread2$1(_objectSpread2$1({}, green), {}, {
    "default": green['700']
  }),
  yellow: _objectSpread2$1(_objectSpread2$1({}, yellow), {}, {
    "default": yellow['400']
  }),
  primary: _objectSpread2$1(_objectSpread2$1({}, blue), {}, {
    "default": blue['500']
  }),
  secondary: _objectSpread2$1(_objectSpread2$1({}, navy), {}, {
    "default": navy['900']
  }),
  success: green['700'],
  warning: yellow['400'],
  error: red['700'],
  accent: gray['200'],
  text: {
    primary: {
      light: black,
      dark: white
    },
    secondary: {
      light: gray['600']
    },
    link: {
      light: blue['500'],
      dark: white
    }
  },
  background: {
    gray: gray['50'],
    white: white
  },
  white: white,
  black: black,
  brandBlue: brandBlue,
  modalOverlay: modalOverlay
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
var _listCacheClear;
var hasRequired_listCacheClear;
function require_listCacheClear() {
  if (hasRequired_listCacheClear) return _listCacheClear;
  hasRequired_listCacheClear = 1;
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  _listCacheClear = listCacheClear;
  return _listCacheClear;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
var eq_1;
var hasRequiredEq;
function requireEq() {
  if (hasRequiredEq) return eq_1;
  hasRequiredEq = 1;
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  eq_1 = eq;
  return eq_1;
}

var _assocIndexOf;
var hasRequired_assocIndexOf;
function require_assocIndexOf() {
  if (hasRequired_assocIndexOf) return _assocIndexOf;
  hasRequired_assocIndexOf = 1;
  var eq = requireEq();

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  _assocIndexOf = assocIndexOf;
  return _assocIndexOf;
}

var _listCacheDelete;
var hasRequired_listCacheDelete;
function require_listCacheDelete() {
  if (hasRequired_listCacheDelete) return _listCacheDelete;
  hasRequired_listCacheDelete = 1;
  var assocIndexOf = require_assocIndexOf();

  /** Used for built-in method references. */
  var arrayProto = Array.prototype;

  /** Built-in value references. */
  var splice = arrayProto.splice;

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  _listCacheDelete = listCacheDelete;
  return _listCacheDelete;
}

var _listCacheGet;
var hasRequired_listCacheGet;
function require_listCacheGet() {
  if (hasRequired_listCacheGet) return _listCacheGet;
  hasRequired_listCacheGet = 1;
  var assocIndexOf = require_assocIndexOf();

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }
  _listCacheGet = listCacheGet;
  return _listCacheGet;
}

var _listCacheHas;
var hasRequired_listCacheHas;
function require_listCacheHas() {
  if (hasRequired_listCacheHas) return _listCacheHas;
  hasRequired_listCacheHas = 1;
  var assocIndexOf = require_assocIndexOf();

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  _listCacheHas = listCacheHas;
  return _listCacheHas;
}

var _listCacheSet;
var hasRequired_listCacheSet;
function require_listCacheSet() {
  if (hasRequired_listCacheSet) return _listCacheSet;
  hasRequired_listCacheSet = 1;
  var assocIndexOf = require_assocIndexOf();

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  _listCacheSet = listCacheSet;
  return _listCacheSet;
}

var _ListCache;
var hasRequired_ListCache;
function require_ListCache() {
  if (hasRequired_ListCache) return _ListCache;
  hasRequired_ListCache = 1;
  var listCacheClear = require_listCacheClear(),
    listCacheDelete = require_listCacheDelete(),
    listCacheGet = require_listCacheGet(),
    listCacheHas = require_listCacheHas(),
    listCacheSet = require_listCacheSet();

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  _ListCache = ListCache;
  return _ListCache;
}

var _stackClear;
var hasRequired_stackClear;
function require_stackClear() {
  if (hasRequired_stackClear) return _stackClear;
  hasRequired_stackClear = 1;
  var ListCache = require_ListCache();

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  _stackClear = stackClear;
  return _stackClear;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
var _stackDelete;
var hasRequired_stackDelete;
function require_stackDelete() {
  if (hasRequired_stackDelete) return _stackDelete;
  hasRequired_stackDelete = 1;
  function stackDelete(key) {
    var data = this.__data__,
      result = data['delete'](key);
    this.size = data.size;
    return result;
  }
  _stackDelete = stackDelete;
  return _stackDelete;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
var _stackGet;
var hasRequired_stackGet;
function require_stackGet() {
  if (hasRequired_stackGet) return _stackGet;
  hasRequired_stackGet = 1;
  function stackGet(key) {
    return this.__data__.get(key);
  }
  _stackGet = stackGet;
  return _stackGet;
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
var _stackHas;
var hasRequired_stackHas;
function require_stackHas() {
  if (hasRequired_stackHas) return _stackHas;
  hasRequired_stackHas = 1;
  function stackHas(key) {
    return this.__data__.has(key);
  }
  _stackHas = stackHas;
  return _stackHas;
}

var _freeGlobal;
var hasRequired_freeGlobal;
function require_freeGlobal() {
  if (hasRequired_freeGlobal) return _freeGlobal;
  hasRequired_freeGlobal = 1;
  var freeGlobal = _typeof$1(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  _freeGlobal = freeGlobal;
  return _freeGlobal;
}

var _root;
var hasRequired_root;
function require_root() {
  if (hasRequired_root) return _root;
  hasRequired_root = 1;
  var freeGlobal = require_freeGlobal();

  /** Detect free variable `self`. */
  var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof$1(self)) == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();
  _root = root;
  return _root;
}

var _Symbol;
var hasRequired_Symbol;
function require_Symbol() {
  if (hasRequired_Symbol) return _Symbol;
  hasRequired_Symbol = 1;
  var root = require_root();

  /** Built-in value references. */
  var _Symbol2 = root.Symbol;
  _Symbol = _Symbol2;
  return _Symbol;
}

var _getRawTag;
var hasRequired_getRawTag;
function require_getRawTag() {
  if (hasRequired_getRawTag) return _getRawTag;
  hasRequired_getRawTag = 1;
  var _Symbol = require_Symbol();

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Built-in value references. */
  var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];
    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }
  _getRawTag = getRawTag;
  return _getRawTag;
}

/** Used for built-in method references. */
var _objectToString;
var hasRequired_objectToString;
function require_objectToString() {
  if (hasRequired_objectToString) return _objectToString;
  hasRequired_objectToString = 1;
  var objectProto = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  _objectToString = objectToString;
  return _objectToString;
}

var _baseGetTag;
var hasRequired_baseGetTag;
function require_baseGetTag() {
  if (hasRequired_baseGetTag) return _baseGetTag;
  hasRequired_baseGetTag = 1;
  var _Symbol = require_Symbol(),
    getRawTag = require_getRawTag(),
    objectToString = require_objectToString();

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }
  _baseGetTag = baseGetTag;
  return _baseGetTag;
}

var isObject_1;
var hasRequiredIsObject;
function requireIsObject() {
  if (hasRequiredIsObject) return isObject_1;
  hasRequiredIsObject = 1;
  function isObject(value) {
    var type = _typeof$1(value);
    return value != null && (type == 'object' || type == 'function');
  }
  isObject_1 = isObject;
  return isObject_1;
}

var isFunction_1;
var hasRequiredIsFunction;
function requireIsFunction() {
  if (hasRequiredIsFunction) return isFunction_1;
  hasRequiredIsFunction = 1;
  var baseGetTag = require_baseGetTag(),
    isObject = requireIsObject();

  /** `Object#toString` result references. */
  var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  isFunction_1 = isFunction;
  return isFunction_1;
}

var _coreJsData;
var hasRequired_coreJsData;
function require_coreJsData() {
  if (hasRequired_coreJsData) return _coreJsData;
  hasRequired_coreJsData = 1;
  var root = require_root();

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root['__core-js_shared__'];
  _coreJsData = coreJsData;
  return _coreJsData;
}

var _isMasked;
var hasRequired_isMasked;
function require_isMasked() {
  if (hasRequired_isMasked) return _isMasked;
  hasRequired_isMasked = 1;
  var coreJsData = require_coreJsData();

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  _isMasked = isMasked;
  return _isMasked;
}

/** Used for built-in method references. */
var _toSource;
var hasRequired_toSource;
function require_toSource() {
  if (hasRequired_toSource) return _toSource;
  hasRequired_toSource = 1;
  var funcProto = Function.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return func + '';
      } catch (e) {}
    }
    return '';
  }
  _toSource = toSource;
  return _toSource;
}

var _baseIsNative;
var hasRequired_baseIsNative;
function require_baseIsNative() {
  if (hasRequired_baseIsNative) return _baseIsNative;
  hasRequired_baseIsNative = 1;
  var isFunction = requireIsFunction(),
    isMasked = require_isMasked(),
    isObject = requireIsObject(),
    toSource = require_toSource();

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used for built-in method references. */
  var funcProto = Function.prototype,
    objectProto = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  _baseIsNative = baseIsNative;
  return _baseIsNative;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
var _getValue;
var hasRequired_getValue;
function require_getValue() {
  if (hasRequired_getValue) return _getValue;
  hasRequired_getValue = 1;
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  _getValue = getValue;
  return _getValue;
}

var _getNative;
var hasRequired_getNative;
function require_getNative() {
  if (hasRequired_getNative) return _getNative;
  hasRequired_getNative = 1;
  var baseIsNative = require_baseIsNative(),
    getValue = require_getValue();

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  _getNative = getNative;
  return _getNative;
}

var _Map;
var hasRequired_Map;
function require_Map() {
  if (hasRequired_Map) return _Map;
  hasRequired_Map = 1;
  var getNative = require_getNative(),
    root = require_root();

  /* Built-in method references that are verified to be native. */
  var Map = getNative(root, 'Map');
  _Map = Map;
  return _Map;
}

var _nativeCreate;
var hasRequired_nativeCreate;
function require_nativeCreate() {
  if (hasRequired_nativeCreate) return _nativeCreate;
  hasRequired_nativeCreate = 1;
  var getNative = require_getNative();

  /* Built-in method references that are verified to be native. */
  var nativeCreate = getNative(Object, 'create');
  _nativeCreate = nativeCreate;
  return _nativeCreate;
}

var _hashClear;
var hasRequired_hashClear;
function require_hashClear() {
  if (hasRequired_hashClear) return _hashClear;
  hasRequired_hashClear = 1;
  var nativeCreate = require_nativeCreate();

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }
  _hashClear = hashClear;
  return _hashClear;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
var _hashDelete;
var hasRequired_hashDelete;
function require_hashDelete() {
  if (hasRequired_hashDelete) return _hashDelete;
  hasRequired_hashDelete = 1;
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  _hashDelete = hashDelete;
  return _hashDelete;
}

var _hashGet;
var hasRequired_hashGet;
function require_hashGet() {
  if (hasRequired_hashGet) return _hashGet;
  hasRequired_hashGet = 1;
  var nativeCreate = require_nativeCreate();

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }
  _hashGet = hashGet;
  return _hashGet;
}

var _hashHas;
var hasRequired_hashHas;
function require_hashHas() {
  if (hasRequired_hashHas) return _hashHas;
  hasRequired_hashHas = 1;
  var nativeCreate = require_nativeCreate();

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }
  _hashHas = hashHas;
  return _hashHas;
}

var _hashSet;
var hasRequired_hashSet;
function require_hashSet() {
  if (hasRequired_hashSet) return _hashSet;
  hasRequired_hashSet = 1;
  var nativeCreate = require_nativeCreate();

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  }
  _hashSet = hashSet;
  return _hashSet;
}

var _Hash;
var hasRequired_Hash;
function require_Hash() {
  if (hasRequired_Hash) return _Hash;
  hasRequired_Hash = 1;
  var hashClear = require_hashClear(),
    hashDelete = require_hashDelete(),
    hashGet = require_hashGet(),
    hashHas = require_hashHas(),
    hashSet = require_hashSet();

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  _Hash = Hash;
  return _Hash;
}

var _mapCacheClear;
var hasRequired_mapCacheClear;
function require_mapCacheClear() {
  if (hasRequired_mapCacheClear) return _mapCacheClear;
  hasRequired_mapCacheClear = 1;
  var Hash = require_Hash(),
    ListCache = require_ListCache(),
    Map = require_Map();

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }
  _mapCacheClear = mapCacheClear;
  return _mapCacheClear;
}

var _isKeyable;
var hasRequired_isKeyable;
function require_isKeyable() {
  if (hasRequired_isKeyable) return _isKeyable;
  hasRequired_isKeyable = 1;
  function isKeyable(value) {
    var type = _typeof$1(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }
  _isKeyable = isKeyable;
  return _isKeyable;
}

var _getMapData;
var hasRequired_getMapData;
function require_getMapData() {
  if (hasRequired_getMapData) return _getMapData;
  hasRequired_getMapData = 1;
  var isKeyable = require_isKeyable();

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }
  _getMapData = getMapData;
  return _getMapData;
}

var _mapCacheDelete;
var hasRequired_mapCacheDelete;
function require_mapCacheDelete() {
  if (hasRequired_mapCacheDelete) return _mapCacheDelete;
  hasRequired_mapCacheDelete = 1;
  var getMapData = require_getMapData();

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  _mapCacheDelete = mapCacheDelete;
  return _mapCacheDelete;
}

var _mapCacheGet;
var hasRequired_mapCacheGet;
function require_mapCacheGet() {
  if (hasRequired_mapCacheGet) return _mapCacheGet;
  hasRequired_mapCacheGet = 1;
  var getMapData = require_getMapData();

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  _mapCacheGet = mapCacheGet;
  return _mapCacheGet;
}

var _mapCacheHas;
var hasRequired_mapCacheHas;
function require_mapCacheHas() {
  if (hasRequired_mapCacheHas) return _mapCacheHas;
  hasRequired_mapCacheHas = 1;
  var getMapData = require_getMapData();

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  _mapCacheHas = mapCacheHas;
  return _mapCacheHas;
}

var _mapCacheSet;
var hasRequired_mapCacheSet;
function require_mapCacheSet() {
  if (hasRequired_mapCacheSet) return _mapCacheSet;
  hasRequired_mapCacheSet = 1;
  var getMapData = require_getMapData();

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
      size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }
  _mapCacheSet = mapCacheSet;
  return _mapCacheSet;
}

var _MapCache;
var hasRequired_MapCache;
function require_MapCache() {
  if (hasRequired_MapCache) return _MapCache;
  hasRequired_MapCache = 1;
  var mapCacheClear = require_mapCacheClear(),
    mapCacheDelete = require_mapCacheDelete(),
    mapCacheGet = require_mapCacheGet(),
    mapCacheHas = require_mapCacheHas(),
    mapCacheSet = require_mapCacheSet();

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  _MapCache = MapCache;
  return _MapCache;
}

var _stackSet;
var hasRequired_stackSet;
function require_stackSet() {
  if (hasRequired_stackSet) return _stackSet;
  hasRequired_stackSet = 1;
  var ListCache = require_ListCache(),
    Map = require_Map(),
    MapCache = require_MapCache();

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
      var pairs = data.__data__;
      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  _stackSet = stackSet;
  return _stackSet;
}

var _Stack;
var hasRequired_Stack;
function require_Stack() {
  if (hasRequired_Stack) return _Stack;
  hasRequired_Stack = 1;
  var ListCache = require_ListCache(),
    stackClear = require_stackClear(),
    stackDelete = require_stackDelete(),
    stackGet = require_stackGet(),
    stackHas = require_stackHas(),
    stackSet = require_stackSet();

  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }

  // Add methods to `Stack`.
  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  _Stack = Stack;
  return _Stack;
}

var _defineProperty$1;
var hasRequired_defineProperty;
function require_defineProperty() {
  if (hasRequired_defineProperty) return _defineProperty$1;
  hasRequired_defineProperty = 1;
  var getNative = require_getNative();
  var defineProperty = function () {
    try {
      var func = getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }();
  _defineProperty$1 = defineProperty;
  return _defineProperty$1;
}

var _baseAssignValue;
var hasRequired_baseAssignValue;
function require_baseAssignValue() {
  if (hasRequired_baseAssignValue) return _baseAssignValue;
  hasRequired_baseAssignValue = 1;
  var defineProperty = require_defineProperty();

  /**
   * The base implementation of `assignValue` and `assignMergeValue` without
   * value checks.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) {
      defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
      });
    } else {
      object[key] = value;
    }
  }
  _baseAssignValue = baseAssignValue;
  return _baseAssignValue;
}

var _assignMergeValue;
var hasRequired_assignMergeValue;
function require_assignMergeValue() {
  if (hasRequired_assignMergeValue) return _assignMergeValue;
  hasRequired_assignMergeValue = 1;
  var baseAssignValue = require_baseAssignValue(),
    eq = requireEq();

  /**
   * This function is like `assignValue` except that it doesn't assign
   * `undefined` values.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  _assignMergeValue = assignMergeValue;
  return _assignMergeValue;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
var _createBaseFor;
var hasRequired_createBaseFor;
function require_createBaseFor() {
  if (hasRequired_createBaseFor) return _createBaseFor;
  hasRequired_createBaseFor = 1;
  function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
      var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  _createBaseFor = createBaseFor;
  return _createBaseFor;
}

var _baseFor;
var hasRequired_baseFor;
function require_baseFor() {
  if (hasRequired_baseFor) return _baseFor;
  hasRequired_baseFor = 1;
  var createBaseFor = require_createBaseFor();

  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */
  var baseFor = createBaseFor();
  _baseFor = baseFor;
  return _baseFor;
}

var _cloneBuffer = {exports: {}};

_cloneBuffer.exports;
var hasRequired_cloneBuffer;
function require_cloneBuffer() {
  if (hasRequired_cloneBuffer) return _cloneBuffer.exports;
  hasRequired_cloneBuffer = 1;
  (function (module, exports) {
    var root = require_root();

    /** Detect free variable `exports`. */
    var freeExports = exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Built-in value references. */
    var Buffer = moduleExports ? root.Buffer : undefined,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }
    module.exports = cloneBuffer;
  })(_cloneBuffer, _cloneBuffer.exports);
  return _cloneBuffer.exports;
}

var _Uint8Array;
var hasRequired_Uint8Array;
function require_Uint8Array() {
  if (hasRequired_Uint8Array) return _Uint8Array;
  hasRequired_Uint8Array = 1;
  var root = require_root();

  /** Built-in value references. */
  var Uint8Array = root.Uint8Array;
  _Uint8Array = Uint8Array;
  return _Uint8Array;
}

var _cloneArrayBuffer;
var hasRequired_cloneArrayBuffer;
function require_cloneArrayBuffer() {
  if (hasRequired_cloneArrayBuffer) return _cloneArrayBuffer;
  hasRequired_cloneArrayBuffer = 1;
  var Uint8Array = require_Uint8Array();

  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }
  _cloneArrayBuffer = cloneArrayBuffer;
  return _cloneArrayBuffer;
}

var _cloneTypedArray;
var hasRequired_cloneTypedArray;
function require_cloneTypedArray() {
  if (hasRequired_cloneTypedArray) return _cloneTypedArray;
  hasRequired_cloneTypedArray = 1;
  var cloneArrayBuffer = require_cloneArrayBuffer();

  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  _cloneTypedArray = cloneTypedArray;
  return _cloneTypedArray;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
var _copyArray;
var hasRequired_copyArray;
function require_copyArray() {
  if (hasRequired_copyArray) return _copyArray;
  hasRequired_copyArray = 1;
  function copyArray(source, array) {
    var index = -1,
      length = source.length;
    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }
  _copyArray = copyArray;
  return _copyArray;
}

var _baseCreate;
var hasRequired_baseCreate;
function require_baseCreate() {
  if (hasRequired_baseCreate) return _baseCreate;
  hasRequired_baseCreate = 1;
  var isObject = requireIsObject();

  /** Built-in value references. */
  var objectCreate = Object.create;

  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} proto The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  var baseCreate = function () {
    function object() {}
    return function (proto) {
      if (!isObject(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result = new object();
      object.prototype = undefined;
      return result;
    };
  }();
  _baseCreate = baseCreate;
  return _baseCreate;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
var _overArg;
var hasRequired_overArg;
function require_overArg() {
  if (hasRequired_overArg) return _overArg;
  hasRequired_overArg = 1;
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  _overArg = overArg;
  return _overArg;
}

var _getPrototype;
var hasRequired_getPrototype;
function require_getPrototype() {
  if (hasRequired_getPrototype) return _getPrototype;
  hasRequired_getPrototype = 1;
  var overArg = require_overArg();

  /** Built-in value references. */
  var getPrototype = overArg(Object.getPrototypeOf, Object);
  _getPrototype = getPrototype;
  return _getPrototype;
}

/** Used for built-in method references. */
var _isPrototype;
var hasRequired_isPrototype;
function require_isPrototype() {
  if (hasRequired_isPrototype) return _isPrototype;
  hasRequired_isPrototype = 1;
  var objectProto = Object.prototype;

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  _isPrototype = isPrototype;
  return _isPrototype;
}

var _initCloneObject;
var hasRequired_initCloneObject;
function require_initCloneObject() {
  if (hasRequired_initCloneObject) return _initCloneObject;
  hasRequired_initCloneObject = 1;
  var baseCreate = require_baseCreate(),
    getPrototype = require_getPrototype(),
    isPrototype = require_isPrototype();

  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }
  _initCloneObject = initCloneObject;
  return _initCloneObject;
}

var isObjectLike_1;
var hasRequiredIsObjectLike;
function requireIsObjectLike() {
  if (hasRequiredIsObjectLike) return isObjectLike_1;
  hasRequiredIsObjectLike = 1;
  function isObjectLike(value) {
    return value != null && _typeof$1(value) == 'object';
  }
  isObjectLike_1 = isObjectLike;
  return isObjectLike_1;
}

var _baseIsArguments;
var hasRequired_baseIsArguments;
function require_baseIsArguments() {
  if (hasRequired_baseIsArguments) return _baseIsArguments;
  hasRequired_baseIsArguments = 1;
  var baseGetTag = require_baseGetTag(),
    isObjectLike = requireIsObjectLike();

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]';

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }
  _baseIsArguments = baseIsArguments;
  return _baseIsArguments;
}

var isArguments_1;
var hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments) return isArguments_1;
  hasRequiredIsArguments = 1;
  var baseIsArguments = require_baseIsArguments(),
    isObjectLike = requireIsObjectLike();

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };
  isArguments_1 = isArguments;
  return isArguments_1;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray_1;
var hasRequiredIsArray;
function requireIsArray() {
  if (hasRequiredIsArray) return isArray_1;
  hasRequiredIsArray = 1;
  var isArray = Array.isArray;
  isArray_1 = isArray;
  return isArray_1;
}

/** Used as references for various `Number` constants. */
var isLength_1;
var hasRequiredIsLength;
function requireIsLength() {
  if (hasRequiredIsLength) return isLength_1;
  hasRequiredIsLength = 1;
  var MAX_SAFE_INTEGER = 9007199254740991;

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  isLength_1 = isLength;
  return isLength_1;
}

var isArrayLike_1;
var hasRequiredIsArrayLike;
function requireIsArrayLike() {
  if (hasRequiredIsArrayLike) return isArrayLike_1;
  hasRequiredIsArrayLike = 1;
  var isFunction = requireIsFunction(),
    isLength = requireIsLength();

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  isArrayLike_1 = isArrayLike;
  return isArrayLike_1;
}

var isArrayLikeObject_1;
var hasRequiredIsArrayLikeObject;
function requireIsArrayLikeObject() {
  if (hasRequiredIsArrayLikeObject) return isArrayLikeObject_1;
  hasRequiredIsArrayLikeObject = 1;
  var isArrayLike = requireIsArrayLike(),
    isObjectLike = requireIsObjectLike();

  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */
  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }
  isArrayLikeObject_1 = isArrayLikeObject;
  return isArrayLikeObject_1;
}

var isBuffer = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
var stubFalse_1;
var hasRequiredStubFalse;
function requireStubFalse() {
  if (hasRequiredStubFalse) return stubFalse_1;
  hasRequiredStubFalse = 1;
  function stubFalse() {
    return false;
  }
  stubFalse_1 = stubFalse;
  return stubFalse_1;
}

isBuffer.exports;
var hasRequiredIsBuffer;
function requireIsBuffer() {
  if (hasRequiredIsBuffer) return isBuffer.exports;
  hasRequiredIsBuffer = 1;
  (function (module, exports) {
    var root = require_root(),
      stubFalse = requireStubFalse();

    /** Detect free variable `exports`. */
    var freeExports = exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Built-in value references. */
    var Buffer = moduleExports ? root.Buffer : undefined;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;
  })(isBuffer, isBuffer.exports);
  return isBuffer.exports;
}

var isPlainObject_1;
var hasRequiredIsPlainObject;
function requireIsPlainObject() {
  if (hasRequiredIsPlainObject) return isPlainObject_1;
  hasRequiredIsPlainObject = 1;
  var baseGetTag = require_baseGetTag(),
    getPrototype = require_getPrototype(),
    isObjectLike = requireIsObjectLike();

  /** `Object#toString` result references. */
  var objectTag = '[object Object]';

  /** Used for built-in method references. */
  var funcProto = Function.prototype,
    objectProto = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to infer the `Object` constructor. */
  var objectCtorString = funcToString.call(Object);

  /**
   * Checks if `value` is a plain object, that is, an object created by the
   * `Object` constructor or one with a `[[Prototype]]` of `null`.
   *
   * @static
   * @memberOf _
   * @since 0.8.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * _.isPlainObject(new Foo);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   *
   * _.isPlainObject(Object.create(null));
   * // => true
   */
  function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
      return false;
    }
    var proto = getPrototype(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
  }
  isPlainObject_1 = isPlainObject;
  return isPlainObject_1;
}

var _baseIsTypedArray;
var hasRequired_baseIsTypedArray;
function require_baseIsTypedArray() {
  if (hasRequired_baseIsTypedArray) return _baseIsTypedArray;
  hasRequired_baseIsTypedArray = 1;
  var baseGetTag = require_baseGetTag(),
    isLength = requireIsLength(),
    isObjectLike = requireIsObjectLike();

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  _baseIsTypedArray = baseIsTypedArray;
  return _baseIsTypedArray;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
var _baseUnary;
var hasRequired_baseUnary;
function require_baseUnary() {
  if (hasRequired_baseUnary) return _baseUnary;
  hasRequired_baseUnary = 1;
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }
  _baseUnary = baseUnary;
  return _baseUnary;
}

var _nodeUtil = {exports: {}};

_nodeUtil.exports;
var hasRequired_nodeUtil;
function require_nodeUtil() {
  if (hasRequired_nodeUtil) return _nodeUtil.exports;
  hasRequired_nodeUtil = 1;
  (function (module, exports) {
    var freeGlobal = require_freeGlobal();

    /** Detect free variable `exports`. */
    var freeExports = exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Detect free variable `process` from Node.js. */
    var freeProcess = moduleExports && freeGlobal.process;

    /** Used to access faster Node.js helpers. */
    var nodeUtil = function () {
      try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) {
          return types;
        }

        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();
    module.exports = nodeUtil;
  })(_nodeUtil, _nodeUtil.exports);
  return _nodeUtil.exports;
}

var isTypedArray_1;
var hasRequiredIsTypedArray;
function requireIsTypedArray() {
  if (hasRequiredIsTypedArray) return isTypedArray_1;
  hasRequiredIsTypedArray = 1;
  var baseIsTypedArray = require_baseIsTypedArray(),
    baseUnary = require_baseUnary(),
    nodeUtil = require_nodeUtil();

  /* Node.js helper references. */
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  isTypedArray_1 = isTypedArray;
  return isTypedArray_1;
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
var _safeGet;
var hasRequired_safeGet;
function require_safeGet() {
  if (hasRequired_safeGet) return _safeGet;
  hasRequired_safeGet = 1;
  function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') {
      return;
    }
    if (key == '__proto__') {
      return;
    }
    return object[key];
  }
  _safeGet = safeGet;
  return _safeGet;
}

var _assignValue;
var hasRequired_assignValue;
function require_assignValue() {
  if (hasRequired_assignValue) return _assignValue;
  hasRequired_assignValue = 1;
  var baseAssignValue = require_baseAssignValue(),
    eq = requireEq();

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  _assignValue = assignValue;
  return _assignValue;
}

var _copyObject;
var hasRequired_copyObject;
function require_copyObject() {
  if (hasRequired_copyObject) return _copyObject;
  hasRequired_copyObject = 1;
  var assignValue = require_assignValue(),
    baseAssignValue = require_baseAssignValue();

  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1,
      length = props.length;
    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
      if (newValue === undefined) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }
    return object;
  }
  _copyObject = copyObject;
  return _copyObject;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
var _baseTimes;
var hasRequired_baseTimes;
function require_baseTimes() {
  if (hasRequired_baseTimes) return _baseTimes;
  hasRequired_baseTimes = 1;
  function baseTimes(n, iteratee) {
    var index = -1,
      result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  _baseTimes = baseTimes;
  return _baseTimes;
}

var _isIndex;
var hasRequired_isIndex;
function require_isIndex() {
  if (hasRequired_isIndex) return _isIndex;
  hasRequired_isIndex = 1;
  var MAX_SAFE_INTEGER = 9007199254740991;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    var type = _typeof$1(value);
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  _isIndex = isIndex;
  return _isIndex;
}

var _arrayLikeKeys;
var hasRequired_arrayLikeKeys;
function require_arrayLikeKeys() {
  if (hasRequired_arrayLikeKeys) return _arrayLikeKeys;
  hasRequired_arrayLikeKeys = 1;
  var baseTimes = require_baseTimes(),
    isArguments = requireIsArguments(),
    isArray = requireIsArray(),
    isBuffer = requireIsBuffer(),
    isIndex = require_isIndex(),
    isTypedArray = requireIsTypedArray();

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
      // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' ||
      // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') ||
      // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
      // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  _arrayLikeKeys = arrayLikeKeys;
  return _arrayLikeKeys;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
var _nativeKeysIn;
var hasRequired_nativeKeysIn;
function require_nativeKeysIn() {
  if (hasRequired_nativeKeysIn) return _nativeKeysIn;
  hasRequired_nativeKeysIn = 1;
  function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }
  _nativeKeysIn = nativeKeysIn;
  return _nativeKeysIn;
}

var _baseKeysIn;
var hasRequired_baseKeysIn;
function require_baseKeysIn() {
  if (hasRequired_baseKeysIn) return _baseKeysIn;
  hasRequired_baseKeysIn = 1;
  var isObject = requireIsObject(),
    isPrototype = require_isPrototype(),
    nativeKeysIn = require_nativeKeysIn();

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeysIn(object) {
    if (!isObject(object)) {
      return nativeKeysIn(object);
    }
    var isProto = isPrototype(object),
      result = [];
    for (var key in object) {
      if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }
  _baseKeysIn = baseKeysIn;
  return _baseKeysIn;
}

var keysIn_1;
var hasRequiredKeysIn;
function requireKeysIn() {
  if (hasRequiredKeysIn) return keysIn_1;
  hasRequiredKeysIn = 1;
  var arrayLikeKeys = require_arrayLikeKeys(),
    baseKeysIn = require_baseKeysIn(),
    isArrayLike = requireIsArrayLike();

  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */
  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }
  keysIn_1 = keysIn;
  return keysIn_1;
}

var toPlainObject_1;
var hasRequiredToPlainObject;
function requireToPlainObject() {
  if (hasRequiredToPlainObject) return toPlainObject_1;
  hasRequiredToPlainObject = 1;
  var copyObject = require_copyObject(),
    keysIn = requireKeysIn();

  /**
   * Converts `value` to a plain object flattening inherited enumerable string
   * keyed properties of `value` to own properties of the plain object.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Object} Returns the converted plain object.
   * @example
   *
   * function Foo() {
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.assign({ 'a': 1 }, new Foo);
   * // => { 'a': 1, 'b': 2 }
   *
   * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
   * // => { 'a': 1, 'b': 2, 'c': 3 }
   */
  function toPlainObject(value) {
    return copyObject(value, keysIn(value));
  }
  toPlainObject_1 = toPlainObject;
  return toPlainObject_1;
}

var _baseMergeDeep;
var hasRequired_baseMergeDeep;
function require_baseMergeDeep() {
  if (hasRequired_baseMergeDeep) return _baseMergeDeep;
  hasRequired_baseMergeDeep = 1;
  var assignMergeValue = require_assignMergeValue(),
    cloneBuffer = require_cloneBuffer(),
    cloneTypedArray = require_cloneTypedArray(),
    copyArray = require_copyArray(),
    initCloneObject = require_initCloneObject(),
    isArguments = requireIsArguments(),
    isArray = requireIsArray(),
    isArrayLikeObject = requireIsArrayLikeObject(),
    isBuffer = requireIsBuffer(),
    isFunction = requireIsFunction(),
    isObject = requireIsObject(),
    isPlainObject = requireIsPlainObject(),
    isTypedArray = requireIsTypedArray(),
    safeGet = require_safeGet(),
    toPlainObject = requireToPlainObject();

  /**
   * A specialized version of `baseMerge` for arrays and objects which performs
   * deep merges and tracks traversed objects enabling objects with circular
   * references to be merged.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {string} key The key of the value to merge.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} mergeFunc The function to merge values.
   * @param {Function} [customizer] The function to customize assigned values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);
    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
      var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
      newValue = srcValue;
      if (isArr || isBuff || isTyped) {
        if (isArray(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject(objValue)) {
          newValue = copyArray(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer(srcValue, true);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray(srcValue, true);
        } else {
          newValue = [];
        }
      } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
        newValue = objValue;
        if (isArguments(objValue)) {
          newValue = toPlainObject(objValue);
        } else if (!isObject(objValue) || isFunction(objValue)) {
          newValue = initCloneObject(srcValue);
        }
      } else {
        isCommon = false;
      }
    }
    if (isCommon) {
      // Recursively merge objects and arrays (susceptible to call stack limits).
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
  }
  _baseMergeDeep = baseMergeDeep;
  return _baseMergeDeep;
}

var _baseMerge;
var hasRequired_baseMerge;
function require_baseMerge() {
  if (hasRequired_baseMerge) return _baseMerge;
  hasRequired_baseMerge = 1;
  var Stack = require_Stack(),
    assignMergeValue = require_assignMergeValue(),
    baseFor = require_baseFor(),
    baseMergeDeep = require_baseMergeDeep(),
    isObject = requireIsObject(),
    keysIn = requireKeysIn(),
    safeGet = require_safeGet();

  /**
   * The base implementation of `_.merge` without support for multiple sources.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} [customizer] The function to customize merged values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */
  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }
    baseFor(source, function (srcValue, key) {
      stack || (stack = new Stack());
      if (isObject(srcValue)) {
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      } else {
        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
        if (newValue === undefined) {
          newValue = srcValue;
        }
        assignMergeValue(object, key, newValue);
      }
    }, keysIn);
  }
  _baseMerge = baseMerge;
  return _baseMerge;
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
var identity_1;
var hasRequiredIdentity;
function requireIdentity() {
  if (hasRequiredIdentity) return identity_1;
  hasRequiredIdentity = 1;
  function identity(value) {
    return value;
  }
  identity_1 = identity;
  return identity_1;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
var _apply;
var hasRequired_apply;
function require_apply() {
  if (hasRequired_apply) return _apply;
  hasRequired_apply = 1;
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  _apply = apply;
  return _apply;
}

var _overRest;
var hasRequired_overRest;
function require_overRest() {
  if (hasRequired_overRest) return _overRest;
  hasRequired_overRest = 1;
  var apply = require_apply();

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax = Math.max;

  /**
   * A specialized version of `baseRest` which transforms the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @param {Function} transform The rest array transform.
   * @returns {Function} Returns the new function.
   */
  function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function () {
      var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);
      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform(array);
      return apply(func, this, otherArgs);
    };
  }
  _overRest = overRest;
  return _overRest;
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
var constant_1;
var hasRequiredConstant;
function requireConstant() {
  if (hasRequiredConstant) return constant_1;
  hasRequiredConstant = 1;
  function constant(value) {
    return function () {
      return value;
    };
  }
  constant_1 = constant;
  return constant_1;
}

var _baseSetToString;
var hasRequired_baseSetToString;
function require_baseSetToString() {
  if (hasRequired_baseSetToString) return _baseSetToString;
  hasRequired_baseSetToString = 1;
  var constant = requireConstant(),
    defineProperty = require_defineProperty(),
    identity = requireIdentity();

  /**
   * The base implementation of `setToString` without support for hot loop shorting.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var baseSetToString = !defineProperty ? identity : function (func, string) {
    return defineProperty(func, 'toString', {
      'configurable': true,
      'enumerable': false,
      'value': constant(string),
      'writable': true
    });
  };
  _baseSetToString = baseSetToString;
  return _baseSetToString;
}

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var _shortOut;
var hasRequired_shortOut;
function require_shortOut() {
  if (hasRequired_shortOut) return _shortOut;
  hasRequired_shortOut = 1;
  var HOT_COUNT = 800,
    HOT_SPAN = 16;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeNow = Date.now;

  /**
   * Creates a function that'll short out and invoke `identity` instead
   * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
   * milliseconds.
   *
   * @private
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new shortable function.
   */
  function shortOut(func) {
    var count = 0,
      lastCalled = 0;
    return function () {
      var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(undefined, arguments);
    };
  }
  _shortOut = shortOut;
  return _shortOut;
}

var _setToString;
var hasRequired_setToString;
function require_setToString() {
  if (hasRequired_setToString) return _setToString;
  hasRequired_setToString = 1;
  var baseSetToString = require_baseSetToString(),
    shortOut = require_shortOut();

  /**
   * Sets the `toString` method of `func` to return `string`.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var setToString = shortOut(baseSetToString);
  _setToString = setToString;
  return _setToString;
}

var _baseRest;
var hasRequired_baseRest;
function require_baseRest() {
  if (hasRequired_baseRest) return _baseRest;
  hasRequired_baseRest = 1;
  var identity = requireIdentity(),
    overRest = require_overRest(),
    setToString = require_setToString();

  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */
  function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
  }
  _baseRest = baseRest;
  return _baseRest;
}

var _isIterateeCall;
var hasRequired_isIterateeCall;
function require_isIterateeCall() {
  if (hasRequired_isIterateeCall) return _isIterateeCall;
  hasRequired_isIterateeCall = 1;
  var eq = requireEq(),
    isArrayLike = requireIsArrayLike(),
    isIndex = require_isIndex(),
    isObject = requireIsObject();

  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */
  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }
    var type = _typeof$1(index);
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
      return eq(object[index], value);
    }
    return false;
  }
  _isIterateeCall = isIterateeCall;
  return _isIterateeCall;
}

var _createAssigner;
var hasRequired_createAssigner;
function require_createAssigner() {
  if (hasRequired_createAssigner) return _createAssigner;
  hasRequired_createAssigner = 1;
  var baseRest = require_baseRest(),
    isIterateeCall = require_isIterateeCall();

  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */
  function createAssigner(assigner) {
    return baseRest(function (object, sources) {
      var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;
      customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? undefined : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }
  _createAssigner = createAssigner;
  return _createAssigner;
}

var merge_1;
var hasRequiredMerge;
function requireMerge() {
  if (hasRequiredMerge) return merge_1;
  hasRequiredMerge = 1;
  var baseMerge = require_baseMerge(),
    createAssigner = require_createAssigner();

  /**
   * This method is like `_.assign` except that it recursively merges own and
   * inherited enumerable string keyed properties of source objects into the
   * destination object. Source properties that resolve to `undefined` are
   * skipped if a destination value exists. Array and plain object properties
   * are merged recursively. Other objects and value types are overridden by
   * assignment. Source objects are applied from left to right. Subsequent
   * sources overwrite property assignments of previous sources.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 0.5.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var object = {
   *   'a': [{ 'b': 2 }, { 'd': 4 }]
   * };
   *
   * var other = {
   *   'a': [{ 'c': 3 }, { 'e': 5 }]
   * };
   *
   * _.merge(object, other);
   * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
   */
  var merge = createAssigner(function (object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
  });
  merge_1 = merge;
  return merge_1;
}

var mergeExports = requireMerge();
var merge$1 = /*@__PURE__*/getDefaultExportFromCjs(mergeExports);

var shadows = {
  outline: '0 0 0 3px rgba(91, 170, 250, 0.7)',
  // primary.400, 70% opacity
  drawer: '-8px 0 16px 0 rgba(33,33,33,.1)'
};
var shadows$1 = merge$1(theme$1.shadows, shadows);

var indices = {
  hide: -100,
  // equivalent to $z-index-negative in fe-core (https://github.com/spothero/fe-core/blob/main/utils/_defaults.scss)
  auto: 'auto',
  base: 0,
  // equivalent to $z-index-back in fe-core
  layer1: 100,
  // equivalent to $z-index-mid in fe-core
  layer2: 200,
  // equivalent to $z-index-fore in fe-core
  layer3: 300,
  // equivalent to $z-index-layer1 in fe-core
  layer4: 400,
  // equivalent to $z-index-layer2 in fe-core
  layer5: 500,
  // equivalent to $z-index-layer3 in fe-core
  layer6: 600,
  // equivalent to $z-index-layer4 in fe-core
  layer7: 700,
  // equivalent to $z-index-modal-shim in fe-core
  layer8: 800,
  // equivalent to $z-index-modal in fe-core
  layer9: 900,
  // equivalent to $z-index-notification in fe-core
  layer10: 1000 // equivalent to $z-index-top in fe-core
};

var breakpoints = {
  mobileXL: '30rem',
  // 480px
  tablet: '48rem',
  // 768px
  desktop: '64rem',
  // 1024px
  desktopXL: '90rem' // 1440px
};

var fonts = {
  heading: "\"Plus Jakarta Sans\", sans-serif",
  body: "\"Plus Jakarta Sans\", sans-serif"
};
var fontSizes = {
  '5xl': '3.5rem',
  // 56px
  '4xl': '3rem',
  // 48px
  '3xl': '2.5rem',
  // 40px
  '2xl': '2rem',
  // 32px
  xl: '1.5rem',
  // 24px
  lg: '1.25rem',
  // 20px
  md: '1.125rem',
  // 18px
  base: '1rem',
  // 16px
  sm: '0.875rem',
  // 14px
  xs: '0.75rem' // 12px
};
var fontWeights = {
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
};

var NOTIFICATION_STATUSES = {
  NEUTRAL: 'neutral',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success'
};
var NOTIFICATION_SIZES = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
};
var notificationBaseStyle = {
  container: {
    paddingY: 2,
    borderRadius: 'base'
  },
  actionButton: {
    fontSize: 'sm',
    height: 'fit-content',
    lineHeight: '1.4',
    color: 'primary.600',
    _hover: {
      color: 'primary.700'
    }
  },
  dismissButton: {
    color: 'gray.600',
    borderColor: 'transparent',
    borderWidth: '2px',
    padding: 0,
    width: 10,
    height: 10,
    backgroundColor: 'transparent',
    borderRadius: 'base',
    marginLeft: 2,
    _hover: {
      color: 'gray.700'
    },
    _focus: {
      color: 'gray.700',
      borderColor: 'white',
      boxShadow: 'outline'
    }
  },
  icon: {
    width: 6,
    marginRight: 2,
    height: 'auto'
  },
  description: {
    lineHeight: 1.4
  },
  title: {
    lineHeight: 1.4
  },
  variants: {},
  sizes: {
    sm: {
      title: {
        fontSize: 'xs'
      },
      description: {
        fontSize: 'xs'
      }
    },
    md: {
      title: {
        fontSize: 'sm'
      },
      description: {
        fontSize: 'sm'
      }
    },
    lg: {
      title: {
        fontSize: 'base'
      },
      description: {
        fontSize: 'base'
      }
    }
  }
};
var notificationStatusStyles = function notificationStatusStyles(status) {
  switch (status) {
    case NOTIFICATION_STATUSES.NEUTRAL:
      return {
        container: {
          background: 'gray.light'
        },
        icon: {
          color: 'gray.dark'
        },
        dismissButton: {
          _hover: {
            background: 'gray.200'
          },
          _focus: {
            background: 'gray.200'
          }
        }
      };
    case NOTIFICATION_STATUSES.WARNING:
      return {
        container: {
          background: 'yellow.100'
        },
        icon: {
          color: 'yellow.500'
        },
        dismissButton: {
          _hover: {
            background: 'yellow.200'
          },
          _focus: {
            background: 'yellow.200'
          }
        }
      };
    case NOTIFICATION_STATUSES.ERROR:
      return {
        container: {
          background: 'red.100'
        },
        icon: {
          color: 'red.700'
        },
        dismissButton: {
          _hover: {
            background: 'red.200'
          },
          _focus: {
            background: 'red.200'
          }
        }
      };
    case NOTIFICATION_STATUSES.SUCCESS:
      return {
        container: {
          background: 'green.100'
        },
        icon: {
          color: 'green.700'
        },
        dismissButton: {
          _hover: {
            background: 'green.200'
          },
          _focus: {
            background: 'green.200'
          }
        }
      };
    default:
      return {};
  }
};
var notificationSizeStyles = function notificationSizeStyles(size) {
  switch (size) {
    case NOTIFICATION_SIZES.SM:
      return {
        title: {
          fontSize: 'xs'
        },
        description: {
          fontSize: 'xs'
        }
      };
    case NOTIFICATION_SIZES.MD:
      return {
        title: {
          fontSize: 'sm'
        },
        description: {
          fontSize: 'sm'
        }
      };
    case NOTIFICATION_SIZES.LG:
      return {
        title: {
          fontSize: 'base'
        },
        description: {
          fontSize: 'base'
        }
      };
    default:
      return {};
  }
};

var base = /*#__PURE__*/Object.freeze({
  __proto__: null,
  NOTIFICATION_STATUSES: NOTIFICATION_STATUSES,
  breakpoints: breakpoints,
  colors: colors$1,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  fonts: fonts,
  notificationBaseStyle: notificationBaseStyle,
  notificationStatusStyles: notificationStatusStyles,
  shadows: shadows$1,
  sizes: sizes$6,
  zIndices: indices
});

var baseStyle$f = {
  px: 8,
  py: 3,
  fontSize: 'base',
  fontFamily: 'body',
  lineHeight: 0.875,
  fontWeight: 'semibold',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '1.25rem',
  textTransform: 'capitalize',
  transition: 'all normal ease',
  _disabled: {
    cursor: 'not-allowed',
    opacity: 1,
    bg: 'gray.medium',
    borderColor: 'gray.medium',
    color: 'gray.dark'
  },
  '& svg': {
    display: 'block'
  }
};
// TODO: We need an active styling
var disabledButtonHoverStyle = {
  _disabled: {
    bg: 'gray.medium',
    borderColor: 'gray.medium',
    color: 'gray.dark'
  }
};
var destructiveButtonStyles = {
  bg: 'white',
  borderColor: 'red.default',
  color: 'red.default',
  _hover: _objectSpread2$1({
    borderColor: 'red.800',
    color: 'red.800'
  }, disabledButtonHoverStyle)
};
var variants$e = {
  primary: {
    bg: 'primary.default',
    borderColor: 'primary.default',
    color: 'white',
    _hover: _objectSpread2$1({
      bg: 'primary.600',
      borderColor: 'primary.600',
      color: 'white'
    }, disabledButtonHoverStyle)
  },
  primaryOnDark: {
    bg: 'yellow.default',
    borderColor: 'yellow.default',
    color: 'black',
    _hover: _objectSpread2$1({
      bg: 'yellow.500',
      borderColor: 'yellow.500',
      color: 'black'
    }, disabledButtonHoverStyle),
    _focus: {
      boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.7)'
    }
  },
  secondary: {
    bg: 'white',
    borderColor: 'gray.medium',
    color: 'primary.default',
    _hover: _objectSpread2$1({
      borderColor: 'primary.600',
      color: 'primary.600'
    }, disabledButtonHoverStyle)
  },
  secondaryOnDark: {
    bg: 'none',
    borderColor: 'white',
    color: 'white',
    _hover: _objectSpread2$1({
      bg: 'white',
      borderColor: 'white',
      color: 'black'
    }, disabledButtonHoverStyle),
    _focus: {
      boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.7)'
    }
  },
  tertiary: {
    bg: 'none',
    borderWidth: 'none',
    borderRadius: 'unset',
    color: 'primary.default',
    h: 'unset',
    m: 'unset',
    minW: 'unset',
    p: 'unset',
    lineHeight: 1,
    _disabled: {
      bg: 'none',
      color: 'gray.dark'
    },
    _hover: {
      color: 'primary.600',
      _disabled: {
        color: 'gray.dark'
      }
    },
    _active: {
      color: 'primary.600',
      _disabled: {
        color: 'gray.dark'
      }
    }
  },
  tertiaryOnDark: {
    bg: 'none',
    borderRadius: 'unset',
    borderWidth: 'none',
    color: 'white',
    h: 'unset',
    m: 'unset',
    minW: 'unset',
    p: 'unset',
    _disabled: {
      bg: 'none',
      color: 'white',
      opacity: '.7'
    },
    _hover: {
      color: 'white',
      opacity: '.8',
      _disabled: {
        opacity: '.7'
      }
    }
  },
  destructive: _objectSpread2$1({}, destructiveButtonStyles),
  destructiveOnDark: _objectSpread2$1({}, destructiveButtonStyles)
};
var defaultProps$b = {
  size: null
};
var buttonStyles = merge$1(theme$1.components.Button, {
  variants: variants$e,
  baseStyle: baseStyle$f,
  defaultProps: defaultProps$b
});

var props = {
  /**
   * Alters the underlying html tag
   */
  as: PropTypes.string,
  /**
   * If `true`, the button will render as an anchor.
   */
  asAnchor: PropTypes.bool,
  /**
   * If `true`, and an anchor button, target="_blank" and rel="noopener noreferrer" will be set on the anchor
   * "isExternal" is used to maintain parity with the Link component.
   */
  isExternal: PropTypes.bool,
  /**
   * If `true`, the button will show a spinner.
   */
  isLoading: PropTypes.bool,
  /**
   * If `true`, the button will be styled in its active state.
   */
  isActive: PropTypes.bool,
  /**
   * If `true`, the button will be disabled.
   */
  isDisabled: PropTypes.bool,
  /**
   * The label to show in the button when `isLoading` is true
   * If no text is passed, it only shows the spinner
   */
  loadingText: PropTypes.string,
  /**
   * The html button type to use.
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  /**
   * If added, the button will show an icon before the button's label.
   * @type PropTypes.node
   */
  leftIcon: PropTypes.node,
  /**
   * If added, the button will show an icon after the button's label.
   * @type PropTypes.node
   */
  rightIcon: PropTypes.node,
  /**
   * The space between the button icon and label.
   * @type SystemProps["marginRight"]
   */
  iconSpacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Replace the spinner component when `isLoading` is set to `true`
   * @type PropTypes.node
   */
  spinner: PropTypes.node,
  variant: PropTypes.oneOf(Object.keys(variants$e))
};

var _excluded$y = ["asAnchor", "isExternal", "height"];
var anchorProps = function anchorProps() {
  var isExternal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return _objectSpread2$1({
    as: 'a',
    type: null
  }, isExternal && {
    target: '_blank',
    rel: 'noopener noreferrer'
  });
};
var heightProps = function heightProps() {
  var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'md';
  var heights = {
    md: {},
    lg: {
      height: 12,
      borderRadius: sizes$6['6'],
      lineHeight: sizes$6['6']
    }
  };
  return heights[height] || {
    height: height // when a custom height is provided, pass it as is
  };
};
var Button$1 = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var asAnchor = _ref.asAnchor,
    isExternal = _ref.isExternal,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'md' : _ref$height,
    props = _objectWithoutProperties$1(_ref, _excluded$y);
  return /*#__PURE__*/React__default.createElement(Button$2, _extends$7({
    iconSpacing: 2
  }, props, heightProps(height), (asAnchor || props.as === 'a') && anchorProps(isExternal), {
    ref: ref
  }));
});
Button$1.propTypes = props;
Button$1.defaultProps = {
  variant: 'primary',
  type: 'button'
};

var _excluded$x = ["header", "children"];
var Drawer = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var header = _ref.header,
    children = _ref.children,
    props = _objectWithoutProperties$1(_ref, _excluded$x);
  return /*#__PURE__*/React__default.createElement(Drawer$1, _extends$7({
    placement: "right"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement(ModalOverlay, null), /*#__PURE__*/React__default.createElement(DrawerContent, null, /*#__PURE__*/React__default.createElement(ModalHeader, null, header, /*#__PURE__*/React__default.createElement(ModalCloseButton, null)), children));
});
Drawer.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

var AccordionActionButton = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var children = _ref.children,
    onClick = _ref.onClick;
  var handleOnClick = function handleOnClick(e) {
    if (onClick) {
      e.preventDefault();
    }
    onClick === null || onClick === void 0 || onClick();
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    ref: ref,
    fontSize: "sm",
    role: "button",
    onClick: handleOnClick,
    color: "primary.default"
  }, children);
});
AccordionActionButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired
};

var _path$5;
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$5.apply(null, arguments);
}
var SvgX = function SvgX(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
  })));
};
var ForwardRef$5 = /*#__PURE__*/forwardRef$1(SvgX);

var _path$4;
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4.apply(null, arguments);
}
var SvgInfoCircleFilled = function SvgInfoCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
  })));
};
var ForwardRef$4 = /*#__PURE__*/forwardRef$1(SvgInfoCircleFilled);

var _path$3;
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3.apply(null, arguments);
}
var SvgExclamationCircleFilled = function SvgExclamationCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2M13 17h-2v-2h2zm0-4h-2V7h2z"
  })));
};
var ForwardRef$3 = /*#__PURE__*/forwardRef$1(SvgExclamationCircleFilled);

var _path$2;
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2.apply(null, arguments);
}
var SvgCheckmarkCircleFilled = function SvgCheckmarkCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m-1.999 14.413-3.713-3.705L7.7 11.292l2.299 2.295 5.294-5.294 1.414 1.414z"
  })));
};
var ForwardRef$2 = /*#__PURE__*/forwardRef$1(SvgCheckmarkCircleFilled);

var _excluded$w = ["status", "title", "buttonProps", "buttonText", "buttonOnBottom", "showDismiss", "onDismissClick", "showIcon", "description", "icon"];
var statusIconMapping = _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, NOTIFICATION_STATUSES.WARNING, ForwardRef$3), NOTIFICATION_STATUSES.SUCCESS, ForwardRef$2), NOTIFICATION_STATUSES.ERROR, ForwardRef$3), NOTIFICATION_STATUSES.NEUTRAL, ForwardRef$4);
var Alert = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var status = _ref.status,
    title = _ref.title,
    buttonProps = _ref.buttonProps,
    buttonText = _ref.buttonText,
    buttonOnBottom = _ref.buttonOnBottom,
    showDismiss = _ref.showDismiss,
    onDismissClick = _ref.onDismissClick,
    showIcon = _ref.showIcon,
    description = _ref.description,
    icon = _ref.icon,
    props = _objectWithoutProperties$1(_ref, _excluded$w);
  var IconVariant = icon || statusIconMapping[status];
  // the issue with storybook breaking with hooks is still a problem, but once that's resolved this should be memoized
  var style = merge$1(_objectSpread2$1({}, theme$1.components.Alert.baseStyle), notificationBaseStyle, notificationStatusStyles(status), notificationSizeStyles(props.size));
  return /*#__PURE__*/React__default.createElement(Alert$1, _extends$7({}, style.container, {
    "data-status": status
  }, props, {
    ref: ref
  }), showIcon ? /*#__PURE__*/React__default.createElement(Icon, _extends$7({}, style.icon, {
    as: IconVariant
  })) : null, /*#__PURE__*/React__default.createElement(VStack, {
    spacing: 0,
    alignItems: "flex-start"
  }, title ? /*#__PURE__*/React__default.createElement(AlertTitle, style.title, title) : null, description ? /*#__PURE__*/React__default.createElement(AlertDescription, style.description, description) : null, buttonOnBottom && buttonText && buttonProps ? /*#__PURE__*/React__default.createElement(Button$1, _extends$7({}, style.actionButton, {
    variant: "tertiary"
  }, buttonProps), buttonText) : null), /*#__PURE__*/React__default.createElement(Flex, {
    alignItems: "center",
    marginLeft: "auto"
  }, !buttonOnBottom && buttonText && buttonProps ? /*#__PURE__*/React__default.createElement(Button$1, _extends$7({}, style.actionButton, {
    variant: "tertiary"
  }, buttonProps), buttonText) : null, showDismiss ? /*#__PURE__*/React__default.createElement(Button$1, _extends$7({}, style.dismissButton, {
    onClick: onDismissClick
  }), /*#__PURE__*/React__default.createElement(Icon, {
    width: 6,
    height: "auto",
    as: ForwardRef$5
  })) : null));
});
Alert.propTypes = {
  /** Status. One of: success, neutral, warning, or error */
  status: PropTypes.oneOf(['neutral', 'success', 'warning', 'error']),
  /** Title Text. Will not display title if empty */
  title: PropTypes.node,
  /** Props to pass to button (like onClick). Will not display button if this or buttonText empty */
  buttonProps: PropTypes.object,
  /** Text of button. Will not display button if this or buttonProps empty */
  buttonText: PropTypes.string,
  /** Whether action button should be under description (as opposed to on right) */
  buttonOnBottom: PropTypes.bool,
  /** Whether or not to show X dismiss button */
  showDismiss: PropTypes.bool,
  /** Callback when X clicked */
  onDismissClick: PropTypes.func,
  /** Whether or not to show the icon */
  showIcon: PropTypes.bool,
  /** Description text. Will not display description if empty */
  description: PropTypes.node,
  /** Size of the text */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Custom Icon */
  icon: PropTypes.func
};
Alert.defaultProps = {
  status: 'neutral',
  title: null,
  buttonProps: null,
  buttonText: null,
  buttonOnBottom: false,
  showDismiss: false,
  onDismissClick: null,
  showIcon: true,
  description: null,
  size: 'md',
  icon: null
};

var variants$d = {
  line: {
    tablist: {
      borderBottom: '2px solid',
      borderColor: 'inherit'
    },
    tab: {
      color: 'gray.600',
      borderBottom: '2px solid',
      borderColor: 'transparent',
      marginBottom: '-2px',
      _selected: {
        color: 'primary.default',
        borderColor: 'primary.default',
        fontWeight: 'semibold'
      },
      _active: {
        color: 'black',
        bg: 'transparent'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      },
      _hover: {
        color: 'black'
      }
    }
  },
  enclosed: {
    tablist: {
      backgroundColor: 'white',
      borderRadius: '8px',
      borederColor: 'gray.200',
      borderWidth: '1px',
      paddingY: 1
    },
    tab: {
      borderRadius: '6px',
      marginX: 1,
      _selected: {
        fontWeight: 'semibold',
        color: 'white',
        backgroundColor: 'primary.default',
        _hover: {
          backgroundColor: 'primary.600'
        }
      },
      _active: {
        backgroundColor: 'gray.200'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      }
    }
  }
};
var styles$2 = merge$1(theme$1.components.Tabs, {
  variants: variants$d
});

var SIZE_SMALL = 'small';
var SIZE_BODY = 'body';
var SIZE_HEADING = 'heading';

/**
 * ### `combineSizeWithVariant`
 * A function that takes in the `size` value, and the
 * `variant` value. The default-like styling for the `size` prop is merged with the styling from the
 * `variant` and a combined styleProp object is returned.
 *
 * @function combineSizeWithVariant
 * @param {string} args.size - The size of Tabs component
 * @param {string} args.variant - The style variant for the Text component
 * @returns {Object} An object containing the merged styleProps from the `variant` and the `size` props
 */

var combineSizeWithVariant = function combineSizeWithVariant(_ref) {
  var size = _ref.size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'line' : _ref$variant;
  var fontSizeMapping = _defineProperty$3(_defineProperty$3(_defineProperty$3({}, SIZE_SMALL, fontSizes.xs), SIZE_BODY, fontSizes.base), SIZE_HEADING, fontSizes.lg);
  var styleProps = styles$2.variants["".concat(variant)];
  styleProps.tab.fontSize = fontSizeMapping[size];
  return styleProps;
};

var _excluded$v = ["size"];
var sizeMapping = _defineProperty$3(_defineProperty$3(_defineProperty$3({}, SIZE_SMALL, 'sm'), SIZE_BODY, 'md'), SIZE_HEADING, 'lg');
var Tabs = forwardRef(function (_ref, ref) {
  var size = _ref.size,
    props = _objectWithoutProperties$1(_ref, _excluded$v);
  return /*#__PURE__*/React__default.createElement(Tabs$1, _extends$7({
    size: sizeMapping[size]
  }, props, combineSizeWithVariant({
    size: size
  }), {
    ref: ref
  }));
});
Tabs.defaultProps = {
  size: SIZE_BODY
};
Tabs.propTypes = {
  /** The React node that will render inside the element */
  children: PropTypes.node,
  /** Controls the size of Tabs */
  size: PropTypes.oneOf([SIZE_SMALL, SIZE_BODY, SIZE_HEADING])
};

var _path$1;
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
var SvgChevronDown = function SvgChevronDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z"
  })));
};
var ForwardRef$1 = /*#__PURE__*/forwardRef$1(SvgChevronDown);

var _excluded$u = ["children", "label", "inputId", "helperText", "errorMessage", "isFieldset", "isOptional", "customRequiredText"];
var FormControl$1 = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var children = _ref.children,
    label = _ref.label,
    inputId = _ref.inputId,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isFieldset = _ref.isFieldset,
    isOptional = _ref.isOptional,
    customRequiredText = _ref.customRequiredText,
    props = _objectWithoutProperties$1(_ref, _excluded$u);
  return /*#__PURE__*/React__default.createElement(FormControl$2, _extends$7({}, props, {
    ref: ref,
    as: isFieldset ? 'fieldset' : 'div',
    borderWidth: "0"
  }), label && /*#__PURE__*/React__default.createElement(FormLabel, {
    color: "gray.600",
    fontWeight: "semibold",
    marginBottom: helperText ? 0 : 1,
    fontSize: "sm",
    htmlFor: inputId,
    as: isFieldset ? 'legend' : 'label',
    requiredIndicator: props !== null && props !== void 0 && props.isRequired && customRequiredText ? /*#__PURE__*/React__default.createElement(Text$1, {
      marginLeft: 1,
      as: "span",
      variant: "caption",
      color: "text.secondary.light"
    }, customRequiredText) : null,
    optionalIndicator: isOptional && !(props !== null && props !== void 0 && props.isRequired) ? /*#__PURE__*/React__default.createElement(Text$1, {
      marginLeft: 1,
      as: "span",
      variant: "caption",
      color: "text.secondary.light"
    }, "Optional") : null
  }, label), helperText && /*#__PURE__*/React__default.createElement(FormHelperText, {
    color: "gray.600",
    marginBottom: 1,
    fontSize: "xs"
  }, helperText), children, /*#__PURE__*/React__default.createElement(FormErrorMessage, {
    color: "error",
    mt: 1,
    fontSize: "xs"
  }, errorMessage));
});
FormControl$1.propTypes = {
  inputId: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  children: PropTypes.element,
  isFieldset: PropTypes.bool,
  isOptional: PropTypes.bool,
  isRequired: PropTypes.bool,
  customRequiredText: PropTypes.string
};

var _excluded$t = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "isOptional"];
var Select$2 = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isInvalid = _ref.isInvalid,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    isOptional = _ref.isOptional,
    props = _objectWithoutProperties$1(_ref, _excluded$t);
  var classes = cn({
    'FormElement-contains-error': isInvalid
  });
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    isOptional: isOptional,
    helperText: helperText,
    label: label,
    inputId: props.id
  }, /*#__PURE__*/React__default.createElement(Select$3, _extends$7({
    icon: /*#__PURE__*/React__default.createElement(Icon, {
      as: ForwardRef$1
    }),
    iconSize: 12,
    fontWeight: "regular",
    fontSize: "sm",
    ref: ref,
    className: classes
  }, props)));
});
Select$2.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isOptional: PropTypes.bool
};

var _excluded$s = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired"];
var Switch = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isInvalid = _ref.isInvalid,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    props = _objectWithoutProperties$1(_ref, _excluded$s);
  var classes = cn({
    'FormElement-contains-error': isInvalid
  });
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    inputId: props.id
  }, /*#__PURE__*/React__default.createElement(Switch$1, _extends$7({
    ref: ref,
    className: classes
  }, props)));
});
Switch.propTypes = {
  isChecked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool
};

var options$1 = ['a', 'abbr', 'address', 'article', 'aside', 'b', 'bdi', 'bdo', 'blockquote', 'button', 'caption', 'cite', 'code', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'fieldset', 'figure', 'footer', 'form', 'header', 'hgroup', 'i', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'pre', 'progress', 'q', 'rb', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video'];

var baseStyle$e = {
  lineHeight: 1.5,
  fontWeight: fontWeights.normal
};
var variants$c = {
  body: _objectSpread2$1(_objectSpread2$1({}, baseStyle$e), {}, {
    fontSize: {
      base: fontSizes.base,
      desktop: fontSizes.base
    }
  }),
  body2: _objectSpread2$1(_objectSpread2$1({}, baseStyle$e), {}, {
    fontSize: {
      base: fontSizes.sm,
      desktop: fontSizes.sm
    }
  }),
  caption: _objectSpread2$1(_objectSpread2$1({}, baseStyle$e), {}, {
    fontSize: {
      base: fontSizes.xs,
      desktop: fontSizes.xs
    }
  })
};
var defaultProps$a = {
  variant: variants$c.body
};
var Text_styles = merge$1(theme$1.components.Text, {
  variants: variants$c,
  baseStyle: baseStyle$e,
  defaultProps: defaultProps$a
});

// Create list of commonly used html text elements
var asOptions = Object.freeze({
  bold: 'b',
  strong: 'strong',
  italic: 'i',
  emphasis: 'em',
  small: 'small',
  strikethrough: 's',
  underline: 'u'
});

/**
 * ### `combineAsWithVariant`
 * A function that takes in the `as` value (the HTML element to render the Text component as), and the
 * `variant` value. The default-like styling for the `as` prop is merged with the styling from the
 * `variant` and a combined styleProp object is returned.
 *
 * By default the `as` property only effects the underlying semantics of the markup, whereas the
 * `variant` only effects the visual styling of the text. In order for the text component to be built
 * with accessibility and ease-of-use in mind, these two properties _should_ be interconnected. Having
 * the style and markup unified allows an experience that is accessible to those using screen-readers
 * (or any other assistive technology) that matches (or is at least a close approximation) of the
 * "standard" visual experience.
 *
 * @function combineAsWithVariant
 * @param {string} args.as - The HTML element to render the Text component as
 * @param {string} args.variant - The style variant for the Text component
 * @returns {Object} An object containing the merged styleProps from the `variant` and the `as` props
 */

var combineAsWithVariant = function combineAsWithVariant(_ref) {
  var as = _ref.as,
    variant = _ref.variant;
  var variantFontSizeBase = Number(variants$c["".concat(variant)].fontSize.base.replace('rem', ''));
  var variantFontSizeDesktop = Number(variants$c["".concat(variant)].fontSize.desktop.replace('rem', ''));
  var styleProps;
  switch (as) {
    case asOptions.bold:
      styleProps = _objectSpread2$1(_objectSpread2$1({}, variants$c["".concat(variant)]), {}, {
        fontWeight: fontWeights.semibold
      });
      break;
    case asOptions.strong:
      styleProps = _objectSpread2$1(_objectSpread2$1({}, variants$c["".concat(variant)]), {}, {
        fontWeight: fontWeights.semibold
      });
      break;
    case asOptions.italic:
      styleProps = _objectSpread2$1(_objectSpread2$1({}, variants$c["".concat(variant)]), {}, {
        fontStyle: 'italic'
      });
      break;
    case asOptions.emphasis:
      styleProps = _objectSpread2$1(_objectSpread2$1({}, variants$c["".concat(variant)]), {}, {
        fontStyle: 'italic'
      });
      break;
    case asOptions.underline:
      styleProps = _objectSpread2$1(_objectSpread2$1({}, variants$c["".concat(variant)]), {}, {
        textDecoration: 'underline'
      });
      break;
    case asOptions.strikethrough:
      styleProps = _objectSpread2$1(_objectSpread2$1({}, variants$c["".concat(variant)]), {}, {
        textDecoration: 'line-through'
      });
      break;
    case asOptions.small:
      styleProps = _objectSpread2$1(_objectSpread2$1({}, variants$c["".concat(variant)]), {}, {
        fontSize: {
          base: "".concat(variantFontSizeBase * 0.8, "rem"),
          desktop: "".concat(variantFontSizeDesktop * 0.8, "rem")
        }
      });
      break;
    default:
      styleProps = _objectSpread2$1({}, variants$c["".concat(variant)]);
      break;
  }
  return styleProps;
};

var _excluded$r = ["as", "variant"];
var Text = forwardRef(function (_ref, ref) {
  var as = _ref.as,
    variant = _ref.variant,
    props = _objectWithoutProperties$1(_ref, _excluded$r);
  return /*#__PURE__*/React__default.createElement(Text$1, _extends$7({
    variant: variant,
    as: as
  }, combineAsWithVariant({
    as: as,
    variant: variant
  }), props, {
    ref: ref
  }));
});
Text.defaultProps = {
  as: 'p',
  variant: 'body'
};
Text.propTypes = {
  /** The React node that will render inside the element */
  children: PropTypes.node,
  /** Controls the underlying styling of the html heading tag */
  as: PropTypes.oneOf(options$1),
  /** The styling that will be applied to the component regardless of the underlying html */
  variant: PropTypes.oneOf(Object.keys(variants$c))
};

// NOTE: considering adding a specifc prop for grid row padding
var baseStyles = {
  gap: {
    base: 4,
    tablet: 8
  },
  templateColumns: 'repeat(12, 1fr)'
};
var compactStyles = {
  gap: 4
};

var _excluded$q = ["isCompact"];
var Grid = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var isCompact = _ref.isCompact,
    props = _objectWithoutProperties$1(_ref, _excluded$q);
  return /*#__PURE__*/React__default.createElement(Grid$1, _extends$7({}, baseStyles, isCompact && compactStyles, props, {
    ref: ref
  }));
});
Grid.propTypes = {
  /** This will reduce the grid gap by half */
  isCompact: PropTypes.bool
};
Grid.defaultProps = {
  isCompact: false
};

// NOTE: styles NOT in the Chakra's base styles do not need to explicitly export baseStyles
// TODO: move this comment to the readme

var styles$1 = {
  colSpan: 12
};

var GridItem = /*#__PURE__*/forwardRef$1(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(GridItem$1, _extends$7({}, styles$1, props, {
    ref: ref
  }));
});

var _excluded$p = ["type"];
var unorderedProps = {
  as: 'ul',
  styleType: 'disc'
};
var orderedProps = {
  as: 'ol',
  styleType: 'decimal'
};
var STYLE_POSITIONS = {
  unset: 'unset',
  revert: 'revert',
  inside: 'inside',
  outside: 'outside',
  initial: 'initial',
  inherit: 'inherit'
};
var TYPES = {
  ordered: 'ordered',
  unstyled: 'unstyled',
  unordered: 'unordered'
};
var getListProps = function getListProps(type) {
  switch (type) {
    case TYPES.ordered:
      return orderedProps;
    case TYPES.unordered:
      return unorderedProps;
    default:
      return;
  }
};
var List = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var type = _ref.type,
    props = _objectWithoutProperties$1(_ref, _excluded$p);
  return /*#__PURE__*/React__default.createElement(List$1, _extends$7({}, getListProps(type), props, {
    ref: ref
  }));
});
List.defaultProps = {
  type: TYPES.unstyled,
  stylePosition: STYLE_POSITIONS.inside
};
List.propTypes = {
  /** The position of the list style */
  stylePosition: PropTypes.oneOf(Object.keys(STYLE_POSITIONS)),
  /** Changes the underlying markdown to be an ordered or unorderd list, (unstyled will render a ul by default) */
  type: PropTypes.oneOf(Object.keys(TYPES))
};

var spinnerStyles = theme$1.components.Spinner;
var SIZE_MAP = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  '2xl': '2xl',
  '3xl': '3xl',
  '4xl': '4xl',
  '5xl': '5xl',
  '6xl': '6xl',
  '7xl': '7xl',
  '8xl': '8xl',
  '9xl': '9xl',
  '10xl': '10xl'
};
var sizes$5 = merge$1(spinnerStyles.sizes, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, SIZE_MAP['2xl'], {
  w: '4rem',
  h: '4rem'
}), SIZE_MAP['3xl'], {
  w: '5rem',
  h: '5rem'
}), SIZE_MAP['4xl'], {
  w: '6rem',
  h: '6rem'
}), SIZE_MAP['5xl'], {
  w: '7rem',
  h: '7rem'
}), SIZE_MAP['6xl'], {
  w: '8rem',
  h: '8rem'
}), SIZE_MAP['7xl'], {
  w: '9rem',
  h: '9rem'
}), SIZE_MAP['8xl'], {
  w: '10rem',
  h: '10rem'
}), SIZE_MAP['9xl'], {
  w: '11rem',
  h: '11rem'
}), SIZE_MAP['10xl'], {
  w: '12rem',
  h: '12rem'
}));
var thicknesses = _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, SIZE_MAP.xl, 3), SIZE_MAP['2xl'], 4), SIZE_MAP['3xl'], 5), SIZE_MAP['4xl'], 6), SIZE_MAP['5xl'], 7), SIZE_MAP['6xl'], 8), SIZE_MAP['7xl'], 9), SIZE_MAP['8xl'], 10), SIZE_MAP['9xl'], 11), SIZE_MAP['10xl'], 12);
var defaultProps$9 = {
  speed: '2s',
  size: SIZE_MAP['2xl'],
  thickness: thicknesses[SIZE_MAP['2xl']]
};
var Spinner_styles = {
  sizes: sizes$5,
  defaultProps: defaultProps$9
};

var _excluded$o = ["size", "thickness"];
var Spinner = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var size = _ref.size,
    thickness = _ref.thickness,
    props = _objectWithoutProperties$1(_ref, _excluded$o);
  var thicknessString = thickness ? "".concat(thickness, "px") : thicknesses[size] ? "".concat(thicknesses[size], "px") : '2px';
  return /*#__PURE__*/React__default.createElement(Spinner$1, _extends$7({
    ref: ref,
    role: "status",
    color: "primary.default",
    emptyColor: "gray.medium",
    thickness: thicknessString,
    size: size || SIZE_MAP['2xl']
  }, props));
});
Spinner.propTypes = {
  /** The main fill color of the spinner */
  color: PropTypes.string,
  /** The diameter of the spinner ring in pixels */
  thickness: PropTypes.number,
  /** The empty color of the spinner */
  emptyColor: PropTypes.string,
  /** The size of the spinner */
  size: PropTypes.oneOf(Object.keys(SIZE_MAP)),
  /** The speed of the spinner, ex: 10s, 0.1s, 250ms */
  speed: PropTypes.string
};

var baseStyle$d = {
  lineHeight: 1.5,
  fontWeight: fontWeights.semibold
};
var variants$b = {
  h1: _objectSpread2$1(_objectSpread2$1({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes['2xl'],
      desktop: fontSizes['3xl']
    }
  }),
  h2: _objectSpread2$1(_objectSpread2$1({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes.xl,
      desktop: fontSizes['2xl']
    }
  }),
  h3: _objectSpread2$1(_objectSpread2$1({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes.lg,
      desktop: fontSizes.xl
    }
  }),
  h4: _objectSpread2$1(_objectSpread2$1({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes.base,
      desktop: fontSizes.lg
    }
  }),
  h5: _objectSpread2$1(_objectSpread2$1({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes.base,
      desktop: fontSizes.base
    }
  }),
  h6: _objectSpread2$1(_objectSpread2$1({}, baseStyle$d), {}, {
    fontSize: {
      base: fontSizes.sm,
      desktop: fontSizes.sm
    }
  })
};
var defaultProps$8 = {
  variant: variants$b.h2
};
var Heading_styles = {
  variants: variants$b,
  baseStyle: baseStyle$d,
  defaultProps: defaultProps$8
};

var Heading = /*#__PURE__*/forwardRef$1(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(Heading$1, _extends$7({}, props, {
    ref: ref,
    variant: props.variant || props.as || 'h2'
  }));
});
Heading.propTypes = {
  /** The React node that will render inside the element */
  children: PropTypes.node,
  /** Controls the underlying level of the html heading tag */
  as: PropTypes.oneOf(Object.keys(variants$b)),
  /** The styling that will be applied to the component regardless of the underlying html */
  variant: PropTypes.oneOf(Object.keys(variants$b))
};

var styles = {
  px: 4,
  mx: 'auto',
  maxW: {
    base: 'container.base',
    tablet: 'container.tablet',
    desktop: 'container.desktop'
  }
};

var Container = /*#__PURE__*/forwardRef$1(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(Container$1, _extends$7({}, styles, props, {
    ref: ref
  }));
});

var global$1 = {
  'html, body': {
    color: 'text.primary.light'
  },
  // By default, Chakra has all svgs set to 'display: block',
  // this breaks the layout of some older components, so now
  // we set all svgs to 'display: inline-block;' and only set
  // 'display: block;' on the components that need it
  // (as of 3/9/2021 only the v1 AutoSuggestInput component
  // needed this update)
  svg: {
    display: 'inline-block'
  },
  // starting in Chakra version 2 they introduced this isolation style that messes with dropdowns being able to appear on top of elements underneath them
  '.chakra-input__group': {
    isolation: 'auto !important'
  },
  // Starting in Chakra version 2 they have incorporated normalize.css which may resulf in some unexpected default styles
  'h1, h2, h3, h4, h5, h6': {
    margin: 0
  }
};
var Fonts = function Fonts() {
  return /*#__PURE__*/React__default.createElement(Global$1, {
    styles: "\n            @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap');\n            /* latin-ext */\n            @font-face {\n                font-family: \"Plus Jakarta Sans\", sans-serif;\n                font-style: normal;\n                font-weight: 700;\n                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n            }\n            /* latin-ext */\n            @font-face {\n                font-family: \"Plus Jakarta Sans\", sans-serif;\n                font-style: normal;\n                font-weight: 600;\n                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n            }\n            /* latin-ext */\n            @font-face {\n                font-family: \"Plus Jakarta Sans\", sans-serif;\n                font-style: normal;\n                font-weight: 400;\n                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n            }\n            /* latin-ext */\n            @font-face {\n                font-family: \"Plus Jakarta Sans\", sans-serif;\n                font-style: normal;\n                font-weight: 300;\n                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n            }\n        "
  });
};
var LegacyOverrides = function LegacyOverrides(_ref) {
  var useLegacyOverrides = _ref.useLegacyOverrides;
  return useLegacyOverrides ? /*#__PURE__*/React__default.createElement(Global$1, {
    styles: "\n        h1,\n        h2,\n        h3,\n        h4,\n        h5,\n        h6 {\n            margin-top: 0;\n            font-weight: ".concat(fontWeights.semibold, ";\n        }\n\n        .heading-sm {\n            font-size: ").concat(fontSizes.base, ";\n        }\n        .heading-md {\n            font-size: ").concat(fontSizes.md, ";\n        }\n        .heading-lg {\n            font-size: ").concat(fontSizes['5xl'], ";\n        }\n\n        p {\n            line-height: 1.5;\n        }\n\n        a {\n            outline: none;\n            text-align: left;\n            color: ").concat(colors$1.primary["default"], ";\n            text-decoration: none;\n\n            &:active,\n            &:focus {\n                outline: none;\n            }\n\n            &:hover {\n                color: ").concat(colors$1.primary['700'], ";\n            }\n        }\n\n        small {\n            font-size: ").concat(fontSizes.xs, ";\n        }\n\n        ")
  }) : null;
};
LegacyOverrides.propTypes = {
  /** If true, this will use the old `spothero-html` base styles */
  useLegacyOverrides: PropTypes.bool
};

var item = {
  mb: 2
};

var baseStyle$c = {
  item: item
};
var index$a = merge$1(theme$1.components.List, {
  baseStyle: baseStyle$c
});

var parts$2 = ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'caption'];
var baseStyle$b = {
  table: {
    borderCollapse: 'collapse',
    color: 'text.primary.light',
    width: '100%'
  },
  thead: {
    borderBottom: '1px',
    borderColor: 'gray.medium'
  },
  th: {
    fontFamily: 'heading',
    fontSize: variants$b.h4.fontSize,
    fontWeight: 'semibold',
    letterSpacing: 'unset',
    padding: 4,
    textAlign: 'start',
    textTransform: 'none'
  },
  tr: {
    borderBottom: '1px',
    borderColor: 'gray.medium',
    _last: {
      border: 'none'
    }
  },
  td: {
    padding: 4,
    textAlign: 'start'
  }
};
var roundedWhiteVariant = {
  table: {
    backgroundColor: 'background.white',
    borderRadius: 6,
    boxShadow: 'md',
    marginBottom: 1
  }
};
var roundedGrayVariant = {
  table: _objectSpread2$1(_objectSpread2$1({}, roundedWhiteVariant.table), {}, {
    backgroundColor: 'background.gray'
  })
};
var variants$a = {
  rounded: roundedWhiteVariant,
  roundedGray: roundedGrayVariant
};
var defaultProps$7 = {
  variant: 'rounded'
};
var Table_styles = {
  parts: parts$2,
  variants: variants$a,
  baseStyle: baseStyle$b,
  defaultProps: defaultProps$7
};

var baseStyle$a = {
  transition: "all 0.15s ease",
  color: 'text.link.light',
  fontWeight: 'semibold',
  _hover: {
    color: 'primary.600',
    textDecoration: 'none'
  },
  _focus: {
    boxShadow: 'outline'
  },
  '& svg': {
    d: 'inline-block',
    verticalAlign: 'initial'
  }
};
var linkOnDark = {
  color: 'text.link.dark',
  _hover: {
    color: 'text.link.dark',
    opacity: '.8'
  }
};
var variants$9 = {
  standard: baseStyle$a,
  onDark: linkOnDark
};
var defaultProps$6 = {
  variant: 'standard'
};
var Link_styles = merge$1(theme$1.components.Link, {
  baseStyle: baseStyle$a,
  variants: variants$9,
  defaultProps: defaultProps$6
});

function anatomy(name) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var called = false;
  function assert() {
    if (!called) {
      called = true;
      return;
    }
    throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
  }
  function parts() {
    assert();
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    for (var _i = 0, _values = values; _i < _values.length; _i++) {
      var part = _values[_i];
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function extend() {
    for (var _len2 = arguments.length, parts2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      parts2[_key2] = arguments[_key2];
    }
    for (var _i2 = 0, _parts = parts2; _i2 < _parts.length; _i2++) {
      var part = _parts[_i2];
      if (part in map) continue;
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function selectors() {
    var value = Object.fromEntries(Object.entries(map).map(function (_ref) {
      var _ref2 = _slicedToArray$1(_ref, 2),
        key = _ref2[0],
        part = _ref2[1];
      return [key, part.selector];
    }));
    return value;
  }
  function classnames() {
    var value = Object.fromEntries(Object.entries(map).map(function (_ref3) {
      var _ref4 = _slicedToArray$1(_ref3, 2),
        key = _ref4[0],
        part = _ref4[1];
      return [key, part.className];
    }));
    return value;
  }
  function toPart(part) {
    var el = ["container", "root"].includes(part !== null && part !== void 0 ? part : "") ? [name] : [name, part];
    var attr = el.filter(Boolean).join("__");
    var className = "chakra-".concat(attr);
    var partObj = {
      className: className,
      selector: ".".concat(className),
      toString: function toString() {
        return part;
      }
    };
    return partObj;
  }
  var __type = {};
  return {
    parts: parts,
    toPart: toPart,
    extend: extend,
    selectors: selectors,
    classnames: classnames,
    get keys() {
      return Object.keys(map);
    },
    __type: __type
  };
}

var accordionAnatomy = anatomy("accordion").parts("root", "container", "button", "panel", "icon");
anatomy("alert").parts("title", "description", "container", "icon", "spinner");
anatomy("avatar").parts("label", "badge", "container", "excessLabel", "group");
anatomy("breadcrumb").parts("link", "item", "container", "separator");
anatomy("button").parts();
anatomy("checkbox").parts("control", "icon", "container", "label");
anatomy("progress").parts("track", "filledTrack", "label");
anatomy("drawer").parts("overlay", "dialogContainer", "dialog", "header", "closeButton", "body", "footer");
anatomy("editable").parts("preview", "input", "textarea");
anatomy("form").parts("container", "requiredIndicator", "helperText");
anatomy("formError").parts("text", "icon");
anatomy("input").parts("addon", "field", "element", "group");
anatomy("list").parts("container", "item", "icon");
anatomy("menu").parts("button", "list", "item", "groupTitle", "icon", "command", "divider");
anatomy("modal").parts("overlay", "dialogContainer", "dialog", "header", "closeButton", "body", "footer");
anatomy("numberinput").parts("root", "field", "stepperGroup", "stepper");
anatomy("pininput").parts("field");
anatomy("popover").parts("content", "header", "body", "footer", "popper", "arrow", "closeButton");
anatomy("progress").parts("label", "filledTrack", "track");
anatomy("radio").parts("container", "control", "label");
anatomy("select").parts("field", "icon");
anatomy("slider").parts("container", "track", "thumb", "filledTrack", "mark");
anatomy("stat").parts("container", "label", "helpText", "number", "icon");
anatomy("switch").parts("container", "track", "thumb", "label");
anatomy("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
anatomy("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
anatomy("tag").parts("container", "label", "closeButton");
anatomy("card").parts("container", "header", "body", "footer");
anatomy("stepper").parts("stepper", "step", "title", "description", "indicator", "separator", "icon", "number");

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(accordionAnatomy.keys);
const baseStyle$9 = definePartsStyle({
    icon: {
        color: 'primary.default',
    },
    button: {
        display: 'flex',
        gridGap: 3.5,
        alignItems: 'center',
        fontSize: 'sm',
        fontWeight: 'semibold',
        _hover: {
            backgroundColor: 'gray.50',
        },
    },
    container: {
        borderColor: 'gray.medium',
    },
});
const variants$8 = {
    lined: {
        button: {
            px: 2,
            py: 3,
        },
        container: {
            borderTopWidth: 1,
            _last: {
                borderBottomWidth: 1,
            },
        },
        panel: {
            px: 2,
            py: 3,
        },
    },
    contained: {
        button: {
            px: 4,
            py: 3,
        },
        container: {
            borderLeftWidth: 1,
            borderRightWidth: 1,
            _first: {
                borderTopLeftRadius: 4,
                borderTopRightRadius: 4,
            },
            _last: {
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4,
            },
        },
        panel: {
            p: 4,
            borderColor: 'gray.medium',
            borderTopWidth: 1,
        },
    },
    // Chakra 2 upgrade broke styles for accordion and some work was done with these components.  to have it default to default makes it so styles that are implemented will be handled.  This is just as a backup
    unstyled: {
        icon: {
            color: 'inherit',
        },
        button: {
            display: 'flex',
            alignItems: 'center',
            fontSize: 'default',
            fontWeight: 'normal',
            _hover: {
                backgroundColor: 'inherit',
            },
            paddingTop: '4',
            paddingBottom: '4',
        },
        container: {
            borderColor: 'inherit',
        },
    }
};
const defaultProps$5 = {
    variant: 'lined',
};
const accordionTheme = defineMultiStyleConfig({
    baseStyle: baseStyle$9,
    variants: variants$8,
    //TODO: add @rollup/plugin-typescript to this project
    //@ts-expect-error - This is due to babel not having a ts parser in it
    defaultProps: defaultProps$5,
});
const theme = extendTheme({
    ...accordionTheme,
});

var colorScheme = {
  low: {
    borderColor: 'gray.100'
  },
  medium: {
    borderColor: 'gray.200'
  }
};
var Divider_styles = merge$1(theme$1.components.Divider, {
  colorScheme: colorScheme
});

var baseStyle$8 = {
  field: {
    fontFamily: fonts.body,
    fontWeight: fontWeights.normal
  }
};
var variants$7 = {
  outline: {
    field: {
      border: '1px solid',
      borderColor: 'inherit',
      bg: 'inherit',
      _hover: {
        borderColor: 'gray.300'
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      },
      _invalid: {
        borderColor: 'error',
        boxShadow: function boxShadow(t) {
          return "0 0 0 1px ".concat(t.colors.error);
        }
      },
      _focus: {
        borderColor: 'primary.400',
        boxShadow: function boxShadow(t) {
          return "0 0 0 1px ".concat(t.colors.primary['400']);
        }
      }
    },
    addon: {
      border: '1px solid',
      borderColor: 'inherit',
      bg: 'gray.100'
    }
  }
};
var selectStyles = merge$1(theme$1.components.Select, {
  baseStyle: baseStyle$8,
  variants: variants$7
});

var baseStyle$7 = {
  container: {
    _disabled: {
      cursor: 'not-allowed'
    }
  },
  control: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderImage: 'initial',
    borderRadius: 'sm',
    borderColor: 'gray.600',
    transition: 'all 150ms ease',
    marginTop: 1.5,
    _readOnly: {
      boxShadow: 'none !important',
      userSelect: 'all'
    },
    _disabled: {
      cursor: 'not-allowed',
      userSelect: 'none',
      borderColor: 'gray.200'
    },
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    },
    _checked: {
      borderColor: 'primary.default',
      backgroundColor: 'primary.default',
      _hover: {
        borderColor: 'primary.600',
        backgroundColor: 'primary.600'
      },
      _disabled: {
        borderColor: 'gray.200',
        backgroundColor: 'gray.200'
      }
    },
    '& svg': {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25))"
    }
  },
  label: {
    _disabled: {
      color: 'gray.200',
      cursor: 'not-allowed'
    }
  },
  icon: {
    color: 'white'
  }
};
var sizes$4 = {
  sm: {
    control: {
      marginTop: '0.3125rem',
      width: 3,
      height: 3
    },
    icon: {
      width: 2.5,
      height: 2
    }
  },
  md: {
    control: {
      marginTop: 1,
      width: 4,
      height: 4
    },
    icon: {
      width: 3,
      height: 2.5
    },
    label: {
      fontSize: 'base'
    }
  },
  lg: {
    control: {
      marginTop: 1,
      width: 5,
      height: 5
    },
    icon: {
      width: 2.5,
      height: 2.5
    },
    label: {
      fontSize: 'md'
    }
  }
};
var index$9 = merge$1(theme$1.components.Checkbox, {
  baseStyle: baseStyle$7,
  sizes: sizes$4
});

var overrides$1 = {
  defaultProps: {
    colorScheme: 'primary',
    size: 'lg'
  },
  baseStyle: function baseStyle(props) {
    return merge$1(theme$1.components.Switch.baseStyle(props), {
      track: {
        overflow: 'clip'
      },
      thumb: {
        transition: 'all 150ms ease',
        boxShadow: 'base',
        _hover: {
          boxShadow: 'md'
        }
      }
    });
  }
};
var index$8 = _objectSpread2$1(_objectSpread2$1({}, theme$1.components.Switch), overrides$1);

var popperStyles = {
  borderRadius: 'base'
};

var body$2 = function body(props) {
  return {
    fontSize: 'sm'
  };
};

var headerStyles = {
  marginBottom: 2,
  fontWeight: 'semibold'
};

var popoverContentStyles = function popoverContentStyles(_ref) {
  var variant = _ref.variant;
  return {
    padding: 4,
    marginBottom: 0,
    maxWidth: '20rem',
    borderRadius: 'base',
    background: variant === 'dark' ? 'secondary.default' : 'white',
    boxShadow: '2px 2px 4px 0 rgba(0,45,91,0.1)',
    color: variant === 'dark' ? 'white' : 'black',
    borderColor: 'gray.100',
    borderWidth: '1px',
    borderStyle: 'solid',
    '--popper-arrow-shadow-color': function popperArrowShadowColor(t) {
      return t.colors.gray['100'];
    },
    zIndex: 'layer10',
    _focusVisible: {
      outline: '3px solid rgba(91, 170, 250, 0.7)'
    }
  };
};

var parts$1 = ['popper', 'content', 'header', 'body'];
var baseStyle$6 = function baseStyle(props) {
  return {
    header: headerStyles,
    content: popoverContentStyles(props),
    body: body$2(),
    popper: popperStyles
  };
};
var index$7 = merge$1(theme$1.components.Popover, {
  parts: parts$1,
  baseStyle: baseStyle$6
});

var baseStyle$5 = {
  field: {
    fontFamily: 'body',
    _placeholder: {
      color: 'text.secondary.light',
      fontWeight: 'normal',
      _disabled: {
        color: 'text.secondary.light',
        opacity: 1
      }
    }
  }
};
var variants$6 = {
  outline: {
    field: {
      border: '1px solid',
      borderColor: 'gray.200',
      fontSize: 'base',
      paddingLeft: 3,
      paddingRight: 3,
      bg: 'inherit',
      fontWeight: 'normal',
      boxShadow: 'none !important',
      _placeholder: {
        color: 'text.secondary.light',
        fontWeight: 'normal'
      },
      _focus: {
        borderColor: 'primary.default'
      },
      _hover: {
        borderColor: 'gray.300'
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all'
      },
      _disabled: {
        backgroundColor: 'gray.50',
        opacity: 1,
        cursor: 'not-allowed'
      },
      _invalid: {
        borderColor: 'error',
        _focus: {
          borderColor: 'error'
        }
      }
    }
  }
};
var inputStyles = merge$1(theme$1.components.Input, {
  baseStyle: baseStyle$5,
  variants: variants$6
});

//Below isn't being used in build for some reason
var variants$5 = {
  refreshed: {
    field: _objectSpread2$1(_objectSpread2$1({}, inputStyles.variants.outline.field), {}, {
      height: 'auto',
      paddingTop: 8,
      paddingBottom: 2
    })
  }
};
var index$6 = merge$1(inputStyles, {
  variants: variants$5
});

var variants$4 = {
  refreshed: {
    field: _objectSpread2$1(_objectSpread2$1({}, selectStyles.variants.outline.field), {}, {
      height: 'auto',
      paddingTop: 6,
      paddingBottom: 3
    }),
    addon: _objectSpread2$1({}, selectStyles.variants.outline.field)
  }
};
var index$5 = merge$1(theme$1.components.Select, {
  variants: variants$4
});

var variants$3 = {
  refreshed: _objectSpread2$1(_objectSpread2$1({}, inputStyles.variants.outline.field), {}, {
    lineHeight: "6",
    width: "100%",
    paddingTop: 5.5,
    paddingBottom: 3,
    borderRadius: 'md',
    justifyContent: 'flex-start',
    minHeight: "14"
  })
};
var index$4 = merge$1(buttonStyles, {
  variants: variants$3
});

var overlay = {
  background: 'modalOverlay',
  zIndex: 'layer8'
};

var dialogContainer$1 = _defineProperty$3(_defineProperty$3({
  display: 'flex',
  zIndex: 'layer8',
  justifyContent: 'center',
  alignItems: {
    base: 'flex-end',
    tablet: 'center'
  },
  height: '100%',
  minHeight: '-moz-available'
}, "minHeight", '-webkit-fill-available'), "minHeight", 'fill-available');

var dialog$1 = (function (_ref) {
  var hasFooter = _ref.hasFooter;
  return {
    borderRadius: 'md',
    borderBottomRadius: {
      base: '0',
      tablet: 'md'
    },
    background: 'white',
    color: 'inherit',
    marginY: 0,
    zIndex: 'layer8',
    boxShadow: 'lg',
    paddingBottom: hasFooter ? 0 : 4
  };
});

var closeButton$1 = (function (_ref) {
  var hasHeader = _ref.hasHeader;
  return {
    position: 'absolute',
    top: hasHeader ? 4 : 2,
    insetEnd: hasHeader ? 4 : 2,
    color: 'gray.dark',
    borderRadius: 'sm',
    width: 8,
    height: 8,
    _focus: {
      boxShadow: 'outline'
    },
    _hover: {
      bg: 'gray.50'
    }
  };
});

var body$1 = (function (_ref) {
  var hasFooter = _ref.hasFooter,
    hasHeader = _ref.hasHeader,
    hideCloseButton = _ref.hideCloseButton;
  var scrollingHeaderStyles = hasHeader || !hideCloseButton ? {
    // The following adapted from https://lea.verou.me/2012/04/background-attachment-local/
    background: 'linear-gradient(white 30%, white), linear-gradient(rgb(0 0 0 / 10%) 0%, white)',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'white',
    backgroundSize: '100% 30px, 100% 10px',
    backgroundAttachment: 'local, scroll'
  } : {};
  return _objectSpread2$1({
    borderBottomRadius: hasFooter ? null : 'md',
    paddingX: 4,
    paddingBottom: 4,
    flex: 1,
    overflow: 'auto',
    display: 'flex'
  }, scrollingHeaderStyles);
});

var footer$1 = {
  borderTop: '1px',
  borderColor: 'gray.100',
  padding: 4
};

var baseStyle$4 = function baseStyle(props) {
  return {
    overlay: overlay,
    dialogContainer: dialogContainer$1,
    header: header$1(props),
    dialog: dialog$1(props),
    closeButton: closeButton$1(props),
    body: body$1(props),
    footer: footer$1
  };
};
var sizes$3 = {
  sm: {
    dialog: {
      // Would have preferred object syntax here and below, but wasn't working for whatever reason
      maxWidth: ['100%', '100%', '48%', '32%', '24%'],
      maxHeight: ['100%', '100%', '60%', '48%', '32%'],
      minHeight: ['auto', 'auto', '32%', '32%', '24%']
    }
  },
  md: {
    dialog: {
      maxWidth: ['100%', '100%', '84%', '60%', '48%'],
      maxHeight: ['100%', '100%', '96%', '84%', '60%'],
      minHeight: ['auto', 'auto', '84%', '60%', '48%']
    }
  },
  lg: {
    dialog: {
      maxWidth: ['100%', '100%', '96%', '84%', '72%'],
      maxHeight: ['100%', '100%', '96%', '96%', '84%'],
      minHeight: ['auto', 'auto', '96%', '84%', '72%']
    }
  }
};
var index$3 = merge$1(theme$1.components.Modal, {
  baseStyle: baseStyle$4,
  sizes: sizes$3
});

var parts = ['control', 'label'];
var baseStyle$3 = {
  container: {
    alignItems: 'start'
  },
  control: {
    borderRadius: '50%',
    borderWidth: '1px',
    borderColor: 'gray.dark',
    backgroundColor: 'white',
    color: 'white',
    minWidth: 5,
    minHeight: 5,
    marginTop: 1,
    transition: 'all 150ms ease',
    _before: {
      content: '""',
      display: 'inline-block',
      position: 'relative',
      width: '0px',
      height: '0px',
      opacity: '0',
      borderRadius: '50%',
      background: 'currentcolor',
      transition: 'all 150ms ease-in',
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25))"
    },
    _checked: {
      borderColor: 'primary.default',
      color: 'white',
      backgroundColor: 'primary.default',
      _before: {
        width: 2,
        height: 2,
        opacity: '1'
      }
    },
    _focus: {
      boxShadow: 'outline'
    },
    _disabled: {
      borderColor: 'gray.200',
      _checked: {
        backgroundColor: 'gray.200'
      }
    }
  },
  label: {
    fontSize: 'base',
    color: 'black',
    marginLeft: 3,
    _disabled: {
      color: 'gray.200'
    }
  }
};
var sizes$2 = {
  sm: {
    control: {
      minWidth: 4,
      minHeight: 4,
      _checked: {
        _before: {
          width: 1.5,
          height: 1.5
        }
      }
    }
  },
  md: {
    control: {
      minWidth: 5,
      minHeight: 5,
      _checked: {
        _before: {
          width: 2,
          height: 2
        }
      }
    },
    label: {
      fontSize: 'base'
    }
  },
  lg: {
    control: {
      minWidth: 6,
      minHeight: 6,
      _checked: {
        _before: {
          width: 2.5,
          height: 2.5
        }
      }
    },
    label: {
      fontSize: 'md'
    }
  }
};
var defaultProps$4 = {
  size: sizes$2.md
};
var index$2 = merge$1(theme$1.components.Radio, {
  parts: parts,
  baseStyle: baseStyle$3,
  sizes: sizes$2,
  defaultProps: defaultProps$4
});

var Skeleton_styles = theme$1.components.Skeleton;

var baseStyle$2 = {
  px: 1,
  textTransform: 'reset',
  fontSize: 'xs',
  borderRadius: 'sm',
  fontWeight: 'bold'
};
var variants$2 = {
  primary: {
    bg: 'primary.default',
    color: 'white'
  },
  warningLight: {
    bg: 'yellow.100',
    color: 'black'
  }
};
var defaultProps$3 = {};
var index$1 = merge$1(theme$1.components.Badge, {
  variants: variants$2,
  baseStyle: baseStyle$2,
  defaultProps: defaultProps$3
});

var _excluded$n = ["hasFooter"];
var body = function body(_ref) {
  var hasFooter = _ref.hasFooter;
    _objectWithoutProperties$1(_ref, _excluded$n);
  return {
    overflowY: 'auto',
    padding: 6,
    paddingBottom: hasFooter ? 24 : 6
  };
};
var footer = function footer(props) {
  return {
    padding: 6,
    backgroundColor: 'white',
    position: 'absolute',
    bottom: 0,
    width: '100%'
  };
};
var header = function header(props) {
  return {
    paddingY: 3,
    paddingX: 6,
    borderBottom: '1px solid',
    borderBottomColor: 'gray.100',
    display: 'flex',
    gridGap: 2,
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 'semibold'
  };
};
var closeButton = function closeButton(props) {
  return {
    width: 8,
    height: 8,
    fontSize: 'xs',
    background: 'transparent',
    borderRadius: 'md',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    transitionProperty: 'common',
    transitionDuration: 'normal',
    outline: 'transparent solid 2px',
    outlineOffset: '2px',
    color: 'gray.600',
    _hover: {
      color: 'black',
      background: 'gray.100'
    },
    _focus: {
      outlineColor: 'primary.default'
    }
  };
};
var dialogContainer = function dialogContainer(props) {
  return {
    zIndex: 'layer2',
    backgroundColor: 'transparent'
  };
};
var dialog = function dialog(props) {
  return {
    backgroundColor: 'white',
    boxShadow: 'drawer'
  };
};
var baseStyle$1 = function baseStyle(props) {
  return {
    body: body(props),
    footer: footer(),
    header: header(),
    dialog: dialog(),
    closeButton: closeButton(),
    dialogContainer: dialogContainer()
  };
};
var defaultProps$2 = {
  size: 'xs'
};
var sizes$1 = {
  xs: {
    dialog: {
      maxWidth: {
        base: '100vw',
        mobileXL: 80
      }
    }
  }
};
var index = merge$1(theme$1.components.Drawer, {
  defaultProps: defaultProps$2,
  baseStyle: baseStyle$1,
  sizes: sizes$1
});

var filledStyle = function filledStyle(props) {
  var _theme$colors$colorSc;
  var colorScheme = props.colorScheme,
    hasStripe = props.hasStripe,
    isIndeterminate = props.isIndeterminate,
    theme = props.theme;
  var color = ((_theme$colors$colorSc = theme.colors[colorScheme]) === null || _theme$colors$colorSc === void 0 ? void 0 : _theme$colors$colorSc[500]) || 'gray.500'; // Default to gray if color is not found

  // Define the gradient for indeterminate progress bar
  var gradient = "linear-gradient(\n        to right,\n        transparent 0%,\n        ".concat(color, " 50%,\n        transparent 100%\n    )");

  // Manually define the stripe pattern using repeating-linear-gradient
  var stripeBackground = hasStripe && !isIndeterminate ? "repeating-linear-gradient(\n            45deg,\n            ".concat(color, " 0px,\n            ").concat(color, " 10px,\n            transparent 10px,\n            transparent 20px\n          )") : null;
  return _objectSpread2$1(_objectSpread2$1({}, stripeBackground && {
    backgroundImage: stripeBackground
  }), isIndeterminate ? {
    backgroundImage: gradient
  } : {
    backgroundColor: color
  });
};
var variantOutlined = function variantOutlined(props) {
  var colors = props.theme.colors;
  return {
    track: {
      bg: 'transparent',
      borderWidth: '1px',
      borderColor: colors.gray['200']
    }
  };
};
var variantSolid = function variantSolid(props) {
  var colors = props.theme.colors;
  return {
    track: {
      bg: colors.gray['100']
    }
  };
};
var variants$1 = {
  outlined: variantOutlined,
  solid: variantSolid
};
var sizes = {
  xl: {
    track: {
      height: 10
    }
  },
  lg: {
    track: {
      height: 6
    }
  },
  md: {
    track: {
      height: 4
    }
  },
  sm: {
    track: {
      height: 2
    }
  },
  xs: {
    track: {
      height: 1
    }
  }
};
var defaultProps$1 = {
  size: 'lg',
  colorScheme: 'primary',
  variant: 'solid'
};
var overrides = {
  defaultProps: defaultProps$1,
  variants: variants$1,
  sizes: sizes,
  baseStyle: function baseStyle(props) {
    var isRounded = props.sx.isRounded;
    return merge$1(theme$1.components.Progress.baseStyle(props), {
      filledTrack: _objectSpread2$1({
        borderRightRadius: isRounded ? 'none' : 'base'
      }, filledStyle(props)),
      track: {
        borderRightRadius: isRounded ? 'full' : 'base',
        borderLeftRadius: isRounded ? 'full' : 'base'
      }
    });
  }
};
var Progress_styles = _objectSpread2$1(_objectSpread2$1({}, theme$1.components.Progress), overrides);

var baseStyle = {
  button: {
    px: 8,
    py: 3,
    fontSize: 'base',
    fontFamily: 'body',
    lineHeight: 0.875,
    fontWeight: 'semibold',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: 'base',
    textTransform: 'capitalize',
    transition: 'all normal ease',
    _hover: {
      bg: 'gray.50',
      borderColor: 'gray.200'
    },
    _disabled: {
      cursor: 'not-allowed',
      opacity: 1,
      bg: 'gray.200',
      borderColor: 'gray.200',
      color: 'gray.600'
    },
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    }
  },
  list: {
    bg: 'white',
    boxShadow: 'base',
    padding: 6,
    zIndex: 'layer1',
    width: 64
  },
  item: {
    paddingX: 2,
    paddingY: 1.5,
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    }
  },
  groupTitle: {
    fontWeight: 'semibold',
    color: 'gray.600',
    padding: 2
  },
  command: {
    // this will style the text defined by the command
    // prop in the MenuItem and MenuItemOption components
    opacity: '0.8',
    fontFamily: 'mono',
    fontSize: 'sm',
    letterSpacing: 'tighter',
    paddingL: 4
  },
  divider: {
    marginY: 2,
    borderColor: 'gray.200'
  }
};
var variants = {
  basic: {
    button: {
      bg: 'primary.default',
      borderColor: 'primary.default',
      color: 'white',
      _hover: {
        bg: 'primary.600',
        borderColor: 'primary.600',
        color: 'white',
        _disabled: {
          bg: 'gray.200',
          borderColor: 'gray.200',
          color: 'gray.600'
        }
      }
    },
    list: {
      bg: 'white',
      boxShadow: 'base',
      zIndex: 'layer1',
      borderColor: 'gray.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: 'base',
      padding: 4,
      width: 64
    },
    groupTitle: {
      fontWeight: 'semibold',
      fontSize: 'md',
      color: 'gray.600',
      padding: 2
    },
    item: {
      fontWeight: 'semibold',
      _hover: {
        color: 'gray.600'
      }
    }
  },
  full: {
    button: {
      height: 8,
      fontSize: 'sm',
      fontWeight: 'semibold',
      color: 'black',
      borderColor: 'white',
      backgroundColor: 'white',
      borderRadius: 'base',
      paddingX: 3,
      paddingY: 'auto',
      _hover: {
        color: 'black',
        backgroundColor: 'gray.50',
        borderColor: 'gray.50'
      },
      _active: {
        color: 'primary.default',
        backgroundColor: 'gray.50',
        borderColor: 'gray.50',
        _hover: {
          color: 'primary.600',
          backgroundColor: 'gray.50',
          borderColor: 'gray.50'
        }
      }
    },
    list: {
      height: '30rem',
      width: '100vw',
      padding: 8,
      backgroundColor: 'white'
    },
    groupTitle: {
      fontSize: 'sm',
      weight: 'normal',
      color: 'gray.600'
    },
    item: {
      display: 'block',
      paddingX: 3.5,
      paddingY: 2.5,
      marginBottom: 2,
      _last: {
        marginBottom: 0
      },
      _hover: {
        backgroundColor: 'gray.50'
      },
      _focus: {
        boxShadow: 'none',
        backgroundColor: 'gray.50'
      }
    }
  }
};
var Menu_styles = merge$1(theme$1.components.Menu, {
  baseStyle: baseStyle,
  variants: variants
});

var components$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Accordion: theme,
  Badge: index$1,
  Button: buttonStyles,
  ButtonRefreshed: index$4,
  Checkbox: index$9,
  Divider: Divider_styles,
  Drawer: index,
  GridItem: styles$1,
  Heading: Heading_styles,
  Input: inputStyles,
  InputRefreshed: index$6,
  Link: Link_styles,
  List: index$a,
  Menu: Menu_styles,
  Modal: index$3,
  Popover: index$7,
  Progress: Progress_styles,
  Radio: index$2,
  Select: selectStyles,
  SelectRefreshed: index$5,
  Skeleton: Skeleton_styles,
  Spinner: Spinner_styles,
  Switch: index$8,
  Table: Table_styles,
  Tabs: styles$2,
  Text: Text_styles
});

// use this to extend the base theme of chakra, this adds on top of what is defined in baseConfig
var extendedTheme = {
  initialColorMode: 'light',
  useSystemColorMode: false,
  styles: {
    global: global$1
  },
  remToPixels: function remToPixels(rem) {
    var baseSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    return !rem ? 0 : "".concat(baseSize * Number(rem.replace('rem', '')));
  }
};

// use this to override base themes from Chakra
var baseConfig = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, theme$1), {}, {
  breakpoints: breakpoints
}, base), {}, {
  components: components$1
});
var THEME = extendTheme(extendedTheme, baseConfig);

var _excluded$m = ["theme", "useLegacyOverrides", "disableExternalFonts", "children"];
var ThemeProvider = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var theme = _ref.theme,
    useLegacyOverrides = _ref.useLegacyOverrides,
    _ref$disableExternalF = _ref.disableExternalFonts,
    disableExternalFonts = _ref$disableExternalF === void 0 ? false : _ref$disableExternalF,
    children = _ref.children,
    props = _objectWithoutProperties$1(_ref, _excluded$m);
  return /*#__PURE__*/React__default.createElement(ChakraProvider, _extends$7({}, props, {
    ref: ref,
    theme: merge$1(THEME, theme)
  }), disableExternalFonts ? null : /*#__PURE__*/React__default.createElement(Fonts, null), /*#__PURE__*/React__default.createElement(LegacyOverrides, {
    useLegacyOverrides: useLegacyOverrides
  }), children);
});
ThemeProvider.propTypes = {
  /** If true, this will use the old `spothero-html` base styles */
  useLegacyOverrides: PropTypes.bool,
  /** If true, this will not load the `Fonts` global styles */
  disableExternalFonts: PropTypes.bool,
  /** The React node (generally your entire App) that will be provided the theme */
  children: PropTypes.node,
  /** Adds additional themeing on top of SpotHero's default configuration */
  theme: PropTypes.object
};

var Card = /*#__PURE__*/forwardRef$1(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(Box, _extends$7({
    position: "relative",
    padding: 4,
    bgColor: "background.white",
    borderRadius: "lg",
    boxShadow: "md"
  }, props, {
    ref: ref
  }));
});

var assignInWith_1;
var hasRequiredAssignInWith;
function requireAssignInWith() {
  if (hasRequiredAssignInWith) return assignInWith_1;
  hasRequiredAssignInWith = 1;
  var copyObject = require_copyObject(),
    createAssigner = require_createAssigner(),
    keysIn = requireKeysIn();

  /**
   * This method is like `_.assignIn` except that it accepts `customizer`
   * which is invoked to produce the assigned values. If `customizer` returns
   * `undefined`, assignment is handled by the method instead. The `customizer`
   * is invoked with five arguments: (objValue, srcValue, key, object, source).
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @alias extendWith
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} sources The source objects.
   * @param {Function} [customizer] The function to customize assigned values.
   * @returns {Object} Returns `object`.
   * @see _.assignWith
   * @example
   *
   * function customizer(objValue, srcValue) {
   *   return _.isUndefined(objValue) ? srcValue : objValue;
   * }
   *
   * var defaults = _.partialRight(_.assignInWith, customizer);
   *
   * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
   * // => { 'a': 1, 'b': 2 }
   */
  var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
    copyObject(source, keysIn(source), object, customizer);
  });
  assignInWith_1 = assignInWith;
  return assignInWith_1;
}

var isError_1;
var hasRequiredIsError;
function requireIsError() {
  if (hasRequiredIsError) return isError_1;
  hasRequiredIsError = 1;
  var baseGetTag = require_baseGetTag(),
    isObjectLike = requireIsObjectLike(),
    isPlainObject = requireIsPlainObject();

  /** `Object#toString` result references. */
  var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

  /**
   * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
   * `SyntaxError`, `TypeError`, or `URIError` object.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
   * @example
   *
   * _.isError(new Error);
   * // => true
   *
   * _.isError(Error);
   * // => false
   */
  function isError(value) {
    if (!isObjectLike(value)) {
      return false;
    }
    var tag = baseGetTag(value);
    return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
  }
  isError_1 = isError;
  return isError_1;
}

var attempt_1;
var hasRequiredAttempt;
function requireAttempt() {
  if (hasRequiredAttempt) return attempt_1;
  hasRequiredAttempt = 1;
  var apply = require_apply(),
    baseRest = require_baseRest(),
    isError = requireIsError();

  /**
   * Attempts to invoke `func`, returning either the result or the caught error
   * object. Any additional arguments are provided to `func` when it's invoked.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Util
   * @param {Function} func The function to attempt.
   * @param {...*} [args] The arguments to invoke `func` with.
   * @returns {*} Returns the `func` result or error object.
   * @example
   *
   * // Avoid throwing errors for invalid selectors.
   * var elements = _.attempt(function(selector) {
   *   return document.querySelectorAll(selector);
   * }, '>_>');
   *
   * if (_.isError(elements)) {
   *   elements = [];
   * }
   */
  var attempt = baseRest(function (func, args) {
    try {
      return apply(func, undefined, args);
    } catch (e) {
      return isError(e) ? e : new Error(e);
    }
  });
  attempt_1 = attempt;
  return attempt_1;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
var _arrayMap;
var hasRequired_arrayMap;
function require_arrayMap() {
  if (hasRequired_arrayMap) return _arrayMap;
  hasRequired_arrayMap = 1;
  function arrayMap(array, iteratee) {
    var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);
    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }
  _arrayMap = arrayMap;
  return _arrayMap;
}

var _baseValues;
var hasRequired_baseValues;
function require_baseValues() {
  if (hasRequired_baseValues) return _baseValues;
  hasRequired_baseValues = 1;
  var arrayMap = require_arrayMap();

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function (key) {
      return object[key];
    });
  }
  _baseValues = baseValues;
  return _baseValues;
}

var _customDefaultsAssignIn;
var hasRequired_customDefaultsAssignIn;
function require_customDefaultsAssignIn() {
  if (hasRequired_customDefaultsAssignIn) return _customDefaultsAssignIn;
  hasRequired_customDefaultsAssignIn = 1;
  var eq = requireEq();

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
   * of source objects to the destination object for all destination properties
   * that resolve to `undefined`.
   *
   * @private
   * @param {*} objValue The destination value.
   * @param {*} srcValue The source value.
   * @param {string} key The key of the property to assign.
   * @param {Object} object The parent object of `objValue`.
   * @returns {*} Returns the value to assign.
   */
  function customDefaultsAssignIn(objValue, srcValue, key, object) {
    if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
      return srcValue;
    }
    return objValue;
  }
  _customDefaultsAssignIn = customDefaultsAssignIn;
  return _customDefaultsAssignIn;
}

/** Used to escape characters for inclusion in compiled string literals. */
var _escapeStringChar;
var hasRequired_escapeStringChar;
function require_escapeStringChar() {
  if (hasRequired_escapeStringChar) return _escapeStringChar;
  hasRequired_escapeStringChar = 1;
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    "\u2028": 'u2028',
    "\u2029": 'u2029'
  };

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }
  _escapeStringChar = escapeStringChar;
  return _escapeStringChar;
}

var _nativeKeys;
var hasRequired_nativeKeys;
function require_nativeKeys() {
  if (hasRequired_nativeKeys) return _nativeKeys;
  hasRequired_nativeKeys = 1;
  var overArg = require_overArg();

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeKeys = overArg(Object.keys, Object);
  _nativeKeys = nativeKeys;
  return _nativeKeys;
}

var _baseKeys;
var hasRequired_baseKeys;
function require_baseKeys() {
  if (hasRequired_baseKeys) return _baseKeys;
  hasRequired_baseKeys = 1;
  var isPrototype = require_isPrototype(),
    nativeKeys = require_nativeKeys();

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }
    return result;
  }
  _baseKeys = baseKeys;
  return _baseKeys;
}

var keys_1;
var hasRequiredKeys;
function requireKeys() {
  if (hasRequiredKeys) return keys_1;
  hasRequiredKeys = 1;
  var arrayLikeKeys = require_arrayLikeKeys(),
    baseKeys = require_baseKeys(),
    isArrayLike = requireIsArrayLike();

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  keys_1 = keys;
  return keys_1;
}

/** Used to match template delimiters. */
var _reInterpolate;
var hasRequired_reInterpolate;
function require_reInterpolate() {
  if (hasRequired_reInterpolate) return _reInterpolate;
  hasRequired_reInterpolate = 1;
  var reInterpolate = /<%=([\s\S]+?)%>/g;
  _reInterpolate = reInterpolate;
  return _reInterpolate;
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
var _basePropertyOf;
var hasRequired_basePropertyOf;
function require_basePropertyOf() {
  if (hasRequired_basePropertyOf) return _basePropertyOf;
  hasRequired_basePropertyOf = 1;
  function basePropertyOf(object) {
    return function (key) {
      return object == null ? undefined : object[key];
    };
  }
  _basePropertyOf = basePropertyOf;
  return _basePropertyOf;
}

var _escapeHtmlChar;
var hasRequired_escapeHtmlChar;
function require_escapeHtmlChar() {
  if (hasRequired_escapeHtmlChar) return _escapeHtmlChar;
  hasRequired_escapeHtmlChar = 1;
  var basePropertyOf = require_basePropertyOf();

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);
  _escapeHtmlChar = escapeHtmlChar;
  return _escapeHtmlChar;
}

var isSymbol_1;
var hasRequiredIsSymbol;
function requireIsSymbol() {
  if (hasRequiredIsSymbol) return isSymbol_1;
  hasRequiredIsSymbol = 1;
  var baseGetTag = require_baseGetTag(),
    isObjectLike = requireIsObjectLike();

  /** `Object#toString` result references. */
  var symbolTag = '[object Symbol]';

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return _typeof$1(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
  }
  isSymbol_1 = isSymbol;
  return isSymbol_1;
}

var _baseToString;
var hasRequired_baseToString;
function require_baseToString() {
  if (hasRequired_baseToString) return _baseToString;
  hasRequired_baseToString = 1;
  var _Symbol = require_Symbol(),
    arrayMap = require_arrayMap(),
    isArray = requireIsArray(),
    isSymbol = requireIsSymbol();

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isArray(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }
  _baseToString = baseToString;
  return _baseToString;
}

var toString_1;
var hasRequiredToString;
function requireToString() {
  if (hasRequiredToString) return toString_1;
  hasRequiredToString = 1;
  var baseToString = require_baseToString();

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString(value) {
    return value == null ? '' : baseToString(value);
  }
  toString_1 = toString;
  return toString_1;
}

var _escape;
var hasRequired_escape;
function require_escape() {
  if (hasRequired_escape) return _escape;
  hasRequired_escape = 1;
  var escapeHtmlChar = require_escapeHtmlChar(),
    toString = requireToString();

  /** Used to match HTML entities and HTML characters. */
  var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /**
   * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
   * corresponding HTML entities.
   *
   * **Note:** No other characters are escaped. To escape additional
   * characters use a third-party library like [_he_](https://mths.be/he).
   *
   * Though the ">" character is escaped for symmetry, characters like
   * ">" and "/" don't need escaping in HTML and have no special meaning
   * unless they're part of a tag or unquoted attribute value. See
   * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
   * (under "semi-related fun fact") for more details.
   *
   * When working with HTML you should always
   * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
   * XSS vectors.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category String
   * @param {string} [string=''] The string to escape.
   * @returns {string} Returns the escaped string.
   * @example
   *
   * _.escape('fred, barney, & pebbles');
   * // => 'fred, barney, &amp; pebbles'
   */
  function escape(string) {
    string = toString(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
  }
  _escape = escape;
  return _escape;
}

/** Used to match template delimiters. */
var _reEscape;
var hasRequired_reEscape;
function require_reEscape() {
  if (hasRequired_reEscape) return _reEscape;
  hasRequired_reEscape = 1;
  var reEscape = /<%-([\s\S]+?)%>/g;
  _reEscape = reEscape;
  return _reEscape;
}

/** Used to match template delimiters. */
var _reEvaluate;
var hasRequired_reEvaluate;
function require_reEvaluate() {
  if (hasRequired_reEvaluate) return _reEvaluate;
  hasRequired_reEvaluate = 1;
  var reEvaluate = /<%([\s\S]+?)%>/g;
  _reEvaluate = reEvaluate;
  return _reEvaluate;
}

var templateSettings_1;
var hasRequiredTemplateSettings;
function requireTemplateSettings() {
  if (hasRequiredTemplateSettings) return templateSettings_1;
  hasRequiredTemplateSettings = 1;
  var escape = require_escape(),
    reEscape = require_reEscape(),
    reEvaluate = require_reEvaluate(),
    reInterpolate = require_reInterpolate();

  /**
   * By default, the template delimiters used by lodash are like those in
   * embedded Ruby (ERB) as well as ES2015 template strings. Change the
   * following template settings to use alternative delimiters.
   *
   * @static
   * @memberOf _
   * @type {Object}
   */
  var templateSettings = {
    /**
     * Used to detect `data` property values to be HTML-escaped.
     *
     * @memberOf _.templateSettings
     * @type {RegExp}
     */
    'escape': reEscape,
    /**
     * Used to detect code to be evaluated.
     *
     * @memberOf _.templateSettings
     * @type {RegExp}
     */
    'evaluate': reEvaluate,
    /**
     * Used to detect `data` property values to inject.
     *
     * @memberOf _.templateSettings
     * @type {RegExp}
     */
    'interpolate': reInterpolate,
    /**
     * Used to reference the data object in the template text.
     *
     * @memberOf _.templateSettings
     * @type {string}
     */
    'variable': '',
    /**
     * Used to import variables into the compiled template.
     *
     * @memberOf _.templateSettings
     * @type {Object}
     */
    'imports': {
      /**
       * A reference to the `lodash` function.
       *
       * @memberOf _.templateSettings.imports
       * @type {Function}
       */
      '_': {
        'escape': escape
      }
    }
  };
  templateSettings_1 = templateSettings;
  return templateSettings_1;
}

var template_1;
var hasRequiredTemplate;
function requireTemplate() {
  if (hasRequiredTemplate) return template_1;
  hasRequiredTemplate = 1;
  var assignInWith = requireAssignInWith(),
    attempt = requireAttempt(),
    baseValues = require_baseValues(),
    customDefaultsAssignIn = require_customDefaultsAssignIn(),
    escapeStringChar = require_escapeStringChar(),
    isError = requireIsError(),
    isIterateeCall = require_isIterateeCall(),
    keys = requireKeys(),
    reInterpolate = require_reInterpolate(),
    templateSettings = requireTemplateSettings(),
    toString = requireToString();

  /** Error message constants. */
  var INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Creates a compiled template function that can interpolate data properties
   * in "interpolate" delimiters, HTML-escape interpolated data properties in
   * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
   * properties may be accessed as free variables in the template. If a setting
   * object is given, it takes precedence over `_.templateSettings` values.
   *
   * **Note:** In the development build `_.template` utilizes
   * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
   * for easier debugging.
   *
   * For more information on precompiling templates see
   * [lodash's custom builds documentation](https://lodash.com/custom-builds).
   *
   * For more information on Chrome extension sandboxes see
   * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category String
   * @param {string} [string=''] The template string.
   * @param {Object} [options={}] The options object.
   * @param {RegExp} [options.escape=_.templateSettings.escape]
   *  The HTML "escape" delimiter.
   * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
   *  The "evaluate" delimiter.
   * @param {Object} [options.imports=_.templateSettings.imports]
   *  An object to import into the template as free variables.
   * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
   *  The "interpolate" delimiter.
   * @param {string} [options.sourceURL='templateSources[n]']
   *  The sourceURL of the compiled template.
   * @param {string} [options.variable='obj']
   *  The data object variable name.
   * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
   * @returns {Function} Returns the compiled template function.
   * @example
   *
   * // Use the "interpolate" delimiter to create a compiled template.
   * var compiled = _.template('hello <%= user %>!');
   * compiled({ 'user': 'fred' });
   * // => 'hello fred!'
   *
   * // Use the HTML "escape" delimiter to escape data property values.
   * var compiled = _.template('<b><%- value %></b>');
   * compiled({ 'value': '<script>' });
   * // => '<b>&lt;script&gt;</b>'
   *
   * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
   * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
   * compiled({ 'users': ['fred', 'barney'] });
   * // => '<li>fred</li><li>barney</li>'
   *
   * // Use the internal `print` function in "evaluate" delimiters.
   * var compiled = _.template('<% print("hello " + user); %>!');
   * compiled({ 'user': 'barney' });
   * // => 'hello barney!'
   *
   * // Use the ES template literal delimiter as an "interpolate" delimiter.
   * // Disable support by replacing the "interpolate" delimiter.
   * var compiled = _.template('hello ${ user }!');
   * compiled({ 'user': 'pebbles' });
   * // => 'hello pebbles!'
   *
   * // Use backslashes to treat delimiters as plain text.
   * var compiled = _.template('<%= "\\<%- value %\\>" %>');
   * compiled({ 'value': 'ignored' });
   * // => '<%- value %>'
   *
   * // Use the `imports` option to import `jQuery` as `jq`.
   * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
   * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
   * compiled({ 'users': ['fred', 'barney'] });
   * // => '<li>fred</li><li>barney</li>'
   *
   * // Use the `sourceURL` option to specify a custom sourceURL for the template.
   * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
   * compiled(data);
   * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
   *
   * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
   * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
   * compiled.source;
   * // => function(data) {
   * //   var __t, __p = '';
   * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
   * //   return __p;
   * // }
   *
   * // Use custom template delimiters.
   * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
   * var compiled = _.template('hello {{ user }}!');
   * compiled({ 'user': 'mustache' });
   * // => 'hello mustache!'
   *
   * // Use the `source` property to inline compiled templates for meaningful
   * // line numbers in error messages and stack traces.
   * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
   *   var JST = {\
   *     "main": ' + _.template(mainText).source + '\
   *   };\
   * ');
   */
  function template(string, options, guard) {
    // Based on John Resig's `tmpl` implementation
    // (http://ejohn.org/blog/javascript-micro-templating/)
    // and Laura Doktorova's doT.js (https://github.com/olado/doT).
    var settings = templateSettings.imports._.templateSettings || templateSettings;
    if (guard && isIterateeCall(string, options, guard)) {
      options = undefined;
    }
    string = toString(string);
    options = assignInWith({}, options, settings, customDefaultsAssignIn);
    var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);
    var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

    // Compile the regexp to match each delimiter.
    var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

    // Use a sourceURL for easier debugging.
    // The sourceURL gets injected into the source that's eval-ed, so be careful
    // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
    // and escape the comment, thus injecting code that gets evaled.
    var sourceURL = hasOwnProperty.call(options, 'sourceURL') ? '//# sourceURL=' + (options.sourceURL + '').replace(/\s/g, ' ') + '\n' : '';
    string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
      interpolateValue || (interpolateValue = esTemplateValue);

      // Escape characters that can't be included in string literals.
      source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

      // Replace delimiters with snippets.
      if (escapeValue) {
        isEscaping = true;
        source += "' +\n__e(" + escapeValue + ") +\n'";
      }
      if (evaluateValue) {
        isEvaluating = true;
        source += "';\n" + evaluateValue + ";\n__p += '";
      }
      if (interpolateValue) {
        source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
      }
      index = offset + match.length;

      // The JS engine embedded in Adobe products needs `match` returned in
      // order to produce the correct `offset` value.
      return match;
    });
    source += "';\n";

    // If `variable` is not specified wrap a with-statement around the generated
    // code to add the data object to the top of the scope chain.
    var variable = hasOwnProperty.call(options, 'variable') && options.variable;
    if (!variable) {
      source = 'with (obj) {\n' + source + '\n}\n';
    }
    // Throw an error if a forbidden character was found in `variable`, to prevent
    // potential command injection attacks.
    else if (reForbiddenIdentifierChars.test(variable)) {
      throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
    }

    // Cleanup code by stripping empty strings.
    source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

    // Frame code as the function body.
    source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
    var result = attempt(function () {
      return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
    });

    // Provide the compiled function's source by its `toString` method or
    // the `source` property as a convenience for inlining compiled templates.
    result.source = source;
    if (isError(result)) {
      throw result;
    }
    return result;
  }
  template_1 = template;
  return template_1;
}

var templateExports = requireTemplate();
var template = /*@__PURE__*/getDefaultExportFromCjs(templateExports);

var _excluded$l = ["isSSR", "cloudinaryImageId", "cloudinaryTemplate", "cloudinaryCloudName", "htmlWidth", "htmlHeight", "quality", "lazyLoad"];

// This code is copied from fe-utils https://github.com/spothero/fe-monorepo/blob/a0e06482e74dcb5502b21c5fbf0a679752a1f8ce/packages/fe-utils/src/environment/environment.js#L391
function isHighDensityDisplay() {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3;
}
var buildCloudinarySrc = function buildCloudinarySrc(_ref) {
  var cloudinaryImageId = _ref.cloudinaryImageId,
    cloudinaryTemplate = _ref.cloudinaryTemplate,
    cloudinaryCloudName = _ref.cloudinaryCloudName,
    htmlWidth = _ref.htmlWidth,
    htmlHeight = _ref.htmlHeight,
    quality = _ref.quality;
  var defaultTemplate = "https://res.cloudinary.com/".concat(cloudinaryCloudName, "/image/upload/$w_{{WIDTH}},$h_{{HEIGHT}},$q_{{QUALITY}}/c_fill,f_auto,fl_progressive,dpr_").concat(isHighDensityDisplay() ? 2 : 1, ",h_$h,q_$q,w_$w/").concat(cloudinaryImageId);
  var tmpl = cloudinaryTemplate ? cloudinaryTemplate : defaultTemplate;
  return template(tmpl, {
    interpolate: /{{([\s\S]+?)}}/g // matches template vars in the format '{{ var }}' or '{{var}}'
  })({
    WIDTH: htmlWidth,
    HEIGHT: htmlHeight,
    QUALITY: quality
  });
};
var Image$1 = function Image(_ref2) {
  var isSSR = _ref2.isSSR,
    cloudinaryImageId = _ref2.cloudinaryImageId,
    cloudinaryTemplate = _ref2.cloudinaryTemplate,
    cloudinaryCloudName = _ref2.cloudinaryCloudName,
    htmlWidth = _ref2.htmlWidth,
    htmlHeight = _ref2.htmlHeight,
    quality = _ref2.quality,
    lazyLoad = _ref2.lazyLoad,
    otherProps = _objectWithoutProperties$1(_ref2, _excluded$l);
  var hasValidCloudinarySrc = (cloudinaryImageId || cloudinaryTemplate) && Boolean(htmlWidth) && Boolean(htmlHeight);
  var cloudinarySrc;
  if (hasValidCloudinarySrc) {
    cloudinarySrc = buildCloudinarySrc({
      cloudinaryImageId: cloudinaryImageId,
      cloudinaryTemplate: cloudinaryTemplate,
      cloudinaryCloudName: cloudinaryCloudName,
      htmlWidth: htmlWidth,
      htmlHeight: htmlHeight,
      quality: quality
    });
  }
  var imageProps = _objectSpread2$1(_objectSpread2$1({}, otherProps), {}, {
    src: cloudinarySrc || otherProps.src,
    htmlWidth: htmlWidth,
    htmlHeight: htmlHeight
  }, lazyLoad && {
    loading: 'lazy'
  });
  if (isSSR) {
    return /*#__PURE__*/React__default.createElement(Img, imageProps);
  } else {
    return /*#__PURE__*/React__default.createElement(Image$2, imageProps);
  }
};
Image$1.propTypes = {
  /** If true, use the image directly without client side checks. */
  isSSR: PropTypes.bool,
  /** The Cloudinary account that this image is stored under. */
  cloudinaryCloudName: PropTypes.string,
  /** The image ID that is stored in Cloudinary for this image. Will be used to replace the source path. */
  cloudinaryImageId: PropTypes.string,
  /** The template URL to use to create the source path from. Replaceable values are {{WIDTH}}, {{HEIGHT}}, and {{QUALITY}}. */
  cloudinaryTemplate: PropTypes.string,
  /** The width of the native HTML image, in pixels. Required if using a Cloudinary ID or Template. */
  htmlWidth: PropTypes.number,
  /** The height of the native HTML image, in pixels. Required if using a Cloudinary ID or Template. */
  htmlHeight: PropTypes.number,
  /** The quality setting if this image uses a Cloudinary ID or Template. */
  quality: PropTypes.number,
  /** Whether to use lazy loading for this image. */
  lazyLoad: PropTypes.bool
};
Image$1.defaultProps = {
  isSSR: false,
  quality: 50,
  cloudinaryCloudName: 'spothero'
};

var _excluded$k = ["color", "loaderBackgroundColor", "isInfinite", "size", "thickness", "trackColor", "value"];
var Loader = function Loader(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'success' : _ref$color,
    _ref$loaderBackground = _ref.loaderBackgroundColor,
    loaderBackgroundColor = _ref$loaderBackground === void 0 ? 'transparent' : _ref$loaderBackground,
    _ref$isInfinite = _ref.isInfinite,
    isInfinite = _ref$isInfinite === void 0 ? true : _ref$isInfinite,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 12 : _ref$size,
    _ref$thickness = _ref.thickness,
    thickness = _ref$thickness === void 0 ? 2 : _ref$thickness,
    _ref$trackColor = _ref.trackColor,
    trackColor = _ref$trackColor === void 0 ? 'gray.medium' : _ref$trackColor,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    props = _objectWithoutProperties$1(_ref, _excluded$k);
  /* -------------------------------------------------------------------- *\
      Note: Since most of the props for this component control multiple
      styles at a time, it was decided that it made the most sense to set
      up the default style-related properties here in lou of creating an
      overly complex styles file.
  \* -------------------------------------------------------------------- */
  var loaderDefaultProps = {
    color: color,
    isIndeterminate: isInfinite,
    size: size,
    thickness: thickness,
    trackColor: trackColor,
    value: value,
    capIsRound: true
  };
  return /*#__PURE__*/React__default.createElement(CircularProgress, _extends$7({
    sx: {
      '& svg > circle:first-of-type': {
        fill: loaderBackgroundColor
      }
    }
  }, loaderDefaultProps, props));
};
Loader.propTypes = {
  /**
   * The color of the Progress bar. Use color names defined within `theme/base/colors`.
   */
  color: PropTypes.string,
  /**
   * Determines if Loader spins for an infinite amount of time. If `true` value prop will be ignored.
   */
  isInfinite: PropTypes.bool,
  /**
   * Sets the background color of the Loader (inside the circle). Use color names defined within `theme/base/colors`.
   */
  loaderBackgroundColor: PropTypes.string,
  /**
   * The size of the Loader. Used as both height and width. Number corresponds to Size token.
   */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The thickness of the Loader. Number is used as pixel width.
   */
  thickness: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The color of the Progress bar track.  Use color names defined within `theme/base/colors`.
   */
  trackColor: PropTypes.string,
  /**
   * The number passed in corresponds to the percentage "done" of the Loader.
   */
  value: PropTypes.number
};

var _excluded$j = ["isRounded"];
var Progress = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var isRounded = _ref.isRounded,
    props = _objectWithoutProperties$1(_ref, _excluded$j);
  // Passing `isRounded` in as a prop throws a 'React does not recognize the X prop on a DOM element' error. Passing `isRounded` through `sx` instead, allows for the prop to be utilized by the theme without being set on the DOM element, avoiding the error.
  return /*#__PURE__*/React__default.createElement(Progress$1, _extends$7({
    ref: ref,
    sx: {
      isRounded: isRounded
    }
  }, props));
});
Progress.propTypes = {
  /** The visual color appearance of the component */
  colorScheme: PropTypes.string,
  /** If true, the progress bar will show a stripe */
  hasStripe: PropTypes.bool,
  /** If true, and hasStripe is true, the stripes will be animated */
  isAnimated: PropTypes.bool,
  /** If true, the progress will be indeterminate and the value prop will be ignored */
  isIndeterminate: PropTypes.bool,
  /** If true, the Progress Bar and Track are rounded */
  isRounded: PropTypes.bool,
  /** The maximum value of the Progress Bar */
  max: PropTypes.number,
  /** The minimum value of the Progress Bar */
  min: PropTypes.number,
  /** The size of the Progress */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /** The value of the progress indicator. If undefined the progress bar will be in indeterminate state */
  value: PropTypes.number,
  /** The visual appearance of the Progress Bar */
  variant: PropTypes.oneOf(['solid', 'outlined'])
};
Progress.defaultProps = {
  colorScheme: 'primary',
  hasStripe: false,
  isAnimated: false,
  isIndeterminate: false,
  isRounded: false,
  max: 100,
  min: 0,
  size: 'md',
  value: 0,
  variant: 'solid'
};

var _excluded$i = ["defaultChecked", "isChecked", "isDisabled", "value", "helperText", "children", "size"];
var Checkbox = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var defaultChecked = _ref.defaultChecked,
    isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    value = _ref.value,
    helperText = _ref.helperText,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    props = _objectWithoutProperties$1(_ref, _excluded$i);
  var helperTextSize = size === 'sm' || size === 'md' ? 'xs' : 'sm';
  return /*#__PURE__*/React__default.createElement(Checkbox$1, _extends$7({
    ref: ref,
    defaultChecked: defaultChecked,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isFocusable: !isDisabled,
    value: value,
    alignItems: "start",
    size: size
  }, props), children, helperText && /*#__PURE__*/React__default.createElement(Box, {
    color: "gray.600",
    fontSize: helperTextSize
  }, helperText));
});
Checkbox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  defaultChecked: PropTypes.bool,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

var _excluded$h = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "isOptional", "customRequiredText"];
var Input$2 = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isInvalid = _ref.isInvalid,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    isOptional = _ref.isOptional,
    customRequiredText = _ref.customRequiredText,
    props = _objectWithoutProperties$1(_ref, _excluded$h);
  var classes = cn({
    'FormElement-contains-error': isInvalid
  });
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    isOptional: isOptional,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    inputId: props.id,
    customRequiredText: customRequiredText
  }, /*#__PURE__*/React__default.createElement(Input$3, _extends$7({
    ref: ref,
    className: classes
  }, props)));
});
Input$2.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isOptional: PropTypes.bool,
  customRequiredText: PropTypes.string
};

var _excluded$g = ["label", "helperText", "errorMessage", "id", "children", "rightElement", "leftElement", "rightElementStyles", "leftElementStyles"];

// No clue how to move these into the style file so just co-located to keep from slowing down
// Chakra V2 will heavily impact this component
var labelStyle = {
  color: 'gray.600',
  fontWeight: 'normal',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  top: 0,
  left: 0,
  position: 'absolute',
  pointerEvents: 'none',
  padding: 'inherit',
  paddingLeft: 3,
  transformOrigin: 'left top',
  // below is from chakra v2 that I'm pulling in
  transitionProperty: 'scale translate',
  transitionDuration: '200ms'
};
var activeLabelStyles = {
  fontSize: '0.85em',
  transform: 'translateY(-.75rem)',
  _invalid: {
    color: 'error',
    '& .chakra-form__required-indicator': {
      display: 'none'
    }
  }
};
var controlStyles = {
  position: 'relative',
  borderWidth: '0',
  sx: {
    label: labelStyle,
    input: {
      '&::placeholder': {
        // below is from chakra v2 that I'm pulling in
        transitionProperty: 'opacity scale translate',
        transitionDuration: '200ms',
        opacity: 0
      },
      _invalid: {
        '&:focus + label': {
          color: 'gray.600'
        },
        '& + label': {
          color: 'error'
        },
        '& + label .chakra-form__required-indicator': {
          //Styling for asterisk always to be red if invalid
          color: 'error'
        },
        '&::placeholder': {
          opacity: 1
        }
      }
    },
    // styles used for when we extend functionality - textarea:not(:placeholder-shown) ~ label
    // on prod build we get style tag inject between input and label
    'input:not(:placeholder-shown) + label, input:not(:placeholder-shown) + style + label, .chakra-select__wrapper + label': _objectSpread2$1({}, activeLabelStyles),
    // should be a cleaner way of doing this
    '.chakra-input__group > .chakra-input__left-element ~ span input': {
      paddingLeft: 10,
      paddingRight: 8 //This should be only when there is a right element - DOM order made this a headache
    },
    '.chakra-input__group:not(:has(.fe-ui-async-select__control)) > .chakra-input__left-element ~ span input': {
      minHeight: 14 // same height as the button
    },
    '.chakra-input__group > .chakra-input__left-element ~ span select': {
      paddingLeft: 10,
      paddingRight: 8 //This should be only when there is a right element - DOM order made this a headache
    },
    '.chakra-input__group > .chakra-input__left-element ~ span button': {
      paddingLeft: 10,
      paddingRight: 8 //This should be only when there is a right element - DOM order made this a headache
    },
    '.chakra-input__group > .chakra-input__left-element ~ span label': {
      // transform: 'scale(0.85) translateY(-1rem) translateX(.5rem)',
      paddingLeft: '2.5rem'
    },
    // Styling for select
    '.chakra-select__wrapper + label': _objectSpread2$1({}, activeLabelStyles),
    '.FormElement-contains-error': {
      borderColor: 'error'
    },
    '.chakra-button + label': _objectSpread2$1(_objectSpread2$1({}, activeLabelStyles), {}, {
      display: 'flex',
      alignItems: 'center',
      margin: 0,
      marginLeft: '1px'
      // marginTop: 2
    }),
    // Styling for async select
    '.chakra-input__group:has(.fe-ui-async-select__single-value) label': _objectSpread2$1({}, activeLabelStyles)
  },
  _focusWithin: {
    label: _objectSpread2$1({}, activeLabelStyles),
    input: {
      '&::placeholder': {
        opacity: '1'
      }
    }
  }
};

/**
 * A component used in the homepage/midfunnel refresh of 2024
 * This formControl allows us to standardize the label movement animation as well as the left/right icons
 * Can be used solo but typically will be used by the Refreshed components themselves
 */
var FormControl = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    children = _ref.children,
    rightElement = _ref.rightElement,
    leftElement = _ref.leftElement,
    rightElementStyles = _ref.rightElementStyles,
    leftElementStyles = _ref.leftElementStyles,
    props = _objectWithoutProperties$1(_ref, _excluded$g);
  return /*#__PURE__*/React__default.createElement(FormControl$2, _extends$7({}, props, {
    ref: ref
  }, controlStyles), /*#__PURE__*/React__default.createElement(InputGroup, null, leftElement && /*#__PURE__*/React__default.createElement(InputLeftElement, _extends$7({
    pointerEvents: "none",
    top: "52%",
    left: "1.3rem",
    transform: "translate(-50%,-50%)"
  }, leftElementStyles), leftElement), /*#__PURE__*/React__default.createElement(Box, {
    as: "span",
    width: "100%",
    position: "relative"
  }, children, label && /*#__PURE__*/React__default.createElement(FormLabel, {
    htmlFor: id
  }, label)), rightElement && /*#__PURE__*/React__default.createElement(InputRightElement, _extends$7({
    top: "50%",
    right: "-1rem",
    transform: "translate(-50%,-50%)"
  }, rightElementStyles), rightElement)), helperText && /*#__PURE__*/React__default.createElement(FormHelperText, {
    color: "gray.600",
    marginTop: 1,
    fontSize: "xs"
  }, helperText), errorMessage && /*#__PURE__*/React__default.createElement(FormErrorMessage, {
    color: "error",
    marginTop: 1,
    fontSize: "xs"
  }, errorMessage));
});
FormControl.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  // Or react node
  helperText: PropTypes.string,
  // Or react node
  errorMessage: PropTypes.string,
  // Or react node
  children: PropTypes.element,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool
};

var _excluded$f = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "rightElement", "leftElement", "rightElementStyles", "leftElementStyles", "placeholder"];

/**
 * A component used in the homepage/midfunnel refresh of 2024
 * Initially built as purpose built as possible with hopes of extending it to other systems
 * using `<RefreshedInput/>` will bring in the core of this.
 */
var Input$1 = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isInvalid = _ref.isInvalid,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    rightElement = _ref.rightElement,
    leftElement = _ref.leftElement,
    rightElementStyles = _ref.rightElementStyles,
    leftElementStyles = _ref.leftElementStyles,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? ' ' : _ref$placeholder,
    props = _objectWithoutProperties$1(_ref, _excluded$f);
  var classes = cn({
    'FormElement-contains-error': isInvalid
  }); //Historic carry over

  return /*#__PURE__*/React__default.createElement(FormControl, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    id: props.id,
    rightElement: rightElement,
    leftElement: leftElement,
    rightElementStyles: rightElementStyles,
    leftElementStyles: leftElementStyles,
    variant: "refreshed"
  }, /*#__PURE__*/React__default.createElement(Input$3, _extends$7({
    placeholder: placeholder,
    ref: ref,
    className: classes,
    paddingTop: 'var(--chakra-sizes-5-5)' // Design requires 5.5
    ,
    paddingBottom: "2",
    lineHeight: "base",
    variant: "refreshed"
  }, props)));
});
Input$1.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  leftElement: PropTypes.element,
  rightElement: PropTypes.element,
  rightElementStyles: PropTypes.object,
  leftElementStyles: PropTypes.object
};

var _excluded$e = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "isOptional", "rightElement", "leftElement", "rightElementStyles", "leftElementStyles"];

//For select left is static arrow,
/**
 * A component used in the homepage/midfunnel refresh of 2024
 * Initially built as purpose built as possible with hopes of extending it to other systems
 * using `<RefreshedSelect><option value="1"/>/<RefreshedSelect>` will bring in the core of this.
 * Left arrow is static for this select.  You can pass a second left element in but it will not over write the down arrow currently
 */
var Select$1 = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isInvalid = _ref.isInvalid,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired;
    _ref.isOptional;
    var rightElement = _ref.rightElement,
    leftElement = _ref.leftElement,
    rightElementStyles = _ref.rightElementStyles,
    leftElementStyles = _ref.leftElementStyles,
    props = _objectWithoutProperties$1(_ref, _excluded$e);
  var classes = cn({
    'FormElement-contains-error': isInvalid
  });
  return /*#__PURE__*/React__default.createElement(FormControl, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    id: props.id,
    rightElement: rightElement,
    leftElement: leftElement,
    rightElementStyles: rightElementStyles,
    leftElementStyles: leftElementStyles
  }, /*#__PURE__*/React__default.createElement(Select$3, _extends$7({
    icon: /*#__PURE__*/React__default.createElement(Icon, {
      as: ForwardRef$1
    }),
    iconSize: 20,
    fontSize: "sm",
    ref: ref,
    className: classes,
    variant: "refreshed"
  }, props)));
});
Select$1.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isOptional: PropTypes.bool,
  rightElement: PropTypes.element,
  rightElementStyles: PropTypes.object
};

var _excluded$d = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "rightElement", "leftElement", "rightElementStyles", "leftElementStyles", "buttonValue"];

/**
 * A component used in the homepage/midfunnel refresh of 2024
 * Initially built as purpose built as possible with hopes of extending it to other systems
 * using `<RefreshedButton/>` will bring in the core of this.
 * The "value" will be the child of the button but must be passed through props like: `<RefreshedButton buttonValue="123"/>`.  This aids in the styling.
 * Recommended to pass a title prop as that will aid in screen readers understanding this due to text not always being in the button
 */
var Button = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isInvalid = _ref.isInvalid,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    rightElement = _ref.rightElement,
    leftElement = _ref.leftElement,
    rightElementStyles = _ref.rightElementStyles,
    leftElementStyles = _ref.leftElementStyles,
    buttonValue = _ref.buttonValue,
    props = _objectWithoutProperties$1(_ref, _excluded$d);
  var classes = cn({
    'FormElement-contains-error': isInvalid
  }); //Historic carry over

  return /*#__PURE__*/React__default.createElement(FormControl, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    id: props.id,
    rightElement: rightElement,
    leftElement: leftElement,
    rightElementStyles: rightElementStyles,
    leftElementStyles: leftElementStyles,
    variant: "refreshed"
  }, /*#__PURE__*/React__default.createElement(Button$2, _extends$7({
    ref: ref,
    className: classes,
    variant: "refreshed",
    "data-value": buttonValue,
    paddingBottom: "2"
  }, props, {
    isDisabled: isDisabled,
    color: isInvalid || !label ? 'gray.600' : 'black',
    borderColor: isInvalid ? 'error' : 'gray.200',
    _focus: {
      borderColor: isInvalid ? 'error' : 'primary.default'
    },
    paddingTop: label ? 'var(--chakra-sizes-5-5)' : '3',
    textTransform: "none"
  }), buttonValue));
});
Button.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  leftElement: PropTypes.element,
  rightElement: PropTypes.element,
  rightElementStyles: PropTypes.object,
  leftElementStyles: PropTypes.object,
  buttonValue: PropTypes.string
};

var isBrowser$2 = typeof document !== 'undefined';
var syncFallback = function syncFallback(create) {
  return create();
};
var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$2 ? syncFallback : useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || useLayoutEffect;

var isBrowser$1 = typeof document !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;
var EmotionCacheContext = /* #__PURE__ */createContext$2(
// we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);
if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef$1(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
if (!isBrowser$1) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);
      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}
var ThemeContext = /* #__PURE__ */createContext$2({});
if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'EmotionThemeContext';
}
var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};
var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};
var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};
var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');
  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }
  return undefined;
};
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' &&
  // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }
  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (process.env.NODE_ENV !== 'production' && !!props.css && (_typeof$1(props.css) !== 'object' || typeof props.css.name !== 'string' || props.css.name.indexOf('-') === -1)) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }
  return newProps;
};
var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
    serialized = _ref.serialized,
    isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });
  if (!isBrowser$1 && rules !== undefined) {
    var _ref2;
    var serializedNames = serialized.name;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }
    return /*#__PURE__*/createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }
  return null;
};
var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';
  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext));
  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];
    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion$1, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/createElement(WrappedComponent, newProps));
});
if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var pkg = {
  name: "@emotion/react",
  version: "11.10.6",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        "default": "./dist/emotion-react.esm.js"
      },
      "default": "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": "./macro.js"
  },
  types: "types/index.d.ts",
  files: ["src", "dist", "jsx-runtime", "jsx-dev-runtime", "_isolated-hnrs", "types/*.d.ts", "macro.js", "macro.d.ts", "macro.js.flow"],
  sideEffects: false,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.10.6",
    "@emotion/cache": "^11.10.5",
    "@emotion/serialize": "^1.1.1",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
    "@emotion/utils": "^1.2.0",
    "@emotion/weak-memoize": "^0.3.0",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: true
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.10.6",
    "@emotion/css-prettifier": "1.1.1",
    "@emotion/server": "11.10.0",
    "@emotion/styled": "11.10.6",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: ["./index.js", "./jsx-runtime.js", "./jsx-dev-runtime.js", "./_isolated-hnrs.js"],
    umdName: "emotionReact",
    exports: {
      envConditions: ["browser", "worker"],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
      }
    }
  }
};
var jsx = function jsx(type, props) {
  var args = arguments;
  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe

  return createElement.apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && (
  // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }
  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext));
  if (!isBrowser$1) {
    var _ref;
    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }
    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);
    if (shouldCache) {
      return null;
    }
    return /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything

  var sheetRef = useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }
    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }
    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
      rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }
    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }
    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }
    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});
if (process.env.NODE_ENV !== 'production') {
  Global.displayName = 'EmotionGlobal';
}
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var keyframes = function keyframes() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;
    switch (_typeof$1(arg)) {
      case 'boolean':
        break;
      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (process.env.NODE_ENV !== 'production' && arg.styles !== undefined && arg.name !== undefined) {
              console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
            }
            toAdd = '';
            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }
          break;
        }
      default:
        {
          toAdd = arg;
        }
    }
    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }
  return cls;
};
function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
    serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    var rules = '';
    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);
      if (!isBrowser$1 && res !== undefined) {
        rules += res;
      }
    }
    if (!isBrowser$1) {
      return rules;
    }
  });
  if (!isBrowser$1 && rules.length !== 0) {
    var _ref2;
    return /*#__PURE__*/createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function (serialized) {
      return serialized.name;
    }).join(' '), _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }
  return null;
};
var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];
  var css = function css() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('css can only be used during render');
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };
  var cx = function cx() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('cx can only be used during render');
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge(cache.registered, css, classnames(args));
  };
  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});
if (process.env.NODE_ENV !== 'production') {
  ClassNames.displayName = 'EmotionClassNames';
}
if (process.env.NODE_ENV !== 'production') {
  var isBrowser = typeof document !== 'undefined'; // #1727, #2905 for some reason Jest and Vitest evaluate modules twice if some consuming module gets mocked

  var isTestEnv = typeof jest !== 'undefined' || typeof vi !== 'undefined';
  if (isBrowser && !isTestEnv) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var globalContext =
    // $FlowIgnore
    typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
    : isBrowser ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";
    if (globalContext[globalKey]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }
    globalContext[globalKey] = true;
  }
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
var _excluded$3$1 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}
function classNames(prefix, state, className) {
  var arr = [className];
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }
  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;
  var innerProps = _objectWithoutProperties(props, _excluded$3$1);
  return _objectSpread2({}, innerProps);
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);
    if (typeof _newValue === 'string') return _newValue;
  }
  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
} // Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36

var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
}; // check for SSR

var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop, options);
  w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps(propsObj) {
  for (var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }
  var propsMap = Object.entries(propsObj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};
function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
    menuEl = _ref.menuEl,
    minHeight = _ref.minHeight,
    placement = _ref.placement,
    shouldScroll = _ref.shouldScroll,
    isFixedPosition = _ref.isFixedPosition,
    theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
    scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
    menuBottom = _menuEl$getBoundingCl.bottom,
    menuHeight = _menuEl$getBoundingCl.height,
    menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
    containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled

      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained

      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above

      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll

      if (placement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled

      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained

      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below

      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };
    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  }
  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2) {
  var _ref3;
  var placement = _ref2.placement,
    _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    spacing = _ref2$theme.spacing,
    colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, _defineProperty$2(_ref3, alignToControl(placement), '100%'), _defineProperty$2(_ref3, "backgroundColor", colors.neutral0), _defineProperty$2(_ref3, "borderRadius", borderRadius), _defineProperty$2(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty$2(_ref3, "marginBottom", spacing.menuGutter), _defineProperty$2(_ref3, "marginTop", spacing.menuGutter), _defineProperty$2(_ref3, "position", 'absolute'), _defineProperty$2(_ref3, "width", '100%'), _defineProperty$2(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /*#__PURE__*/createContext$2({
  getPortalPlacement: null
}); // NOTE: internal only

var MenuPlacer = /*#__PURE__*/function (_Component) {
  _inherits(MenuPlacer, _Component);
  var _super = _createSuper(MenuPlacer);
  function MenuPlacer() {
    var _this;
    _classCallCheck(this, MenuPlacer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };
    _this.context = void 0;
    _this.getPlacement = function (ref) {
      var _this$props = _this.props,
        minMenuHeight = _this$props.minMenuHeight,
        maxMenuHeight = _this$props.maxMenuHeight,
        menuPlacement = _this$props.menuPlacement,
        menuPosition = _this$props.menuPosition,
        menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
        theme = _this$props.theme;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement) getPortalPlacement(state);
      _this.setState(state);
    };
    _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread2(_objectSpread2({}, _this.props), {}, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    };
    return _this;
  }
  _createClass(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);
  return MenuPlacer;
}(Component);
MenuPlacer.contextType = PortalPlacementContext;
var Menu$1 = function Menu(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", _extends$6({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
    baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return jsx("div", _extends$6({
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
    baseUnit = _ref5$theme.spacing.baseUnit,
    colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends$6({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends$6({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
    offset = _ref6.offset,
    position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /*#__PURE__*/function (_Component2) {
  _inherits(MenuPortal, _Component2);
  var _super2 = _createSuper(MenuPortal);
  function MenuPortal() {
    var _this2;
    _classCallCheck(this, MenuPortal);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };
    _this2.getPortalPlacement = function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    };
    return _this2;
  }
  _createClass(MenuPortal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        appendTo = _this$props2.appendTo,
        children = _this$props2.children,
        className = _this$props2.className,
        controlElement = _this$props2.controlElement,
        cx = _this$props2.cx,
        innerProps = _this$props2.innerProps,
        menuPlacement = _this$props2.menuPlacement,
        position = _this$props2.menuPosition,
        getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }
      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = jsx("div", _extends$6({
        css: getStyles('menuPortal', state),
        className: cx({
          'menu-portal': true
        }, className)
      }, innerProps), children);
      return jsx(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /*#__PURE__*/createPortal(menuWrapper, appendTo) : menuWrapper);
    }
  }]);
  return MenuPortal;
}(Component);
var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isRtl = props.isRtl;
  return jsx("div", _extends$6({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing,
    isMulti = _ref2.isMulti,
    hasValue = _ref2.hasValue,
    controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return {
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    innerProps = props.innerProps,
    isMulti = props.isMulti,
    getStyles = props.getStyles,
    hasValue = props.hasValue;
  return jsx("div", _extends$6({
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    innerProps = props.innerProps,
    getStyles = props.getStyles;
  return jsx("div", _extends$6({
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children);
};
var _templateObject;
var _excluded$2$1 = ["size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2$1 = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded$2$1);
  return jsx("svg", _extends$6({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$1
  }, props));
};
var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, _extends$6({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, _extends$6({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
    _ref3$theme = _ref3.theme,
    baseUnit = _ref3$theme.spacing.baseUnit,
    colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator$1 = function DropdownIndicator(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends$6({
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }, innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends$6({
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }, innerProps), children || jsx(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
    _ref4$theme = _ref4.theme,
    baseUnit = _ref4$theme.spacing.baseUnit,
    colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("span", _extends$6({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
    size = _ref5.size,
    _ref5$theme = _ref5.theme,
    colors = _ref5$theme.colors,
    baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};
var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
    offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};
var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps,
    isRtl = props.isRtl;
  return jsx("div", _extends$6({
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }, innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};
var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    _ref$theme = _ref.theme,
    colors = _ref$theme.colors,
    borderRadius = _ref$theme.borderRadius,
    spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};
var Control = function Control(props) {
  var children = props.children,
    cx = props.cx,
    getStyles = props.getStyles,
    className = props.className,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$6({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};
var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};
var Group = function Group(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    Heading = props.Heading,
    headingProps = props.headingProps,
    innerProps = props.innerProps,
    label = props.label,
    theme = props.theme,
    selectProps = props.selectProps;
  return jsx("div", _extends$6({
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, innerProps), jsx(Heading, _extends$6({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var getStyles = props.getStyles,
    cx = props.cx,
    className = props.className;
  var _cleanCommonProps = cleanCommonProps(props);
  _cleanCommonProps.data;
  var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1$1);
  return jsx("div", _extends$6({
    css: getStyles('groupHeading', props),
    className: cx({
      'group-heading': true
    }, className)
  }, innerProps));
};
var _excluded$c = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    value = _ref.value,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return _objectSpread2({
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80,
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle);
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
  return _objectSpread2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};
var Input = function Input(props) {
  var className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    value = props.value;
  var _cleanCommonProps = cleanCommonProps(props),
    innerRef = _cleanCommonProps.innerRef,
    isDisabled = _cleanCommonProps.isDisabled,
    isHidden = _cleanCommonProps.isHidden,
    inputClassName = _cleanCommonProps.inputClassName,
    innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$c);
  return jsx("div", {
    className: cx({
      'input-container': true
    }, className),
    css: getStyles('input', props),
    "data-value": value || ''
  }, jsx("input", _extends$6({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    borderRadius = _ref$theme.borderRadius,
    colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug
  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    colors = _ref2$theme.colors,
    cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
    spacing = _ref3$theme.spacing,
    borderRadius = _ref3$theme.borderRadius,
    colors = _ref3$theme.colors,
    isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
    innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
    innerProps = _ref5.innerProps;
  return jsx("div", _extends$6({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue(props) {
  var children = props.children,
    className = props.className,
    components = props.components,
    cx = props.cx,
    data = props.data,
    getStyles = props.getStyles,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    removeProps = props.removeProps,
    selectProps = props.selectProps;
  var Container = components.Container,
    Label = components.Label,
    Remove = components.Remove;
  return jsx(ClassNames, null, function (_ref6) {
    var css = _ref6.css,
      emotionCx = _ref6.cx;
    return jsx(Container, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }, innerProps),
      selectProps: selectProps
    }, jsx(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), jsx(Remove, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className)),
        'aria-label': "Remove ".concat(children || 'option')
      }, removeProps),
      selectProps: selectProps
    }));
  });
};
var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  };
};
var Option = function Option(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", _extends$6({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  };
};
var Placeholder = function Placeholder(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends$6({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};
var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
};
var SingleValue = function SingleValue(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    isDisabled = props.isDisabled,
    innerProps = props.innerProps;
  return jsx("div", _extends$6({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};
var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator$1,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu$1,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual(newInputs[i], lastInputs[i])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }
  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }
    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }
  return memoized;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
var A11yText = function A11yText(props) {
  return jsx("span", _extends$6({
    css: _ref
  }, props));
};
var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
      isMulti = props.isMulti,
      isDisabled = props.isDisabled,
      tabSelectsValue = props.tabSelectsValue,
      context = props.context;
    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
      case 'input':
        return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      labels = props.labels,
      isDisabled = props.isDisabled;
    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");
      case 'clear':
        return 'All selected options have been cleared.';
      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
      focused = props.focused,
      options = props.options,
      _props$label2 = props.label,
      label = _props$label2 === void 0 ? '' : _props$label2,
      selectValue = props.selectValue,
      isDisabled = props.isDisabled,
      isSelected = props.isSelected;
    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };
    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === 'menu') {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }
    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
      resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};
var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
    focusedOption = props.focusedOption,
    focusedValue = props.focusedValue,
    focusableOptions = props.focusableOptions,
    isFocused = props.isFocused,
    selectValue = props.selectValue,
    selectProps = props.selectProps,
    id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
    getOptionLabel = selectProps.getOptionLabel,
    inputValue = selectProps.inputValue,
    isMulti = selectProps.isMulti,
    isOptionDisabled = selectProps.isOptionDisabled,
    isSearchable = selectProps.isSearchable,
    menuIsOpen = selectProps.menuIsOpen,
    options = selectProps.options,
    screenReaderStatus = selectProps.screenReaderStatus,
    tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live']; // Update aria live message configuration when prop changes

  var messages = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]); // Update aria live selected option when prop changes

  var ariaSelected = useMemo(function () {
    var message = '';
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
        selectedOptions = ariaSelection.options,
        removedValue = ariaSelection.removedValue,
        removedValues = ariaSelection.removedValues,
        value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value

      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      }; // If there is just one item from the action then get its label

      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : ''; // If there are multiple items from the action then return an array of labels

      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
      var onChangeProps = _objectSpread2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = useMemo(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: options,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, options, selectValue]);
  var ariaResults = useMemo(function () {
    var resultsMsg = '';
    if (menuIsOpen && options.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus]);
  var ariaGuidance = useMemo(function () {
    var guidanceMsg = '';
    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  return jsx(Fragment, null, jsx(A11yText, {
    id: id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};
var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = _objectSpread2({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: 'any'
      }, config),
      ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
      ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
      stringify = _ignoreCase$ignoreAcc.stringify,
      trim = _ignoreCase$ignoreAcc.trim,
      matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};
var _excluded$b = ["innerRef"];
function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, _excluded$b);

  // Remove animation props not meant for HTML elements
  var filteredProps = removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
  return jsx("input", _extends$6({
    ref: innerRef
  }, filteredProps, {
    css: /*#__PURE__*/css$2({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var cancelScroll = function cancelScroll(event) {
  event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
      scrollTop = _scrollTarget$current.scrollTop,
      scrollHeight = _scrollTarget$current.scrollHeight,
      clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false; // reset bottom/top flags

    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    } // bottom limit

    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true; // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    } // cancel scroll

    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}
var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};
function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
    _ref$accountForScroll = _ref.accountForScrollbars,
    accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    } // apply the lock styles and padding if this is the first scroll lock

    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    } // account for touch devices

    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions); // Allow scroll on provided target

      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    } // increment active scroll locks

    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style; // safely decrement active scroll locks

    activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    } // remove touch listeners

    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function blurSelectInput() {
  return document.activeElement && document.activeElement.blur();
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function ScrollManager(_ref) {
  var children = _ref.children,
    lockEnabled = _ref.lockEnabled,
    _ref$captureEnabled = _ref.captureEnabled,
    captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2
  }), children(targetRef));
}
var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};
var defaultStyles$1 = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css,
  valueContainer: valueContainerCSS
}; // Merge Utility
var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};
var defaultProps = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true
};
function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
    inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
    isSelected = categorizedOption.isSelected,
    label = categorizedOption.label,
    value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
    lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;
  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
    isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);
  var _super = _createSuper(Select);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;
    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange(newValue, actionMeta);
    };
    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
        closeMenuOnSelect = _this$props2.closeMenuOnSelect,
        isMulti = _this$props2.isMulti,
        inputValue = _this$props2.inputValue;
      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue

      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };
    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
        blurInputOnSelect = _this$props3.blurInputOnSelect,
        isMulti = _this$props3.isMulti,
        name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };
    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };
    _this.getValue = function () {
      return _this.state.selectValue;
    };
    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };
    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };
    _this.getStyles = function (key, props) {
      var base = defaultStyles$1[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value: value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function (event) {
      // Event captured by dropdown indicator
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
        isMulti = _this$props4.isMulti,
        menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };
    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars

      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      _this.setState({
        focusedOption: focusedOption
      });
    };
    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
        isMulti = _this$props5.isMulti,
        backspaceRemovesValue = _this$props5.backspaceRemovesValue,
        escapeClearsValue = _this$props5.escapeClearsValue,
        inputValue = _this$props5.inputValue,
        isClearable = _this$props5.isClearable,
        isDisabled = _this$props5.isDisabled,
        menuIsOpen = _this$props5.menuIsOpen,
        onKeyDown = _this$props5.onKeyDown,
        tabSelectsValue = _this$props5.tabSelectsValue,
        openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
        focusedOption = _this$state.focusedOption,
        focusedValue = _this$state.focusedValue,
        selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === 'function') {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key

      _this.blockOptionHover = true;
      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;
          _this.focusValue('previous');
          break;
        case 'ArrowRight':
          if (!isMulti || inputValue) return;
          _this.focusValue('next');
          break;
        case 'Delete':
        case 'Backspace':
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case 'Tab':
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
          // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case ' ':
          // space
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu('first');
            break;
          }
          if (!focusedOption) return;
          _this.selectOption(focusedOption);
          break;
        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }
          break;
        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }
          break;
        case 'PageUp':
          if (!menuIsOpen) return;
          _this.focusOption('pageup');
          break;
        case 'PageDown':
          if (!menuIsOpen) return;
          _this.focusOption('pagedown');
          break;
        case 'Home':
          if (!menuIsOpen) return;
          _this.focusOption('first');
          break;
        case 'End':
          if (!menuIsOpen) return;
          _this.focusOption('last');
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    return _this;
  }
  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
        isDisabled = _this$props6.isDisabled,
        menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } // scroll the focused option into view if necessary

      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    } // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state,
        selectValue = _this$state2.selectValue,
        isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open

      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
        selectValue = _this$state3.selectValue,
        focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing

      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value:
    // ==============================
    // Getters
    // ==============================
    function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.

      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.

      return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
        cx = this.cx,
        getStyles = this.getStyles,
        getValue = this.getValue,
        selectOption = this.selectOption,
        setValue = this.setValue,
        props = this.props;
      var isMulti = props.isMulti,
        isRtl = props.isRtl,
        options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
        isClearable = _this$props7.isClearable,
        isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value:
    // ==============================
    // Composition Handlers
    // ==============================
    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value:
    // ==============================
    // Touch Handlers
    // ==============================
    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value:
    // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
        isDisabled = _this$props8.isDisabled,
        isSearchable = _this$props8.isSearchable,
        inputId = _this$props8.inputId,
        inputValue = _this$props8.inputValue,
        tabIndex = _this$props8.tabIndex,
        form = _this$props8.form,
        menuIsOpen = _this$props8.menuIsOpen;
      var _this$getComponents = this.getComponents(),
        Input = _this$getComponents.Input;
      var _this$state4 = this.state,
        inputIsHidden = _this$state4.inputIsHidden,
        ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

      var ariaAttributes = _objectSpread2(_objectSpread2(_objectSpread2({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        role: 'combobox'
      }, menuIsOpen && {
        'aria-controls': this.getElementId('listbox'),
        'aria-owns': this.getElementId('listbox')
      }), !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });
      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/React.createElement(DummyInput, _extends$6({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }
      return /*#__PURE__*/React.createElement(Input, _extends$6({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(),
        MultiValue = _this$getComponents2.MultiValue,
        MultiValueContainer = _this$getComponents2.MultiValueContainer,
        MultiValueLabel = _this$getComponents2.MultiValueLabel,
        MultiValueRemove = _this$getComponents2.MultiValueRemove,
        SingleValue = _this$getComponents2.SingleValue,
        Placeholder = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props,
        controlShouldRenderValue = _this$props9.controlShouldRenderValue,
        isDisabled = _this$props9.isDisabled,
        isMulti = _this$props9.isMulti,
        inputValue = _this$props9.inputValue,
        placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
        selectValue = _this$state5.selectValue,
        focusedValue = _this$state5.focusedValue,
        isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/React.createElement(Placeholder, _extends$6({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/React.createElement(MultiValue, _extends$6({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /*#__PURE__*/React.createElement(SingleValue, _extends$6({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
        ClearIndicator = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props,
        isDisabled = _this$props10.isDisabled,
        isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(ClearIndicator, _extends$6({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
        LoadingIndicator = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props,
        isDisabled = _this$props11.isDisabled,
        isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(LoadingIndicator, _extends$6({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
        DropdownIndicator = _this$getComponents5.DropdownIndicator,
        IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/React.createElement(IndicatorSeparator, _extends$6({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
        DropdownIndicator = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(DropdownIndicator, _extends$6({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(),
        Group = _this$getComponents7.Group,
        GroupHeading = _this$getComponents7.GroupHeading,
        Menu = _this$getComponents7.Menu,
        MenuList = _this$getComponents7.MenuList,
        MenuPortal = _this$getComponents7.MenuPortal,
        LoadingMessage = _this$getComponents7.LoadingMessage,
        NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
        Option = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
        captureMenuScroll = _this$props12.captureMenuScroll,
        inputValue = _this$props12.inputValue,
        isLoading = _this$props12.isLoading,
        loadingMessage = _this$props12.loadingMessage,
        minMenuHeight = _this$props12.minMenuHeight,
        maxMenuHeight = _this$props12.maxMenuHeight,
        menuIsOpen = _this$props12.menuIsOpen,
        menuPlacement = _this$props12.menuPlacement,
        menuPosition = _this$props12.menuPosition,
        menuPortalTarget = _this$props12.menuPortalTarget,
        menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
        menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
        noOptionsMessage = _this$props12.noOptionsMessage,
        onMenuScrollToTop = _this$props12.onMenuScrollToTop,
        onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props, id) {
        var type = props.type,
          data = props.data,
          isDisabled = props.isDisabled,
          isSelected = props.isSelected,
          label = props.label,
          value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /*#__PURE__*/React.createElement(Option, _extends$6({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
              options = item.options,
              groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/React.createElement(Group, _extends$6({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/React.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });
        if (_message === null) return null;
        menuUI = /*#__PURE__*/React.createElement(NoOptionsMessage, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/React.createElement(MenuPlacer, _extends$6({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
          _ref4$placerProps = _ref4.placerProps,
          placement = _ref4$placerProps.placement,
          maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/React.createElement(Menu, _extends$6({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId('listbox')
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/React.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/React.createElement(MenuList, _extends$6({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/React.createElement(MenuPortal, _extends$6({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props,
        delimiter = _this$props13.delimiter,
        isDisabled = _this$props13.isDisabled,
        isMulti = _this$props13.isMulti,
        name = _this$props13.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;
      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/React.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/React.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/React.createElement("input", {
            name: name,
            type: "hidden"
          });
          return /*#__PURE__*/React.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return /*#__PURE__*/React.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
        ariaSelection = _this$state6.ariaSelection,
        focusedOption = _this$state6.focusedOption,
        focusedValue = _this$state6.focusedValue,
        isFocused = _this$state6.isFocused,
        selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/React.createElement(LiveRegion, _extends$6({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
        Control = _this$getComponents8.Control,
        IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
        SelectContainer = _this$getComponents8.SelectContainer,
        ValueContainer = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props,
        className = _this$props14.className,
        id = _this$props14.id,
        isDisabled = _this$props14.isDisabled,
        menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/React.createElement(SelectContainer, _extends$6({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/React.createElement(Control, _extends$6({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/React.createElement(ValueContainer, _extends$6({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/React.createElement(IndicatorsContainer, _extends$6({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
        clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
        inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
        ariaSelection = state.ariaSelection,
        isFocused = state.isFocused,
        prevWasFocused = state.prevWasFocused;
      var options = props.options,
        value = props.value,
        menuIsOpen = props.menuIsOpen,
        inputValue = props.inputValue,
        isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      } // some updates should toggle the state of the input visibility

      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      } // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null

      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select;
}(Component);
Select.defaultProps = defaultProps;

var _excluded$a = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
    defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
    _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
    defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    propsInputValue = _ref.inputValue,
    propsMenuIsOpen = _ref.menuIsOpen,
    propsOnChange = _ref.onChange,
    propsOnInputChange = _ref.onInputChange,
    propsOnMenuClose = _ref.onMenuClose,
    propsOnMenuOpen = _ref.onMenuOpen,
    propsValue = _ref.value,
    restSelectProps = _objectWithoutProperties(_ref, _excluded$a);
  var _useState = useState(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
    _useState2 = _slicedToArray(_useState, 2),
    stateInputValue = _useState2[0],
    setStateInputValue = _useState2[1];
  var _useState3 = useState(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
    _useState4 = _slicedToArray(_useState3, 2),
    stateMenuIsOpen = _useState4[0],
    setStateMenuIsOpen = _useState4[1];
  var _useState5 = useState(propsValue !== undefined ? propsValue : defaultValue),
    _useState6 = _slicedToArray(_useState5, 2),
    stateValue = _useState6[0],
    setStateValue = _useState6[1];
  var onChange = useCallback(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }
    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = useCallback(function (value, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }
    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}

var _excluded$9 = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];
function useAsync(_ref) {
  var _ref$defaultOptions = _ref.defaultOptions,
    propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions,
    _ref$cacheOptions = _ref.cacheOptions,
    cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions,
    propsLoadOptions = _ref.loadOptions;
  _ref.options;
  var _ref$isLoading = _ref.isLoading,
    propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    propsOnInputChange = _ref.onInputChange,
    _ref$filterOption = _ref.filterOption,
    filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption,
    restSelectProps = _objectWithoutProperties(_ref, _excluded$9);
  var propsInputValue = restSelectProps.inputValue;
  var lastRequest = useRef(undefined);
  var mounted = useRef(false);
  var _useState = useState(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined),
    _useState2 = _slicedToArray(_useState, 2),
    defaultOptions = _useState2[0],
    setDefaultOptions = _useState2[1];
  var _useState3 = useState(typeof propsInputValue !== 'undefined' ? propsInputValue : ''),
    _useState4 = _slicedToArray(_useState3, 2),
    stateInputValue = _useState4[0],
    setStateInputValue = _useState4[1];
  var _useState5 = useState(propsDefaultOptions === true),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    loadedInputValue = _useState8[0],
    setLoadedInputValue = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    loadedOptions = _useState10[0],
    setLoadedOptions = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    passEmptyOptions = _useState12[0],
    setPassEmptyOptions = _useState12[1];
  var _useState13 = useState({}),
    _useState14 = _slicedToArray(_useState13, 2),
    optionsCache = _useState14[0],
    setOptionsCache = _useState14[1];
  var _useState15 = useState(undefined),
    _useState16 = _slicedToArray(_useState15, 2),
    prevDefaultOptions = _useState16[0],
    setPrevDefaultOptions = _useState16[1];
  var _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    prevCacheOptions = _useState18[0],
    setPrevCacheOptions = _useState18[1];
  if (cacheOptions !== prevCacheOptions) {
    setOptionsCache({});
    setPrevCacheOptions(cacheOptions);
  }
  if (propsDefaultOptions !== prevDefaultOptions) {
    setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    setPrevDefaultOptions(propsDefaultOptions);
  }
  useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  var loadOptions = useCallback(function (inputValue, callback) {
    if (!propsLoadOptions) return callback();
    var loader = propsLoadOptions(inputValue, callback);
    if (loader && typeof loader.then === 'function') {
      loader.then(callback, function () {
        return callback();
      });
    }
  }, [propsLoadOptions]);
  useEffect(function () {
    if (propsDefaultOptions === true) {
      loadOptions(stateInputValue, function (options) {
        if (!mounted.current) return;
        setDefaultOptions(options || []);
        setIsLoading(!!lastRequest.current);
      });
    } // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var onInputChange = useCallback(function (newValue, actionMeta) {
    var inputValue = handleInputChange(newValue, actionMeta, propsOnInputChange);
    if (!inputValue) {
      lastRequest.current = undefined;
      setStateInputValue('');
      setLoadedInputValue('');
      setLoadedOptions([]);
      setIsLoading(false);
      setPassEmptyOptions(false);
      return;
    }
    if (cacheOptions && optionsCache[inputValue]) {
      setStateInputValue(inputValue);
      setLoadedInputValue(inputValue);
      setLoadedOptions(optionsCache[inputValue]);
      setIsLoading(false);
      setPassEmptyOptions(false);
    } else {
      var request = lastRequest.current = {};
      setStateInputValue(inputValue);
      setIsLoading(true);
      setPassEmptyOptions(!loadedInputValue);
      loadOptions(inputValue, function (options) {
        if (!mounted) return;
        if (request !== lastRequest.current) return;
        lastRequest.current = undefined;
        setIsLoading(false);
        setLoadedInputValue(inputValue);
        setLoadedOptions(options || []);
        setPassEmptyOptions(false);
        setOptionsCache(options ? _objectSpread2(_objectSpread2({}, optionsCache), {}, _defineProperty$2({}, inputValue, options)) : optionsCache);
      });
    }
  }, [cacheOptions, loadOptions, loadedInputValue, optionsCache, propsOnInputChange]);
  var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options: options,
    isLoading: isLoading || propsIsLoading,
    onInputChange: onInputChange,
    filterOption: filterOption
  });
}

var AsyncSelect = /*#__PURE__*/forwardRef$1(function (props, ref) {
  var stateManagedProps = useAsync(props);
  var selectProps = useStateManager(stateManagedProps);
  return /*#__PURE__*/React.createElement(Select, _extends$6({
    ref: ref
  }, selectProps));
});

var _path, _path2;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var SvgXCircle = function SvgXCircle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M9.172 16.242 12 13.414l2.828 2.828 1.414-1.414L13.414 12l2.828-2.828-1.414-1.414L12 10.586 9.172 7.758 7.758 9.172 10.586 12l-2.828 2.828z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10m0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef$1(SvgXCircle);

var AutoSuggestSelect$1 = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isInvalid = _ref.isInvalid,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    getOptions = _ref.getOptions,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    leftElement = _ref.leftElement,
    leftElementStyles = _ref.leftElementStyles;
  var _useTheme = useTheme(),
    colors = _useTheme.colors,
    fontSizes = _useTheme.fontSizes,
    sizes = _useTheme.sizes;
  var handleChange = function handleChange(selectedOption) {
    onChange(selectedOption);
  };
  var baseText = {
    fontSize: fontSizes.base,
    color: colors.black
  };

  /** React Select doesn't use Chakra but it does use Emotion so it's not too difficult to use values from our Chakra theme. Here is the documentation for React Select styling: https://react-select.com/styles  */
  var customStyles = {
    menu: function menu(provided) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), baseText);
    },
    control: function control(provided, state) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary["default"] : colors.gray['200'],
        borderWidth: '1px',
        boxShadow: 'none',
        '&:hover': {
          borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary["default"] : colors.gray['300']
        }
      });
    },
    input: function input(provided, state) {
      return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, provided), baseText), {}, {
        paddingBottom: sizes['2'],
        paddingTop: sizes['5.5'],
        paddingRight: sizes['3'],
        backgroundColor: state.isDisabled ? colors.gray['200'] : 'transparent'
      }, leftElement ? {
        paddingLeft: sizes['10']
      } : {
        paddingLeft: sizes['3']
      }), {}, {
        cursor: state.isDisabled ? 'not-allowed' : !state.hasValue ? 'text' : 'auto'
      });
    },
    placeholder: function placeholder(provided) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        padding: sizes['2'],
        fontSize: fontSizes.base,
        color: colors.gray['600']
      });
    },
    singleValue: function singleValue(provided) {
      return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, provided), baseText), {}, {
        paddingBottom: sizes['2'],
        paddingTop: sizes['5.5'],
        paddingRight: sizes['3']
      }, leftElement ? {
        paddingLeft: sizes['10']
      } : {
        paddingLeft: sizes['3']
      });
    },
    option: function option(provided, state) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        backgroundColor: state.isSelected ? colors.gray['200'] : state.isFocused ? colors.gray['50'] : 'transparent',
        color: colors.black
      });
    },
    clearIndicator: function clearIndicator(provided) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        color: colors.gray['600']
      });
    },
    dropdownIndicator: function dropdownIndicator(provided) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        color: colors.gray['600']
      });
    }
  };
  var clearIndicatorStyles = {
    width: sizes['5'],
    display: 'flex',
    marginRight: sizes['3'],
    color: colors.gray['600'],
    cursor: 'pointer'
  };

  /** React Select allows you to override the clear indicator with your own custom component: https://react-select.com/components */
  var ClearIndicator = function ClearIndicator(_ref2) {
    var innerRef = _ref2.innerRef,
      innerProps = _ref2.innerProps;
    return /*#__PURE__*/React__default.createElement("div", _extends$7({
      style: clearIndicatorStyles,
      ref: innerRef
    }, innerProps), /*#__PURE__*/React__default.createElement(ForwardRef, null));
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: isInvalid ? {
      label: {
        color: 'error'
      }
    } : {}
  }, /*#__PURE__*/React__default.createElement(FormControl, {
    errorMessage: errorMessage,
    isRequired: isRequired,
    helperText: helperText,
    label: label,
    inputId: id,
    leftElement: leftElement,
    leftElementStyles: leftElementStyles
  }, /*#__PURE__*/React__default.createElement(AsyncSelect, {
    classNamePrefix: "fe-ui-async-select",
    closeMenuOnSelect: true,
    isClearable: true,
    cacheOptions: true,
    components: {
      DropdownIndicator: function DropdownIndicator() {
        return null;
      },
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      ClearIndicator: ClearIndicator
    },
    openMenuOnClick: false,
    loadOptions: getOptions,
    onChange: handleChange,
    isDisabled: isDisabled,
    id: id,
    placeholder: placeholder,
    defaultValue: defaultValue,
    styles: customStyles,
    ref: ref
  })));
});
AutoSuggestSelect$1.propTypes = {
  /** ID applied to the select and label */
  id: PropTypes.string.isRequired,
  /** Label that describes the select */
  label: PropTypes.string,
  /** Text to use as placeholder in the input */
  placeholder: PropTypes.string,
  /** Optional helper text displayed below the select */
  helperText: PropTypes.string,
  /** Error message that would display under the select */
  errorMessage: PropTypes.string,
  /** Boolean that sets whether the select is valid */
  isInvalid: PropTypes.bool,
  /** Boolean that sets whether the select is disabled */
  isDisabled: PropTypes.bool,
  /** Boolean that sets whether the select is required */
  isRequired: PropTypes.bool,
  /** Function that is called with the value typed into the input that returns a list of options for the select */
  getOptions: PropTypes.func.isRequired,
  /** Function that is called when an option is selected, it returns the label and value of the selection */
  onChange: PropTypes.func.isRequired,
  // This prop is added to work around error: 'innerRef' is missing in props validation react/prop-types
  // eslint-disable-next-line react/no-unused-prop-types
  innerRef: PropTypes.object,
  // This prop is added to work around error: 'innerProps' is missing in props validation react/prop-types
  // eslint-disable-next-line react/no-unused-prop-types
  innerProps: PropTypes.object,
  // Element to display to the left of the input
  leftElement: PropTypes.element,
  // Styling of leftElement
  leftElementStyles: PropTypes.object
};

var _excluded$8 = ["defaultChecked", "isChecked", "isDisabled", "value", "helperText", "children", "size"];
var Radio = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var defaultChecked = _ref.defaultChecked,
    isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    value = _ref.value,
    helperText = _ref.helperText,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    props = _objectWithoutProperties$1(_ref, _excluded$8);
  var helperTextSize = size === 'sm' || size === 'md' ? 'xs' : 'sm';
  return /*#__PURE__*/React__default.createElement(Radio$1, _extends$7({
    ref: ref,
    defaultChecked: defaultChecked,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isFocusable: !isDisabled,
    value: value,
    size: size
  }, props), children, helperText && /*#__PURE__*/React__default.createElement(Box, {
    color: "gray.600",
    fontSize: helperTextSize
  }, helperText));
});
Radio.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  defaultChecked: PropTypes.bool,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

var _excluded$7 = ["label", "errorMessage", "defaultValue", "isDisabled", "isInvalid", "isRequired", "name", "onChange", "value", "children", "direction"];
var RadioGroup = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var label = _ref.label,
    errorMessage = _ref.errorMessage,
    defaultValue = _ref.defaultValue,
    isDisabled = _ref.isDisabled,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    name = _ref.name,
    onChange = _ref.onChange,
    value = _ref.value,
    children = _ref.children,
    direction = _ref.direction,
    props = _objectWithoutProperties$1(_ref, _excluded$7);
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    label: label,
    inputId: props.id,
    isFieldset: true
  }, /*#__PURE__*/React__default.createElement(RadioGroup$1, _extends$7({
    ref: ref,
    defaultValue: defaultValue,
    name: name,
    onChange: onChange,
    value: value
  }, props), /*#__PURE__*/React__default.createElement(Stack, {
    direction: direction ? direction : 'column',
    gap: 0
  }, children)));
});
RadioGroup.propTypes = {
  children: PropTypes.node,
  defaultValue: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'column'])
};

var _excluded$6 = ["isChecked", "isDisabled", "value", "helperText", "expandableChildren", "defaultChecked", "isRadio", "label", "isExpandable", "size", "expandableChildrenStyles"];
var SelectionCard = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    value = _ref.value,
    helperText = _ref.helperText,
    expandableChildren = _ref.expandableChildren,
    defaultChecked = _ref.defaultChecked,
    isRadio = _ref.isRadio,
    label = _ref.label,
    isExpandable = _ref.isExpandable,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$expandableChildr = _ref.expandableChildrenStyles,
    expandableChildrenStyles = _ref$expandableChildr === void 0 ? {} : _ref$expandableChildr,
    props = _objectWithoutProperties$1(_ref, _excluded$6);
  var Component = isRadio ? Radio : Checkbox;
  var expandableTextSize = size === 'sm' || size === 'md' ? 'xs' : 'sm';
  var hasExpandableContent = isExpandable && isChecked && expandableChildren;
  var prefersReducedMotion = usePrefersReducedMotion();
  return /*#__PURE__*/React__default.createElement(Box, {
    paddingBottom: hasExpandableContent ? 3 : 0,
    borderRadius: "lg",
    borderColor: isChecked ? 'primary.default' : 'gray.medium',
    borderWidth: "1px",
    _hover: {
      borderColor: isDisabled ? 'gray.medium' : 'primary.default'
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    borderColor: "gray.medium",
    borderBottomWidth: hasExpandableContent ? '1px' : 0
  }, /*#__PURE__*/React__default.createElement(Component, _extends$7({
    ref: ref,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isFocusable: !isDisabled,
    value: value,
    defaultChecked: defaultChecked,
    helperText: helperText,
    size: size,
    width: "100%",
    paddingX: 4,
    paddingY: 3
  }, props), label)), /*#__PURE__*/React__default.createElement(Box, {
    overflow: "hidden",
    display: "grid"
    // Using this as a pseudo height transition to get around no height auto transition
    ,
    gridTemplateRows: hasExpandableContent ? '1fr' : '0fr',
    opacity: hasExpandableContent ? '100%' : '0%',
    transition: prefersReducedMotion ? '' : 'all 150ms ease-out'
  }, /*#__PURE__*/React__default.createElement(Box, {
    overflow: "hidden"
  }, hasExpandableContent && /*#__PURE__*/React__default.createElement(Box, _extends$7({
    color: "gray.600",
    fontSize: expandableTextSize,
    paddingTop: 3,
    paddingX: 4
  }, expandableChildrenStyles), expandableChildren))));
});
SelectionCard.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  expandableChildren: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  defaultChecked: PropTypes.bool,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  isRadio: PropTypes.bool,
  isExpandable: PropTypes.bool,
  expandableChildrenStyles: PropTypes.object,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

var _excluded$5 = ["variant", "colorScheme"];
var Divider = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var variant = _ref.variant,
    borderColor = _ref.colorScheme,
    props = _objectWithoutProperties$1(_ref, _excluded$5);
  return /*#__PURE__*/React__default.createElement(Divider$1, _extends$7({}, colorScheme[borderColor], {
    variant: variant
  }, props, {
    ref: ref
  }));
});
Divider.propTypes = {
  /** Color scheme used */
  colorScheme: PropTypes.oneOf(['low', 'medium']),
  /** The styling that will be applied to the HR tag */
  variant: PropTypes.oneOf(['solid', 'dashed'])
};
Divider.defaultProps = {
  variant: 'solid',
  colorScheme: 'medium'
};

var _excluded$4 = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "isOptional", "customRequiredText"];
var Textarea = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isInvalid = _ref.isInvalid,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    isOptional = _ref.isOptional,
    customRequiredText = _ref.customRequiredText,
    props = _objectWithoutProperties$1(_ref, _excluded$4);
  var classes = cn({
    'FormElement-contains-error': isInvalid
  });
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    isOptional: isOptional,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    inputId: props.id,
    customRequiredText: customRequiredText
  }, /*#__PURE__*/React__default.createElement(Textarea$1, _extends$7({
    ref: ref,
    className: classes
  }, props)));
});
Textarea.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isOptional: PropTypes.bool,
  customRequiredText: PropTypes.string
};

var _excluded$3 = ["children"];
var Popover = /*#__PURE__*/forwardRef$1(function (props, ref) {
  var children = props.children,
    rest = _objectWithoutProperties$1(props, _excluded$3);
  return /*#__PURE__*/React__default.createElement(Popover$1, _extends$7({}, rest, {
    ref: ref
  }), Children.toArray(children).map(function (child, index) {
    return /*#__PURE__*/cloneElement(child, {
      ref: ref,
      variant: props.variant,
      key: "Popover-child-".concat(index)
    });
  }));
});
Popover.propTypes = {
  /** React children */
  children: PropTypes.node,
  /** Styles the Popover */
  variant: PropTypes.oneOf(['light', 'dark'])
};

var arrowStyles = function arrowStyles(_ref) {
  var variant = _ref.variant;
  return {
    backgroundColor: variant === 'dark' ? 'secondary.default' : 'white'
  };
};

var PopoverArrow = /*#__PURE__*/forwardRef$1(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(PopoverArrow$1, _extends$7({
    ref: ref
  }, props, arrowStyles(props)));
});

var pseudoStyles = function pseudoStyles(variant) {
  return {
    bgColor: variant === 'dark' ? 'gray.600' : 'gray.50'
  };
};
var closeButtonStyles = function closeButtonStyles(_ref) {
  var variant = _ref.variant;
  return {
    color: variant === 'dark' ? 'white' : 'black',
    fontSize: '0.5rem',
    position: 'absolute',
    top: 0,
    right: 0,
    padding: 4,
    borderTopRightRadius: 4,
    _hover: pseudoStyles(variant),
    _focus: _objectSpread2$1(_objectSpread2$1({}, pseudoStyles(variant)), {}, {
      boxShadow: 'outline'
    })
  };
};

var PopoverCloseButton = /*#__PURE__*/forwardRef$1(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(PopoverCloseButton$1, _extends$7({
    ref: ref
  }, props, closeButtonStyles(props)));
});

var _excluded$2 = ["header", "variant", "children", "hideCloseButton", "hideArrow", "popoverBodyProps"];
var PopoverContent = /*#__PURE__*/forwardRef$1(function (props, ref) {
  var header = props.header,
    variant = props.variant,
    children = props.children,
    hideCloseButton = props.hideCloseButton,
    hideArrow = props.hideArrow,
    popoverBodyProps = props.popoverBodyProps,
    rest = _objectWithoutProperties$1(props, _excluded$2);
  return /*#__PURE__*/React__default.createElement(PopoverContent$1, _extends$7({}, rest, {
    ref: ref
  }), hideArrow ? null : /*#__PURE__*/React__default.createElement(PopoverArrow, {
    variant: variant
  }), hideCloseButton ? null : /*#__PURE__*/React__default.createElement(PopoverCloseButton, {
    variant: variant
  }), header ? /*#__PURE__*/React__default.createElement(PopoverHeader, null, header) : null, /*#__PURE__*/React__default.createElement(PopoverBody, popoverBodyProps, children));
});
PopoverContent.propTypes = {
  /** React children */
  children: PropTypes.node,
  /** Whether or not to hide the close button */
  hideCloseButton: PropTypes.bool,
  /** Whether or not to hide the arrow */
  hideArrow: PropTypes.bool,
  /** Styles the Popover */
  variant: PropTypes.oneOf(['light', 'dark']),
  /** The string or node for the header (optional) */
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /** Props to pass to the PopoverBody */
  popoverBodyProps: PropTypes.object
};
PopoverContent.defaultProps = {
  variant: 'light',
  hideCloseButton: false,
  hideArrow: false
};

var AutoSuggestSelect = /*#__PURE__*/forwardRef$1(function (_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isInvalid = _ref.isInvalid,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    getOptions = _ref.getOptions,
    onChange = _ref.onChange,
    iconSrc = _ref.iconSrc,
    placeholder = _ref.placeholder,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue;
  var _useTheme = useTheme(),
    colors = _useTheme.colors,
    fontSizes = _useTheme.fontSizes,
    sizes = _useTheme.sizes;
  var handleChange = function handleChange(selectedOption) {
    onChange(selectedOption);
  };
  var icon = function icon() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transparent';
    return {
      alignItems: 'center',
      display: 'flex',
      ':before': {
        backgroundColor: color,
        content: '" "',
        display: 'block',
        marginRight: sizes['3'],
        height: sizes['4'],
        width: sizes['5'],
        mask: "url(".concat(iconSrc, ") no-repeat 50% 50%"),
        maskSize: 'contain'
      }
    };
  };
  var baseText = {
    fontSize: fontSizes.base,
    color: colors.black
  };

  /** React Select doesn't use Chakra but it does use Emotion so it's not too difficult to use values from our Chakra theme. Here is the documentation for React Select styling: https://react-select.com/styles  */
  var customStyles = {
    menu: function menu(provided) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), baseText);
    },
    control: function control(provided, state) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary["default"] : colors.gray['200'],
        borderWidth: '1px',
        boxShadow: 'none',
        '&:hover': {
          borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary["default"] : colors.gray['200']
        }
      });
    },
    input: function input(provided, state) {
      return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, provided), baseText), {}, {
        padding: sizes['2'],
        backgroundColor: state.isDisabled ? colors.gray['200'] : 'transparent'
      }, iconSrc && icon(colors.gray['600']));
    },
    placeholder: function placeholder(provided) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        padding: sizes['2'],
        fontSize: fontSizes.base,
        color: colors.gray['600']
      }, iconSrc && icon());
    },
    singleValue: function singleValue(provided) {
      return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, provided), baseText), {}, {
        padding: sizes['2']
      }, iconSrc && icon());
    },
    option: function option(provided, state) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        backgroundColor: state.isSelected ? colors.gray['200'] : state.isFocused ? colors.gray['50'] : 'transparent',
        color: colors.black
      });
    },
    clearIndicator: function clearIndicator(provided) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        color: colors.gray['600']
      });
    },
    dropdownIndicator: function dropdownIndicator(provided) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        color: colors.gray['600']
      });
    }
  };
  var clearIndicatorStyles = {
    width: sizes['5'],
    display: 'flex',
    marginRight: sizes['3'],
    color: colors.gray['600'],
    cursor: 'pointer'
  };

  /** React Select allows you to override the clear indicator with your own custom component: https://react-select.com/components */
  var ClearIndicator = function ClearIndicator(_ref2) {
    var innerRef = _ref2.innerRef,
      innerProps = _ref2.innerProps;
    return /*#__PURE__*/React__default.createElement("div", _extends$7({
      style: clearIndicatorStyles,
      ref: innerRef
    }, innerProps), /*#__PURE__*/React__default.createElement(ForwardRef, null));
  };
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    errorMessage: errorMessage,
    isRequired: isRequired,
    helperText: helperText,
    label: label,
    inputId: id
  }, /*#__PURE__*/React__default.createElement(AsyncSelect, {
    closeMenuOnSelect: true,
    isClearable: true,
    cacheOptions: true,
    components: {
      DropdownIndicator: function DropdownIndicator() {
        return null;
      },
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      ClearIndicator: ClearIndicator
    },
    openMenuOnClick: false,
    loadOptions: getOptions,
    onChange: handleChange,
    isDisabled: isDisabled,
    id: id,
    placeholder: placeholder,
    defaultValue: defaultValue,
    styles: customStyles,
    ref: ref
  }));
});
AutoSuggestSelect.propTypes = {
  /** ID applied to the select and label */
  id: PropTypes.string.isRequired,
  /** Label that describes the select */
  label: PropTypes.string,
  /** Text to use as placeholder in the input */
  placeholder: PropTypes.string,
  /** Optional helper text displayed below the select */
  helperText: PropTypes.string,
  /** Error message that would display under the select */
  errorMessage: PropTypes.string,
  /** Boolean that sets whether the select is valid */
  isInvalid: PropTypes.bool,
  /** Boolean that sets whether the select is disabled */
  isDisabled: PropTypes.bool,
  /** Boolean that sets whether the select is required */
  isRequired: PropTypes.bool,
  /** Function that is called with the value typed into the input that returns a list of options for the select */
  getOptions: PropTypes.func.isRequired,
  /** Function that is called when an option is selected, it returns the label and value of the selection */
  onChange: PropTypes.func.isRequired,
  /** Optional src to SVG to use as search icon */
  iconSrc: PropTypes.string,
  // This prop is added to work around error: 'innerRef' is missing in props validation react/prop-types
  // eslint-disable-next-line react/no-unused-prop-types
  innerRef: PropTypes.object,
  // This prop is added to work around error: 'innerProps' is missing in props validation react/prop-types
  // eslint-disable-next-line react/no-unused-prop-types
  innerProps: PropTypes.object
};

var defaultStyles = {
  border: 0,
  borderRadius: '4px',
  fontWeight: 'normal',
  paddingX: 4,
  paddingY: 1,
  _hover: {
    boxShadow: '0 0 0 2px rgba(158, 202, 237, 1)'
  },
  _focus: {
    boxShadow: '0 0 0 2px rgba(158, 202, 237, 1)'
  }
};
var inactiveStyles = {
  color: 'black',
  borderColor: 'gray.100',
  bg: 'gray.100',
  _hover: {
    bg: 'gray.100'
  },
  _active: {
    bg: 'gray.100'
  }
};
var activeStyles = {
  color: 'black',
  fontWeight: 'semibold',
  boxShadow: 'sm',
  bg: 'white',
  _hover: {
    bg: 'white'
  },
  _active: {
    bg: 'white'
  }
};
var buttonGroupStyles = {
  borderRadius: '4px',
  backgroundColor: 'gray.100',
  padding: 1
};

/**
 * @example (
 * <ToggleButtonGroup onChange={handleChangeValue} value={value}>
 *  <Button value={value1}>label1</Button>
 *  <Button value={value2}>label2</Button>
 * </ToggleButtonGroup>
 * )
 * @note
 * must have multiple child elements
 */
var ToggleButtonGroup = /*#__PURE__*/forwardRef$1(function (props, ref) {
  var onChange = props.onChange,
    value = props.value,
    children = props.children,
    groupProps = props.groupProps;
  if (!children) throw new Error('Children required');

  // iterate over array of child nodes to apply extended props
  return /*#__PURE__*/React__default.createElement(ButtonGroup, _extends$7({
    ref: ref,
    sx: _objectSpread2$1({}, buttonGroupStyles)
  }, groupProps), React__default.Children.map(children, function (CHILD) {
    var _CHILD$props3;
    return /*#__PURE__*/React__default.cloneElement(CHILD, _objectSpread2$1({
      onClick: function onClick() {
        var _CHILD$props, _CHILD$props2;
        if (value === (CHILD === null || CHILD === void 0 || (_CHILD$props = CHILD.props) === null || _CHILD$props === void 0 ? void 0 : _CHILD$props.value)) return;
        onChange(CHILD === null || CHILD === void 0 || (_CHILD$props2 = CHILD.props) === null || _CHILD$props2 === void 0 ? void 0 : _CHILD$props2.value);
      }
    }, value !== (CHILD === null || CHILD === void 0 || (_CHILD$props3 = CHILD.props) === null || _CHILD$props3 === void 0 ? void 0 : _CHILD$props3.value) ? {
      sx: _objectSpread2$1(_objectSpread2$1({}, defaultStyles), inactiveStyles)
    } : {
      sx: _objectSpread2$1(_objectSpread2$1({}, defaultStyles), activeStyles)
    }));
  }));
});
ToggleButtonGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  groupProps: PropTypes.object
};

var _excluded$1 = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"];
var compareOption = function compareOption() {
  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var option = arguments.length > 1 ? arguments[1] : undefined;
  var accessors = arguments.length > 2 ? arguments[2] : undefined;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return "Create \"".concat(inputValue, "\"");
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
function useCreatable(_ref) {
  var _ref$allowCreateWhile = _ref.allowCreateWhileLoading,
    allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile,
    _ref$createOptionPosi = _ref.createOptionPosition,
    createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi,
    _ref$formatCreateLabe = _ref.formatCreateLabel,
    formatCreateLabel = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe,
    _ref$isValidNewOption = _ref.isValidNewOption,
    isValidNewOption = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption,
    _ref$getNewOptionData = _ref.getNewOptionData,
    getNewOptionData = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData,
    onCreateOption = _ref.onCreateOption,
    _ref$options = _ref.options,
    propsOptions = _ref$options === void 0 ? [] : _ref$options,
    propsOnChange = _ref.onChange,
    restSelectProps = _objectWithoutProperties(_ref, _excluded$1);
  var _restSelectProps$getO = restSelectProps.getOptionValue,
    getOptionValue$1$1 = _restSelectProps$getO === void 0 ? getOptionValue$1 : _restSelectProps$getO,
    _restSelectProps$getO2 = restSelectProps.getOptionLabel,
    getOptionLabel$1$1 = _restSelectProps$getO2 === void 0 ? getOptionLabel$1 : _restSelectProps$getO2,
    inputValue = restSelectProps.inputValue,
    isLoading = restSelectProps.isLoading,
    isMulti = restSelectProps.isMulti,
    value = restSelectProps.value,
    name = restSelectProps.name;
  var newOption = useMemo(function () {
    return isValidNewOption(inputValue, cleanValue(value), propsOptions, {
      getOptionValue: getOptionValue$1$1,
      getOptionLabel: getOptionLabel$1$1
    }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
  }, [formatCreateLabel, getNewOptionData, getOptionLabel$1$1, getOptionValue$1$1, inputValue, isValidNewOption, propsOptions, value]);
  var options = useMemo(function () {
    return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray(propsOptions)) : [].concat(_toConsumableArray(propsOptions), [newOption]) : propsOptions;
  }, [allowCreateWhileLoading, createOptionPosition, isLoading, newOption, propsOptions]);
  var onChange = useCallback(function (newValue, actionMeta) {
    if (actionMeta.action !== 'select-option') {
      return propsOnChange(newValue, actionMeta);
    }
    var valueArray = Array.isArray(newValue) ? newValue : [newValue];
    if (valueArray[valueArray.length - 1] === newOption) {
      if (onCreateOption) onCreateOption(inputValue);else {
        var newOptionData = getNewOptionData(inputValue, inputValue);
        var newActionMeta = {
          action: 'create-option',
          name: name,
          option: newOptionData
        };
        propsOnChange(valueTernary(isMulti, [].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newOptionData), newActionMeta);
      }
      return;
    }
    propsOnChange(newValue, actionMeta);
  }, [getNewOptionData, inputValue, isMulti, name, newOption, onCreateOption, propsOnChange, value]);
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options: options,
    onChange: onChange
  });
}

var CreatableSelect$2 = /*#__PURE__*/forwardRef$1(function (props, ref) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return /*#__PURE__*/React.createElement(Select, _extends$6({
    ref: ref
  }, selectProps));
});

var _excluded = ["id", "label", "isInvalid", "isLoading", "isRequired", "options", "placeholder", "errorMessage", "helperText", "innerRef"],
  _excluded2 = ["id", "label", "isInvalid", "isLoading", "isRequired", "options", "placeholder", "errorMessage", "helperText"];
var DropdownIndicator = function DropdownIndicator(props) {
  var _useTheme = useTheme(),
    sizes = _useTheme.sizes;
  return /*#__PURE__*/React__default.createElement(components.DropdownIndicator, props, /*#__PURE__*/React__default.createElement(Icon, {
    className: "CreatableSelect-dropdown-icon",
    as: ForwardRef$1,
    boxSize: sizes['2.5']
  }));
};

// Exporting without forwardRef for storybook to work
var CreatableSelectNode = function CreatableSelectNode(_ref) {
  var id = _ref.id,
    label = _ref.label,
    _ref$isInvalid = _ref.isInvalid,
    isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    isRequired = _ref.isRequired,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    errorMessage = _ref.errorMessage,
    helperText = _ref.helperText,
    innerRef = _ref.innerRef,
    props = _objectWithoutProperties$1(_ref, _excluded);
  var _useTheme2 = useTheme(),
    colors = _useTheme2.colors,
    fontSizes = _useTheme2.fontSizes;
  if (innerRef) {
    props.ref = innerRef;
  }
  var customStyles = {
    control: function control(provided, state) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary["default"] : colors.gray['200'],
        borderWidth: '1px',
        boxShadow: 'none',
        '&:hover': {
          borderColor: isInvalid ? colors.error : state.isFocused ? colors.primary["default"] : colors.gray['200']
        }
      });
    },
    placeholder: function placeholder(provided) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        fontSize: fontSizes.sm,
        color: colors.gray['200']
      });
    },
    dropdownIndicator: function dropdownIndicator(provided) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        color: colors.brandBlue,
        '&:hover': {
          color: colors.brandBlue
        }
      });
    },
    indicatorSeparator: function indicatorSeparator(provided) {
      return _objectSpread2$1(_objectSpread2$1({}, provided), {}, {
        display: 'none'
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    errorMessage: errorMessage,
    isRequired: isRequired,
    isInvalid: isInvalid,
    helperText: helperText,
    label: label,
    inputId: id
  }, /*#__PURE__*/React__default.createElement(CreatableSelect$2, _extends$7({
    id: id,
    components: {
      DropdownIndicator: DropdownIndicator
    },
    styles: customStyles,
    options: options,
    placeholder: placeholder,
    isLoading: isLoading
  }, props)));
};
var CreatableSelect = /*#__PURE__*/forwardRef$1(function (props, ref) {
  var id = props.id,
    label = props.label,
    _props$isInvalid = props.isInvalid,
    isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
    isRequired = props.isRequired,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    errorMessage = props.errorMessage,
    helperText = props.helperText,
    additionalProps = _objectWithoutProperties$1(props, _excluded2);
  return /*#__PURE__*/React__default.createElement(CreatableSelectNode, _extends$7({
    id: id,
    innerRef: ref,
    label: label,
    options: options,
    placeholder: placeholder,
    helperText: helperText,
    errorMessage: errorMessage,
    isLoading: isLoading,
    isInvalid: isInvalid,
    isRequired: isRequired
  }, additionalProps));
});
CreatableSelect.propTypes = {
  id: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string
};
CreatableSelectNode.propTypes = {
  id: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  innerRef: PropTypes.shape({
    current: PropTypes.instanceOf(CreatableSelect$2)
  })
};
var CreatableSelect$1 = /*#__PURE__*/forwardRef$1(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(CreatableSelectNode, _extends$7({
    ref: ref
  }, props));
});

var Menu = forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(Menu$2, _extends$7({}, props, {
    ref: ref
  }));
});
Menu.propTypes = {
  /** The React node that will render inside the element */
  children: PropTypes.node
};

export { Accordion, AccordionActionButton, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Alert, AlwaysMountedModal, AspectRatio, AutoSuggestSelect, Badge, Input$3 as BasicInput, Textarea$1 as BasicTextarea, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button$1 as Button, ButtonGroup, Card, Center, Checkbox, CheckboxGroup, Circle$1 as Circle, Code, Collapse, Container, CreatableSelect$1 as CreatableSelect, Divider, Drawer, ModalBody as DrawerBody, ModalCloseButton as DrawerCloseButton, Drawer$1 as DrawerContainer, DrawerContent, ModalFooter as DrawerFooter, ModalHeader as DrawerHeader, ModalOverlay as DrawerOverlay, Fade, Flex, Grid, GridItem, HStack, Heading, Icon, Image$1 as Image, Input$2 as Input, InputGroup, InputLeftAddon, InputLeftElement, InputRightAddon, InputRightElement, Kbd, Link, LinkBox, LinkOverlay, List, ListItem, Loader, Menu, MenuButton, MenuDivider, MenuGroup, MenuItem, MenuItemOption, MenuList$1 as MenuList, MenuOptionGroup, Modal, ModalBody, ModalFooter, ModalHeader, Popover, PopoverAnchor, PopoverArrow, PopoverContent, PopoverTrigger, Portal, Progress, Radio, RadioGroup, AutoSuggestSelect$1 as RefreshedAutoSuggestSelect, Button as RefreshedButtonInput, FormControl as RefreshedFormControl, Input$1 as RefreshedInput, Select$1 as RefreshedSelectInput, ScaleFade, Select$2 as Select, SelectionCard, SimpleGrid, Skeleton, SkeletonCircle, SkeletonText, Slide, SlideFade, Spinner, Square, Switch, Tab, TabList, TabPanel, TabPanels, Table, TableCaption, TableContainer, Tabs, Tbody, Td, Text, Textarea, Tfoot, Th, Thead, ThemeProvider, ToggleButtonGroup, Tooltip, Tr, VStack, createIcon, keyframes$2 as keyframes, useBreakpointValue, useClipboard, useControllableProp, useControllableState, useDisclosure$1 as useDisclosure, useMediaQuery, usePopper, usePrefersReducedMotion, useStyleConfig, useTheme, useToast, useToken };
//# sourceMappingURL=index.esm.js.map
